import { ref as W, readonly as Ca, getCurrentInstance as pi, onMounted as Er, nextTick as cs, watch as te, inject as ce, reactive as Do, computed as v, provide as mn, onUnmounted as Sa, toValue as Q, useId as ps, mergeProps as x, createElementBlock as h, openBlock as m, createElementVNode as g, renderSlot as R, createTextVNode as q, toDisplayString as y, resolveComponent as ze, resolveDirective as uo, withDirectives as Ze, createBlock as j, resolveDynamicComponent as $e, withCtx as U, createCommentVNode as B, normalizeClass as ee, markRaw as Se, Transition as Cn, vShow as Fn, Teleport as ms, Fragment as Y, renderList as he, createVNode as L, normalizeProps as Vo, createSlots as ht, withModifiers as Ot, normalizeStyle as Zt, withKeys as Te, defineComponent as se, unref as z, toHandlers as wo, mergeModels as Mt, useModel as At, vModelText as fs, guardReactiveProps as Rr, onBeforeMount as gs, onScopeDispose as hs, useSlots as bs, toRef as mi, onBeforeUnmount as vs, isRef as ys } from "vue";
import { useStorage as Vr } from "@vueuse/core";
var ks = Object.defineProperty, fi = Object.getOwnPropertySymbols, ws = Object.prototype.hasOwnProperty, xs = Object.prototype.propertyIsEnumerable, gi = (e, t, n) => t in e ? ks(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, Cs = (e, t) => {
  for (var n in t || (t = {})) ws.call(t, n) && gi(e, n, t[n]);
  if (fi) for (var n of fi(t)) xs.call(t, n) && gi(e, n, t[n]);
  return e;
};
function Jt(e) {
  return e == null || e === "" || Array.isArray(e) && e.length === 0 || !(e instanceof Date) && typeof e == "object" && Object.keys(e).length === 0;
}
function ar(e, t, n = /* @__PURE__ */ new WeakSet()) {
  if (e === t) return !0;
  if (!e || !t || typeof e != "object" || typeof t != "object" || n.has(e) || n.has(t)) return !1;
  n.add(e).add(t);
  let o = Array.isArray(e), i = Array.isArray(t), r, a, d;
  if (o && i) {
    if (a = e.length, a != t.length) return !1;
    for (r = a; r-- !== 0; ) if (!ar(e[r], t[r], n)) return !1;
    return !0;
  }
  if (o != i) return !1;
  let l = e instanceof Date, u = t instanceof Date;
  if (l != u) return !1;
  if (l && u) return e.getTime() == t.getTime();
  let s = e instanceof RegExp, c = t instanceof RegExp;
  if (s != c) return !1;
  if (s && c) return e.toString() == t.toString();
  let p = Object.keys(e);
  if (a = p.length, a !== Object.keys(t).length) return !1;
  for (r = a; r-- !== 0; ) if (!Object.prototype.hasOwnProperty.call(t, p[r])) return !1;
  for (r = a; r-- !== 0; ) if (d = p[r], !ar(e[d], t[d], n)) return !1;
  return !0;
}
function Ss(e, t) {
  return ar(e, t);
}
function No(e) {
  return typeof e == "function" && "call" in e && "apply" in e;
}
function le(e) {
  return !Jt(e);
}
function kt(e, t) {
  if (!e || !t) return null;
  try {
    let n = e[t];
    if (le(n)) return n;
  } catch {
  }
  if (Object.keys(e).length) {
    if (No(t)) return t(e);
    if (t.indexOf(".") === -1) return e[t];
    {
      let n = t.split("."), o = e;
      for (let i = 0, r = n.length; i < r; ++i) {
        if (o == null) return null;
        o = o[n[i]];
      }
      return o;
    }
  }
  return null;
}
function co(e, t, n) {
  return n ? kt(e, n) === kt(t, n) : Ss(e, t);
}
function $s(e, t) {
  if (e != null && t && t.length) {
    for (let n of t) if (co(e, n)) return !0;
  }
  return !1;
}
function gt(e, t = !0) {
  return e instanceof Object && e.constructor === Object && (t || Object.keys(e).length !== 0);
}
function $a(e = {}, t = {}) {
  let n = Cs({}, e);
  return Object.keys(t).forEach((o) => {
    let i = o;
    gt(t[i]) && i in e && gt(e[i]) ? n[i] = $a(e[i], t[i]) : n[i] = t[i];
  }), n;
}
function Ba(...e) {
  return e.reduce((t, n, o) => o === 0 ? n : $a(t, n), {});
}
function hi(e, t) {
  let n = -1;
  if (le(e)) try {
    n = e.findLastIndex(t);
  } catch {
    n = e.lastIndexOf([...e].reverse().find(t));
  }
  return n;
}
function Xe(e, ...t) {
  return No(e) ? e(...t) : e;
}
function Ye(e, t = !0) {
  return typeof e == "string" && (t || e !== "");
}
function ft(e) {
  return Ye(e) ? e.replace(/(-|_)/g, "").toLowerCase() : e;
}
function Nr(e, t = "", n = {}) {
  let o = ft(t).split("."), i = o.shift();
  if (i) {
    if (gt(e)) {
      let r = Object.keys(e).find((a) => ft(a) === i) || "";
      return Nr(Xe(e[r], n), o.join("."), n);
    }
    return;
  }
  return Xe(e, n);
}
function Ta(e, t = !0) {
  return Array.isArray(e) && (t || e.length !== 0);
}
function Bs(e) {
  return le(e) && !isNaN(e);
}
function Ts(e = "") {
  return le(e) && e.length === 1 && !!e.match(/\S| /);
}
function Is() {
  return new Intl.Collator(void 0, { numeric: !0 }).compare;
}
function Lt(e, t) {
  if (t) {
    let n = t.test(e);
    return t.lastIndex = 0, n;
  }
  return !1;
}
function Ds(...e) {
  return Ba(...e);
}
function Mn(e) {
  return e && e.replace(/\/\*(?:(?!\*\/)[\s\S])*\*\/|[\r\n\t]+/g, "").replace(/ {2,}/g, " ").replace(/ ([{:}]) /g, "$1").replace(/([;,]) /g, "$1").replace(/ !/g, "!").replace(/: /g, ":").trim();
}
function tt(e) {
  if (e && /[\xC0-\xFF\u0100-\u017E]/.test(e)) {
    let t = { A: /[\xC0-\xC5\u0100\u0102\u0104]/g, AE: /[\xC6]/g, C: /[\xC7\u0106\u0108\u010A\u010C]/g, D: /[\xD0\u010E\u0110]/g, E: /[\xC8-\xCB\u0112\u0114\u0116\u0118\u011A]/g, G: /[\u011C\u011E\u0120\u0122]/g, H: /[\u0124\u0126]/g, I: /[\xCC-\xCF\u0128\u012A\u012C\u012E\u0130]/g, IJ: /[\u0132]/g, J: /[\u0134]/g, K: /[\u0136]/g, L: /[\u0139\u013B\u013D\u013F\u0141]/g, N: /[\xD1\u0143\u0145\u0147\u014A]/g, O: /[\xD2-\xD6\xD8\u014C\u014E\u0150]/g, OE: /[\u0152]/g, R: /[\u0154\u0156\u0158]/g, S: /[\u015A\u015C\u015E\u0160]/g, T: /[\u0162\u0164\u0166]/g, U: /[\xD9-\xDC\u0168\u016A\u016C\u016E\u0170\u0172]/g, W: /[\u0174]/g, Y: /[\xDD\u0176\u0178]/g, Z: /[\u0179\u017B\u017D]/g, a: /[\xE0-\xE5\u0101\u0103\u0105]/g, ae: /[\xE6]/g, c: /[\xE7\u0107\u0109\u010B\u010D]/g, d: /[\u010F\u0111]/g, e: /[\xE8-\xEB\u0113\u0115\u0117\u0119\u011B]/g, g: /[\u011D\u011F\u0121\u0123]/g, i: /[\xEC-\xEF\u0129\u012B\u012D\u012F\u0131]/g, ij: /[\u0133]/g, j: /[\u0135]/g, k: /[\u0137,\u0138]/g, l: /[\u013A\u013C\u013E\u0140\u0142]/g, n: /[\xF1\u0144\u0146\u0148\u014B]/g, p: /[\xFE]/g, o: /[\xF2-\xF6\xF8\u014D\u014F\u0151]/g, oe: /[\u0153]/g, r: /[\u0155\u0157\u0159]/g, s: /[\u015B\u015D\u015F\u0161]/g, t: /[\u0163\u0165\u0167]/g, u: /[\xF9-\xFC\u0169\u016B\u016D\u016F\u0171\u0173]/g, w: /[\u0175]/g, y: /[\xFD\xFF\u0177]/g, z: /[\u017A\u017C\u017E]/g };
    for (let n in t) e = e.replace(t[n], n);
  }
  return e;
}
function Ps(e) {
  return Ye(e, !1) ? e[0].toUpperCase() + e.slice(1) : e;
}
function Ia(e) {
  return Ye(e) ? e.replace(/(_)/g, "-").replace(/[A-Z]/g, (t, n) => n === 0 ? t : "-" + t.toLowerCase()).toLowerCase() : e;
}
function jr() {
  let e = /* @__PURE__ */ new Map();
  return { on(t, n) {
    let o = e.get(t);
    return o ? o.push(n) : o = [n], e.set(t, o), this;
  }, off(t, n) {
    let o = e.get(t);
    return o && o.splice(o.indexOf(n) >>> 0, 1), this;
  }, emit(t, n) {
    let o = e.get(t);
    o && o.forEach((i) => {
      i(n);
    });
  }, clear() {
    e.clear();
  } };
}
function Pe(...e) {
  if (e) {
    let t = [];
    for (let n = 0; n < e.length; n++) {
      let o = e[n];
      if (!o) continue;
      let i = typeof o;
      if (i === "string" || i === "number") t.push(o);
      else if (i === "object") {
        let r = Array.isArray(o) ? [Pe(...o)] : Object.entries(o).map(([a, d]) => d ? a : void 0);
        t = r.length ? t.concat(r.filter((a) => !!a)) : t;
      }
    }
    return t.join(" ").trim();
  }
}
function zs(e, t) {
  return e ? e.classList ? e.classList.contains(t) : new RegExp("(^| )" + t + "( |$)", "gi").test(e.className) : !1;
}
function Po(e, t) {
  if (e && t) {
    let n = (o) => {
      zs(e, o) || (e.classList ? e.classList.add(o) : e.className += " " + o);
    };
    [t].flat().filter(Boolean).forEach((o) => o.split(" ").forEach(n));
  }
}
function Ls() {
  return window.innerWidth - document.documentElement.offsetWidth;
}
function Os(e) {
  typeof e == "string" ? Po(document.body, e || "p-overflow-hidden") : (e != null && e.variableName && document.body.style.setProperty(e.variableName, Ls() + "px"), Po(document.body, e?.className || "p-overflow-hidden"));
}
function An(e, t) {
  if (e && t) {
    let n = (o) => {
      e.classList ? e.classList.remove(o) : e.className = e.className.replace(new RegExp("(^|\\b)" + o.split(" ").join("|") + "(\\b|$)", "gi"), " ");
    };
    [t].flat().filter(Boolean).forEach((o) => o.split(" ").forEach(n));
  }
}
function Ms(e) {
  typeof e == "string" ? An(document.body, e || "p-overflow-hidden") : (e != null && e.variableName && document.body.style.removeProperty(e.variableName), An(document.body, e?.className || "p-overflow-hidden"));
}
function lr(e) {
  for (let t of document?.styleSheets) try {
    for (let n of t?.cssRules) for (let o of n?.style) if (e.test(o)) return { name: o, value: n.style.getPropertyValue(o).trim() };
  } catch {
  }
  return null;
}
function Da(e) {
  let t = { width: 0, height: 0 };
  if (e) {
    let [n, o] = [e.style.visibility, e.style.display];
    e.style.visibility = "hidden", e.style.display = "block", t.width = e.offsetWidth, t.height = e.offsetHeight, e.style.display = o, e.style.visibility = n;
  }
  return t;
}
function Ur() {
  let e = window, t = document, n = t.documentElement, o = t.getElementsByTagName("body")[0], i = e.innerWidth || n.clientWidth || o.clientWidth, r = e.innerHeight || n.clientHeight || o.clientHeight;
  return { width: i, height: r };
}
function sr(e) {
  return e ? Math.abs(e.scrollLeft) : 0;
}
function As() {
  let e = document.documentElement;
  return (window.pageXOffset || sr(e)) - (e.clientLeft || 0);
}
function _s() {
  let e = document.documentElement;
  return (window.pageYOffset || e.scrollTop) - (e.clientTop || 0);
}
function Fs(e) {
  return e ? getComputedStyle(e).direction === "rtl" : !1;
}
function Pa(e, t, n = !0) {
  var o, i, r, a;
  if (e) {
    let d = e.offsetParent ? { width: e.offsetWidth, height: e.offsetHeight } : Da(e), l = d.height, u = d.width, s = t.offsetHeight, c = t.offsetWidth, p = t.getBoundingClientRect(), f = _s(), b = As(), k = Ur(), T, $, S = "top";
    p.top + s + l > k.height ? (T = p.top + f - l, S = "bottom", T < 0 && (T = f)) : T = s + p.top + f, p.left + u > k.width ? $ = Math.max(0, p.left + b + c - u) : $ = p.left + b, Fs(e) ? e.style.insetInlineEnd = $ + "px" : e.style.insetInlineStart = $ + "px", e.style.top = T + "px", e.style.transformOrigin = S, n && (e.style.marginTop = S === "bottom" ? `calc(${(i = (o = lr(/-anchor-gutter$/)) == null ? void 0 : o.value) != null ? i : "2px"} * -1)` : (a = (r = lr(/-anchor-gutter$/)) == null ? void 0 : r.value) != null ? a : "");
  }
}
function Hr(e, t) {
  e && (typeof t == "string" ? e.style.cssText = t : Object.entries(t || {}).forEach(([n, o]) => e.style[n] = o));
}
function fn(e, t) {
  return e instanceof HTMLElement ? e.offsetWidth : 0;
}
function za(e, t, n = !0, o = void 0) {
  var i;
  if (e) {
    let r = e.offsetParent ? { width: e.offsetWidth, height: e.offsetHeight } : Da(e), a = t.offsetHeight, d = t.getBoundingClientRect(), l = Ur(), u, s, c = o ?? "top";
    if (!o && d.top + a + r.height > l.height ? (u = -1 * r.height, c = "bottom", d.top + u < 0 && (u = -1 * d.top)) : u = a, r.width > l.width ? s = d.left * -1 : d.left + r.width > l.width ? s = (d.left + r.width - l.width) * -1 : s = 0, e.style.top = u + "px", e.style.insetInlineStart = s + "px", e.style.transformOrigin = c, n) {
      let p = (i = lr(/-anchor-gutter$/)) == null ? void 0 : i.value;
      e.style.marginTop = c === "bottom" ? `calc(${p ?? "2px"} * -1)` : p ?? "";
    }
  }
}
function Kr(e) {
  if (e) {
    let t = e.parentNode;
    return t && t instanceof ShadowRoot && t.host && (t = t.host), t;
  }
  return null;
}
function Es(e) {
  return !!(e !== null && typeof e < "u" && e.nodeName && Kr(e));
}
function Qt(e) {
  return typeof Element < "u" ? e instanceof Element : e !== null && typeof e == "object" && e.nodeType === 1 && typeof e.nodeName == "string";
}
function Rs() {
  if (window.getSelection) {
    let e = window.getSelection() || {};
    e.empty ? e.empty() : e.removeAllRanges && e.rangeCount > 0 && e.getRangeAt(0).getClientRects().length > 0 && e.removeAllRanges();
  }
}
function zo(e, t = {}) {
  if (Qt(e)) {
    let n = (o, i) => {
      var r, a;
      let d = (r = e?.$attrs) != null && r[o] ? [(a = e?.$attrs) == null ? void 0 : a[o]] : [];
      return [i].flat().reduce((l, u) => {
        if (u != null) {
          let s = typeof u;
          if (s === "string" || s === "number") l.push(u);
          else if (s === "object") {
            let c = Array.isArray(u) ? n(o, u) : Object.entries(u).map(([p, f]) => o === "style" && (f || f === 0) ? `${p.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase()}:${f}` : f ? p : void 0);
            l = c.length ? l.concat(c.filter((p) => !!p)) : l;
          }
        }
        return l;
      }, d);
    };
    Object.entries(t).forEach(([o, i]) => {
      if (i != null) {
        let r = o.match(/^on(.+)/);
        r ? e.addEventListener(r[1].toLowerCase(), i) : o === "p-bind" || o === "pBind" ? zo(e, i) : (i = o === "class" ? [...new Set(n("class", i))].join(" ").trim() : o === "style" ? n("style", i).join(";").trim() : i, (e.$attrs = e.$attrs || {}) && (e.$attrs[o] = i), e.setAttribute(o, i));
      }
    });
  }
}
function La(e, t = {}, ...n) {
  {
    let o = document.createElement(e);
    return zo(o, t), o.append(...n), o;
  }
}
function Dt(e, t) {
  return Qt(e) ? Array.from(e.querySelectorAll(t)) : [];
}
function qe(e, t) {
  return Qt(e) ? e.matches(t) ? e : e.querySelector(t) : null;
}
function We(e, t) {
  e && document.activeElement !== e && e.focus(t);
}
function Ut(e, t) {
  if (Qt(e)) {
    let n = e.getAttribute(t);
    return isNaN(n) ? n === "true" || n === "false" ? n === "true" : n : +n;
  }
}
function En(e, t = "") {
  let n = Dt(e, `button:not([tabindex = "-1"]):not([disabled]):not([style*="display:none"]):not([hidden])${t},
            [href]:not([tabindex = "-1"]):not([style*="display:none"]):not([hidden])${t},
            input:not([tabindex = "-1"]):not([disabled]):not([style*="display:none"]):not([hidden])${t},
            select:not([tabindex = "-1"]):not([disabled]):not([style*="display:none"]):not([hidden])${t},
            textarea:not([tabindex = "-1"]):not([disabled]):not([style*="display:none"]):not([hidden])${t},
            [tabIndex]:not([tabIndex = "-1"]):not([disabled]):not([style*="display:none"]):not([hidden])${t},
            [contenteditable]:not([tabIndex = "-1"]):not([disabled]):not([style*="display:none"]):not([hidden])${t}`), o = [];
  for (let i of n) getComputedStyle(i).display != "none" && getComputedStyle(i).visibility != "hidden" && o.push(i);
  return o;
}
function un(e, t) {
  let n = En(e, t);
  return n.length > 0 ? n[0] : null;
}
function Kt(e) {
  if (e) {
    let t = e.offsetHeight, n = getComputedStyle(e);
    return t -= parseFloat(n.paddingTop) + parseFloat(n.paddingBottom) + parseFloat(n.borderTopWidth) + parseFloat(n.borderBottomWidth), t;
  }
  return 0;
}
function Dn(e) {
  var t;
  if (e) {
    let n = (t = Kr(e)) == null ? void 0 : t.childNodes, o = 0;
    if (n) for (let i = 0; i < n.length; i++) {
      if (n[i] === e) return o;
      n[i].nodeType === 1 && o++;
    }
  }
  return -1;
}
function Oa(e, t) {
  let n = En(e, t);
  return n.length > 0 ? n[n.length - 1] : null;
}
function Vs(e) {
  if (e) {
    let t = e.getBoundingClientRect();
    return { top: t.top + (window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0), left: t.left + (window.pageXOffset || sr(document.documentElement) || sr(document.body) || 0) };
  }
  return { top: "auto", left: "auto" };
}
function Ma(e, t) {
  return e ? e.offsetHeight : 0;
}
function Aa(e, t = []) {
  let n = Kr(e);
  return n === null ? t : Aa(n, t.concat([n]));
}
function Ns(e) {
  let t = [];
  if (e) {
    let n = Aa(e), o = /(auto|scroll)/, i = (r) => {
      try {
        let a = window.getComputedStyle(r, null);
        return o.test(a.getPropertyValue("overflow")) || o.test(a.getPropertyValue("overflowX")) || o.test(a.getPropertyValue("overflowY"));
      } catch {
        return !1;
      }
    };
    for (let r of n) {
      let a = r.nodeType === 1 && r.dataset.scrollselectors;
      if (a) {
        let d = a.split(",");
        for (let l of d) {
          let u = qe(r, l);
          u && i(u) && t.push(u);
        }
      }
      r.nodeType !== 9 && i(r) && t.push(r);
    }
  }
  return t;
}
function bi() {
  if (window.getSelection) return window.getSelection().toString();
  if (document.getSelection) return document.getSelection().toString();
}
function Wt(e) {
  if (e) {
    let t = e.offsetWidth, n = getComputedStyle(e);
    return t -= parseFloat(n.paddingLeft) + parseFloat(n.paddingRight) + parseFloat(n.borderLeftWidth) + parseFloat(n.borderRightWidth), t;
  }
  return 0;
}
function js() {
  return /(android)/i.test(navigator.userAgent);
}
function _a() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
function vi(e, t = "") {
  return Qt(e) ? e.matches(`button:not([tabindex = "-1"]):not([disabled]):not([style*="display:none"]):not([hidden])${t},
            [href][clientHeight][clientWidth]:not([tabindex = "-1"]):not([disabled]):not([style*="display:none"]):not([hidden])${t},
            input:not([tabindex = "-1"]):not([disabled]):not([style*="display:none"]):not([hidden])${t},
            select:not([tabindex = "-1"]):not([disabled]):not([style*="display:none"]):not([hidden])${t},
            textarea:not([tabindex = "-1"]):not([disabled]):not([style*="display:none"]):not([hidden])${t},
            [tabIndex]:not([tabIndex = "-1"]):not([disabled]):not([style*="display:none"]):not([hidden])${t},
            [contenteditable]:not([tabIndex = "-1"]):not([disabled]):not([style*="display:none"]):not([hidden])${t}`) : !1;
}
function Lo(e) {
  return !!(e && e.offsetParent != null);
}
function Fa() {
  return "ontouchstart" in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
}
function Wr(e, t = "", n) {
  Qt(e) && n !== null && n !== void 0 && e.setAttribute(t, n);
}
var xo = {};
function Us(e = "pui_id_") {
  return Object.hasOwn(xo, e) || (xo[e] = 0), xo[e]++, `${e}${xo[e]}`;
}
function Hs() {
  let e = [], t = (a, d, l = 999) => {
    let u = i(a, d, l), s = u.value + (u.key === a ? 0 : l) + 1;
    return e.push({ key: a, value: s }), s;
  }, n = (a) => {
    e = e.filter((d) => d.value !== a);
  }, o = (a, d) => i(a).value, i = (a, d, l = 0) => [...e].reverse().find((u) => !0) || { key: a, value: l }, r = (a) => a && parseInt(a.style.zIndex, 10) || 0;
  return { get: r, set: (a, d, l) => {
    d && (d.style.zIndex = String(t(a, !0, l)));
  }, clear: (a) => {
    a && (n(r(a)), a.style.zIndex = "");
  }, getCurrent: (a) => o(a) };
}
var wt = Hs(), Ks = Object.defineProperty, Ws = Object.defineProperties, Ys = Object.getOwnPropertyDescriptors, Oo = Object.getOwnPropertySymbols, Ea = Object.prototype.hasOwnProperty, Ra = Object.prototype.propertyIsEnumerable, yi = (e, t, n) => t in e ? Ks(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, it = (e, t) => {
  for (var n in t || (t = {})) Ea.call(t, n) && yi(e, n, t[n]);
  if (Oo) for (var n of Oo(t)) Ra.call(t, n) && yi(e, n, t[n]);
  return e;
}, Qo = (e, t) => Ws(e, Ys(t)), yt = (e, t) => {
  var n = {};
  for (var o in e) Ea.call(e, o) && t.indexOf(o) < 0 && (n[o] = e[o]);
  if (e != null && Oo) for (var o of Oo(e)) t.indexOf(o) < 0 && Ra.call(e, o) && (n[o] = e[o]);
  return n;
};
function Gs(...e) {
  return Ba(...e);
}
var qs = jr(), Ee = qs, hn = /{([^}]*)}/g, Va = /(\d+\s+[\+\-\*\/]\s+\d+)/g, Na = /var\([^)]+\)/g;
function ki(e) {
  return Ye(e) ? e.replace(/[A-Z]/g, (t, n) => n === 0 ? t : "." + t.toLowerCase()).toLowerCase() : e;
}
function Zs(e) {
  return gt(e) && e.hasOwnProperty("$value") && e.hasOwnProperty("$type") ? e.$value : e;
}
function Xs(e) {
  return e.replaceAll(/ /g, "").replace(/[^\w]/g, "-");
}
function dr(e = "", t = "") {
  return Xs(`${Ye(e, !1) && Ye(t, !1) ? `${e}-` : e}${t}`);
}
function ja(e = "", t = "") {
  return `--${dr(e, t)}`;
}
function Js(e = "") {
  let t = (e.match(/{/g) || []).length, n = (e.match(/}/g) || []).length;
  return (t + n) % 2 !== 0;
}
function Ua(e, t = "", n = "", o = [], i) {
  if (Ye(e)) {
    let r = e.trim();
    if (Js(r)) return;
    if (Lt(r, hn)) {
      let a = r.replaceAll(hn, (d) => {
        let l = d.replace(/{|}/g, "").split(".").filter((u) => !o.some((s) => Lt(u, s)));
        return `var(${ja(n, Ia(l.join("-")))}${le(i) ? `, ${i}` : ""})`;
      });
      return Lt(a.replace(Na, "0"), Va) ? `calc(${a})` : a;
    }
    return r;
  } else if (Bs(e)) return e;
}
function Qs(e, t, n) {
  Ye(t, !1) && e.push(`${t}:${n};`);
}
function cn(e, t) {
  return e ? `${e}{${t}}` : "";
}
function Ha(e, t) {
  if (e.indexOf("dt(") === -1) return e;
  function n(a, d) {
    let l = [], u = 0, s = "", c = null, p = 0;
    for (; u <= a.length; ) {
      let f = a[u];
      if ((f === '"' || f === "'" || f === "`") && a[u - 1] !== "\\" && (c = c === f ? null : f), !c && (f === "(" && p++, f === ")" && p--, (f === "," || u === a.length) && p === 0)) {
        let b = s.trim();
        b.startsWith("dt(") ? l.push(Ha(b, d)) : l.push(o(b)), s = "", u++;
        continue;
      }
      f !== void 0 && (s += f), u++;
    }
    return l;
  }
  function o(a) {
    let d = a[0];
    if ((d === '"' || d === "'" || d === "`") && a[a.length - 1] === d) return a.slice(1, -1);
    let l = Number(a);
    return isNaN(l) ? a : l;
  }
  let i = [], r = [];
  for (let a = 0; a < e.length; a++) if (e[a] === "d" && e.slice(a, a + 3) === "dt(") r.push(a), a += 2;
  else if (e[a] === ")" && r.length > 0) {
    let d = r.pop();
    r.length === 0 && i.push([d, a]);
  }
  if (!i.length) return e;
  for (let a = i.length - 1; a >= 0; a--) {
    let [d, l] = i[a], u = e.slice(d + 3, l), s = n(u, t), c = t(...s);
    e = e.slice(0, d) + c + e.slice(l + 1);
  }
  return e;
}
function wi(e) {
  return e.length === 4 ? `#${e[1]}${e[1]}${e[2]}${e[2]}${e[3]}${e[3]}` : e;
}
function xi(e) {
  let t = parseInt(e.substring(1), 16), n = t >> 16 & 255, o = t >> 8 & 255, i = t & 255;
  return { r: n, g: o, b: i };
}
function ed(e, t, n) {
  return `#${e.toString(16).padStart(2, "0")}${t.toString(16).padStart(2, "0")}${n.toString(16).padStart(2, "0")}`;
}
var Ka = (e, t, n) => {
  e = wi(e), t = wi(t);
  let o = (n / 100 * 2 - 1 + 1) / 2, i = 1 - o, r = xi(e), a = xi(t), d = Math.round(r.r * o + a.r * i), l = Math.round(r.g * o + a.g * i), u = Math.round(r.b * o + a.b * i);
  return ed(d, l, u);
}, td = (e, t) => Ka("#000000", e, t), nd = (e, t) => Ka("#ffffff", e, t), Ci = [50, 100, 200, 300, 400, 500, 600, 700, 800, 900, 950], od = (e) => {
  if (Lt(e, hn)) {
    let t = e.replace(/{|}/g, "");
    return Ci.reduce((n, o) => (n[o] = `{${t}.${o}}`, n), {});
  }
  return typeof e == "string" ? Ci.reduce((t, n, o) => (t[n] = o <= 5 ? nd(e, (5 - o) * 19) : td(e, (o - 5) * 15), t), {}) : e;
}, Wa = (e) => {
  var t;
  let n = ve.getTheme(), o = ur(n, e, void 0, "variable"), i = (t = o?.match(/--[\w-]+/g)) == null ? void 0 : t[0], r = ur(n, e, void 0, "value");
  return { name: i, variable: o, value: r };
}, Yt = (...e) => ur(ve.getTheme(), ...e), ur = (e = {}, t, n, o) => {
  if (t) {
    let { variable: i, options: r } = ve.defaults || {}, { prefix: a, transform: d } = e?.options || r || {}, l = Lt(t, hn) ? t : `{${t}}`;
    return o === "value" || Jt(o) && d === "strict" ? ve.getTokenValue(t) : Ua(l, void 0, a, [i.excludedKeyRegex], n);
  }
  return "";
};
function Co(e, ...t) {
  if (e instanceof Array) {
    let n = e.reduce((o, i, r) => {
      var a;
      return o + i + ((a = Xe(t[r], { dt: Yt })) != null ? a : "");
    }, "");
    return Ha(n, Yt);
  }
  return Xe(e, { dt: Yt });
}
function rd(e, t = {}) {
  let n = ve.defaults.variable, { prefix: o = n.prefix, selector: i = n.selector, excludedKeyRegex: r = n.excludedKeyRegex } = t, a = [], d = [], l = [{ node: e, path: o }];
  for (; l.length; ) {
    let { node: s, path: c } = l.pop();
    for (let p in s) {
      let f = s[p], b = Zs(f), k = Lt(p, r) ? dr(c) : dr(c, Ia(p));
      if (gt(b)) l.push({ node: b, path: k });
      else {
        let T = ja(k), $ = Ua(b, k, o, [r]);
        Qs(d, T, $);
        let S = k;
        o && S.startsWith(o + "-") && (S = S.slice(o.length + 1)), a.push(S.replace(/-/g, "."));
      }
    }
  }
  let u = d.join("");
  return { value: d, tokens: a, declarations: u, css: cn(i, u) };
}
var rt = { regex: { rules: { class: { pattern: /^\.([a-zA-Z][\w-]*)$/, resolve(e) {
  return { type: "class", selector: e, matched: this.pattern.test(e.trim()) };
} }, attr: { pattern: /^\[(.*)\]$/, resolve(e) {
  return { type: "attr", selector: `:root${e}`, matched: this.pattern.test(e.trim()) };
} }, media: { pattern: /^@media (.*)$/, resolve(e) {
  return { type: "media", selector: e, matched: this.pattern.test(e.trim()) };
} }, system: { pattern: /^system$/, resolve(e) {
  return { type: "system", selector: "@media (prefers-color-scheme: dark)", matched: this.pattern.test(e.trim()) };
} }, custom: { resolve(e) {
  return { type: "custom", selector: e, matched: !0 };
} } }, resolve(e) {
  let t = Object.keys(this.rules).filter((n) => n !== "custom").map((n) => this.rules[n]);
  return [e].flat().map((n) => {
    var o;
    return (o = t.map((i) => i.resolve(n)).find((i) => i.matched)) != null ? o : this.rules.custom.resolve(n);
  });
} }, _toVariables(e, t) {
  return rd(e, { prefix: t?.prefix });
}, getCommon({ name: e = "", theme: t = {}, params: n, set: o, defaults: i }) {
  var r, a, d, l, u, s, c;
  let { preset: p, options: f } = t, b, k, T, $, S, O, w;
  if (le(p) && f.transform !== "strict") {
    let { primitive: F, semantic: D, extend: C } = p, I = D || {}, { colorScheme: N } = I, K = yt(I, ["colorScheme"]), V = C || {}, { colorScheme: M } = V, P = yt(V, ["colorScheme"]), E = N || {}, { dark: H } = E, ae = yt(E, ["dark"]), fe = M || {}, { dark: Be } = fe, Ae = yt(fe, ["dark"]), Oe = le(F) ? this._toVariables({ primitive: F }, f) : {}, _e = le(K) ? this._toVariables({ semantic: K }, f) : {}, be = le(ae) ? this._toVariables({ light: ae }, f) : {}, je = le(H) ? this._toVariables({ dark: H }, f) : {}, G = le(P) ? this._toVariables({ semantic: P }, f) : {}, Fe = le(Ae) ? this._toVariables({ light: Ae }, f) : {}, He = le(Be) ? this._toVariables({ dark: Be }, f) : {}, [Me, Vt] = [(r = Oe.declarations) != null ? r : "", Oe.tokens], [Nt, jt] = [(a = _e.declarations) != null ? a : "", _e.tokens || []], [_, J] = [(d = be.declarations) != null ? d : "", be.tokens || []], [re, ie] = [(l = je.declarations) != null ? l : "", je.tokens || []], [we, Z] = [(u = G.declarations) != null ? u : "", G.tokens || []], [ke, Tt] = [(s = Fe.declarations) != null ? s : "", Fe.tokens || []], [It, ot] = [(c = He.declarations) != null ? c : "", He.tokens || []];
    b = this.transformCSS(e, Me, "light", "variable", f, o, i), k = Vt;
    let vt = this.transformCSS(e, `${Nt}${_}`, "light", "variable", f, o, i), bo = this.transformCSS(e, `${re}`, "dark", "variable", f, o, i);
    T = `${vt}${bo}`, $ = [.../* @__PURE__ */ new Set([...jt, ...J, ...ie])];
    let Zo = this.transformCSS(e, `${we}${ke}color-scheme:light`, "light", "variable", f, o, i), vo = this.transformCSS(e, `${It}color-scheme:dark`, "dark", "variable", f, o, i);
    S = `${Zo}${vo}`, O = [.../* @__PURE__ */ new Set([...Z, ...Tt, ...ot])], w = Xe(p.css, { dt: Yt });
  }
  return { primitive: { css: b, tokens: k }, semantic: { css: T, tokens: $ }, global: { css: S, tokens: O }, style: w };
}, getPreset({ name: e = "", preset: t = {}, options: n, params: o, set: i, defaults: r, selector: a }) {
  var d, l, u;
  let s, c, p;
  if (le(t) && n.transform !== "strict") {
    let f = e.replace("-directive", ""), b = t, { colorScheme: k, extend: T, css: $ } = b, S = yt(b, ["colorScheme", "extend", "css"]), O = T || {}, { colorScheme: w } = O, F = yt(O, ["colorScheme"]), D = k || {}, { dark: C } = D, I = yt(D, ["dark"]), N = w || {}, { dark: K } = N, V = yt(N, ["dark"]), M = le(S) ? this._toVariables({ [f]: it(it({}, S), F) }, n) : {}, P = le(I) ? this._toVariables({ [f]: it(it({}, I), V) }, n) : {}, E = le(C) ? this._toVariables({ [f]: it(it({}, C), K) }, n) : {}, [H, ae] = [(d = M.declarations) != null ? d : "", M.tokens || []], [fe, Be] = [(l = P.declarations) != null ? l : "", P.tokens || []], [Ae, Oe] = [(u = E.declarations) != null ? u : "", E.tokens || []], _e = this.transformCSS(f, `${H}${fe}`, "light", "variable", n, i, r, a), be = this.transformCSS(f, Ae, "dark", "variable", n, i, r, a);
    s = `${_e}${be}`, c = [.../* @__PURE__ */ new Set([...ae, ...Be, ...Oe])], p = Xe($, { dt: Yt });
  }
  return { css: s, tokens: c, style: p };
}, getPresetC({ name: e = "", theme: t = {}, params: n, set: o, defaults: i }) {
  var r;
  let { preset: a, options: d } = t, l = (r = a?.components) == null ? void 0 : r[e];
  return this.getPreset({ name: e, preset: l, options: d, params: n, set: o, defaults: i });
}, getPresetD({ name: e = "", theme: t = {}, params: n, set: o, defaults: i }) {
  var r, a;
  let d = e.replace("-directive", ""), { preset: l, options: u } = t, s = ((r = l?.components) == null ? void 0 : r[d]) || ((a = l?.directives) == null ? void 0 : a[d]);
  return this.getPreset({ name: d, preset: s, options: u, params: n, set: o, defaults: i });
}, applyDarkColorScheme(e) {
  return !(e.darkModeSelector === "none" || e.darkModeSelector === !1);
}, getColorSchemeOption(e, t) {
  var n;
  return this.applyDarkColorScheme(e) ? this.regex.resolve(e.darkModeSelector === !0 ? t.options.darkModeSelector : (n = e.darkModeSelector) != null ? n : t.options.darkModeSelector) : [];
}, getLayerOrder(e, t = {}, n, o) {
  let { cssLayer: i } = t;
  return i ? `@layer ${Xe(i.order || i.name || "primeui", n)}` : "";
}, getCommonStyleSheet({ name: e = "", theme: t = {}, params: n, props: o = {}, set: i, defaults: r }) {
  let a = this.getCommon({ name: e, theme: t, params: n, set: i, defaults: r }), d = Object.entries(o).reduce((l, [u, s]) => l.push(`${u}="${s}"`) && l, []).join(" ");
  return Object.entries(a || {}).reduce((l, [u, s]) => {
    if (gt(s) && Object.hasOwn(s, "css")) {
      let c = Mn(s.css), p = `${u}-variables`;
      l.push(`<style type="text/css" data-primevue-style-id="${p}" ${d}>${c}</style>`);
    }
    return l;
  }, []).join("");
}, getStyleSheet({ name: e = "", theme: t = {}, params: n, props: o = {}, set: i, defaults: r }) {
  var a;
  let d = { name: e, theme: t, params: n, set: i, defaults: r }, l = (a = e.includes("-directive") ? this.getPresetD(d) : this.getPresetC(d)) == null ? void 0 : a.css, u = Object.entries(o).reduce((s, [c, p]) => s.push(`${c}="${p}"`) && s, []).join(" ");
  return l ? `<style type="text/css" data-primevue-style-id="${e}-variables" ${u}>${Mn(l)}</style>` : "";
}, createTokens(e = {}, t, n = "", o = "", i = {}) {
  let r = function(d, l = {}, u = []) {
    if (u.includes(this.path)) return console.warn(`Circular reference detected at ${this.path}`), { colorScheme: d, path: this.path, paths: l, value: void 0 };
    u.push(this.path), l.name = this.path, l.binding || (l.binding = {});
    let s = this.value;
    if (typeof this.value == "string" && hn.test(this.value)) {
      let c = this.value.trim().replace(hn, (p) => {
        var f;
        let b = p.slice(1, -1), k = this.tokens[b];
        if (!k) return console.warn(`Token not found for path: ${b}`), "__UNRESOLVED__";
        let T = k.computed(d, l, u);
        return Array.isArray(T) && T.length === 2 ? `light-dark(${T[0].value},${T[1].value})` : (f = T?.value) != null ? f : "__UNRESOLVED__";
      });
      s = Va.test(c.replace(Na, "0")) ? `calc(${c})` : c;
    }
    return Jt(l.binding) && delete l.binding, u.pop(), { colorScheme: d, path: this.path, paths: l, value: s.includes("__UNRESOLVED__") ? void 0 : s };
  }, a = (d, l, u) => {
    Object.entries(d).forEach(([s, c]) => {
      let p = Lt(s, t.variable.excludedKeyRegex) ? l : l ? `${l}.${ki(s)}` : ki(s), f = u ? `${u}.${s}` : s;
      gt(c) ? a(c, p, f) : (i[p] || (i[p] = { paths: [], computed: (b, k = {}, T = []) => {
        if (i[p].paths.length === 1) return i[p].paths[0].computed(i[p].paths[0].scheme, k.binding, T);
        if (b && b !== "none") for (let $ = 0; $ < i[p].paths.length; $++) {
          let S = i[p].paths[$];
          if (S.scheme === b) return S.computed(b, k.binding, T);
        }
        return i[p].paths.map(($) => $.computed($.scheme, k[$.scheme], T));
      } }), i[p].paths.push({ path: f, value: c, scheme: f.includes("colorScheme.light") ? "light" : f.includes("colorScheme.dark") ? "dark" : "none", computed: r, tokens: i }));
    });
  };
  return a(e, n, o), i;
}, getTokenValue(e, t, n) {
  var o;
  let i = ((d) => d.split(".").filter((l) => !Lt(l.toLowerCase(), n.variable.excludedKeyRegex)).join("."))(t), r = t.includes("colorScheme.light") ? "light" : t.includes("colorScheme.dark") ? "dark" : void 0, a = [(o = e[i]) == null ? void 0 : o.computed(r)].flat().filter((d) => d);
  return a.length === 1 ? a[0].value : a.reduce((d = {}, l) => {
    let u = l, { colorScheme: s } = u, c = yt(u, ["colorScheme"]);
    return d[s] = c, d;
  }, void 0);
}, getSelectorRule(e, t, n, o) {
  return n === "class" || n === "attr" ? cn(le(t) ? `${e}${t},${e} ${t}` : e, o) : cn(e, cn(t ?? ":root", o));
}, transformCSS(e, t, n, o, i = {}, r, a, d) {
  if (le(t)) {
    let { cssLayer: l } = i;
    if (o !== "style") {
      let u = this.getColorSchemeOption(i, a);
      t = n === "dark" ? u.reduce((s, { type: c, selector: p }) => (le(p) && (s += p.includes("[CSS]") ? p.replace("[CSS]", t) : this.getSelectorRule(p, d, c, t)), s), "") : cn(d ?? ":root", t);
    }
    if (l) {
      let u = { name: "primeui" };
      gt(l) && (u.name = Xe(l.name, { name: e, type: o })), le(u.name) && (t = cn(`@layer ${u.name}`, t), r?.layerNames(u.name));
    }
    return t;
  }
  return "";
} }, ve = { defaults: { variable: { prefix: "p", selector: ":root", excludedKeyRegex: /^(primitive|semantic|components|directives|variables|colorscheme|light|dark|common|root|states|extend|css)$/gi }, options: { prefix: "p", darkModeSelector: "system", cssLayer: !1 } }, _theme: void 0, _layerNames: /* @__PURE__ */ new Set(), _loadedStyleNames: /* @__PURE__ */ new Set(), _loadingStyles: /* @__PURE__ */ new Set(), _tokens: {}, update(e = {}) {
  let { theme: t } = e;
  t && (this._theme = Qo(it({}, t), { options: it(it({}, this.defaults.options), t.options) }), this._tokens = rt.createTokens(this.preset, this.defaults), this.clearLoadedStyleNames());
}, get theme() {
  return this._theme;
}, get preset() {
  var e;
  return ((e = this.theme) == null ? void 0 : e.preset) || {};
}, get options() {
  var e;
  return ((e = this.theme) == null ? void 0 : e.options) || {};
}, get tokens() {
  return this._tokens;
}, getTheme() {
  return this.theme;
}, setTheme(e) {
  this.update({ theme: e }), Ee.emit("theme:change", e);
}, getPreset() {
  return this.preset;
}, setPreset(e) {
  this._theme = Qo(it({}, this.theme), { preset: e }), this._tokens = rt.createTokens(e, this.defaults), this.clearLoadedStyleNames(), Ee.emit("preset:change", e), Ee.emit("theme:change", this.theme);
}, getOptions() {
  return this.options;
}, setOptions(e) {
  this._theme = Qo(it({}, this.theme), { options: e }), this.clearLoadedStyleNames(), Ee.emit("options:change", e), Ee.emit("theme:change", this.theme);
}, getLayerNames() {
  return [...this._layerNames];
}, setLayerNames(e) {
  this._layerNames.add(e);
}, getLoadedStyleNames() {
  return this._loadedStyleNames;
}, isStyleNameLoaded(e) {
  return this._loadedStyleNames.has(e);
}, setLoadedStyleName(e) {
  this._loadedStyleNames.add(e);
}, deleteLoadedStyleName(e) {
  this._loadedStyleNames.delete(e);
}, clearLoadedStyleNames() {
  this._loadedStyleNames.clear();
}, getTokenValue(e) {
  return rt.getTokenValue(this.tokens, e, this.defaults);
}, getCommon(e = "", t) {
  return rt.getCommon({ name: e, theme: this.theme, params: t, defaults: this.defaults, set: { layerNames: this.setLayerNames.bind(this) } });
}, getComponent(e = "", t) {
  let n = { name: e, theme: this.theme, params: t, defaults: this.defaults, set: { layerNames: this.setLayerNames.bind(this) } };
  return rt.getPresetC(n);
}, getDirective(e = "", t) {
  let n = { name: e, theme: this.theme, params: t, defaults: this.defaults, set: { layerNames: this.setLayerNames.bind(this) } };
  return rt.getPresetD(n);
}, getCustomPreset(e = "", t, n, o) {
  let i = { name: e, preset: t, options: this.options, selector: n, params: o, defaults: this.defaults, set: { layerNames: this.setLayerNames.bind(this) } };
  return rt.getPreset(i);
}, getLayerOrderCSS(e = "") {
  return rt.getLayerOrder(e, this.options, { names: this.getLayerNames() }, this.defaults);
}, transformCSS(e = "", t, n = "style", o) {
  return rt.transformCSS(e, t, o, n, this.options, { layerNames: this.setLayerNames.bind(this) }, this.defaults);
}, getCommonStyleSheet(e = "", t, n = {}) {
  return rt.getCommonStyleSheet({ name: e, theme: this.theme, params: t, props: n, defaults: this.defaults, set: { layerNames: this.setLayerNames.bind(this) } });
}, getStyleSheet(e, t, n = {}) {
  return rt.getStyleSheet({ name: e, theme: this.theme, params: t, props: n, defaults: this.defaults, set: { layerNames: this.setLayerNames.bind(this) } });
}, onStyleMounted(e) {
  this._loadingStyles.add(e);
}, onStyleUpdated(e) {
  this._loadingStyles.add(e);
}, onStyleLoaded(e, { name: t }) {
  this._loadingStyles.size && (this._loadingStyles.delete(t), Ee.emit(`theme:${t}:load`, e), !this._loadingStyles.size && Ee.emit("theme:load"));
} }, Ve = {
  STARTS_WITH: "startsWith",
  CONTAINS: "contains",
  NOT_CONTAINS: "notContains",
  ENDS_WITH: "endsWith",
  EQUALS: "equals",
  NOT_EQUALS: "notEquals",
  LESS_THAN: "lt",
  LESS_THAN_OR_EQUAL_TO: "lte",
  GREATER_THAN: "gt",
  GREATER_THAN_OR_EQUAL_TO: "gte",
  DATE_IS: "dateIs",
  DATE_IS_NOT: "dateIsNot",
  DATE_BEFORE: "dateBefore",
  DATE_AFTER: "dateAfter"
};
function Si(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (!n) {
    if (Array.isArray(e) || (n = id(e)) || t) {
      n && (e = n);
      var o = 0, i = function() {
      };
      return { s: i, n: function() {
        return o >= e.length ? { done: !0 } : { done: !1, value: e[o++] };
      }, e: function(u) {
        throw u;
      }, f: i };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var r, a = !0, d = !1;
  return { s: function() {
    n = n.call(e);
  }, n: function() {
    var u = n.next();
    return a = u.done, u;
  }, e: function(u) {
    d = !0, r = u;
  }, f: function() {
    try {
      a || n.return == null || n.return();
    } finally {
      if (d) throw r;
    }
  } };
}
function id(e, t) {
  if (e) {
    if (typeof e == "string") return $i(e, t);
    var n = {}.toString.call(e).slice(8, -1);
    return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? $i(e, t) : void 0;
  }
}
function $i(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, o = Array(t); n < t; n++) o[n] = e[n];
  return o;
}
var ad = {
  filter: function(t, n, o, i, r) {
    var a = [];
    if (!t)
      return a;
    var d = Si(t), l;
    try {
      for (d.s(); !(l = d.n()).done; ) {
        var u = l.value;
        if (typeof u == "string") {
          if (this.filters[i](u, o, r)) {
            a.push(u);
            continue;
          }
        } else {
          var s = Si(n), c;
          try {
            for (s.s(); !(c = s.n()).done; ) {
              var p = c.value, f = kt(u, p);
              if (this.filters[i](f, o, r)) {
                a.push(u);
                break;
              }
            }
          } catch (b) {
            s.e(b);
          } finally {
            s.f();
          }
        }
      }
    } catch (b) {
      d.e(b);
    } finally {
      d.f();
    }
    return a;
  },
  filters: {
    startsWith: function(t, n, o) {
      if (n == null || n === "")
        return !0;
      if (t == null)
        return !1;
      var i = tt(n.toString()).toLocaleLowerCase(o), r = tt(t.toString()).toLocaleLowerCase(o);
      return r.slice(0, i.length) === i;
    },
    contains: function(t, n, o) {
      if (n == null || n === "")
        return !0;
      if (t == null)
        return !1;
      var i = tt(n.toString()).toLocaleLowerCase(o), r = tt(t.toString()).toLocaleLowerCase(o);
      return r.indexOf(i) !== -1;
    },
    notContains: function(t, n, o) {
      if (n == null || n === "")
        return !0;
      if (t == null)
        return !1;
      var i = tt(n.toString()).toLocaleLowerCase(o), r = tt(t.toString()).toLocaleLowerCase(o);
      return r.indexOf(i) === -1;
    },
    endsWith: function(t, n, o) {
      if (n == null || n === "")
        return !0;
      if (t == null)
        return !1;
      var i = tt(n.toString()).toLocaleLowerCase(o), r = tt(t.toString()).toLocaleLowerCase(o);
      return r.indexOf(i, r.length - i.length) !== -1;
    },
    equals: function(t, n, o) {
      return n == null || n === "" ? !0 : t == null ? !1 : t.getTime && n.getTime ? t.getTime() === n.getTime() : tt(t.toString()).toLocaleLowerCase(o) == tt(n.toString()).toLocaleLowerCase(o);
    },
    notEquals: function(t, n, o) {
      return n == null || n === "" ? !1 : t == null ? !0 : t.getTime && n.getTime ? t.getTime() !== n.getTime() : tt(t.toString()).toLocaleLowerCase(o) != tt(n.toString()).toLocaleLowerCase(o);
    },
    in: function(t, n) {
      if (n == null || n.length === 0)
        return !0;
      for (var o = 0; o < n.length; o++)
        if (co(t, n[o]))
          return !0;
      return !1;
    },
    between: function(t, n) {
      return n == null || n[0] == null || n[1] == null ? !0 : t == null ? !1 : t.getTime ? n[0].getTime() <= t.getTime() && t.getTime() <= n[1].getTime() : n[0] <= t && t <= n[1];
    },
    lt: function(t, n) {
      return n == null ? !0 : t == null ? !1 : t.getTime && n.getTime ? t.getTime() < n.getTime() : t < n;
    },
    lte: function(t, n) {
      return n == null ? !0 : t == null ? !1 : t.getTime && n.getTime ? t.getTime() <= n.getTime() : t <= n;
    },
    gt: function(t, n) {
      return n == null ? !0 : t == null ? !1 : t.getTime && n.getTime ? t.getTime() > n.getTime() : t > n;
    },
    gte: function(t, n) {
      return n == null ? !0 : t == null ? !1 : t.getTime && n.getTime ? t.getTime() >= n.getTime() : t >= n;
    },
    dateIs: function(t, n) {
      return n == null ? !0 : t == null ? !1 : t.toDateString() === n.toDateString();
    },
    dateIsNot: function(t, n) {
      return n == null ? !0 : t == null ? !1 : t.toDateString() !== n.toDateString();
    },
    dateBefore: function(t, n) {
      return n == null ? !0 : t == null ? !1 : t.getTime() < n.getTime();
    },
    dateAfter: function(t, n) {
      return n == null ? !0 : t == null ? !1 : t.getTime() > n.getTime();
    }
  },
  register: function(t, n) {
    this.filters[t] = n;
  }
}, ld = `
    *,
    ::before,
    ::after {
        box-sizing: border-box;
    }

    /* Non vue overlay animations */
    .p-connected-overlay {
        opacity: 0;
        transform: scaleY(0.8);
        transition:
            transform 0.12s cubic-bezier(0, 0, 0.2, 1),
            opacity 0.12s cubic-bezier(0, 0, 0.2, 1);
    }

    .p-connected-overlay-visible {
        opacity: 1;
        transform: scaleY(1);
    }

    .p-connected-overlay-hidden {
        opacity: 0;
        transform: scaleY(1);
        transition: opacity 0.1s linear;
    }

    /* Vue based overlay animations */
    .p-connected-overlay-enter-from {
        opacity: 0;
        transform: scaleY(0.8);
    }

    .p-connected-overlay-leave-to {
        opacity: 0;
    }

    .p-connected-overlay-enter-active {
        transition:
            transform 0.12s cubic-bezier(0, 0, 0.2, 1),
            opacity 0.12s cubic-bezier(0, 0, 0.2, 1);
    }

    .p-connected-overlay-leave-active {
        transition: opacity 0.1s linear;
    }

    /* Toggleable Content */
    .p-toggleable-content-enter-from,
    .p-toggleable-content-leave-to {
        max-height: 0;
    }

    .p-toggleable-content-enter-to,
    .p-toggleable-content-leave-from {
        max-height: 1000px;
    }

    .p-toggleable-content-leave-active {
        overflow: hidden;
        transition: max-height 0.45s cubic-bezier(0, 1, 0, 1);
    }

    .p-toggleable-content-enter-active {
        overflow: hidden;
        transition: max-height 1s ease-in-out;
    }

    .p-disabled,
    .p-disabled * {
        cursor: default;
        pointer-events: none;
        user-select: none;
    }

    .p-disabled,
    .p-component:disabled {
        opacity: dt('disabled.opacity');
    }

    .pi {
        font-size: dt('icon.size');
    }

    .p-icon {
        width: dt('icon.size');
        height: dt('icon.size');
    }

    .p-overlay-mask {
        background: dt('mask.background');
        color: dt('mask.color');
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }

    .p-overlay-mask-enter {
        animation: p-overlay-mask-enter-animation dt('mask.transition.duration') forwards;
    }

    .p-overlay-mask-leave {
        animation: p-overlay-mask-leave-animation dt('mask.transition.duration') forwards;
    }

    @keyframes p-overlay-mask-enter-animation {
        from {
            background: transparent;
        }
        to {
            background: dt('mask.background');
        }
    }
    @keyframes p-overlay-mask-leave-animation {
        from {
            background: dt('mask.background');
        }
        to {
            background: transparent;
        }
    }
`;
function Rn(e) {
  "@babel/helpers - typeof";
  return Rn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Rn(e);
}
function Bi(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    t && (o = o.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, o);
  }
  return n;
}
function Ti(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Bi(Object(n), !0).forEach(function(o) {
      sd(e, o, n[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Bi(Object(n)).forEach(function(o) {
      Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(n, o));
    });
  }
  return e;
}
function sd(e, t, n) {
  return (t = dd(t)) in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function dd(e) {
  var t = ud(e, "string");
  return Rn(t) == "symbol" ? t : t + "";
}
function ud(e, t) {
  if (Rn(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var o = n.call(e, t);
    if (Rn(o) != "object") return o;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function cd(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
  pi() && pi().components ? Er(e) : t ? e() : cs(e);
}
var pd = 0;
function md(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = W(!1), o = W(e), i = W(null), r = _a() ? window.document : void 0, a = t.document, d = a === void 0 ? r : a, l = t.immediate, u = l === void 0 ? !0 : l, s = t.manual, c = s === void 0 ? !1 : s, p = t.name, f = p === void 0 ? "style_".concat(++pd) : p, b = t.id, k = b === void 0 ? void 0 : b, T = t.media, $ = T === void 0 ? void 0 : T, S = t.nonce, O = S === void 0 ? void 0 : S, w = t.first, F = w === void 0 ? !1 : w, D = t.onMounted, C = D === void 0 ? void 0 : D, I = t.onUpdated, N = I === void 0 ? void 0 : I, K = t.onLoad, V = K === void 0 ? void 0 : K, M = t.props, P = M === void 0 ? {} : M, E = function() {
  }, H = function(Be) {
    var Ae = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (d) {
      var Oe = Ti(Ti({}, P), Ae), _e = Oe.name || f, be = Oe.id || k, je = Oe.nonce || O;
      i.value = d.querySelector('style[data-primevue-style-id="'.concat(_e, '"]')) || d.getElementById(be) || d.createElement("style"), i.value.isConnected || (o.value = Be || e, zo(i.value, {
        type: "text/css",
        id: be,
        media: $,
        nonce: je
      }), F ? d.head.prepend(i.value) : d.head.appendChild(i.value), Wr(i.value, "data-primevue-style-id", _e), zo(i.value, Oe), i.value.onload = function(G) {
        return V?.(G, {
          name: _e
        });
      }, C?.(_e)), !n.value && (E = te(o, function(G) {
        i.value.textContent = G, N?.(_e);
      }, {
        immediate: !0
      }), n.value = !0);
    }
  }, ae = function() {
    !d || !n.value || (E(), Es(i.value) && d.head.removeChild(i.value), n.value = !1, i.value = null);
  };
  return u && !c && cd(H), {
    id: k,
    name: f,
    el: i,
    css: o,
    unload: ae,
    load: H,
    isLoaded: Ca(n)
  };
}
function Vn(e) {
  "@babel/helpers - typeof";
  return Vn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Vn(e);
}
var Ii, Di, Pi, zi;
function Li(e, t) {
  return bd(e) || hd(e, t) || gd(e, t) || fd();
}
function fd() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function gd(e, t) {
  if (e) {
    if (typeof e == "string") return Oi(e, t);
    var n = {}.toString.call(e).slice(8, -1);
    return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Oi(e, t) : void 0;
  }
}
function Oi(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, o = Array(t); n < t; n++) o[n] = e[n];
  return o;
}
function hd(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var o, i, r, a, d = [], l = !0, u = !1;
    try {
      if (r = (n = n.call(e)).next, t !== 0) for (; !(l = (o = r.call(n)).done) && (d.push(o.value), d.length !== t); l = !0) ;
    } catch (s) {
      u = !0, i = s;
    } finally {
      try {
        if (!l && n.return != null && (a = n.return(), Object(a) !== a)) return;
      } finally {
        if (u) throw i;
      }
    }
    return d;
  }
}
function bd(e) {
  if (Array.isArray(e)) return e;
}
function Mi(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    t && (o = o.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, o);
  }
  return n;
}
function er(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Mi(Object(n), !0).forEach(function(o) {
      vd(e, o, n[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Mi(Object(n)).forEach(function(o) {
      Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(n, o));
    });
  }
  return e;
}
function vd(e, t, n) {
  return (t = yd(t)) in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function yd(e) {
  var t = kd(e, "string");
  return Vn(t) == "symbol" ? t : t + "";
}
function kd(e, t) {
  if (Vn(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var o = n.call(e, t);
    if (Vn(o) != "object") return o;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function So(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } }));
}
var wd = function(t) {
  var n = t.dt;
  return `
.p-hidden-accessible {
    border: 0;
    clip: rect(0 0 0 0);
    height: 1px;
    margin: -1px;
    opacity: 0;
    overflow: hidden;
    padding: 0;
    pointer-events: none;
    position: absolute;
    white-space: nowrap;
    width: 1px;
}

.p-overflow-hidden {
    overflow: hidden;
    padding-right: `.concat(n("scrollbar.width"), `;
}
`);
}, xd = {}, Cd = {}, oe = {
  name: "base",
  css: wd,
  style: ld,
  classes: xd,
  inlineStyles: Cd,
  load: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : function(r) {
      return r;
    }, i = o(Co(Ii || (Ii = So(["", ""])), t));
    return le(i) ? md(Mn(i), er({
      name: this.name
    }, n)) : {};
  },
  loadCSS: function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return this.load(this.css, t);
  },
  loadStyle: function() {
    var t = this, n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    return this.load(this.style, n, function() {
      var i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
      return ve.transformCSS(n.name || t.name, "".concat(i).concat(Co(Di || (Di = So(["", ""])), o)));
    });
  },
  getCommonTheme: function(t) {
    return ve.getCommon(this.name, t);
  },
  getComponentTheme: function(t) {
    return ve.getComponent(this.name, t);
  },
  getDirectiveTheme: function(t) {
    return ve.getDirective(this.name, t);
  },
  getPresetTheme: function(t, n, o) {
    return ve.getCustomPreset(this.name, t, n, o);
  },
  getLayerOrderThemeCSS: function() {
    return ve.getLayerOrderCSS(this.name);
  },
  getStyleSheet: function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (this.css) {
      var o = Xe(this.css, {
        dt: Yt
      }) || "", i = Mn(Co(Pi || (Pi = So(["", "", ""])), o, t)), r = Object.entries(n).reduce(function(a, d) {
        var l = Li(d, 2), u = l[0], s = l[1];
        return a.push("".concat(u, '="').concat(s, '"')) && a;
      }, []).join(" ");
      return le(i) ? '<style type="text/css" data-primevue-style-id="'.concat(this.name, '" ').concat(r, ">").concat(i, "</style>") : "";
    }
    return "";
  },
  getCommonThemeStyleSheet: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return ve.getCommonStyleSheet(this.name, t, n);
  },
  getThemeStyleSheet: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, o = [ve.getStyleSheet(this.name, t, n)];
    if (this.style) {
      var i = this.name === "base" ? "global-style" : "".concat(this.name, "-style"), r = Co(zi || (zi = So(["", ""])), Xe(this.style, {
        dt: Yt
      })), a = Mn(ve.transformCSS(i, r)), d = Object.entries(n).reduce(function(l, u) {
        var s = Li(u, 2), c = s[0], p = s[1];
        return l.push("".concat(c, '="').concat(p, '"')) && l;
      }, []).join(" ");
      le(a) && o.push('<style type="text/css" data-primevue-style-id="'.concat(i, '" ').concat(d, ">").concat(a, "</style>"));
    }
    return o.join("");
  },
  extend: function(t) {
    return er(er({}, this), {}, {
      css: void 0,
      style: void 0
    }, t);
  }
}, zt = jr();
function Nn(e) {
  "@babel/helpers - typeof";
  return Nn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Nn(e);
}
function Ai(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    t && (o = o.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, o);
  }
  return n;
}
function $o(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Ai(Object(n), !0).forEach(function(o) {
      Sd(e, o, n[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Ai(Object(n)).forEach(function(o) {
      Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(n, o));
    });
  }
  return e;
}
function Sd(e, t, n) {
  return (t = $d(t)) in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function $d(e) {
  var t = Bd(e, "string");
  return Nn(t) == "symbol" ? t : t + "";
}
function Bd(e, t) {
  if (Nn(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var o = n.call(e, t);
    if (Nn(o) != "object") return o;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var Td = {
  ripple: !1,
  inputStyle: null,
  inputVariant: null,
  locale: {
    startsWith: "Starts with",
    contains: "Contains",
    notContains: "Not contains",
    endsWith: "Ends with",
    equals: "Equals",
    notEquals: "Not equals",
    noFilter: "No Filter",
    lt: "Less than",
    lte: "Less than or equal to",
    gt: "Greater than",
    gte: "Greater than or equal to",
    dateIs: "Date is",
    dateIsNot: "Date is not",
    dateBefore: "Date is before",
    dateAfter: "Date is after",
    clear: "Clear",
    apply: "Apply",
    matchAll: "Match All",
    matchAny: "Match Any",
    addRule: "Add Rule",
    removeRule: "Remove Rule",
    accept: "Yes",
    reject: "No",
    choose: "Choose",
    upload: "Upload",
    cancel: "Cancel",
    completed: "Completed",
    pending: "Pending",
    fileSizeTypes: ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"],
    dayNames: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
    dayNamesShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    dayNamesMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
    monthNames: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
    monthNamesShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    chooseYear: "Choose Year",
    chooseMonth: "Choose Month",
    chooseDate: "Choose Date",
    prevDecade: "Previous Decade",
    nextDecade: "Next Decade",
    prevYear: "Previous Year",
    nextYear: "Next Year",
    prevMonth: "Previous Month",
    nextMonth: "Next Month",
    prevHour: "Previous Hour",
    nextHour: "Next Hour",
    prevMinute: "Previous Minute",
    nextMinute: "Next Minute",
    prevSecond: "Previous Second",
    nextSecond: "Next Second",
    am: "am",
    pm: "pm",
    today: "Today",
    weekHeader: "Wk",
    firstDayOfWeek: 0,
    showMonthAfterYear: !1,
    dateFormat: "mm/dd/yy",
    weak: "Weak",
    medium: "Medium",
    strong: "Strong",
    passwordPrompt: "Enter a password",
    emptyFilterMessage: "No results found",
    searchMessage: "{0} results are available",
    selectionMessage: "{0} items selected",
    emptySelectionMessage: "No selected item",
    emptySearchMessage: "No results found",
    fileChosenMessage: "{0} files",
    noFileChosenMessage: "No file chosen",
    emptyMessage: "No available options",
    aria: {
      trueLabel: "True",
      falseLabel: "False",
      nullLabel: "Not Selected",
      star: "1 star",
      stars: "{star} stars",
      selectAll: "All items selected",
      unselectAll: "All items unselected",
      close: "Close",
      previous: "Previous",
      next: "Next",
      navigation: "Navigation",
      scrollTop: "Scroll Top",
      moveTop: "Move Top",
      moveUp: "Move Up",
      moveDown: "Move Down",
      moveBottom: "Move Bottom",
      moveToTarget: "Move to Target",
      moveToSource: "Move to Source",
      moveAllToTarget: "Move All to Target",
      moveAllToSource: "Move All to Source",
      pageLabel: "Page {page}",
      firstPageLabel: "First Page",
      lastPageLabel: "Last Page",
      nextPageLabel: "Next Page",
      prevPageLabel: "Previous Page",
      rowsPerPageLabel: "Rows per page",
      jumpToPageDropdownLabel: "Jump to Page Dropdown",
      jumpToPageInputLabel: "Jump to Page Input",
      selectRow: "Row Selected",
      unselectRow: "Row Unselected",
      expandRow: "Row Expanded",
      collapseRow: "Row Collapsed",
      showFilterMenu: "Show Filter Menu",
      hideFilterMenu: "Hide Filter Menu",
      filterOperator: "Filter Operator",
      filterConstraint: "Filter Constraint",
      editRow: "Row Edit",
      saveEdit: "Save Edit",
      cancelEdit: "Cancel Edit",
      listView: "List View",
      gridView: "Grid View",
      slide: "Slide",
      slideNumber: "{slideNumber}",
      zoomImage: "Zoom Image",
      zoomIn: "Zoom In",
      zoomOut: "Zoom Out",
      rotateRight: "Rotate Right",
      rotateLeft: "Rotate Left",
      listLabel: "Option List"
    }
  },
  filterMatchModeOptions: {
    text: [Ve.STARTS_WITH, Ve.CONTAINS, Ve.NOT_CONTAINS, Ve.ENDS_WITH, Ve.EQUALS, Ve.NOT_EQUALS],
    numeric: [Ve.EQUALS, Ve.NOT_EQUALS, Ve.LESS_THAN, Ve.LESS_THAN_OR_EQUAL_TO, Ve.GREATER_THAN, Ve.GREATER_THAN_OR_EQUAL_TO],
    date: [Ve.DATE_IS, Ve.DATE_IS_NOT, Ve.DATE_BEFORE, Ve.DATE_AFTER]
  },
  zIndex: {
    modal: 1100,
    overlay: 1e3,
    menu: 1e3,
    tooltip: 1100
  },
  theme: void 0,
  unstyled: !1,
  pt: void 0,
  ptOptions: {
    mergeSections: !0,
    mergeProps: !1
  },
  csp: {
    nonce: void 0
  }
}, Ya = Symbol();
function Id() {
  var e = ce(Ya);
  if (!e)
    throw new Error("PrimeVue is not installed!");
  return e;
}
function Dd(e, t) {
  var n = {
    config: Do(t)
  };
  return e.config.globalProperties.$primevue = n, e.provide(Ya, n), Pd(), zd(e, n), n;
}
var pn = [];
function Pd() {
  Ee.clear(), pn.forEach(function(e) {
    return e?.();
  }), pn = [];
}
function zd(e, t) {
  var n = W(!1), o = function() {
    var u;
    if (((u = t.config) === null || u === void 0 ? void 0 : u.theme) !== "none" && !ve.isStyleNameLoaded("common")) {
      var s, c, p = ((s = oe.getCommonTheme) === null || s === void 0 ? void 0 : s.call(oe)) || {}, f = p.primitive, b = p.semantic, k = p.global, T = p.style, $ = {
        nonce: (c = t.config) === null || c === void 0 || (c = c.csp) === null || c === void 0 ? void 0 : c.nonce
      };
      oe.load(f?.css, $o({
        name: "primitive-variables"
      }, $)), oe.load(b?.css, $o({
        name: "semantic-variables"
      }, $)), oe.load(k?.css, $o({
        name: "global-variables"
      }, $)), oe.loadStyle($o({
        name: "global-style"
      }, $), T), ve.setLoadedStyleName("common");
    }
  };
  Ee.on("theme:change", function(l) {
    n.value || (e.config.globalProperties.$primevue.config.theme = l, n.value = !0);
  });
  var i = te(t.config, function(l, u) {
    zt.emit("config:change", {
      newValue: l,
      oldValue: u
    });
  }, {
    immediate: !0,
    deep: !0
  }), r = te(function() {
    return t.config.ripple;
  }, function(l, u) {
    zt.emit("config:ripple:change", {
      newValue: l,
      oldValue: u
    });
  }, {
    immediate: !0,
    deep: !0
  }), a = te(function() {
    return t.config.theme;
  }, function(l, u) {
    n.value || ve.setTheme(l), t.config.unstyled || o(), n.value = !1, zt.emit("config:theme:change", {
      newValue: l,
      oldValue: u
    });
  }, {
    immediate: !0,
    deep: !1
  }), d = te(function() {
    return t.config.unstyled;
  }, function(l, u) {
    !l && t.config.theme && o(), zt.emit("config:unstyled:change", {
      newValue: l,
      oldValue: u
    });
  }, {
    immediate: !0,
    deep: !0
  });
  pn.push(i), pn.push(r), pn.push(a), pn.push(d);
}
var Ld = {
  install: function(t, n) {
    var o = Ds(Td, n);
    Dd(t, o);
  }
}, Od = { transitionDuration: "{transition.duration}" }, Md = { borderWidth: "0", borderColor: "{content.border.color}" }, Ad = { color: "{text.color}", hoverColor: "{text.color}", activeColor: "{text.color}", activeHoverColor: "{text.color}", padding: "1.25rem", fontWeight: "600", borderRadius: "0", borderWidth: "0", borderColor: "{content.border.color}", background: "{content.background}", hoverBackground: "{content.hover.background}", activeBackground: "{content.background}", activeHoverBackground: "{content.background}", focusRing: { width: "0", style: "none", color: "unset", offset: "0", shadow: "none" }, toggleIcon: { color: "{text.muted.color}", hoverColor: "{text.muted.color}", activeColor: "{text.muted.color}", activeHoverColor: "{text.muted.color}" }, first: { topBorderRadius: "{content.border.radius}", borderWidth: "0" }, last: { bottomBorderRadius: "{content.border.radius}", activeBottomBorderRadius: "0" } }, _d = { borderWidth: "0", borderColor: "{content.border.color}", background: "{content.background}", color: "{text.color}", padding: "0 1.25rem 1.25rem 1.25rem" }, Fd = `
.p-accordionpanel {
    box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);
    transition: margin dt('accordion.transition.duration');
}

.p-accordionpanel-active {
    margin: 1rem 0;
}

.p-accordionpanel:first-child {
    border-top-left-radius: dt('content.border.radius');
    border-top-right-radius: dt('content.border.radius');
    margin-top: 0;
}

.p-accordionpanel:last-child {
    border-bottom-left-radius: dt('content.border.radius');
    border-bottom-right-radius: dt('content.border.radius');
    margin-bottom: 0;
}

.p-accordionpanel:not(.p-disabled) .p-accordionheader:focus-visible {
    background: dt('navigation.item.active.background');
}
`, Ed = { root: Od, panel: Md, header: Ad, content: _d, css: Fd }, Rd = { background: "{form.field.background}", disabledBackground: "{form.field.disabled.background}", filledBackground: "{form.field.filled.background}", filledHoverBackground: "{form.field.filled.hover.background}", filledFocusBackground: "{form.field.filled.focus.background}", borderColor: "{form.field.border.color}", hoverBorderColor: "{form.field.hover.border.color}", focusBorderColor: "{form.field.focus.border.color}", invalidBorderColor: "{form.field.invalid.border.color}", color: "{form.field.color}", disabledColor: "{form.field.disabled.color}", placeholderColor: "{form.field.placeholder.color}", shadow: "{form.field.shadow}", paddingX: "{form.field.padding.x}", paddingY: "{form.field.padding.y}", borderRadius: "{form.field.border.radius}", focusRing: { width: "{form.field.focus.ring.width}", style: "{form.field.focus.ring.style}", color: "{form.field.focus.ring.color}", offset: "{form.field.focus.ring.offset}", shadow: "{form.field.focus.ring.shadow}" }, transitionDuration: "{form.field.transition.duration}" }, Vd = { background: "{overlay.select.background}", borderColor: "{overlay.select.border.color}", borderRadius: "{overlay.select.border.radius}", color: "{overlay.select.color}", shadow: "{overlay.select.shadow}" }, Nd = { padding: "{list.padding}", gap: "{list.gap}" }, jd = { focusBackground: "{list.option.focus.background}", selectedBackground: "{list.option.selected.background}", selectedFocusBackground: "{list.option.selected.focus.background}", color: "{list.option.color}", focusColor: "{list.option.focus.color}", selectedColor: "{list.option.selected.color}", selectedFocusColor: "{list.option.selected.focus.color}", padding: "{list.option.padding}", borderRadius: "{list.option.border.radius}" }, Ud = { background: "{list.option.group.background}", color: "{list.option.group.color}", fontWeight: "{list.option.group.font.weight}", padding: "{list.option.group.padding}" }, Hd = { width: "3rem", sm: { width: "2.5rem" }, lg: { width: "3.5rem" }, borderColor: "{form.field.border.color}", hoverBorderColor: "{form.field.border.color}", activeBorderColor: "{form.field.border.color}", borderRadius: "{form.field.border.radius}", focusRing: { width: "0", style: "none", color: "unset", offset: "0", shadow: "none" } }, Kd = { borderRadius: "{border.radius.sm}" }, Wd = { padding: "{list.option.padding}" }, Yd = { light: { chip: { focusBackground: "{surface.300}", focusColor: "{surface.950}" }, dropdown: { background: "{surface.100}", hoverBackground: "{surface.200}", activeBackground: "{surface.300}", color: "{surface.600}", hoverColor: "{surface.700}", activeColor: "{surface.800}" } }, dark: { chip: { focusBackground: "{surface.600}", focusColor: "{surface.0}" }, dropdown: { background: "{surface.800}", hoverBackground: "{surface.700}", activeBackground: "{surface.600}", color: "{surface.300}", hoverColor: "{surface.200}", activeColor: "{surface.100}" } } }, Gd = `
.p-autocomplete-dropdown:focus-visible {
    background: dt('autocomplete.dropdown.hover.background');
    border-color: dt('autocomplete.dropdown.hover.border.color');
    color: dt('autocomplete.dropdown.hover.color');
}

.p-variant-filled.p-autocomplete-input-multiple {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    border: 1px solid transparent;
    background: dt('autocomplete.filled.background') no-repeat;
    background-image: linear-gradient(to bottom, dt('autocomplete.focus.border.color'), dt('autocomplete.focus.border.color')), linear-gradient(to bottom, dt('autocomplete.border.color'), dt('autocomplete.border.color'));
    background-size: 0 2px, 100% 1px;
    background-position: 50% 100%, 50% 100%;
    background-origin: border-box;
    transition: background-size 0.3s cubic-bezier(0.64, 0.09, 0.08, 1);
}

.p-autocomplete:not(.p-disabled):hover .p-variant-filled.p-autocomplete-input-multiple {
    background: dt('autocomplete.filled.hover.background') no-repeat;
    background-image: linear-gradient(to bottom, dt('autocomplete.focus.border.color'), dt('autocomplete.focus.border.color')), linear-gradient(to bottom, dt('autocomplete.hover.border.color'), dt('autocomplete.hover.border.color'));
    background-size: 0 2px, 100% 1px;
    background-position: 50% 100%, 50% 100%;
    background-origin: border-box;
    border-color: transparent;
}

.p-autocomplete:not(.p-disabled).p-focus .p-variant-filled.p-autocomplete-input-multiple {
    outline: 0 none;
    background: dt('autocomplete.filled.focus.background') no-repeat;
    background-image: linear-gradient(to bottom, dt('autocomplete.focus.border.color'), dt('autocomplete.focus.border.color')), linear-gradient(to bottom, dt('autocomplete.border.color'), dt('autocomplete.border.color'));
    background-size: 100% 2px, 100% 1px;
    background-position: 50% 100%, 50% 100%;
    background-origin: border-box;
    border-color: transparent;
}

.p-autocomplete:not(.p-disabled).p-focus:hover .p-variant-filled.p-autocomplete-input-multiple {
    background-image: linear-gradient(to bottom, dt('autocomplete.focus.border.color'), dt('autocomplete.focus.border.color')), linear-gradient(to bottom, dt('autocomplete.hover.border.color'), dt('autocomplete.hover.border.color'));
}

.p-autocomplete.p-invalid .p-autocomplete-input-multiple {
    background-image: linear-gradient(to bottom, dt('autocomplete.invalid.border.color'), dt('autocomplete.invalid.border.color')), linear-gradient(to bottom, dt('autocomplete.invalid.border.color'), dt('autocomplete.invalid.border.color'));
}

.p-autocomplete.p-invalid.p-focus .p-autocomplete-input-multiple  {
    background-image: linear-gradient(to bottom, dt('autocomplete.invalid.border.color'), dt('autocomplete.invalid.border.color')), linear-gradient(to bottom, dt('autocomplete.invalid.border.color'), dt('autocomplete.invalid.border.color'));
}

.p-autocomplete-option {
    transition: none;
}
`, qd = { root: Rd, overlay: Vd, list: Nd, option: jd, optionGroup: Ud, dropdown: Hd, chip: Kd, emptyMessage: Wd, colorScheme: Yd, css: Gd }, Zd = { width: "2rem", height: "2rem", fontSize: "1rem", background: "{content.border.color}", color: "{content.color}", borderRadius: "{content.border.radius}" }, Xd = { size: "1rem" }, Jd = { borderColor: "{content.background}", offset: "-0.75rem" }, Qd = { width: "3rem", height: "3rem", fontSize: "1.5rem", icon: { size: "1.5rem" }, group: { offset: "-1rem" } }, eu = { width: "4rem", height: "4rem", fontSize: "2rem", icon: { size: "2rem" }, group: { offset: "-1.5rem" } }, tu = { root: Zd, icon: Xd, group: Jd, lg: Qd, xl: eu, css: "" }, nu = { borderRadius: "{border.radius.md}", padding: "0 0.5rem", fontSize: "0.75rem", fontWeight: "700", minWidth: "1.5rem", height: "1.5rem" }, ou = { size: "0.5rem" }, ru = { fontSize: "0.625rem", minWidth: "1.25rem", height: "1.25rem" }, iu = { fontSize: "0.875rem", minWidth: "1.75rem", height: "1.75rem" }, au = { fontSize: "1rem", minWidth: "2rem", height: "2rem" }, lu = { light: { primary: { background: "{primary.color}", color: "{primary.contrast.color}" }, secondary: { background: "{surface.100}", color: "{surface.600}" }, success: { background: "{green.500}", color: "{surface.0}" }, info: { background: "{sky.500}", color: "{surface.0}" }, warn: { background: "{orange.500}", color: "{surface.0}" }, danger: { background: "{red.500}", color: "{surface.0}" }, contrast: { background: "{surface.950}", color: "{surface.0}" } }, dark: { primary: { background: "{primary.color}", color: "{primary.contrast.color}" }, secondary: { background: "{surface.800}", color: "{surface.300}" }, success: { background: "{green.400}", color: "{green.950}" }, info: { background: "{sky.400}", color: "{sky.950}" }, warn: { background: "{orange.400}", color: "{orange.950}" }, danger: { background: "{red.400}", color: "{red.950}" }, contrast: { background: "{surface.0}", color: "{surface.950}" } } }, su = { root: nu, dot: ou, sm: ru, lg: iu, xl: au, colorScheme: lu, css: "" }, du = { borderRadius: { none: "0", xs: "2px", sm: "4px", md: "6px", lg: "8px", xl: "12px" }, emerald: { 50: "#E8F6F1", 100: "#C5EBE1", 200: "#9EDFCF", 300: "#76D3BD", 400: "#58C9AF", 500: "#3BBFA1", 600: "#35AF94", 700: "#2D9B83", 800: "#268873", 900: "#1A6657", 950: "#0d3329" }, green: { 50: "#E8F5E9", 100: "#C8E6C9", 200: "#A5D6A7", 300: "#81C784", 400: "#66BB6A", 500: "#4CAF50", 600: "#43A047", 700: "#388E3C", 800: "#2E7D32", 900: "#1B5E20", 950: "#0e2f10" }, lime: { 50: "#F9FBE7", 100: "#F0F4C3", 200: "#E6EE9C", 300: "#DCE775", 400: "#D4E157", 500: "#CDDC39", 600: "#C0CA33", 700: "#AFB42B", 800: "#9E9D24", 900: "#827717", 950: "#413c0c" }, red: { 50: "#FFEBEE", 100: "#FFCDD2", 200: "#EF9A9A", 300: "#E57373", 400: "#EF5350", 500: "#F44336", 600: "#E53935", 700: "#D32F2F", 800: "#C62828", 900: "#B71C1C", 950: "#5c0e0e" }, orange: { 50: "#FFF3E0", 100: "#FFE0B2", 200: "#FFCC80", 300: "#FFB74D", 400: "#FFA726", 500: "#FF9800", 600: "#FB8C00", 700: "#F57C00", 800: "#EF6C00", 900: "#E65100", 950: "#732900" }, amber: { 50: "#FFF8E1", 100: "#FFECB3", 200: "#FFE082", 300: "#FFD54F", 400: "#FFCA28", 500: "#FFC107", 600: "#FFB300", 700: "#FFA000", 800: "#FF8F00", 900: "#FF6F00", 950: "#803800" }, yellow: { 50: "#FFFDE7", 100: "#FFF9C4", 200: "#FFF59D", 300: "#FFF176", 400: "#FFEE58", 500: "#FFEB3B", 600: "#FDD835", 700: "#FBC02D", 800: "#F9A825", 900: "#F57F17", 950: "#7b400c" }, teal: { 50: "#E0F2F1", 100: "#B2DFDB", 200: "#80CBC4", 300: "#4DB6AC", 400: "#26A69A", 500: "#009688", 600: "#00897B", 700: "#00796B", 800: "#00695C", 900: "#004D40", 950: "#002720" }, cyan: { 50: "#E0F7FA", 100: "#B2EBF2", 200: "#80DEEA", 300: "#4DD0E1", 400: "#26C6DA", 500: "#00BCD4", 600: "#00ACC1", 700: "#0097A7", 800: "#00838F", 900: "#006064", 950: "#003032" }, sky: { 50: "#E1F5FE", 100: "#B3E5FC", 200: "#81D4FA", 300: "#4FC3F7", 400: "#29B6F6", 500: "#03A9F4", 600: "#039BE5", 700: "#0288D1", 800: "#0277BD", 900: "#01579B", 950: "#012c4e" }, blue: { 50: "#E3F2FD", 100: "#BBDEFB", 200: "#90CAF9", 300: "#64B5F6", 400: "#42A5F5", 500: "#2196F3", 600: "#1E88E5", 700: "#1976D2", 800: "#1565C0", 900: "#0D47A1", 950: "#072451" }, indigo: { 50: "#E8EAF6", 100: "#C5CAE9", 200: "#9FA8DA", 300: "#7986CB", 400: "#5C6BC0", 500: "#3F51B5", 600: "#3949AB", 700: "#303F9F", 800: "#283593", 900: "#1A237E", 950: "#0d123f" }, violet: { 50: "#EDE7F6", 100: "#D1C4E9", 200: "#B39DDB", 300: "#9575CD", 400: "#7E57C2", 500: "#673AB7", 600: "#5E35B1", 700: "#512DA8", 800: "#4527A0", 900: "#311B92", 950: "#190e49" }, purple: { 50: "#F3E5F5", 100: "#E1BEE7", 200: "#CE93D8", 300: "#BA68C8", 400: "#AB47BC", 500: "#9C27B0", 600: "#8E24AA", 700: "#7B1FA2", 800: "#6A1B9A", 900: "#4A148C", 950: "#250a46" }, fuchsia: { 50: "#FDE6F3", 100: "#FBC1E3", 200: "#F897D1", 300: "#F56DBF", 400: "#F34DB2", 500: "#F12DA5", 600: "#E0289D", 700: "#CC2392", 800: "#B81E88", 900: "#951777", 950: "#4b0c3c" }, pink: { 50: "#FCE4EC", 100: "#F8BBD0", 200: "#F48FB1", 300: "#F06292", 400: "#EC407A", 500: "#E91E63", 600: "#D81B60", 700: "#C2185B", 800: "#AD1457", 900: "#880E4F", 950: "#440728" }, rose: { 50: "#FFF0F0", 100: "#FFD9D9", 200: "#FFC0C0", 300: "#FFA7A7", 400: "#FF8E8E", 500: "#FF7575", 600: "#FF5252", 700: "#FF3838", 800: "#F71C1C", 900: "#D50000", 950: "#3E0000" }, slate: { 50: "#f8fafc", 100: "#f1f5f9", 200: "#e2e8f0", 300: "#cbd5e1", 400: "#94a3b8", 500: "#64748b", 600: "#475569", 700: "#334155", 800: "#1e293b", 900: "#0f172a", 950: "#020617" }, gray: { 50: "#f9fafb", 100: "#f3f4f6", 200: "#e5e7eb", 300: "#d1d5db", 400: "#9ca3af", 500: "#6b7280", 600: "#4b5563", 700: "#374151", 800: "#1f2937", 900: "#111827", 950: "#030712" }, zinc: { 50: "#fafafa", 100: "#f4f4f5", 200: "#e4e4e7", 300: "#d4d4d8", 400: "#a1a1aa", 500: "#71717a", 600: "#52525b", 700: "#3f3f46", 800: "#27272a", 900: "#18181b", 950: "#09090b" }, neutral: { 50: "#fafafa", 100: "#f5f5f5", 200: "#e5e5e5", 300: "#d4d4d4", 400: "#a3a3a3", 500: "#737373", 600: "#525252", 700: "#404040", 800: "#262626", 900: "#171717", 950: "#0a0a0a" }, stone: { 50: "#fafaf9", 100: "#f5f5f4", 200: "#e7e5e4", 300: "#d6d3d1", 400: "#a8a29e", 500: "#78716c", 600: "#57534e", 700: "#44403c", 800: "#292524", 900: "#1c1917", 950: "#0c0a09" } }, uu = { transitionDuration: "0.2s", focusRing: { width: "0", style: "none", color: "unset", offset: "0" }, disabledOpacity: "0.38", iconSize: "1rem", anchorGutter: "0", primary: { 50: "{emerald.50}", 100: "{emerald.100}", 200: "{emerald.200}", 300: "{emerald.300}", 400: "{emerald.400}", 500: "{emerald.500}", 600: "{emerald.600}", 700: "{emerald.700}", 800: "{emerald.800}", 900: "{emerald.900}", 950: "{emerald.950}" }, formField: { paddingX: "0.75rem", paddingY: "0.75rem", sm: { fontSize: "0.875rem", paddingX: "0.625rem", paddingY: "0.625rem" }, lg: { fontSize: "1.125rem", paddingX: "0.825rem", paddingY: "0.825rem" }, borderRadius: "{border.radius.sm}", focusRing: { width: "2px", style: "solid", color: "{primary.color}", offset: "-2px", shadow: "none" }, transitionDuration: "{transition.duration}" }, list: { padding: "0.5rem 0", gap: "0", header: { padding: "0.75rem 1rem" }, option: { padding: "0.75rem 1rem", borderRadius: "{border.radius.none}" }, optionGroup: { padding: "0.75rem 1rem", fontWeight: "700" } }, content: { borderRadius: "{border.radius.sm}" }, mask: { transitionDuration: "0.15s" }, navigation: { list: { padding: "0.5rem 0", gap: "0" }, item: { padding: "0.75rem 1rem", borderRadius: "{border.radius.none}", gap: "0.5rem" }, submenuLabel: { padding: "0.75rem 1rem", fontWeight: "700" }, submenuIcon: { size: "0.875rem" } }, overlay: { select: { borderRadius: "{border.radius.sm}", shadow: "0 5px 5px -3px rgba(0,0,0,.2), 0 8px 10px 1px rgba(0,0,0,.14), 0 3px 14px 2px rgba(0,0,0,.12)" }, popover: { borderRadius: "{border.radius.sm}", padding: "1rem", shadow: "0 11px 15px -7px rgba(0,0,0,.2), 0 24px 38px 3px rgba(0,0,0,.14), 0 9px 46px 8px rgba(0,0,0,.12)" }, modal: { borderRadius: "{border.radius.sm}", padding: "1.5rem", shadow: "0 11px 15px -7px rgba(0,0,0,.2), 0 24px 38px 3px rgba(0,0,0,.14), 0 9px 46px 8px rgba(0,0,0,.12)" }, navigation: { shadow: "0 2px 4px -1px rgba(0,0,0,.2), 0 4px 5px 0 rgba(0,0,0,.14), 0 1px 10px 0 rgba(0,0,0,.12)" } }, colorScheme: { light: { focusRing: { shadow: "0 0 1px 4px {surface.200}" }, surface: { 0: "#ffffff", 50: "{slate.50}", 100: "{slate.100}", 200: "{slate.200}", 300: "{slate.300}", 400: "{slate.400}", 500: "{slate.500}", 600: "{slate.600}", 700: "{slate.700}", 800: "{slate.800}", 900: "{slate.900}", 950: "{slate.950}" }, primary: { color: "{primary.500}", contrastColor: "#ffffff", hoverColor: "{primary.400}", activeColor: "{primary.300}" }, highlight: { background: "color-mix(in srgb, {primary.color}, transparent 88%)", focusBackground: "color-mix(in srgb, {primary.color}, transparent 76%)", color: "{primary.700}", focusColor: "{primary.800}" }, mask: { background: "rgba(0,0,0,0.32)", color: "{surface.200}" }, formField: { background: "{surface.0}", disabledBackground: "{surface.300}", filledBackground: "{surface.100}", filledHoverBackground: "{surface.200}", filledFocusBackground: "{surface.100}", borderColor: "{surface.400}", hoverBorderColor: "{surface.900}", focusBorderColor: "{primary.color}", invalidBorderColor: "{red.800}", color: "{surface.900}", disabledColor: "{surface.600}", placeholderColor: "{surface.600}", invalidPlaceholderColor: "{red.800}", floatLabelColor: "{surface.600}", floatLabelFocusColor: "{primary.600}", floatLabelActiveColor: "{surface.600}", floatLabelInvalidColor: "{form.field.invalid.placeholder.color}", iconColor: "{surface.600}", shadow: "none" }, text: { color: "{surface.900}", hoverColor: "{surface.900}", mutedColor: "{surface.600}", hoverMutedColor: "{surface.600}" }, content: { background: "{surface.0}", hoverBackground: "{surface.100}", borderColor: "{surface.300}", color: "{text.color}", hoverColor: "{text.hover.color}" }, overlay: { select: { background: "{surface.0}", borderColor: "{surface.0}", color: "{text.color}" }, popover: { background: "{surface.0}", borderColor: "{surface.0}", color: "{text.color}" }, modal: { background: "{surface.0}", borderColor: "{surface.0}", color: "{text.color}" } }, list: { option: { focusBackground: "{surface.100}", selectedBackground: "{highlight.background}", selectedFocusBackground: "{highlight.focus.background}", color: "{text.color}", focusColor: "{text.hover.color}", selectedColor: "{highlight.color}", selectedFocusColor: "{highlight.focus.color}", icon: { color: "{surface.600}", focusColor: "{surface.600}" } }, optionGroup: { background: "transparent", color: "{text.color}" } }, navigation: { item: { focusBackground: "{surface.100}", activeBackground: "{surface.200}", color: "{text.color}", focusColor: "{text.hover.color}", activeColor: "{text.hover.color}", icon: { color: "{surface.600}", focusColor: "{surface.600}", activeColor: "{surface.600}" } }, submenuLabel: { background: "transparent", color: "{text.color}" }, submenuIcon: { color: "{surface.600}", focusColor: "{surface.600}", activeColor: "{surface.600}" } } }, dark: { focusRing: { shadow: "0 0 1px 4px {surface.700}" }, surface: { 0: "#ffffff", 50: "{zinc.50}", 100: "{zinc.100}", 200: "{zinc.200}", 300: "{zinc.300}", 400: "{zinc.400}", 500: "{zinc.500}", 600: "{zinc.600}", 700: "{zinc.700}", 800: "{zinc.800}", 900: "{zinc.900}", 950: "{zinc.950}" }, primary: { color: "{primary.400}", contrastColor: "{surface.900}", hoverColor: "{primary.300}", activeColor: "{primary.200}" }, highlight: { background: "color-mix(in srgb, {primary.400}, transparent 84%)", focusBackground: "color-mix(in srgb, {primary.400}, transparent 76%)", color: "rgba(255,255,255,.87)", focusColor: "rgba(255,255,255,.87)" }, mask: { background: "rgba(0,0,0,0.6)", color: "{surface.200}" }, formField: { background: "{surface.950}", disabledBackground: "{surface.700}", filledBackground: "{surface.800}", filledHoverBackground: "{surface.700}", filledFocusBackground: "{surface.800}", borderColor: "{surface.600}", hoverBorderColor: "{surface.400}", focusBorderColor: "{primary.color}", invalidBorderColor: "{red.300}", color: "{surface.0}", disabledColor: "{surface.400}", placeholderColor: "{surface.400}", invalidPlaceholderColor: "{red.300}", floatLabelColor: "{surface.400}", floatLabelFocusColor: "{primary.color}", floatLabelActiveColor: "{surface.400}", floatLabelInvalidColor: "{form.field.invalid.placeholder.color}", iconColor: "{surface.400}", shadow: "none" }, text: { color: "{surface.0}", hoverColor: "{surface.0}", mutedColor: "{surface.400}", hoverMutedColor: "{surface.400}" }, content: { background: "{surface.900}", hoverBackground: "{surface.800}", borderColor: "{surface.700}", color: "{text.color}", hoverColor: "{text.hover.color}" }, overlay: { select: { background: "{surface.900}", borderColor: "{surface.900}", color: "{text.color}" }, popover: { background: "{surface.900}", borderColor: "{surface.900}", color: "{text.color}" }, modal: { background: "{surface.900}", borderColor: "{surface.900}", color: "{text.color}" } }, list: { option: { focusBackground: "{surface.800}", selectedBackground: "{highlight.background}", selectedFocusBackground: "{highlight.focus.background}", color: "{text.color}", focusColor: "{text.hover.color}", selectedColor: "{highlight.color}", selectedFocusColor: "{highlight.focus.color}", icon: { color: "{surface.400}", focusColor: "{surface.400}" } }, optionGroup: { background: "transparent", color: "{text.muted.color}" } }, navigation: { item: { focusBackground: "{surface.800}", activeBackground: "{surface.700}", color: "{text.color}", focusColor: "{text.hover.color}", activeColor: "{text.hover.color}", icon: { color: "{surface.400}", focusColor: "{surface.400}", activeColor: "{surface.400}" } }, submenuLabel: { background: "transparent", color: "{text.muted.color}" }, submenuIcon: { color: "{surface.400}", focusColor: "{surface.400}", activeColor: "{surface.400}" } } } } }, cu = { primitive: du, semantic: uu }, pu = { borderRadius: "{content.border.radius}" }, mu = { root: pu, css: "" }, fu = { padding: "1rem", background: "{content.background}", gap: "0.5rem", transitionDuration: "{transition.duration}" }, gu = { color: "{text.muted.color}", hoverColor: "{text.color}", borderRadius: "{content.border.radius}", gap: "{navigation.item.gap}", icon: { color: "{navigation.item.icon.color}", hoverColor: "{navigation.item.icon.focus.color}" }, focusRing: { width: "{focus.ring.width}", style: "{focus.ring.style}", color: "{focus.ring.color}", offset: "{focus.ring.offset}", shadow: "{focus.ring.shadow}" } }, hu = { color: "{navigation.item.icon.color}" }, bu = { root: fu, item: gu, separator: hu, css: "" }, vu = { borderRadius: "{form.field.border.radius}", roundedBorderRadius: "2rem", gap: "0.5rem", paddingX: "1rem", paddingY: "0.625rem", iconOnlyWidth: "3rem", sm: { fontSize: "{form.field.sm.font.size}", paddingX: "{form.field.sm.padding.x}", paddingY: "{form.field.sm.padding.y}", iconOnlyWidth: "2.5rem" }, lg: { fontSize: "{form.field.lg.font.size}", paddingX: "{form.field.lg.padding.x}", paddingY: "{form.field.lg.padding.y}", iconOnlyWidth: "3.5rem" }, label: { fontWeight: "500" }, raisedShadow: "0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12)", focusRing: { width: "{focus.ring.width}", style: "{focus.ring.style}", offset: "{focus.ring.offset}" }, badgeSize: "1rem", transitionDuration: "{form.field.transition.duration}" }, yu = { light: { root: { primary: { background: "{primary.color}", hoverBackground: "{primary.hover.color}", activeBackground: "{primary.active.color}", borderColor: "{primary.color}", hoverBorderColor: "{primary.hover.color}", activeBorderColor: "{primary.active.color}", color: "{primary.contrast.color}", hoverColor: "{primary.contrast.color}", activeColor: "{primary.contrast.color}", focusRing: { color: "{primary.color}", shadow: "none" } }, secondary: { background: "{surface.100}", hoverBackground: "{surface.200}", activeBackground: "{surface.300}", borderColor: "{surface.100}", hoverBorderColor: "{surface.200}", activeBorderColor: "{surface.300}", color: "{surface.600}", hoverColor: "{surface.700}", activeColor: "{surface.800}", focusRing: { color: "{surface.600}", shadow: "none" } }, info: { background: "{sky.500}", hoverBackground: "{sky.400}", activeBackground: "{sky.300}", borderColor: "{sky.500}", hoverBorderColor: "{sky.400}", activeBorderColor: "{sky.300}", color: "#ffffff", hoverColor: "#ffffff", activeColor: "#ffffff", focusRing: { color: "{sky.500}", shadow: "none" } }, success: { background: "{green.500}", hoverBackground: "{green.400}", activeBackground: "{green.300}", borderColor: "{green.500}", hoverBorderColor: "{green.400}", activeBorderColor: "{green.300}", color: "#ffffff", hoverColor: "#ffffff", activeColor: "#ffffff", focusRing: { color: "{green.500}", shadow: "none" } }, warn: { background: "{orange.500}", hoverBackground: "{orange.400}", activeBackground: "{orange.300}", borderColor: "{orange.500}", hoverBorderColor: "{orange.400}", activeBorderColor: "{orange.300}", color: "#ffffff", hoverColor: "#ffffff", activeColor: "#ffffff", focusRing: { color: "{orange.500}", shadow: "none" } }, help: { background: "{purple.500}", hoverBackground: "{purple.400}", activeBackground: "{purple.300}", borderColor: "{purple.500}", hoverBorderColor: "{purple.400}", activeBorderColor: "{purple.300}", color: "#ffffff", hoverColor: "#ffffff", activeColor: "#ffffff", focusRing: { color: "{purple.500}", shadow: "none" } }, danger: { background: "{red.500}", hoverBackground: "{red.400}", activeBackground: "{red.300}", borderColor: "{red.500}", hoverBorderColor: "{red.400}", activeBorderColor: "{red.300}", color: "#ffffff", hoverColor: "#ffffff", activeColor: "#ffffff", focusRing: { color: "{red.500}", shadow: "none" } }, contrast: { background: "{surface.950}", hoverBackground: "{surface.800}", activeBackground: "{surface.700}", borderColor: "{surface.950}", hoverBorderColor: "{surface.800}", activeBorderColor: "{surface.700}", color: "{surface.0}", hoverColor: "{surface.0}", activeColor: "{surface.0}", focusRing: { color: "{surface.950}", shadow: "none" } } }, outlined: { primary: { hoverBackground: "{primary.50}", activeBackground: "{primary.100}", borderColor: "{primary.color}", color: "{primary.color}" }, secondary: { hoverBackground: "{surface.50}", activeBackground: "{surface.100}", borderColor: "{surface.600}", color: "{surface.600}" }, success: { hoverBackground: "{green.50}", activeBackground: "{green.100}", borderColor: "{green.500}", color: "{green.500}" }, info: { hoverBackground: "{sky.50}", activeBackground: "{sky.100}", borderColor: "{sky.500}", color: "{sky.500}" }, warn: { hoverBackground: "{orange.50}", activeBackground: "{orange.100}", borderColor: "{orange.500}", color: "{orange.500}" }, help: { hoverBackground: "{purple.50}", activeBackground: "{purple.100}", borderColor: "{purple.500}", color: "{purple.500}" }, danger: { hoverBackground: "{red.50}", activeBackground: "{red.100}", borderColor: "{red.500}", color: "{red.500}" }, contrast: { hoverBackground: "{surface.50}", activeBackground: "{surface.100}", borderColor: "{surface.950}", color: "{surface.950}" }, plain: { hoverBackground: "{surface.50}", activeBackground: "{surface.100}", borderColor: "{surface.900}", color: "{surface.900}" } }, text: { primary: { hoverBackground: "{primary.50}", activeBackground: "{primary.100}", color: "{primary.color}" }, secondary: { hoverBackground: "{surface.50}", activeBackground: "{surface.100}", color: "{surface.600}" }, success: { hoverBackground: "{green.50}", activeBackground: "{green.100}", color: "{green.500}" }, info: { hoverBackground: "{sky.50}", activeBackground: "{sky.100}", color: "{sky.500}" }, warn: { hoverBackground: "{orange.50}", activeBackground: "{orange.100}", color: "{orange.500}" }, help: { hoverBackground: "{purple.50}", activeBackground: "{purple.100}", color: "{purple.500}" }, danger: { hoverBackground: "{red.50}", activeBackground: "{red.100}", color: "{red.500}" }, contrast: { hoverBackground: "{surface.50}", activeBackground: "{surface.100}", color: "{surface.950}" }, plain: { hoverBackground: "{surface.50}", activeBackground: "{surface.100}", color: "{surface.900}" } }, link: { color: "{primary.color}", hoverColor: "{primary.color}", activeColor: "{primary.color}" } }, dark: { root: { primary: { background: "{primary.color}", hoverBackground: "{primary.hover.color}", activeBackground: "{primary.active.color}", borderColor: "{primary.color}", hoverBorderColor: "{primary.hover.color}", activeBorderColor: "{primary.active.color}", color: "{primary.contrast.color}", hoverColor: "{primary.contrast.color}", activeColor: "{primary.contrast.color}", focusRing: { color: "{primary.color}", shadow: "none" } }, secondary: { background: "{surface.800}", hoverBackground: "{surface.700}", activeBackground: "{surface.600}", borderColor: "{surface.800}", hoverBorderColor: "{surface.700}", activeBorderColor: "{surface.600}", color: "{surface.300}", hoverColor: "{surface.200}", activeColor: "{surface.100}", focusRing: { color: "{surface.300}", shadow: "none" } }, info: { background: "{sky.400}", hoverBackground: "{sky.300}", activeBackground: "{sky.200}", borderColor: "{sky.400}", hoverBorderColor: "{sky.300}", activeBorderColor: "{sky.200}", color: "{sky.950}", hoverColor: "{sky.950}", activeColor: "{sky.950}", focusRing: { color: "{sky.400}", shadow: "none" } }, success: { background: "{green.400}", hoverBackground: "{green.300}", activeBackground: "{green.200}", borderColor: "{green.400}", hoverBorderColor: "{green.300}", activeBorderColor: "{green.200}", color: "{green.950}", hoverColor: "{green.950}", activeColor: "{green.950}", focusRing: { color: "{green.400}", shadow: "none" } }, warn: { background: "{orange.400}", hoverBackground: "{orange.300}", activeBackground: "{orange.200}", borderColor: "{orange.400}", hoverBorderColor: "{orange.300}", activeBorderColor: "{orange.200}", color: "{orange.950}", hoverColor: "{orange.950}", activeColor: "{orange.950}", focusRing: { color: "{orange.400}", shadow: "none" } }, help: { background: "{purple.400}", hoverBackground: "{purple.300}", activeBackground: "{purple.200}", borderColor: "{purple.400}", hoverBorderColor: "{purple.300}", activeBorderColor: "{purple.200}", color: "{purple.950}", hoverColor: "{purple.950}", activeColor: "{purple.950}", focusRing: { color: "{purple.400}", shadow: "none" } }, danger: { background: "{red.400}", hoverBackground: "{red.300}", activeBackground: "{red.200}", borderColor: "{red.400}", hoverBorderColor: "{red.300}", activeBorderColor: "{red.200}", color: "{red.950}", hoverColor: "{red.950}", activeColor: "{red.950}", focusRing: { color: "{red.400}", shadow: "none" } }, contrast: { background: "{surface.0}", hoverBackground: "{surface.100}", activeBackground: "{surface.200}", borderColor: "{surface.0}", hoverBorderColor: "{surface.100}", activeBorderColor: "{surface.200}", color: "{surface.950}", hoverColor: "{surface.950}", activeColor: "{surface.950}", focusRing: { color: "{surface.0}", shadow: "none" } } }, outlined: { primary: { hoverBackground: "color-mix(in srgb, {primary.color}, transparent 96%)", activeBackground: "color-mix(in srgb, {primary.color}, transparent 84%)", borderColor: "{primary.700}", color: "{primary.color}" }, secondary: { hoverBackground: "rgba(255,255,255,0.04)", activeBackground: "rgba(255,255,255,0.16)", borderColor: "{surface.700}", color: "{surface.400}" }, success: { hoverBackground: "color-mix(in srgb, {green.400}, transparent 96%)", activeBackground: "color-mix(in srgb, {green.400}, transparent 84%)", borderColor: "{green.700}", color: "{green.400}" }, info: { hoverBackground: "color-mix(in srgb, {sky.400}, transparent 96%)", activeBackground: "color-mix(in srgb, {sky.400}, transparent 84%)", borderColor: "{sky.700}", color: "{sky.400}" }, warn: { hoverBackground: "color-mix(in srgb, {orange.400}, transparent 96%)", activeBackground: "color-mix(in srgb, {orange.400}, transparent 84%)", borderColor: "{orange.700}", color: "{orange.400}" }, help: { hoverBackground: "color-mix(in srgb, {purple.400}, transparent 96%)", activeBackground: "color-mix(in srgb, {purple.400}, transparent 84%)", borderColor: "{purple.700}", color: "{purple.400}" }, danger: { hoverBackground: "color-mix(in srgb, {red.400}, transparent 96%)", activeBackground: "color-mix(in srgb, {red.400}, transparent 84%)", borderColor: "{red.700}", color: "{red.400}" }, contrast: { hoverBackground: "{surface.800}", activeBackground: "{surface.700}", borderColor: "{surface.500}", color: "{surface.0}" }, plain: { hoverBackground: "{surface.800}", activeBackground: "{surface.700}", borderColor: "{surface.600}", color: "{surface.0}" } }, text: { primary: { hoverBackground: "color-mix(in srgb, {primary.color}, transparent 96%)", activeBackground: "color-mix(in srgb, {primary.color}, transparent 84%)", color: "{primary.color}" }, secondary: { hoverBackground: "{surface.800}", activeBackground: "{surface.700}", color: "{surface.400}" }, success: { hoverBackground: "color-mix(in srgb, {green.400}, transparent 96%)", activeBackground: "color-mix(in srgb, {green.400}, transparent 84%)", color: "{green.400}" }, info: { hoverBackground: "color-mix(in srgb, {sky.400}, transparent 96%)", activeBackground: "color-mix(in srgb, {sky.400}, transparent 84%)", color: "{sky.400}" }, warn: { hoverBackground: "color-mix(in srgb, {orange.400}, transparent 96%)", activeBackground: "color-mix(in srgb, {orange.400}, transparent 84%)", color: "{orange.400}" }, help: { hoverBackground: "color-mix(in srgb, {purple.400}, transparent 96%)", activeBackground: "color-mix(in srgb, {purple.400}, transparent 84%)", color: "{purple.400}" }, danger: { hoverBackground: "color-mix(in srgb, {red.400}, transparent 96%)", activeBackground: "color-mix(in srgb, {red.400}, transparent 84%)", color: "{red.400}" }, contrast: { hoverBackground: "{surface.800}", activeBackground: "{surface.700}", color: "{surface.0}" }, plain: { hoverBackground: "{surface.800}", activeBackground: "{surface.700}", color: "{surface.0}" } }, link: { color: "{primary.color}", hoverColor: "{primary.color}", activeColor: "{primary.color}" } } }, ku = `
.p-button:focus-visible {
    background: dt('button.primary.active.background');
    border-color: dt('button.primary.active.background');
}

.p-button-secondary:focus-visible {
    background: dt('button.secondary.active.background');
    border-color: dt('button.secondary.active.background');
}

.p-button-success:focus-visible {
    background: dt('button.success.active.background');
    border-color: dt('button.success.active.background');
}

.p-button-info:focus-visible {
    background: dt('button.info.active.background');
    border-color: dt('button.info.active.background');
}

.p-button-warn:focus-visible {
    background: dt('button.warn.active.background');
    border-color: dt('button.warn.active.background');
}

.p-button-help:focus-visible {
    background: dt('button.help.active.background');
    border-color: dt('button.help.active.background');
}

.p-button-danger:focus-visible {
    background: dt('button.danger.active.background');
    border-color: dt('button.danger.active.background');
}

.p-button-contrast:focus-visible {
    background: dt('button.contrast.active.background');
    border-color: dt('button.contrast.active.background');
}

.p-button-link:focus-visible {
    background: color-mix(in srgb, dt('primary.color'), transparent 84%);
    border-color: transparent;
}

.p-button-text:focus-visible {
    background: dt('button.text.primary.active.background');
    border-color: transparent;
}

.p-button-secondary.p-button-text:focus-visible {
    background: dt('button.text.secondary.active.background');
    border-color: transparent;
}

.p-button-success.p-button-text:focus-visible {
    background: dt('button.text.success.active.background');
    border-color: transparent;
}

.p-button-info.p-button-text:focus-visible {
    background: dt('button.text.info.active.background');
    border-color: transparent;
}

.p-button-warn.p-button-text:focus-visible {
    background: dt('button.text.warn.active.background');
    border-color: transparent;
}

.p-button-help.p-button-text:focus-visible {
    background: dt('button.text.help.active.background');
    border-color: transparent;
}

.p-button-danger.p-button-text:focus-visible {
    background: dt('button.text.danger.active.background');
    border-color: transparent;
}

.p-button-contrast.p-button-text:focus-visible {
    background: dt('button.text.contrast.active.background');
    border-color: transparent;
}

.p-button-plain.p-button-text:focus-visible {
    background: dt('button.text.plain.active.background');
    border-color: transparent;
}

.p-button-outlined:focus-visible {
    background: dt('button.outlined.primary.active.background');
}

.p-button-secondary.p-button-outlined:focus-visible {
    background: dt('button.outlined.secondary.active.background');
    border-color: dt('button.outlined.secondary.border.color');
}

.p-button-success.p-button-outlined:focus-visible {
    background: dt('button.outlined.success.active.background');
}

.p-button-info.p-button-outlined:focus-visible {
    background: dt('button.outlined.info.active.background');
}

.p-button-warn.p-button-outlined:focus-visible {
    background: dt('button.outlined.warn.active.background');
}

.p-button-help.p-button-outlined:focus-visible {
    background: dt('button.outlined.help.active.background');
}

.p-button-danger.p-button-outlined:focus-visible {
    background: dt('button.outlined.danger.active.background');
}

.p-button-contrast.p-button-outlined:focus-visible {
    background: dt('button.outlined.contrast.active.background');
}

.p-button-plain.p-button-outlined:focus-visible {
    background: dt('button.outlined.plain.active.background');
}
`, wu = { root: vu, colorScheme: yu, css: ku }, xu = { background: "{content.background}", borderRadius: "{content.border.radius}", color: "{content.color}", shadow: "0 2px 1px -1px rgba(0,0,0,.2), 0 1px 1px 0 rgba(0,0,0,.14), 0 1px 3px 0 rgba(0,0,0,.12)" }, Cu = { padding: "1.5rem", gap: "0.75rem" }, Su = { gap: "0.5rem" }, $u = { fontSize: "1.25rem", fontWeight: "500" }, Bu = { color: "{text.muted.color}" }, Tu = { root: xu, body: Cu, caption: Su, title: $u, subtitle: Bu, css: "" }, Iu = { transitionDuration: "{transition.duration}" }, Du = { gap: "0.25rem" }, Pu = { padding: "1rem", gap: "1rem" }, zu = { width: "1.25rem", height: "1.25rem", borderRadius: "50%", focusRing: { width: "0", style: "none", color: "unset", offset: "0", shadow: "none" } }, Lu = { light: { indicator: { background: "{surface.200}", hoverBackground: "{surface.300}", activeBackground: "{primary.color}" } }, dark: { indicator: { background: "{surface.700}", hoverBackground: "{surface.600}", activeBackground: "{primary.color}" } } }, Ou = `
.p-carousel-indicator-button:hover {
    box-shadow: 0 0 1px 10px color-mix(in srgb, dt('text.color'), transparent 96%);
}

.p-carousel-indicator-button:focus-visible {
    box-shadow: 0 0 1px 10px color-mix(in srgb, dt('text.color'), transparent 96%);
}

.p-carousel-indicator-active .p-carousel-indicator-button:hover {
    box-shadow: 0 0 1px 10px color-mix(in srgb, dt('carousel.indicator.active.background'), transparent 92%);
}

.p-carousel-indicator-active .p-carousel-indicator-button:focus-visible {
    box-shadow: 0 0 1px 10px color-mix(in srgb, dt('carousel.indicator.active.background'), transparent 84%);
}
`, Mu = { root: Iu, content: Du, indicatorList: Pu, indicator: zu, colorScheme: Lu, css: Ou }, Au = { background: "{form.field.background}", disabledBackground: "{form.field.disabled.background}", filledBackground: "{form.field.filled.background}", filledHoverBackground: "{form.field.filled.hover.background}", filledFocusBackground: "{form.field.filled.focus.background}", borderColor: "{form.field.border.color}", hoverBorderColor: "{form.field.hover.border.color}", focusBorderColor: "{form.field.focus.border.color}", invalidBorderColor: "{form.field.invalid.border.color}", color: "{form.field.color}", disabledColor: "{form.field.disabled.color}", placeholderColor: "{form.field.placeholder.color}", invalidPlaceholderColor: "{form.field.invalid.placeholder.color}", shadow: "{form.field.shadow}", paddingX: "{form.field.padding.x}", paddingY: "{form.field.padding.y}", borderRadius: "{form.field.border.radius}", focusRing: { width: "{form.field.focus.ring.width}", style: "{form.field.focus.ring.style}", color: "{form.field.focus.ring.color}", offset: "{form.field.focus.ring.offset}", shadow: "{form.field.focus.ring.shadow}" }, transitionDuration: "{form.field.transition.duration}", sm: { fontSize: "{form.field.sm.font.size}", paddingX: "{form.field.sm.padding.x}", paddingY: "{form.field.sm.padding.y}" }, lg: { fontSize: "{form.field.lg.font.size}", paddingX: "{form.field.lg.padding.x}", paddingY: "{form.field.lg.padding.y}" } }, _u = { width: "2.5rem", color: "{form.field.icon.color}" }, Fu = { background: "{overlay.select.background}", borderColor: "{overlay.select.border.color}", borderRadius: "{overlay.select.border.radius}", color: "{overlay.select.color}", shadow: "{overlay.select.shadow}" }, Eu = { padding: "{list.padding}", gap: "{list.gap}", mobileIndent: "1rem" }, Ru = { focusBackground: "{list.option.focus.background}", selectedBackground: "{list.option.selected.background}", selectedFocusBackground: "{list.option.selected.focus.background}", color: "{list.option.color}", focusColor: "{list.option.focus.color}", selectedColor: "{list.option.selected.color}", selectedFocusColor: "{list.option.selected.focus.color}", padding: "{list.option.padding}", borderRadius: "{list.option.border.radius}", icon: { color: "{list.option.icon.color}", focusColor: "{list.option.icon.focus.color}", size: "0.875rem" } }, Vu = { color: "{form.field.icon.color}" }, Nu = `
.p-cascadeselect.p-variant-filled {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    border: 1px solid transparent;
    background: dt('cascadeselect.filled.background') no-repeat;
    background-image: linear-gradient(to bottom, dt('cascadeselect.focus.border.color'), dt('cascadeselect.focus.border.color')), linear-gradient(to bottom, dt('cascadeselect.border.color'), dt('cascadeselect.border.color'));
    background-size: 0 2px, 100% 1px;
    background-position: 50% 100%, 50% 100%;
    background-origin: border-box;
    transition: background-size 0.3s cubic-bezier(0.64, 0.09, 0.08, 1);
}

.p-cascadeselect.p-variant-filled:not(.p-disabled):hover {
    background: dt('cascadeselect.filled.hover.background') no-repeat;
    background-image: linear-gradient(to bottom, dt('cascadeselect.focus.border.color'), dt('cascadeselect.focus.border.color')), linear-gradient(to bottom, dt('cascadeselect.hover.border.color'), dt('cascadeselect.hover.border.color'));
    background-size: 0 2px, 100% 1px;
    background-position: 50% 100%, 50% 100%;
    background-origin: border-box;
    border-color: transparent;
}

.p-cascadeselect.p-variant-filled:not(.p-disabled).p-focus {
    outline: 0 none;
    background: dt('cascadeselect.filled.focus.background') no-repeat;
    background-image: linear-gradient(to bottom, dt('cascadeselect.focus.border.color'), dt('cascadeselect.focus.border.color')), linear-gradient(to bottom, dt('cascadeselect.border.color'), dt('cascadeselect.border.color'));
    background-size: 100% 2px, 100% 1px;
    background-position: 50% 100%, 50% 100%;
    background-origin: border-box;
    border-color: transparent;
}

.p-cascadeselect.p-variant-filled:not(.p-disabled).p-focus:hover {
    background-image: linear-gradient(to bottom, dt('cascadeselect.focus.border.color'), dt('cascadeselect.focus.border.color')), linear-gradient(to bottom, dt('cascadeselect.hover.border.color'), dt('cascadeselect.hover.border.color'));
}

.p-cascadeselect.p-variant-filled.p-invalid {
    background-image: linear-gradient(to bottom, dt('cascadeselect.invalid.border.color'), dt('cascadeselect.invalid.border.color')), linear-gradient(to bottom, dt('cascadeselect.invalid.border.color'), dt('cascadeselect.invalid.border.color'));
}

.p-cascadeselect.p-variant-filled.p-invalid:not(.p-disabled).p-focus  {
    background-image: linear-gradient(to bottom, dt('cascadeselect.invalid.border.color'), dt('cascadeselect.invalid.border.color')), linear-gradient(to bottom, dt('cascadeselect.invalid.border.color'), dt('cascadeselect.invalid.border.color'));
}

.p-cascadeselect-option {
    transition: none;
}
`, ju = { root: Au, dropdown: _u, overlay: Fu, list: Eu, option: Ru, clearIcon: Vu, css: Nu }, Uu = { borderRadius: "{border.radius.xs}", width: "18px", height: "18px", background: "{form.field.background}", checkedBackground: "{primary.color}", checkedHoverBackground: "{primary.color}", disabledBackground: "{form.field.disabled.background}", filledBackground: "{form.field.filled.background}", borderColor: "{form.field.border.color}", hoverBorderColor: "{form.field.hover.border.color}", focusBorderColor: "{form.field.focus.border.color}", checkedBorderColor: "{primary.color}", checkedHoverBorderColor: "{primary.color}", checkedFocusBorderColor: "{primary.color}", checkedDisabledBorderColor: "{form.field.border.color}", invalidBorderColor: "{form.field.invalid.border.color}", shadow: "{form.field.shadow}", focusRing: { width: "0", style: "none", color: "unset", offset: "0", shadow: "none" }, transitionDuration: "{form.field.transition.duration}", sm: { width: "14px", height: "14px" }, lg: { width: "22px", height: "22px" } }, Hu = { size: "0.875rem", color: "{form.field.color}", checkedColor: "{primary.contrast.color}", checkedHoverColor: "{primary.contrast.color}", disabledColor: "{form.field.disabled.color}", sm: { size: "0.75rem" }, lg: { size: "1rem" } }, Ku = `
.p-checkbox {
    border-radius: 50%;
    transition: box-shadow dt('checkbox.transition.duration');
}

.p-checkbox-box {
    border-width: 2px;
}

.p-checkbox:not(.p-disabled):has(.p-checkbox-input:hover) {
    box-shadow: 0 0 1px 10px color-mix(in srgb, dt('text.color'), transparent 96%);
}

.p-checkbox:not(.p-disabled):has(.p-checkbox-input:focus-visible) {
    box-shadow: 0 0 1px 10px color-mix(in srgb, dt('text.color'), transparent 88%);
}

.p-checkbox-checked:not(.p-disabled):has(.p-checkbox-input:hover) {
    box-shadow: 0 0 1px 10px color-mix(in srgb, dt('checkbox.checked.background'), transparent 92%);
}

.p-checkbox-checked:not(.p-disabled):has(.p-checkbox-input:focus-visible) {
    box-shadow: 0 0 1px 10px color-mix(in srgb, dt('checkbox.checked.background'), transparent 84%);
}

.p-checkbox-checked .p-checkbox-box:before  {
    content: "";
    position: absolute;
    top: var(--p-md-check-icon-t);
    left: 2px;
    border-right: 2px solid transparent;
    border-bottom: 2px solid transparent;
    transform: rotate(45deg);
    transform-origin: 0% 100%;
    animation: p-md-check 125ms 50ms linear forwards;
}

.p-checkbox-checked .p-checkbox-icon {
    display: none;
}

.p-checkbox {
    --p-md-check-icon-t: 10px;
    --p-md-check-icon-w: 6px;
    --p-md-check-icon-h: 12px;
}

.p-checkbox-sm {
    --p-md-check-icon-t: 8px;
    --p-md-check-icon-w: 4px;
    --p-md-check-icon-h: 10px;
}

.p-checkbox-lg {
    --p-md-check-icon-t: 12px;
    --p-md-check-icon-w: 8px;
    --p-md-check-icon-h: 16px;
}

@keyframes p-md-check {
    0%{
      width: 0;
      height: 0;
      border-color: dt('checkbox.icon.checked.color');
      transform: translate3d(0,0,0) rotate(45deg);
    }
    33%{
      width: var(--p-md-check-icon-w);
      height: 0;
      transform: translate3d(0,0,0) rotate(45deg);
    }
    100%{
      width: var(--p-md-check-icon-w);
      height: var(--p-md-check-icon-h);
      border-color: dt('checkbox.icon.checked.color');
      transform: translate3d(0,calc(-1 * var(--p-md-check-icon-h)),0) rotate(45deg);
    }
}
`, Wu = { root: Uu, icon: Hu, css: Ku }, Yu = { borderRadius: "2rem", paddingX: "0.75rem", paddingY: "0.75rem", gap: "0.5rem", transitionDuration: "{transition.duration}" }, Gu = { width: "2.25rem", height: "2.25rem" }, qu = { size: "1rem" }, Zu = { size: "1rem", focusRing: { width: "{focus.ring.width}", style: "{focus.ring.style}", color: "{focus.ring.color}", offset: "{focus.ring.offset}" } }, Xu = { light: { root: { background: "{surface.200}", color: "{surface.900}" }, icon: { color: "{surface.600}" }, removeIcon: { color: "{surface.600}", focusRing: { shadow: "0 0 1px 4px {surface.300}" } } }, dark: { root: { background: "{surface.700}", color: "{surface.0}" }, icon: { color: "{surface.0}" }, removeIcon: { color: "{surface.0}", focusRing: { shadow: "0 0 1px 4px {surface.600}" } } } }, Ju = { root: Yu, image: Gu, icon: qu, removeIcon: Zu, colorScheme: Xu, css: "" }, Qu = { transitionDuration: "{transition.duration}" }, ec = { width: "2rem", height: "2rem", borderRadius: "{form.field.border.radius}", focusRing: { width: "{focus.ring.width}", style: "{focus.ring.style}", color: "{focus.ring.color}", offset: "{focus.ring.offset}", shadow: "{focus.ring.shadow}" } }, tc = { shadow: "{overlay.popover.shadow}", borderRadius: "{overlay.popover.borderRadius}" }, nc = { light: { panel: { background: "{surface.800}", borderColor: "{surface.900}" }, handle: { color: "{surface.0}" } }, dark: { panel: { background: "{surface.900}", borderColor: "{surface.700}" }, handle: { color: "{surface.0}" } } }, oc = { root: Qu, preview: ec, panel: tc, colorScheme: nc, css: "" }, rc = { size: "2rem", color: "{overlay.modal.color}" }, ic = { gap: "1rem" }, ac = { icon: rc, content: ic, css: "" }, lc = { background: "{overlay.popover.background}", borderColor: "{overlay.popover.border.color}", color: "{overlay.popover.color}", borderRadius: "{overlay.popover.border.radius}", shadow: "{overlay.popover.shadow}", gutter: "10px", arrowOffset: "1.25rem" }, sc = { padding: "{overlay.popover.padding}", gap: "1rem" }, dc = { size: "1.5rem", color: "{overlay.popover.color}" }, uc = { gap: "0.5rem", padding: "0 {overlay.popover.padding} {overlay.popover.padding} {overlay.popover.padding}" }, cc = { root: lc, content: sc, icon: dc, footer: uc, css: "" }, pc = { background: "{content.background}", borderColor: "transparent", color: "{content.color}", borderRadius: "{content.border.radius}", shadow: "{overlay.navigation.shadow}", transitionDuration: "{transition.duration}" }, mc = { padding: "{navigation.list.padding}", gap: "{navigation.list.gap}" }, fc = { focusBackground: "{navigation.item.focus.background}", activeBackground: "{navigation.item.active.background}", color: "{navigation.item.color}", focusColor: "{navigation.item.focus.color}", activeColor: "{navigation.item.active.color}", padding: "{navigation.item.padding}", borderRadius: "{navigation.item.border.radius}", gap: "{navigation.item.gap}", icon: { color: "{navigation.item.icon.color}", focusColor: "{navigation.item.icon.focus.color}", activeColor: "{navigation.item.icon.active.color}" } }, gc = { mobileIndent: "1rem" }, hc = { size: "{navigation.submenu.icon.size}", color: "{navigation.submenu.icon.color}", focusColor: "{navigation.submenu.icon.focus.color}", activeColor: "{navigation.submenu.icon.active.color}" }, bc = { borderColor: "{content.border.color}" }, vc = { root: pc, list: mc, item: fc, submenu: gc, submenuIcon: hc, separator: bc, css: "" }, yc = { transitionDuration: "{transition.duration}" }, kc = { background: "{content.background}", borderColor: "{datatable.border.color}", color: "{content.color}", borderWidth: "0 0 1px 0", padding: "0.75rem 1rem", sm: { padding: "0.375rem 0.5rem" }, lg: { padding: "1rem 1.25rem" } }, wc = { background: "{content.background}", hoverBackground: "{content.hover.background}", selectedBackground: "{highlight.background}", borderColor: "{datatable.border.color}", color: "{content.color}", hoverColor: "{content.hover.color}", selectedColor: "{highlight.color}", gap: "0.5rem", padding: "0.75rem 1rem", focusRing: { width: "{focus.ring.width}", style: "{focus.ring.style}", color: "{focus.ring.color}", offset: "-1px", shadow: "{focus.ring.shadow}" }, sm: { padding: "0.375rem 0.5rem" }, lg: { padding: "1rem 1.25rem" } }, xc = { fontWeight: "600" }, Cc = { background: "{content.background}", hoverBackground: "{content.hover.background}", selectedBackground: "{highlight.background}", color: "{content.color}", hoverColor: "{content.hover.color}", selectedColor: "{highlight.color}", focusRing: { width: "{focus.ring.width}", style: "{focus.ring.style}", color: "{focus.ring.color}", offset: "-1px", shadow: "{focus.ring.shadow}" } }, Sc = { borderColor: "{datatable.border.color}", padding: "0.75rem 1rem", sm: { padding: "0.375rem 0.5rem" }, lg: { padding: "1rem 1.25rem" } }, $c = { background: "{content.background}", borderColor: "{datatable.border.color}", color: "{content.color}", padding: "0.75rem 1rem", sm: { padding: "0.375rem 0.5rem" }, lg: { padding: "1rem 1.25rem" } }, Bc = { fontWeight: "600" }, Tc = { background: "{content.background}", borderColor: "{datatable.border.color}", color: "{content.color}", borderWidth: "0 0 1px 0", padding: "0.75rem 1rem", sm: { padding: "0.375rem 0.5rem" }, lg: { padding: "1rem 1.25rem" } }, Ic = { color: "{primary.color}" }, Dc = { width: "0.5rem" }, Pc = { width: "1px", color: "{primary.color}" }, zc = { color: "{text.muted.color}", hoverColor: "{text.hover.muted.color}", size: "0.875rem" }, Lc = { size: "2rem" }, Oc = { hoverBackground: "{content.hover.background}", selectedHoverBackground: "{content.background}", color: "{text.muted.color}", hoverColor: "{text.color}", selectedHoverColor: "{primary.color}", size: "1.75rem", borderRadius: "50%", focusRing: { width: "{focus.ring.width}", style: "{focus.ring.style}", color: "{focus.ring.color}", offset: "{focus.ring.offset}", shadow: "{focus.ring.shadow}" } }, Mc = { inlineGap: "0.5rem", overlaySelect: { background: "{overlay.select.background}", borderColor: "{overlay.select.border.color}", borderRadius: "{overlay.select.border.radius}", color: "{overlay.select.color}", shadow: "{overlay.select.shadow}" }, overlayPopover: { background: "{overlay.popover.background}", borderColor: "{overlay.popover.border.color}", borderRadius: "{overlay.popover.border.radius}", color: "{overlay.popover.color}", shadow: "{overlay.popover.shadow}", padding: "{overlay.popover.padding}", gap: "0.5rem" }, rule: { borderColor: "{content.border.color}" }, constraintList: { padding: "{list.padding}", gap: "{list.gap}" }, constraint: { focusBackground: "{list.option.focus.background}", selectedBackground: "{list.option.selected.background}", selectedFocusBackground: "{list.option.selected.focus.background}", color: "{list.option.color}", focusColor: "{list.option.focus.color}", selectedColor: "{list.option.selected.color}", selectedFocusColor: "{list.option.selected.focus.color}", separator: { borderColor: "{content.border.color}" }, padding: "{list.option.padding}", borderRadius: "{list.option.border.radius}" } }, Ac = { borderColor: "{datatable.border.color}", borderWidth: "0 0 1px 0" }, _c = { borderColor: "{datatable.border.color}", borderWidth: "0 0 1px 0" }, Fc = { light: { root: { borderColor: "{content.border.color}" }, row: { stripedBackground: "{surface.50}" }, bodyCell: { selectedBorderColor: "{primary.100}" } }, dark: { root: { borderColor: "{surface.800}" }, row: { stripedBackground: "{surface.950}" }, bodyCell: { selectedBorderColor: "{primary.900}" } } }, Ec = `
.p-datatable-header-cell,
.p-datatable-tbody > tr {
    transition: none;
}
`, Rc = { root: yc, header: kc, headerCell: wc, columnTitle: xc, row: Cc, bodyCell: Sc, footerCell: $c, columnFooter: Bc, footer: Tc, dropPoint: Ic, columnResizer: Dc, resizeIndicator: Pc, sortIcon: zc, loadingIcon: Lc, rowToggleButton: Oc, filter: Mc, paginatorTop: Ac, paginatorBottom: _c, colorScheme: Fc, css: Ec }, Vc = { borderColor: "transparent", borderWidth: "0", borderRadius: "0", padding: "0" }, Nc = { background: "{content.background}", color: "{content.color}", borderColor: "{content.border.color}", borderWidth: "0 0 1px 0", padding: "0.75rem 1rem", borderRadius: "0" }, jc = { background: "{content.background}", color: "{content.color}", borderColor: "transparent", borderWidth: "0", padding: "0", borderRadius: "0" }, Uc = { background: "{content.background}", color: "{content.color}", borderColor: "{content.border.color}", borderWidth: "1px 0 0 0", padding: "0.75rem 1rem", borderRadius: "0" }, Hc = { borderColor: "{content.border.color}", borderWidth: "0 0 1px 0" }, Kc = { borderColor: "{content.border.color}", borderWidth: "1px 0 0 0" }, Wc = { root: Vc, header: Nc, content: jc, footer: Uc, paginatorTop: Hc, paginatorBottom: Kc, css: "" }, Yc = { transitionDuration: "{transition.duration}" }, Gc = { background: "{content.background}", borderColor: "{content.border.color}", color: "{content.color}", borderRadius: "{content.border.radius}", shadow: "{overlay.popover.shadow}", padding: "0.5rem" }, qc = { background: "{content.background}", borderColor: "{content.border.color}", color: "{content.color}", padding: "0 0 0.5rem 0" }, Zc = { gap: "0.5rem", fontWeight: "700" }, Xc = { width: "3rem", sm: { width: "2.5rem" }, lg: { width: "3.5rem" }, borderColor: "{form.field.border.color}", hoverBorderColor: "{form.field.border.color}", activeBorderColor: "{form.field.border.color}", borderRadius: "{form.field.border.radius}", focusRing: { width: "0", style: "none", color: "unset", offset: "0", shadow: "none" } }, Jc = { color: "{form.field.icon.color}" }, Qc = { hoverBackground: "{content.hover.background}", color: "{content.color}", hoverColor: "{content.hover.color}", padding: "0.5rem 0.75rem", borderRadius: "{content.border.radius}" }, ep = { hoverBackground: "{content.hover.background}", color: "{content.color}", hoverColor: "{content.hover.color}", padding: "0.5rem 0.75rem", borderRadius: "{content.border.radius}" }, tp = { borderColor: "{content.border.color}", gap: "{overlay.popover.padding}" }, np = { margin: "0.5rem 0 0 0" }, op = { padding: "0.5rem", fontWeight: "700", color: "{content.color}" }, rp = { hoverBackground: "{content.hover.background}", selectedBackground: "{primary.color}", rangeSelectedBackground: "{highlight.background}", color: "{content.color}", hoverColor: "{content.hover.color}", selectedColor: "{primary.contrast.color}", rangeSelectedColor: "{highlight.color}", width: "2.5rem", height: "2.5rem", borderRadius: "50%", padding: "0.125rem", focusRing: { width: "{focus.ring.width}", style: "{focus.ring.style}", color: "{focus.ring.color}", offset: "{focus.ring.offset}", shadow: "{focus.ring.shadow}" } }, ip = { margin: "0.5rem 0 0 0" }, ap = { padding: "0.625rem", borderRadius: "{content.border.radius}" }, lp = { margin: "0.5rem 0 0 0" }, sp = { padding: "0.625rem", borderRadius: "{content.border.radius}" }, dp = { padding: "0.5rem 0 0 0", borderColor: "{content.border.color}" }, up = { padding: "0.5rem 0 0 0", borderColor: "{content.border.color}", gap: "0.5rem", buttonGap: "0.25rem" }, cp = { light: { dropdown: { background: "{surface.100}", hoverBackground: "{surface.200}", activeBackground: "{surface.300}", color: "{surface.600}", hoverColor: "{surface.700}", activeColor: "{surface.800}" }, today: { background: "{surface.200}", color: "{surface.900}" } }, dark: { dropdown: { background: "{surface.800}", hoverBackground: "{surface.700}", activeBackground: "{surface.600}", color: "{surface.300}", hoverColor: "{surface.200}", activeColor: "{surface.100}" }, today: { background: "{surface.700}", color: "{surface.0}" } } }, pp = `
.p-datepicker-header {
    justify-content: start;
}

.p-datepicker-title {
    order: 1;
}

.p-datepicker-prev-button {
    order: 2;
    margin-inline-start: auto;
}

.p-datepicker-next-button {
    order: 2;
    margin-inline-start: 0.5rem;
}

.p-datepicker-select-month:focus-visible {
    background: dt('datepicker.select.month.hover.background');
    color: dt('datepicker.select.month.hover.color');
    outline: 0 none;
}

.p-datepicker-select-year:focus-visible {
    background: dt('datepicker.select.year.hover.background');
    color: dt('datepicker.select.year.hover.color');
    outline: 0 none;
}

.p-datepicker-dropdown:focus-visible {
    outline: 0 none;
    background: dt('datepicker.dropdown.hover.background');
    border-color: dt('datepicker.dropdown.hover.border.color');
    color: dt('datepicker.dropdown.hover.color');
}
`, mp = { root: Yc, panel: Gc, header: qc, title: Zc, dropdown: Xc, inputIcon: Jc, selectMonth: Qc, selectYear: ep, group: tp, dayView: np, weekDay: op, date: rp, monthView: ip, month: ap, yearView: lp, year: sp, buttonbar: dp, timePicker: up, colorScheme: cp, css: pp }, fp = { background: "{overlay.modal.background}", borderColor: "{overlay.modal.border.color}", color: "{overlay.modal.color}", borderRadius: "{overlay.modal.border.radius}", shadow: "{overlay.modal.shadow}" }, gp = { padding: "{overlay.modal.padding}", gap: "0.5rem" }, hp = { fontSize: "1.25rem", fontWeight: "600" }, bp = { padding: "0 {overlay.modal.padding} {overlay.modal.padding} {overlay.modal.padding}" }, vp = { padding: "0 {overlay.modal.padding} {overlay.modal.padding} {overlay.modal.padding}", gap: "0.5rem" }, yp = { root: fp, header: gp, title: hp, content: bp, footer: vp, css: "" }, kp = { borderColor: "{content.border.color}" }, wp = { background: "{content.background}", color: "{text.color}" }, xp = { margin: "1rem 0", padding: "0 1rem", content: { padding: "0 0.5rem" } }, Cp = { margin: "0 1rem", padding: "0.5rem 0", content: { padding: "0.5rem 0" } }, Sp = { root: kp, content: wp, horizontal: xp, vertical: Cp, css: "" }, $p = { background: "rgba(255, 255, 255, 0.1)", borderColor: "rgba(255, 255, 255, 0.2)", padding: "0.5rem", borderRadius: "{border.radius.xl}" }, Bp = { borderRadius: "{content.border.radius}", padding: "0.5rem", size: "3rem", focusRing: { width: "{focus.ring.width}", style: "{focus.ring.style}", color: "{focus.ring.color}", offset: "{focus.ring.offset}", shadow: "{focus.ring.shadow}" } }, Tp = { root: $p, item: Bp, css: "" }, Ip = { background: "{overlay.modal.background}", borderColor: "{overlay.modal.border.color}", color: "{overlay.modal.color}", shadow: "{overlay.modal.shadow}" }, Dp = { padding: "{overlay.modal.padding}" }, Pp = { fontSize: "1.5rem", fontWeight: "600" }, zp = { padding: "0 {overlay.modal.padding} {overlay.modal.padding} {overlay.modal.padding}" }, Lp = { padding: "{overlay.modal.padding}" }, Op = { root: Ip, header: Dp, title: Pp, content: zp, footer: Lp, css: "" }, Mp = { background: "{content.background}", borderColor: "{content.border.color}", borderRadius: "{content.border.radius}" }, Ap = { color: "{text.muted.color}", hoverColor: "{text.color}", activeColor: "{primary.color}" }, _p = { background: "{overlay.select.background}", borderColor: "{overlay.select.border.color}", borderRadius: "{overlay.select.border.radius}", color: "{overlay.select.color}", shadow: "{overlay.select.shadow}", padding: "{list.padding}" }, Fp = { focusBackground: "{list.option.focus.background}", color: "{list.option.color}", focusColor: "{list.option.focus.color}", padding: "{list.option.padding}", borderRadius: "{list.option.border.radius}" }, Ep = { background: "{content.background}", borderColor: "{content.border.color}", color: "{content.color}", borderRadius: "{content.border.radius}" }, Rp = `
.p-editor .p-editor-toolbar {
    padding: 0.75rem
}
`, Vp = { toolbar: Mp, toolbarItem: Ap, overlay: _p, overlayOption: Fp, content: Ep, css: Rp }, Np = { background: "{content.background}", borderColor: "{content.border.color}", borderRadius: "{content.border.radius}", color: "{content.color}", padding: "0 1.25rem 1.25rem 1.25rem", transitionDuration: "{transition.duration}" }, jp = { background: "{content.background}", hoverBackground: "{content.hover.background}", color: "{content.color}", hoverColor: "{content.hover.color}", borderRadius: "{content.border.radius}", borderWidth: "1px", borderColor: "transparent", padding: "0.75rem 1rem", gap: "0.5rem", fontWeight: "600", focusRing: { width: "0", style: "none", color: "unset", offset: "0", shadow: "none" } }, Up = { color: "{text.muted.color}", hoverColor: "{text.hover.muted.color}" }, Hp = { padding: "0" }, Kp = `
.p-fieldset-toggle-button:focus-visible {
    background: dt('navigation.item.active.background');
}
`, Wp = { root: Np, legend: jp, toggleIcon: Up, content: Hp, css: Kp }, Yp = { background: "{content.background}", borderColor: "{content.border.color}", color: "{content.color}", borderRadius: "{content.border.radius}", transitionDuration: "{transition.duration}" }, Gp = { background: "transparent", color: "{text.color}", padding: "1.25rem", borderColor: "unset", borderWidth: "0", borderRadius: "0", gap: "0.5rem" }, qp = { highlightBorderColor: "{primary.color}", padding: "0 1.25rem 1.25rem 1.25rem", gap: "1rem" }, Zp = { padding: "1rem", gap: "1rem", borderColor: "{content.border.color}", info: { gap: "0.5rem" } }, Xp = { gap: "0.5rem" }, Jp = { height: "0.25rem" }, Qp = { gap: "0.5rem" }, em = { root: Yp, header: Gp, content: qp, file: Zp, fileList: Xp, progressbar: Jp, basic: Qp, css: "" }, tm = { color: "{form.field.float.label.color}", focusColor: "{form.field.float.label.focus.color}", activeColor: "{form.field.float.label.active.color}", invalidColor: "{form.field.float.label.invalid.color}", transitionDuration: "0.2s", positionX: "{form.field.padding.x}", positionY: "{form.field.padding.y}", fontWeight: "500", active: { fontSize: "0.75rem", fontWeight: "400" } }, nm = { active: { top: "-1.25rem" } }, om = { input: { paddingTop: "1.5rem", paddingBottom: "0.5rem" }, active: { top: "0.5rem" } }, rm = { borderRadius: "{border.radius.xs}", active: { background: "{form.field.background}", padding: "0 0.125rem" } }, im = { root: tm, over: nm, in: om, on: rm, css: "" }, am = { borderWidth: "1px", borderColor: "{content.border.color}", borderRadius: "{content.border.radius}", transitionDuration: "{transition.duration}" }, lm = { background: "rgba(255, 255, 255, 0.1)", hoverBackground: "rgba(255, 255, 255, 0.2)", color: "{surface.100}", hoverColor: "{surface.0}", size: "3rem", gutter: "0.5rem", prev: { borderRadius: "50%" }, next: { borderRadius: "50%" }, focusRing: { width: "{focus.ring.width}", style: "{focus.ring.style}", color: "{focus.ring.color}", offset: "{focus.ring.offset}", shadow: "{focus.ring.shadow}" } }, sm = { size: "1.5rem" }, dm = { background: "{content.background}", padding: "1rem 0.25rem" }, um = { size: "2rem", borderRadius: "50%", gutter: "0.5rem", focusRing: { width: "{focus.ring.width}", style: "{focus.ring.style}", color: "{focus.ring.color}", offset: "{focus.ring.offset}", shadow: "{focus.ring.shadow}" } }, cm = { size: "1rem" }, pm = { background: "rgba(0, 0, 0, 0.5)", color: "{surface.100}", padding: "1rem" }, mm = { gap: "0.5rem", padding: "1rem" }, fm = { width: "1rem", height: "1rem", activeBackground: "{primary.color}", borderRadius: "50%", focusRing: { width: "{focus.ring.width}", style: "{focus.ring.style}", color: "{focus.ring.color}", offset: "{focus.ring.offset}", shadow: "{focus.ring.shadow}" } }, gm = { background: "rgba(0, 0, 0, 0.5)" }, hm = { background: "rgba(255, 255, 255, 0.4)", hoverBackground: "rgba(255, 255, 255, 0.6)", activeBackground: "rgba(255, 255, 255, 0.9)" }, bm = { size: "3rem", gutter: "0.5rem", background: "rgba(255, 255, 255, 0.1)", hoverBackground: "rgba(255, 255, 255, 0.2)", color: "{surface.50}", hoverColor: "{surface.0}", borderRadius: "50%", focusRing: { width: "{focus.ring.width}", style: "{focus.ring.style}", color: "{focus.ring.color}", offset: "{focus.ring.offset}", shadow: "{focus.ring.shadow}" } }, vm = { size: "1.5rem" }, ym = { light: { thumbnailNavButton: { hoverBackground: "{surface.100}", color: "{surface.600}", hoverColor: "{surface.700}" }, indicatorButton: { background: "{surface.200}", hoverBackground: "{surface.300}" } }, dark: { thumbnailNavButton: { hoverBackground: "{surface.700}", color: "{surface.400}", hoverColor: "{surface.0}" }, indicatorButton: { background: "{surface.700}", hoverBackground: "{surface.600}" } } }, km = { root: am, navButton: lm, navIcon: sm, thumbnailsContent: dm, thumbnailNavButton: um, thumbnailNavButtonIcon: cm, caption: pm, indicatorList: mm, indicatorButton: fm, insetIndicatorList: gm, insetIndicatorButton: hm, closeButton: bm, closeButtonIcon: vm, colorScheme: ym, css: "" }, wm = { color: "{form.field.icon.color}" }, xm = { icon: wm, css: "" }, Cm = { color: "{form.field.float.label.color}", focusColor: "{form.field.float.label.focus.color}", invalidColor: "{form.field.float.label.invalid.color}", transitionDuration: "0.2s", positionX: "{form.field.padding.x}", top: "0.5rem", fontSize: "0.75rem", fontWeight: "400" }, Sm = { paddingTop: "1.5rem", paddingBottom: "0.5rem" }, $m = { root: Cm, input: Sm, css: "" }, Bm = { transitionDuration: "{transition.duration}" }, Tm = { icon: { size: "1.5rem" }, mask: { background: "{mask.background}", color: "{mask.color}" } }, Im = { position: { left: "auto", right: "1rem", top: "1rem", bottom: "auto" }, blur: "8px", background: "rgba(255,255,255,0.1)", borderColor: "rgba(255,255,255,0.2)", borderWidth: "1px", borderRadius: "30px", padding: ".5rem", gap: "0.5rem" }, Dm = { hoverBackground: "rgba(255,255,255,0.1)", color: "{surface.50}", hoverColor: "{surface.0}", size: "3rem", iconSize: "1.5rem", borderRadius: "50%", focusRing: { width: "{focus.ring.width}", style: "{focus.ring.style}", color: "{focus.ring.color}", offset: "{focus.ring.offset}", shadow: "{focus.ring.shadow}" } }, Pm = { root: Bm, preview: Tm, toolbar: Im, action: Dm, css: "" }, zm = { size: "20px", hoverSize: "40px", background: "rgba(255,255,255,0.4)", hoverBackground: "rgba(255,255,255,0.6)", borderColor: "unset", hoverBorderColor: "unset", borderWidth: "0", borderRadius: "50%", transitionDuration: "{transition.duration}", focusRing: { width: "{focus.ring.width}", style: "{focus.ring.style}", color: "rgba(255,255,255,0.3)", offset: "{focus.ring.offset}", shadow: "{focus.ring.shadow}" } }, Lm = { handle: zm, css: "" }, Om = { padding: "{form.field.padding.y} {form.field.padding.x}", borderRadius: "{content.border.radius}", gap: "0.5rem" }, Mm = { fontWeight: "500" }, Am = { size: "1rem" }, _m = { light: { info: { background: "color-mix(in srgb, {blue.50}, transparent 5%)", borderColor: "{blue.200}", color: "{blue.600}", shadow: "0px 4px 8px 0px color-mix(in srgb, {blue.500}, transparent 96%)" }, success: { background: "color-mix(in srgb, {green.50}, transparent 5%)", borderColor: "{green.200}", color: "{green.600}", shadow: "0px 4px 8px 0px color-mix(in srgb, {green.500}, transparent 96%)" }, warn: { background: "color-mix(in srgb,{yellow.50}, transparent 5%)", borderColor: "{yellow.200}", color: "{yellow.600}", shadow: "0px 4px 8px 0px color-mix(in srgb, {yellow.500}, transparent 96%)" }, error: { background: "color-mix(in srgb, {red.50}, transparent 5%)", borderColor: "{red.200}", color: "{red.600}", shadow: "0px 4px 8px 0px color-mix(in srgb, {red.500}, transparent 96%)" }, secondary: { background: "{surface.100}", borderColor: "{surface.200}", color: "{surface.600}", shadow: "0px 4px 8px 0px color-mix(in srgb, {surface.500}, transparent 96%)" }, contrast: { background: "{surface.900}", borderColor: "{surface.950}", color: "{surface.50}", shadow: "0px 4px 8px 0px color-mix(in srgb, {surface.950}, transparent 96%)" } }, dark: { info: { background: "color-mix(in srgb, {blue.500}, transparent 84%)", borderColor: "color-mix(in srgb, {blue.700}, transparent 64%)", color: "{blue.500}", shadow: "0px 4px 8px 0px color-mix(in srgb, {blue.500}, transparent 96%)" }, success: { background: "color-mix(in srgb, {green.500}, transparent 84%)", borderColor: "color-mix(in srgb, {green.700}, transparent 64%)", color: "{green.500}", shadow: "0px 4px 8px 0px color-mix(in srgb, {green.500}, transparent 96%)" }, warn: { background: "color-mix(in srgb, {yellow.500}, transparent 84%)", borderColor: "color-mix(in srgb, {yellow.700}, transparent 64%)", color: "{yellow.500}", shadow: "0px 4px 8px 0px color-mix(in srgb, {yellow.500}, transparent 96%)" }, error: { background: "color-mix(in srgb, {red.500}, transparent 84%)", borderColor: "color-mix(in srgb, {red.700}, transparent 64%)", color: "{red.500}", shadow: "0px 4px 8px 0px color-mix(in srgb, {red.500}, transparent 96%)" }, secondary: { background: "{surface.800}", borderColor: "{surface.700}", color: "{surface.300}", shadow: "0px 4px 8px 0px color-mix(in srgb, {surface.500}, transparent 96%)" }, contrast: { background: "{surface.0}", borderColor: "{surface.100}", color: "{surface.950}", shadow: "0px 4px 8px 0px color-mix(in srgb, {surface.950}, transparent 96%)" } } }, Fm = { root: Om, text: Mm, icon: Am, colorScheme: _m, css: "" }, Em = { padding: "{form.field.padding.y} {form.field.padding.x}", borderRadius: "{content.border.radius}", focusRing: { width: "{focus.ring.width}", style: "{focus.ring.style}", color: "{focus.ring.color}", offset: "{focus.ring.offset}", shadow: "{focus.ring.shadow}" }, transitionDuration: "{transition.duration}" }, Rm = { hoverBackground: "{content.hover.background}", hoverColor: "{content.hover.color}" }, Vm = { root: Em, display: Rm, css: "" }, Nm = { background: "{form.field.background}", disabledBackground: "{form.field.disabled.background}", filledBackground: "{form.field.filled.background}", filledFocusBackground: "{form.field.filled.focus.background}", borderColor: "{form.field.border.color}", hoverBorderColor: "{form.field.hover.border.color}", focusBorderColor: "{form.field.focus.border.color}", invalidBorderColor: "{form.field.invalid.border.color}", color: "{form.field.color}", disabledColor: "{form.field.disabled.color}", placeholderColor: "{form.field.placeholder.color}", shadow: "{form.field.shadow}", paddingX: "{form.field.padding.x}", paddingY: "{form.field.padding.y}", borderRadius: "{form.field.border.radius}", focusRing: { width: "{form.field.focus.ring.width}", style: "{form.field.focus.ring.style}", color: "{form.field.focus.ring.color}", offset: "{form.field.focus.ring.offset}", shadow: "{form.field.focus.ring.shadow}" }, transitionDuration: "{form.field.transition.duration}" }, jm = { borderRadius: "{border.radius.sm}" }, Um = { light: { chip: { focusBackground: "{surface.200}", color: "{surface.800}" } }, dark: { chip: { focusBackground: "{surface.700}", color: "{surface.0}" } } }, Hm = { root: Nm, chip: jm, colorScheme: Um, css: "" }, Km = { background: "{form.field.background}", borderColor: "{form.field.border.color}", color: "{form.field.icon.color}", borderRadius: "{form.field.border.radius}", padding: "0.75rem", minWidth: "3rem" }, Wm = `
.p-inputgroup:has(.p-variant-filled) .p-inputgroupaddon {
    border-block-start-color: dt('inputtext.filled.background');
    border-inline-color: dt('inputtext.filled.background');
    background: dt('inputtext.filled.background') no-repeat;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
}
`, Ym = { addon: Km, css: Wm }, Gm = { transitionDuration: "{transition.duration}" }, qm = { width: "3rem", borderRadius: "{form.field.border.radius}", verticalPadding: "{form.field.padding.y}" }, Zm = { light: { button: { background: "transparent", hoverBackground: "{surface.100}", activeBackground: "{surface.200}", borderColor: "{form.field.border.color}", hoverBorderColor: "{form.field.border.color}", activeBorderColor: "{form.field.border.color}", color: "{surface.400}", hoverColor: "{surface.500}", activeColor: "{surface.600}" } }, dark: { button: { background: "transparent", hoverBackground: "{surface.800}", activeBackground: "{surface.700}", borderColor: "{form.field.border.color}", hoverBorderColor: "{form.field.border.color}", activeBorderColor: "{form.field.border.color}", color: "{surface.400}", hoverColor: "{surface.300}", activeColor: "{surface.200}" } } }, Xm = `
.p-inputnumber-stacked .p-inputnumber-button-group {
    top: 2px;
    right: 2px;
    height: calc(100% - 4px);
}

.p-inputnumber-horizontal:has(.p-variant-filled) .p-inputnumber-button {
    border-block-start-color: dt('inputtext.filled.background');
    border-inline-color: dt('inputtext.filled.background');
    background: dt('inputtext.filled.background') no-repeat;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
}

.p-inputnumber-vertical:has(.p-variant-filled) .p-inputnumber-button {
    border-block-color: dt('inputtext.filled.background');
    border-inline-color: dt('inputtext.filled.background');
    background: dt('inputtext.filled.background') no-repeat;
}

.p-inputnumber-vertical:has(.p-variant-filled) .p-inputnumber-increment-button {
    border-block-end: 1px solid dt('inputtext.border.color')
}
`, Jm = { root: Gm, button: qm, colorScheme: Zm, css: Xm }, Qm = { gap: "0.5rem" }, ef = { width: "3rem", sm: { width: "2.5rem" }, lg: { width: "3.5rem" } }, tf = { root: Qm, input: ef, css: "" }, nf = { background: "{form.field.background}", disabledBackground: "{form.field.disabled.background}", filledBackground: "{form.field.filled.background}", filledHoverBackground: "{form.field.filled.hover.background}", filledFocusBackground: "{form.field.filled.focus.background}", borderColor: "{form.field.border.color}", hoverBorderColor: "{form.field.hover.border.color}", focusBorderColor: "{form.field.focus.border.color}", invalidBorderColor: "{form.field.invalid.border.color}", color: "{form.field.color}", disabledColor: "{form.field.disabled.color}", placeholderColor: "{form.field.placeholder.color}", invalidPlaceholderColor: "{form.field.invalid.placeholder.color}", shadow: "{form.field.shadow}", paddingX: "{form.field.padding.x}", paddingY: "{form.field.padding.y}", borderRadius: "{form.field.border.radius}", focusRing: { width: "{form.field.focus.ring.width}", style: "{form.field.focus.ring.style}", color: "{form.field.focus.ring.color}", offset: "{form.field.focus.ring.offset}", shadow: "{form.field.focus.ring.shadow}" }, transitionDuration: "{form.field.transition.duration}", sm: { fontSize: "{form.field.sm.font.size}", paddingX: "{form.field.sm.padding.x}", paddingY: "{form.field.sm.padding.y}" }, lg: { fontSize: "{form.field.lg.font.size}", paddingX: "{form.field.lg.padding.x}", paddingY: "{form.field.lg.padding.y}" } }, of = `
.p-inputtext.p-variant-filled {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    border: 1px solid transparent;
    background: dt('inputtext.filled.background') no-repeat;
    background-image: linear-gradient(to bottom, dt('inputtext.focus.border.color'), dt('inputtext.focus.border.color')), linear-gradient(to bottom, dt('inputtext.border.color'), dt('inputtext.border.color'));
    background-size: 0 2px, 100% 1px;
    background-position: 50% 100%, 50% 100%;
    background-origin: border-box;
    transition: background-size 0.3s cubic-bezier(0.64, 0.09, 0.08, 1);
}

.p-inputtext.p-variant-filled:enabled:hover {
    background: dt('inputtext.filled.hover.background') no-repeat;
    background-image: linear-gradient(to bottom, dt('inputtext.focus.border.color'), dt('inputtext.focus.border.color')), linear-gradient(to bottom, dt('inputtext.hover.border.color'), dt('inputtext.hover.border.color'));
    background-size: 0 2px, 100% 1px;
    background-position: 50% 100%, 50% 100%;
    background-origin: border-box;
    border-color: transparent;
}

.p-inputtext.p-variant-filled:enabled:focus {
    outline: 0 none;
    background: dt('inputtext.filled.focus.background') no-repeat;
    background-image: linear-gradient(to bottom, dt('inputtext.focus.border.color'), dt('inputtext.focus.border.color')), linear-gradient(to bottom, dt('inputtext.border.color'), dt('inputtext.border.color'));
    background-size: 100% 2px, 100% 1px;
    background-position: 50% 100%, 50% 100%;
    background-origin: border-box;
    border-color: transparent;
}

.p-inputtext.p-variant-filled:enabled:hover:focus {
    background-image: linear-gradient(to bottom, dt('inputtext.focus.border.color'), dt('inputtext.focus.border.color')), linear-gradient(to bottom, dt('inputtext.hover.border.color'), dt('inputtext.hover.border.color'));
}

.p-inputtext.p-variant-filled.p-invalid {
    background-image: linear-gradient(to bottom, dt('inputtext.invalid.border.color'), dt('inputtext.invalid.border.color')), linear-gradient(to bottom, dt('inputtext.invalid.border.color'), dt('inputtext.invalid.border.color'));
}

.p-inputtext.p-variant-filled.p-invalid:enabled:focus {
    background-image: linear-gradient(to bottom, dt('inputtext.invalid.border.color'), dt('inputtext.invalid.border.color')), linear-gradient(to bottom, dt('inputtext.invalid.border.color'), dt('inputtext.invalid.border.color'));
}

.p-inputtext.p-variant-filled:disabled {
    background: dt('inputtext.disabled.background') no-repeat;
    background-image: linear-gradient(to bottom, dt('inputtext.border.color'), dt('inputtext.border.color')), linear-gradient(to bottom, dt('inputtext.border.color'), dt('inputtext.border.color'));
    background-size: 0 2px, 100% 1px;
    background-position: 50% 100%, 50% 100%;
    background-origin: border-box;
    border-color: transparent;
}
`, rf = { root: nf, css: of }, af = { transitionDuration: "{transition.duration}", focusRing: { width: "{focus.ring.width}", style: "{focus.ring.style}", color: "{focus.ring.color}", offset: "{focus.ring.offset}", shadow: "{focus.ring.shadow}" } }, lf = { background: "{primary.color}" }, sf = { background: "{content.border.color}" }, df = { color: "{text.muted.color}" }, uf = { root: af, value: lf, range: sf, text: df, css: "" }, cf = { background: "{form.field.background}", disabledBackground: "{form.field.disabled.background}", borderColor: "{form.field.border.color}", invalidBorderColor: "{form.field.invalid.border.color}", color: "{form.field.color}", disabledColor: "{form.field.disabled.color}", shadow: "{form.field.shadow}", borderRadius: "{form.field.border.radius}", transitionDuration: "{form.field.transition.duration}" }, pf = { padding: "{list.padding}", gap: "{list.gap}", header: { padding: "{list.header.padding}" } }, mf = { focusBackground: "{list.option.focus.background}", selectedBackground: "{list.option.selected.background}", selectedFocusBackground: "{list.option.selected.focus.background}", color: "{list.option.color}", focusColor: "{list.option.focus.color}", selectedColor: "{list.option.selected.color}", selectedFocusColor: "{list.option.selected.focus.color}", padding: "{list.option.padding}", borderRadius: "{list.option.border.radius}" }, ff = { background: "{list.option.group.background}", color: "{list.option.group.color}", fontWeight: "{list.option.group.font.weight}", padding: "{list.option.group.padding}" }, gf = { color: "{list.option.color}", gutterStart: "-0.375rem", gutterEnd: "0.375rem" }, hf = { padding: "{list.option.padding}" }, bf = { light: { option: { stripedBackground: "{surface.50}" } }, dark: { option: { stripedBackground: "{surface.900}" } } }, vf = `
.p-listbox-option {
    transition: none;
}
`, yf = { root: cf, list: pf, option: mf, optionGroup: ff, checkmark: gf, emptyMessage: hf, colorScheme: bf, css: vf }, kf = { background: "{content.background}", borderColor: "{content.border.color}", borderRadius: "{content.border.radius}", color: "{content.color}", gap: "0.5rem", verticalOrientation: { padding: "{navigation.list.padding}", gap: "{navigation.list.gap}" }, horizontalOrientation: { padding: "0.5rem 0.75rem", gap: "0.5rem" }, transitionDuration: "{transition.duration}" }, wf = { borderRadius: "{content.border.radius}", padding: "{navigation.item.padding}" }, xf = { focusBackground: "{navigation.item.focus.background}", activeBackground: "{navigation.item.active.background}", color: "{navigation.item.color}", focusColor: "{navigation.item.focus.color}", activeColor: "{navigation.item.active.color}", padding: "{navigation.item.padding}", borderRadius: "{navigation.item.border.radius}", gap: "{navigation.item.gap}", icon: { color: "{navigation.item.icon.color}", focusColor: "{navigation.item.icon.focus.color}", activeColor: "{navigation.item.icon.active.color}" } }, Cf = { padding: "0", background: "{content.background}", borderColor: "transparent", borderRadius: "{content.border.radius}", color: "{content.color}", shadow: "{overlay.navigation.shadow}", gap: "0.5rem" }, Sf = { padding: "{navigation.list.padding}", gap: "{navigation.list.gap}" }, $f = { padding: "{navigation.submenu.label.padding}", fontWeight: "{navigation.submenu.label.font.weight}", background: "{navigation.submenu.label.background.}", color: "{navigation.submenu.label.color}" }, Bf = { size: "{navigation.submenu.icon.size}", color: "{navigation.submenu.icon.color}", focusColor: "{navigation.submenu.icon.focus.color}", activeColor: "{navigation.submenu.icon.active.color}" }, Tf = { borderColor: "{content.border.color}" }, If = { borderRadius: "50%", size: "2.5rem", color: "{text.muted.color}", hoverColor: "{text.hover.muted.color}", hoverBackground: "{content.hover.background}", focusRing: { width: "0", style: "none", color: "unset", offset: "0", shadow: "none" } }, Df = `
.p-megamenu-button:focus-visible {
    background: dt('navigation.item.active.background');
}
`, Pf = { root: kf, baseItem: wf, item: xf, overlay: Cf, submenu: Sf, submenuLabel: $f, submenuIcon: Bf, separator: Tf, mobileButton: If, css: Df }, zf = { background: "{content.background}", borderColor: "{content.border.color}", color: "{content.color}", borderRadius: "{content.border.radius}", shadow: "{overlay.navigation.shadow}", transitionDuration: "{transition.duration}" }, Lf = { padding: "{navigation.list.padding}", gap: "{navigation.list.gap}" }, Of = { focusBackground: "{navigation.item.focus.background}", color: "{navigation.item.color}", focusColor: "{navigation.item.focus.color}", padding: "{navigation.item.padding}", borderRadius: "{navigation.item.border.radius}", gap: "{navigation.item.gap}", icon: { color: "{navigation.item.icon.color}", focusColor: "{navigation.item.icon.focus.color}" } }, Mf = { padding: "{navigation.submenu.label.padding}", fontWeight: "{navigation.submenu.label.font.weight}", background: "{navigation.submenu.label.background}", color: "{navigation.submenu.label.color}" }, Af = { borderColor: "{content.border.color}" }, _f = `
.p-menu-overlay {
    border-color: transparent;
}
`, Ff = { root: zf, list: Lf, item: Of, submenuLabel: Mf, separator: Af, css: _f }, Ef = { background: "{content.background}", borderColor: "{content.border.color}", borderRadius: "{content.border.radius}", color: "{content.color}", gap: "0.5rem", padding: "0.5rem 0.75rem", transitionDuration: "{transition.duration}" }, Rf = { borderRadius: "{content.border.radius}", padding: "{navigation.item.padding}" }, Vf = { focusBackground: "{navigation.item.focus.background}", activeBackground: "{navigation.item.active.background}", color: "{navigation.item.color}", focusColor: "{navigation.item.focus.color}", activeColor: "{navigation.item.active.color}", padding: "{navigation.item.padding}", borderRadius: "{navigation.item.border.radius}", gap: "{navigation.item.gap}", icon: { color: "{navigation.item.icon.color}", focusColor: "{navigation.item.icon.focus.color}", activeColor: "{navigation.item.icon.active.color}" } }, Nf = { padding: "{navigation.list.padding}", gap: "{navigation.list.gap}", background: "{content.background}", borderColor: "transparent", borderRadius: "{content.border.radius}", shadow: "{overlay.navigation.shadow}", mobileIndent: "1rem", icon: { size: "{navigation.submenu.icon.size}", color: "{navigation.submenu.icon.color}", focusColor: "{navigation.submenu.icon.focus.color}", activeColor: "{navigation.submenu.icon.active.color}" } }, jf = { borderColor: "{content.border.color}" }, Uf = { borderRadius: "50%", size: "2.5rem", color: "{text.muted.color}", hoverColor: "{text.hover.muted.color}", hoverBackground: "{content.hover.background}", focusRing: { width: "0", style: "none", color: "unset", offset: "0", shadow: "none" } }, Hf = `
.p-menubar-button:focus-visible {
    background: dt('navigation.item.active.background');
}
`, Kf = { root: Ef, baseItem: Rf, item: Vf, submenu: Nf, separator: jf, mobileButton: Uf, css: Hf }, Wf = { borderRadius: "{content.border.radius}", borderWidth: "0", transitionDuration: "{transition.duration}" }, Yf = { padding: "1rem 1.25rem", gap: "0.5rem", sm: { padding: "0.625rem 0.625rem" }, lg: { padding: "0.825rem 0.825rem" } }, Gf = { fontSize: "1rem", fontWeight: "500", sm: { fontSize: "0.875rem" }, lg: { fontSize: "1.125rem" } }, qf = { size: "1.25rem", sm: { size: "1rem" }, lg: { size: "1.5rem" } }, Zf = { width: "2rem", height: "2rem", borderRadius: "50%", focusRing: { width: "{focus.ring.width}", style: "{focus.ring.style}", offset: "{focus.ring.offset}" } }, Xf = { size: "1rem", sm: { size: "0.875rem" }, lg: { size: "1.125rem" } }, Jf = { root: { borderWidth: "1px" } }, Qf = { content: { padding: "0" } }, eg = { light: { info: { background: "color-mix(in srgb, {blue.50}, transparent 5%)", borderColor: "{blue.200}", color: "{blue.600}", shadow: "none", closeButton: { hoverBackground: "{blue.100}", focusRing: { color: "{blue.600}", shadow: "none" } }, outlined: { color: "{blue.600}", borderColor: "{blue.600}" }, simple: { color: "{blue.600}" } }, success: { background: "color-mix(in srgb, {green.50}, transparent 5%)", borderColor: "{green.200}", color: "{green.600}", shadow: "none", closeButton: { hoverBackground: "{green.100}", focusRing: { color: "{green.600}", shadow: "none" } }, outlined: { color: "{green.600}", borderColor: "{green.600}" }, simple: { color: "{green.600}" } }, warn: { background: "color-mix(in srgb,{yellow.50}, transparent 5%)", borderColor: "{yellow.200}", color: "{yellow.900}", shadow: "none", closeButton: { hoverBackground: "{yellow.100}", focusRing: { color: "{yellow.600}", shadow: "none" } }, outlined: { color: "{yellow.900}", borderColor: "{yellow.900}" }, simple: { color: "{yellow.900}" } }, error: { background: "color-mix(in srgb, {red.50}, transparent 5%)", borderColor: "{red.200}", color: "{red.600}", shadow: "none", closeButton: { hoverBackground: "{red.100}", focusRing: { color: "{red.600}", shadow: "none" } }, outlined: { color: "{red.600}", borderColor: "{red.600}" }, simple: { color: "{red.600}" } }, secondary: { background: "{surface.100}", borderColor: "{surface.200}", color: "{surface.600}", shadow: "none", closeButton: { hoverBackground: "{surface.200}", focusRing: { color: "{surface.600}", shadow: "none" } }, outlined: { color: "{surface.600}", borderColor: "{surface.600}" }, simple: { color: "{surface.600}" } }, contrast: { background: "{surface.900}", borderColor: "{surface.950}", color: "{surface.50}", shadow: "none", closeButton: { hoverBackground: "{surface.800}", focusRing: { color: "{surface.50}", shadow: "none" } }, outlined: { color: "{surface.950}", borderColor: "{surface.950}" }, simple: { color: "{surface.950}" } } }, dark: { info: { background: "color-mix(in srgb, {blue.500}, transparent 84%)", borderColor: "color-mix(in srgb, {blue.700}, transparent 64%)", color: "{blue.500}", shadow: "none", closeButton: { hoverBackground: "rgba(255, 255, 255, 0.05)", focusRing: { color: "{blue.500}", shadow: "none" } }, outlined: { color: "{blue.500}", borderColor: "{blue.500}" }, simple: { color: "{blue.500}" } }, success: { background: "color-mix(in srgb, {green.500}, transparent 84%)", borderColor: "color-mix(in srgb, {green.700}, transparent 64%)", color: "{green.500}", shadow: "none", closeButton: { hoverBackground: "rgba(255, 255, 255, 0.05)", focusRing: { color: "{green.500}", shadow: "none" } }, outlined: { color: "{green.500}", borderColor: "{green.500}" }, simple: { color: "{green.500}" } }, warn: { background: "color-mix(in srgb, {yellow.500}, transparent 84%)", borderColor: "color-mix(in srgb, {yellow.700}, transparent 64%)", color: "{yellow.500}", shadow: "none", closeButton: { hoverBackground: "rgba(255, 255, 255, 0.05)", focusRing: { color: "{yellow.500}", shadow: "none" } }, outlined: { color: "{yellow.500}", borderColor: "{yellow.500}" }, simple: { color: "{yellow.500}" } }, error: { background: "color-mix(in srgb, {red.500}, transparent 84%)", borderColor: "color-mix(in srgb, {red.700}, transparent 64%)", color: "{red.500}", shadow: "none", closeButton: { hoverBackground: "rgba(255, 255, 255, 0.05)", focusRing: { color: "{red.500}", shadow: "none" } }, outlined: { color: "{red.500}", borderColor: "{red.500}" }, simple: { color: "{red.500}" } }, secondary: { background: "{surface.800}", borderColor: "{surface.700}", color: "{surface.300}", shadow: "none", closeButton: { hoverBackground: "{surface.700}", focusRing: { color: "{surface.300}", shadow: "none" } }, outlined: { color: "{surface.400}", borderColor: "{surface.400}" }, simple: { color: "{surface.400}" } }, contrast: { background: "{surface.0}", borderColor: "{surface.100}", color: "{surface.950}", shadow: "none", closeButton: { hoverBackground: "{surface.100}", focusRing: { color: "{surface.950}", shadow: "none" } }, outlined: { color: "{surface.0}", borderColor: "{surface.0}" }, simple: { color: "{surface.0}" } } } }, tg = { root: Wf, content: Yf, text: Gf, icon: qf, closeButton: Zf, closeIcon: Xf, outlined: Jf, simple: Qf, colorScheme: eg, css: "" }, ng = { borderRadius: "{content.border.radius}", gap: "1rem" }, og = { background: "{content.border.color}", size: "0.5rem" }, rg = { gap: "0.5rem" }, ig = { size: "0.5rem" }, ag = { size: "1rem" }, lg = { verticalGap: "0.5rem", horizontalGap: "1rem" }, sg = { root: ng, meters: og, label: rg, labelMarker: ig, labelIcon: ag, labelList: lg, css: "" }, dg = { background: "{form.field.background}", disabledBackground: "{form.field.disabled.background}", filledBackground: "{form.field.filled.background}", filledHoverBackground: "{form.field.filled.hover.background}", filledFocusBackground: "{form.field.filled.focus.background}", borderColor: "{form.field.border.color}", hoverBorderColor: "{form.field.hover.border.color}", focusBorderColor: "{form.field.focus.border.color}", invalidBorderColor: "{form.field.invalid.border.color}", color: "{form.field.color}", disabledColor: "{form.field.disabled.color}", placeholderColor: "{form.field.placeholder.color}", invalidPlaceholderColor: "{form.field.invalid.placeholder.color}", shadow: "{form.field.shadow}", paddingX: "{form.field.padding.x}", paddingY: "{form.field.padding.y}", borderRadius: "{form.field.border.radius}", focusRing: { width: "{form.field.focus.ring.width}", style: "{form.field.focus.ring.style}", color: "{form.field.focus.ring.color}", offset: "{form.field.focus.ring.offset}", shadow: "{form.field.focus.ring.shadow}" }, transitionDuration: "{form.field.transition.duration}", sm: { fontSize: "{form.field.sm.font.size}", paddingX: "{form.field.sm.padding.x}", paddingY: "{form.field.sm.padding.y}" }, lg: { fontSize: "{form.field.lg.font.size}", paddingX: "{form.field.lg.padding.x}", paddingY: "{form.field.lg.padding.y}" } }, ug = { width: "2.5rem", color: "{form.field.icon.color}" }, cg = { background: "{overlay.select.background}", borderColor: "{overlay.select.border.color}", borderRadius: "{overlay.select.border.radius}", color: "{overlay.select.color}", shadow: "{overlay.select.shadow}" }, pg = { padding: "{list.padding}", gap: "{list.gap}", header: { padding: "{list.header.padding}" } }, mg = { focusBackground: "{list.option.focus.background}", selectedBackground: "{list.option.selected.background}", selectedFocusBackground: "{list.option.selected.focus.background}", color: "{list.option.color}", focusColor: "{list.option.focus.color}", selectedColor: "{list.option.selected.color}", selectedFocusColor: "{list.option.selected.focus.color}", padding: "{list.option.padding}", borderRadius: "{list.option.border.radius}", gap: "0.75rem" }, fg = { background: "{list.option.group.background}", color: "{list.option.group.color}", fontWeight: "{list.option.group.font.weight}", padding: "{list.option.group.padding}" }, gg = { color: "{form.field.icon.color}" }, hg = { borderRadius: "{border.radius.sm}" }, bg = { padding: "{list.option.padding}" }, vg = `
.p-multiselect.p-variant-filled {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    border: 1px solid transparent;
    background: dt('multiselect.filled.background') no-repeat;
    background-image: linear-gradient(to bottom, dt('multiselect.focus.border.color'), dt('multiselect.focus.border.color')), linear-gradient(to bottom, dt('multiselect.border.color'), dt('multiselect.border.color'));
    background-size: 0 2px, 100% 1px;
    background-position: 50% 100%, 50% 100%;
    background-origin: border-box;
    transition: background-size 0.3s cubic-bezier(0.64, 0.09, 0.08, 1);
}

.p-multiselect.p-variant-filled:not(.p-disabled):hover {
    background: dt('multiselect.filled.hover.background') no-repeat;
    background-image: linear-gradient(to bottom, dt('multiselect.focus.border.color'), dt('multiselect.focus.border.color')), linear-gradient(to bottom, dt('multiselect.hover.border.color'), dt('multiselect.hover.border.color'));
    background-size: 0 2px, 100% 1px;
    background-position: 50% 100%, 50% 100%;
    background-origin: border-box;
    border-color: transparent;
}

.p-multiselect.p-variant-filled:not(.p-disabled).p-focus {
    outline: 0 none;
    background: dt('multiselect.filled.focus.background') no-repeat;
    background-image: linear-gradient(to bottom, dt('multiselect.focus.border.color'), dt('multiselect.focus.border.color')), linear-gradient(to bottom, dt('multiselect.border.color'), dt('multiselect.border.color'));
    background-size: 100% 2px, 100% 1px;
    background-position: 50% 100%, 50% 100%;
    background-origin: border-box;
    border-color: transparent;
}

.p-multiselect.p-variant-filled:not(.p-disabled).p-focus:hover {
    background-image: linear-gradient(to bottom, dt('multiselect.focus.border.color'), dt('multiselect.focus.border.color')), linear-gradient(to bottom, dt('multiselect.hover.border.color'), dt('multiselect.hover.border.color'));
}

.p-multiselect.p-variant-filled.p-invalid {
    background-image: linear-gradient(to bottom, dt('multiselect.invalid.border.color'), dt('multiselect.invalid.border.color')), linear-gradient(to bottom, dt('multiselect.invalid.border.color'), dt('multiselect.invalid.border.color'));
}

.p-multiselect.p-variant-filled.p-invalid:not(.p-disabled).p-focus  {
    background-image: linear-gradient(to bottom, dt('multiselect.invalid.border.color'), dt('multiselect.invalid.border.color')), linear-gradient(to bottom, dt('multiselect.invalid.border.color'), dt('multiselect.invalid.border.color'));
}

.p-multiselect-option {
    transition: none;
}
`, yg = { root: dg, dropdown: ug, overlay: cg, list: pg, option: mg, optionGroup: fg, chip: hg, clearIcon: gg, emptyMessage: bg, css: vg }, kg = { gap: "1.125rem" }, wg = { gap: "0.5rem" }, xg = { root: kg, controls: wg, css: "" }, Cg = { gutter: "0.75rem", transitionDuration: "{transition.duration}" }, Sg = { background: "{content.background}", hoverBackground: "{content.hover.background}", selectedBackground: "{highlight.background}", borderColor: "{content.border.color}", color: "{content.color}", selectedColor: "{highlight.color}", hoverColor: "{content.hover.color}", padding: "1rem 1.25rem", toggleablePadding: "1rem 1.25rem 1.5rem 1.25rem", borderRadius: "{content.border.radius}" }, $g = { background: "{content.background}", hoverBackground: "{content.hover.background}", borderColor: "{content.border.color}", color: "{text.muted.color}", hoverColor: "{text.color}", size: "1.75rem", borderRadius: "50%", focusRing: { width: "{focus.ring.width}", style: "{focus.ring.style}", color: "{focus.ring.color}", offset: "{focus.ring.offset}", shadow: "{focus.ring.shadow}" } }, Bg = { color: "{content.border.color}", borderRadius: "{content.border.radius}", height: "24px" }, Tg = { root: Cg, node: Sg, nodeToggleButton: $g, connector: Bg, css: "" }, Ig = { outline: { width: "2px", color: "{content.background}" } }, Dg = { root: Ig, css: "" }, Pg = { padding: "0.5rem 1rem", gap: "0.25rem", borderRadius: "{content.border.radius}", background: "{content.background}", color: "{content.color}", transitionDuration: "{transition.duration}" }, zg = { background: "transparent", hoverBackground: "{content.hover.background}", selectedBackground: "{highlight.background}", color: "{text.muted.color}", hoverColor: "{text.hover.muted.color}", selectedColor: "{highlight.color}", width: "2.5rem", height: "2.5rem", borderRadius: "50%", focusRing: { width: "{focus.ring.width}", style: "{focus.ring.style}", color: "{focus.ring.color}", offset: "{focus.ring.offset}", shadow: "{focus.ring.shadow}" } }, Lg = { color: "{text.muted.color}" }, Og = { maxWidth: "2.5rem" }, Mg = { root: Pg, navButton: zg, currentPageReport: Lg, jumpToPageInput: Og, css: "" }, Ag = { background: "{content.background}", borderColor: "{content.border.color}", color: "{content.color}", borderRadius: "{content.border.radius}" }, _g = { background: "transparent", color: "{text.color}", padding: "1.25rem", borderColor: "{content.border.color}", borderWidth: "0", borderRadius: "0" }, Fg = { padding: "0.5rem 1.25rem" }, Eg = { fontWeight: "600" }, Rg = { padding: "0 1.25rem 1.25rem 1.25rem" }, Vg = { padding: "0 1.25rem 1.25rem 1.25rem" }, Ng = { root: Ag, header: _g, toggleableHeader: Fg, title: Eg, content: Rg, footer: Vg, css: "" }, jg = { gap: "0", transitionDuration: "{transition.duration}" }, Ug = { background: "{content.background}", borderColor: "{content.border.color}", borderWidth: "0", color: "{content.color}", padding: "0", borderRadius: "0", first: { borderWidth: "0", topBorderRadius: "{content.border.radius}" }, last: { borderWidth: "0", bottomBorderRadius: "{content.border.radius}" } }, Hg = { focusBackground: "{navigation.item.focus.background}", color: "{navigation.item.color}", focusColor: "{navigation.item.focus.color}", gap: "0.5rem", padding: "{navigation.item.padding}", borderRadius: "{content.border.radius}", icon: { color: "{navigation.item.icon.color}", focusColor: "{navigation.item.icon.focus.color}" } }, Kg = { indent: "1rem" }, Wg = { color: "{navigation.submenu.icon.color}", focusColor: "{navigation.submenu.icon.focus.color}" }, Yg = `
.p-panelmenu-panel {
    box-shadow: 0 0 0 1px dt('panelmenu.panel.border.color');
    transition: margin dt('panelmenu.transition.duration');
}

.p-panelmenu-panel:has(.p-panelmenu-header-active) {
    margin: 1rem 0;
}

.p-panelmenu-panel:first-child {
    border-top-left-radius: dt('content.border.radius');
    border-top-right-radius: dt('content.border.radius');
    margin-top: 0;
}

.p-panelmenu-panel:last-child {
    border-bottom-left-radius: dt('content.border.radius');
    border-bottom-right-radius: dt('content.border.radius');
    margin-bottom: 0;
}

.p-accordionpanel:not(.p-disabled) .p-accordionheader:focus-visible {
    background: dt('navigation.item.active.background');
}
`, Gg = { root: jg, panel: Ug, item: Hg, submenu: Kg, submenuIcon: Wg, css: Yg }, qg = { background: "{content.border.color}", borderRadius: "{content.border.radius}", height: ".75rem" }, Zg = { color: "{form.field.icon.color}" }, Xg = { background: "{overlay.popover.background}", borderColor: "{overlay.popover.border.color}", borderRadius: "{overlay.popover.border.radius}", color: "{overlay.popover.color}", padding: "{overlay.popover.padding}", shadow: "{overlay.popover.shadow}" }, Jg = { gap: "0.5rem" }, Qg = { light: { strength: { weakBackground: "{red.500}", mediumBackground: "{amber.500}", strongBackground: "{green.500}" } }, dark: { strength: { weakBackground: "{red.400}", mediumBackground: "{amber.400}", strongBackground: "{green.400}" } } }, eh = { meter: qg, icon: Zg, overlay: Xg, content: Jg, colorScheme: Qg, css: "" }, th = { gap: "1.125rem" }, nh = { gap: "0.5rem" }, oh = { root: th, controls: nh, css: "" }, rh = { background: "{overlay.popover.background}", borderColor: "{overlay.popover.border.color}", color: "{overlay.popover.color}", borderRadius: "{overlay.popover.border.radius}", shadow: "{overlay.popover.shadow}", gutter: "10px", arrowOffset: "1.25rem" }, ih = { padding: "{overlay.popover.padding}" }, ah = { root: rh, content: ih, css: "" }, lh = { background: "{content.border.color}", borderRadius: "{content.border.radius}", height: "1rem" }, sh = { background: "{primary.color}" }, dh = { color: "{primary.contrast.color}", fontSize: "0.75rem", fontWeight: "600" }, uh = { root: lh, value: sh, label: dh, css: "" }, ch = { light: { root: { colorOne: "{red.500}", colorTwo: "{blue.500}", colorThree: "{green.500}", colorFour: "{yellow.500}" } }, dark: { root: { colorOne: "{red.400}", colorTwo: "{blue.400}", colorThree: "{green.400}", colorFour: "{yellow.400}" } } }, ph = { colorScheme: ch, css: "" }, mh = { width: "20px", height: "20px", background: "{form.field.background}", checkedBackground: "{primary.contrast.color}", checkedHoverBackground: "{primary.contrast.color}", disabledBackground: "{form.field.disabled.background}", filledBackground: "{form.field.filled.background}", borderColor: "{form.field.border.color}", hoverBorderColor: "{form.field.hover.border.color}", focusBorderColor: "{form.field.focus.border.color}", checkedBorderColor: "{primary.color}", checkedHoverBorderColor: "{primary.color}", checkedFocusBorderColor: "{primary.color}", checkedDisabledBorderColor: "{form.field.border.color}", invalidBorderColor: "{form.field.invalid.border.color}", shadow: "{form.field.shadow}", focusRing: { width: "0", style: "none", color: "unset", offset: "0", shadow: "none" }, transitionDuration: "{form.field.transition.duration}", sm: { width: "16px", height: "16px" }, lg: { width: "24px", height: "24px" } }, fh = { size: "10px", checkedColor: "{primary.color}", checkedHoverColor: "{primary.color}", disabledColor: "{form.field.disabled.color}", sm: { size: "8px" }, lg: { size: "12px" } }, gh = { root: mh, icon: fh }, hh = { gap: "0.5rem", transitionDuration: "{transition.duration}", focusRing: { width: "0", style: "none", color: "unset", offset: "0", shadow: "none" } }, bh = { size: "1.125rem", color: "{text.muted.color}", hoverColor: "{primary.color}", activeColor: "{primary.color}" }, vh = `
.p-rating:not(.p-disabled):not(.p-readonly) .p-rating-option:hover {
    background: color-mix(in srgb, dt('rating.icon.color'), transparent 96%);
    box-shadow: 0 0 1px 8px color-mix(in srgb, dt('rating.icon.color'), transparent 96%);
}

.p-rating:not(.p-disabled):not(.p-readonly) .p-rating-option-active:hover {
    background: color-mix(in srgb, dt('rating.icon.active.color'), transparent 92%);
    box-shadow: 0 0 1px 8px color-mix(in srgb, dt('rating.icon.active.color'), transparent 92%);
}

.p-rating-option.p-focus-visible {
    background: color-mix(in srgb, dt('rating.icon.active.color'), transparent 84%);
    box-shadow: 0 0 1px 8px color-mix(in srgb, dt('rating.icon.active.color'), transparent 84%);
}
`, yh = { root: hh, icon: bh, css: vh }, kh = { light: { root: { background: "rgba(0,0,0,0.1)" } }, dark: { root: { background: "rgba(255,255,255,0.3)" } } }, wh = { colorScheme: kh, css: "" }, xh = { transitionDuration: "{transition.duration}" }, Ch = { size: "9px", borderRadius: "{border.radius.sm}", focusRing: { width: "{focus.ring.width}", style: "{focus.ring.style}", color: "{focus.ring.color}", offset: "{focus.ring.offset}", shadow: "{focus.ring.shadow}" } }, Sh = { light: { bar: { background: "{surface.200}" } }, dark: { bar: { background: "{surface.700}" } } }, $h = { root: xh, bar: Ch, colorScheme: Sh, css: "" }, Bh = { background: "{form.field.background}", disabledBackground: "{form.field.disabled.background}", filledBackground: "{form.field.filled.background}", filledHoverBackground: "{form.field.filled.hover.background}", filledFocusBackground: "{form.field.filled.focus.background}", borderColor: "{form.field.border.color}", hoverBorderColor: "{form.field.hover.border.color}", focusBorderColor: "{form.field.focus.border.color}", invalidBorderColor: "{form.field.invalid.border.color}", color: "{form.field.color}", disabledColor: "{form.field.disabled.color}", placeholderColor: "{form.field.placeholder.color}", invalidPlaceholderColor: "{form.field.invalid.placeholder.color}", shadow: "{form.field.shadow}", paddingX: "{form.field.padding.x}", paddingY: "{form.field.padding.y}", borderRadius: "{form.field.border.radius}", focusRing: { width: "{form.field.focus.ring.width}", style: "{form.field.focus.ring.style}", color: "{form.field.focus.ring.color}", offset: "{form.field.focus.ring.offset}", shadow: "{form.field.focus.ring.shadow}" }, transitionDuration: "{form.field.transition.duration}", sm: { fontSize: "{form.field.sm.font.size}", paddingX: "{form.field.sm.padding.x}", paddingY: "{form.field.sm.padding.y}" }, lg: { fontSize: "{form.field.lg.font.size}", paddingX: "{form.field.lg.padding.x}", paddingY: "{form.field.lg.padding.y}" } }, Th = { width: "2.5rem", color: "{form.field.icon.color}" }, Ih = { background: "{overlay.select.background}", borderColor: "{overlay.select.border.color}", borderRadius: "{overlay.select.border.radius}", color: "{overlay.select.color}", shadow: "{overlay.select.shadow}" }, Dh = { padding: "{list.padding}", gap: "{list.gap}", header: { padding: "{list.header.padding}" } }, Ph = { focusBackground: "{list.option.focus.background}", selectedBackground: "{list.option.selected.background}", selectedFocusBackground: "{list.option.selected.focus.background}", color: "{list.option.color}", focusColor: "{list.option.focus.color}", selectedColor: "{list.option.selected.color}", selectedFocusColor: "{list.option.selected.focus.color}", padding: "{list.option.padding}", borderRadius: "{list.option.border.radius}" }, zh = { background: "{list.option.group.background}", color: "{list.option.group.color}", fontWeight: "{list.option.group.font.weight}", padding: "{list.option.group.padding}" }, Lh = { color: "{form.field.icon.color}" }, Oh = { color: "{list.option.color}", gutterStart: "-0.375rem", gutterEnd: "0.375rem" }, Mh = { padding: "{list.option.padding}" }, Ah = `
.p-select.p-variant-filled {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    border: 1px solid transparent;
    background: dt('select.filled.background') no-repeat;
    background-image: linear-gradient(to bottom, dt('select.focus.border.color'), dt('select.focus.border.color')), linear-gradient(to bottom, dt('select.border.color'), dt('select.border.color'));
    background-size: 0 2px, 100% 1px;
    background-position: 50% 100%, 50% 100%;
    background-origin: border-box;
    transition: background-size 0.3s cubic-bezier(0.64, 0.09, 0.08, 1);
}

.p-select.p-variant-filled:not(.p-disabled):hover {
    background: dt('select.filled.hover.background') no-repeat;
    background-image: linear-gradient(to bottom, dt('select.focus.border.color'), dt('select.focus.border.color')), linear-gradient(to bottom, dt('select.hover.border.color'), dt('select.hover.border.color'));
    background-size: 0 2px, 100% 1px;
    background-position: 50% 100%, 50% 100%;
    background-origin: border-box;
    border-color: transparent;
}

.p-select.p-variant-filled:not(.p-disabled).p-focus {
    outline: 0 none;
    background: dt('select.filled.focus.background') no-repeat;
    background-image: linear-gradient(to bottom, dt('select.focus.border.color'), dt('select.focus.border.color')), linear-gradient(to bottom, dt('select.border.color'), dt('select.border.color'));
    background-size: 100% 2px, 100% 1px;
    background-position: 50% 100%, 50% 100%;
    background-origin: border-box;
    border-color: transparent;
}

.p-select.p-variant-filled:not(.p-disabled).p-focus:hover {
    background-image: linear-gradient(to bottom, dt('select.focus.border.color'), dt('select.focus.border.color')), linear-gradient(to bottom, dt('select.hover.border.color'), dt('select.hover.border.color'));
}

.p-select.p-variant-filled.p-invalid {
    background-image: linear-gradient(to bottom, dt('select.invalid.border.color'), dt('select.invalid.border.color')), linear-gradient(to bottom, dt('select.invalid.border.color'), dt('select.invalid.border.color'));
}

.p-select.p-variant-filled.p-invalid:not(.p-disabled).p-focus  {
    background-image: linear-gradient(to bottom, dt('select.invalid.border.color'), dt('select.invalid.border.color')), linear-gradient(to bottom, dt('select.invalid.border.color'), dt('select.invalid.border.color'));
}

.p-select-option {
    transition: none;
}
`, _h = { root: Bh, dropdown: Th, overlay: Ih, list: Dh, option: Ph, optionGroup: zh, clearIcon: Lh, checkmark: Oh, emptyMessage: Mh, css: Ah }, Fh = { borderRadius: "{form.field.border.radius}" }, Eh = { light: { root: { invalidBorderColor: "{form.field.invalid.border.color}" } }, dark: { root: { invalidBorderColor: "{form.field.invalid.border.color}" } } }, Rh = { root: Fh, colorScheme: Eh, css: "" }, Vh = { borderRadius: "{content.border.radius}" }, Nh = { light: { root: { background: "{surface.200}", animationBackground: "rgba(255,255,255,0.4)" } }, dark: { root: { background: "rgba(255, 255, 255, 0.06)", animationBackground: "rgba(255, 255, 255, 0.04)" } } }, jh = { root: Vh, colorScheme: Nh, css: "" }, Uh = { transitionDuration: "{transition.duration}" }, Hh = { background: "{content.border.color}", borderRadius: "{border.radius.xs}", size: "2px" }, Kh = { background: "{primary.color}" }, Wh = { width: "18px", height: "18px", borderRadius: "50%", background: "{primary.color}", hoverBackground: "{primary.color}", content: { borderRadius: "50%", background: "{primary.color}", hoverBackground: "{primary.color}", width: "18px", height: "18px", shadow: "0px 2px 1px -1px rgba(0, 0, 0, .2), 0px 1px 1px 0px rgba(0, 0, 0, .14), 0px 1px 3px 0px rgba(0, 0, 0, .12)" }, focusRing: { width: "0", style: "none", color: "unset", offset: "0", shadow: "none" } }, Yh = `
.p-slider-handle {
    transition: box-shadow dt('slider.transition.duration');
}

.p-slider:not(.p-disabled) .p-slider-handle:hover {
    box-shadow: 0 0 1px 10px color-mix(in srgb, dt('slider.handle.background'), transparent 92%);
}

.p-slider-handle:focus-visible,
.p-slider:not(.p-disabled) .p-slider-handle:focus:hover {
    box-shadow: 0 0 1px 10px color-mix(in srgb, dt('slider.handle.background'), transparent 84%);
}
`, Gh = { root: Uh, track: Hh, range: Kh, handle: Wh, css: Yh }, qh = { gap: "0.5rem", transitionDuration: "{transition.duration}" }, Zh = { root: qh, css: "" }, Xh = { borderRadius: "{form.field.border.radius}", roundedBorderRadius: "2rem", raisedShadow: "0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12)" }, Jh = { root: Xh, css: "" }, Qh = { background: "{content.background}", borderColor: "{content.border.color}", color: "{content.color}", transitionDuration: "{transition.duration}" }, eb = { background: "{content.border.color}" }, tb = { size: "24px", background: "transparent", borderRadius: "{content.border.radius}", focusRing: { width: "{focus.ring.width}", style: "{focus.ring.style}", color: "{focus.ring.color}", offset: "{focus.ring.offset}", shadow: "{focus.ring.shadow}" } }, nb = { root: Qh, gutter: eb, handle: tb, css: "" }, ob = { transitionDuration: "{transition.duration}" }, rb = { background: "{content.border.color}", activeBackground: "{primary.color}", margin: "0 0 0 1.625rem", size: "2px" }, ib = { padding: "0.5rem", gap: "1rem" }, ab = { padding: "0.75rem 1rem", borderRadius: "{content.border.radius}", focusRing: { width: "0", style: "none", color: "unset", offset: "0", shadow: "none" }, gap: "0.5rem" }, lb = { color: "{text.muted.color}", activeColor: "{text.color}", fontWeight: "500" }, sb = { activeBackground: "{primary.color}", activeBorderColor: "{primary.color}", activeColor: "{primary.contrast.color}", size: "2rem", fontSize: "1.143rem", fontWeight: "500", borderRadius: "50%", shadow: "none" }, db = { padding: "0.875rem 0.5rem 1.125rem 0.5rem" }, ub = { background: "{content.background}", color: "{content.color}", padding: "0", indent: "1rem" }, cb = { light: { stepNumber: { background: "{surface.400}", borderColor: "{surface.400}", color: "{surface.0}" } }, dark: { stepNumber: { background: "{surface.200}", borderColor: "{surface.200}", color: "{surface.900}" } } }, pb = `
.p-step-header:focus-visible {
    background: dt('navigation.item.active.background');
}
`, mb = { root: ob, separator: rb, step: ib, stepHeader: ab, stepTitle: lb, stepNumber: sb, steppanels: db, steppanel: ub, colorScheme: cb, css: pb }, fb = { transitionDuration: "{transition.duration}" }, gb = { background: "{content.border.color}" }, hb = { borderRadius: "{content.border.radius}", focusRing: { width: "{focus.ring.width}", style: "{focus.ring.style}", color: "{focus.ring.color}", offset: "{focus.ring.offset}", shadow: "{focus.ring.shadow}" }, gap: "0.5rem" }, bb = { color: "{text.muted.color}", activeColor: "{primary.color}", fontWeight: "500" }, vb = { background: "{content.background}", activeBackground: "{content.background}", borderColor: "{content.border.color}", activeBorderColor: "{content.border.color}", color: "{text.muted.color}", activeColor: "{primary.color}", size: "2rem", fontSize: "1.143rem", fontWeight: "500", borderRadius: "50%", shadow: "0px 0.5px 0px 0px rgba(0, 0, 0, 0.06), 0px 1px 1px 0px rgba(0, 0, 0, 0.12)" }, yb = { root: fb, separator: gb, itemLink: hb, itemLabel: bb, itemNumber: vb, css: "" }, kb = { transitionDuration: "{transition.duration}" }, wb = { borderWidth: "0 0 1px 0", background: "{content.background}", borderColor: "{content.border.color}" }, xb = { background: "transparent", hoverBackground: "transparent", activeBackground: "transparent", borderWidth: "0 0 1px 0", borderColor: "{content.border.color}", hoverBorderColor: "{content.border.color}", activeBorderColor: "{primary.color}", color: "{text.muted.color}", hoverColor: "{text.color}", activeColor: "{primary.color}", padding: "1rem 1.125rem", fontWeight: "600", margin: "0 0 -1px 0", gap: "0.5rem", focusRing: { width: "{focus.ring.width}", style: "{focus.ring.style}", color: "{focus.ring.color}", offset: "{focus.ring.offset}", shadow: "{focus.ring.shadow}" } }, Cb = { color: "{text.muted.color}", hoverColor: "{text.color}", activeColor: "{primary.color}" }, Sb = { height: "1px", bottom: "-1px", background: "{primary.color}" }, $b = { root: kb, tablist: wb, item: xb, itemIcon: Cb, activeBar: Sb, css: "" }, Bb = { transitionDuration: "{transition.duration}" }, Tb = { borderWidth: "0 0 1px 0", background: "{content.background}", borderColor: "{content.border.color}" }, Ib = { background: "transparent", hoverBackground: "{content.hover.background}", activeBackground: "transparent", borderWidth: "0 0 1px 0", borderColor: "{content.border.color}", hoverBorderColor: "{content.border.color}", activeBorderColor: "{primary.color}", color: "{text.color}", hoverColor: "{text.color}", activeColor: "{primary.color}", padding: "1rem 1.25rem", fontWeight: "600", margin: "0 0 -1px 0", gap: "0.5rem", focusRing: { width: "0", style: "none", color: "unset", offset: "0", shadow: "none" } }, Db = { background: "{content.background}", color: "{content.color}", padding: "1.25rem 1.25rem 1.25rem 1.25rem", focusRing: { width: "0", style: "none", color: "unset", offset: "0", shadow: "none" } }, Pb = { background: "{content.background}", color: "{text.muted.color}", hoverColor: "{text.color}", width: "3rem", shadow: "none", focusRing: { width: "0", style: "none", color: "unset", offset: "0", shadow: "none" } }, zb = { height: "2px", bottom: "-1px", background: "{primary.color}" }, Lb = `
.p-tabs-scrollable .p-tab {
    flex-grow: 0
}

.p-tab-active {
    --p-ripple-background: color-mix(in srgb, dt('primary.color'), transparent 90%);
}

.p-tab:not(.p-disabled):focus-visible {
    background: dt('navigation.item.active.background');
}

.p-tablist-nav-button:focus-visible {
    background: dt('navigation.item.active.background');
}
`, Ob = { root: Bb, tablist: Tb, tab: Ib, tabpanel: Db, navButton: Pb, activeBar: zb, css: Lb }, Mb = { transitionDuration: "{transition.duration}" }, Ab = { background: "{content.background}", borderColor: "{content.border.color}" }, _b = { borderColor: "{content.border.color}", activeBorderColor: "{primary.color}", color: "{text.muted.color}", hoverColor: "{text.color}", activeColor: "{primary.color}" }, Fb = { background: "{content.background}", color: "{content.color}" }, Eb = { background: "{content.background}", color: "{text.muted.color}", hoverColor: "{text.color}" }, Rb = { light: { navButton: { shadow: "0px 0px 10px 50px rgba(255, 255, 255, 0.6)" } }, dark: { navButton: { shadow: "0px 0px 10px 50px color-mix(in srgb, {content.background}, transparent 50%)" } } }, Vb = { root: Mb, tabList: Ab, tab: _b, tabPanel: Fb, navButton: Eb, colorScheme: Rb, css: "" }, Nb = { fontSize: "0.875rem", fontWeight: "700", padding: "0.25rem 0.5rem", gap: "0.25rem", borderRadius: "{content.border.radius}", roundedBorderRadius: "{border.radius.xl}" }, jb = { size: "0.75rem" }, Ub = { light: { primary: { background: "{primary.color}", color: "{primary.contrast.color}" }, secondary: { background: "{surface.100}", color: "{surface.600}" }, success: { background: "{green.500}", color: "{surface.0}" }, info: { background: "{sky.500}", color: "{surface.0}" }, warn: { background: "{orange.500}", color: "{surface.0}" }, danger: { background: "{red.500}", color: "{surface.0}" }, contrast: { background: "{surface.950}", color: "{surface.0}" } }, dark: { primary: { background: "{primary.color}", color: "{primary.contrast.color}" }, secondary: { background: "{surface.800}", color: "{surface.300}" }, success: { background: "{green.400}", color: "{green.950}" }, info: { background: "{sky.400}", color: "{sky.950}" }, warn: { background: "{orange.400}", color: "{orange.950}" }, danger: { background: "{red.400}", color: "{red.950}" }, contrast: { background: "{surface.0}", color: "{surface.950}" } } }, Hb = { root: Nb, icon: jb, colorScheme: Ub, css: "" }, Kb = { background: "{form.field.background}", borderColor: "{form.field.border.color}", color: "{form.field.color}", height: "18rem", padding: "{form.field.padding.y} {form.field.padding.x}", borderRadius: "{form.field.border.radius}" }, Wb = { gap: "0.25rem" }, Yb = { margin: "2px 0" }, Gb = { root: Kb, prompt: Wb, commandResponse: Yb, css: "" }, qb = { background: "{form.field.background}", disabledBackground: "{form.field.disabled.background}", filledBackground: "{form.field.filled.background}", filledHoverBackground: "{form.field.filled.hover.background}", filledFocusBackground: "{form.field.filled.focus.background}", borderColor: "{form.field.border.color}", hoverBorderColor: "{form.field.hover.border.color}", focusBorderColor: "{form.field.focus.border.color}", invalidBorderColor: "{form.field.invalid.border.color}", color: "{form.field.color}", disabledColor: "{form.field.disabled.color}", placeholderColor: "{form.field.placeholder.color}", invalidPlaceholderColor: "{form.field.invalid.placeholder.color}", shadow: "{form.field.shadow}", paddingX: "{form.field.padding.x}", paddingY: "{form.field.padding.y}", borderRadius: "{form.field.border.radius}", focusRing: { width: "{form.field.focus.ring.width}", style: "{form.field.focus.ring.style}", color: "{form.field.focus.ring.color}", offset: "{form.field.focus.ring.offset}", shadow: "{form.field.focus.ring.shadow}" }, transitionDuration: "{form.field.transition.duration}", sm: { fontSize: "{form.field.sm.font.size}", paddingX: "{form.field.sm.padding.x}", paddingY: "{form.field.sm.padding.y}" }, lg: { fontSize: "{form.field.lg.font.size}", paddingX: "{form.field.lg.padding.x}", paddingY: "{form.field.lg.padding.y}" } }, Zb = `
.p-textarea.p-variant-filled {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    border: 1px solid transparent;
    background: dt('textarea.filled.background') no-repeat;
    background-image: linear-gradient(to bottom, dt('textarea.focus.border.color'), dt('textarea.focus.border.color')), linear-gradient(to bottom, dt('textarea.border.color'), dt('textarea.border.color'));
    background-size: 0 2px, 100% 1px;
    background-position: 50% 100%, 50% 100%;
    background-origin: border-box;
    transition: background-size 0.3s cubic-bezier(0.64, 0.09, 0.08, 1);
}

.p-textarea.p-variant-filled:enabled:hover {
    background: dt('textarea.filled.hover.background') no-repeat;
    background-image: linear-gradient(to bottom, dt('textarea.focus.border.color'), dt('textarea.focus.border.color')), linear-gradient(to bottom, dt('textarea.hover.border.color'), dt('textarea.hover.border.color'));
    background-size: 0 2px, 100% 1px;
    background-position: 50% 100%, 50% 100%;
    background-origin: border-box;
    border-color: transparent;
}

.p-textarea.p-variant-filled:enabled:focus {
    outline: 0 none;
    background: dt('textarea.filled.focus.background') no-repeat;
    background-image: linear-gradient(to bottom, dt('textarea.focus.border.color'), dt('textarea.focus.border.color')), linear-gradient(to bottom, dt('textarea.border.color'), dt('textarea.border.color'));
    background-size: 100% 2px, 100% 1px;
    background-position: 50% 100%, 50% 100%;
    background-origin: border-box;
    border-color: transparent;
}

.p-textarea.p-variant-filled:enabled:hover:focus {
    background-image: linear-gradient(to bottom, dt('textarea.focus.border.color'), dt('textarea.focus.border.color')), linear-gradient(to bottom, dt('textarea.hover.border.color'), dt('textarea.hover.border.color'));
}

.p-textarea.p-variant-filled.p-invalid {
    background-image: linear-gradient(to bottom, dt('textarea.invalid.border.color'), dt('textarea.invalid.border.color')), linear-gradient(to bottom, dt('textarea.invalid.border.color'), dt('textarea.invalid.border.color'));
}

.p-textarea.p-variant-filled.p-invalid:enabled:focus {
    background-image: linear-gradient(to bottom, dt('textarea.invalid.border.color'), dt('textarea.invalid.border.color')), linear-gradient(to bottom, dt('textarea.invalid.border.color'), dt('textarea.invalid.border.color'));
}
`, Xb = { root: qb, css: Zb }, Jb = { background: "{content.background}", borderColor: "{content.border.color}", color: "{content.color}", borderRadius: "{content.border.radius}", shadow: "{overlay.navigation.shadow}", transitionDuration: "{transition.duration}" }, Qb = { padding: "{navigation.list.padding}", gap: "{navigation.list.gap}" }, ev = { focusBackground: "{navigation.item.focus.background}", activeBackground: "{navigation.item.active.background}", color: "{navigation.item.color}", focusColor: "{navigation.item.focus.color}", activeColor: "{navigation.item.active.color}", padding: "{navigation.item.padding}", borderRadius: "{navigation.item.border.radius}", gap: "{navigation.item.gap}", icon: { color: "{navigation.item.icon.color}", focusColor: "{navigation.item.icon.focus.color}", activeColor: "{navigation.item.icon.active.color}" } }, tv = { mobileIndent: "1rem" }, nv = { size: "{navigation.submenu.icon.size}", color: "{navigation.submenu.icon.color}", focusColor: "{navigation.submenu.icon.focus.color}", activeColor: "{navigation.submenu.icon.active.color}" }, ov = { borderColor: "{content.border.color}" }, rv = `
.p-tieredmenu-overlay {
    border-color: transparent;
}
`, iv = { root: Jb, list: Qb, item: ev, submenu: tv, submenuIcon: nv, separator: ov, css: rv }, av = { minHeight: "5rem" }, lv = { eventContent: { padding: "1rem 0" } }, sv = { eventContent: { padding: "0 1rem" } }, dv = { size: "1.5rem", borderRadius: "50%", borderWidth: "2px", background: "{primary.color}", content: { borderRadius: "50%", size: "0", background: "{primary.color}", insetShadow: "none" } }, uv = { color: "{content.border.color}", size: "2px" }, cv = { light: { eventMarker: { borderColor: "{surface.0}" } }, dark: { eventMarker: { borderColor: "{surface.900}" } } }, pv = { event: av, horizontal: lv, vertical: sv, eventMarker: dv, eventConnector: uv, colorScheme: cv, css: "" }, mv = { width: "25rem", borderRadius: "{content.border.radius}", borderWidth: "0", transitionDuration: "{transition.duration}" }, fv = { size: "1.25rem" }, gv = { padding: "{overlay.popover.padding}", gap: "0.5rem" }, hv = { gap: "0.5rem" }, bv = { fontWeight: "500", fontSize: "1rem" }, vv = { fontWeight: "500", fontSize: "0.875rem" }, yv = { width: "2rem", height: "2rem", borderRadius: "50%", focusRing: { width: "{focus.ring.width}", style: "{focus.ring.style}", offset: "{focus.ring.offset}" } }, kv = { size: "1rem" }, wv = { light: { root: { blur: "0" }, info: { background: "{blue.50}", borderColor: "{blue.200}", color: "{blue.600}", detailColor: "{surface.700}", shadow: "0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12)", closeButton: { hoverBackground: "{blue.100}", focusRing: { color: "{blue.600}", shadow: "none" } } }, success: { background: "{green.50}", borderColor: "{green.200}", color: "{green.600}", detailColor: "{surface.700}", shadow: "0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12)", closeButton: { hoverBackground: "{green.100}", focusRing: { color: "{green.600}", shadow: "none" } } }, warn: { background: "{yellow.50}", borderColor: "{yellow.200}", color: "{yellow.900}", detailColor: "{surface.700}", shadow: "0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12)", closeButton: { hoverBackground: "{yellow.100}", focusRing: { color: "{yellow.600}", shadow: "none" } } }, error: { background: "{red.50}", borderColor: "{red.200}", color: "{red.600}", detailColor: "{surface.700}", shadow: "0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12)", closeButton: { hoverBackground: "{red.100}", focusRing: { color: "{red.600}", shadow: "none" } } }, secondary: { background: "{surface.100}", borderColor: "{surface.200}", color: "{surface.600}", detailColor: "{surface.700}", shadow: "0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12)", closeButton: { hoverBackground: "{surface.200}", focusRing: { color: "{surface.600}", shadow: "none" } } }, contrast: { background: "{surface.900}", borderColor: "{surface.950}", color: "{surface.50}", detailColor: "{surface.0}", shadow: "0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12)", closeButton: { hoverBackground: "{surface.800}", focusRing: { color: "{surface.50}", shadow: "none" } } } }, dark: { root: { blur: "10px" }, info: { background: "color-mix(in srgb, {blue.500}, transparent 36%)", borderColor: "color-mix(in srgb, {blue.700}, transparent 64%)", color: "{surface.0}", detailColor: "{blue.100}", shadow: "0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12)", closeButton: { hoverBackground: "rgba(255, 255, 255, 0.05)", focusRing: { color: "{blue.500}", shadow: "none" } } }, success: { background: "color-mix(in srgb, {green.500}, transparent 36%)", borderColor: "color-mix(in srgb, {green.700}, transparent 64%)", color: "{surface.0}", detailColor: "{green.100}", shadow: "0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12)", closeButton: { hoverBackground: "rgba(255, 255, 255, 0.05)", focusRing: { color: "{green.500}", shadow: "none" } } }, warn: { background: "color-mix(in srgb, {yellow.500}, transparent 36%)", borderColor: "color-mix(in srgb, {yellow.700}, transparent 64%)", color: "{surface.0}", detailColor: "{yellow.50}", shadow: "0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12)", closeButton: { hoverBackground: "rgba(255, 255, 255, 0.05)", focusRing: { color: "{yellow.500}", shadow: "none" } } }, error: { background: "color-mix(in srgb, {red.500}, transparent 36%)", borderColor: "color-mix(in srgb, {red.700}, transparent 64%)", color: "{surface.0}", detailColor: "{red.100}", shadow: "0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12)", closeButton: { hoverBackground: "rgba(255, 255, 255, 0.05)", focusRing: { color: "{red.500}", shadow: "none" } } }, secondary: { background: "{surface.800}", borderColor: "{surface.700}", color: "{surface.300}", detailColor: "{surface.0}", shadow: "0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12)", closeButton: { hoverBackground: "{surface.700}", focusRing: { color: "{surface.300}", shadow: "none" } } }, contrast: { background: "{surface.0}", borderColor: "{surface.100}", color: "{surface.950}", detailColor: "{surface.950}", shadow: "0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12)", closeButton: { hoverBackground: "{surface.100}", focusRing: { color: "{surface.950}", shadow: "none" } } } } }, xv = { root: mv, icon: fv, content: gv, text: hv, summary: bv, detail: vv, closeButton: yv, closeIcon: kv, colorScheme: wv, css: "" }, Cv = { padding: "0.75rem 1rem", borderRadius: "{form.field.border.radius}", gap: "0.5rem", fontWeight: "500", background: "{form.field.background}", borderColor: "{form.field.border.color}", color: "{form.field.color}", hoverColor: "{form.field.color}", checkedColor: "{form.field.color}", checkedBorderColor: "{form.field.border.color}", disabledBackground: "{form.field.disabled.background}", disabledBorderColor: "{form.field.disabled.background}", disabledColor: "{form.field.disabled.color}", invalidBorderColor: "{form.field.invalid.border.color}", focusRing: { width: "0", style: "none", offset: "0", color: "unset", shadow: "none" }, transitionDuration: "{form.field.transition.duration}", sm: { fontSize: "{form.field.sm.font.size}", padding: "0.625rem 0.75rem" }, lg: { fontSize: "{form.field.lg.font.size}", padding: "0.875rem 1.25rem" } }, Sv = { color: "{text.muted.color}", hoverColor: "{text.muted.color}", checkedColor: "{text.muted.color}", disabledColor: "{form.field.disabled.color}" }, $v = { checkedBackground: "transparent", checkedShadow: "none", padding: "0", borderRadius: "0", sm: { padding: "0" }, lg: { padding: "0" } }, Bv = { light: { root: { hoverBackground: "{surface.100}", checkedBackground: "{surface.200}" } }, dark: { root: { hoverBackground: "{surface.800}", checkedBackground: "{surface.700}" } } }, Tv = `
.p-togglebutton:focus-visible {
    background: dt('togglebutton.hover.background');
}
`, Iv = { root: Cv, icon: Sv, content: $v, colorScheme: Bv, css: Tv }, Dv = { width: "2.75rem", height: "1rem", borderRadius: "30px", gap: "0px", shadow: "none", focusRing: { width: "0", style: "none", color: "unset", offset: "0", shadow: "none" }, borderWidth: "1px", borderColor: "transparent", hoverBorderColor: "transparent", checkedBorderColor: "transparent", checkedHoverBorderColor: "transparent", invalidBorderColor: "{form.field.invalid.border.color}", transitionDuration: "{form.field.transition.duration}", slideDuration: "0.2s" }, Pv = { borderRadius: "50%", size: "1.5rem" }, zv = { light: { root: { background: "{surface.300}", disabledBackground: "{surface.400}", hoverBackground: "{surface.300}", checkedBackground: "{primary.200}", checkedHoverBackground: "{primary.200}" }, handle: { background: "{surface.0}", disabledBackground: "{surface.200}", hoverBackground: "{surface.0}", checkedBackground: "{primary.color}", checkedHoverBackground: "{primary.color}", color: "{text.muted.color}", hoverColor: "{text.color}", checkedColor: "{primary.contrast.color}", checkedHoverColor: "{primary.contrast.color}" } }, dark: { root: { background: "{surface.700}", disabledBackground: "{surface.600}", hoverBackground: "{surface.700}", checkedBackground: "{primary.color}", checkedHoverBackground: "{primary.color}" }, handle: { background: "{surface.400}", disabledBackground: "{surface.500}", hoverBackground: "{surface.300}", checkedBackground: "{primary.200}", checkedHoverBackground: "{primary.200}", color: "{surface.800}", hoverColor: "{surface.900}", checkedColor: "{primary.contrast.color}", checkedHoverColor: "{primary.contrast.color}" } } }, Lv = `
.p-toggleswitch-handle {
    box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
}

.p-toggleswitch:not(.p-disabled):has(.p-toggleswitch-input:hover) .p-toggleswitch-handle {
    box-shadow: 0 0 1px 10px color-mix(in srgb, dt('text.color'), transparent 96%), 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
}

.p-toggleswitch:not(.p-disabled):has(.p-toggleswitch-input:focus-visible) .p-toggleswitch-handle {
    box-shadow: 0 0 1px 10px color-mix(in srgb, dt('text.color'), transparent 88%), 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
}

.p-toggleswitch:not(.p-disabled):has(.p-toggleswitch-input:hover).p-toggleswitch-checked .p-toggleswitch-handle {
    box-shadow: 0 0 1px 10px color-mix(in srgb, dt('toggleswitch.handle.checked.background'), transparent 92%), 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
}

.p-toggleswitch:not(.p-disabled):has(.p-toggleswitch-input:focus-visible).p-toggleswitch-checked .p-toggleswitch-handle {
    box-shadow: 0 0 1px 10px color-mix(in srgb, dt('toggleswitch.handle.checked.background'), transparent 84%), 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
}
`, Ov = { root: Dv, handle: Pv, colorScheme: zv, css: Lv }, Mv = { color: "{content.color}", borderRadius: "{content.border.radius}", gap: "0.5rem", padding: "1rem" }, Av = { light: { root: { background: "{surface.100}", borderColor: "{surface.100}" } }, dark: { root: { background: "{surface.800}", borderColor: "{surface.800}" } } }, _v = { root: Mv, colorScheme: Av, css: "" }, Fv = { background: "{surface.600}", color: "{surface.0}", maxWidth: "12.5rem", gutter: "0.25rem", shadow: "{overlay.popover.shadow}", padding: "0.5rem 0.75rem", borderRadius: "{overlay.popover.border.radius}" }, Ev = { root: Fv, css: "" }, Rv = { background: "{content.background}", color: "{content.color}", padding: "1rem", gap: "2px", indent: "2rem", transitionDuration: "{transition.duration}" }, Vv = { padding: "0.5rem 0.75rem", borderRadius: "{border.radius.xs}", hoverBackground: "{content.hover.background}", selectedBackground: "{highlight.background}", color: "{text.color}", hoverColor: "{text.hover.color}", selectedColor: "{highlight.color}", focusRing: { width: "{focus.ring.width}", style: "{focus.ring.style}", color: "{focus.ring.color}", offset: "-1px", shadow: "{focus.ring.shadow}" }, gap: "0.5rem" }, Nv = { color: "{text.muted.color}", hoverColor: "{text.hover.muted.color}", selectedColor: "{highlight.color}" }, jv = { borderRadius: "50%", size: "2rem", hoverBackground: "{content.hover.background}", selectedHoverBackground: "{content.background}", color: "{text.muted.color}", hoverColor: "{text.hover.muted.color}", selectedHoverColor: "{primary.color}", focusRing: { width: "{focus.ring.width}", style: "{focus.ring.style}", color: "{focus.ring.color}", offset: "{focus.ring.offset}", shadow: "{focus.ring.shadow}" } }, Uv = { size: "2rem" }, Hv = { margin: "0 0 0.75rem 0" }, Kv = `
.p-tree-node-content {
    transition: none;
}
`, Wv = { root: Rv, node: Vv, nodeIcon: Nv, nodeToggleButton: jv, loadingIcon: Uv, filter: Hv, css: Kv }, Yv = { background: "{form.field.background}", disabledBackground: "{form.field.disabled.background}", filledBackground: "{form.field.filled.background}", filledHoverBackground: "{form.field.filled.hover.background}", filledFocusBackground: "{form.field.filled.focus.background}", borderColor: "{form.field.border.color}", hoverBorderColor: "{form.field.hover.border.color}", focusBorderColor: "{form.field.focus.border.color}", invalidBorderColor: "{form.field.invalid.border.color}", color: "{form.field.color}", disabledColor: "{form.field.disabled.color}", placeholderColor: "{form.field.placeholder.color}", invalidPlaceholderColor: "{form.field.invalid.placeholder.color}", shadow: "{form.field.shadow}", paddingX: "{form.field.padding.x}", paddingY: "{form.field.padding.y}", borderRadius: "{form.field.border.radius}", focusRing: { width: "{form.field.focus.ring.width}", style: "{form.field.focus.ring.style}", color: "{form.field.focus.ring.color}", offset: "{form.field.focus.ring.offset}", shadow: "{form.field.focus.ring.shadow}" }, transitionDuration: "{form.field.transition.duration}", sm: { fontSize: "{form.field.sm.font.size}", paddingX: "{form.field.sm.padding.x}", paddingY: "{form.field.sm.padding.y}" }, lg: { fontSize: "{form.field.lg.font.size}", paddingX: "{form.field.lg.padding.x}", paddingY: "{form.field.lg.padding.y}" } }, Gv = { width: "2.5rem", color: "{form.field.icon.color}" }, qv = { background: "{overlay.select.background}", borderColor: "{overlay.select.border.color}", borderRadius: "{overlay.select.border.radius}", color: "{overlay.select.color}", shadow: "{overlay.select.shadow}" }, Zv = { padding: "{list.padding}" }, Xv = { padding: "{list.option.padding}" }, Jv = { borderRadius: "{border.radius.sm}" }, Qv = { color: "{form.field.icon.color}" }, e0 = `
.p-treeselect.p-variant-filled {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    border: 1px solid transparent;
    background: dt('treeselect.filled.background') no-repeat;
    background-image: linear-gradient(to bottom, dt('treeselect.focus.border.color'), dt('treeselect.focus.border.color')), linear-gradient(to bottom, dt('treeselect.border.color'), dt('treeselect.border.color'));
    background-size: 0 2px, 100% 1px;
    background-position: 50% 100%, 50% 100%;
    background-origin: border-box;
    transition: background-size 0.3s cubic-bezier(0.64, 0.09, 0.08, 1);
}

.p-treeselect.p-variant-filled:not(.p-disabled):hover {
    background: dt('treeselect.filled.hover.background') no-repeat;
    background-image: linear-gradient(to bottom, dt('treeselect.focus.border.color'), dt('treeselect.focus.border.color')), linear-gradient(to bottom, dt('treeselect.hover.border.color'), dt('treeselect.hover.border.color'));
    background-size: 0 2px, 100% 1px;
    background-position: 50% 100%, 50% 100%;
    background-origin: border-box;
    border-color: transparent;
}

.p-treeselect.p-variant-filled:not(.p-disabled).p-focus {
    outline: 0 none;
    background: dt('treeselect.filled.focus.background') no-repeat;
    background-image: linear-gradient(to bottom, dt('treeselect.focus.border.color'), dt('treeselect.focus.border.color')), linear-gradient(to bottom, dt('treeselect.border.color'), dt('treeselect.border.color'));
    background-size: 100% 2px, 100% 1px;
    background-position: 50% 100%, 50% 100%;
    background-origin: border-box;
    border-color: transparent;
}

.p-treeselect.p-variant-filled:not(.p-disabled).p-focus:hover {
    background-image: linear-gradient(to bottom, dt('treeselect.focus.border.color'), dt('treeselect.focus.border.color')), linear-gradient(to bottom, dt('treeselect.hover.border.color'), dt('treeselect.hover.border.color'));
}

.p-treeselect.p-variant-filled.p-invalid {
    background-image: linear-gradient(to bottom, dt('treeselect.invalid.border.color'), dt('treeselect.invalid.border.color')), linear-gradient(to bottom, dt('treeselect.invalid.border.color'), dt('treeselect.invalid.border.color'));
}

.p-treeselect.p-variant-filled.p-invalid:not(.p-disabled).p-focus  {
    background-image: linear-gradient(to bottom, dt('treeselect.invalid.border.color'), dt('treeselect.invalid.border.color')), linear-gradient(to bottom, dt('treeselect.invalid.border.color'), dt('treeselect.invalid.border.color'));
}
`, t0 = { root: Yv, dropdown: Gv, overlay: qv, tree: Zv, emptyMessage: Xv, chip: Jv, clearIcon: Qv, css: e0 }, n0 = { transitionDuration: "{transition.duration}" }, o0 = { background: "{content.background}", borderColor: "{treetable.border.color}", color: "{content.color}", borderWidth: "0 0 1px 0", padding: "0.75rem 1rem" }, r0 = { background: "{content.background}", hoverBackground: "{content.hover.background}", selectedBackground: "{highlight.background}", borderColor: "{treetable.border.color}", color: "{content.color}", hoverColor: "{content.hover.color}", selectedColor: "{highlight.color}", gap: "0.5rem", padding: "0.75rem 1rem", focusRing: { width: "{focus.ring.width}", style: "{focus.ring.style}", color: "{focus.ring.color}", offset: "-1px", shadow: "{focus.ring.shadow}" } }, i0 = { fontWeight: "600" }, a0 = { background: "{content.background}", hoverBackground: "{content.hover.background}", selectedBackground: "{highlight.background}", color: "{content.color}", hoverColor: "{content.hover.color}", selectedColor: "{highlight.color}", focusRing: { width: "{focus.ring.width}", style: "{focus.ring.style}", color: "{focus.ring.color}", offset: "-1px", shadow: "{focus.ring.shadow}" } }, l0 = { borderColor: "{treetable.border.color}", padding: "0.75rem 1rem", gap: "0.5rem" }, s0 = { background: "{content.background}", borderColor: "{treetable.border.color}", color: "{content.color}", padding: "0.75rem 1rem" }, d0 = { fontWeight: "600" }, u0 = { background: "{content.background}", borderColor: "{treetable.border.color}", color: "{content.color}", borderWidth: "0 0 1px 0", padding: "0.75rem 1rem" }, c0 = { width: "0.5rem" }, p0 = { width: "1px", color: "{primary.color}" }, m0 = { color: "{text.muted.color}", hoverColor: "{text.hover.muted.color}", size: "0.875rem" }, f0 = { size: "2rem" }, g0 = { hoverBackground: "{content.hover.background}", selectedHoverBackground: "{content.background}", color: "{text.muted.color}", hoverColor: "{text.color}", selectedHoverColor: "{primary.color}", size: "1.75rem", borderRadius: "50%", focusRing: { width: "{focus.ring.width}", style: "{focus.ring.style}", color: "{focus.ring.color}", offset: "{focus.ring.offset}", shadow: "{focus.ring.shadow}" } }, h0 = { borderColor: "{content.border.color}", borderWidth: "0 0 1px 0" }, b0 = { borderColor: "{content.border.color}", borderWidth: "0 0 1px 0" }, v0 = { light: { root: { borderColor: "{content.border.color}" }, bodyCell: { selectedBorderColor: "{primary.100}" } }, dark: { root: { borderColor: "{surface.800}" }, bodyCell: { selectedBorderColor: "{primary.900}" } } }, y0 = { root: n0, header: o0, headerCell: r0, columnTitle: i0, row: a0, bodyCell: l0, footerCell: s0, columnFooter: d0, footer: u0, columnResizer: c0, resizeIndicator: p0, sortIcon: m0, loadingIcon: f0, nodeToggleButton: g0, paginatorTop: h0, paginatorBottom: b0, colorScheme: v0 }, k0 = { mask: { background: "{content.background}", color: "{text.muted.color}" }, icon: { size: "2rem" } }, w0 = { loader: k0, css: "" }, x0 = Object.defineProperty, C0 = Object.defineProperties, S0 = Object.getOwnPropertyDescriptors, _i = Object.getOwnPropertySymbols, $0 = Object.prototype.hasOwnProperty, B0 = Object.prototype.propertyIsEnumerable, Fi = (e, t, n) => t in e ? x0(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, Ei, T0 = (Ei = ((e, t) => {
  for (var n in t || (t = {})) $0.call(t, n) && Fi(e, n, t[n]);
  if (_i) for (var n of _i(t)) B0.call(t, n) && Fi(e, n, t[n]);
  return e;
})({}, cu), C0(Ei, S0({ components: { accordion: Ed, autocomplete: qd, avatar: tu, badge: su, blockui: mu, breadcrumb: bu, button: wu, datepicker: mp, card: Tu, carousel: Mu, cascadeselect: ju, checkbox: Wu, chip: Ju, colorpicker: oc, confirmdialog: ac, confirmpopup: cc, contextmenu: vc, dataview: Wc, datatable: Rc, dialog: yp, divider: Sp, dock: Tp, drawer: Op, editor: Vp, fieldset: Wp, fileupload: em, iftalabel: $m, floatlabel: im, galleria: km, iconfield: xm, image: Pm, imagecompare: Lm, inlinemessage: Fm, inplace: Vm, inputchips: Hm, inputgroup: Ym, inputnumber: Jm, inputotp: tf, inputtext: rf, knob: uf, listbox: yf, megamenu: Pf, menu: Ff, menubar: Kf, message: tg, metergroup: sg, multiselect: yg, orderlist: xg, organizationchart: Tg, overlaybadge: Dg, popover: ah, paginator: Mg, password: eh, panel: Ng, panelmenu: Gg, picklist: oh, progressbar: uh, progressspinner: ph, radiobutton: gh, rating: yh, ripple: wh, scrollpanel: $h, select: _h, selectbutton: Rh, skeleton: jh, slider: Gh, speeddial: Zh, splitter: nb, splitbutton: Jh, stepper: mb, steps: yb, tabmenu: $b, tabs: Ob, tabview: Vb, textarea: Xb, tieredmenu: iv, tag: Hb, terminal: Gb, timeline: pv, togglebutton: Iv, toggleswitch: Ov, tree: Wv, treeselect: t0, treetable: y0, toast: xv, toolbar: _v, tooltip: Ev, virtualscroller: w0 } }))), I0 = (...e) => Gs(...e);
const cr = {
  0: "#ffffff",
  50: "{indigo.50}",
  100: "{indigo.100}",
  200: "{indigo.200}",
  300: "{indigo.300}",
  400: "{indigo.400}",
  500: "{indigo.500}",
  600: "{indigo.600}",
  700: "{indigo.700}",
  800: "{indigo.800}",
  900: "{indigo.900}",
  950: "{indigo.950}"
}, D0 = {
  0: "#ffffff",
  50: "{blue.50}",
  100: "{blue.100}",
  200: "{blue.200}",
  300: "{blue.300}",
  400: "{blue.400}",
  500: "{blue.500}",
  600: "{blue.600}",
  700: "{blue.700}",
  800: "{blue.800}",
  900: "{blue.900}",
  950: "{blue.950}"
}, P0 = {
  0: "#ffffff",
  50: "{teal.50}",
  100: "{teal.100}",
  200: "{teal.200}",
  300: "{teal.300}",
  400: "{teal.400}",
  500: "{teal.500}",
  600: "{teal.600}",
  700: "{teal.700}",
  800: "{teal.800}",
  900: "{teal.900}",
  950: "{teal.950}"
};
function z0(e) {
  if (!e) return cr;
  const t = od(e);
  return typeof t == "string" || !t ? cr : { 0: "#ffffff", ...t };
}
function Ga(e = cr) {
  return I0(T0, {
    semantic: {
      colorScheme: {
        light: {
          primary: e,
          secondary: D0,
          accent: P0
        }
      }
    },
    components: {
      progressspinner: {
        colorScheme: {
          light: {
            root: {
              colorOne: e[400],
              colorTwo: e[400],
              colorThree: e[600],
              colorFour: e[800]
            }
          }
        }
      }
    }
  });
}
const L0 = /* @__PURE__ */ Ga();
function st(e) {
  return e ? e.replace(/_/g, "-") : "en";
}
function O0(e, t = 1) {
  const n = st(e), o = new Intl.DateTimeFormat(n, { weekday: "long" }), i = new Intl.DateTimeFormat(n, { weekday: "short" }), r = new Intl.DateTimeFormat(n, { weekday: "narrow" }), a = [], d = [], l = [], u = new Date(Date.UTC(2024, 0, 7));
  for (let b = 0; b < 7; b++) {
    const k = new Date(u);
    k.setUTCDate(k.getUTCDate() + b), a.push(o.format(k)), d.push(i.format(k)), l.push(r.format(k));
  }
  const s = new Intl.DateTimeFormat(n, { month: "long" }), c = new Intl.DateTimeFormat(n, { month: "short" }), p = [], f = [];
  for (let b = 0; b < 12; b++) {
    const k = new Date(Date.UTC(2024, b, 15));
    p.push(s.format(k)), f.push(c.format(k));
  }
  return {
    dayNames: a,
    dayNamesShort: d,
    dayNamesMin: l,
    monthNames: p,
    monthNamesShort: f,
    firstDayOfWeek: t
  };
}
function bn(e, t) {
  const n = st(t);
  return new Intl.DateTimeFormat(n, {
    weekday: "long",
    day: "numeric",
    month: "numeric",
    year: "numeric"
  }).format(e);
}
function qa(e, t, n) {
  const o = st(n), i = (u) => String(u).padStart(2, "0"), r = (u) => new Intl.DateTimeFormat(o, u).format(e), a = () => e.getHours() % 12 || 12, d = {
    d: () => i(e.getDate()),
    j: () => String(e.getDate()),
    D: () => r({ weekday: "short" }),
    l: () => r({ weekday: "long" }),
    N: () => String(e.getDay() || 7),
    w: () => String(e.getDay()),
    m: () => i(e.getMonth() + 1),
    n: () => String(e.getMonth() + 1),
    M: () => r({ month: "short" }),
    F: () => r({ month: "long" }),
    y: () => i(e.getFullYear() % 100),
    Y: () => String(e.getFullYear()),
    G: () => String(e.getHours()),
    H: () => i(e.getHours()),
    g: () => String(a()),
    h: () => i(a()),
    i: () => i(e.getMinutes()),
    s: () => i(e.getSeconds()),
    A: () => e.getHours() < 12 ? "AM" : "PM",
    a: () => e.getHours() < 12 ? "a.m." : "p.m."
  };
  let l = "";
  for (let u = 0; u < t.length; u++) {
    const s = t[u];
    if (s === "\\" && u + 1 < t.length) {
      l += t[++u];
      continue;
    }
    l += d[s] ? d[s]() : s;
  }
  return l;
}
function M0(e, t, n) {
  const o = e.match(/^(\d{1,2}):(\d{2})(?::(\d{2}))?/);
  if (!o) return e;
  const i = new Date(2e3, 0, 1, Number(o[1]), Number(o[2]), Number(o[3] ?? 0));
  return qa(i, t, n);
}
function Ri(e) {
  if (!e) return null;
  const t = /^-?\d+(?:\.(\d+))?$/.exec(e.trim());
  return t ? t[1]?.length ?? 0 : null;
}
function en(e, t) {
  if (!Number.isFinite(e)) return e;
  const n = t ?? 2, o = Math.abs(e);
  let i = +`${o}e${n}`;
  Number.isNaN(i) && (i = o * 10 ** n);
  const r = Math.round(i) / 10 ** n;
  return e < 0 ? -r : r;
}
function Za(e, t) {
  return Number.isInteger(e) ? String(e) : e.toFixed(t ?? 2);
}
function A0(e) {
  try {
    return new Intl.NumberFormat("en", { style: "currency", currency: e }).resolvedOptions().maximumFractionDigits ?? 2;
  } catch {
    return 2;
  }
}
function To(e, t) {
  if (!e) return "";
  try {
    return new Intl.NumberFormat(st(t), {
      style: "currency",
      currency: e,
      currencyDisplay: "narrowSymbol"
    }).formatToParts(0).find((o) => o.type === "currency")?.value ?? e;
  } catch {
    return e;
  }
}
function _t(e, t = {}) {
  const n = (t.code || "").toUpperCase(), o = t.decimals ?? (n ? A0(n) : 2), i = new Intl.NumberFormat(st(t.lang), {
    minimumFractionDigits: o,
    maximumFractionDigits: o
  }).format(e), r = t.unit && t.unit.toUpperCase() !== n ? t.unit : n ? To(n, t.lang) : t.unit ?? "";
  return r ? `${i} ${r}` : i;
}
const _n = "mancub-form-", ye = globalThis.__mancub_empty_field__ ??= Symbol("empty-field");
globalThis.__mancub_empty_field__ = ye;
function Xa(e = "default") {
  const t = ce(_n + e, null), n = t || Do({
    fields: {},
    initialValues: {},
    valid: {},
    messages: {}
  }), o = v(() => {
    for (const d in n.valid)
      if (n.valid[d] !== void 0 && n.valid[d] !== !0)
        return !1;
    return !0;
  });
  t || mn(_n + e, n);
  function i() {
    for (const d in n.fields) {
      const l = n.initialValues[d];
      typeof l == "function" ? n.fields[d] = l() : n.fields[d] = l;
    }
  }
  function r(d, l, u = !0) {
    if (d in n) {
      console.warn(`Field "${d}" already exists in form "${e}".`);
      return;
    }
    let s;
    l && typeof l == "function" ? s = l() : s = l, s === void 0 && (s = ye), u && (n.fields[d] = s), l && typeof l == "function" ? n.initialValues[d] = l : n.initialValues[d] = s;
  }
  return { formState: n, resetForm: i, addField: r, isValid: o, validate: () => {
    document.dispatchEvent(new CustomEvent(_n + e + "-validate"));
  } };
}
const pr = (e = "default") => _n + e + "-validate", _0 = (e = "default") => {
  document.dispatchEvent(new CustomEvent(pr(e)));
}, F0 = (e) => e === ye ? "This field is required" : !0, Vi = ({ attribute_values: e, operator: t, attribute_ident: n }, o) => {
  const i = o[n];
  switch (t) {
    case "=":
      return e === i;
    case "!=":
      return e !== i;
    case "in":
      return Array.isArray(e) && e.some((r) => r === i);
    case "not in":
      return Array.isArray(e) && !e.some((r) => r === i);
    case ">":
      return typeof i == "number" && typeof e == "number" && i > e;
    case "<":
      return typeof i == "number" && typeof e == "number" && i < e;
    case ">=":
      return typeof i == "number" && typeof e == "number" && i >= e;
    case "<=":
      return typeof i == "number" && typeof e == "number" && i <= e;
    default:
      return !0;
  }
}, E0 = (e, t) => {
  const n = t?.conditions;
  return !n || n.length === 0 ? !0 : t?.conditions_logic === "or" ? n.some((o) => Vi(o, e)) : n.every((o) => Vi(o, e));
};
function Sn(e, t, n, o = "default", i = [
  F0
], r, a = {
  autoValidate: !0
}) {
  const d = Xa(o), l = W(n !== void 0 ? n : ye), u = W([]), s = v(() => c.value && u.value.length === 0), c = v(() => E0(d.formState.fields, r));
  te([l, c], ([f, b]) => {
    b ? d.formState.fields[t] = f : delete d.formState.fields[t];
  }), d.addField(t, n, c.value);
  const p = () => {
    const f = /* @__PURE__ */ new Set();
    for (const b of i) {
      const k = b(l.value);
      k !== !0 && f.add(typeof k == "string" ? k : "Invalid value");
    }
    u.value = [...f], c.value && (d.formState.valid[t] = f.size === 0);
  };
  return te(e, () => {
    e.value && Object.prototype.hasOwnProperty.call(e.value, "classList") && e.value.classList.add("form-field");
  }), te([s, c], () => {
    c.value ? d.formState.valid[t] = s.value : delete d.formState.valid[t];
  }), a.autoValidate && te(l, () => {
    p();
  }), Er(() => {
    document.addEventListener(pr(o), p);
  }), Sa(() => {
    document.removeEventListener(pr(o), p);
  }), c.value && (d.formState.valid[t] = (() => {
    for (const f of i)
      if (f(l.value) !== !0) return !1;
    return !0;
  })()), {
    id: _n + o + "-" + t,
    model: l,
    errors: u,
    messages: v(() => d.formState.messages[t] || []),
    isValid: s,
    isVisible: c,
    validate: p
  };
}
const Ja = "mancub-price-";
function tn(e, t) {
  if (!e) return { amount: null, display: "", unit: "", code: "", decimals: null };
  const n = (t || "").toUpperCase(), o = (e.currency || "").toUpperCase(), i = e.amounts_by_currency || {};
  if (n && n !== o && i[n] != null) {
    const a = Number(i[n]);
    return {
      amount: Number.isFinite(a) ? a : null,
      display: i[n],
      unit: n,
      code: n,
      decimals: Ri(i[n])
    };
  }
  const r = Number(e.amount);
  return {
    amount: Number.isFinite(r) ? r : null,
    display: e.amount_display ?? "",
    unit: e.currency_unit || e.currency || "",
    code: o,
    decimals: Ri(e.amount_display)
  };
}
function Qa(e, t) {
  const n = t && t > 1 ? t : 1;
  if (n === 1 || e.amount === null) return e;
  const o = en(e.amount / n, e.decimals);
  return { ...e, amount: o, display: Za(o, e.decimals) };
}
function Gt(e, t, n) {
  const o = el(t);
  let i = 0, r = "", a = null;
  for (const d of e) {
    const l = tn(d, n);
    if (l.amount != null) {
      const u = $n(d, o, l.code);
      i += u ? en(l.amount * (1 - u / 100), l.decimals) : l.amount;
    }
    !r && l.unit && (r = l.unit), l.decimals != null && (a = Math.max(a ?? 0, l.decimals));
  }
  return { amount: i, unit: r, decimals: a };
}
function R0(e, t = "default") {
  const n = Ja + t, o = v(() => new Map(Q(e).map((r) => [r.ident, r]))), i = { get: (r) => o.value.get(r) };
  return mn(n, i), i;
}
function Yr(e = "default") {
  const t = Ja + e;
  return ce(t, null);
}
function jo(e, t = "default") {
  const n = Yr(t);
  return { price: v(() => {
    const i = Q(e);
    return i ? n?.get(i) ?? null : null;
  }) };
}
function V0(e) {
  if (typeof e == "string") return e.slice(0, 10);
  const t = e ?? /* @__PURE__ */ new Date(), n = t.getFullYear(), o = String(t.getMonth() + 1).padStart(2, "0"), i = String(t.getDate()).padStart(2, "0");
  return `${n}-${o}-${i}`;
}
function N0(e, t) {
  if (e.valid_from && e.valid_from > t || e.valid_to && e.valid_to < t) return !1;
  const n = e.validity;
  return !n || n.length === 0 ? !0 : n.some((o) => (!o.start || o.start <= t) && (!o.end || o.end >= t));
}
function j0(e) {
  const [t, n, o] = e.split("-").map(Number);
  return !t || !n || !o ? null : (new Date(Date.UTC(t, n - 1, o)).getUTCDay() + 6) % 7;
}
function U0(e, t) {
  const n = e.day_of_week_mask;
  if (!n || n.length === 0) return !0;
  const o = j0(t);
  return o === null || n.includes(o);
}
function H0(e, t) {
  const n = e.level ?? 0, o = t.level ?? 0;
  return n !== o ? n > o : e.sort_order < t.sort_order;
}
function Mo(e, t, n) {
  const o = V0(t), i = /* @__PURE__ */ new Map();
  for (const r of e) {
    if (!N0(r, o) || !U0(r, o) || n && !Gr(r.time_mask, n)) continue;
    const a = i.get(r.ident);
    (!a || H0(r, a)) && i.set(r.ident, r);
  }
  return [...i.values()].sort((r, a) => r.sort_order - a.sort_order);
}
function Gr(e, t) {
  if (!e || e.length === 0) return !0;
  if (!t) return !1;
  const n = t.slice(0, 5);
  return e.some((o) => {
    const i = (o.start ?? "").slice(0, 5), r = (o.end ?? "").slice(0, 5);
    return !i || !r ? !1 : i === r ? n === i : i <= n && n <= r;
  });
}
const mr = { percent: 0, idents: [] };
function el(e) {
  return e == null ? mr : typeof e == "number" ? { percent: e, idents: [] } : e;
}
function po(e, t, n) {
  if (!e || !t || t.length === 0) return mr;
  const o = new Map(t.map((u) => [u.ident, u])), i = (u) => Number(u.discount_percentage) || 0, r = [];
  for (const [u, s] of Object.entries(e)) {
    const c = o.get(u);
    c && Gr(s, n) && r.push(c);
  }
  if (r.length === 0) return mr;
  const a = (u) => Math.round(u * 100) / 100, d = r.reduce((u, s) => i(s) > i(u) ? s : u), l = r.filter((u) => u.is_stackable);
  if (l.length > 0) {
    let u = 1;
    for (const c of l) u *= 1 - i(c) / 100;
    const s = (1 - u) * 100;
    if (s >= i(d)) return { percent: a(s), idents: l.map((c) => c.ident) };
  }
  return { percent: a(i(d)), idents: [d.ident] };
}
function Ni(e, t, n) {
  return po(e, t, n).percent;
}
function ji(e, t) {
  for (const [n, o] of Object.entries(e ?? {})) {
    if (n.toUpperCase() !== t) continue;
    const i = Number(o);
    return Number.isFinite(i) ? i : null;
  }
  return null;
}
function $n(e, t, n) {
  const o = el(t), i = e?.discount_bypass ?? {}, r = Number(e?.amount);
  if (!(r > 0) || o.idents.length === 0) return o.percent;
  const a = (n || "").toUpperCase(), d = (e?.currency || "").toUpperCase();
  let l = null;
  if (a && a !== d) {
    const s = ji(e?.exchange_bypass, a);
    s !== null && s > 0 && (l = s);
  }
  let u = null;
  for (const s of o.idents) {
    const c = i[s];
    if (c == null) continue;
    const p = typeof c == "object";
    let f = null;
    if (p && l !== null) {
      const b = ji(c.exchange_bypass, a);
      b !== null && (f = (1 - b / l) * 100);
    }
    if (f === null) {
      const b = Number(p ? c.amount : c);
      Number.isFinite(b) && (f = (1 - b / r) * 100);
    }
    f !== null && (u === null || f > u) && (u = f);
  }
  return u === null ? o.percent : Math.max(u, 0);
}
function Ao(e, t, n) {
  if (!e || !t || t.length === 0)
    return { hasDiscount: !1, maxPercent: 0, titles: [] };
  const o = new Map(t.map((a) => [a.ident, a]));
  let i = 0;
  const r = [];
  for (const [a, d] of Object.entries(e)) {
    const l = o.get(a);
    l && (n && !Gr(d, n) || (i = Math.max(i, Number(l.discount_percentage) || 0), l.title && !r.includes(l.title) && r.push(l.title)));
  }
  return { hasDiscount: i > 0 || r.length > 0, maxPercent: Math.round(i * 100) / 100, titles: r };
}
function K0(e, t, n, o = [], i) {
  if (!e || e.length === 0) return [];
  const r = [...new Set(e)].sort(), a = [];
  let d = null;
  for (const l of r) {
    const { percent: u, idents: s } = po(t, n, l), { titles: c } = Ao(t, n, l), p = Mo(o, i, l).map((k) => [k.ident, k.valid_from, k.valid_to, k.amount]), f = JSON.stringify([u, s, c, p]), b = a[a.length - 1];
    b && f === d ? b.times.push(l) : (a.push({ times: [l], label: "", percent: u, idents: s, titles: c }), d = f);
  }
  for (const l of a) {
    const u = l.times[0].slice(0, 5), s = l.times[l.times.length - 1].slice(0, 5);
    l.label = u === s ? u : `${u} - ${s}`;
  }
  return a;
}
function tl(e, t, n) {
  if (!e) return !1;
  const o = e.time_list;
  if (!o || o.length === 0) return !1;
  const i = n.getTime() + Math.max(t ?? 0, 0) * 6e4;
  let r = -1 / 0;
  for (const a of o) {
    const d = (/* @__PURE__ */ new Date(`${e.day}T${a.end}`)).getTime();
    d > r && (r = d);
  }
  return r === -1 / 0 ? !1 : r < i;
}
function fr(e, t) {
  if (!e) return !1;
  const n = e.time_list;
  if (!n || n.length === 0) return !1;
  let o = -1 / 0;
  for (const i of n) {
    const r = (/* @__PURE__ */ new Date(`${e.day}T${i.end}`)).getTime();
    r > o && (o = r);
  }
  return o === -1 / 0 ? !1 : o < t.getTime();
}
function qt(e) {
  const t = String(e.month + 1).padStart(2, "0"), n = String(e.day).padStart(2, "0");
  return `${e.year}-${t}-${n}`;
}
function Ne(e) {
  const [t, n, o] = e.slice(0, 10).split("-").map(Number);
  return new Date(t, n - 1, o);
}
function lt(e) {
  return qt({ day: e.getDate(), month: e.getMonth(), year: e.getFullYear() });
}
function Io(e, t) {
  if (t === ye || t === void 0 || t === null) return null;
  switch (e.attribute_type) {
    case "boolean":
      return t === !1 ? null : e.price_ident ?? null;
    case "choice":
      return e.choices.find((o) => o.value === t)?.price_ident ?? null;
    case "geolocation": {
      const n = e.choices.find((o) => o.value === t);
      return n ? n.price_ident ?? n.value ?? null : null;
    }
    case "fixed":
      return e.price_ident ?? null;
    case "number":
    case "string":
      return e.price_ident ?? null;
  }
  return null;
}
function Uo(e, t) {
  return e.prices_snapshot?.length ? Gt(
    e.prices_snapshot,
    { percent: e.discount_percent ?? 0, idents: e.discount_idents ?? [] },
    t
  ) : { amount: e.total_amount, unit: e.currency_unit ?? e.currency, decimals: null };
}
const W0 = "mancub.basket", dt = Vr(W0, [], void 0, {
  mergeDefaults: !0
}), Y0 = v(() => dt.value.length), G0 = v(() => {
  const e = /* @__PURE__ */ new Map();
  for (const t of dt.value) {
    const n = e.get(t.currency);
    n ? n.amount += t.total_amount : e.set(t.currency, { amount: t.total_amount, unit: t.currency_unit });
  }
  return e;
});
function q0(e) {
  const t = {
    ...e,
    id: crypto.randomUUID(),
    added_at: (/* @__PURE__ */ new Date()).toISOString()
  };
  return dt.value = [...dt.value, t], t;
}
function Z0(e, t) {
  dt.value = dt.value.map((n) => n.id === e ? { ...n, ...t } : n);
}
function X0(e) {
  dt.value = dt.value.filter((t) => t.id !== e);
}
function J0() {
  dt.value = [];
}
function Q0(e) {
  return dt.value.find((t) => t.id === e);
}
function nn() {
  return { items: dt, count: Y0, totalsByCurrency: G0, add: q0, update: Z0, remove: X0, clear: J0, findById: Q0 };
}
const Ct = Symbol("mancub:apiUrl"), St = Symbol("mancub:host"), qr = Symbol("mancub:activeDiscount"), nl = Symbol("mancub:errorDetails"), ol = Symbol("mancub:currency"), mo = Symbol("mancub:language"), rl = Symbol("mancub:successContent"), vn = W(null), ey = "mancub:currency-change", jn = (e) => (e || "").trim().toUpperCase() || null;
function _o(e) {
  vn.value = jn(e);
}
function il(e) {
  const t = jn(e);
  !t || t === vn.value || (vn.value = t, typeof document < "u" && document.dispatchEvent(new CustomEvent(ey, { detail: { currency: t } })));
}
function d9() {
  return { currency: Ca(vn), setCurrency: _o, selectCurrency: il };
}
function al(e) {
  te(() => Q(e), (t) => {
    t && _o(t);
  }, { immediate: !0 });
}
function Bn(e = null) {
  const t = ce(ol, null);
  return v(() => jn(Q(e)) ?? jn(Q(t)) ?? vn.value);
}
function Ho() {
  const e = nn();
  return v(() => vn.value ?? jn(e.items.value.find((t) => t.currency)?.currency));
}
var Pt = {
  _loadedStyleNames: /* @__PURE__ */ new Set(),
  getLoadedStyleNames: function() {
    return this._loadedStyleNames;
  },
  isStyleNameLoaded: function(t) {
    return this._loadedStyleNames.has(t);
  },
  setLoadedStyleName: function(t) {
    this._loadedStyleNames.add(t);
  },
  deleteLoadedStyleName: function(t) {
    this._loadedStyleNames.delete(t);
  },
  clearLoadedStyleNames: function() {
    this._loadedStyleNames.clear();
  }
};
function ty() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "pc", t = ps();
  return "".concat(e).concat(t.replace("v-", "").replaceAll("-", "_"));
}
var Ui = oe.extend({
  name: "common"
});
function Un(e) {
  "@babel/helpers - typeof";
  return Un = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Un(e);
}
function ny(e) {
  return dl(e) || oy(e) || sl(e) || ll();
}
function oy(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function Pn(e, t) {
  return dl(e) || ry(e, t) || sl(e, t) || ll();
}
function ll() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function sl(e, t) {
  if (e) {
    if (typeof e == "string") return Hi(e, t);
    var n = {}.toString.call(e).slice(8, -1);
    return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Hi(e, t) : void 0;
  }
}
function Hi(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, o = Array(t); n < t; n++) o[n] = e[n];
  return o;
}
function ry(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var o, i, r, a, d = [], l = !0, u = !1;
    try {
      if (r = (n = n.call(e)).next, t === 0) {
        if (Object(n) !== n) return;
        l = !1;
      } else for (; !(l = (o = r.call(n)).done) && (d.push(o.value), d.length !== t); l = !0) ;
    } catch (s) {
      u = !0, i = s;
    } finally {
      try {
        if (!l && n.return != null && (a = n.return(), Object(a) !== a)) return;
      } finally {
        if (u) throw i;
      }
    }
    return d;
  }
}
function dl(e) {
  if (Array.isArray(e)) return e;
}
function Ki(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    t && (o = o.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, o);
  }
  return n;
}
function de(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Ki(Object(n), !0).forEach(function(o) {
      Ln(e, o, n[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Ki(Object(n)).forEach(function(o) {
      Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(n, o));
    });
  }
  return e;
}
function Ln(e, t, n) {
  return (t = iy(t)) in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function iy(e) {
  var t = ay(e, "string");
  return Un(t) == "symbol" ? t : t + "";
}
function ay(e, t) {
  if (Un(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var o = n.call(e, t);
    if (Un(o) != "object") return o;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var nt = {
  name: "BaseComponent",
  props: {
    pt: {
      type: Object,
      default: void 0
    },
    ptOptions: {
      type: Object,
      default: void 0
    },
    unstyled: {
      type: Boolean,
      default: void 0
    },
    dt: {
      type: Object,
      default: void 0
    }
  },
  inject: {
    $parentInstance: {
      default: void 0
    }
  },
  watch: {
    isUnstyled: {
      immediate: !0,
      handler: function(t) {
        Ee.off("theme:change", this._loadCoreStyles), t || (this._loadCoreStyles(), this._themeChangeListener(this._loadCoreStyles));
      }
    },
    dt: {
      immediate: !0,
      handler: function(t, n) {
        var o = this;
        Ee.off("theme:change", this._themeScopedListener), t ? (this._loadScopedThemeStyles(t), this._themeScopedListener = function() {
          return o._loadScopedThemeStyles(t);
        }, this._themeChangeListener(this._themeScopedListener)) : this._unloadScopedThemeStyles();
      }
    }
  },
  scopedStyleEl: void 0,
  rootEl: void 0,
  uid: void 0,
  $attrSelector: void 0,
  beforeCreate: function() {
    var t, n, o, i, r, a, d, l, u, s, c, p = (t = this.pt) === null || t === void 0 ? void 0 : t._usept, f = p ? (n = this.pt) === null || n === void 0 || (n = n.originalValue) === null || n === void 0 ? void 0 : n[this.$.type.name] : void 0, b = p ? (o = this.pt) === null || o === void 0 || (o = o.value) === null || o === void 0 ? void 0 : o[this.$.type.name] : this.pt;
    (i = b || f) === null || i === void 0 || (i = i.hooks) === null || i === void 0 || (r = i.onBeforeCreate) === null || r === void 0 || r.call(i);
    var k = (a = this.$primevueConfig) === null || a === void 0 || (a = a.pt) === null || a === void 0 ? void 0 : a._usept, T = k ? (d = this.$primevue) === null || d === void 0 || (d = d.config) === null || d === void 0 || (d = d.pt) === null || d === void 0 ? void 0 : d.originalValue : void 0, $ = k ? (l = this.$primevue) === null || l === void 0 || (l = l.config) === null || l === void 0 || (l = l.pt) === null || l === void 0 ? void 0 : l.value : (u = this.$primevue) === null || u === void 0 || (u = u.config) === null || u === void 0 ? void 0 : u.pt;
    (s = $ || T) === null || s === void 0 || (s = s[this.$.type.name]) === null || s === void 0 || (s = s.hooks) === null || s === void 0 || (c = s.onBeforeCreate) === null || c === void 0 || c.call(s), this.$attrSelector = ty(), this.uid = this.$attrs.id || this.$attrSelector.replace("pc", "pv_id_");
  },
  created: function() {
    this._hook("onCreated");
  },
  beforeMount: function() {
    var t;
    this.rootEl = qe(Qt(this.$el) ? this.$el : (t = this.$el) === null || t === void 0 ? void 0 : t.parentElement, "[".concat(this.$attrSelector, "]")), this.rootEl && (this.rootEl.$pc = de({
      name: this.$.type.name,
      attrSelector: this.$attrSelector
    }, this.$params)), this._loadStyles(), this._hook("onBeforeMount");
  },
  mounted: function() {
    this._hook("onMounted");
  },
  beforeUpdate: function() {
    this._hook("onBeforeUpdate");
  },
  updated: function() {
    this._hook("onUpdated");
  },
  beforeUnmount: function() {
    this._hook("onBeforeUnmount");
  },
  unmounted: function() {
    this._removeThemeListeners(), this._unloadScopedThemeStyles(), this._hook("onUnmounted");
  },
  methods: {
    _hook: function(t) {
      if (!this.$options.hostName) {
        var n = this._usePT(this._getPT(this.pt, this.$.type.name), this._getOptionValue, "hooks.".concat(t)), o = this._useDefaultPT(this._getOptionValue, "hooks.".concat(t));
        n?.(), o?.();
      }
    },
    _mergeProps: function(t) {
      for (var n = arguments.length, o = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++)
        o[i - 1] = arguments[i];
      return No(t) ? t.apply(void 0, o) : x.apply(void 0, o);
    },
    _load: function() {
      Pt.isStyleNameLoaded("base") || (oe.loadCSS(this.$styleOptions), this._loadGlobalStyles(), Pt.setLoadedStyleName("base")), this._loadThemeStyles();
    },
    _loadStyles: function() {
      this._load(), this._themeChangeListener(this._load);
    },
    _loadCoreStyles: function() {
      var t, n;
      !Pt.isStyleNameLoaded((t = this.$style) === null || t === void 0 ? void 0 : t.name) && (n = this.$style) !== null && n !== void 0 && n.name && (Ui.loadCSS(this.$styleOptions), this.$options.style && this.$style.loadCSS(this.$styleOptions), Pt.setLoadedStyleName(this.$style.name));
    },
    _loadGlobalStyles: function() {
      var t = this._useGlobalPT(this._getOptionValue, "global.css", this.$params);
      le(t) && oe.load(t, de({
        name: "global"
      }, this.$styleOptions));
    },
    _loadThemeStyles: function() {
      var t, n;
      if (!(this.isUnstyled || this.$theme === "none")) {
        if (!ve.isStyleNameLoaded("common")) {
          var o, i, r = ((o = this.$style) === null || o === void 0 || (i = o.getCommonTheme) === null || i === void 0 ? void 0 : i.call(o)) || {}, a = r.primitive, d = r.semantic, l = r.global, u = r.style;
          oe.load(a?.css, de({
            name: "primitive-variables"
          }, this.$styleOptions)), oe.load(d?.css, de({
            name: "semantic-variables"
          }, this.$styleOptions)), oe.load(l?.css, de({
            name: "global-variables"
          }, this.$styleOptions)), oe.loadStyle(de({
            name: "global-style"
          }, this.$styleOptions), u), ve.setLoadedStyleName("common");
        }
        if (!ve.isStyleNameLoaded((t = this.$style) === null || t === void 0 ? void 0 : t.name) && (n = this.$style) !== null && n !== void 0 && n.name) {
          var s, c, p, f, b = ((s = this.$style) === null || s === void 0 || (c = s.getComponentTheme) === null || c === void 0 ? void 0 : c.call(s)) || {}, k = b.css, T = b.style;
          (p = this.$style) === null || p === void 0 || p.load(k, de({
            name: "".concat(this.$style.name, "-variables")
          }, this.$styleOptions)), (f = this.$style) === null || f === void 0 || f.loadStyle(de({
            name: "".concat(this.$style.name, "-style")
          }, this.$styleOptions), T), ve.setLoadedStyleName(this.$style.name);
        }
        if (!ve.isStyleNameLoaded("layer-order")) {
          var $, S, O = ($ = this.$style) === null || $ === void 0 || (S = $.getLayerOrderThemeCSS) === null || S === void 0 ? void 0 : S.call($);
          oe.load(O, de({
            name: "layer-order",
            first: !0
          }, this.$styleOptions)), ve.setLoadedStyleName("layer-order");
        }
      }
    },
    _loadScopedThemeStyles: function(t) {
      var n, o, i, r = ((n = this.$style) === null || n === void 0 || (o = n.getPresetTheme) === null || o === void 0 ? void 0 : o.call(n, t, "[".concat(this.$attrSelector, "]"))) || {}, a = r.css, d = (i = this.$style) === null || i === void 0 ? void 0 : i.load(a, de({
        name: "".concat(this.$attrSelector, "-").concat(this.$style.name)
      }, this.$styleOptions));
      this.scopedStyleEl = d.el;
    },
    _unloadScopedThemeStyles: function() {
      var t;
      (t = this.scopedStyleEl) === null || t === void 0 || (t = t.value) === null || t === void 0 || t.remove();
    },
    _themeChangeListener: function() {
      var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : function() {
      };
      Pt.clearLoadedStyleNames(), Ee.on("theme:change", t);
    },
    _removeThemeListeners: function() {
      Ee.off("theme:change", this._loadCoreStyles), Ee.off("theme:change", this._load), Ee.off("theme:change", this._themeScopedListener);
    },
    _getHostInstance: function(t) {
      return t ? this.$options.hostName ? t.$.type.name === this.$options.hostName ? t : this._getHostInstance(t.$parentInstance) : t.$parentInstance : void 0;
    },
    _getPropValue: function(t) {
      var n;
      return this[t] || ((n = this._getHostInstance(this)) === null || n === void 0 ? void 0 : n[t]);
    },
    _getOptionValue: function(t) {
      var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
      return Nr(t, n, o);
    },
    _getPTValue: function() {
      var t, n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !0, a = /./g.test(o) && !!i[o.split(".")[0]], d = this._getPropValue("ptOptions") || ((t = this.$primevueConfig) === null || t === void 0 ? void 0 : t.ptOptions) || {}, l = d.mergeSections, u = l === void 0 ? !0 : l, s = d.mergeProps, c = s === void 0 ? !1 : s, p = r ? a ? this._useGlobalPT(this._getPTClassValue, o, i) : this._useDefaultPT(this._getPTClassValue, o, i) : void 0, f = a ? void 0 : this._getPTSelf(n, this._getPTClassValue, o, de(de({}, i), {}, {
        global: p || {}
      })), b = this._getPTDatasets(o);
      return u || !u && f ? c ? this._mergeProps(c, p, f, b) : de(de(de({}, p), f), b) : de(de({}, f), b);
    },
    _getPTSelf: function() {
      for (var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = arguments.length, o = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++)
        o[i - 1] = arguments[i];
      return x(
        this._usePT.apply(this, [this._getPT(t, this.$name)].concat(o)),
        // Exp; <component :pt="{}"
        this._usePT.apply(this, [this.$_attrsPT].concat(o))
        // Exp; <component :pt:[passthrough_key]:[attribute]="{value}" or <component :pt:[passthrough_key]="() =>{value}"
      );
    },
    _getPTDatasets: function() {
      var t, n, o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", i = "data-pc-", r = o === "root" && le((t = this.pt) === null || t === void 0 ? void 0 : t["data-pc-section"]);
      return o !== "transition" && de(de({}, o === "root" && de(de(Ln({}, "".concat(i, "name"), ft(r ? (n = this.pt) === null || n === void 0 ? void 0 : n["data-pc-section"] : this.$.type.name)), r && Ln({}, "".concat(i, "extend"), ft(this.$.type.name))), {}, Ln({}, "".concat(this.$attrSelector), ""))), {}, Ln({}, "".concat(i, "section"), ft(o)));
    },
    _getPTClassValue: function() {
      var t = this._getOptionValue.apply(this, arguments);
      return Ye(t) || Ta(t) ? {
        class: t
      } : t;
    },
    _getPT: function(t) {
      var n = this, o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", i = arguments.length > 2 ? arguments[2] : void 0, r = function(d) {
        var l, u = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, s = i ? i(d) : d, c = ft(o), p = ft(n.$name);
        return (l = u ? c !== p ? s?.[c] : void 0 : s?.[c]) !== null && l !== void 0 ? l : s;
      };
      return t != null && t.hasOwnProperty("_usept") ? {
        _usept: t._usept,
        originalValue: r(t.originalValue),
        value: r(t.value)
      } : r(t, !0);
    },
    _usePT: function(t, n, o, i) {
      var r = function(k) {
        return n(k, o, i);
      };
      if (t != null && t.hasOwnProperty("_usept")) {
        var a, d = t._usept || ((a = this.$primevueConfig) === null || a === void 0 ? void 0 : a.ptOptions) || {}, l = d.mergeSections, u = l === void 0 ? !0 : l, s = d.mergeProps, c = s === void 0 ? !1 : s, p = r(t.originalValue), f = r(t.value);
        return p === void 0 && f === void 0 ? void 0 : Ye(f) ? f : Ye(p) ? p : u || !u && f ? c ? this._mergeProps(c, p, f) : de(de({}, p), f) : f;
      }
      return r(t);
    },
    _useGlobalPT: function(t, n, o) {
      return this._usePT(this.globalPT, t, n, o);
    },
    _useDefaultPT: function(t, n, o) {
      return this._usePT(this.defaultPT, t, n, o);
    },
    ptm: function() {
      var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      return this._getPTValue(this.pt, t, de(de({}, this.$params), n));
    },
    ptmi: function() {
      var t, n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, i = x(this.$_attrsWithoutPT, this.ptm(n, o));
      return i?.hasOwnProperty("id") && ((t = i.id) !== null && t !== void 0 || (i.id = this.$id)), i;
    },
    ptmo: function() {
      var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
      return this._getPTValue(t, n, de({
        instance: this
      }, o), !1);
    },
    cx: function() {
      var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      return this.isUnstyled ? void 0 : this._getOptionValue(this.$style.classes, t, de(de({}, this.$params), n));
    },
    sx: function() {
      var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0, o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
      if (n) {
        var i = this._getOptionValue(this.$style.inlineStyles, t, de(de({}, this.$params), o)), r = this._getOptionValue(Ui.inlineStyles, t, de(de({}, this.$params), o));
        return [r, i];
      }
    }
  },
  computed: {
    globalPT: function() {
      var t, n = this;
      return this._getPT((t = this.$primevueConfig) === null || t === void 0 ? void 0 : t.pt, void 0, function(o) {
        return Xe(o, {
          instance: n
        });
      });
    },
    defaultPT: function() {
      var t, n = this;
      return this._getPT((t = this.$primevueConfig) === null || t === void 0 ? void 0 : t.pt, void 0, function(o) {
        return n._getOptionValue(o, n.$name, de({}, n.$params)) || Xe(o, de({}, n.$params));
      });
    },
    isUnstyled: function() {
      var t;
      return this.unstyled !== void 0 ? this.unstyled : (t = this.$primevueConfig) === null || t === void 0 ? void 0 : t.unstyled;
    },
    $id: function() {
      return this.$attrs.id || this.uid;
    },
    $inProps: function() {
      var t, n = Object.keys(((t = this.$.vnode) === null || t === void 0 ? void 0 : t.props) || {});
      return Object.fromEntries(Object.entries(this.$props).filter(function(o) {
        var i = Pn(o, 1), r = i[0];
        return n?.includes(r);
      }));
    },
    $theme: function() {
      var t;
      return (t = this.$primevueConfig) === null || t === void 0 ? void 0 : t.theme;
    },
    $style: function() {
      return de(de({
        classes: void 0,
        inlineStyles: void 0,
        load: function() {
        },
        loadCSS: function() {
        },
        loadStyle: function() {
        }
      }, (this._getHostInstance(this) || {}).$style), this.$options.style);
    },
    $styleOptions: function() {
      var t;
      return {
        nonce: (t = this.$primevueConfig) === null || t === void 0 || (t = t.csp) === null || t === void 0 ? void 0 : t.nonce
      };
    },
    $primevueConfig: function() {
      var t;
      return (t = this.$primevue) === null || t === void 0 ? void 0 : t.config;
    },
    $name: function() {
      return this.$options.hostName || this.$.type.name;
    },
    $params: function() {
      var t = this._getHostInstance(this) || this.$parent;
      return {
        instance: this,
        props: this.$props,
        state: this.$data,
        attrs: this.$attrs,
        parent: {
          instance: t,
          props: t?.$props,
          state: t?.$data,
          attrs: t?.$attrs
        }
      };
    },
    $_attrsPT: function() {
      return Object.entries(this.$attrs || {}).filter(function(t) {
        var n = Pn(t, 1), o = n[0];
        return o?.startsWith("pt:");
      }).reduce(function(t, n) {
        var o = Pn(n, 2), i = o[0], r = o[1], a = i.split(":"), d = ny(a), l = d.slice(1);
        return l?.reduce(function(u, s, c, p) {
          return !u[s] && (u[s] = c === p.length - 1 ? r : {}), u[s];
        }, t), t;
      }, {});
    },
    $_attrsWithoutPT: function() {
      return Object.entries(this.$attrs || {}).filter(function(t) {
        var n = Pn(t, 1), o = n[0];
        return !(o != null && o.startsWith("pt:"));
      }).reduce(function(t, n) {
        var o = Pn(n, 2), i = o[0], r = o[1];
        return t[i] = r, t;
      }, {});
    }
  }
}, ly = `
.p-icon {
    display: inline-block;
    vertical-align: baseline;
}

.p-icon-spin {
    -webkit-animation: p-icon-spin 2s infinite linear;
    animation: p-icon-spin 2s infinite linear;
}

@-webkit-keyframes p-icon-spin {
    0% {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    100% {
        -webkit-transform: rotate(359deg);
        transform: rotate(359deg);
    }
}

@keyframes p-icon-spin {
    0% {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    100% {
        -webkit-transform: rotate(359deg);
        transform: rotate(359deg);
    }
}
`, sy = oe.extend({
  name: "baseicon",
  css: ly
});
function Hn(e) {
  "@babel/helpers - typeof";
  return Hn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Hn(e);
}
function Wi(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    t && (o = o.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, o);
  }
  return n;
}
function Yi(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Wi(Object(n), !0).forEach(function(o) {
      dy(e, o, n[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Wi(Object(n)).forEach(function(o) {
      Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(n, o));
    });
  }
  return e;
}
function dy(e, t, n) {
  return (t = uy(t)) in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function uy(e) {
  var t = cy(e, "string");
  return Hn(t) == "symbol" ? t : t + "";
}
function cy(e, t) {
  if (Hn(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var o = n.call(e, t);
    if (Hn(o) != "object") return o;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var Ue = {
  name: "BaseIcon",
  extends: nt,
  props: {
    label: {
      type: String,
      default: void 0
    },
    spin: {
      type: Boolean,
      default: !1
    }
  },
  style: sy,
  provide: function() {
    return {
      $pcIcon: this,
      $parentInstance: this
    };
  },
  methods: {
    pti: function() {
      var t = Jt(this.label);
      return Yi(Yi({}, !this.isUnstyled && {
        class: ["p-icon", {
          "p-icon-spin": this.spin
        }]
      }), {}, {
        role: t ? void 0 : "img",
        "aria-label": t ? void 0 : this.label,
        "aria-hidden": t
      });
    }
  }
}, Ko = {
  name: "SpinnerIcon",
  extends: Ue
};
function py(e) {
  return hy(e) || gy(e) || fy(e) || my();
}
function my() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function fy(e, t) {
  if (e) {
    if (typeof e == "string") return gr(e, t);
    var n = {}.toString.call(e).slice(8, -1);
    return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? gr(e, t) : void 0;
  }
}
function gy(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function hy(e) {
  if (Array.isArray(e)) return gr(e);
}
function gr(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, o = Array(t); n < t; n++) o[n] = e[n];
  return o;
}
function by(e, t, n, o, i, r) {
  return m(), h("svg", x({
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.pti()), py(t[0] || (t[0] = [g("path", {
    d: "M6.99701 14C5.85441 13.999 4.72939 13.7186 3.72012 13.1832C2.71084 12.6478 1.84795 11.8737 1.20673 10.9284C0.565504 9.98305 0.165424 8.89526 0.041387 7.75989C-0.0826496 6.62453 0.073125 5.47607 0.495122 4.4147C0.917119 3.35333 1.59252 2.4113 2.46241 1.67077C3.33229 0.930247 4.37024 0.413729 5.4857 0.166275C6.60117 -0.0811796 7.76026 -0.0520535 8.86188 0.251112C9.9635 0.554278 10.9742 1.12227 11.8057 1.90555C11.915 2.01493 11.9764 2.16319 11.9764 2.31778C11.9764 2.47236 11.915 2.62062 11.8057 2.73C11.7521 2.78503 11.688 2.82877 11.6171 2.85864C11.5463 2.8885 11.4702 2.90389 11.3933 2.90389C11.3165 2.90389 11.2404 2.8885 11.1695 2.85864C11.0987 2.82877 11.0346 2.78503 10.9809 2.73C9.9998 1.81273 8.73246 1.26138 7.39226 1.16876C6.05206 1.07615 4.72086 1.44794 3.62279 2.22152C2.52471 2.99511 1.72683 4.12325 1.36345 5.41602C1.00008 6.70879 1.09342 8.08723 1.62775 9.31926C2.16209 10.5513 3.10478 11.5617 4.29713 12.1803C5.48947 12.7989 6.85865 12.988 8.17414 12.7157C9.48963 12.4435 10.6711 11.7264 11.5196 10.6854C12.3681 9.64432 12.8319 8.34282 12.8328 7C12.8328 6.84529 12.8943 6.69692 13.0038 6.58752C13.1132 6.47812 13.2616 6.41667 13.4164 6.41667C13.5712 6.41667 13.7196 6.47812 13.8291 6.58752C13.9385 6.69692 14 6.84529 14 7C14 8.85651 13.2622 10.637 11.9489 11.9497C10.6356 13.2625 8.85432 14 6.99701 14Z",
    fill: "currentColor"
  }, null, -1)])), 16);
}
Ko.render = by;
var vy = `
    .p-badge {
        display: inline-flex;
        border-radius: dt('badge.border.radius');
        align-items: center;
        justify-content: center;
        padding: dt('badge.padding');
        background: dt('badge.primary.background');
        color: dt('badge.primary.color');
        font-size: dt('badge.font.size');
        font-weight: dt('badge.font.weight');
        min-width: dt('badge.min.width');
        height: dt('badge.height');
    }

    .p-badge-dot {
        width: dt('badge.dot.size');
        min-width: dt('badge.dot.size');
        height: dt('badge.dot.size');
        border-radius: 50%;
        padding: 0;
    }

    .p-badge-circle {
        padding: 0;
        border-radius: 50%;
    }

    .p-badge-secondary {
        background: dt('badge.secondary.background');
        color: dt('badge.secondary.color');
    }

    .p-badge-success {
        background: dt('badge.success.background');
        color: dt('badge.success.color');
    }

    .p-badge-info {
        background: dt('badge.info.background');
        color: dt('badge.info.color');
    }

    .p-badge-warn {
        background: dt('badge.warn.background');
        color: dt('badge.warn.color');
    }

    .p-badge-danger {
        background: dt('badge.danger.background');
        color: dt('badge.danger.color');
    }

    .p-badge-contrast {
        background: dt('badge.contrast.background');
        color: dt('badge.contrast.color');
    }

    .p-badge-sm {
        font-size: dt('badge.sm.font.size');
        min-width: dt('badge.sm.min.width');
        height: dt('badge.sm.height');
    }

    .p-badge-lg {
        font-size: dt('badge.lg.font.size');
        min-width: dt('badge.lg.min.width');
        height: dt('badge.lg.height');
    }

    .p-badge-xl {
        font-size: dt('badge.xl.font.size');
        min-width: dt('badge.xl.min.width');
        height: dt('badge.xl.height');
    }
`, yy = {
  root: function(t) {
    var n = t.props, o = t.instance;
    return ["p-badge p-component", {
      "p-badge-circle": le(n.value) && String(n.value).length === 1,
      "p-badge-dot": Jt(n.value) && !o.$slots.default,
      "p-badge-sm": n.size === "small",
      "p-badge-lg": n.size === "large",
      "p-badge-xl": n.size === "xlarge",
      "p-badge-info": n.severity === "info",
      "p-badge-success": n.severity === "success",
      "p-badge-warn": n.severity === "warn",
      "p-badge-danger": n.severity === "danger",
      "p-badge-secondary": n.severity === "secondary",
      "p-badge-contrast": n.severity === "contrast"
    }];
  }
}, ky = oe.extend({
  name: "badge",
  style: vy,
  classes: yy
}), wy = {
  name: "BaseBadge",
  extends: nt,
  props: {
    value: {
      type: [String, Number],
      default: null
    },
    severity: {
      type: String,
      default: null
    },
    size: {
      type: String,
      default: null
    }
  },
  style: ky,
  provide: function() {
    return {
      $pcBadge: this,
      $parentInstance: this
    };
  }
};
function Kn(e) {
  "@babel/helpers - typeof";
  return Kn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Kn(e);
}
function Gi(e, t, n) {
  return (t = xy(t)) in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function xy(e) {
  var t = Cy(e, "string");
  return Kn(t) == "symbol" ? t : t + "";
}
function Cy(e, t) {
  if (Kn(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var o = n.call(e, t);
    if (Kn(o) != "object") return o;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var ul = {
  name: "Badge",
  extends: wy,
  inheritAttrs: !1,
  computed: {
    dataP: function() {
      return Pe(Gi(Gi({
        circle: this.value != null && String(this.value).length === 1,
        empty: this.value == null && !this.$slots.default
      }, this.severity, this.severity), this.size, this.size));
    }
  }
}, Sy = ["data-p"];
function $y(e, t, n, o, i, r) {
  return m(), h("span", x({
    class: e.cx("root"),
    "data-p": r.dataP
  }, e.ptmi("root")), [R(e.$slots, "default", {}, function() {
    return [q(y(e.value), 1)];
  })], 16, Sy);
}
ul.render = $y;
function Wn(e) {
  "@babel/helpers - typeof";
  return Wn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Wn(e);
}
function qi(e, t) {
  return Dy(e) || Iy(e, t) || Ty(e, t) || By();
}
function By() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Ty(e, t) {
  if (e) {
    if (typeof e == "string") return Zi(e, t);
    var n = {}.toString.call(e).slice(8, -1);
    return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Zi(e, t) : void 0;
  }
}
function Zi(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, o = Array(t); n < t; n++) o[n] = e[n];
  return o;
}
function Iy(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var o, i, r, a, d = [], l = !0, u = !1;
    try {
      if (r = (n = n.call(e)).next, t !== 0) for (; !(l = (o = r.call(n)).done) && (d.push(o.value), d.length !== t); l = !0) ;
    } catch (s) {
      u = !0, i = s;
    } finally {
      try {
        if (!l && n.return != null && (a = n.return(), Object(a) !== a)) return;
      } finally {
        if (u) throw i;
      }
    }
    return d;
  }
}
function Dy(e) {
  if (Array.isArray(e)) return e;
}
function Xi(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    t && (o = o.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, o);
  }
  return n;
}
function me(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Xi(Object(n), !0).forEach(function(o) {
      hr(e, o, n[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Xi(Object(n)).forEach(function(o) {
      Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(n, o));
    });
  }
  return e;
}
function hr(e, t, n) {
  return (t = Py(t)) in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Py(e) {
  var t = zy(e, "string");
  return Wn(t) == "symbol" ? t : t + "";
}
function zy(e, t) {
  if (Wn(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var o = n.call(e, t);
    if (Wn(o) != "object") return o;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var ne = {
  _getMeta: function() {
    return [gt(arguments.length <= 0 ? void 0 : arguments[0]) || arguments.length <= 0 ? void 0 : arguments[0], Xe(gt(arguments.length <= 0 ? void 0 : arguments[0]) ? arguments.length <= 0 ? void 0 : arguments[0] : arguments.length <= 1 ? void 0 : arguments[1])];
  },
  _getConfig: function(t, n) {
    var o, i, r;
    return (o = (t == null || (i = t.instance) === null || i === void 0 ? void 0 : i.$primevue) || (n == null || (r = n.ctx) === null || r === void 0 || (r = r.appContext) === null || r === void 0 || (r = r.config) === null || r === void 0 || (r = r.globalProperties) === null || r === void 0 ? void 0 : r.$primevue)) === null || o === void 0 ? void 0 : o.config;
  },
  _getOptionValue: Nr,
  _getPTValue: function() {
    var t, n, o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, d = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !0, l = function() {
      var S = ne._getOptionValue.apply(ne, arguments);
      return Ye(S) || Ta(S) ? {
        class: S
      } : S;
    }, u = ((t = o.binding) === null || t === void 0 || (t = t.value) === null || t === void 0 ? void 0 : t.ptOptions) || ((n = o.$primevueConfig) === null || n === void 0 ? void 0 : n.ptOptions) || {}, s = u.mergeSections, c = s === void 0 ? !0 : s, p = u.mergeProps, f = p === void 0 ? !1 : p, b = d ? ne._useDefaultPT(o, o.defaultPT(), l, r, a) : void 0, k = ne._usePT(o, ne._getPT(i, o.$name), l, r, me(me({}, a), {}, {
      global: b || {}
    })), T = ne._getPTDatasets(o, r);
    return c || !c && k ? f ? ne._mergeProps(o, f, b, k, T) : me(me(me({}, b), k), T) : me(me({}, k), T);
  },
  _getPTDatasets: function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", o = "data-pc-";
    return me(me({}, n === "root" && hr({}, "".concat(o, "name"), ft(t.$name))), {}, hr({}, "".concat(o, "section"), ft(n)));
  },
  _getPT: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", o = arguments.length > 2 ? arguments[2] : void 0, i = function(a) {
      var d, l = o ? o(a) : a, u = ft(n);
      return (d = l?.[u]) !== null && d !== void 0 ? d : l;
    };
    return t && Object.hasOwn(t, "_usept") ? {
      _usept: t._usept,
      originalValue: i(t.originalValue),
      value: i(t.value)
    } : i(t);
  },
  _usePT: function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = arguments.length > 1 ? arguments[1] : void 0, o = arguments.length > 2 ? arguments[2] : void 0, i = arguments.length > 3 ? arguments[3] : void 0, r = arguments.length > 4 ? arguments[4] : void 0, a = function(T) {
      return o(T, i, r);
    };
    if (n && Object.hasOwn(n, "_usept")) {
      var d, l = n._usept || ((d = t.$primevueConfig) === null || d === void 0 ? void 0 : d.ptOptions) || {}, u = l.mergeSections, s = u === void 0 ? !0 : u, c = l.mergeProps, p = c === void 0 ? !1 : c, f = a(n.originalValue), b = a(n.value);
      return f === void 0 && b === void 0 ? void 0 : Ye(b) ? b : Ye(f) ? f : s || !s && b ? p ? ne._mergeProps(t, p, f, b) : me(me({}, f), b) : b;
    }
    return a(n);
  },
  _useDefaultPT: function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, o = arguments.length > 2 ? arguments[2] : void 0, i = arguments.length > 3 ? arguments[3] : void 0, r = arguments.length > 4 ? arguments[4] : void 0;
    return ne._usePT(t, n, o, i, r);
  },
  _loadStyles: function() {
    var t, n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, o = arguments.length > 1 ? arguments[1] : void 0, i = arguments.length > 2 ? arguments[2] : void 0, r = ne._getConfig(o, i), a = {
      nonce: r == null || (t = r.csp) === null || t === void 0 ? void 0 : t.nonce
    };
    ne._loadCoreStyles(n, a), ne._loadThemeStyles(n, a), ne._loadScopedThemeStyles(n, a), ne._removeThemeListeners(n), n.$loadStyles = function() {
      return ne._loadThemeStyles(n, a);
    }, ne._themeChangeListener(n.$loadStyles);
  },
  _loadCoreStyles: function() {
    var t, n, o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, i = arguments.length > 1 ? arguments[1] : void 0;
    if (!Pt.isStyleNameLoaded((t = o.$style) === null || t === void 0 ? void 0 : t.name) && (n = o.$style) !== null && n !== void 0 && n.name) {
      var r;
      oe.loadCSS(i), (r = o.$style) === null || r === void 0 || r.loadCSS(i), Pt.setLoadedStyleName(o.$style.name);
    }
  },
  _loadThemeStyles: function() {
    var t, n, o, i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = arguments.length > 1 ? arguments[1] : void 0;
    if (!(i != null && i.isUnstyled() || (i == null || (t = i.theme) === null || t === void 0 ? void 0 : t.call(i)) === "none")) {
      if (!ve.isStyleNameLoaded("common")) {
        var a, d, l = ((a = i.$style) === null || a === void 0 || (d = a.getCommonTheme) === null || d === void 0 ? void 0 : d.call(a)) || {}, u = l.primitive, s = l.semantic, c = l.global, p = l.style;
        oe.load(u?.css, me({
          name: "primitive-variables"
        }, r)), oe.load(s?.css, me({
          name: "semantic-variables"
        }, r)), oe.load(c?.css, me({
          name: "global-variables"
        }, r)), oe.loadStyle(me({
          name: "global-style"
        }, r), p), ve.setLoadedStyleName("common");
      }
      if (!ve.isStyleNameLoaded((n = i.$style) === null || n === void 0 ? void 0 : n.name) && (o = i.$style) !== null && o !== void 0 && o.name) {
        var f, b, k, T, $ = ((f = i.$style) === null || f === void 0 || (b = f.getDirectiveTheme) === null || b === void 0 ? void 0 : b.call(f)) || {}, S = $.css, O = $.style;
        (k = i.$style) === null || k === void 0 || k.load(S, me({
          name: "".concat(i.$style.name, "-variables")
        }, r)), (T = i.$style) === null || T === void 0 || T.loadStyle(me({
          name: "".concat(i.$style.name, "-style")
        }, r), O), ve.setLoadedStyleName(i.$style.name);
      }
      if (!ve.isStyleNameLoaded("layer-order")) {
        var w, F, D = (w = i.$style) === null || w === void 0 || (F = w.getLayerOrderThemeCSS) === null || F === void 0 ? void 0 : F.call(w);
        oe.load(D, me({
          name: "layer-order",
          first: !0
        }, r)), ve.setLoadedStyleName("layer-order");
      }
    }
  },
  _loadScopedThemeStyles: function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = arguments.length > 1 ? arguments[1] : void 0, o = t.preset();
    if (o && t.$attrSelector) {
      var i, r, a, d = ((i = t.$style) === null || i === void 0 || (r = i.getPresetTheme) === null || r === void 0 ? void 0 : r.call(i, o, "[".concat(t.$attrSelector, "]"))) || {}, l = d.css, u = (a = t.$style) === null || a === void 0 ? void 0 : a.load(l, me({
        name: "".concat(t.$attrSelector, "-").concat(t.$style.name)
      }, n));
      t.scopedStyleEl = u.el;
    }
  },
  _themeChangeListener: function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : function() {
    };
    Pt.clearLoadedStyleNames(), Ee.on("theme:change", t);
  },
  _removeThemeListeners: function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    Ee.off("theme:change", t.$loadStyles), t.$loadStyles = void 0;
  },
  _hook: function(t, n, o, i, r, a) {
    var d, l, u = "on".concat(Ps(n)), s = ne._getConfig(i, r), c = o?.$instance, p = ne._usePT(c, ne._getPT(i == null || (d = i.value) === null || d === void 0 ? void 0 : d.pt, t), ne._getOptionValue, "hooks.".concat(u)), f = ne._useDefaultPT(c, s == null || (l = s.pt) === null || l === void 0 || (l = l.directives) === null || l === void 0 ? void 0 : l[t], ne._getOptionValue, "hooks.".concat(u)), b = {
      el: o,
      binding: i,
      vnode: r,
      prevVnode: a
    };
    p?.(c, b), f?.(c, b);
  },
  /* eslint-disable-next-line no-unused-vars */
  _mergeProps: function() {
    for (var t = arguments.length > 1 ? arguments[1] : void 0, n = arguments.length, o = new Array(n > 2 ? n - 2 : 0), i = 2; i < n; i++)
      o[i - 2] = arguments[i];
    return No(t) ? t.apply(void 0, o) : x.apply(void 0, o);
  },
  _extend: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, o = function(d, l, u, s, c) {
      var p, f, b, k;
      l._$instances = l._$instances || {};
      var T = ne._getConfig(u, s), $ = l._$instances[t] || {}, S = Jt($) ? me(me({}, n), n?.methods) : {};
      l._$instances[t] = me(me({}, $), {}, {
        /* new instance variables to pass in directive methods */
        $name: t,
        $host: l,
        $binding: u,
        $modifiers: u?.modifiers,
        $value: u?.value,
        $el: $.$el || l || void 0,
        $style: me({
          classes: void 0,
          inlineStyles: void 0,
          load: function() {
          },
          loadCSS: function() {
          },
          loadStyle: function() {
          }
        }, n?.style),
        $primevueConfig: T,
        $attrSelector: (p = l.$pd) === null || p === void 0 || (p = p[t]) === null || p === void 0 ? void 0 : p.attrSelector,
        /* computed instance variables */
        defaultPT: function() {
          return ne._getPT(T?.pt, void 0, function(w) {
            var F;
            return w == null || (F = w.directives) === null || F === void 0 ? void 0 : F[t];
          });
        },
        isUnstyled: function() {
          var w, F;
          return ((w = l._$instances[t]) === null || w === void 0 || (w = w.$binding) === null || w === void 0 || (w = w.value) === null || w === void 0 ? void 0 : w.unstyled) !== void 0 ? (F = l._$instances[t]) === null || F === void 0 || (F = F.$binding) === null || F === void 0 || (F = F.value) === null || F === void 0 ? void 0 : F.unstyled : T?.unstyled;
        },
        theme: function() {
          var w;
          return (w = l._$instances[t]) === null || w === void 0 || (w = w.$primevueConfig) === null || w === void 0 ? void 0 : w.theme;
        },
        preset: function() {
          var w;
          return (w = l._$instances[t]) === null || w === void 0 || (w = w.$binding) === null || w === void 0 || (w = w.value) === null || w === void 0 ? void 0 : w.dt;
        },
        /* instance's methods */
        ptm: function() {
          var w, F = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", D = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
          return ne._getPTValue(l._$instances[t], (w = l._$instances[t]) === null || w === void 0 || (w = w.$binding) === null || w === void 0 || (w = w.value) === null || w === void 0 ? void 0 : w.pt, F, me({}, D));
        },
        ptmo: function() {
          var w = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, F = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", D = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
          return ne._getPTValue(l._$instances[t], w, F, D, !1);
        },
        cx: function() {
          var w, F, D = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", C = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
          return (w = l._$instances[t]) !== null && w !== void 0 && w.isUnstyled() ? void 0 : ne._getOptionValue((F = l._$instances[t]) === null || F === void 0 || (F = F.$style) === null || F === void 0 ? void 0 : F.classes, D, me({}, C));
        },
        sx: function() {
          var w, F = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", D = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0, C = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
          return D ? ne._getOptionValue((w = l._$instances[t]) === null || w === void 0 || (w = w.$style) === null || w === void 0 ? void 0 : w.inlineStyles, F, me({}, C)) : void 0;
        }
      }, S), l.$instance = l._$instances[t], (f = (b = l.$instance)[d]) === null || f === void 0 || f.call(b, l, u, s, c), l["$".concat(t)] = l.$instance, ne._hook(t, d, l, u, s, c), l.$pd || (l.$pd = {}), l.$pd[t] = me(me({}, (k = l.$pd) === null || k === void 0 ? void 0 : k[t]), {}, {
        name: t,
        instance: l._$instances[t]
      });
    }, i = function(d) {
      var l, u, s, c = d._$instances[t], p = c?.watch, f = function(T) {
        var $, S = T.newValue, O = T.oldValue;
        return p == null || ($ = p.config) === null || $ === void 0 ? void 0 : $.call(c, S, O);
      }, b = function(T) {
        var $, S = T.newValue, O = T.oldValue;
        return p == null || ($ = p["config.ripple"]) === null || $ === void 0 ? void 0 : $.call(c, S, O);
      };
      c.$watchersCallback = {
        config: f,
        "config.ripple": b
      }, p == null || (l = p.config) === null || l === void 0 || l.call(c, c?.$primevueConfig), zt.on("config:change", f), p == null || (u = p["config.ripple"]) === null || u === void 0 || u.call(c, c == null || (s = c.$primevueConfig) === null || s === void 0 ? void 0 : s.ripple), zt.on("config:ripple:change", b);
    }, r = function(d) {
      var l = d._$instances[t].$watchersCallback;
      l && (zt.off("config:change", l.config), zt.off("config:ripple:change", l["config.ripple"]), d._$instances[t].$watchersCallback = void 0);
    };
    return {
      created: function(d, l, u, s) {
        d.$pd || (d.$pd = {}), d.$pd[t] = {
          name: t,
          attrSelector: Us("pd")
        }, o("created", d, l, u, s);
      },
      beforeMount: function(d, l, u, s) {
        var c;
        ne._loadStyles((c = d.$pd[t]) === null || c === void 0 ? void 0 : c.instance, l, u), o("beforeMount", d, l, u, s), i(d);
      },
      mounted: function(d, l, u, s) {
        var c;
        ne._loadStyles((c = d.$pd[t]) === null || c === void 0 ? void 0 : c.instance, l, u), o("mounted", d, l, u, s);
      },
      beforeUpdate: function(d, l, u, s) {
        o("beforeUpdate", d, l, u, s);
      },
      updated: function(d, l, u, s) {
        var c;
        ne._loadStyles((c = d.$pd[t]) === null || c === void 0 ? void 0 : c.instance, l, u), o("updated", d, l, u, s);
      },
      beforeUnmount: function(d, l, u, s) {
        var c;
        r(d), ne._removeThemeListeners((c = d.$pd[t]) === null || c === void 0 ? void 0 : c.instance), o("beforeUnmount", d, l, u, s);
      },
      unmounted: function(d, l, u, s) {
        var c;
        (c = d.$pd[t]) === null || c === void 0 || (c = c.instance) === null || c === void 0 || (c = c.scopedStyleEl) === null || c === void 0 || (c = c.value) === null || c === void 0 || c.remove(), o("unmounted", d, l, u, s);
      }
    };
  },
  extend: function() {
    var t = ne._getMeta.apply(ne, arguments), n = qi(t, 2), o = n[0], i = n[1];
    return me({
      extend: function() {
        var a = ne._getMeta.apply(ne, arguments), d = qi(a, 2), l = d[0], u = d[1];
        return ne.extend(l, me(me(me({}, i), i?.methods), u));
      }
    }, ne._extend(o, i));
  }
}, Ly = `
    .p-ink {
        display: block;
        position: absolute;
        background: dt('ripple.background');
        border-radius: 100%;
        transform: scale(0);
        pointer-events: none;
    }

    .p-ink-active {
        animation: ripple 0.4s linear;
    }

    @keyframes ripple {
        100% {
            opacity: 0;
            transform: scale(2.5);
        }
    }
`, Oy = {
  root: "p-ink"
}, My = oe.extend({
  name: "ripple-directive",
  style: Ly,
  classes: Oy
}), Ay = ne.extend({
  style: My
});
function Yn(e) {
  "@babel/helpers - typeof";
  return Yn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Yn(e);
}
function _y(e) {
  return Vy(e) || Ry(e) || Ey(e) || Fy();
}
function Fy() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Ey(e, t) {
  if (e) {
    if (typeof e == "string") return br(e, t);
    var n = {}.toString.call(e).slice(8, -1);
    return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? br(e, t) : void 0;
  }
}
function Ry(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function Vy(e) {
  if (Array.isArray(e)) return br(e);
}
function br(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, o = Array(t); n < t; n++) o[n] = e[n];
  return o;
}
function Ji(e, t, n) {
  return (t = Ny(t)) in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Ny(e) {
  var t = jy(e, "string");
  return Yn(t) == "symbol" ? t : t + "";
}
function jy(e, t) {
  if (Yn(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var o = n.call(e, t);
    if (Yn(o) != "object") return o;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var fo = Ay.extend("ripple", {
  watch: {
    "config.ripple": function(t) {
      t ? (this.createRipple(this.$host), this.bindEvents(this.$host), this.$host.setAttribute("data-pd-ripple", !0), this.$host.style.overflow = "hidden", this.$host.style.position = "relative") : (this.remove(this.$host), this.$host.removeAttribute("data-pd-ripple"));
    }
  },
  unmounted: function(t) {
    this.remove(t);
  },
  timeout: void 0,
  methods: {
    bindEvents: function(t) {
      t.addEventListener("mousedown", this.onMouseDown.bind(this));
    },
    unbindEvents: function(t) {
      t.removeEventListener("mousedown", this.onMouseDown.bind(this));
    },
    createRipple: function(t) {
      var n = this.getInk(t);
      n || (n = La("span", Ji(Ji({
        role: "presentation",
        "aria-hidden": !0,
        "data-p-ink": !0,
        "data-p-ink-active": !1,
        class: !this.isUnstyled() && this.cx("root"),
        onAnimationEnd: this.onAnimationEnd.bind(this)
      }, this.$attrSelector, ""), "p-bind", this.ptm("root"))), t.appendChild(n), this.$el = n);
    },
    remove: function(t) {
      var n = this.getInk(t);
      n && (this.$host.style.overflow = "", this.$host.style.position = "", this.unbindEvents(t), n.removeEventListener("animationend", this.onAnimationEnd), n.remove());
    },
    onMouseDown: function(t) {
      var n = this, o = t.currentTarget, i = this.getInk(o);
      if (!(!i || getComputedStyle(i, null).display === "none")) {
        if (!this.isUnstyled() && An(i, "p-ink-active"), i.setAttribute("data-p-ink-active", "false"), !Kt(i) && !Wt(i)) {
          var r = Math.max(fn(o), Ma(o));
          i.style.height = r + "px", i.style.width = r + "px";
        }
        var a = Vs(o), d = t.pageX - a.left + document.body.scrollTop - Wt(i) / 2, l = t.pageY - a.top + document.body.scrollLeft - Kt(i) / 2;
        i.style.top = l + "px", i.style.left = d + "px", !this.isUnstyled() && Po(i, "p-ink-active"), i.setAttribute("data-p-ink-active", "true"), this.timeout = setTimeout(function() {
          i && (!n.isUnstyled() && An(i, "p-ink-active"), i.setAttribute("data-p-ink-active", "false"));
        }, 401);
      }
    },
    onAnimationEnd: function(t) {
      this.timeout && clearTimeout(this.timeout), !this.isUnstyled() && An(t.currentTarget, "p-ink-active"), t.currentTarget.setAttribute("data-p-ink-active", "false");
    },
    getInk: function(t) {
      return t && t.children ? _y(t.children).find(function(n) {
        return Ut(n, "data-pc-name") === "ripple";
      }) : void 0;
    }
  }
}), Uy = `
    .p-button {
        display: inline-flex;
        cursor: pointer;
        user-select: none;
        align-items: center;
        justify-content: center;
        overflow: hidden;
        position: relative;
        color: dt('button.primary.color');
        background: dt('button.primary.background');
        border: 1px solid dt('button.primary.border.color');
        padding: dt('button.padding.y') dt('button.padding.x');
        font-size: 1rem;
        font-family: inherit;
        font-feature-settings: inherit;
        transition:
            background dt('button.transition.duration'),
            color dt('button.transition.duration'),
            border-color dt('button.transition.duration'),
            outline-color dt('button.transition.duration'),
            box-shadow dt('button.transition.duration');
        border-radius: dt('button.border.radius');
        outline-color: transparent;
        gap: dt('button.gap');
    }

    .p-button:disabled {
        cursor: default;
    }

    .p-button-icon-right {
        order: 1;
    }

    .p-button-icon-right:dir(rtl) {
        order: -1;
    }

    .p-button:not(.p-button-vertical) .p-button-icon:not(.p-button-icon-right):dir(rtl) {
        order: 1;
    }

    .p-button-icon-bottom {
        order: 2;
    }

    .p-button-icon-only {
        width: dt('button.icon.only.width');
        padding-inline-start: 0;
        padding-inline-end: 0;
        gap: 0;
    }

    .p-button-icon-only.p-button-rounded {
        border-radius: 50%;
        height: dt('button.icon.only.width');
    }

    .p-button-icon-only .p-button-label {
        visibility: hidden;
        width: 0;
    }

    .p-button-icon-only::after {
        content: "\0A0";
        visibility: hidden;
        width: 0;
    }

    .p-button-sm {
        font-size: dt('button.sm.font.size');
        padding: dt('button.sm.padding.y') dt('button.sm.padding.x');
    }

    .p-button-sm .p-button-icon {
        font-size: dt('button.sm.font.size');
    }

    .p-button-sm.p-button-icon-only {
        width: dt('button.sm.icon.only.width');
    }

    .p-button-sm.p-button-icon-only.p-button-rounded {
        height: dt('button.sm.icon.only.width');
    }

    .p-button-lg {
        font-size: dt('button.lg.font.size');
        padding: dt('button.lg.padding.y') dt('button.lg.padding.x');
    }

    .p-button-lg .p-button-icon {
        font-size: dt('button.lg.font.size');
    }

    .p-button-lg.p-button-icon-only {
        width: dt('button.lg.icon.only.width');
    }

    .p-button-lg.p-button-icon-only.p-button-rounded {
        height: dt('button.lg.icon.only.width');
    }

    .p-button-vertical {
        flex-direction: column;
    }

    .p-button-label {
        font-weight: dt('button.label.font.weight');
    }

    .p-button-fluid {
        width: 100%;
    }

    .p-button-fluid.p-button-icon-only {
        width: dt('button.icon.only.width');
    }

    .p-button:not(:disabled):hover {
        background: dt('button.primary.hover.background');
        border: 1px solid dt('button.primary.hover.border.color');
        color: dt('button.primary.hover.color');
    }

    .p-button:not(:disabled):active {
        background: dt('button.primary.active.background');
        border: 1px solid dt('button.primary.active.border.color');
        color: dt('button.primary.active.color');
    }

    .p-button:focus-visible {
        box-shadow: dt('button.primary.focus.ring.shadow');
        outline: dt('button.focus.ring.width') dt('button.focus.ring.style') dt('button.primary.focus.ring.color');
        outline-offset: dt('button.focus.ring.offset');
    }

    .p-button .p-badge {
        min-width: dt('button.badge.size');
        height: dt('button.badge.size');
        line-height: dt('button.badge.size');
    }

    .p-button-raised {
        box-shadow: dt('button.raised.shadow');
    }

    .p-button-rounded {
        border-radius: dt('button.rounded.border.radius');
    }

    .p-button-secondary {
        background: dt('button.secondary.background');
        border: 1px solid dt('button.secondary.border.color');
        color: dt('button.secondary.color');
    }

    .p-button-secondary:not(:disabled):hover {
        background: dt('button.secondary.hover.background');
        border: 1px solid dt('button.secondary.hover.border.color');
        color: dt('button.secondary.hover.color');
    }

    .p-button-secondary:not(:disabled):active {
        background: dt('button.secondary.active.background');
        border: 1px solid dt('button.secondary.active.border.color');
        color: dt('button.secondary.active.color');
    }

    .p-button-secondary:focus-visible {
        outline-color: dt('button.secondary.focus.ring.color');
        box-shadow: dt('button.secondary.focus.ring.shadow');
    }

    .p-button-success {
        background: dt('button.success.background');
        border: 1px solid dt('button.success.border.color');
        color: dt('button.success.color');
    }

    .p-button-success:not(:disabled):hover {
        background: dt('button.success.hover.background');
        border: 1px solid dt('button.success.hover.border.color');
        color: dt('button.success.hover.color');
    }

    .p-button-success:not(:disabled):active {
        background: dt('button.success.active.background');
        border: 1px solid dt('button.success.active.border.color');
        color: dt('button.success.active.color');
    }

    .p-button-success:focus-visible {
        outline-color: dt('button.success.focus.ring.color');
        box-shadow: dt('button.success.focus.ring.shadow');
    }

    .p-button-info {
        background: dt('button.info.background');
        border: 1px solid dt('button.info.border.color');
        color: dt('button.info.color');
    }

    .p-button-info:not(:disabled):hover {
        background: dt('button.info.hover.background');
        border: 1px solid dt('button.info.hover.border.color');
        color: dt('button.info.hover.color');
    }

    .p-button-info:not(:disabled):active {
        background: dt('button.info.active.background');
        border: 1px solid dt('button.info.active.border.color');
        color: dt('button.info.active.color');
    }

    .p-button-info:focus-visible {
        outline-color: dt('button.info.focus.ring.color');
        box-shadow: dt('button.info.focus.ring.shadow');
    }

    .p-button-warn {
        background: dt('button.warn.background');
        border: 1px solid dt('button.warn.border.color');
        color: dt('button.warn.color');
    }

    .p-button-warn:not(:disabled):hover {
        background: dt('button.warn.hover.background');
        border: 1px solid dt('button.warn.hover.border.color');
        color: dt('button.warn.hover.color');
    }

    .p-button-warn:not(:disabled):active {
        background: dt('button.warn.active.background');
        border: 1px solid dt('button.warn.active.border.color');
        color: dt('button.warn.active.color');
    }

    .p-button-warn:focus-visible {
        outline-color: dt('button.warn.focus.ring.color');
        box-shadow: dt('button.warn.focus.ring.shadow');
    }

    .p-button-help {
        background: dt('button.help.background');
        border: 1px solid dt('button.help.border.color');
        color: dt('button.help.color');
    }

    .p-button-help:not(:disabled):hover {
        background: dt('button.help.hover.background');
        border: 1px solid dt('button.help.hover.border.color');
        color: dt('button.help.hover.color');
    }

    .p-button-help:not(:disabled):active {
        background: dt('button.help.active.background');
        border: 1px solid dt('button.help.active.border.color');
        color: dt('button.help.active.color');
    }

    .p-button-help:focus-visible {
        outline-color: dt('button.help.focus.ring.color');
        box-shadow: dt('button.help.focus.ring.shadow');
    }

    .p-button-danger {
        background: dt('button.danger.background');
        border: 1px solid dt('button.danger.border.color');
        color: dt('button.danger.color');
    }

    .p-button-danger:not(:disabled):hover {
        background: dt('button.danger.hover.background');
        border: 1px solid dt('button.danger.hover.border.color');
        color: dt('button.danger.hover.color');
    }

    .p-button-danger:not(:disabled):active {
        background: dt('button.danger.active.background');
        border: 1px solid dt('button.danger.active.border.color');
        color: dt('button.danger.active.color');
    }

    .p-button-danger:focus-visible {
        outline-color: dt('button.danger.focus.ring.color');
        box-shadow: dt('button.danger.focus.ring.shadow');
    }

    .p-button-contrast {
        background: dt('button.contrast.background');
        border: 1px solid dt('button.contrast.border.color');
        color: dt('button.contrast.color');
    }

    .p-button-contrast:not(:disabled):hover {
        background: dt('button.contrast.hover.background');
        border: 1px solid dt('button.contrast.hover.border.color');
        color: dt('button.contrast.hover.color');
    }

    .p-button-contrast:not(:disabled):active {
        background: dt('button.contrast.active.background');
        border: 1px solid dt('button.contrast.active.border.color');
        color: dt('button.contrast.active.color');
    }

    .p-button-contrast:focus-visible {
        outline-color: dt('button.contrast.focus.ring.color');
        box-shadow: dt('button.contrast.focus.ring.shadow');
    }

    .p-button-outlined {
        background: transparent;
        border-color: dt('button.outlined.primary.border.color');
        color: dt('button.outlined.primary.color');
    }

    .p-button-outlined:not(:disabled):hover {
        background: dt('button.outlined.primary.hover.background');
        border-color: dt('button.outlined.primary.border.color');
        color: dt('button.outlined.primary.color');
    }

    .p-button-outlined:not(:disabled):active {
        background: dt('button.outlined.primary.active.background');
        border-color: dt('button.outlined.primary.border.color');
        color: dt('button.outlined.primary.color');
    }

    .p-button-outlined.p-button-secondary {
        border-color: dt('button.outlined.secondary.border.color');
        color: dt('button.outlined.secondary.color');
    }

    .p-button-outlined.p-button-secondary:not(:disabled):hover {
        background: dt('button.outlined.secondary.hover.background');
        border-color: dt('button.outlined.secondary.border.color');
        color: dt('button.outlined.secondary.color');
    }

    .p-button-outlined.p-button-secondary:not(:disabled):active {
        background: dt('button.outlined.secondary.active.background');
        border-color: dt('button.outlined.secondary.border.color');
        color: dt('button.outlined.secondary.color');
    }

    .p-button-outlined.p-button-success {
        border-color: dt('button.outlined.success.border.color');
        color: dt('button.outlined.success.color');
    }

    .p-button-outlined.p-button-success:not(:disabled):hover {
        background: dt('button.outlined.success.hover.background');
        border-color: dt('button.outlined.success.border.color');
        color: dt('button.outlined.success.color');
    }

    .p-button-outlined.p-button-success:not(:disabled):active {
        background: dt('button.outlined.success.active.background');
        border-color: dt('button.outlined.success.border.color');
        color: dt('button.outlined.success.color');
    }

    .p-button-outlined.p-button-info {
        border-color: dt('button.outlined.info.border.color');
        color: dt('button.outlined.info.color');
    }

    .p-button-outlined.p-button-info:not(:disabled):hover {
        background: dt('button.outlined.info.hover.background');
        border-color: dt('button.outlined.info.border.color');
        color: dt('button.outlined.info.color');
    }

    .p-button-outlined.p-button-info:not(:disabled):active {
        background: dt('button.outlined.info.active.background');
        border-color: dt('button.outlined.info.border.color');
        color: dt('button.outlined.info.color');
    }

    .p-button-outlined.p-button-warn {
        border-color: dt('button.outlined.warn.border.color');
        color: dt('button.outlined.warn.color');
    }

    .p-button-outlined.p-button-warn:not(:disabled):hover {
        background: dt('button.outlined.warn.hover.background');
        border-color: dt('button.outlined.warn.border.color');
        color: dt('button.outlined.warn.color');
    }

    .p-button-outlined.p-button-warn:not(:disabled):active {
        background: dt('button.outlined.warn.active.background');
        border-color: dt('button.outlined.warn.border.color');
        color: dt('button.outlined.warn.color');
    }

    .p-button-outlined.p-button-help {
        border-color: dt('button.outlined.help.border.color');
        color: dt('button.outlined.help.color');
    }

    .p-button-outlined.p-button-help:not(:disabled):hover {
        background: dt('button.outlined.help.hover.background');
        border-color: dt('button.outlined.help.border.color');
        color: dt('button.outlined.help.color');
    }

    .p-button-outlined.p-button-help:not(:disabled):active {
        background: dt('button.outlined.help.active.background');
        border-color: dt('button.outlined.help.border.color');
        color: dt('button.outlined.help.color');
    }

    .p-button-outlined.p-button-danger {
        border-color: dt('button.outlined.danger.border.color');
        color: dt('button.outlined.danger.color');
    }

    .p-button-outlined.p-button-danger:not(:disabled):hover {
        background: dt('button.outlined.danger.hover.background');
        border-color: dt('button.outlined.danger.border.color');
        color: dt('button.outlined.danger.color');
    }

    .p-button-outlined.p-button-danger:not(:disabled):active {
        background: dt('button.outlined.danger.active.background');
        border-color: dt('button.outlined.danger.border.color');
        color: dt('button.outlined.danger.color');
    }

    .p-button-outlined.p-button-contrast {
        border-color: dt('button.outlined.contrast.border.color');
        color: dt('button.outlined.contrast.color');
    }

    .p-button-outlined.p-button-contrast:not(:disabled):hover {
        background: dt('button.outlined.contrast.hover.background');
        border-color: dt('button.outlined.contrast.border.color');
        color: dt('button.outlined.contrast.color');
    }

    .p-button-outlined.p-button-contrast:not(:disabled):active {
        background: dt('button.outlined.contrast.active.background');
        border-color: dt('button.outlined.contrast.border.color');
        color: dt('button.outlined.contrast.color');
    }

    .p-button-outlined.p-button-plain {
        border-color: dt('button.outlined.plain.border.color');
        color: dt('button.outlined.plain.color');
    }

    .p-button-outlined.p-button-plain:not(:disabled):hover {
        background: dt('button.outlined.plain.hover.background');
        border-color: dt('button.outlined.plain.border.color');
        color: dt('button.outlined.plain.color');
    }

    .p-button-outlined.p-button-plain:not(:disabled):active {
        background: dt('button.outlined.plain.active.background');
        border-color: dt('button.outlined.plain.border.color');
        color: dt('button.outlined.plain.color');
    }

    .p-button-text {
        background: transparent;
        border-color: transparent;
        color: dt('button.text.primary.color');
    }

    .p-button-text:not(:disabled):hover {
        background: dt('button.text.primary.hover.background');
        border-color: transparent;
        color: dt('button.text.primary.color');
    }

    .p-button-text:not(:disabled):active {
        background: dt('button.text.primary.active.background');
        border-color: transparent;
        color: dt('button.text.primary.color');
    }

    .p-button-text.p-button-secondary {
        background: transparent;
        border-color: transparent;
        color: dt('button.text.secondary.color');
    }

    .p-button-text.p-button-secondary:not(:disabled):hover {
        background: dt('button.text.secondary.hover.background');
        border-color: transparent;
        color: dt('button.text.secondary.color');
    }

    .p-button-text.p-button-secondary:not(:disabled):active {
        background: dt('button.text.secondary.active.background');
        border-color: transparent;
        color: dt('button.text.secondary.color');
    }

    .p-button-text.p-button-success {
        background: transparent;
        border-color: transparent;
        color: dt('button.text.success.color');
    }

    .p-button-text.p-button-success:not(:disabled):hover {
        background: dt('button.text.success.hover.background');
        border-color: transparent;
        color: dt('button.text.success.color');
    }

    .p-button-text.p-button-success:not(:disabled):active {
        background: dt('button.text.success.active.background');
        border-color: transparent;
        color: dt('button.text.success.color');
    }

    .p-button-text.p-button-info {
        background: transparent;
        border-color: transparent;
        color: dt('button.text.info.color');
    }

    .p-button-text.p-button-info:not(:disabled):hover {
        background: dt('button.text.info.hover.background');
        border-color: transparent;
        color: dt('button.text.info.color');
    }

    .p-button-text.p-button-info:not(:disabled):active {
        background: dt('button.text.info.active.background');
        border-color: transparent;
        color: dt('button.text.info.color');
    }

    .p-button-text.p-button-warn {
        background: transparent;
        border-color: transparent;
        color: dt('button.text.warn.color');
    }

    .p-button-text.p-button-warn:not(:disabled):hover {
        background: dt('button.text.warn.hover.background');
        border-color: transparent;
        color: dt('button.text.warn.color');
    }

    .p-button-text.p-button-warn:not(:disabled):active {
        background: dt('button.text.warn.active.background');
        border-color: transparent;
        color: dt('button.text.warn.color');
    }

    .p-button-text.p-button-help {
        background: transparent;
        border-color: transparent;
        color: dt('button.text.help.color');
    }

    .p-button-text.p-button-help:not(:disabled):hover {
        background: dt('button.text.help.hover.background');
        border-color: transparent;
        color: dt('button.text.help.color');
    }

    .p-button-text.p-button-help:not(:disabled):active {
        background: dt('button.text.help.active.background');
        border-color: transparent;
        color: dt('button.text.help.color');
    }

    .p-button-text.p-button-danger {
        background: transparent;
        border-color: transparent;
        color: dt('button.text.danger.color');
    }

    .p-button-text.p-button-danger:not(:disabled):hover {
        background: dt('button.text.danger.hover.background');
        border-color: transparent;
        color: dt('button.text.danger.color');
    }

    .p-button-text.p-button-danger:not(:disabled):active {
        background: dt('button.text.danger.active.background');
        border-color: transparent;
        color: dt('button.text.danger.color');
    }

    .p-button-text.p-button-contrast {
        background: transparent;
        border-color: transparent;
        color: dt('button.text.contrast.color');
    }

    .p-button-text.p-button-contrast:not(:disabled):hover {
        background: dt('button.text.contrast.hover.background');
        border-color: transparent;
        color: dt('button.text.contrast.color');
    }

    .p-button-text.p-button-contrast:not(:disabled):active {
        background: dt('button.text.contrast.active.background');
        border-color: transparent;
        color: dt('button.text.contrast.color');
    }

    .p-button-text.p-button-plain {
        background: transparent;
        border-color: transparent;
        color: dt('button.text.plain.color');
    }

    .p-button-text.p-button-plain:not(:disabled):hover {
        background: dt('button.text.plain.hover.background');
        border-color: transparent;
        color: dt('button.text.plain.color');
    }

    .p-button-text.p-button-plain:not(:disabled):active {
        background: dt('button.text.plain.active.background');
        border-color: transparent;
        color: dt('button.text.plain.color');
    }

    .p-button-link {
        background: transparent;
        border-color: transparent;
        color: dt('button.link.color');
    }

    .p-button-link:not(:disabled):hover {
        background: transparent;
        border-color: transparent;
        color: dt('button.link.hover.color');
    }

    .p-button-link:not(:disabled):hover .p-button-label {
        text-decoration: underline;
    }

    .p-button-link:not(:disabled):active {
        background: transparent;
        border-color: transparent;
        color: dt('button.link.active.color');
    }
`;
function Gn(e) {
  "@babel/helpers - typeof";
  return Gn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Gn(e);
}
function mt(e, t, n) {
  return (t = Hy(t)) in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Hy(e) {
  var t = Ky(e, "string");
  return Gn(t) == "symbol" ? t : t + "";
}
function Ky(e, t) {
  if (Gn(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var o = n.call(e, t);
    if (Gn(o) != "object") return o;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var Wy = {
  root: function(t) {
    var n = t.instance, o = t.props;
    return ["p-button p-component", mt(mt(mt(mt(mt(mt(mt(mt(mt({
      "p-button-icon-only": n.hasIcon && !o.label && !o.badge,
      "p-button-vertical": (o.iconPos === "top" || o.iconPos === "bottom") && o.label,
      "p-button-loading": o.loading,
      "p-button-link": o.link || o.variant === "link"
    }, "p-button-".concat(o.severity), o.severity), "p-button-raised", o.raised), "p-button-rounded", o.rounded), "p-button-text", o.text || o.variant === "text"), "p-button-outlined", o.outlined || o.variant === "outlined"), "p-button-sm", o.size === "small"), "p-button-lg", o.size === "large"), "p-button-plain", o.plain), "p-button-fluid", n.hasFluid)];
  },
  loadingIcon: "p-button-loading-icon",
  icon: function(t) {
    var n = t.props;
    return ["p-button-icon", mt({}, "p-button-icon-".concat(n.iconPos), n.label)];
  },
  label: "p-button-label"
}, Yy = oe.extend({
  name: "button",
  style: Uy,
  classes: Wy
}), Gy = {
  name: "BaseButton",
  extends: nt,
  props: {
    label: {
      type: String,
      default: null
    },
    icon: {
      type: String,
      default: null
    },
    iconPos: {
      type: String,
      default: "left"
    },
    iconClass: {
      type: [String, Object],
      default: null
    },
    badge: {
      type: String,
      default: null
    },
    badgeClass: {
      type: [String, Object],
      default: null
    },
    badgeSeverity: {
      type: String,
      default: "secondary"
    },
    loading: {
      type: Boolean,
      default: !1
    },
    loadingIcon: {
      type: String,
      default: void 0
    },
    as: {
      type: [String, Object],
      default: "BUTTON"
    },
    asChild: {
      type: Boolean,
      default: !1
    },
    link: {
      type: Boolean,
      default: !1
    },
    severity: {
      type: String,
      default: null
    },
    raised: {
      type: Boolean,
      default: !1
    },
    rounded: {
      type: Boolean,
      default: !1
    },
    text: {
      type: Boolean,
      default: !1
    },
    outlined: {
      type: Boolean,
      default: !1
    },
    size: {
      type: String,
      default: null
    },
    variant: {
      type: String,
      default: null
    },
    plain: {
      type: Boolean,
      default: !1
    },
    fluid: {
      type: Boolean,
      default: null
    }
  },
  style: Yy,
  provide: function() {
    return {
      $pcButton: this,
      $parentInstance: this
    };
  }
};
function qn(e) {
  "@babel/helpers - typeof";
  return qn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, qn(e);
}
function Ke(e, t, n) {
  return (t = qy(t)) in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function qy(e) {
  var t = Zy(e, "string");
  return qn(t) == "symbol" ? t : t + "";
}
function Zy(e, t) {
  if (qn(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var o = n.call(e, t);
    if (qn(o) != "object") return o;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var bt = {
  name: "Button",
  extends: Gy,
  inheritAttrs: !1,
  inject: {
    $pcFluid: {
      default: null
    }
  },
  methods: {
    getPTOptions: function(t) {
      var n = t === "root" ? this.ptmi : this.ptm;
      return n(t, {
        context: {
          disabled: this.disabled
        }
      });
    }
  },
  computed: {
    disabled: function() {
      return this.$attrs.disabled || this.$attrs.disabled === "" || this.loading;
    },
    defaultAriaLabel: function() {
      return this.label ? this.label + (this.badge ? " " + this.badge : "") : this.$attrs.ariaLabel;
    },
    hasIcon: function() {
      return this.icon || this.$slots.icon;
    },
    attrs: function() {
      return x(this.asAttrs, this.a11yAttrs, this.getPTOptions("root"));
    },
    asAttrs: function() {
      return this.as === "BUTTON" ? {
        type: "button",
        disabled: this.disabled
      } : void 0;
    },
    a11yAttrs: function() {
      return {
        "aria-label": this.defaultAriaLabel,
        "data-pc-name": "button",
        "data-p-disabled": this.disabled,
        "data-p-severity": this.severity
      };
    },
    hasFluid: function() {
      return Jt(this.fluid) ? !!this.$pcFluid : this.fluid;
    },
    dataP: function() {
      return Pe(Ke(Ke(Ke(Ke(Ke(Ke(Ke(Ke(Ke(Ke({}, this.size, this.size), "icon-only", this.hasIcon && !this.label && !this.badge), "loading", this.loading), "fluid", this.hasFluid), "rounded", this.rounded), "raised", this.raised), "outlined", this.outlined || this.variant === "outlined"), "text", this.text || this.variant === "text"), "link", this.link || this.variant === "link"), "vertical", (this.iconPos === "top" || this.iconPos === "bottom") && this.label));
    },
    dataIconP: function() {
      return Pe(Ke(Ke({}, this.iconPos, this.iconPos), this.size, this.size));
    },
    dataLabelP: function() {
      return Pe(Ke(Ke({}, this.size, this.size), "icon-only", this.hasIcon && !this.label && !this.badge));
    }
  },
  components: {
    SpinnerIcon: Ko,
    Badge: ul
  },
  directives: {
    ripple: fo
  }
}, Xy = ["data-p"], Jy = ["data-p"];
function Qy(e, t, n, o, i, r) {
  var a = ze("SpinnerIcon"), d = ze("Badge"), l = uo("ripple");
  return e.asChild ? R(e.$slots, "default", {
    key: 1,
    class: ee(e.cx("root")),
    a11yAttrs: r.a11yAttrs
  }) : Ze((m(), j($e(e.as), x({
    key: 0,
    class: e.cx("root"),
    "data-p": r.dataP
  }, r.attrs), {
    default: U(function() {
      return [R(e.$slots, "default", {}, function() {
        return [e.loading ? R(e.$slots, "loadingicon", x({
          key: 0,
          class: [e.cx("loadingIcon"), e.cx("icon")]
        }, e.ptm("loadingIcon")), function() {
          return [e.loadingIcon ? (m(), h("span", x({
            key: 0,
            class: [e.cx("loadingIcon"), e.cx("icon"), e.loadingIcon]
          }, e.ptm("loadingIcon")), null, 16)) : (m(), j(a, x({
            key: 1,
            class: [e.cx("loadingIcon"), e.cx("icon")],
            spin: ""
          }, e.ptm("loadingIcon")), null, 16, ["class"]))];
        }) : R(e.$slots, "icon", x({
          key: 1,
          class: [e.cx("icon")]
        }, e.ptm("icon")), function() {
          return [e.icon ? (m(), h("span", x({
            key: 0,
            class: [e.cx("icon"), e.icon, e.iconClass],
            "data-p": r.dataIconP
          }, e.ptm("icon")), null, 16, Xy)) : B("", !0)];
        }), e.label ? (m(), h("span", x({
          key: 2,
          class: e.cx("label")
        }, e.ptm("label"), {
          "data-p": r.dataLabelP
        }), y(e.label), 17, Jy)) : B("", !0), e.badge ? (m(), j(d, {
          key: 3,
          value: e.badge,
          class: ee(e.badgeClass),
          severity: e.badgeSeverity,
          unstyled: e.unstyled,
          pt: e.ptm("pcBadge")
        }, null, 8, ["value", "class", "severity", "unstyled", "pt"])) : B("", !0)];
      })];
    }),
    _: 3
  }, 16, ["class", "data-p"])), [[l]]);
}
bt.render = Qy;
const e1 = {
  viewBox: "0 0 24 24",
  width: "1.2em",
  height: "1.2em"
};
function t1(e, t) {
  return m(), h("svg", e1, [...t[0] || (t[0] = [
    g("path", {
      fill: "currentColor",
      d: "M5 6h18v12H5zm9 3a3 3 0 0 1 3 3a3 3 0 0 1-3 3a3 3 0 0 1-3-3a3 3 0 0 1 3-3M9 8a2 2 0 0 1-2 2v4a2 2 0 0 1 2 2h10a2 2 0 0 1 2-2v-4a2 2 0 0 1-2-2zm-8 2h2v10h16v2H1z"
    }, null, -1)
  ])]);
}
const n1 = Se({ name: "mdi-cash-multiple", render: t1 }), o1 = {
  viewBox: "0 0 24 24",
  width: "1.2em",
  height: "1.2em"
};
function r1(e, t) {
  return m(), h("svg", o1, [...t[0] || (t[0] = [
    g("path", {
      fill: "currentColor",
      d: "M22 10V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v4a2 2 0 1 1 0 4v4c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-4c-1.1 0-2-.9-2-2s.9-2 2-2m-2-1.46c-1.19.69-2 1.99-2 3.46s.81 2.77 2 3.46V18H4v-2.54c1.19-.69 2-1.99 2-3.46c0-1.5-.8-2.77-2-3.46V6h16zM11 15h2v2h-2m0-6h2v2h-2m0-6h2v2h-2Z"
    }, null, -1)
  ])]);
}
const cl = Se({ name: "mdi-ticket-confirmation-outline", render: r1 }), i1 = {
  viewBox: "0 0 24 24",
  width: "1.2em",
  height: "1.2em"
};
function a1(e, t) {
  return m(), h("svg", i1, [...t[0] || (t[0] = [
    g("path", {
      fill: "currentColor",
      d: "m21.41 11.58l-9-9A2 2 0 0 0 11 2H4a2 2 0 0 0-2 2v7a2 2 0 0 0 .59 1.42l9 9A2 2 0 0 0 13 22a2 2 0 0 0 1.41-.59l7-7A2 2 0 0 0 22 13a2 2 0 0 0-.59-1.42M13 20l-9-9V4h7l9 9M6.5 5A1.5 1.5 0 1 1 5 6.5A1.5 1.5 0 0 1 6.5 5"
    }, null, -1)
  ])]);
}
const l1 = Se({ name: "mdi-tag-outline", render: a1 });
var Wo = {
  name: "TimesIcon",
  extends: Ue
};
function s1(e) {
  return p1(e) || c1(e) || u1(e) || d1();
}
function d1() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function u1(e, t) {
  if (e) {
    if (typeof e == "string") return vr(e, t);
    var n = {}.toString.call(e).slice(8, -1);
    return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? vr(e, t) : void 0;
  }
}
function c1(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function p1(e) {
  if (Array.isArray(e)) return vr(e);
}
function vr(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, o = Array(t); n < t; n++) o[n] = e[n];
  return o;
}
function m1(e, t, n, o, i, r) {
  return m(), h("svg", x({
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.pti()), s1(t[0] || (t[0] = [g("path", {
    d: "M8.01186 7.00933L12.27 2.75116C12.341 2.68501 12.398 2.60524 12.4375 2.51661C12.4769 2.42798 12.4982 2.3323 12.4999 2.23529C12.5016 2.13827 12.4838 2.0419 12.4474 1.95194C12.4111 1.86197 12.357 1.78024 12.2884 1.71163C12.2198 1.64302 12.138 1.58893 12.0481 1.55259C11.9581 1.51625 11.8617 1.4984 11.7647 1.50011C11.6677 1.50182 11.572 1.52306 11.4834 1.56255C11.3948 1.60204 11.315 1.65898 11.2488 1.72997L6.99067 5.98814L2.7325 1.72997C2.59553 1.60234 2.41437 1.53286 2.22718 1.53616C2.03999 1.53946 1.8614 1.61529 1.72901 1.74767C1.59663 1.88006 1.5208 2.05865 1.5175 2.24584C1.5142 2.43303 1.58368 2.61419 1.71131 2.75116L5.96948 7.00933L1.71131 11.2675C1.576 11.403 1.5 11.5866 1.5 11.7781C1.5 11.9696 1.576 12.1532 1.71131 12.2887C1.84679 12.424 2.03043 12.5 2.2219 12.5C2.41338 12.5 2.59702 12.424 2.7325 12.2887L6.99067 8.03052L11.2488 12.2887C11.3843 12.424 11.568 12.5 11.7594 12.5C11.9509 12.5 12.1346 12.424 12.27 12.2887C12.4053 12.1532 12.4813 11.9696 12.4813 11.7781C12.4813 11.5866 12.4053 11.403 12.27 11.2675L8.01186 7.00933Z",
    fill: "currentColor"
  }, null, -1)])), 16);
}
Wo.render = m1;
var f1 = `
    .p-message {
        border-radius: dt('message.border.radius');
        outline-width: dt('message.border.width');
        outline-style: solid;
    }

    .p-message-content {
        display: flex;
        align-items: center;
        padding: dt('message.content.padding');
        gap: dt('message.content.gap');
        height: 100%;
    }

    .p-message-icon {
        flex-shrink: 0;
    }

    .p-message-close-button {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        margin-inline-start: auto;
        overflow: hidden;
        position: relative;
        width: dt('message.close.button.width');
        height: dt('message.close.button.height');
        border-radius: dt('message.close.button.border.radius');
        background: transparent;
        transition:
            background dt('message.transition.duration'),
            color dt('message.transition.duration'),
            outline-color dt('message.transition.duration'),
            box-shadow dt('message.transition.duration'),
            opacity 0.3s;
        outline-color: transparent;
        color: inherit;
        padding: 0;
        border: none;
        cursor: pointer;
        user-select: none;
    }

    .p-message-close-icon {
        font-size: dt('message.close.icon.size');
        width: dt('message.close.icon.size');
        height: dt('message.close.icon.size');
    }

    .p-message-close-button:focus-visible {
        outline-width: dt('message.close.button.focus.ring.width');
        outline-style: dt('message.close.button.focus.ring.style');
        outline-offset: dt('message.close.button.focus.ring.offset');
    }

    .p-message-info {
        background: dt('message.info.background');
        outline-color: dt('message.info.border.color');
        color: dt('message.info.color');
        box-shadow: dt('message.info.shadow');
    }

    .p-message-info .p-message-close-button:focus-visible {
        outline-color: dt('message.info.close.button.focus.ring.color');
        box-shadow: dt('message.info.close.button.focus.ring.shadow');
    }

    .p-message-info .p-message-close-button:hover {
        background: dt('message.info.close.button.hover.background');
    }

    .p-message-info.p-message-outlined {
        color: dt('message.info.outlined.color');
        outline-color: dt('message.info.outlined.border.color');
    }

    .p-message-info.p-message-simple {
        color: dt('message.info.simple.color');
    }

    .p-message-success {
        background: dt('message.success.background');
        outline-color: dt('message.success.border.color');
        color: dt('message.success.color');
        box-shadow: dt('message.success.shadow');
    }

    .p-message-success .p-message-close-button:focus-visible {
        outline-color: dt('message.success.close.button.focus.ring.color');
        box-shadow: dt('message.success.close.button.focus.ring.shadow');
    }

    .p-message-success .p-message-close-button:hover {
        background: dt('message.success.close.button.hover.background');
    }

    .p-message-success.p-message-outlined {
        color: dt('message.success.outlined.color');
        outline-color: dt('message.success.outlined.border.color');
    }

    .p-message-success.p-message-simple {
        color: dt('message.success.simple.color');
    }

    .p-message-warn {
        background: dt('message.warn.background');
        outline-color: dt('message.warn.border.color');
        color: dt('message.warn.color');
        box-shadow: dt('message.warn.shadow');
    }

    .p-message-warn .p-message-close-button:focus-visible {
        outline-color: dt('message.warn.close.button.focus.ring.color');
        box-shadow: dt('message.warn.close.button.focus.ring.shadow');
    }

    .p-message-warn .p-message-close-button:hover {
        background: dt('message.warn.close.button.hover.background');
    }

    .p-message-warn.p-message-outlined {
        color: dt('message.warn.outlined.color');
        outline-color: dt('message.warn.outlined.border.color');
    }

    .p-message-warn.p-message-simple {
        color: dt('message.warn.simple.color');
    }

    .p-message-error {
        background: dt('message.error.background');
        outline-color: dt('message.error.border.color');
        color: dt('message.error.color');
        box-shadow: dt('message.error.shadow');
    }

    .p-message-error .p-message-close-button:focus-visible {
        outline-color: dt('message.error.close.button.focus.ring.color');
        box-shadow: dt('message.error.close.button.focus.ring.shadow');
    }

    .p-message-error .p-message-close-button:hover {
        background: dt('message.error.close.button.hover.background');
    }

    .p-message-error.p-message-outlined {
        color: dt('message.error.outlined.color');
        outline-color: dt('message.error.outlined.border.color');
    }

    .p-message-error.p-message-simple {
        color: dt('message.error.simple.color');
    }

    .p-message-secondary {
        background: dt('message.secondary.background');
        outline-color: dt('message.secondary.border.color');
        color: dt('message.secondary.color');
        box-shadow: dt('message.secondary.shadow');
    }

    .p-message-secondary .p-message-close-button:focus-visible {
        outline-color: dt('message.secondary.close.button.focus.ring.color');
        box-shadow: dt('message.secondary.close.button.focus.ring.shadow');
    }

    .p-message-secondary .p-message-close-button:hover {
        background: dt('message.secondary.close.button.hover.background');
    }

    .p-message-secondary.p-message-outlined {
        color: dt('message.secondary.outlined.color');
        outline-color: dt('message.secondary.outlined.border.color');
    }

    .p-message-secondary.p-message-simple {
        color: dt('message.secondary.simple.color');
    }

    .p-message-contrast {
        background: dt('message.contrast.background');
        outline-color: dt('message.contrast.border.color');
        color: dt('message.contrast.color');
        box-shadow: dt('message.contrast.shadow');
    }

    .p-message-contrast .p-message-close-button:focus-visible {
        outline-color: dt('message.contrast.close.button.focus.ring.color');
        box-shadow: dt('message.contrast.close.button.focus.ring.shadow');
    }

    .p-message-contrast .p-message-close-button:hover {
        background: dt('message.contrast.close.button.hover.background');
    }

    .p-message-contrast.p-message-outlined {
        color: dt('message.contrast.outlined.color');
        outline-color: dt('message.contrast.outlined.border.color');
    }

    .p-message-contrast.p-message-simple {
        color: dt('message.contrast.simple.color');
    }

    .p-message-text {
        font-size: dt('message.text.font.size');
        font-weight: dt('message.text.font.weight');
    }

    .p-message-icon {
        font-size: dt('message.icon.size');
        width: dt('message.icon.size');
        height: dt('message.icon.size');
    }

    .p-message-enter-from {
        opacity: 0;
    }

    .p-message-enter-active {
        transition: opacity 0.3s;
    }

    .p-message.p-message-leave-from {
        max-height: 1000px;
    }

    .p-message.p-message-leave-to {
        max-height: 0;
        opacity: 0;
        margin: 0;
    }

    .p-message-leave-active {
        overflow: hidden;
        transition:
            max-height 0.45s cubic-bezier(0, 1, 0, 1),
            opacity 0.3s,
            margin 0.3s;
    }

    .p-message-leave-active .p-message-close-button {
        opacity: 0;
    }

    .p-message-sm .p-message-content {
        padding: dt('message.content.sm.padding');
    }

    .p-message-sm .p-message-text {
        font-size: dt('message.text.sm.font.size');
    }

    .p-message-sm .p-message-icon {
        font-size: dt('message.icon.sm.size');
        width: dt('message.icon.sm.size');
        height: dt('message.icon.sm.size');
    }

    .p-message-sm .p-message-close-icon {
        font-size: dt('message.close.icon.sm.size');
        width: dt('message.close.icon.sm.size');
        height: dt('message.close.icon.sm.size');
    }

    .p-message-lg .p-message-content {
        padding: dt('message.content.lg.padding');
    }

    .p-message-lg .p-message-text {
        font-size: dt('message.text.lg.font.size');
    }

    .p-message-lg .p-message-icon {
        font-size: dt('message.icon.lg.size');
        width: dt('message.icon.lg.size');
        height: dt('message.icon.lg.size');
    }

    .p-message-lg .p-message-close-icon {
        font-size: dt('message.close.icon.lg.size');
        width: dt('message.close.icon.lg.size');
        height: dt('message.close.icon.lg.size');
    }

    .p-message-outlined {
        background: transparent;
        outline-width: dt('message.outlined.border.width');
    }

    .p-message-simple {
        background: transparent;
        outline-color: transparent;
        box-shadow: none;
    }

    .p-message-simple .p-message-content {
        padding: dt('message.simple.content.padding');
    }

    .p-message-outlined .p-message-close-button:hover,
    .p-message-simple .p-message-close-button:hover {
        background: transparent;
    }
`, g1 = {
  root: function(t) {
    var n = t.props;
    return ["p-message p-component p-message-" + n.severity, {
      "p-message-outlined": n.variant === "outlined",
      "p-message-simple": n.variant === "simple",
      "p-message-sm": n.size === "small",
      "p-message-lg": n.size === "large"
    }];
  },
  content: "p-message-content",
  icon: "p-message-icon",
  text: "p-message-text",
  closeButton: "p-message-close-button",
  closeIcon: "p-message-close-icon"
}, h1 = oe.extend({
  name: "message",
  style: f1,
  classes: g1
}), b1 = {
  name: "BaseMessage",
  extends: nt,
  props: {
    severity: {
      type: String,
      default: "info"
    },
    closable: {
      type: Boolean,
      default: !1
    },
    life: {
      type: Number,
      default: null
    },
    icon: {
      type: String,
      default: void 0
    },
    closeIcon: {
      type: String,
      default: void 0
    },
    closeButtonProps: {
      type: null,
      default: null
    },
    size: {
      type: String,
      default: null
    },
    variant: {
      type: String,
      default: null
    }
  },
  style: h1,
  provide: function() {
    return {
      $pcMessage: this,
      $parentInstance: this
    };
  }
};
function Zn(e) {
  "@babel/helpers - typeof";
  return Zn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Zn(e);
}
function Qi(e, t, n) {
  return (t = v1(t)) in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function v1(e) {
  var t = y1(e, "string");
  return Zn(t) == "symbol" ? t : t + "";
}
function y1(e, t) {
  if (Zn(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var o = n.call(e, t);
    if (Zn(o) != "object") return o;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var Ft = {
  name: "Message",
  extends: b1,
  inheritAttrs: !1,
  emits: ["close", "life-end"],
  timeout: null,
  data: function() {
    return {
      visible: !0
    };
  },
  mounted: function() {
    var t = this;
    this.life && setTimeout(function() {
      t.visible = !1, t.$emit("life-end");
    }, this.life);
  },
  methods: {
    close: function(t) {
      this.visible = !1, this.$emit("close", t);
    }
  },
  computed: {
    closeAriaLabel: function() {
      return this.$primevue.config.locale.aria ? this.$primevue.config.locale.aria.close : void 0;
    },
    dataP: function() {
      return Pe(Qi(Qi({
        outlined: this.variant === "outlined",
        simple: this.variant === "simple"
      }, this.severity, this.severity), this.size, this.size));
    }
  },
  directives: {
    ripple: fo
  },
  components: {
    TimesIcon: Wo
  }
};
function Xn(e) {
  "@babel/helpers - typeof";
  return Xn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Xn(e);
}
function ea(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    t && (o = o.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, o);
  }
  return n;
}
function ta(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ea(Object(n), !0).forEach(function(o) {
      k1(e, o, n[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : ea(Object(n)).forEach(function(o) {
      Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(n, o));
    });
  }
  return e;
}
function k1(e, t, n) {
  return (t = w1(t)) in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function w1(e) {
  var t = x1(e, "string");
  return Xn(t) == "symbol" ? t : t + "";
}
function x1(e, t) {
  if (Xn(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var o = n.call(e, t);
    if (Xn(o) != "object") return o;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var C1 = ["data-p"], S1 = ["data-p"], $1 = ["data-p"], B1 = ["aria-label", "data-p"], T1 = ["data-p"];
function I1(e, t, n, o, i, r) {
  var a = ze("TimesIcon"), d = uo("ripple");
  return m(), j(Cn, x({
    name: "p-message",
    appear: ""
  }, e.ptmi("transition")), {
    default: U(function() {
      return [Ze(g("div", x({
        class: e.cx("root"),
        role: "alert",
        "aria-live": "assertive",
        "aria-atomic": "true",
        "data-p": r.dataP
      }, e.ptm("root")), [e.$slots.container ? R(e.$slots, "container", {
        key: 0,
        closeCallback: r.close
      }) : (m(), h("div", x({
        key: 1,
        class: e.cx("content"),
        "data-p": r.dataP
      }, e.ptm("content")), [R(e.$slots, "icon", {
        class: ee(e.cx("icon"))
      }, function() {
        return [(m(), j($e(e.icon ? "span" : null), x({
          class: [e.cx("icon"), e.icon],
          "data-p": r.dataP
        }, e.ptm("icon")), null, 16, ["class", "data-p"]))];
      }), e.$slots.default ? (m(), h("div", x({
        key: 0,
        class: e.cx("text"),
        "data-p": r.dataP
      }, e.ptm("text")), [R(e.$slots, "default")], 16, $1)) : B("", !0), e.closable ? Ze((m(), h("button", x({
        key: 1,
        class: e.cx("closeButton"),
        "aria-label": r.closeAriaLabel,
        type: "button",
        onClick: t[0] || (t[0] = function(l) {
          return r.close(l);
        }),
        "data-p": r.dataP
      }, ta(ta({}, e.closeButtonProps), e.ptm("closeButton"))), [R(e.$slots, "closeicon", {}, function() {
        return [e.closeIcon ? (m(), h("i", x({
          key: 0,
          class: [e.cx("closeIcon"), e.closeIcon],
          "data-p": r.dataP
        }, e.ptm("closeIcon")), null, 16, T1)) : (m(), j(a, x({
          key: 1,
          class: [e.cx("closeIcon"), e.closeIcon],
          "data-p": r.dataP
        }, e.ptm("closeIcon")), null, 16, ["class", "data-p"]))];
      })], 16, B1)), [[d]]) : B("", !0)], 16, S1))], 16, C1), [[Fn, i.visible]])];
    }),
    _: 3
  }, 16);
}
Ft.render = I1;
var D1 = `
    .p-inputgroup,
    .p-inputgroup .p-iconfield,
    .p-inputgroup .p-floatlabel,
    .p-inputgroup .p-iftalabel {
        display: flex;
        align-items: stretch;
        width: 100%;
    }

    .p-inputgroup .p-inputtext,
    .p-inputgroup .p-inputwrapper {
        flex: 1 1 auto;
        width: 1%;
    }

    .p-inputgroupaddon {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: dt('inputgroup.addon.padding');
        background: dt('inputgroup.addon.background');
        color: dt('inputgroup.addon.color');
        border-block-start: 1px solid dt('inputgroup.addon.border.color');
        border-block-end: 1px solid dt('inputgroup.addon.border.color');
        min-width: dt('inputgroup.addon.min.width');
    }

    .p-inputgroupaddon:first-child,
    .p-inputgroupaddon + .p-inputgroupaddon {
        border-inline-start: 1px solid dt('inputgroup.addon.border.color');
    }

    .p-inputgroupaddon:last-child {
        border-inline-end: 1px solid dt('inputgroup.addon.border.color');
    }

    .p-inputgroupaddon:has(.p-button) {
        padding: 0;
        overflow: hidden;
    }

    .p-inputgroupaddon .p-button {
        border-radius: 0;
    }

    .p-inputgroup > .p-component,
    .p-inputgroup > .p-inputwrapper > .p-component,
    .p-inputgroup > .p-iconfield > .p-component,
    .p-inputgroup > .p-floatlabel > .p-component,
    .p-inputgroup > .p-floatlabel > .p-inputwrapper > .p-component,
    .p-inputgroup > .p-iftalabel > .p-component,
    .p-inputgroup > .p-iftalabel > .p-inputwrapper > .p-component {
        border-radius: 0;
        margin: 0;
    }

    .p-inputgroupaddon:first-child,
    .p-inputgroup > .p-component:first-child,
    .p-inputgroup > .p-inputwrapper:first-child > .p-component,
    .p-inputgroup > .p-iconfield:first-child > .p-component,
    .p-inputgroup > .p-floatlabel:first-child > .p-component,
    .p-inputgroup > .p-floatlabel:first-child > .p-inputwrapper > .p-component,
    .p-inputgroup > .p-iftalabel:first-child > .p-component,
    .p-inputgroup > .p-iftalabel:first-child > .p-inputwrapper > .p-component {
        border-start-start-radius: dt('inputgroup.addon.border.radius');
        border-end-start-radius: dt('inputgroup.addon.border.radius');
    }

    .p-inputgroupaddon:last-child,
    .p-inputgroup > .p-component:last-child,
    .p-inputgroup > .p-inputwrapper:last-child > .p-component,
    .p-inputgroup > .p-iconfield:last-child > .p-component,
    .p-inputgroup > .p-floatlabel:last-child > .p-component,
    .p-inputgroup > .p-floatlabel:last-child > .p-inputwrapper > .p-component,
    .p-inputgroup > .p-iftalabel:last-child > .p-component,
    .p-inputgroup > .p-iftalabel:last-child > .p-inputwrapper > .p-component {
        border-start-end-radius: dt('inputgroup.addon.border.radius');
        border-end-end-radius: dt('inputgroup.addon.border.radius');
    }

    .p-inputgroup .p-component:focus,
    .p-inputgroup .p-component.p-focus,
    .p-inputgroup .p-inputwrapper-focus,
    .p-inputgroup .p-component:focus ~ label,
    .p-inputgroup .p-component.p-focus ~ label,
    .p-inputgroup .p-inputwrapper-focus ~ label {
        z-index: 1;
    }

    .p-inputgroup > .p-button:not(.p-button-icon-only) {
        width: auto;
    }

    .p-inputgroup .p-iconfield + .p-iconfield .p-inputtext {
        border-inline-start: 0;
    }
`, P1 = {
  root: "p-inputgroup"
}, z1 = oe.extend({
  name: "inputgroup",
  style: D1,
  classes: P1
}), L1 = {
  name: "BaseInputGroup",
  extends: nt,
  style: z1,
  provide: function() {
    return {
      $pcInputGroup: this,
      $parentInstance: this
    };
  }
}, pl = {
  name: "InputGroup",
  extends: L1,
  inheritAttrs: !1
};
function O1(e, t, n, o, i, r) {
  return m(), h("div", x({
    class: e.cx("root")
  }, e.ptmi("root")), [R(e.$slots, "default")], 16);
}
pl.render = O1;
function Jn(e) {
  "@babel/helpers - typeof";
  return Jn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Jn(e);
}
function M1(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function A1(e, t) {
  for (var n = 0; n < t.length; n++) {
    var o = t[n];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, F1(o.key), o);
  }
}
function _1(e, t, n) {
  return t && A1(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function F1(e) {
  var t = E1(e, "string");
  return Jn(t) == "symbol" ? t : t + "";
}
function E1(e, t) {
  if (Jn(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var o = n.call(e, t);
    if (Jn(o) != "object") return o;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var ml = /* @__PURE__ */ (function() {
  function e(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : function() {
    };
    M1(this, e), this.element = t, this.listener = n;
  }
  return _1(e, [{
    key: "bindScrollListener",
    value: function() {
      this.scrollableParents = Ns(this.element);
      for (var n = 0; n < this.scrollableParents.length; n++)
        this.scrollableParents[n].addEventListener("scroll", this.listener);
    }
  }, {
    key: "unbindScrollListener",
    value: function() {
      if (this.scrollableParents)
        for (var n = 0; n < this.scrollableParents.length; n++)
          this.scrollableParents[n].removeEventListener("scroll", this.listener);
    }
  }, {
    key: "destroy",
    value: function() {
      this.unbindScrollListener(), this.element = null, this.listener = null, this.scrollableParents = null;
    }
  }]);
})(), fl = {
  name: "BlankIcon",
  extends: Ue
};
function R1(e) {
  return U1(e) || j1(e) || N1(e) || V1();
}
function V1() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function N1(e, t) {
  if (e) {
    if (typeof e == "string") return yr(e, t);
    var n = {}.toString.call(e).slice(8, -1);
    return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? yr(e, t) : void 0;
  }
}
function j1(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function U1(e) {
  if (Array.isArray(e)) return yr(e);
}
function yr(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, o = Array(t); n < t; n++) o[n] = e[n];
  return o;
}
function H1(e, t, n, o, i, r) {
  return m(), h("svg", x({
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.pti()), R1(t[0] || (t[0] = [g("rect", {
    width: "1",
    height: "1",
    fill: "currentColor",
    "fill-opacity": "0"
  }, null, -1)])), 16);
}
fl.render = H1;
var Zr = {
  name: "CheckIcon",
  extends: Ue
};
function K1(e) {
  return q1(e) || G1(e) || Y1(e) || W1();
}
function W1() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Y1(e, t) {
  if (e) {
    if (typeof e == "string") return kr(e, t);
    var n = {}.toString.call(e).slice(8, -1);
    return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? kr(e, t) : void 0;
  }
}
function G1(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function q1(e) {
  if (Array.isArray(e)) return kr(e);
}
function kr(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, o = Array(t); n < t; n++) o[n] = e[n];
  return o;
}
function Z1(e, t, n, o, i, r) {
  return m(), h("svg", x({
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.pti()), K1(t[0] || (t[0] = [g("path", {
    d: "M4.86199 11.5948C4.78717 11.5923 4.71366 11.5745 4.64596 11.5426C4.57826 11.5107 4.51779 11.4652 4.46827 11.4091L0.753985 7.69483C0.683167 7.64891 0.623706 7.58751 0.580092 7.51525C0.536478 7.44299 0.509851 7.36177 0.502221 7.27771C0.49459 7.19366 0.506156 7.10897 0.536046 7.03004C0.565935 6.95111 0.613367 6.88 0.674759 6.82208C0.736151 6.76416 0.8099 6.72095 0.890436 6.69571C0.970973 6.67046 1.05619 6.66385 1.13966 6.67635C1.22313 6.68886 1.30266 6.72017 1.37226 6.76792C1.44186 6.81567 1.4997 6.8786 1.54141 6.95197L4.86199 10.2503L12.6397 2.49483C12.7444 2.42694 12.8689 2.39617 12.9932 2.40745C13.1174 2.41873 13.2343 2.47141 13.3251 2.55705C13.4159 2.64268 13.4753 2.75632 13.4938 2.87973C13.5123 3.00315 13.4888 3.1292 13.4271 3.23768L5.2557 11.4091C5.20618 11.4652 5.14571 11.5107 5.07801 11.5426C5.01031 11.5745 4.9368 11.5923 4.86199 11.5948Z",
    fill: "currentColor"
  }, null, -1)])), 16);
}
Zr.render = Z1;
var Xr = {
  name: "ChevronDownIcon",
  extends: Ue
};
function X1(e) {
  return tk(e) || ek(e) || Q1(e) || J1();
}
function J1() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Q1(e, t) {
  if (e) {
    if (typeof e == "string") return wr(e, t);
    var n = {}.toString.call(e).slice(8, -1);
    return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? wr(e, t) : void 0;
  }
}
function ek(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function tk(e) {
  if (Array.isArray(e)) return wr(e);
}
function wr(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, o = Array(t); n < t; n++) o[n] = e[n];
  return o;
}
function nk(e, t, n, o, i, r) {
  return m(), h("svg", x({
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.pti()), X1(t[0] || (t[0] = [g("path", {
    d: "M7.01744 10.398C6.91269 10.3985 6.8089 10.378 6.71215 10.3379C6.61541 10.2977 6.52766 10.2386 6.45405 10.1641L1.13907 4.84913C1.03306 4.69404 0.985221 4.5065 1.00399 4.31958C1.02276 4.13266 1.10693 3.95838 1.24166 3.82747C1.37639 3.69655 1.55301 3.61742 1.74039 3.60402C1.92777 3.59062 2.11386 3.64382 2.26584 3.75424L7.01744 8.47394L11.769 3.75424C11.9189 3.65709 12.097 3.61306 12.2748 3.62921C12.4527 3.64535 12.6199 3.72073 12.7498 3.84328C12.8797 3.96582 12.9647 4.12842 12.9912 4.30502C13.0177 4.48162 12.9841 4.662 12.8958 4.81724L7.58083 10.1322C7.50996 10.2125 7.42344 10.2775 7.32656 10.3232C7.22968 10.3689 7.12449 10.3944 7.01744 10.398Z",
    fill: "currentColor"
  }, null, -1)])), 16);
}
Xr.render = nk;
var gl = {
  name: "SearchIcon",
  extends: Ue
};
function ok(e) {
  return lk(e) || ak(e) || ik(e) || rk();
}
function rk() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function ik(e, t) {
  if (e) {
    if (typeof e == "string") return xr(e, t);
    var n = {}.toString.call(e).slice(8, -1);
    return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? xr(e, t) : void 0;
  }
}
function ak(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function lk(e) {
  if (Array.isArray(e)) return xr(e);
}
function xr(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, o = Array(t); n < t; n++) o[n] = e[n];
  return o;
}
function sk(e, t, n, o, i, r) {
  return m(), h("svg", x({
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.pti()), ok(t[0] || (t[0] = [g("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M2.67602 11.0265C3.6661 11.688 4.83011 12.0411 6.02086 12.0411C6.81149 12.0411 7.59438 11.8854 8.32483 11.5828C8.87005 11.357 9.37808 11.0526 9.83317 10.6803L12.9769 13.8241C13.0323 13.8801 13.0983 13.9245 13.171 13.9548C13.2438 13.985 13.3219 14.0003 13.4007 14C13.4795 14.0003 13.5575 13.985 13.6303 13.9548C13.7031 13.9245 13.7691 13.8801 13.8244 13.8241C13.9367 13.7116 13.9998 13.5592 13.9998 13.4003C13.9998 13.2414 13.9367 13.089 13.8244 12.9765L10.6807 9.8328C11.053 9.37773 11.3573 8.86972 11.5831 8.32452C11.8857 7.59408 12.0414 6.81119 12.0414 6.02056C12.0414 4.8298 11.6883 3.66579 11.0268 2.67572C10.3652 1.68564 9.42494 0.913972 8.32483 0.45829C7.22472 0.00260857 6.01418 -0.116618 4.84631 0.115686C3.67844 0.34799 2.60568 0.921393 1.76369 1.76338C0.921698 2.60537 0.348296 3.67813 0.115991 4.84601C-0.116313 6.01388 0.00291375 7.22441 0.458595 8.32452C0.914277 9.42464 1.68595 10.3649 2.67602 11.0265ZM3.35565 2.0158C4.14456 1.48867 5.07206 1.20731 6.02086 1.20731C7.29317 1.20731 8.51338 1.71274 9.41304 2.6124C10.3127 3.51206 10.8181 4.73226 10.8181 6.00457C10.8181 6.95337 10.5368 7.88088 10.0096 8.66978C9.48251 9.45868 8.73328 10.0736 7.85669 10.4367C6.98011 10.7997 6.01554 10.8947 5.08496 10.7096C4.15439 10.5245 3.2996 10.0676 2.62869 9.39674C1.95778 8.72583 1.50089 7.87104 1.31579 6.94046C1.13068 6.00989 1.22568 5.04532 1.58878 4.16874C1.95187 3.29215 2.56675 2.54292 3.35565 2.0158Z",
    fill: "currentColor"
  }, null, -1)])), 16);
}
gl.render = sk;
var dk = `
    .p-iconfield {
        position: relative;
        display: block;
    }

    .p-inputicon {
        position: absolute;
        top: 50%;
        margin-top: calc(-1 * (dt('icon.size') / 2));
        color: dt('iconfield.icon.color');
        line-height: 1;
        z-index: 1;
    }

    .p-iconfield .p-inputicon:first-child {
        inset-inline-start: dt('form.field.padding.x');
    }

    .p-iconfield .p-inputicon:last-child {
        inset-inline-end: dt('form.field.padding.x');
    }

    .p-iconfield .p-inputtext:not(:first-child),
    .p-iconfield .p-inputwrapper:not(:first-child) .p-inputtext {
        padding-inline-start: calc((dt('form.field.padding.x') * 2) + dt('icon.size'));
    }

    .p-iconfield .p-inputtext:not(:last-child) {
        padding-inline-end: calc((dt('form.field.padding.x') * 2) + dt('icon.size'));
    }

    .p-iconfield:has(.p-inputfield-sm) .p-inputicon {
        font-size: dt('form.field.sm.font.size');
        width: dt('form.field.sm.font.size');
        height: dt('form.field.sm.font.size');
        margin-top: calc(-1 * (dt('form.field.sm.font.size') / 2));
    }

    .p-iconfield:has(.p-inputfield-lg) .p-inputicon {
        font-size: dt('form.field.lg.font.size');
        width: dt('form.field.lg.font.size');
        height: dt('form.field.lg.font.size');
        margin-top: calc(-1 * (dt('form.field.lg.font.size') / 2));
    }
`, uk = {
  root: "p-iconfield"
}, ck = oe.extend({
  name: "iconfield",
  style: dk,
  classes: uk
}), pk = {
  name: "BaseIconField",
  extends: nt,
  style: ck,
  provide: function() {
    return {
      $pcIconField: this,
      $parentInstance: this
    };
  }
}, hl = {
  name: "IconField",
  extends: pk,
  inheritAttrs: !1
};
function mk(e, t, n, o, i, r) {
  return m(), h("div", x({
    class: e.cx("root")
  }, e.ptmi("root")), [R(e.$slots, "default")], 16);
}
hl.render = mk;
var fk = {
  root: "p-inputicon"
}, gk = oe.extend({
  name: "inputicon",
  classes: fk
}), hk = {
  name: "BaseInputIcon",
  extends: nt,
  style: gk,
  props: {
    class: null
  },
  provide: function() {
    return {
      $pcInputIcon: this,
      $parentInstance: this
    };
  }
}, bl = {
  name: "InputIcon",
  extends: hk,
  inheritAttrs: !1,
  computed: {
    containerClass: function() {
      return [this.cx("root"), this.class];
    }
  }
};
function bk(e, t, n, o, i, r) {
  return m(), h("span", x({
    class: r.containerClass
  }, e.ptmi("root"), {
    "aria-hidden": "true"
  }), [R(e.$slots, "default")], 16);
}
bl.render = bk;
var vl = {
  name: "BaseEditableHolder",
  extends: nt,
  emits: ["update:modelValue", "value-change"],
  props: {
    modelValue: {
      type: null,
      default: void 0
    },
    defaultValue: {
      type: null,
      default: void 0
    },
    name: {
      type: String,
      default: void 0
    },
    invalid: {
      type: Boolean,
      default: void 0
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    formControl: {
      type: Object,
      default: void 0
    }
  },
  inject: {
    $parentInstance: {
      default: void 0
    },
    $pcForm: {
      default: void 0
    },
    $pcFormField: {
      default: void 0
    }
  },
  data: function() {
    return {
      d_value: this.defaultValue !== void 0 ? this.defaultValue : this.modelValue
    };
  },
  watch: {
    modelValue: function(t) {
      this.d_value = t;
    },
    defaultValue: function(t) {
      this.d_value = t;
    },
    $formName: {
      immediate: !0,
      handler: function(t) {
        var n, o;
        this.formField = ((n = this.$pcForm) === null || n === void 0 || (o = n.register) === null || o === void 0 ? void 0 : o.call(n, t, this.$formControl)) || {};
      }
    },
    $formControl: {
      immediate: !0,
      handler: function(t) {
        var n, o;
        this.formField = ((n = this.$pcForm) === null || n === void 0 || (o = n.register) === null || o === void 0 ? void 0 : o.call(n, this.$formName, t)) || {};
      }
    },
    $formDefaultValue: {
      immediate: !0,
      handler: function(t) {
        this.d_value !== t && (this.d_value = t);
      }
    },
    $formValue: {
      immediate: !1,
      handler: function(t) {
        var n;
        (n = this.$pcForm) !== null && n !== void 0 && n.getFieldState(this.$formName) && t !== this.d_value && (this.d_value = t);
      }
    }
  },
  formField: {},
  methods: {
    writeValue: function(t, n) {
      var o, i;
      this.controlled && (this.d_value = t, this.$emit("update:modelValue", t)), this.$emit("value-change", t), (o = (i = this.formField).onChange) === null || o === void 0 || o.call(i, {
        originalEvent: n,
        value: t
      });
    },
    // @todo move to @primeuix/utils
    findNonEmpty: function() {
      for (var t = arguments.length, n = new Array(t), o = 0; o < t; o++)
        n[o] = arguments[o];
      return n.find(le);
    }
  },
  computed: {
    $filled: function() {
      return le(this.d_value);
    },
    $invalid: function() {
      var t, n;
      return !this.$formNovalidate && this.findNonEmpty(this.invalid, (t = this.$pcFormField) === null || t === void 0 || (t = t.$field) === null || t === void 0 ? void 0 : t.invalid, (n = this.$pcForm) === null || n === void 0 || (n = n.getFieldState(this.$formName)) === null || n === void 0 ? void 0 : n.invalid);
    },
    $formName: function() {
      var t;
      return this.$formNovalidate ? void 0 : this.name || ((t = this.$formControl) === null || t === void 0 ? void 0 : t.name);
    },
    $formControl: function() {
      var t;
      return this.formControl || ((t = this.$pcFormField) === null || t === void 0 ? void 0 : t.formControl);
    },
    $formNovalidate: function() {
      var t;
      return (t = this.$formControl) === null || t === void 0 ? void 0 : t.novalidate;
    },
    $formDefaultValue: function() {
      var t, n;
      return this.findNonEmpty(this.d_value, (t = this.$pcFormField) === null || t === void 0 ? void 0 : t.initialValue, (n = this.$pcForm) === null || n === void 0 || (n = n.initialValues) === null || n === void 0 ? void 0 : n[this.$formName]);
    },
    $formValue: function() {
      var t, n;
      return this.findNonEmpty((t = this.$pcFormField) === null || t === void 0 || (t = t.$field) === null || t === void 0 ? void 0 : t.value, (n = this.$pcForm) === null || n === void 0 || (n = n.getFieldState(this.$formName)) === null || n === void 0 ? void 0 : n.value);
    },
    controlled: function() {
      return this.$inProps.hasOwnProperty("modelValue") || !this.$inProps.hasOwnProperty("modelValue") && !this.$inProps.hasOwnProperty("defaultValue");
    },
    // @deprecated use $filled instead
    filled: function() {
      return this.$filled;
    }
  }
}, on = {
  name: "BaseInput",
  extends: vl,
  props: {
    size: {
      type: String,
      default: null
    },
    fluid: {
      type: Boolean,
      default: null
    },
    variant: {
      type: String,
      default: null
    }
  },
  inject: {
    $parentInstance: {
      default: void 0
    },
    $pcFluid: {
      default: void 0
    }
  },
  computed: {
    $variant: function() {
      var t;
      return (t = this.variant) !== null && t !== void 0 ? t : this.$primevue.config.inputStyle || this.$primevue.config.inputVariant;
    },
    $fluid: function() {
      var t;
      return (t = this.fluid) !== null && t !== void 0 ? t : !!this.$pcFluid;
    },
    // @deprecated use $fluid instead
    hasFluid: function() {
      return this.$fluid;
    }
  }
}, vk = `
    .p-inputtext {
        font-family: inherit;
        font-feature-settings: inherit;
        font-size: 1rem;
        color: dt('inputtext.color');
        background: dt('inputtext.background');
        padding-block: dt('inputtext.padding.y');
        padding-inline: dt('inputtext.padding.x');
        border: 1px solid dt('inputtext.border.color');
        transition:
            background dt('inputtext.transition.duration'),
            color dt('inputtext.transition.duration'),
            border-color dt('inputtext.transition.duration'),
            outline-color dt('inputtext.transition.duration'),
            box-shadow dt('inputtext.transition.duration');
        appearance: none;
        border-radius: dt('inputtext.border.radius');
        outline-color: transparent;
        box-shadow: dt('inputtext.shadow');
    }

    .p-inputtext:enabled:hover {
        border-color: dt('inputtext.hover.border.color');
    }

    .p-inputtext:enabled:focus {
        border-color: dt('inputtext.focus.border.color');
        box-shadow: dt('inputtext.focus.ring.shadow');
        outline: dt('inputtext.focus.ring.width') dt('inputtext.focus.ring.style') dt('inputtext.focus.ring.color');
        outline-offset: dt('inputtext.focus.ring.offset');
    }

    .p-inputtext.p-invalid {
        border-color: dt('inputtext.invalid.border.color');
    }

    .p-inputtext.p-variant-filled {
        background: dt('inputtext.filled.background');
    }

    .p-inputtext.p-variant-filled:enabled:hover {
        background: dt('inputtext.filled.hover.background');
    }

    .p-inputtext.p-variant-filled:enabled:focus {
        background: dt('inputtext.filled.focus.background');
    }

    .p-inputtext:disabled {
        opacity: 1;
        background: dt('inputtext.disabled.background');
        color: dt('inputtext.disabled.color');
    }

    .p-inputtext::placeholder {
        color: dt('inputtext.placeholder.color');
    }

    .p-inputtext.p-invalid::placeholder {
        color: dt('inputtext.invalid.placeholder.color');
    }

    .p-inputtext-sm {
        font-size: dt('inputtext.sm.font.size');
        padding-block: dt('inputtext.sm.padding.y');
        padding-inline: dt('inputtext.sm.padding.x');
    }

    .p-inputtext-lg {
        font-size: dt('inputtext.lg.font.size');
        padding-block: dt('inputtext.lg.padding.y');
        padding-inline: dt('inputtext.lg.padding.x');
    }

    .p-inputtext-fluid {
        width: 100%;
    }
`, yk = {
  root: function(t) {
    var n = t.instance, o = t.props;
    return ["p-inputtext p-component", {
      "p-filled": n.$filled,
      "p-inputtext-sm p-inputfield-sm": o.size === "small",
      "p-inputtext-lg p-inputfield-lg": o.size === "large",
      "p-invalid": n.$invalid,
      "p-variant-filled": n.$variant === "filled",
      "p-inputtext-fluid": n.$fluid
    }];
  }
}, kk = oe.extend({
  name: "inputtext",
  style: vk,
  classes: yk
}), wk = {
  name: "BaseInputText",
  extends: on,
  style: kk,
  provide: function() {
    return {
      $pcInputText: this,
      $parentInstance: this
    };
  }
};
function Qn(e) {
  "@babel/helpers - typeof";
  return Qn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Qn(e);
}
function xk(e, t, n) {
  return (t = Ck(t)) in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Ck(e) {
  var t = Sk(e, "string");
  return Qn(t) == "symbol" ? t : t + "";
}
function Sk(e, t) {
  if (Qn(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var o = n.call(e, t);
    if (Qn(o) != "object") return o;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var Et = {
  name: "InputText",
  extends: wk,
  inheritAttrs: !1,
  methods: {
    onInput: function(t) {
      this.writeValue(t.target.value, t);
    }
  },
  computed: {
    attrs: function() {
      return x(this.ptmi("root", {
        context: {
          filled: this.$filled,
          disabled: this.disabled
        }
      }), this.formField);
    },
    dataP: function() {
      return Pe(xk({
        invalid: this.$invalid,
        fluid: this.$fluid,
        filled: this.$variant === "filled"
      }, this.size, this.size));
    }
  }
}, $k = ["value", "name", "disabled", "aria-invalid", "data-p"];
function Bk(e, t, n, o, i, r) {
  return m(), h("input", x({
    type: "text",
    class: e.cx("root"),
    value: e.d_value,
    name: e.name,
    disabled: e.disabled,
    "aria-invalid": e.$invalid || void 0,
    "data-p": r.dataP,
    onInput: t[0] || (t[0] = function() {
      return r.onInput && r.onInput.apply(r, arguments);
    })
  }, r.attrs), null, 16, $k);
}
Et.render = Bk;
var yl = jr(), Yo = {
  name: "Portal",
  props: {
    appendTo: {
      type: [String, Object],
      default: "body"
    },
    disabled: {
      type: Boolean,
      default: !1
    }
  },
  data: function() {
    return {
      mounted: !1
    };
  },
  mounted: function() {
    this.mounted = _a();
  },
  computed: {
    inline: function() {
      return this.disabled || this.appendTo === "self";
    }
  }
};
function Tk(e, t, n, o, i, r) {
  return r.inline ? R(e.$slots, "default", {
    key: 0
  }) : i.mounted ? (m(), j(ms, {
    key: 1,
    to: n.appendTo
  }, [R(e.$slots, "default")], 8, ["to"])) : B("", !0);
}
Yo.render = Tk;
var Ik = `
    .p-virtualscroller-loader {
        background: dt('virtualscroller.loader.mask.background');
        color: dt('virtualscroller.loader.mask.color');
    }

    .p-virtualscroller-loading-icon {
        font-size: dt('virtualscroller.loader.icon.size');
        width: dt('virtualscroller.loader.icon.size');
        height: dt('virtualscroller.loader.icon.size');
    }
`, Dk = `
.p-virtualscroller {
    position: relative;
    overflow: auto;
    contain: strict;
    transform: translateZ(0);
    will-change: scroll-position;
    outline: 0 none;
}

.p-virtualscroller-content {
    position: absolute;
    top: 0;
    left: 0;
    min-height: 100%;
    min-width: 100%;
    will-change: transform;
}

.p-virtualscroller-spacer {
    position: absolute;
    top: 0;
    left: 0;
    height: 1px;
    width: 1px;
    transform-origin: 0 0;
    pointer-events: none;
}

.p-virtualscroller-loader {
    position: sticky;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}

.p-virtualscroller-loader-mask {
    display: flex;
    align-items: center;
    justify-content: center;
}

.p-virtualscroller-horizontal > .p-virtualscroller-content {
    display: flex;
}

.p-virtualscroller-inline .p-virtualscroller-content {
    position: static;
}

.p-virtualscroller .p-virtualscroller-loading {
    transform: none !important;
    min-height: 0;
    position: sticky;
    inset-block-start: 0;
    inset-inline-start: 0;
}
`, na = oe.extend({
  name: "virtualscroller",
  css: Dk,
  style: Ik
}), Pk = {
  name: "BaseVirtualScroller",
  extends: nt,
  props: {
    id: {
      type: String,
      default: null
    },
    style: null,
    class: null,
    items: {
      type: Array,
      default: null
    },
    itemSize: {
      type: [Number, Array],
      default: 0
    },
    scrollHeight: null,
    scrollWidth: null,
    orientation: {
      type: String,
      default: "vertical"
    },
    numToleratedItems: {
      type: Number,
      default: null
    },
    delay: {
      type: Number,
      default: 0
    },
    resizeDelay: {
      type: Number,
      default: 10
    },
    lazy: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    loaderDisabled: {
      type: Boolean,
      default: !1
    },
    columns: {
      type: Array,
      default: null
    },
    loading: {
      type: Boolean,
      default: !1
    },
    showSpacer: {
      type: Boolean,
      default: !0
    },
    showLoader: {
      type: Boolean,
      default: !1
    },
    tabindex: {
      type: Number,
      default: 0
    },
    inline: {
      type: Boolean,
      default: !1
    },
    step: {
      type: Number,
      default: 0
    },
    appendOnly: {
      type: Boolean,
      default: !1
    },
    autoSize: {
      type: Boolean,
      default: !1
    }
  },
  style: na,
  provide: function() {
    return {
      $pcVirtualScroller: this,
      $parentInstance: this
    };
  },
  beforeMount: function() {
    var t;
    na.loadCSS({
      nonce: (t = this.$primevueConfig) === null || t === void 0 || (t = t.csp) === null || t === void 0 ? void 0 : t.nonce
    });
  }
};
function eo(e) {
  "@babel/helpers - typeof";
  return eo = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, eo(e);
}
function oa(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    t && (o = o.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, o);
  }
  return n;
}
function zn(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? oa(Object(n), !0).forEach(function(o) {
      kl(e, o, n[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : oa(Object(n)).forEach(function(o) {
      Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(n, o));
    });
  }
  return e;
}
function kl(e, t, n) {
  return (t = zk(t)) in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function zk(e) {
  var t = Lk(e, "string");
  return eo(t) == "symbol" ? t : t + "";
}
function Lk(e, t) {
  if (eo(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var o = n.call(e, t);
    if (eo(o) != "object") return o;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var wl = {
  name: "VirtualScroller",
  extends: Pk,
  inheritAttrs: !1,
  emits: ["update:numToleratedItems", "scroll", "scroll-index-change", "lazy-load"],
  data: function() {
    var t = this.isBoth();
    return {
      first: t ? {
        rows: 0,
        cols: 0
      } : 0,
      last: t ? {
        rows: 0,
        cols: 0
      } : 0,
      page: t ? {
        rows: 0,
        cols: 0
      } : 0,
      numItemsInViewport: t ? {
        rows: 0,
        cols: 0
      } : 0,
      lastScrollPos: t ? {
        top: 0,
        left: 0
      } : 0,
      d_numToleratedItems: this.numToleratedItems,
      d_loading: this.loading,
      loaderArr: [],
      spacerStyle: {},
      contentStyle: {}
    };
  },
  element: null,
  content: null,
  lastScrollPos: null,
  scrollTimeout: null,
  resizeTimeout: null,
  defaultWidth: 0,
  defaultHeight: 0,
  defaultContentWidth: 0,
  defaultContentHeight: 0,
  isRangeChanged: !1,
  lazyLoadState: {},
  resizeListener: null,
  resizeObserver: null,
  initialized: !1,
  watch: {
    numToleratedItems: function(t) {
      this.d_numToleratedItems = t;
    },
    loading: function(t, n) {
      this.lazy && t !== n && t !== this.d_loading && (this.d_loading = t);
    },
    items: {
      handler: function(t, n) {
        (!n || n.length !== (t || []).length) && (this.init(), this.calculateAutoSize());
      },
      deep: !0
    },
    itemSize: function() {
      this.init(), this.calculateAutoSize();
    },
    orientation: function() {
      this.lastScrollPos = this.isBoth() ? {
        top: 0,
        left: 0
      } : 0;
    },
    scrollHeight: function() {
      this.init(), this.calculateAutoSize();
    },
    scrollWidth: function() {
      this.init(), this.calculateAutoSize();
    }
  },
  mounted: function() {
    this.viewInit(), this.lastScrollPos = this.isBoth() ? {
      top: 0,
      left: 0
    } : 0, this.lazyLoadState = this.lazyLoadState || {};
  },
  updated: function() {
    !this.initialized && this.viewInit();
  },
  unmounted: function() {
    this.unbindResizeListener(), this.initialized = !1;
  },
  methods: {
    viewInit: function() {
      Lo(this.element) && (this.setContentEl(this.content), this.init(), this.calculateAutoSize(), this.defaultWidth = Wt(this.element), this.defaultHeight = Kt(this.element), this.defaultContentWidth = Wt(this.content), this.defaultContentHeight = Kt(this.content), this.initialized = !0), this.element && this.bindResizeListener();
    },
    init: function() {
      this.disabled || (this.setSize(), this.calculateOptions(), this.setSpacerSize());
    },
    isVertical: function() {
      return this.orientation === "vertical";
    },
    isHorizontal: function() {
      return this.orientation === "horizontal";
    },
    isBoth: function() {
      return this.orientation === "both";
    },
    scrollTo: function(t) {
      this.element && this.element.scrollTo(t);
    },
    scrollToIndex: function(t) {
      var n = this, o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "auto", i = this.isBoth(), r = this.isHorizontal(), a = i ? t.every(function(C) {
        return C > -1;
      }) : t > -1;
      if (a) {
        var d = this.first, l = this.element, u = l.scrollTop, s = u === void 0 ? 0 : u, c = l.scrollLeft, p = c === void 0 ? 0 : c, f = this.calculateNumItems(), b = f.numToleratedItems, k = this.getContentPosition(), T = this.itemSize, $ = function() {
          var I = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, N = arguments.length > 1 ? arguments[1] : void 0;
          return I <= N ? 0 : I;
        }, S = function(I, N, K) {
          return I * N + K;
        }, O = function() {
          var I = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, N = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
          return n.scrollTo({
            left: I,
            top: N,
            behavior: o
          });
        }, w = i ? {
          rows: 0,
          cols: 0
        } : 0, F = !1, D = !1;
        i ? (w = {
          rows: $(t[0], b[0]),
          cols: $(t[1], b[1])
        }, O(S(w.cols, T[1], k.left), S(w.rows, T[0], k.top)), D = this.lastScrollPos.top !== s || this.lastScrollPos.left !== p, F = w.rows !== d.rows || w.cols !== d.cols) : (w = $(t, b), r ? O(S(w, T, k.left), s) : O(p, S(w, T, k.top)), D = this.lastScrollPos !== (r ? p : s), F = w !== d), this.isRangeChanged = F, D && (this.first = w);
      }
    },
    scrollInView: function(t, n) {
      var o = this, i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "auto";
      if (n) {
        var r = this.isBoth(), a = this.isHorizontal(), d = r ? t.every(function(T) {
          return T > -1;
        }) : t > -1;
        if (d) {
          var l = this.getRenderedRange(), u = l.first, s = l.viewport, c = function() {
            var $ = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, S = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
            return o.scrollTo({
              left: $,
              top: S,
              behavior: i
            });
          }, p = n === "to-start", f = n === "to-end";
          if (p) {
            if (r)
              s.first.rows - u.rows > t[0] ? c(s.first.cols * this.itemSize[1], (s.first.rows - 1) * this.itemSize[0]) : s.first.cols - u.cols > t[1] && c((s.first.cols - 1) * this.itemSize[1], s.first.rows * this.itemSize[0]);
            else if (s.first - u > t) {
              var b = (s.first - 1) * this.itemSize;
              a ? c(b, 0) : c(0, b);
            }
          } else if (f) {
            if (r)
              s.last.rows - u.rows <= t[0] + 1 ? c(s.first.cols * this.itemSize[1], (s.first.rows + 1) * this.itemSize[0]) : s.last.cols - u.cols <= t[1] + 1 && c((s.first.cols + 1) * this.itemSize[1], s.first.rows * this.itemSize[0]);
            else if (s.last - u <= t + 1) {
              var k = (s.first + 1) * this.itemSize;
              a ? c(k, 0) : c(0, k);
            }
          }
        }
      } else
        this.scrollToIndex(t, i);
    },
    getRenderedRange: function() {
      var t = function(c, p) {
        return Math.floor(c / (p || c));
      }, n = this.first, o = 0;
      if (this.element) {
        var i = this.isBoth(), r = this.isHorizontal(), a = this.element, d = a.scrollTop, l = a.scrollLeft;
        if (i)
          n = {
            rows: t(d, this.itemSize[0]),
            cols: t(l, this.itemSize[1])
          }, o = {
            rows: n.rows + this.numItemsInViewport.rows,
            cols: n.cols + this.numItemsInViewport.cols
          };
        else {
          var u = r ? l : d;
          n = t(u, this.itemSize), o = n + this.numItemsInViewport;
        }
      }
      return {
        first: this.first,
        last: this.last,
        viewport: {
          first: n,
          last: o
        }
      };
    },
    calculateNumItems: function() {
      var t = this.isBoth(), n = this.isHorizontal(), o = this.itemSize, i = this.getContentPosition(), r = this.element ? this.element.offsetWidth - i.left : 0, a = this.element ? this.element.offsetHeight - i.top : 0, d = function(p, f) {
        return Math.ceil(p / (f || p));
      }, l = function(p) {
        return Math.ceil(p / 2);
      }, u = t ? {
        rows: d(a, o[0]),
        cols: d(r, o[1])
      } : d(n ? r : a, o), s = this.d_numToleratedItems || (t ? [l(u.rows), l(u.cols)] : l(u));
      return {
        numItemsInViewport: u,
        numToleratedItems: s
      };
    },
    calculateOptions: function() {
      var t = this, n = this.isBoth(), o = this.first, i = this.calculateNumItems(), r = i.numItemsInViewport, a = i.numToleratedItems, d = function(s, c, p) {
        var f = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
        return t.getLast(s + c + (s < p ? 2 : 3) * p, f);
      }, l = n ? {
        rows: d(o.rows, r.rows, a[0]),
        cols: d(o.cols, r.cols, a[1], !0)
      } : d(o, r, a);
      this.last = l, this.numItemsInViewport = r, this.d_numToleratedItems = a, this.$emit("update:numToleratedItems", this.d_numToleratedItems), this.showLoader && (this.loaderArr = n ? Array.from({
        length: r.rows
      }).map(function() {
        return Array.from({
          length: r.cols
        });
      }) : Array.from({
        length: r
      })), this.lazy && Promise.resolve().then(function() {
        var u;
        t.lazyLoadState = {
          first: t.step ? n ? {
            rows: 0,
            cols: o.cols
          } : 0 : o,
          last: Math.min(t.step ? t.step : l, ((u = t.items) === null || u === void 0 ? void 0 : u.length) || 0)
        }, t.$emit("lazy-load", t.lazyLoadState);
      });
    },
    calculateAutoSize: function() {
      var t = this;
      this.autoSize && !this.d_loading && Promise.resolve().then(function() {
        if (t.content) {
          var n = t.isBoth(), o = t.isHorizontal(), i = t.isVertical();
          t.content.style.minHeight = t.content.style.minWidth = "auto", t.content.style.position = "relative", t.element.style.contain = "none";
          var r = [Wt(t.element), Kt(t.element)], a = r[0], d = r[1];
          (n || o) && (t.element.style.width = a < t.defaultWidth ? a + "px" : t.scrollWidth || t.defaultWidth + "px"), (n || i) && (t.element.style.height = d < t.defaultHeight ? d + "px" : t.scrollHeight || t.defaultHeight + "px"), t.content.style.minHeight = t.content.style.minWidth = "", t.content.style.position = "", t.element.style.contain = "";
        }
      });
    },
    getLast: function() {
      var t, n, o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, i = arguments.length > 1 ? arguments[1] : void 0;
      return this.items ? Math.min(i ? ((t = this.columns || this.items[0]) === null || t === void 0 ? void 0 : t.length) || 0 : ((n = this.items) === null || n === void 0 ? void 0 : n.length) || 0, o) : 0;
    },
    getContentPosition: function() {
      if (this.content) {
        var t = getComputedStyle(this.content), n = parseFloat(t.paddingLeft) + Math.max(parseFloat(t.left) || 0, 0), o = parseFloat(t.paddingRight) + Math.max(parseFloat(t.right) || 0, 0), i = parseFloat(t.paddingTop) + Math.max(parseFloat(t.top) || 0, 0), r = parseFloat(t.paddingBottom) + Math.max(parseFloat(t.bottom) || 0, 0);
        return {
          left: n,
          right: o,
          top: i,
          bottom: r,
          x: n + o,
          y: i + r
        };
      }
      return {
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        x: 0,
        y: 0
      };
    },
    setSize: function() {
      var t = this;
      if (this.element) {
        var n = this.isBoth(), o = this.isHorizontal(), i = this.element.parentElement, r = this.scrollWidth || "".concat(this.element.offsetWidth || i.offsetWidth, "px"), a = this.scrollHeight || "".concat(this.element.offsetHeight || i.offsetHeight, "px"), d = function(u, s) {
          return t.element.style[u] = s;
        };
        n || o ? (d("height", a), d("width", r)) : d("height", a);
      }
    },
    setSpacerSize: function() {
      var t = this, n = this.items;
      if (n) {
        var o = this.isBoth(), i = this.isHorizontal(), r = this.getContentPosition(), a = function(l, u, s) {
          var c = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0;
          return t.spacerStyle = zn(zn({}, t.spacerStyle), kl({}, "".concat(l), (u || []).length * s + c + "px"));
        };
        o ? (a("height", n, this.itemSize[0], r.y), a("width", this.columns || n[1], this.itemSize[1], r.x)) : i ? a("width", this.columns || n, this.itemSize, r.x) : a("height", n, this.itemSize, r.y);
      }
    },
    setContentPosition: function(t) {
      var n = this;
      if (this.content && !this.appendOnly) {
        var o = this.isBoth(), i = this.isHorizontal(), r = t ? t.first : this.first, a = function(s, c) {
          return s * c;
        }, d = function() {
          var s = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
          return n.contentStyle = zn(zn({}, n.contentStyle), {
            transform: "translate3d(".concat(s, "px, ").concat(c, "px, 0)")
          });
        };
        if (o)
          d(a(r.cols, this.itemSize[1]), a(r.rows, this.itemSize[0]));
        else {
          var l = a(r, this.itemSize);
          i ? d(l, 0) : d(0, l);
        }
      }
    },
    onScrollPositionChange: function(t) {
      var n = this, o = t.target, i = this.isBoth(), r = this.isHorizontal(), a = this.getContentPosition(), d = function(V, M) {
        return V ? V > M ? V - M : V : 0;
      }, l = function(V, M) {
        return Math.floor(V / (M || V));
      }, u = function(V, M, P, E, H, ae) {
        return V <= H ? H : ae ? P - E - H : M + H - 1;
      }, s = function(V, M, P, E, H, ae, fe, Be) {
        if (V <= ae) return 0;
        var Ae = Math.max(0, fe ? V < M ? P : V - ae : V > M ? P : V - 2 * ae), Oe = n.getLast(Ae, Be);
        return Ae > Oe ? Oe - H : Ae;
      }, c = function(V, M, P, E, H, ae) {
        var fe = M + E + 2 * H;
        return V >= H && (fe += H + 1), n.getLast(fe, ae);
      }, p = d(o.scrollTop, a.top), f = d(o.scrollLeft, a.left), b = i ? {
        rows: 0,
        cols: 0
      } : 0, k = this.last, T = !1, $ = this.lastScrollPos;
      if (i) {
        var S = this.lastScrollPos.top <= p, O = this.lastScrollPos.left <= f;
        if (!this.appendOnly || this.appendOnly && (S || O)) {
          var w = {
            rows: l(p, this.itemSize[0]),
            cols: l(f, this.itemSize[1])
          }, F = {
            rows: u(w.rows, this.first.rows, this.last.rows, this.numItemsInViewport.rows, this.d_numToleratedItems[0], S),
            cols: u(w.cols, this.first.cols, this.last.cols, this.numItemsInViewport.cols, this.d_numToleratedItems[1], O)
          };
          b = {
            rows: s(w.rows, F.rows, this.first.rows, this.last.rows, this.numItemsInViewport.rows, this.d_numToleratedItems[0], S),
            cols: s(w.cols, F.cols, this.first.cols, this.last.cols, this.numItemsInViewport.cols, this.d_numToleratedItems[1], O, !0)
          }, k = {
            rows: c(w.rows, b.rows, this.last.rows, this.numItemsInViewport.rows, this.d_numToleratedItems[0]),
            cols: c(w.cols, b.cols, this.last.cols, this.numItemsInViewport.cols, this.d_numToleratedItems[1], !0)
          }, T = b.rows !== this.first.rows || k.rows !== this.last.rows || b.cols !== this.first.cols || k.cols !== this.last.cols || this.isRangeChanged, $ = {
            top: p,
            left: f
          };
        }
      } else {
        var D = r ? f : p, C = this.lastScrollPos <= D;
        if (!this.appendOnly || this.appendOnly && C) {
          var I = l(D, this.itemSize), N = u(I, this.first, this.last, this.numItemsInViewport, this.d_numToleratedItems, C);
          b = s(I, N, this.first, this.last, this.numItemsInViewport, this.d_numToleratedItems, C), k = c(I, b, this.last, this.numItemsInViewport, this.d_numToleratedItems), T = b !== this.first || k !== this.last || this.isRangeChanged, $ = D;
        }
      }
      return {
        first: b,
        last: k,
        isRangeChanged: T,
        scrollPos: $
      };
    },
    onScrollChange: function(t) {
      var n = this.onScrollPositionChange(t), o = n.first, i = n.last, r = n.isRangeChanged, a = n.scrollPos;
      if (r) {
        var d = {
          first: o,
          last: i
        };
        if (this.setContentPosition(d), this.first = o, this.last = i, this.lastScrollPos = a, this.$emit("scroll-index-change", d), this.lazy && this.isPageChanged(o)) {
          var l, u, s = {
            first: this.step ? Math.min(this.getPageByFirst(o) * this.step, (((l = this.items) === null || l === void 0 ? void 0 : l.length) || 0) - this.step) : o,
            last: Math.min(this.step ? (this.getPageByFirst(o) + 1) * this.step : i, ((u = this.items) === null || u === void 0 ? void 0 : u.length) || 0)
          }, c = this.lazyLoadState.first !== s.first || this.lazyLoadState.last !== s.last;
          c && this.$emit("lazy-load", s), this.lazyLoadState = s;
        }
      }
    },
    onScroll: function(t) {
      var n = this;
      if (this.$emit("scroll", t), this.delay) {
        if (this.scrollTimeout && clearTimeout(this.scrollTimeout), this.isPageChanged()) {
          if (!this.d_loading && this.showLoader) {
            var o = this.onScrollPositionChange(t), i = o.isRangeChanged, r = i || (this.step ? this.isPageChanged() : !1);
            r && (this.d_loading = !0);
          }
          this.scrollTimeout = setTimeout(function() {
            n.onScrollChange(t), n.d_loading && n.showLoader && (!n.lazy || n.loading === void 0) && (n.d_loading = !1, n.page = n.getPageByFirst());
          }, this.delay);
        }
      } else
        this.onScrollChange(t);
    },
    onResize: function() {
      var t = this;
      this.resizeTimeout && clearTimeout(this.resizeTimeout), this.resizeTimeout = setTimeout(function() {
        if (Lo(t.element)) {
          var n = t.isBoth(), o = t.isVertical(), i = t.isHorizontal(), r = [Wt(t.element), Kt(t.element)], a = r[0], d = r[1], l = a !== t.defaultWidth, u = d !== t.defaultHeight, s = n ? l || u : i ? l : o ? u : !1;
          s && (t.d_numToleratedItems = t.numToleratedItems, t.defaultWidth = a, t.defaultHeight = d, t.defaultContentWidth = Wt(t.content), t.defaultContentHeight = Kt(t.content), t.init());
        }
      }, this.resizeDelay);
    },
    bindResizeListener: function() {
      var t = this;
      this.resizeListener || (this.resizeListener = this.onResize.bind(this), window.addEventListener("resize", this.resizeListener), window.addEventListener("orientationchange", this.resizeListener), this.resizeObserver = new ResizeObserver(function() {
        t.onResize();
      }), this.resizeObserver.observe(this.element));
    },
    unbindResizeListener: function() {
      this.resizeListener && (window.removeEventListener("resize", this.resizeListener), window.removeEventListener("orientationchange", this.resizeListener), this.resizeListener = null), this.resizeObserver && (this.resizeObserver.disconnect(), this.resizeObserver = null);
    },
    getOptions: function(t) {
      var n = (this.items || []).length, o = this.isBoth() ? this.first.rows + t : this.first + t;
      return {
        index: o,
        count: n,
        first: o === 0,
        last: o === n - 1,
        even: o % 2 === 0,
        odd: o % 2 !== 0
      };
    },
    getLoaderOptions: function(t, n) {
      var o = this.loaderArr.length;
      return zn({
        index: t,
        count: o,
        first: t === 0,
        last: t === o - 1,
        even: t % 2 === 0,
        odd: t % 2 !== 0
      }, n);
    },
    getPageByFirst: function(t) {
      return Math.floor(((t ?? this.first) + this.d_numToleratedItems * 4) / (this.step || 1));
    },
    isPageChanged: function(t) {
      return this.step && !this.lazy ? this.page !== this.getPageByFirst(t ?? this.first) : !0;
    },
    setContentEl: function(t) {
      this.content = t || this.content || qe(this.element, '[data-pc-section="content"]');
    },
    elementRef: function(t) {
      this.element = t;
    },
    contentRef: function(t) {
      this.content = t;
    }
  },
  computed: {
    containerClass: function() {
      return ["p-virtualscroller", this.class, {
        "p-virtualscroller-inline": this.inline,
        "p-virtualscroller-both p-both-scroll": this.isBoth(),
        "p-virtualscroller-horizontal p-horizontal-scroll": this.isHorizontal()
      }];
    },
    contentClass: function() {
      return ["p-virtualscroller-content", {
        "p-virtualscroller-loading": this.d_loading
      }];
    },
    loaderClass: function() {
      return ["p-virtualscroller-loader", {
        "p-virtualscroller-loader-mask": !this.$slots.loader
      }];
    },
    loadedItems: function() {
      var t = this;
      return this.items && !this.d_loading ? this.isBoth() ? this.items.slice(this.appendOnly ? 0 : this.first.rows, this.last.rows).map(function(n) {
        return t.columns ? n : n.slice(t.appendOnly ? 0 : t.first.cols, t.last.cols);
      }) : this.isHorizontal() && this.columns ? this.items : this.items.slice(this.appendOnly ? 0 : this.first, this.last) : [];
    },
    loadedRows: function() {
      return this.d_loading ? this.loaderDisabled ? this.loaderArr : [] : this.loadedItems;
    },
    loadedColumns: function() {
      if (this.columns) {
        var t = this.isBoth(), n = this.isHorizontal();
        if (t || n)
          return this.d_loading && this.loaderDisabled ? t ? this.loaderArr[0] : this.loaderArr : this.columns.slice(t ? this.first.cols : this.first, t ? this.last.cols : this.last);
      }
      return this.columns;
    }
  },
  components: {
    SpinnerIcon: Ko
  }
}, Ok = ["tabindex"];
function Mk(e, t, n, o, i, r) {
  var a = ze("SpinnerIcon");
  return e.disabled ? (m(), h(Y, {
    key: 1
  }, [R(e.$slots, "default"), R(e.$slots, "content", {
    items: e.items,
    rows: e.items,
    columns: r.loadedColumns
  })], 64)) : (m(), h("div", x({
    key: 0,
    ref: r.elementRef,
    class: r.containerClass,
    tabindex: e.tabindex,
    style: e.style,
    onScroll: t[0] || (t[0] = function() {
      return r.onScroll && r.onScroll.apply(r, arguments);
    })
  }, e.ptmi("root")), [R(e.$slots, "content", {
    styleClass: r.contentClass,
    items: r.loadedItems,
    getItemOptions: r.getOptions,
    loading: i.d_loading,
    getLoaderOptions: r.getLoaderOptions,
    itemSize: e.itemSize,
    rows: r.loadedRows,
    columns: r.loadedColumns,
    contentRef: r.contentRef,
    spacerStyle: i.spacerStyle,
    contentStyle: i.contentStyle,
    vertical: r.isVertical(),
    horizontal: r.isHorizontal(),
    both: r.isBoth()
  }, function() {
    return [g("div", x({
      ref: r.contentRef,
      class: r.contentClass,
      style: i.contentStyle
    }, e.ptm("content")), [(m(!0), h(Y, null, he(r.loadedItems, function(d, l) {
      return R(e.$slots, "item", {
        key: l,
        item: d,
        options: r.getOptions(l)
      });
    }), 128))], 16)];
  }), e.showSpacer ? (m(), h("div", x({
    key: 0,
    class: "p-virtualscroller-spacer",
    style: i.spacerStyle
  }, e.ptm("spacer")), null, 16)) : B("", !0), !e.loaderDisabled && e.showLoader && i.d_loading ? (m(), h("div", x({
    key: 1,
    class: r.loaderClass
  }, e.ptm("loader")), [e.$slots && e.$slots.loader ? (m(!0), h(Y, {
    key: 0
  }, he(i.loaderArr, function(d, l) {
    return R(e.$slots, "loader", {
      key: l,
      options: r.getLoaderOptions(l, r.isBoth() && {
        numCols: e.d_numItemsInViewport.cols
      })
    });
  }), 128)) : B("", !0), R(e.$slots, "loadingicon", {}, function() {
    return [L(a, x({
      spin: "",
      class: "p-virtualscroller-loading-icon"
    }, e.ptm("loadingIcon")), null, 16)];
  })], 16)) : B("", !0)], 16, Ok));
}
wl.render = Mk;
var Ak = `
    .p-select {
        display: inline-flex;
        cursor: pointer;
        position: relative;
        user-select: none;
        background: dt('select.background');
        border: 1px solid dt('select.border.color');
        transition:
            background dt('select.transition.duration'),
            color dt('select.transition.duration'),
            border-color dt('select.transition.duration'),
            outline-color dt('select.transition.duration'),
            box-shadow dt('select.transition.duration');
        border-radius: dt('select.border.radius');
        outline-color: transparent;
        box-shadow: dt('select.shadow');
    }

    .p-select:not(.p-disabled):hover {
        border-color: dt('select.hover.border.color');
    }

    .p-select:not(.p-disabled).p-focus {
        border-color: dt('select.focus.border.color');
        box-shadow: dt('select.focus.ring.shadow');
        outline: dt('select.focus.ring.width') dt('select.focus.ring.style') dt('select.focus.ring.color');
        outline-offset: dt('select.focus.ring.offset');
    }

    .p-select.p-variant-filled {
        background: dt('select.filled.background');
    }

    .p-select.p-variant-filled:not(.p-disabled):hover {
        background: dt('select.filled.hover.background');
    }

    .p-select.p-variant-filled:not(.p-disabled).p-focus {
        background: dt('select.filled.focus.background');
    }

    .p-select.p-invalid {
        border-color: dt('select.invalid.border.color');
    }

    .p-select.p-disabled {
        opacity: 1;
        background: dt('select.disabled.background');
    }

    .p-select-clear-icon {
        position: absolute;
        top: 50%;
        margin-top: -0.5rem;
        color: dt('select.clear.icon.color');
        inset-inline-end: dt('select.dropdown.width');
    }

    .p-select-dropdown {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        background: transparent;
        color: dt('select.dropdown.color');
        width: dt('select.dropdown.width');
        border-start-end-radius: dt('select.border.radius');
        border-end-end-radius: dt('select.border.radius');
    }

    .p-select-label {
        display: block;
        white-space: nowrap;
        overflow: hidden;
        flex: 1 1 auto;
        width: 1%;
        padding: dt('select.padding.y') dt('select.padding.x');
        text-overflow: ellipsis;
        cursor: pointer;
        color: dt('select.color');
        background: transparent;
        border: 0 none;
        outline: 0 none;
        font-size: 1rem;
    }

    .p-select-label.p-placeholder {
        color: dt('select.placeholder.color');
    }

    .p-select.p-invalid .p-select-label.p-placeholder {
        color: dt('select.invalid.placeholder.color');
    }

    .p-select:has(.p-select-clear-icon) .p-select-label {
        padding-inline-end: calc(1rem + dt('select.padding.x'));
    }

    .p-select.p-disabled .p-select-label {
        color: dt('select.disabled.color');
    }

    .p-select-label-empty {
        overflow: hidden;
        opacity: 0;
    }

    input.p-select-label {
        cursor: default;
    }

    .p-select-overlay {
        position: absolute;
        top: 0;
        left: 0;
        background: dt('select.overlay.background');
        color: dt('select.overlay.color');
        border: 1px solid dt('select.overlay.border.color');
        border-radius: dt('select.overlay.border.radius');
        box-shadow: dt('select.overlay.shadow');
        min-width: 100%;
    }

    .p-select-header {
        padding: dt('select.list.header.padding');
    }

    .p-select-filter {
        width: 100%;
    }

    .p-select-list-container {
        overflow: auto;
    }

    .p-select-option-group {
        cursor: auto;
        margin: 0;
        padding: dt('select.option.group.padding');
        background: dt('select.option.group.background');
        color: dt('select.option.group.color');
        font-weight: dt('select.option.group.font.weight');
    }

    .p-select-list {
        margin: 0;
        padding: 0;
        list-style-type: none;
        padding: dt('select.list.padding');
        gap: dt('select.list.gap');
        display: flex;
        flex-direction: column;
    }

    .p-select-option {
        cursor: pointer;
        font-weight: normal;
        white-space: nowrap;
        position: relative;
        overflow: hidden;
        display: flex;
        align-items: center;
        padding: dt('select.option.padding');
        border: 0 none;
        color: dt('select.option.color');
        background: transparent;
        transition:
            background dt('select.transition.duration'),
            color dt('select.transition.duration'),
            border-color dt('select.transition.duration'),
            box-shadow dt('select.transition.duration'),
            outline-color dt('select.transition.duration');
        border-radius: dt('select.option.border.radius');
    }

    .p-select-option:not(.p-select-option-selected):not(.p-disabled).p-focus {
        background: dt('select.option.focus.background');
        color: dt('select.option.focus.color');
    }

    .p-select-option.p-select-option-selected {
        background: dt('select.option.selected.background');
        color: dt('select.option.selected.color');
    }

    .p-select-option.p-select-option-selected.p-focus {
        background: dt('select.option.selected.focus.background');
        color: dt('select.option.selected.focus.color');
    }

    .p-select-option-blank-icon {
        flex-shrink: 0;
    }

    .p-select-option-check-icon {
        position: relative;
        flex-shrink: 0;
        margin-inline-start: dt('select.checkmark.gutter.start');
        margin-inline-end: dt('select.checkmark.gutter.end');
        color: dt('select.checkmark.color');
    }

    .p-select-empty-message {
        padding: dt('select.empty.message.padding');
    }

    .p-select-fluid {
        display: flex;
        width: 100%;
    }

    .p-select-sm .p-select-label {
        font-size: dt('select.sm.font.size');
        padding-block: dt('select.sm.padding.y');
        padding-inline: dt('select.sm.padding.x');
    }

    .p-select-sm .p-select-dropdown .p-icon {
        font-size: dt('select.sm.font.size');
        width: dt('select.sm.font.size');
        height: dt('select.sm.font.size');
    }

    .p-select-lg .p-select-label {
        font-size: dt('select.lg.font.size');
        padding-block: dt('select.lg.padding.y');
        padding-inline: dt('select.lg.padding.x');
    }

    .p-select-lg .p-select-dropdown .p-icon {
        font-size: dt('select.lg.font.size');
        width: dt('select.lg.font.size');
        height: dt('select.lg.font.size');
    }
`, _k = {
  root: function(t) {
    var n = t.instance, o = t.props, i = t.state;
    return ["p-select p-component p-inputwrapper", {
      "p-disabled": o.disabled,
      "p-invalid": n.$invalid,
      "p-variant-filled": n.$variant === "filled",
      "p-focus": i.focused,
      "p-inputwrapper-filled": n.$filled,
      "p-inputwrapper-focus": i.focused || i.overlayVisible,
      "p-select-open": i.overlayVisible,
      "p-select-fluid": n.$fluid,
      "p-select-sm p-inputfield-sm": o.size === "small",
      "p-select-lg p-inputfield-lg": o.size === "large"
    }];
  },
  label: function(t) {
    var n = t.instance, o = t.props;
    return ["p-select-label", {
      "p-placeholder": !o.editable && n.label === o.placeholder,
      "p-select-label-empty": !o.editable && !n.$slots.value && (n.label === "p-emptylabel" || n.label.length === 0)
    }];
  },
  clearIcon: "p-select-clear-icon",
  dropdown: "p-select-dropdown",
  loadingicon: "p-select-loading-icon",
  dropdownIcon: "p-select-dropdown-icon",
  overlay: "p-select-overlay p-component",
  header: "p-select-header",
  pcFilter: "p-select-filter",
  listContainer: "p-select-list-container",
  list: "p-select-list",
  optionGroup: "p-select-option-group",
  optionGroupLabel: "p-select-option-group-label",
  option: function(t) {
    var n = t.instance, o = t.props, i = t.state, r = t.option, a = t.focusedOption;
    return ["p-select-option", {
      "p-select-option-selected": n.isSelected(r) && o.highlightOnSelect,
      "p-focus": i.focusedOptionIndex === a,
      "p-disabled": n.isOptionDisabled(r)
    }];
  },
  optionLabel: "p-select-option-label",
  optionCheckIcon: "p-select-option-check-icon",
  optionBlankIcon: "p-select-option-blank-icon",
  emptyMessage: "p-select-empty-message"
}, Fk = oe.extend({
  name: "select",
  style: Ak,
  classes: _k
}), Ek = {
  name: "BaseSelect",
  extends: on,
  props: {
    options: Array,
    optionLabel: [String, Function],
    optionValue: [String, Function],
    optionDisabled: [String, Function],
    optionGroupLabel: [String, Function],
    optionGroupChildren: [String, Function],
    scrollHeight: {
      type: String,
      default: "14rem"
    },
    filter: Boolean,
    filterPlaceholder: String,
    filterLocale: String,
    filterMatchMode: {
      type: String,
      default: "contains"
    },
    filterFields: {
      type: Array,
      default: null
    },
    editable: Boolean,
    placeholder: {
      type: String,
      default: null
    },
    dataKey: null,
    showClear: {
      type: Boolean,
      default: !1
    },
    inputId: {
      type: String,
      default: null
    },
    inputClass: {
      type: [String, Object],
      default: null
    },
    inputStyle: {
      type: Object,
      default: null
    },
    labelId: {
      type: String,
      default: null
    },
    labelClass: {
      type: [String, Object],
      default: null
    },
    labelStyle: {
      type: Object,
      default: null
    },
    panelClass: {
      type: [String, Object],
      default: null
    },
    overlayStyle: {
      type: Object,
      default: null
    },
    overlayClass: {
      type: [String, Object],
      default: null
    },
    panelStyle: {
      type: Object,
      default: null
    },
    appendTo: {
      type: [String, Object],
      default: "body"
    },
    loading: {
      type: Boolean,
      default: !1
    },
    clearIcon: {
      type: String,
      default: void 0
    },
    dropdownIcon: {
      type: String,
      default: void 0
    },
    filterIcon: {
      type: String,
      default: void 0
    },
    loadingIcon: {
      type: String,
      default: void 0
    },
    resetFilterOnHide: {
      type: Boolean,
      default: !1
    },
    resetFilterOnClear: {
      type: Boolean,
      default: !1
    },
    virtualScrollerOptions: {
      type: Object,
      default: null
    },
    autoOptionFocus: {
      type: Boolean,
      default: !1
    },
    autoFilterFocus: {
      type: Boolean,
      default: !1
    },
    selectOnFocus: {
      type: Boolean,
      default: !1
    },
    focusOnHover: {
      type: Boolean,
      default: !0
    },
    highlightOnSelect: {
      type: Boolean,
      default: !0
    },
    checkmark: {
      type: Boolean,
      default: !1
    },
    filterMessage: {
      type: String,
      default: null
    },
    selectionMessage: {
      type: String,
      default: null
    },
    emptySelectionMessage: {
      type: String,
      default: null
    },
    emptyFilterMessage: {
      type: String,
      default: null
    },
    emptyMessage: {
      type: String,
      default: null
    },
    tabindex: {
      type: Number,
      default: 0
    },
    ariaLabel: {
      type: String,
      default: null
    },
    ariaLabelledby: {
      type: String,
      default: null
    }
  },
  style: Fk,
  provide: function() {
    return {
      $pcSelect: this,
      $parentInstance: this
    };
  }
};
function to(e) {
  "@babel/helpers - typeof";
  return to = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, to(e);
}
function Rk(e) {
  return Uk(e) || jk(e) || Nk(e) || Vk();
}
function Vk() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Nk(e, t) {
  if (e) {
    if (typeof e == "string") return Cr(e, t);
    var n = {}.toString.call(e).slice(8, -1);
    return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Cr(e, t) : void 0;
  }
}
function jk(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function Uk(e) {
  if (Array.isArray(e)) return Cr(e);
}
function Cr(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, o = Array(t); n < t; n++) o[n] = e[n];
  return o;
}
function ra(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    t && (o = o.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, o);
  }
  return n;
}
function ia(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ra(Object(n), !0).forEach(function(o) {
      Ht(e, o, n[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : ra(Object(n)).forEach(function(o) {
      Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(n, o));
    });
  }
  return e;
}
function Ht(e, t, n) {
  return (t = Hk(t)) in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Hk(e) {
  var t = Kk(e, "string");
  return to(t) == "symbol" ? t : t + "";
}
function Kk(e, t) {
  if (to(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var o = n.call(e, t);
    if (to(o) != "object") return o;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var rn = {
  name: "Select",
  extends: Ek,
  inheritAttrs: !1,
  emits: ["change", "focus", "blur", "before-show", "before-hide", "show", "hide", "filter"],
  outsideClickListener: null,
  scrollHandler: null,
  resizeListener: null,
  labelClickListener: null,
  matchMediaOrientationListener: null,
  overlay: null,
  list: null,
  virtualScroller: null,
  searchTimeout: null,
  searchValue: null,
  isModelValueChanged: !1,
  data: function() {
    return {
      clicked: !1,
      focused: !1,
      focusedOptionIndex: -1,
      filterValue: null,
      overlayVisible: !1,
      queryOrientation: null
    };
  },
  watch: {
    modelValue: function() {
      this.isModelValueChanged = !0;
    },
    options: function() {
      this.autoUpdateModel();
    }
  },
  mounted: function() {
    this.autoUpdateModel(), this.bindLabelClickListener(), this.bindMatchMediaOrientationListener();
  },
  updated: function() {
    this.overlayVisible && this.isModelValueChanged && this.scrollInView(this.findSelectedOptionIndex()), this.isModelValueChanged = !1;
  },
  beforeUnmount: function() {
    this.unbindOutsideClickListener(), this.unbindResizeListener(), this.unbindLabelClickListener(), this.unbindMatchMediaOrientationListener(), this.scrollHandler && (this.scrollHandler.destroy(), this.scrollHandler = null), this.overlay && (wt.clear(this.overlay), this.overlay = null);
  },
  methods: {
    getOptionIndex: function(t, n) {
      return this.virtualScrollerDisabled ? t : n && n(t).index;
    },
    getOptionLabel: function(t) {
      return this.optionLabel ? kt(t, this.optionLabel) : t;
    },
    getOptionValue: function(t) {
      return this.optionValue ? kt(t, this.optionValue) : t;
    },
    getOptionRenderKey: function(t, n) {
      return (this.dataKey ? kt(t, this.dataKey) : this.getOptionLabel(t)) + "_" + n;
    },
    getPTItemOptions: function(t, n, o, i) {
      return this.ptm(i, {
        context: {
          option: t,
          index: o,
          selected: this.isSelected(t),
          focused: this.focusedOptionIndex === this.getOptionIndex(o, n),
          disabled: this.isOptionDisabled(t)
        }
      });
    },
    isOptionDisabled: function(t) {
      return this.optionDisabled ? kt(t, this.optionDisabled) : !1;
    },
    isOptionGroup: function(t) {
      return this.optionGroupLabel && t.optionGroup && t.group;
    },
    getOptionGroupLabel: function(t) {
      return kt(t, this.optionGroupLabel);
    },
    getOptionGroupChildren: function(t) {
      return kt(t, this.optionGroupChildren);
    },
    getAriaPosInset: function(t) {
      var n = this;
      return (this.optionGroupLabel ? t - this.visibleOptions.slice(0, t).filter(function(o) {
        return n.isOptionGroup(o);
      }).length : t) + 1;
    },
    show: function(t) {
      this.$emit("before-show"), this.overlayVisible = !0, this.focusedOptionIndex = this.focusedOptionIndex !== -1 ? this.focusedOptionIndex : this.autoOptionFocus ? this.findFirstFocusedOptionIndex() : this.editable ? -1 : this.findSelectedOptionIndex(), t && We(this.$refs.focusInput);
    },
    hide: function(t) {
      var n = this, o = function() {
        n.$emit("before-hide"), n.overlayVisible = !1, n.clicked = !1, n.focusedOptionIndex = -1, n.searchValue = "", n.resetFilterOnHide && (n.filterValue = null), t && We(n.$refs.focusInput);
      };
      setTimeout(function() {
        o();
      }, 0);
    },
    onFocus: function(t) {
      this.disabled || (this.focused = !0, this.overlayVisible && (this.focusedOptionIndex = this.focusedOptionIndex !== -1 ? this.focusedOptionIndex : this.autoOptionFocus ? this.findFirstFocusedOptionIndex() : this.editable ? -1 : this.findSelectedOptionIndex(), this.scrollInView(this.focusedOptionIndex)), this.$emit("focus", t));
    },
    onBlur: function(t) {
      var n = this;
      setTimeout(function() {
        var o, i;
        n.focused = !1, n.focusedOptionIndex = -1, n.searchValue = "", n.$emit("blur", t), (o = (i = n.formField).onBlur) === null || o === void 0 || o.call(i, t);
      }, 100);
    },
    onKeyDown: function(t) {
      if (this.disabled) {
        t.preventDefault();
        return;
      }
      if (js())
        switch (t.code) {
          case "Backspace":
            this.onBackspaceKey(t, this.editable);
            break;
          case "Enter":
          case "NumpadDecimal":
            this.onEnterKey(t);
            break;
          default:
            t.preventDefault();
            return;
        }
      var n = t.metaKey || t.ctrlKey;
      switch (t.code) {
        case "ArrowDown":
          this.onArrowDownKey(t);
          break;
        case "ArrowUp":
          this.onArrowUpKey(t, this.editable);
          break;
        case "ArrowLeft":
        case "ArrowRight":
          this.onArrowLeftKey(t, this.editable);
          break;
        case "Home":
          this.onHomeKey(t, this.editable);
          break;
        case "End":
          this.onEndKey(t, this.editable);
          break;
        case "PageDown":
          this.onPageDownKey(t);
          break;
        case "PageUp":
          this.onPageUpKey(t);
          break;
        case "Space":
          this.onSpaceKey(t, this.editable);
          break;
        case "Enter":
        case "NumpadEnter":
          this.onEnterKey(t);
          break;
        case "Escape":
          this.onEscapeKey(t);
          break;
        case "Tab":
          this.onTabKey(t);
          break;
        case "Backspace":
          this.onBackspaceKey(t, this.editable);
          break;
        case "ShiftLeft":
        case "ShiftRight":
          break;
        default:
          !n && Ts(t.key) && (!this.overlayVisible && this.show(), !this.editable && this.searchOptions(t, t.key));
          break;
      }
      this.clicked = !1;
    },
    onEditableInput: function(t) {
      var n = t.target.value;
      this.searchValue = "";
      var o = this.searchOptions(t, n);
      !o && (this.focusedOptionIndex = -1), this.updateModel(t, n), !this.overlayVisible && le(n) && this.show();
    },
    onContainerClick: function(t) {
      this.disabled || this.loading || t.target.tagName === "INPUT" || t.target.getAttribute("data-pc-section") === "clearicon" || t.target.closest('[data-pc-section="clearicon"]') || ((!this.overlay || !this.overlay.contains(t.target)) && (this.overlayVisible ? this.hide(!0) : this.show(!0)), this.clicked = !0);
    },
    onClearClick: function(t) {
      this.updateModel(t, null), this.resetFilterOnClear && (this.filterValue = null);
    },
    onFirstHiddenFocus: function(t) {
      var n = t.relatedTarget === this.$refs.focusInput ? un(this.overlay, ':not([data-p-hidden-focusable="true"])') : this.$refs.focusInput;
      We(n);
    },
    onLastHiddenFocus: function(t) {
      var n = t.relatedTarget === this.$refs.focusInput ? Oa(this.overlay, ':not([data-p-hidden-focusable="true"])') : this.$refs.focusInput;
      We(n);
    },
    onOptionSelect: function(t, n) {
      var o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0, i = this.getOptionValue(n) !== "" ? this.getOptionValue(n) : this.getOptionLabel(n);
      this.updateModel(t, i), o && this.hide(!0);
    },
    onOptionMouseMove: function(t, n) {
      this.focusOnHover && this.changeFocusedOptionIndex(t, n);
    },
    onFilterChange: function(t) {
      var n = t.target.value;
      this.filterValue = n, this.focusedOptionIndex = -1, this.$emit("filter", {
        originalEvent: t,
        value: n
      }), !this.virtualScrollerDisabled && this.virtualScroller.scrollToIndex(0);
    },
    onFilterKeyDown: function(t) {
      if (!t.isComposing)
        switch (t.code) {
          case "ArrowDown":
            this.onArrowDownKey(t);
            break;
          case "ArrowUp":
            this.onArrowUpKey(t, !0);
            break;
          case "ArrowLeft":
          case "ArrowRight":
            this.onArrowLeftKey(t, !0);
            break;
          case "Home":
            this.onHomeKey(t, !0);
            break;
          case "End":
            this.onEndKey(t, !0);
            break;
          case "Enter":
          case "NumpadEnter":
            this.onEnterKey(t);
            break;
          case "Escape":
            this.onEscapeKey(t);
            break;
          case "Tab":
            this.onTabKey(t);
            break;
        }
    },
    onFilterBlur: function() {
      this.focusedOptionIndex = -1;
    },
    onFilterUpdated: function() {
      this.overlayVisible && this.alignOverlay();
    },
    onOverlayClick: function(t) {
      yl.emit("overlay-click", {
        originalEvent: t,
        target: this.$el
      });
    },
    onOverlayKeyDown: function(t) {
      switch (t.code) {
        case "Escape":
          this.onEscapeKey(t);
          break;
      }
    },
    onArrowDownKey: function(t) {
      if (!this.overlayVisible)
        this.show(), this.editable && this.changeFocusedOptionIndex(t, this.findSelectedOptionIndex());
      else {
        var n = this.focusedOptionIndex !== -1 ? this.findNextOptionIndex(this.focusedOptionIndex) : this.clicked ? this.findFirstOptionIndex() : this.findFirstFocusedOptionIndex();
        this.changeFocusedOptionIndex(t, n);
      }
      t.preventDefault();
    },
    onArrowUpKey: function(t) {
      var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
      if (t.altKey && !n)
        this.focusedOptionIndex !== -1 && this.onOptionSelect(t, this.visibleOptions[this.focusedOptionIndex]), this.overlayVisible && this.hide(), t.preventDefault();
      else {
        var o = this.focusedOptionIndex !== -1 ? this.findPrevOptionIndex(this.focusedOptionIndex) : this.clicked ? this.findLastOptionIndex() : this.findLastFocusedOptionIndex();
        this.changeFocusedOptionIndex(t, o), !this.overlayVisible && this.show(), t.preventDefault();
      }
    },
    onArrowLeftKey: function(t) {
      var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
      n && (this.focusedOptionIndex = -1);
    },
    onHomeKey: function(t) {
      var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
      if (n) {
        var o = t.currentTarget;
        t.shiftKey ? o.setSelectionRange(0, t.target.selectionStart) : (o.setSelectionRange(0, 0), this.focusedOptionIndex = -1);
      } else
        this.changeFocusedOptionIndex(t, this.findFirstOptionIndex()), !this.overlayVisible && this.show();
      t.preventDefault();
    },
    onEndKey: function(t) {
      var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
      if (n) {
        var o = t.currentTarget;
        if (t.shiftKey)
          o.setSelectionRange(t.target.selectionStart, o.value.length);
        else {
          var i = o.value.length;
          o.setSelectionRange(i, i), this.focusedOptionIndex = -1;
        }
      } else
        this.changeFocusedOptionIndex(t, this.findLastOptionIndex()), !this.overlayVisible && this.show();
      t.preventDefault();
    },
    onPageUpKey: function(t) {
      this.scrollInView(0), t.preventDefault();
    },
    onPageDownKey: function(t) {
      this.scrollInView(this.visibleOptions.length - 1), t.preventDefault();
    },
    onEnterKey: function(t) {
      this.overlayVisible ? (this.focusedOptionIndex !== -1 && this.onOptionSelect(t, this.visibleOptions[this.focusedOptionIndex]), this.hide(!0)) : (this.focusedOptionIndex = -1, this.onArrowDownKey(t)), t.preventDefault();
    },
    onSpaceKey: function(t) {
      var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
      !n && this.onEnterKey(t);
    },
    onEscapeKey: function(t) {
      this.overlayVisible && this.hide(!0), t.preventDefault(), t.stopPropagation();
    },
    onTabKey: function(t) {
      var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
      n || (this.overlayVisible && this.hasFocusableElements() ? (We(this.$refs.firstHiddenFocusableElementOnOverlay), t.preventDefault()) : (this.focusedOptionIndex !== -1 && this.onOptionSelect(t, this.visibleOptions[this.focusedOptionIndex]), this.overlayVisible && this.hide(this.filter)));
    },
    onBackspaceKey: function(t) {
      var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
      n && !this.overlayVisible && this.show();
    },
    onOverlayEnter: function(t) {
      var n = this;
      wt.set("overlay", t, this.$primevue.config.zIndex.overlay), Hr(t, {
        position: "absolute",
        top: "0"
      }), this.alignOverlay(), this.scrollInView(), this.$attrSelector && t.setAttribute(this.$attrSelector, ""), setTimeout(function() {
        n.autoFilterFocus && n.filter && We(n.$refs.filterInput.$el), n.autoUpdateModel();
      }, 1);
    },
    onOverlayAfterEnter: function() {
      this.bindOutsideClickListener(), this.bindScrollListener(), this.bindResizeListener(), this.$emit("show");
    },
    onOverlayLeave: function() {
      var t = this;
      this.unbindOutsideClickListener(), this.unbindScrollListener(), this.unbindResizeListener(), this.autoFilterFocus && this.filter && !this.editable && this.$nextTick(function() {
        t.$refs.filterInput && We(t.$refs.filterInput.$el);
      }), this.$emit("hide"), this.overlay = null;
    },
    onOverlayAfterLeave: function(t) {
      wt.clear(t);
    },
    alignOverlay: function() {
      this.appendTo === "self" ? za(this.overlay, this.$el) : this.overlay && (this.overlay.style.minWidth = fn(this.$el) + "px", Pa(this.overlay, this.$el));
    },
    bindOutsideClickListener: function() {
      var t = this;
      this.outsideClickListener || (this.outsideClickListener = function(n) {
        var o = n.composedPath();
        t.overlayVisible && t.overlay && !o.includes(t.$el) && !o.includes(t.overlay) && t.hide();
      }, document.addEventListener("click", this.outsideClickListener, !0));
    },
    unbindOutsideClickListener: function() {
      this.outsideClickListener && (document.removeEventListener("click", this.outsideClickListener, !0), this.outsideClickListener = null);
    },
    bindScrollListener: function() {
      var t = this;
      this.scrollHandler || (this.scrollHandler = new ml(this.$refs.container, function() {
        t.overlayVisible && t.hide();
      })), this.scrollHandler.bindScrollListener();
    },
    unbindScrollListener: function() {
      this.scrollHandler && this.scrollHandler.unbindScrollListener();
    },
    bindResizeListener: function() {
      var t = this;
      this.resizeListener || (this.resizeListener = function() {
        t.overlayVisible && !Fa() && t.hide();
      }, window.addEventListener("resize", this.resizeListener));
    },
    unbindResizeListener: function() {
      this.resizeListener && (window.removeEventListener("resize", this.resizeListener), this.resizeListener = null);
    },
    bindLabelClickListener: function() {
      var t = this;
      if (!this.editable && !this.labelClickListener) {
        var n = document.querySelector('label[for="'.concat(this.labelId, '"]'));
        n && Lo(n) && (this.labelClickListener = function() {
          We(t.$refs.focusInput);
        }, n.addEventListener("click", this.labelClickListener));
      }
    },
    unbindLabelClickListener: function() {
      if (this.labelClickListener) {
        var t = document.querySelector('label[for="'.concat(this.labelId, '"]'));
        t && Lo(t) && t.removeEventListener("click", this.labelClickListener);
      }
    },
    bindMatchMediaOrientationListener: function() {
      var t = this;
      if (!this.matchMediaOrientationListener) {
        var n = matchMedia("(orientation: portrait)");
        this.queryOrientation = n, this.matchMediaOrientationListener = function() {
          t.alignOverlay();
        }, this.queryOrientation.addEventListener("change", this.matchMediaOrientationListener);
      }
    },
    unbindMatchMediaOrientationListener: function() {
      this.matchMediaOrientationListener && (this.queryOrientation.removeEventListener("change", this.matchMediaOrientationListener), this.queryOrientation = null, this.matchMediaOrientationListener = null);
    },
    hasFocusableElements: function() {
      return En(this.overlay, ':not([data-p-hidden-focusable="true"])').length > 0;
    },
    isOptionExactMatched: function(t) {
      var n;
      return this.isValidOption(t) && typeof this.getOptionLabel(t) == "string" && ((n = this.getOptionLabel(t)) === null || n === void 0 ? void 0 : n.toLocaleLowerCase(this.filterLocale)) == this.searchValue.toLocaleLowerCase(this.filterLocale);
    },
    isOptionStartsWith: function(t) {
      var n;
      return this.isValidOption(t) && typeof this.getOptionLabel(t) == "string" && ((n = this.getOptionLabel(t)) === null || n === void 0 ? void 0 : n.toLocaleLowerCase(this.filterLocale).startsWith(this.searchValue.toLocaleLowerCase(this.filterLocale)));
    },
    isValidOption: function(t) {
      return le(t) && !(this.isOptionDisabled(t) || this.isOptionGroup(t));
    },
    isValidSelectedOption: function(t) {
      return this.isValidOption(t) && this.isSelected(t);
    },
    isSelected: function(t) {
      return co(this.d_value, this.getOptionValue(t) !== "" ? this.getOptionValue(t) : this.getOptionLabel(t), this.equalityKey);
    },
    findFirstOptionIndex: function() {
      var t = this;
      return this.visibleOptions.findIndex(function(n) {
        return t.isValidOption(n);
      });
    },
    findLastOptionIndex: function() {
      var t = this;
      return hi(this.visibleOptions, function(n) {
        return t.isValidOption(n);
      });
    },
    findNextOptionIndex: function(t) {
      var n = this, o = t < this.visibleOptions.length - 1 ? this.visibleOptions.slice(t + 1).findIndex(function(i) {
        return n.isValidOption(i);
      }) : -1;
      return o > -1 ? o + t + 1 : t;
    },
    findPrevOptionIndex: function(t) {
      var n = this, o = t > 0 ? hi(this.visibleOptions.slice(0, t), function(i) {
        return n.isValidOption(i);
      }) : -1;
      return o > -1 ? o : t;
    },
    findSelectedOptionIndex: function() {
      var t = this;
      return this.$filled ? this.visibleOptions.findIndex(function(n) {
        return t.isValidSelectedOption(n);
      }) : -1;
    },
    findFirstFocusedOptionIndex: function() {
      var t = this.findSelectedOptionIndex();
      return t < 0 ? this.findFirstOptionIndex() : t;
    },
    findLastFocusedOptionIndex: function() {
      var t = this.findSelectedOptionIndex();
      return t < 0 ? this.findLastOptionIndex() : t;
    },
    searchOptions: function(t, n) {
      var o = this;
      this.searchValue = (this.searchValue || "") + n;
      var i = -1, r = !1;
      return le(this.searchValue) && (i = this.visibleOptions.findIndex(function(a) {
        return o.isOptionExactMatched(a);
      }), i === -1 && (i = this.visibleOptions.findIndex(function(a) {
        return o.isOptionStartsWith(a);
      })), i !== -1 && (r = !0), i === -1 && this.focusedOptionIndex === -1 && (i = this.findFirstFocusedOptionIndex()), i !== -1 && this.changeFocusedOptionIndex(t, i)), this.searchTimeout && clearTimeout(this.searchTimeout), this.searchTimeout = setTimeout(function() {
        o.searchValue = "", o.searchTimeout = null;
      }, 500), r;
    },
    changeFocusedOptionIndex: function(t, n) {
      this.focusedOptionIndex !== n && (this.focusedOptionIndex = n, this.scrollInView(), this.selectOnFocus && this.onOptionSelect(t, this.visibleOptions[n], !1));
    },
    scrollInView: function() {
      var t = this, n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : -1;
      this.$nextTick(function() {
        var o = n !== -1 ? "".concat(t.$id, "_").concat(n) : t.focusedOptionId, i = qe(t.list, 'li[id="'.concat(o, '"]'));
        i ? i.scrollIntoView && i.scrollIntoView({
          block: "nearest",
          inline: "nearest"
        }) : t.virtualScrollerDisabled || t.virtualScroller && t.virtualScroller.scrollToIndex(n !== -1 ? n : t.focusedOptionIndex);
      });
    },
    autoUpdateModel: function() {
      this.autoOptionFocus && (this.focusedOptionIndex = this.findFirstFocusedOptionIndex()), this.selectOnFocus && this.autoOptionFocus && !this.$filled && this.onOptionSelect(null, this.visibleOptions[this.focusedOptionIndex], !1);
    },
    updateModel: function(t, n) {
      this.writeValue(n, t), this.$emit("change", {
        originalEvent: t,
        value: n
      });
    },
    flatOptions: function(t) {
      var n = this;
      return (t || []).reduce(function(o, i, r) {
        o.push({
          optionGroup: i,
          group: !0,
          index: r
        });
        var a = n.getOptionGroupChildren(i);
        return a && a.forEach(function(d) {
          return o.push(d);
        }), o;
      }, []);
    },
    overlayRef: function(t) {
      this.overlay = t;
    },
    listRef: function(t, n) {
      this.list = t, n && n(t);
    },
    virtualScrollerRef: function(t) {
      this.virtualScroller = t;
    }
  },
  computed: {
    visibleOptions: function() {
      var t = this, n = this.optionGroupLabel ? this.flatOptions(this.options) : this.options || [];
      if (this.filterValue) {
        var o = ad.filter(n, this.searchFields, this.filterValue, this.filterMatchMode, this.filterLocale);
        if (this.optionGroupLabel) {
          var i = this.options || [], r = [];
          return i.forEach(function(a) {
            var d = t.getOptionGroupChildren(a), l = d.filter(function(u) {
              return o.includes(u);
            });
            l.length > 0 && r.push(ia(ia({}, a), {}, Ht({}, typeof t.optionGroupChildren == "string" ? t.optionGroupChildren : "items", Rk(l))));
          }), this.flatOptions(r);
        }
        return o;
      }
      return n;
    },
    // @deprecated use $filled instead
    hasSelectedOption: function() {
      return this.$filled;
    },
    label: function() {
      var t = this.findSelectedOptionIndex();
      return t !== -1 ? this.getOptionLabel(this.visibleOptions[t]) : this.placeholder || "p-emptylabel";
    },
    editableInputValue: function() {
      var t = this.findSelectedOptionIndex();
      return t !== -1 ? this.getOptionLabel(this.visibleOptions[t]) : this.d_value || "";
    },
    equalityKey: function() {
      return this.optionValue ? null : this.dataKey;
    },
    searchFields: function() {
      return this.filterFields || [this.optionLabel];
    },
    filterResultMessageText: function() {
      return le(this.visibleOptions) ? this.filterMessageText.replaceAll("{0}", this.visibleOptions.length) : this.emptyFilterMessageText;
    },
    filterMessageText: function() {
      return this.filterMessage || this.$primevue.config.locale.searchMessage || "";
    },
    emptyFilterMessageText: function() {
      return this.emptyFilterMessage || this.$primevue.config.locale.emptySearchMessage || this.$primevue.config.locale.emptyFilterMessage || "";
    },
    emptyMessageText: function() {
      return this.emptyMessage || this.$primevue.config.locale.emptyMessage || "";
    },
    selectionMessageText: function() {
      return this.selectionMessage || this.$primevue.config.locale.selectionMessage || "";
    },
    emptySelectionMessageText: function() {
      return this.emptySelectionMessage || this.$primevue.config.locale.emptySelectionMessage || "";
    },
    selectedMessageText: function() {
      return this.$filled ? this.selectionMessageText.replaceAll("{0}", "1") : this.emptySelectionMessageText;
    },
    focusedOptionId: function() {
      return this.focusedOptionIndex !== -1 ? "".concat(this.$id, "_").concat(this.focusedOptionIndex) : null;
    },
    ariaSetSize: function() {
      var t = this;
      return this.visibleOptions.filter(function(n) {
        return !t.isOptionGroup(n);
      }).length;
    },
    isClearIconVisible: function() {
      return this.showClear && this.d_value != null && le(this.options);
    },
    virtualScrollerDisabled: function() {
      return !this.virtualScrollerOptions;
    },
    containerDataP: function() {
      return Pe(Ht({
        invalid: this.$invalid,
        disabled: this.disabled,
        focus: this.focused,
        fluid: this.$fluid,
        filled: this.$variant === "filled"
      }, this.size, this.size));
    },
    labelDataP: function() {
      return Pe(Ht(Ht({
        placeholder: !this.editable && this.label === this.placeholder,
        clearable: this.showClear,
        disabled: this.disabled,
        editable: this.editable
      }, this.size, this.size), "empty", !this.editable && !this.$slots.value && (this.label === "p-emptylabel" || this.label.length === 0)));
    },
    dropdownIconDataP: function() {
      return Pe(Ht({}, this.size, this.size));
    },
    overlayDataP: function() {
      return Pe(Ht({}, "portal-" + this.appendTo, "portal-" + this.appendTo));
    }
  },
  directives: {
    ripple: fo
  },
  components: {
    InputText: Et,
    VirtualScroller: wl,
    Portal: Yo,
    InputIcon: bl,
    IconField: hl,
    TimesIcon: Wo,
    ChevronDownIcon: Xr,
    SpinnerIcon: Ko,
    SearchIcon: gl,
    CheckIcon: Zr,
    BlankIcon: fl
  }
}, Wk = ["id", "data-p"], Yk = ["name", "id", "value", "placeholder", "tabindex", "disabled", "aria-label", "aria-labelledby", "aria-expanded", "aria-controls", "aria-activedescendant", "aria-invalid", "data-p"], Gk = ["name", "id", "tabindex", "aria-label", "aria-labelledby", "aria-expanded", "aria-controls", "aria-activedescendant", "aria-invalid", "aria-disabled", "data-p"], qk = ["data-p"], Zk = ["id"], Xk = ["id"], Jk = ["id", "aria-label", "aria-selected", "aria-disabled", "aria-setsize", "aria-posinset", "onMousedown", "onMousemove", "data-p-selected", "data-p-focused", "data-p-disabled"];
function Qk(e, t, n, o, i, r) {
  var a = ze("SpinnerIcon"), d = ze("InputText"), l = ze("SearchIcon"), u = ze("InputIcon"), s = ze("IconField"), c = ze("CheckIcon"), p = ze("BlankIcon"), f = ze("VirtualScroller"), b = ze("Portal"), k = uo("ripple");
  return m(), h("div", x({
    ref: "container",
    id: e.$id,
    class: e.cx("root"),
    onClick: t[12] || (t[12] = function() {
      return r.onContainerClick && r.onContainerClick.apply(r, arguments);
    }),
    "data-p": r.containerDataP
  }, e.ptmi("root")), [e.editable ? (m(), h("input", x({
    key: 0,
    ref: "focusInput",
    name: e.name,
    id: e.labelId || e.inputId,
    type: "text",
    class: [e.cx("label"), e.inputClass, e.labelClass],
    style: [e.inputStyle, e.labelStyle],
    value: r.editableInputValue,
    placeholder: e.placeholder,
    tabindex: e.disabled ? -1 : e.tabindex,
    disabled: e.disabled,
    autocomplete: "off",
    role: "combobox",
    "aria-label": e.ariaLabel,
    "aria-labelledby": e.ariaLabelledby,
    "aria-haspopup": "listbox",
    "aria-expanded": i.overlayVisible,
    "aria-controls": e.$id + "_list",
    "aria-activedescendant": i.focused ? r.focusedOptionId : void 0,
    "aria-invalid": e.invalid || void 0,
    onFocus: t[0] || (t[0] = function() {
      return r.onFocus && r.onFocus.apply(r, arguments);
    }),
    onBlur: t[1] || (t[1] = function() {
      return r.onBlur && r.onBlur.apply(r, arguments);
    }),
    onKeydown: t[2] || (t[2] = function() {
      return r.onKeyDown && r.onKeyDown.apply(r, arguments);
    }),
    onInput: t[3] || (t[3] = function() {
      return r.onEditableInput && r.onEditableInput.apply(r, arguments);
    }),
    "data-p": r.labelDataP
  }, e.ptm("label")), null, 16, Yk)) : (m(), h("span", x({
    key: 1,
    ref: "focusInput",
    name: e.name,
    id: e.labelId || e.inputId,
    class: [e.cx("label"), e.inputClass, e.labelClass],
    style: [e.inputStyle, e.labelStyle],
    tabindex: e.disabled ? -1 : e.tabindex,
    role: "combobox",
    "aria-label": e.ariaLabel || (r.label === "p-emptylabel" ? void 0 : r.label),
    "aria-labelledby": e.ariaLabelledby,
    "aria-haspopup": "listbox",
    "aria-expanded": i.overlayVisible,
    "aria-controls": e.$id + "_list",
    "aria-activedescendant": i.focused ? r.focusedOptionId : void 0,
    "aria-invalid": e.invalid || void 0,
    "aria-disabled": e.disabled,
    onFocus: t[4] || (t[4] = function() {
      return r.onFocus && r.onFocus.apply(r, arguments);
    }),
    onBlur: t[5] || (t[5] = function() {
      return r.onBlur && r.onBlur.apply(r, arguments);
    }),
    onKeydown: t[6] || (t[6] = function() {
      return r.onKeyDown && r.onKeyDown.apply(r, arguments);
    }),
    "data-p": r.labelDataP
  }, e.ptm("label")), [R(e.$slots, "value", {
    value: e.d_value,
    placeholder: e.placeholder
  }, function() {
    var T;
    return [q(y(r.label === "p-emptylabel" ? " " : (T = r.label) !== null && T !== void 0 ? T : "empty"), 1)];
  })], 16, Gk)), r.isClearIconVisible ? R(e.$slots, "clearicon", {
    key: 2,
    class: ee(e.cx("clearIcon")),
    clearCallback: r.onClearClick
  }, function() {
    return [(m(), j($e(e.clearIcon ? "i" : "TimesIcon"), x({
      ref: "clearIcon",
      class: [e.cx("clearIcon"), e.clearIcon],
      onClick: r.onClearClick
    }, e.ptm("clearIcon"), {
      "data-pc-section": "clearicon"
    }), null, 16, ["class", "onClick"]))];
  }) : B("", !0), g("div", x({
    class: e.cx("dropdown")
  }, e.ptm("dropdown")), [e.loading ? R(e.$slots, "loadingicon", {
    key: 0,
    class: ee(e.cx("loadingIcon"))
  }, function() {
    return [e.loadingIcon ? (m(), h("span", x({
      key: 0,
      class: [e.cx("loadingIcon"), "pi-spin", e.loadingIcon],
      "aria-hidden": "true"
    }, e.ptm("loadingIcon")), null, 16)) : (m(), j(a, x({
      key: 1,
      class: e.cx("loadingIcon"),
      spin: "",
      "aria-hidden": "true"
    }, e.ptm("loadingIcon")), null, 16, ["class"]))];
  }) : R(e.$slots, "dropdownicon", {
    key: 1,
    class: ee(e.cx("dropdownIcon"))
  }, function() {
    return [(m(), j($e(e.dropdownIcon ? "span" : "ChevronDownIcon"), x({
      class: [e.cx("dropdownIcon"), e.dropdownIcon],
      "aria-hidden": "true",
      "data-p": r.dropdownIconDataP
    }, e.ptm("dropdownIcon")), null, 16, ["class", "data-p"]))];
  })], 16), L(b, {
    appendTo: e.appendTo
  }, {
    default: U(function() {
      return [L(Cn, x({
        name: "p-connected-overlay",
        onEnter: r.onOverlayEnter,
        onAfterEnter: r.onOverlayAfterEnter,
        onLeave: r.onOverlayLeave,
        onAfterLeave: r.onOverlayAfterLeave
      }, e.ptm("transition")), {
        default: U(function() {
          return [i.overlayVisible ? (m(), h("div", x({
            key: 0,
            ref: r.overlayRef,
            class: [e.cx("overlay"), e.panelClass, e.overlayClass],
            style: [e.panelStyle, e.overlayStyle],
            onClick: t[10] || (t[10] = function() {
              return r.onOverlayClick && r.onOverlayClick.apply(r, arguments);
            }),
            onKeydown: t[11] || (t[11] = function() {
              return r.onOverlayKeyDown && r.onOverlayKeyDown.apply(r, arguments);
            }),
            "data-p": r.overlayDataP
          }, e.ptm("overlay")), [g("span", x({
            ref: "firstHiddenFocusableElementOnOverlay",
            role: "presentation",
            "aria-hidden": "true",
            class: "p-hidden-accessible p-hidden-focusable",
            tabindex: 0,
            onFocus: t[7] || (t[7] = function() {
              return r.onFirstHiddenFocus && r.onFirstHiddenFocus.apply(r, arguments);
            })
          }, e.ptm("hiddenFirstFocusableEl"), {
            "data-p-hidden-accessible": !0,
            "data-p-hidden-focusable": !0
          }), null, 16), R(e.$slots, "header", {
            value: e.d_value,
            options: r.visibleOptions
          }), e.filter ? (m(), h("div", x({
            key: 0,
            class: e.cx("header")
          }, e.ptm("header")), [L(s, {
            unstyled: e.unstyled,
            pt: e.ptm("pcFilterContainer")
          }, {
            default: U(function() {
              return [L(d, {
                ref: "filterInput",
                type: "text",
                value: i.filterValue,
                onVnodeMounted: r.onFilterUpdated,
                onVnodeUpdated: r.onFilterUpdated,
                class: ee(e.cx("pcFilter")),
                placeholder: e.filterPlaceholder,
                variant: e.variant,
                unstyled: e.unstyled,
                role: "searchbox",
                autocomplete: "off",
                "aria-owns": e.$id + "_list",
                "aria-activedescendant": r.focusedOptionId,
                onKeydown: r.onFilterKeyDown,
                onBlur: r.onFilterBlur,
                onInput: r.onFilterChange,
                pt: e.ptm("pcFilter"),
                formControl: {
                  novalidate: !0
                }
              }, null, 8, ["value", "onVnodeMounted", "onVnodeUpdated", "class", "placeholder", "variant", "unstyled", "aria-owns", "aria-activedescendant", "onKeydown", "onBlur", "onInput", "pt"]), L(u, {
                unstyled: e.unstyled,
                pt: e.ptm("pcFilterIconContainer")
              }, {
                default: U(function() {
                  return [R(e.$slots, "filtericon", {}, function() {
                    return [e.filterIcon ? (m(), h("span", x({
                      key: 0,
                      class: e.filterIcon
                    }, e.ptm("filterIcon")), null, 16)) : (m(), j(l, Vo(x({
                      key: 1
                    }, e.ptm("filterIcon"))), null, 16))];
                  })];
                }),
                _: 3
              }, 8, ["unstyled", "pt"])];
            }),
            _: 3
          }, 8, ["unstyled", "pt"]), g("span", x({
            role: "status",
            "aria-live": "polite",
            class: "p-hidden-accessible"
          }, e.ptm("hiddenFilterResult"), {
            "data-p-hidden-accessible": !0
          }), y(r.filterResultMessageText), 17)], 16)) : B("", !0), g("div", x({
            class: e.cx("listContainer"),
            style: {
              "max-height": r.virtualScrollerDisabled ? e.scrollHeight : ""
            }
          }, e.ptm("listContainer")), [L(f, x({
            ref: r.virtualScrollerRef
          }, e.virtualScrollerOptions, {
            items: r.visibleOptions,
            style: {
              height: e.scrollHeight
            },
            tabindex: -1,
            disabled: r.virtualScrollerDisabled,
            pt: e.ptm("virtualScroller")
          }), ht({
            content: U(function(T) {
              var $ = T.styleClass, S = T.contentRef, O = T.items, w = T.getItemOptions, F = T.contentStyle, D = T.itemSize;
              return [g("ul", x({
                ref: function(I) {
                  return r.listRef(I, S);
                },
                id: e.$id + "_list",
                class: [e.cx("list"), $],
                style: F,
                role: "listbox"
              }, e.ptm("list")), [(m(!0), h(Y, null, he(O, function(C, I) {
                return m(), h(Y, {
                  key: r.getOptionRenderKey(C, r.getOptionIndex(I, w))
                }, [r.isOptionGroup(C) ? (m(), h("li", x({
                  key: 0,
                  id: e.$id + "_" + r.getOptionIndex(I, w),
                  style: {
                    height: D ? D + "px" : void 0
                  },
                  class: e.cx("optionGroup"),
                  role: "option"
                }, {
                  ref_for: !0
                }, e.ptm("optionGroup")), [R(e.$slots, "optiongroup", {
                  option: C.optionGroup,
                  index: r.getOptionIndex(I, w)
                }, function() {
                  return [g("span", x({
                    class: e.cx("optionGroupLabel")
                  }, {
                    ref_for: !0
                  }, e.ptm("optionGroupLabel")), y(r.getOptionGroupLabel(C.optionGroup)), 17)];
                })], 16, Xk)) : Ze((m(), h("li", x({
                  key: 1,
                  id: e.$id + "_" + r.getOptionIndex(I, w),
                  class: e.cx("option", {
                    option: C,
                    focusedOption: r.getOptionIndex(I, w)
                  }),
                  style: {
                    height: D ? D + "px" : void 0
                  },
                  role: "option",
                  "aria-label": r.getOptionLabel(C),
                  "aria-selected": r.isSelected(C),
                  "aria-disabled": r.isOptionDisabled(C),
                  "aria-setsize": r.ariaSetSize,
                  "aria-posinset": r.getAriaPosInset(r.getOptionIndex(I, w)),
                  onMousedown: function(K) {
                    return r.onOptionSelect(K, C);
                  },
                  onMousemove: function(K) {
                    return r.onOptionMouseMove(K, r.getOptionIndex(I, w));
                  },
                  onClick: t[8] || (t[8] = Ot(function() {
                  }, ["stop"])),
                  "data-p-selected": !e.checkmark && r.isSelected(C),
                  "data-p-focused": i.focusedOptionIndex === r.getOptionIndex(I, w),
                  "data-p-disabled": r.isOptionDisabled(C)
                }, {
                  ref_for: !0
                }, r.getPTItemOptions(C, w, I, "option")), [e.checkmark ? (m(), h(Y, {
                  key: 0
                }, [r.isSelected(C) ? (m(), j(c, x({
                  key: 0,
                  class: e.cx("optionCheckIcon")
                }, {
                  ref_for: !0
                }, e.ptm("optionCheckIcon")), null, 16, ["class"])) : (m(), j(p, x({
                  key: 1,
                  class: e.cx("optionBlankIcon")
                }, {
                  ref_for: !0
                }, e.ptm("optionBlankIcon")), null, 16, ["class"]))], 64)) : B("", !0), R(e.$slots, "option", {
                  option: C,
                  selected: r.isSelected(C),
                  index: r.getOptionIndex(I, w)
                }, function() {
                  return [g("span", x({
                    class: e.cx("optionLabel")
                  }, {
                    ref_for: !0
                  }, e.ptm("optionLabel")), y(r.getOptionLabel(C)), 17)];
                })], 16, Jk)), [[k]])], 64);
              }), 128)), i.filterValue && (!O || O && O.length === 0) ? (m(), h("li", x({
                key: 0,
                class: e.cx("emptyMessage"),
                role: "option"
              }, e.ptm("emptyMessage"), {
                "data-p-hidden-accessible": !0
              }), [R(e.$slots, "emptyfilter", {}, function() {
                return [q(y(r.emptyFilterMessageText), 1)];
              })], 16)) : !e.options || e.options && e.options.length === 0 ? (m(), h("li", x({
                key: 1,
                class: e.cx("emptyMessage"),
                role: "option"
              }, e.ptm("emptyMessage"), {
                "data-p-hidden-accessible": !0
              }), [R(e.$slots, "empty", {}, function() {
                return [q(y(r.emptyMessageText), 1)];
              })], 16)) : B("", !0)], 16, Zk)];
            }),
            _: 2
          }, [e.$slots.loader ? {
            name: "loader",
            fn: U(function(T) {
              var $ = T.options;
              return [R(e.$slots, "loader", {
                options: $
              })];
            }),
            key: "0"
          } : void 0]), 1040, ["items", "style", "disabled", "pt"])], 16), R(e.$slots, "footer", {
            value: e.d_value,
            options: r.visibleOptions
          }), !e.options || e.options && e.options.length === 0 ? (m(), h("span", x({
            key: 1,
            role: "status",
            "aria-live": "polite",
            class: "p-hidden-accessible"
          }, e.ptm("hiddenEmptyMessage"), {
            "data-p-hidden-accessible": !0
          }), y(r.emptyMessageText), 17)) : B("", !0), g("span", x({
            role: "status",
            "aria-live": "polite",
            class: "p-hidden-accessible"
          }, e.ptm("hiddenSelectedMessage"), {
            "data-p-hidden-accessible": !0
          }), y(r.selectedMessageText), 17), g("span", x({
            ref: "lastHiddenFocusableElementOnOverlay",
            role: "presentation",
            "aria-hidden": "true",
            class: "p-hidden-accessible p-hidden-focusable",
            tabindex: 0,
            onFocus: t[9] || (t[9] = function() {
              return r.onLastHiddenFocus && r.onLastHiddenFocus.apply(r, arguments);
            })
          }, e.ptm("hiddenLastFocusableEl"), {
            "data-p-hidden-accessible": !0,
            "data-p-hidden-focusable": !0
          }), null, 16)], 16, qk)) : B("", !0)];
        }),
        _: 3
      }, 16, ["onEnter", "onAfterEnter", "onLeave", "onAfterLeave"])];
    }),
    _: 3
  }, 8, ["appendTo"])], 16, Wk);
}
rn.render = Qk;
var ew = {
  root: "p-inputgroupaddon"
}, tw = oe.extend({
  name: "inputgroupaddon",
  classes: ew
}), nw = {
  name: "BaseInputGroupAddon",
  extends: nt,
  style: tw,
  provide: function() {
    return {
      $pcInputGroupAddon: this,
      $parentInstance: this
    };
  }
}, xl = {
  name: "InputGroupAddon",
  extends: nw,
  inheritAttrs: !1
};
function ow(e, t, n, o, i, r) {
  return m(), h("div", x({
    class: e.cx("root")
  }, e.ptmi("root")), [R(e.$slots, "default")], 16);
}
xl.render = ow;
const rw = {
  viewBox: "0 0 24 24",
  width: "1.2em",
  height: "1.2em"
};
function iw(e, t) {
  return m(), h("svg", rw, [...t[0] || (t[0] = [
    g("path", {
      fill: "currentColor",
      d: "M12 20c4.4 0 8-3.6 8-8s-3.6-8-8-8s-8 3.6-8 8s3.6 8 8 8m0-18c5.5 0 10 4.5 10 10s-4.5 10-10 10S2 17.5 2 12S6.5 2 12 2m5 11.9l-.7 1.3l-5.3-2.9V7h1.5v4.4z"
    }, null, -1)
  ])]);
}
const aw = Se({ name: "mdi-clock-time-four-outline", render: iw });
var Cl = {
  name: "CalendarIcon",
  extends: Ue
};
function lw(e) {
  return cw(e) || uw(e) || dw(e) || sw();
}
function sw() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function dw(e, t) {
  if (e) {
    if (typeof e == "string") return Sr(e, t);
    var n = {}.toString.call(e).slice(8, -1);
    return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Sr(e, t) : void 0;
  }
}
function uw(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function cw(e) {
  if (Array.isArray(e)) return Sr(e);
}
function Sr(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, o = Array(t); n < t; n++) o[n] = e[n];
  return o;
}
function pw(e, t, n, o, i, r) {
  return m(), h("svg", x({
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.pti()), lw(t[0] || (t[0] = [g("path", {
    d: "M10.7838 1.51351H9.83783V0.567568C9.83783 0.417039 9.77804 0.272676 9.6716 0.166237C9.56516 0.0597971 9.42079 0 9.27027 0C9.11974 0 8.97538 0.0597971 8.86894 0.166237C8.7625 0.272676 8.7027 0.417039 8.7027 0.567568V1.51351H5.29729V0.567568C5.29729 0.417039 5.2375 0.272676 5.13106 0.166237C5.02462 0.0597971 4.88025 0 4.72973 0C4.5792 0 4.43484 0.0597971 4.3284 0.166237C4.22196 0.272676 4.16216 0.417039 4.16216 0.567568V1.51351H3.21621C2.66428 1.51351 2.13494 1.73277 1.74467 2.12305C1.35439 2.51333 1.13513 3.04266 1.13513 3.59459V11.9189C1.13513 12.4709 1.35439 13.0002 1.74467 13.3905C2.13494 13.7807 2.66428 14 3.21621 14H10.7838C11.3357 14 11.865 13.7807 12.2553 13.3905C12.6456 13.0002 12.8649 12.4709 12.8649 11.9189V3.59459C12.8649 3.04266 12.6456 2.51333 12.2553 2.12305C11.865 1.73277 11.3357 1.51351 10.7838 1.51351ZM3.21621 2.64865H4.16216V3.59459C4.16216 3.74512 4.22196 3.88949 4.3284 3.99593C4.43484 4.10237 4.5792 4.16216 4.72973 4.16216C4.88025 4.16216 5.02462 4.10237 5.13106 3.99593C5.2375 3.88949 5.29729 3.74512 5.29729 3.59459V2.64865H8.7027V3.59459C8.7027 3.74512 8.7625 3.88949 8.86894 3.99593C8.97538 4.10237 9.11974 4.16216 9.27027 4.16216C9.42079 4.16216 9.56516 4.10237 9.6716 3.99593C9.77804 3.88949 9.83783 3.74512 9.83783 3.59459V2.64865H10.7838C11.0347 2.64865 11.2753 2.74831 11.4527 2.92571C11.6301 3.10311 11.7297 3.34371 11.7297 3.59459V5.67568H2.27027V3.59459C2.27027 3.34371 2.36993 3.10311 2.54733 2.92571C2.72473 2.74831 2.96533 2.64865 3.21621 2.64865ZM10.7838 12.8649H3.21621C2.96533 12.8649 2.72473 12.7652 2.54733 12.5878C2.36993 12.4104 2.27027 12.1698 2.27027 11.9189V6.81081H11.7297V11.9189C11.7297 12.1698 11.6301 12.4104 11.4527 12.5878C11.2753 12.7652 11.0347 12.8649 10.7838 12.8649Z",
    fill: "currentColor"
  }, null, -1)])), 16);
}
Cl.render = pw;
var Sl = {
  name: "ChevronLeftIcon",
  extends: Ue
};
function mw(e) {
  return bw(e) || hw(e) || gw(e) || fw();
}
function fw() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function gw(e, t) {
  if (e) {
    if (typeof e == "string") return $r(e, t);
    var n = {}.toString.call(e).slice(8, -1);
    return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? $r(e, t) : void 0;
  }
}
function hw(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function bw(e) {
  if (Array.isArray(e)) return $r(e);
}
function $r(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, o = Array(t); n < t; n++) o[n] = e[n];
  return o;
}
function vw(e, t, n, o, i, r) {
  return m(), h("svg", x({
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.pti()), mw(t[0] || (t[0] = [g("path", {
    d: "M9.61296 13C9.50997 13.0005 9.40792 12.9804 9.3128 12.9409C9.21767 12.9014 9.13139 12.8433 9.05902 12.7701L3.83313 7.54416C3.68634 7.39718 3.60388 7.19795 3.60388 6.99022C3.60388 6.78249 3.68634 6.58325 3.83313 6.43628L9.05902 1.21039C9.20762 1.07192 9.40416 0.996539 9.60724 1.00012C9.81032 1.00371 10.0041 1.08597 10.1477 1.22959C10.2913 1.37322 10.3736 1.56698 10.3772 1.77005C10.3808 1.97313 10.3054 2.16968 10.1669 2.31827L5.49496 6.99022L10.1669 11.6622C10.3137 11.8091 10.3962 12.0084 10.3962 12.2161C10.3962 12.4238 10.3137 12.6231 10.1669 12.7701C10.0945 12.8433 10.0083 12.9014 9.91313 12.9409C9.81801 12.9804 9.71596 13.0005 9.61296 13Z",
    fill: "currentColor"
  }, null, -1)])), 16);
}
Sl.render = vw;
var $l = {
  name: "ChevronRightIcon",
  extends: Ue
};
function yw(e) {
  return Cw(e) || xw(e) || ww(e) || kw();
}
function kw() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function ww(e, t) {
  if (e) {
    if (typeof e == "string") return Br(e, t);
    var n = {}.toString.call(e).slice(8, -1);
    return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Br(e, t) : void 0;
  }
}
function xw(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function Cw(e) {
  if (Array.isArray(e)) return Br(e);
}
function Br(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, o = Array(t); n < t; n++) o[n] = e[n];
  return o;
}
function Sw(e, t, n, o, i, r) {
  return m(), h("svg", x({
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.pti()), yw(t[0] || (t[0] = [g("path", {
    d: "M4.38708 13C4.28408 13.0005 4.18203 12.9804 4.08691 12.9409C3.99178 12.9014 3.9055 12.8433 3.83313 12.7701C3.68634 12.6231 3.60388 12.4238 3.60388 12.2161C3.60388 12.0084 3.68634 11.8091 3.83313 11.6622L8.50507 6.99022L3.83313 2.31827C3.69467 2.16968 3.61928 1.97313 3.62287 1.77005C3.62645 1.56698 3.70872 1.37322 3.85234 1.22959C3.99596 1.08597 4.18972 1.00371 4.3928 1.00012C4.59588 0.996539 4.79242 1.07192 4.94102 1.21039L10.1669 6.43628C10.3137 6.58325 10.3962 6.78249 10.3962 6.99022C10.3962 7.19795 10.3137 7.39718 10.1669 7.54416L4.94102 12.7701C4.86865 12.8433 4.78237 12.9014 4.68724 12.9409C4.59212 12.9804 4.49007 13.0005 4.38708 13Z",
    fill: "currentColor"
  }, null, -1)])), 16);
}
$l.render = Sw;
var Bl = {
  name: "ChevronUpIcon",
  extends: Ue
};
function $w(e) {
  return Dw(e) || Iw(e) || Tw(e) || Bw();
}
function Bw() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Tw(e, t) {
  if (e) {
    if (typeof e == "string") return Tr(e, t);
    var n = {}.toString.call(e).slice(8, -1);
    return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Tr(e, t) : void 0;
  }
}
function Iw(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function Dw(e) {
  if (Array.isArray(e)) return Tr(e);
}
function Tr(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, o = Array(t); n < t; n++) o[n] = e[n];
  return o;
}
function Pw(e, t, n, o, i, r) {
  return m(), h("svg", x({
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.pti()), $w(t[0] || (t[0] = [g("path", {
    d: "M12.2097 10.4113C12.1057 10.4118 12.0027 10.3915 11.9067 10.3516C11.8107 10.3118 11.7237 10.2532 11.6506 10.1792L6.93602 5.46461L2.22139 10.1476C2.07272 10.244 1.89599 10.2877 1.71953 10.2717C1.54307 10.2556 1.3771 10.1808 1.24822 10.0593C1.11933 9.93766 1.035 9.77633 1.00874 9.6011C0.982477 9.42587 1.0158 9.2469 1.10338 9.09287L6.37701 3.81923C6.52533 3.6711 6.72639 3.58789 6.93602 3.58789C7.14565 3.58789 7.3467 3.6711 7.49502 3.81923L12.7687 9.09287C12.9168 9.24119 13 9.44225 13 9.65187C13 9.8615 12.9168 10.0626 12.7687 10.2109C12.616 10.3487 12.4151 10.4207 12.2097 10.4113Z",
    fill: "currentColor"
  }, null, -1)])), 16);
}
Bl.render = Pw;
var zw = `
    .p-datepicker {
        display: inline-flex;
        max-width: 100%;
    }

    .p-datepicker-input {
        flex: 1 1 auto;
        width: 1%;
    }

    .p-datepicker:has(.p-datepicker-dropdown) .p-datepicker-input {
        border-start-end-radius: 0;
        border-end-end-radius: 0;
    }

    .p-datepicker-dropdown {
        cursor: pointer;
        display: inline-flex;
        user-select: none;
        align-items: center;
        justify-content: center;
        overflow: hidden;
        position: relative;
        width: dt('datepicker.dropdown.width');
        border-start-end-radius: dt('datepicker.dropdown.border.radius');
        border-end-end-radius: dt('datepicker.dropdown.border.radius');
        background: dt('datepicker.dropdown.background');
        border: 1px solid dt('datepicker.dropdown.border.color');
        border-inline-start: 0 none;
        color: dt('datepicker.dropdown.color');
        transition:
            background dt('datepicker.transition.duration'),
            color dt('datepicker.transition.duration'),
            border-color dt('datepicker.transition.duration'),
            outline-color dt('datepicker.transition.duration');
        outline-color: transparent;
    }

    .p-datepicker-dropdown:not(:disabled):hover {
        background: dt('datepicker.dropdown.hover.background');
        border-color: dt('datepicker.dropdown.hover.border.color');
        color: dt('datepicker.dropdown.hover.color');
    }

    .p-datepicker-dropdown:not(:disabled):active {
        background: dt('datepicker.dropdown.active.background');
        border-color: dt('datepicker.dropdown.active.border.color');
        color: dt('datepicker.dropdown.active.color');
    }

    .p-datepicker-dropdown:focus-visible {
        box-shadow: dt('datepicker.dropdown.focus.ring.shadow');
        outline: dt('datepicker.dropdown.focus.ring.width') dt('datepicker.dropdown.focus.ring.style') dt('datepicker.dropdown.focus.ring.color');
        outline-offset: dt('datepicker.dropdown.focus.ring.offset');
    }

    .p-datepicker:has(.p-datepicker-input-icon-container) {
        position: relative;
    }

    .p-datepicker:has(.p-datepicker-input-icon-container) .p-datepicker-input {
        padding-inline-end: calc((dt('form.field.padding.x') * 2) + dt('icon.size'));
    }

    .p-datepicker-input-icon-container {
        cursor: pointer;
        position: absolute;
        top: 50%;
        inset-inline-end: dt('form.field.padding.x');
        margin-block-start: calc(-1 * (dt('icon.size') / 2));
        color: dt('datepicker.input.icon.color');
        line-height: 1;
    }

    .p-datepicker-fluid {
        display: flex;
    }

    .p-datepicker-fluid .p-datepicker-input {
        width: 1%;
    }

    .p-datepicker .p-datepicker-panel {
        min-width: 100%;
    }

    .p-datepicker-panel {
        width: auto;
        padding: dt('datepicker.panel.padding');
        background: dt('datepicker.panel.background');
        color: dt('datepicker.panel.color');
        border: 1px solid dt('datepicker.panel.border.color');
        border-radius: dt('datepicker.panel.border.radius');
        box-shadow: dt('datepicker.panel.shadow');
    }

    .p-datepicker-panel-inline {
        display: inline-block;
        overflow-x: auto;
        box-shadow: none;
    }

    .p-datepicker-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: dt('datepicker.header.padding');
        background: dt('datepicker.header.background');
        color: dt('datepicker.header.color');
        border-block-end: 1px solid dt('datepicker.header.border.color');
    }

    .p-datepicker-next-button:dir(rtl) {
        order: -1;
    }

    .p-datepicker-prev-button:dir(rtl) {
        order: 1;
    }

    .p-datepicker-title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: dt('datepicker.title.gap');
        font-weight: dt('datepicker.title.font.weight');
    }

    .p-datepicker-select-year,
    .p-datepicker-select-month {
        border: none;
        background: transparent;
        margin: 0;
        cursor: pointer;
        font-weight: inherit;
        transition:
            background dt('datepicker.transition.duration'),
            color dt('datepicker.transition.duration'),
            border-color dt('datepicker.transition.duration'),
            outline-color dt('datepicker.transition.duration'),
            box-shadow dt('datepicker.transition.duration');
    }

    .p-datepicker-select-month {
        padding: dt('datepicker.select.month.padding');
        color: dt('datepicker.select.month.color');
        border-radius: dt('datepicker.select.month.border.radius');
    }

    .p-datepicker-select-year {
        padding: dt('datepicker.select.year.padding');
        color: dt('datepicker.select.year.color');
        border-radius: dt('datepicker.select.year.border.radius');
    }

    .p-datepicker-select-month:enabled:hover {
        background: dt('datepicker.select.month.hover.background');
        color: dt('datepicker.select.month.hover.color');
    }

    .p-datepicker-select-year:enabled:hover {
        background: dt('datepicker.select.year.hover.background');
        color: dt('datepicker.select.year.hover.color');
    }

    .p-datepicker-select-month:focus-visible,
    .p-datepicker-select-year:focus-visible {
        box-shadow: dt('datepicker.date.focus.ring.shadow');
        outline: dt('datepicker.date.focus.ring.width') dt('datepicker.date.focus.ring.style') dt('datepicker.date.focus.ring.color');
        outline-offset: dt('datepicker.date.focus.ring.offset');
    }

    .p-datepicker-calendar-container {
        display: flex;
    }

    .p-datepicker-calendar-container .p-datepicker-calendar {
        flex: 1 1 auto;
        border-inline-start: 1px solid dt('datepicker.group.border.color');
        padding-inline-end: dt('datepicker.group.gap');
        padding-inline-start: dt('datepicker.group.gap');
    }

    .p-datepicker-calendar-container .p-datepicker-calendar:first-child {
        padding-inline-start: 0;
        border-inline-start: 0 none;
    }

    .p-datepicker-calendar-container .p-datepicker-calendar:last-child {
        padding-inline-end: 0;
    }

    .p-datepicker-day-view {
        width: 100%;
        border-collapse: collapse;
        font-size: 1rem;
        margin: dt('datepicker.day.view.margin');
    }

    .p-datepicker-weekday-cell {
        padding: dt('datepicker.week.day.padding');
    }

    .p-datepicker-weekday {
        font-weight: dt('datepicker.week.day.font.weight');
        color: dt('datepicker.week.day.color');
    }

    .p-datepicker-day-cell {
        padding: dt('datepicker.date.padding');
    }

    .p-datepicker-day {
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        margin: 0 auto;
        overflow: hidden;
        position: relative;
        width: dt('datepicker.date.width');
        height: dt('datepicker.date.height');
        border-radius: dt('datepicker.date.border.radius');
        transition:
            background dt('datepicker.transition.duration'),
            color dt('datepicker.transition.duration'),
            border-color dt('datepicker.transition.duration'),
            box-shadow dt('datepicker.transition.duration'),
            outline-color dt('datepicker.transition.duration');
        border: 1px solid transparent;
        outline-color: transparent;
        color: dt('datepicker.date.color');
    }

    .p-datepicker-day:not(.p-datepicker-day-selected):not(.p-disabled):hover {
        background: dt('datepicker.date.hover.background');
        color: dt('datepicker.date.hover.color');
    }

    .p-datepicker-day:focus-visible {
        box-shadow: dt('datepicker.date.focus.ring.shadow');
        outline: dt('datepicker.date.focus.ring.width') dt('datepicker.date.focus.ring.style') dt('datepicker.date.focus.ring.color');
        outline-offset: dt('datepicker.date.focus.ring.offset');
    }

    .p-datepicker-day-selected {
        background: dt('datepicker.date.selected.background');
        color: dt('datepicker.date.selected.color');
    }

    .p-datepicker-day-selected-range {
        background: dt('datepicker.date.range.selected.background');
        color: dt('datepicker.date.range.selected.color');
    }

    .p-datepicker-today > .p-datepicker-day {
        background: dt('datepicker.today.background');
        color: dt('datepicker.today.color');
    }

    .p-datepicker-today > .p-datepicker-day-selected {
        background: dt('datepicker.date.selected.background');
        color: dt('datepicker.date.selected.color');
    }

    .p-datepicker-today > .p-datepicker-day-selected-range {
        background: dt('datepicker.date.range.selected.background');
        color: dt('datepicker.date.range.selected.color');
    }

    .p-datepicker-weeknumber {
        text-align: center;
    }

    .p-datepicker-month-view {
        margin: dt('datepicker.month.view.margin');
    }

    .p-datepicker-month {
        width: 33.3%;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        overflow: hidden;
        position: relative;
        padding: dt('datepicker.month.padding');
        transition:
            background dt('datepicker.transition.duration'),
            color dt('datepicker.transition.duration'),
            border-color dt('datepicker.transition.duration'),
            box-shadow dt('datepicker.transition.duration'),
            outline-color dt('datepicker.transition.duration');
        border-radius: dt('datepicker.month.border.radius');
        outline-color: transparent;
        color: dt('datepicker.date.color');
    }

    .p-datepicker-month:not(.p-disabled):not(.p-datepicker-month-selected):hover {
        color: dt('datepicker.date.hover.color');
        background: dt('datepicker.date.hover.background');
    }

    .p-datepicker-month-selected {
        color: dt('datepicker.date.selected.color');
        background: dt('datepicker.date.selected.background');
    }

    .p-datepicker-month:not(.p-disabled):focus-visible {
        box-shadow: dt('datepicker.date.focus.ring.shadow');
        outline: dt('datepicker.date.focus.ring.width') dt('datepicker.date.focus.ring.style') dt('datepicker.date.focus.ring.color');
        outline-offset: dt('datepicker.date.focus.ring.offset');
    }

    .p-datepicker-year-view {
        margin: dt('datepicker.year.view.margin');
    }

    .p-datepicker-year {
        width: 50%;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        overflow: hidden;
        position: relative;
        padding: dt('datepicker.year.padding');
        transition:
            background dt('datepicker.transition.duration'),
            color dt('datepicker.transition.duration'),
            border-color dt('datepicker.transition.duration'),
            box-shadow dt('datepicker.transition.duration'),
            outline-color dt('datepicker.transition.duration');
        border-radius: dt('datepicker.year.border.radius');
        outline-color: transparent;
        color: dt('datepicker.date.color');
    }

    .p-datepicker-year:not(.p-disabled):not(.p-datepicker-year-selected):hover {
        color: dt('datepicker.date.hover.color');
        background: dt('datepicker.date.hover.background');
    }

    .p-datepicker-year-selected {
        color: dt('datepicker.date.selected.color');
        background: dt('datepicker.date.selected.background');
    }

    .p-datepicker-year:not(.p-disabled):focus-visible {
        box-shadow: dt('datepicker.date.focus.ring.shadow');
        outline: dt('datepicker.date.focus.ring.width') dt('datepicker.date.focus.ring.style') dt('datepicker.date.focus.ring.color');
        outline-offset: dt('datepicker.date.focus.ring.offset');
    }

    .p-datepicker-buttonbar {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: dt('datepicker.buttonbar.padding');
        border-block-start: 1px solid dt('datepicker.buttonbar.border.color');
    }

    .p-datepicker-buttonbar .p-button {
        width: auto;
    }

    .p-datepicker-time-picker {
        display: flex;
        justify-content: center;
        align-items: center;
        border-block-start: 1px solid dt('datepicker.time.picker.border.color');
        padding: 0;
        gap: dt('datepicker.time.picker.gap');
    }

    .p-datepicker-calendar-container + .p-datepicker-time-picker {
        padding: dt('datepicker.time.picker.padding');
    }

    .p-datepicker-time-picker > div {
        display: flex;
        align-items: center;
        flex-direction: column;
        gap: dt('datepicker.time.picker.button.gap');
    }

    .p-datepicker-time-picker span {
        font-size: 1rem;
    }

    .p-datepicker-timeonly .p-datepicker-time-picker {
        border-block-start: 0 none;
    }

    .p-datepicker-time-picker:dir(rtl) {
        flex-direction: row-reverse;
    }

    .p-datepicker:has(.p-inputtext-sm) .p-datepicker-dropdown {
        width: dt('datepicker.dropdown.sm.width');
    }

    .p-datepicker:has(.p-inputtext-sm) .p-datepicker-dropdown .p-icon,
    .p-datepicker:has(.p-inputtext-sm) .p-datepicker-input-icon {
        font-size: dt('form.field.sm.font.size');
        width: dt('form.field.sm.font.size');
        height: dt('form.field.sm.font.size');
    }

    .p-datepicker:has(.p-inputtext-lg) .p-datepicker-dropdown {
        width: dt('datepicker.dropdown.lg.width');
    }

    .p-datepicker:has(.p-inputtext-lg) .p-datepicker-dropdown .p-icon,
    .p-datepicker:has(.p-inputtext-lg) .p-datepicker-input-icon {
        font-size: dt('form.field.lg.font.size');
        width: dt('form.field.lg.font.size');
        height: dt('form.field.lg.font.size');
    }

    .p-datepicker:has(.p-datepicker-dropdown) .p-datepicker-clear-icon,
    .p-datepicker:has(.p-datepicker-input-icon-container) .p-datepicker-clear-icon {
        inset-inline-end: calc(dt('datepicker.dropdown.width') + dt('form.field.padding.x'));
    }

    .p-datepicker-clear-icon {
        position: absolute;
        top: 50%;
        margin-top: -0.5rem;
        cursor: pointer;
        color: dt('form.field.icon.color');
        inset-inline-end: dt('form.field.padding.x');
    }
`, Lw = {
  root: function(t) {
    var n = t.props;
    return {
      position: n.appendTo === "self" ? "relative" : void 0
    };
  }
}, Ow = {
  root: function(t) {
    var n = t.instance, o = t.state;
    return ["p-datepicker p-component p-inputwrapper", {
      "p-invalid": n.$invalid,
      "p-inputwrapper-filled": n.$filled,
      "p-inputwrapper-focus": o.focused || o.overlayVisible,
      "p-focus": o.focused || o.overlayVisible,
      "p-datepicker-fluid": n.$fluid
    }];
  },
  pcInputText: "p-datepicker-input",
  dropdown: "p-datepicker-dropdown",
  inputIconContainer: "p-datepicker-input-icon-container",
  inputIcon: "p-datepicker-input-icon",
  panel: function(t) {
    var n = t.props;
    return ["p-datepicker-panel p-component", {
      "p-datepicker-panel-inline": n.inline,
      "p-disabled": n.disabled,
      "p-datepicker-timeonly": n.timeOnly
    }];
  },
  calendarContainer: "p-datepicker-calendar-container",
  calendar: "p-datepicker-calendar",
  header: "p-datepicker-header",
  pcPrevButton: "p-datepicker-prev-button",
  title: "p-datepicker-title",
  selectMonth: "p-datepicker-select-month",
  selectYear: "p-datepicker-select-year",
  decade: "p-datepicker-decade",
  pcNextButton: "p-datepicker-next-button",
  dayView: "p-datepicker-day-view",
  weekHeader: "p-datepicker-weekheader p-disabled",
  weekNumber: "p-datepicker-weeknumber",
  weekLabelContainer: "p-datepicker-weeklabel-container p-disabled",
  weekDayCell: "p-datepicker-weekday-cell",
  weekDay: "p-datepicker-weekday",
  dayCell: function(t) {
    var n = t.date;
    return ["p-datepicker-day-cell", {
      "p-datepicker-other-month": n.otherMonth,
      "p-datepicker-today": n.today
    }];
  },
  day: function(t) {
    var n = t.instance, o = t.props, i = t.state, r = t.date, a = "";
    return n.isRangeSelection() && n.isSelected(r) && r.selectable && (a = n.isDateEquals(i.d_value[0], r) || n.isDateEquals(i.d_value[1], r) ? "p-datepicker-day-selected" : "p-datepicker-day-selected-range"), ["p-datepicker-day", {
      "p-datepicker-day-selected": !n.isRangeSelection() && n.isSelected(r) && r.selectable,
      "p-disabled": o.disabled || !r.selectable
    }, a];
  },
  monthView: "p-datepicker-month-view",
  month: function(t) {
    var n = t.instance, o = t.props, i = t.month, r = t.index;
    return ["p-datepicker-month", {
      "p-datepicker-month-selected": n.isMonthSelected(r),
      "p-disabled": o.disabled || !i.selectable
    }];
  },
  yearView: "p-datepicker-year-view",
  year: function(t) {
    var n = t.instance, o = t.props, i = t.year;
    return ["p-datepicker-year", {
      "p-datepicker-year-selected": n.isYearSelected(i.value),
      "p-disabled": o.disabled || !i.selectable
    }];
  },
  timePicker: "p-datepicker-time-picker",
  hourPicker: "p-datepicker-hour-picker",
  pcIncrementButton: "p-datepicker-increment-button",
  pcDecrementButton: "p-datepicker-decrement-button",
  separator: "p-datepicker-separator",
  minutePicker: "p-datepicker-minute-picker",
  secondPicker: "p-datepicker-second-picker",
  ampmPicker: "p-datepicker-ampm-picker",
  buttonbar: "p-datepicker-buttonbar",
  pcTodayButton: "p-datepicker-today-button",
  pcClearButton: "p-datepicker-clear-button"
}, Mw = oe.extend({
  name: "datepicker",
  style: zw,
  classes: Ow,
  inlineStyles: Lw
}), Aw = {
  name: "BaseDatePicker",
  extends: on,
  props: {
    selectionMode: {
      type: String,
      default: "single"
    },
    dateFormat: {
      type: String,
      default: null
    },
    inline: {
      type: Boolean,
      default: !1
    },
    showOtherMonths: {
      type: Boolean,
      default: !0
    },
    selectOtherMonths: {
      type: Boolean,
      default: !1
    },
    showIcon: {
      type: Boolean,
      default: !1
    },
    iconDisplay: {
      type: String,
      default: "button"
    },
    icon: {
      type: String,
      default: void 0
    },
    prevIcon: {
      type: String,
      default: void 0
    },
    nextIcon: {
      type: String,
      default: void 0
    },
    incrementIcon: {
      type: String,
      default: void 0
    },
    decrementIcon: {
      type: String,
      default: void 0
    },
    numberOfMonths: {
      type: Number,
      default: 1
    },
    responsiveOptions: Array,
    breakpoint: {
      type: String,
      default: "769px"
    },
    view: {
      type: String,
      default: "date"
    },
    minDate: {
      type: Date,
      value: null
    },
    maxDate: {
      type: Date,
      value: null
    },
    disabledDates: {
      type: Array,
      value: null
    },
    disabledDays: {
      type: Array,
      value: null
    },
    maxDateCount: {
      type: Number,
      value: null
    },
    showOnFocus: {
      type: Boolean,
      default: !0
    },
    autoZIndex: {
      type: Boolean,
      default: !0
    },
    baseZIndex: {
      type: Number,
      default: 0
    },
    showButtonBar: {
      type: Boolean,
      default: !1
    },
    shortYearCutoff: {
      type: String,
      default: "+10"
    },
    showTime: {
      type: Boolean,
      default: !1
    },
    timeOnly: {
      type: Boolean,
      default: !1
    },
    hourFormat: {
      type: String,
      default: "24"
    },
    stepHour: {
      type: Number,
      default: 1
    },
    stepMinute: {
      type: Number,
      default: 1
    },
    stepSecond: {
      type: Number,
      default: 1
    },
    showSeconds: {
      type: Boolean,
      default: !1
    },
    hideOnDateTimeSelect: {
      type: Boolean,
      default: !1
    },
    hideOnRangeSelection: {
      type: Boolean,
      default: !1
    },
    timeSeparator: {
      type: String,
      default: ":"
    },
    showWeek: {
      type: Boolean,
      default: !1
    },
    manualInput: {
      type: Boolean,
      default: !0
    },
    appendTo: {
      type: [String, Object],
      default: "body"
    },
    readonly: {
      type: Boolean,
      default: !1
    },
    placeholder: {
      type: String,
      default: null
    },
    required: {
      type: Boolean,
      default: null
    },
    inputId: {
      type: String,
      default: null
    },
    inputClass: {
      type: [String, Object],
      default: null
    },
    inputStyle: {
      type: Object,
      default: null
    },
    panelClass: {
      type: [String, Object],
      default: null
    },
    panelStyle: {
      type: Object,
      default: null
    },
    todayButtonProps: {
      type: Object,
      default: function() {
        return {
          severity: "secondary",
          text: !0,
          size: "small"
        };
      }
    },
    clearButtonProps: {
      type: Object,
      default: function() {
        return {
          severity: "secondary",
          text: !0,
          size: "small"
        };
      }
    },
    navigatorButtonProps: {
      type: Object,
      default: function() {
        return {
          severity: "secondary",
          text: !0,
          rounded: !0
        };
      }
    },
    timepickerButtonProps: {
      type: Object,
      default: function() {
        return {
          severity: "secondary",
          text: !0,
          rounded: !0
        };
      }
    },
    ariaLabelledby: {
      type: String,
      default: null
    },
    ariaLabel: {
      type: String,
      default: null
    }
  },
  style: Mw,
  provide: function() {
    return {
      $pcDatePicker: this,
      $parentInstance: this
    };
  }
};
function aa(e, t, n) {
  return (t = _w(t)) in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function _w(e) {
  var t = Fw(e, "string");
  return yn(t) == "symbol" ? t : t + "";
}
function Fw(e, t) {
  if (yn(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var o = n.call(e, t);
    if (yn(o) != "object") return o;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function yn(e) {
  "@babel/helpers - typeof";
  return yn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, yn(e);
}
function tr(e) {
  return Vw(e) || Rw(e) || Tl(e) || Ew();
}
function Ew() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Rw(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function Vw(e) {
  if (Array.isArray(e)) return Ir(e);
}
function nr(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (!n) {
    if (Array.isArray(e) || (n = Tl(e)) || t) {
      n && (e = n);
      var o = 0, i = function() {
      };
      return { s: i, n: function() {
        return o >= e.length ? { done: !0 } : { done: !1, value: e[o++] };
      }, e: function(u) {
        throw u;
      }, f: i };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var r, a = !0, d = !1;
  return { s: function() {
    n = n.call(e);
  }, n: function() {
    var u = n.next();
    return a = u.done, u;
  }, e: function(u) {
    d = !0, r = u;
  }, f: function() {
    try {
      a || n.return == null || n.return();
    } finally {
      if (d) throw r;
    }
  } };
}
function Tl(e, t) {
  if (e) {
    if (typeof e == "string") return Ir(e, t);
    var n = {}.toString.call(e).slice(8, -1);
    return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Ir(e, t) : void 0;
  }
}
function Ir(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, o = Array(t); n < t; n++) o[n] = e[n];
  return o;
}
var Jr = {
  name: "DatePicker",
  extends: Aw,
  inheritAttrs: !1,
  emits: ["show", "hide", "input", "month-change", "year-change", "date-select", "today-click", "clear-click", "focus", "blur", "keydown"],
  inject: {
    $pcFluid: {
      default: null
    }
  },
  navigationState: null,
  timePickerChange: !1,
  scrollHandler: null,
  outsideClickListener: null,
  resizeListener: null,
  matchMediaListener: null,
  matchMediaOrientationListener: null,
  overlay: null,
  input: null,
  previousButton: null,
  nextButton: null,
  timePickerTimer: null,
  preventFocus: !1,
  typeUpdate: !1,
  data: function() {
    return {
      currentMonth: null,
      currentYear: null,
      currentHour: null,
      currentMinute: null,
      currentSecond: null,
      pm: null,
      focused: !1,
      overlayVisible: !1,
      currentView: this.view,
      query: null,
      queryMatches: !1,
      queryOrientation: null,
      focusedDateIndex: 0
    };
  },
  watch: {
    modelValue: function(t) {
      this.updateCurrentMetaData(), !this.typeUpdate && !this.inline && this.input && (this.input.value = this.inputFieldValue), this.typeUpdate = !1;
    },
    showTime: function() {
      this.updateCurrentMetaData();
    },
    minDate: function() {
      this.updateCurrentMetaData();
    },
    maxDate: function() {
      this.updateCurrentMetaData();
    },
    months: function() {
      this.overlay && (this.focused || (this.inline && (this.preventFocus = !0), setTimeout(this.updateFocus, 0)));
    },
    numberOfMonths: function() {
      this.destroyResponsiveStyleElement(), this.createResponsiveStyle();
    },
    responsiveOptions: function() {
      this.destroyResponsiveStyleElement(), this.createResponsiveStyle();
    },
    currentView: function() {
      var t = this;
      Promise.resolve(null).then(function() {
        return t.alignOverlay();
      });
    },
    view: function(t) {
      this.currentView = t;
    }
  },
  created: function() {
    this.updateCurrentMetaData();
  },
  mounted: function() {
    this.createResponsiveStyle(), this.bindMatchMediaListener(), this.bindMatchMediaOrientationListener(), this.inline ? this.disabled || (this.preventFocus = !0, this.initFocusableCell()) : this.input.value = this.inputFieldValue;
  },
  updated: function() {
    this.overlay && (this.preventFocus = !0, setTimeout(this.updateFocus, 0)), this.input && this.selectionStart != null && this.selectionEnd != null && (this.input.selectionStart = this.selectionStart, this.input.selectionEnd = this.selectionEnd, this.selectionStart = null, this.selectionEnd = null);
  },
  beforeUnmount: function() {
    this.timePickerTimer && clearTimeout(this.timePickerTimer), this.destroyResponsiveStyleElement(), this.unbindOutsideClickListener(), this.unbindResizeListener(), this.unbindMatchMediaListener(), this.unbindMatchMediaOrientationListener(), this.scrollHandler && (this.scrollHandler.destroy(), this.scrollHandler = null), this.overlay && this.autoZIndex && wt.clear(this.overlay), this.overlay = null;
  },
  methods: {
    isComparable: function() {
      return this.d_value != null && typeof this.d_value != "string";
    },
    isSelected: function(t) {
      if (!this.isComparable())
        return !1;
      if (this.d_value) {
        if (this.isSingleSelection())
          return this.isDateEquals(this.d_value, t);
        if (this.isMultipleSelection()) {
          var n = !1, o = nr(this.d_value), i;
          try {
            for (o.s(); !(i = o.n()).done; ) {
              var r = i.value;
              if (n = this.isDateEquals(r, t), n)
                break;
            }
          } catch (a) {
            o.e(a);
          } finally {
            o.f();
          }
          return n;
        } else if (this.isRangeSelection())
          return this.d_value[1] ? this.isDateEquals(this.d_value[0], t) || this.isDateEquals(this.d_value[1], t) || this.isDateBetween(this.d_value[0], this.d_value[1], t) : this.isDateEquals(this.d_value[0], t);
      }
      return !1;
    },
    isMonthSelected: function(t) {
      var n = this;
      if (!this.isComparable()) return !1;
      if (this.isMultipleSelection())
        return this.d_value.some(function(l) {
          return l.getMonth() === t && l.getFullYear() === n.currentYear;
        });
      if (this.isRangeSelection())
        if (this.d_value[1]) {
          var r = new Date(this.currentYear, t, 1), a = new Date(this.d_value[0].getFullYear(), this.d_value[0].getMonth(), 1), d = new Date(this.d_value[1].getFullYear(), this.d_value[1].getMonth(), 1);
          return r >= a && r <= d;
        } else {
          var o, i;
          return ((o = this.d_value[0]) === null || o === void 0 ? void 0 : o.getFullYear()) === this.currentYear && ((i = this.d_value[0]) === null || i === void 0 ? void 0 : i.getMonth()) === t;
        }
      else
        return this.d_value.getMonth() === t && this.d_value.getFullYear() === this.currentYear;
    },
    isYearSelected: function(t) {
      if (!this.isComparable()) return !1;
      if (this.isMultipleSelection())
        return this.d_value.some(function(i) {
          return i.getFullYear() === t;
        });
      if (this.isRangeSelection()) {
        var n = this.d_value[0] ? this.d_value[0].getFullYear() : null, o = this.d_value[1] ? this.d_value[1].getFullYear() : null;
        return n === t || o === t || n < t && o > t;
      } else
        return this.d_value.getFullYear() === t;
    },
    isDateEquals: function(t, n) {
      return t ? t.getDate() === n.day && t.getMonth() === n.month && t.getFullYear() === n.year : !1;
    },
    isDateBetween: function(t, n, o) {
      var i = !1;
      if (t && n) {
        var r = new Date(o.year, o.month, o.day);
        return t.getTime() <= r.getTime() && n.getTime() >= r.getTime();
      }
      return i;
    },
    getFirstDayOfMonthIndex: function(t, n) {
      var o = /* @__PURE__ */ new Date();
      o.setDate(1), o.setMonth(t), o.setFullYear(n);
      var i = o.getDay() + this.sundayIndex;
      return i >= 7 ? i - 7 : i;
    },
    getDaysCountInMonth: function(t, n) {
      return 32 - this.daylightSavingAdjust(new Date(n, t, 32)).getDate();
    },
    getDaysCountInPrevMonth: function(t, n) {
      var o = this.getPreviousMonthAndYear(t, n);
      return this.getDaysCountInMonth(o.month, o.year);
    },
    getPreviousMonthAndYear: function(t, n) {
      var o, i;
      return t === 0 ? (o = 11, i = n - 1) : (o = t - 1, i = n), {
        month: o,
        year: i
      };
    },
    getNextMonthAndYear: function(t, n) {
      var o, i;
      return t === 11 ? (o = 0, i = n + 1) : (o = t + 1, i = n), {
        month: o,
        year: i
      };
    },
    daylightSavingAdjust: function(t) {
      return t ? (t.setHours(t.getHours() > 12 ? t.getHours() + 2 : 0), t) : null;
    },
    isToday: function(t, n, o, i) {
      return t.getDate() === n && t.getMonth() === o && t.getFullYear() === i;
    },
    isSelectable: function(t, n, o, i) {
      var r = !0, a = !0, d = !0, l = !0;
      return i && !this.selectOtherMonths ? !1 : (this.minDate && (this.minDate.getFullYear() > o || this.minDate.getFullYear() === o && (this.minDate.getMonth() > n || this.minDate.getMonth() === n && this.minDate.getDate() > t)) && (r = !1), this.maxDate && (this.maxDate.getFullYear() < o || this.maxDate.getFullYear() === o && (this.maxDate.getMonth() < n || this.maxDate.getMonth() === n && this.maxDate.getDate() < t)) && (a = !1), this.disabledDates && (d = !this.isDateDisabled(t, n, o)), this.disabledDays && (l = !this.isDayDisabled(t, n, o)), r && a && d && l);
    },
    onOverlayEnter: function(t) {
      var n = this.inline ? void 0 : {
        position: "absolute",
        top: "0"
      };
      Hr(t, n), this.autoZIndex && wt.set("overlay", t, this.baseZIndex || this.$primevue.config.zIndex.overlay), this.$attrSelector && t.setAttribute(this.$attrSelector, ""), this.alignOverlay(), this.$emit("show");
    },
    onOverlayEnterComplete: function() {
      this.bindOutsideClickListener(), this.bindScrollListener(), this.bindResizeListener();
    },
    onOverlayAfterLeave: function(t) {
      this.autoZIndex && wt.clear(t);
    },
    onOverlayLeave: function() {
      this.currentView = this.view, this.unbindOutsideClickListener(), this.unbindScrollListener(), this.unbindResizeListener(), this.$emit("hide"), this.overlay = null;
    },
    onPrevButtonClick: function(t) {
      this.navigationState = {
        backward: !0,
        button: !0
      }, this.navBackward(t);
    },
    onNextButtonClick: function(t) {
      this.navigationState = {
        backward: !1,
        button: !0
      }, this.navForward(t);
    },
    navBackward: function(t) {
      t.preventDefault(), this.isEnabled() && (this.currentView === "month" ? (this.decrementYear(), this.$emit("year-change", {
        month: this.currentMonth,
        year: this.currentYear
      })) : this.currentView === "year" ? this.decrementDecade() : t.shiftKey ? this.decrementYear() : (this.currentMonth === 0 ? (this.currentMonth = 11, this.decrementYear()) : this.currentMonth--, this.$emit("month-change", {
        month: this.currentMonth + 1,
        year: this.currentYear
      })));
    },
    navForward: function(t) {
      t.preventDefault(), this.isEnabled() && (this.currentView === "month" ? (this.incrementYear(), this.$emit("year-change", {
        month: this.currentMonth,
        year: this.currentYear
      })) : this.currentView === "year" ? this.incrementDecade() : t.shiftKey ? this.incrementYear() : (this.currentMonth === 11 ? (this.currentMonth = 0, this.incrementYear()) : this.currentMonth++, this.$emit("month-change", {
        month: this.currentMonth + 1,
        year: this.currentYear
      })));
    },
    decrementYear: function() {
      this.currentYear--;
    },
    decrementDecade: function() {
      this.currentYear = this.currentYear - 10;
    },
    incrementYear: function() {
      this.currentYear++;
    },
    incrementDecade: function() {
      this.currentYear = this.currentYear + 10;
    },
    switchToMonthView: function(t) {
      this.currentView = "month", setTimeout(this.updateFocus, 0), t.preventDefault();
    },
    switchToYearView: function(t) {
      this.currentView = "year", setTimeout(this.updateFocus, 0), t.preventDefault();
    },
    isEnabled: function() {
      return !this.disabled && !this.readonly;
    },
    updateCurrentTimeMeta: function(t) {
      var n = t.getHours();
      this.hourFormat === "12" && (this.pm = n > 11, n >= 12 && (n = n == 12 ? 12 : n - 12)), this.currentHour = Math.floor(n / this.stepHour) * this.stepHour, this.currentMinute = Math.floor(t.getMinutes() / this.stepMinute) * this.stepMinute, this.currentSecond = Math.floor(t.getSeconds() / this.stepSecond) * this.stepSecond;
    },
    bindOutsideClickListener: function() {
      var t = this;
      this.outsideClickListener || (this.outsideClickListener = function(n) {
        t.overlayVisible && t.isOutsideClicked(n) && (t.overlayVisible = !1);
      }, document.addEventListener("mousedown", this.outsideClickListener));
    },
    unbindOutsideClickListener: function() {
      this.outsideClickListener && (document.removeEventListener("mousedown", this.outsideClickListener), this.outsideClickListener = null);
    },
    bindScrollListener: function() {
      var t = this;
      this.scrollHandler || (this.scrollHandler = new ml(this.$refs.container, function() {
        t.overlayVisible && (t.overlayVisible = !1);
      })), this.scrollHandler.bindScrollListener();
    },
    unbindScrollListener: function() {
      this.scrollHandler && this.scrollHandler.unbindScrollListener();
    },
    bindResizeListener: function() {
      var t = this;
      this.resizeListener || (this.resizeListener = function() {
        t.overlayVisible && !Fa() && (t.overlayVisible = !1);
      }, window.addEventListener("resize", this.resizeListener));
    },
    unbindResizeListener: function() {
      this.resizeListener && (window.removeEventListener("resize", this.resizeListener), this.resizeListener = null);
    },
    bindMatchMediaListener: function() {
      var t = this;
      if (!this.matchMediaListener) {
        var n = matchMedia("(max-width: ".concat(this.breakpoint, ")"));
        this.query = n, this.queryMatches = n.matches, this.matchMediaListener = function() {
          t.queryMatches = n.matches, t.mobileActive = !1;
        }, this.query.addEventListener("change", this.matchMediaListener);
      }
    },
    unbindMatchMediaListener: function() {
      this.matchMediaListener && (this.query.removeEventListener("change", this.matchMediaListener), this.matchMediaListener = null);
    },
    bindMatchMediaOrientationListener: function() {
      var t = this;
      if (!this.matchMediaOrientationListener) {
        var n = matchMedia("(orientation: portrait)");
        this.queryOrientation = n, this.matchMediaOrientationListener = function() {
          t.alignOverlay();
        }, this.queryOrientation.addEventListener("change", this.matchMediaOrientationListener);
      }
    },
    unbindMatchMediaOrientationListener: function() {
      this.matchMediaOrientationListener && (this.queryOrientation.removeEventListener("change", this.matchMediaOrientationListener), this.queryOrientation = null, this.matchMediaOrientationListener = null);
    },
    isOutsideClicked: function(t) {
      var n = t.composedPath();
      return !(this.$el.isSameNode(t.target) || this.isNavIconClicked(t) || n.includes(this.$el) || n.includes(this.overlay));
    },
    isNavIconClicked: function(t) {
      return this.previousButton && (this.previousButton.isSameNode(t.target) || this.previousButton.contains(t.target)) || this.nextButton && (this.nextButton.isSameNode(t.target) || this.nextButton.contains(t.target));
    },
    alignOverlay: function() {
      this.overlay && (this.appendTo === "self" || this.inline ? za(this.overlay, this.$el) : (this.view === "date" ? (this.overlay.style.width = fn(this.overlay) + "px", this.overlay.style.minWidth = fn(this.$el) + "px") : this.overlay.style.width = fn(this.$el) + "px", Pa(this.overlay, this.$el)));
    },
    onButtonClick: function() {
      this.isEnabled() && (this.overlayVisible ? this.overlayVisible = !1 : (this.input.focus(), this.overlayVisible = !0));
    },
    isDateDisabled: function(t, n, o) {
      if (this.disabledDates) {
        var i = nr(this.disabledDates), r;
        try {
          for (i.s(); !(r = i.n()).done; ) {
            var a = r.value;
            if (a.getFullYear() === o && a.getMonth() === n && a.getDate() === t)
              return !0;
          }
        } catch (d) {
          i.e(d);
        } finally {
          i.f();
        }
      }
      return !1;
    },
    isDayDisabled: function(t, n, o) {
      if (this.disabledDays) {
        var i = new Date(o, n, t), r = i.getDay();
        return this.disabledDays.indexOf(r) !== -1;
      }
      return !1;
    },
    onMonthDropdownChange: function(t) {
      this.currentMonth = parseInt(t), this.$emit("month-change", {
        month: this.currentMonth + 1,
        year: this.currentYear
      });
    },
    onYearDropdownChange: function(t) {
      this.currentYear = parseInt(t), this.$emit("year-change", {
        month: this.currentMonth + 1,
        year: this.currentYear
      });
    },
    onDateSelect: function(t, n) {
      var o = this;
      if (!(this.disabled || !n.selectable)) {
        if (Dt(this.overlay, 'table td span:not([data-p-disabled="true"])').forEach(function(r) {
          return r.tabIndex = -1;
        }), t && t.currentTarget.focus(), this.isMultipleSelection() && this.isSelected(n)) {
          var i = this.d_value.filter(function(r) {
            return !o.isDateEquals(r, n);
          });
          this.updateModel(i);
        } else
          this.shouldSelectDate(n) && (n.otherMonth ? (this.currentMonth = n.month, this.currentYear = n.year, this.selectDate(n)) : this.selectDate(n));
        this.isSingleSelection() && (!this.showTime || this.hideOnDateTimeSelect) && (this.input && this.input.focus(), setTimeout(function() {
          o.overlayVisible = !1;
        }, 150));
      }
    },
    selectDate: function(t) {
      var n = this, o = new Date(t.year, t.month, t.day);
      this.showTime && (this.hourFormat === "12" && this.currentHour !== 12 && this.pm ? o.setHours(this.currentHour + 12) : o.setHours(this.currentHour), o.setMinutes(this.currentMinute), o.setSeconds(this.showSeconds ? this.currentSecond : 0)), this.minDate && this.minDate > o && (o = this.minDate, this.currentHour = o.getHours(), this.currentMinute = o.getMinutes(), this.currentSecond = o.getSeconds()), this.maxDate && this.maxDate < o && (o = this.maxDate, this.currentHour = o.getHours(), this.currentMinute = o.getMinutes(), this.currentSecond = o.getSeconds());
      var i = null;
      if (this.isSingleSelection())
        i = o;
      else if (this.isMultipleSelection())
        i = this.d_value ? [].concat(tr(this.d_value), [o]) : [o];
      else if (this.isRangeSelection())
        if (this.d_value && this.d_value.length) {
          var r = this.d_value[0], a = this.d_value[1];
          !a && o.getTime() >= r.getTime() ? (a = o, this.focusedDateIndex = 1) : (r = o, a = null, this.focusedDateIndex = 0), i = [r, a];
        } else
          i = [o, null], this.focusedDateIndex = 0;
      i !== null && this.updateModel(i), this.isRangeSelection() && this.hideOnRangeSelection && i[1] !== null && setTimeout(function() {
        n.overlayVisible = !1;
      }, 150), this.$emit("date-select", o);
    },
    updateModel: function(t) {
      this.writeValue(t);
    },
    shouldSelectDate: function() {
      return this.isMultipleSelection() && this.maxDateCount != null ? this.maxDateCount > (this.d_value ? this.d_value.length : 0) : !0;
    },
    isSingleSelection: function() {
      return this.selectionMode === "single";
    },
    isRangeSelection: function() {
      return this.selectionMode === "range";
    },
    isMultipleSelection: function() {
      return this.selectionMode === "multiple";
    },
    formatValue: function(t) {
      if (typeof t == "string")
        return this.dateFormat ? isNaN(new Date(t)) ? t : this.formatDate(new Date(t), this.dateFormat) : t;
      var n = "";
      if (t)
        try {
          if (this.isSingleSelection())
            n = this.formatDateTime(t);
          else if (this.isMultipleSelection())
            for (var o = 0; o < t.length; o++) {
              var i = this.formatDateTime(t[o]);
              n += i, o !== t.length - 1 && (n += ", ");
            }
          else if (this.isRangeSelection() && t && t.length) {
            var r = t[0], a = t[1];
            n = this.formatDateTime(r), a && (n += " - " + this.formatDateTime(a));
          }
        } catch {
          n = t;
        }
      return n;
    },
    formatDateTime: function(t) {
      var n = null;
      return t && (this.timeOnly ? n = this.formatTime(t) : (n = this.formatDate(t, this.datePattern), this.showTime && (n += " " + this.formatTime(t)))), n;
    },
    formatDate: function(t, n) {
      if (!t)
        return "";
      var o, i = function(s) {
        var c = o + 1 < n.length && n.charAt(o + 1) === s;
        return c && o++, c;
      }, r = function(s, c, p) {
        var f = "" + c;
        if (i(s))
          for (; f.length < p; )
            f = "0" + f;
        return f;
      }, a = function(s, c, p, f) {
        return i(s) ? f[c] : p[c];
      }, d = "", l = !1;
      if (t)
        for (o = 0; o < n.length; o++)
          if (l)
            n.charAt(o) === "'" && !i("'") ? l = !1 : d += n.charAt(o);
          else
            switch (n.charAt(o)) {
              case "d":
                d += r("d", t.getDate(), 2);
                break;
              case "D":
                d += a("D", t.getDay(), this.$primevue.config.locale.dayNamesShort, this.$primevue.config.locale.dayNames);
                break;
              case "o":
                d += r("o", Math.round((new Date(t.getFullYear(), t.getMonth(), t.getDate()).getTime() - new Date(t.getFullYear(), 0, 0).getTime()) / 864e5), 3);
                break;
              case "m":
                d += r("m", t.getMonth() + 1, 2);
                break;
              case "M":
                d += a("M", t.getMonth(), this.$primevue.config.locale.monthNamesShort, this.$primevue.config.locale.monthNames);
                break;
              case "y":
                d += i("y") ? t.getFullYear() : (t.getFullYear() % 100 < 10 ? "0" : "") + t.getFullYear() % 100;
                break;
              case "@":
                d += t.getTime();
                break;
              case "!":
                d += t.getTime() * 1e4 + this.ticksTo1970;
                break;
              case "'":
                i("'") ? d += "'" : l = !0;
                break;
              default:
                d += n.charAt(o);
            }
      return d;
    },
    formatTime: function(t) {
      if (!t)
        return "";
      var n = "", o = t.getHours(), i = t.getMinutes(), r = t.getSeconds();
      return this.hourFormat === "12" && o > 11 && o !== 12 && (o -= 12), this.hourFormat === "12" ? n += o === 0 ? 12 : o < 10 ? "0" + o : o : n += o < 10 ? "0" + o : o, n += ":", n += i < 10 ? "0" + i : i, this.showSeconds && (n += ":", n += r < 10 ? "0" + r : r), this.hourFormat === "12" && (n += t.getHours() > 11 ? " ".concat(this.$primevue.config.locale.pm) : " ".concat(this.$primevue.config.locale.am)), n;
    },
    onTodayButtonClick: function(t) {
      var n = /* @__PURE__ */ new Date(), o = {
        day: n.getDate(),
        month: n.getMonth(),
        year: n.getFullYear(),
        otherMonth: n.getMonth() !== this.currentMonth || n.getFullYear() !== this.currentYear,
        today: !0,
        selectable: !0
      };
      this.onDateSelect(null, o), this.$emit("today-click", n), t.preventDefault();
    },
    onClearButtonClick: function(t) {
      this.updateModel(this.$formDefaultValue || null), this.overlayVisible = !1, this.$emit("clear-click", t), t.preventDefault();
    },
    onTimePickerElementMouseDown: function(t, n, o) {
      this.isEnabled() && (this.repeat(t, null, n, o), t.preventDefault());
    },
    onTimePickerElementMouseUp: function(t) {
      this.isEnabled() && (this.clearTimePickerTimer(), this.updateModelTime(), t.preventDefault());
    },
    onTimePickerElementMouseLeave: function() {
      this.clearTimePickerTimer();
    },
    onTimePickerElementKeyDown: function(t, n, o) {
      switch (t.code) {
        case "Enter":
        case "NumpadEnter":
        case "Space":
          this.isEnabled() && (this.repeat(t, null, n, o), t.preventDefault());
          break;
      }
    },
    onTimePickerElementKeyUp: function(t) {
      switch (t.code) {
        case "Enter":
        case "NumpadEnter":
        case "Space":
          this.isEnabled() && (this.clearTimePickerTimer(), this.updateModelTime(), t.preventDefault());
          break;
      }
    },
    repeat: function(t, n, o, i) {
      var r = this, a = n || 500;
      switch (this.clearTimePickerTimer(), this.timePickerTimer = setTimeout(function() {
        r.repeat(t, 100, o, i);
      }, a), o) {
        case 0:
          i === 1 ? this.incrementHour(t) : this.decrementHour(t);
          break;
        case 1:
          i === 1 ? this.incrementMinute(t) : this.decrementMinute(t);
          break;
        case 2:
          i === 1 ? this.incrementSecond(t) : this.decrementSecond(t);
          break;
      }
    },
    convertTo24Hour: function(t, n) {
      return this.hourFormat == "12" ? t === 12 ? n ? 12 : 0 : n ? t + 12 : t : t;
    },
    validateTime: function(t, n, o, i) {
      var r = this.isComparable() ? this.d_value : this.viewDate, a = this.convertTo24Hour(t, i);
      this.isRangeSelection() && (r = this.d_value[1] || this.d_value[0]), this.isMultipleSelection() && (r = this.d_value[this.d_value.length - 1]);
      var d = r ? r.toDateString() : null;
      return !(this.minDate && d && this.minDate.toDateString() === d && (this.minDate.getHours() > a || this.minDate.getHours() === a && (this.minDate.getMinutes() > n || this.minDate.getMinutes() === n && this.minDate.getSeconds() > o)) || this.maxDate && d && this.maxDate.toDateString() === d && (this.maxDate.getHours() < a || this.maxDate.getHours() === a && (this.maxDate.getMinutes() < n || this.maxDate.getMinutes() === n && this.maxDate.getSeconds() < o)));
    },
    incrementHour: function(t) {
      var n = this.currentHour, o = this.currentHour + Number(this.stepHour), i = this.pm;
      this.hourFormat == "24" ? o = o >= 24 ? o - 24 : o : this.hourFormat == "12" && (n < 12 && o > 11 && (i = !this.pm), o = o >= 13 ? o - 12 : o), this.validateTime(o, this.currentMinute, this.currentSecond, i) && (this.currentHour = o, this.pm = i), t.preventDefault();
    },
    decrementHour: function(t) {
      var n = this.currentHour - this.stepHour, o = this.pm;
      this.hourFormat == "24" ? n = n < 0 ? 24 + n : n : this.hourFormat == "12" && (this.currentHour === 12 && (o = !this.pm), n = n <= 0 ? 12 + n : n), this.validateTime(n, this.currentMinute, this.currentSecond, o) && (this.currentHour = n, this.pm = o), t.preventDefault();
    },
    incrementMinute: function(t) {
      var n = this.currentMinute + Number(this.stepMinute);
      this.validateTime(this.currentHour, n, this.currentSecond, this.pm) && (this.currentMinute = n > 59 ? n - 60 : n), t.preventDefault();
    },
    decrementMinute: function(t) {
      var n = this.currentMinute - this.stepMinute;
      n = n < 0 ? 60 + n : n, this.validateTime(this.currentHour, n, this.currentSecond, this.pm) && (this.currentMinute = n), t.preventDefault();
    },
    incrementSecond: function(t) {
      var n = this.currentSecond + Number(this.stepSecond);
      this.validateTime(this.currentHour, this.currentMinute, n, this.pm) && (this.currentSecond = n > 59 ? n - 60 : n), t.preventDefault();
    },
    decrementSecond: function(t) {
      var n = this.currentSecond - this.stepSecond;
      n = n < 0 ? 60 + n : n, this.validateTime(this.currentHour, this.currentMinute, n, this.pm) && (this.currentSecond = n), t.preventDefault();
    },
    updateModelTime: function() {
      var t = this;
      this.timePickerChange = !0;
      var n = this.isComparable() ? this.d_value : this.viewDate;
      this.isRangeSelection() && (n = this.d_value[this.focusedDateIndex] || this.d_value[0]), this.isMultipleSelection() && (n = this.d_value[this.d_value.length - 1]), n = n ? new Date(n.getTime()) : /* @__PURE__ */ new Date(), this.hourFormat == "12" ? this.currentHour === 12 ? n.setHours(this.pm ? 12 : 0) : n.setHours(this.pm ? this.currentHour + 12 : this.currentHour) : n.setHours(this.currentHour), n.setMinutes(this.currentMinute), n.setSeconds(this.currentSecond), this.isRangeSelection() && (this.focusedDateIndex === 1 && this.d_value[1] ? n = [this.d_value[0], n] : this.focusedDateIndex === 0 ? n = [n, this.d_value[1]] : n = [n, null]), this.isMultipleSelection() && (n = [].concat(tr(this.d_value.slice(0, -1)), [n])), this.updateModel(n), this.$emit("date-select", n), setTimeout(function() {
        return t.timePickerChange = !1;
      }, 0);
    },
    toggleAMPM: function(t) {
      var n = this.validateTime(this.currentHour, this.currentMinute, this.currentSecond, !this.pm);
      !n && (this.maxDate || this.minDate) || (this.pm = !this.pm, this.updateModelTime(), t.preventDefault());
    },
    clearTimePickerTimer: function() {
      this.timePickerTimer && clearInterval(this.timePickerTimer);
    },
    onMonthSelect: function(t, n) {
      n.month;
      var o = n.index;
      this.view === "month" ? this.onDateSelect(t, {
        year: this.currentYear,
        month: o,
        day: 1,
        selectable: !0
      }) : (this.currentMonth = o, this.currentView = "date", this.$emit("month-change", {
        month: this.currentMonth + 1,
        year: this.currentYear
      })), setTimeout(this.updateFocus, 0);
    },
    onYearSelect: function(t, n) {
      this.view === "year" ? this.onDateSelect(t, {
        year: n.value,
        month: 0,
        day: 1,
        selectable: !0
      }) : (this.currentYear = n.value, this.currentView = "month", this.$emit("year-change", {
        month: this.currentMonth + 1,
        year: this.currentYear
      })), setTimeout(this.updateFocus, 0);
    },
    updateCurrentMetaData: function() {
      var t = this.viewDate;
      if (this.currentMonth = t.getMonth(), this.currentYear = t.getFullYear(), this.showTime || this.timeOnly) {
        var n = t;
        this.isRangeSelection() && this.d_value && this.d_value[this.focusedDateIndex] && (n = this.d_value[this.focusedDateIndex]), this.updateCurrentTimeMeta(n);
      }
    },
    isValidSelection: function(t) {
      var n = this;
      if (t == null)
        return !0;
      var o = !0;
      return this.isSingleSelection() ? this.isSelectable(t.getDate(), t.getMonth(), t.getFullYear(), !1) || (o = !1) : t.every(function(i) {
        return n.isSelectable(i.getDate(), i.getMonth(), i.getFullYear(), !1);
      }) && this.isRangeSelection() && (o = t.length > 1 && t[1] >= t[0]), o;
    },
    parseValue: function(t) {
      if (!t || t.trim().length === 0)
        return null;
      var n;
      if (this.isSingleSelection())
        n = this.parseDateTime(t);
      else if (this.isMultipleSelection()) {
        var o = t.split(",");
        n = [];
        var i = nr(o), r;
        try {
          for (i.s(); !(r = i.n()).done; ) {
            var a = r.value;
            n.push(this.parseDateTime(a.trim()));
          }
        } catch (u) {
          i.e(u);
        } finally {
          i.f();
        }
      } else if (this.isRangeSelection()) {
        var d = t.split(" - ");
        n = [];
        for (var l = 0; l < d.length; l++)
          n[l] = this.parseDateTime(d[l].trim());
      }
      return n;
    },
    parseDateTime: function(t) {
      var n, o = t.split(" ");
      if (this.timeOnly)
        n = /* @__PURE__ */ new Date(), this.populateTime(n, o[0], o[1]);
      else {
        var i = this.datePattern;
        this.showTime ? (n = this.parseDate(o[0], i), this.populateTime(n, o[1], o[2])) : n = this.parseDate(t, i);
      }
      return n;
    },
    populateTime: function(t, n, o) {
      if (this.hourFormat == "12" && !o)
        throw "Invalid Time";
      this.pm = o === this.$primevue.config.locale.pm || o === this.$primevue.config.locale.pm.toLowerCase();
      var i = this.parseTime(n);
      t.setHours(i.hour), t.setMinutes(i.minute), t.setSeconds(i.second);
    },
    parseTime: function(t) {
      var n = t.split(":"), o = this.showSeconds ? 3 : 2, i = /^[0-9][0-9]$/;
      if (n.length !== o || !n[0].match(i) || !n[1].match(i) || this.showSeconds && !n[2].match(i))
        throw "Invalid time";
      var r = parseInt(n[0]), a = parseInt(n[1]), d = this.showSeconds ? parseInt(n[2]) : null;
      if (isNaN(r) || isNaN(a) || r > 23 || a > 59 || this.hourFormat == "12" && r > 12 || this.showSeconds && (isNaN(d) || d > 59))
        throw "Invalid time";
      return this.hourFormat == "12" && r !== 12 && this.pm ? r += 12 : this.hourFormat == "12" && r == 12 && !this.pm && (r = 0), {
        hour: r,
        minute: a,
        second: d
      };
    },
    parseDate: function(t, n) {
      if (n == null || t == null)
        throw "Invalid arguments";
      if (t = yn(t) === "object" ? t.toString() : t + "", t === "")
        return null;
      var o, i, r, a = 0, d = typeof this.shortYearCutoff != "string" ? this.shortYearCutoff : (/* @__PURE__ */ new Date()).getFullYear() % 100 + parseInt(this.shortYearCutoff, 10), l = -1, u = -1, s = -1, c = -1, p = !1, f, b = function(O) {
        var w = o + 1 < n.length && n.charAt(o + 1) === O;
        return w && o++, w;
      }, k = function(O) {
        var w = b(O), F = O === "@" ? 14 : O === "!" ? 20 : O === "y" && w ? 4 : O === "o" ? 3 : 2, D = O === "y" ? F : 1, C = new RegExp("^\\d{" + D + "," + F + "}"), I = t.substring(a).match(C);
        if (!I)
          throw "Missing number at position " + a;
        return a += I[0].length, parseInt(I[0], 10);
      }, T = function(O, w, F) {
        for (var D = -1, C = b(O) ? F : w, I = [], N = 0; N < C.length; N++)
          I.push([N, C[N]]);
        I.sort(function(M, P) {
          return -(M[1].length - P[1].length);
        });
        for (var K = 0; K < I.length; K++) {
          var V = I[K][1];
          if (t.substr(a, V.length).toLowerCase() === V.toLowerCase()) {
            D = I[K][0], a += V.length;
            break;
          }
        }
        if (D !== -1)
          return D + 1;
        throw "Unknown name at position " + a;
      }, $ = function() {
        if (t.charAt(a) !== n.charAt(o))
          throw "Unexpected literal at position " + a;
        a++;
      };
      for (this.currentView === "month" && (s = 1), this.currentView === "year" && (s = 1, u = 1), o = 0; o < n.length; o++)
        if (p)
          n.charAt(o) === "'" && !b("'") ? p = !1 : $();
        else
          switch (n.charAt(o)) {
            case "d":
              s = k("d");
              break;
            case "D":
              T("D", this.$primevue.config.locale.dayNamesShort, this.$primevue.config.locale.dayNames);
              break;
            case "o":
              c = k("o");
              break;
            case "m":
              u = k("m");
              break;
            case "M":
              u = T("M", this.$primevue.config.locale.monthNamesShort, this.$primevue.config.locale.monthNames);
              break;
            case "y":
              l = k("y");
              break;
            case "@":
              f = new Date(k("@")), l = f.getFullYear(), u = f.getMonth() + 1, s = f.getDate();
              break;
            case "!":
              f = new Date((k("!") - this.ticksTo1970) / 1e4), l = f.getFullYear(), u = f.getMonth() + 1, s = f.getDate();
              break;
            case "'":
              b("'") ? $() : p = !0;
              break;
            default:
              $();
          }
      if (a < t.length && (r = t.substr(a), !/^\s+/.test(r)))
        throw "Extra/unparsed characters found in date: " + r;
      if (l === -1 ? l = (/* @__PURE__ */ new Date()).getFullYear() : l < 100 && (l += (/* @__PURE__ */ new Date()).getFullYear() - (/* @__PURE__ */ new Date()).getFullYear() % 100 + (l <= d ? 0 : -100)), c > -1) {
        u = 1, s = c;
        do {
          if (i = this.getDaysCountInMonth(l, u - 1), s <= i)
            break;
          u++, s -= i;
        } while (!0);
      }
      if (f = this.daylightSavingAdjust(new Date(l, u - 1, s)), f.getFullYear() !== l || f.getMonth() + 1 !== u || f.getDate() !== s)
        throw "Invalid date";
      return f;
    },
    getWeekNumber: function(t) {
      var n = new Date(t.getTime());
      n.setDate(n.getDate() + 4 - (n.getDay() || 7));
      var o = n.getTime();
      return n.setMonth(0), n.setDate(1), Math.floor(Math.round((o - n.getTime()) / 864e5) / 7) + 1;
    },
    onDateCellKeydown: function(t, n, o) {
      t.preventDefault();
      var i = t.currentTarget, r = i.parentElement, a = Dn(r);
      switch (t.code) {
        case "ArrowDown": {
          i.tabIndex = "-1";
          var d = r.parentElement.nextElementSibling;
          if (d) {
            var l = Dn(r.parentElement), u = Array.from(r.parentElement.parentElement.children), s = u.slice(l + 1), c = s.find(function(fe) {
              var Be = fe.children[a].children[0];
              return !Ut(Be, "data-p-disabled");
            });
            if (c) {
              var p = c.children[a].children[0];
              p.tabIndex = "0", p.focus();
            } else
              this.navigationState = {
                backward: !1
              }, this.navForward(t);
          } else
            this.navigationState = {
              backward: !1
            }, this.navForward(t);
          t.preventDefault();
          break;
        }
        case "ArrowUp": {
          if (i.tabIndex = "-1", t.altKey)
            this.overlayVisible = !1, this.focused = !0;
          else {
            var f = r.parentElement.previousElementSibling;
            if (f) {
              var b = Dn(r.parentElement), k = Array.from(r.parentElement.parentElement.children), T = k.slice(0, b).reverse(), $ = T.find(function(fe) {
                var Be = fe.children[a].children[0];
                return !Ut(Be, "data-p-disabled");
              });
              if ($) {
                var S = $.children[a].children[0];
                S.tabIndex = "0", S.focus();
              } else
                this.navigationState = {
                  backward: !0
                }, this.navBackward(t);
            } else
              this.navigationState = {
                backward: !0
              }, this.navBackward(t);
          }
          t.preventDefault();
          break;
        }
        case "ArrowLeft": {
          i.tabIndex = "-1";
          var O = r.previousElementSibling;
          if (O) {
            var w = Array.from(r.parentElement.children), F = w.slice(0, a).reverse(), D = F.find(function(fe) {
              var Be = fe.children[0];
              return !Ut(Be, "data-p-disabled");
            });
            if (D) {
              var C = D.children[0];
              C.tabIndex = "0", C.focus();
            } else
              this.navigateToMonth(t, !0, o);
          } else
            this.navigateToMonth(t, !0, o);
          t.preventDefault();
          break;
        }
        case "ArrowRight": {
          i.tabIndex = "-1";
          var I = r.nextElementSibling;
          if (I) {
            var N = Array.from(r.parentElement.children), K = N.slice(a + 1), V = K.find(function(fe) {
              var Be = fe.children[0];
              return !Ut(Be, "data-p-disabled");
            });
            if (V) {
              var M = V.children[0];
              M.tabIndex = "0", M.focus();
            } else
              this.navigateToMonth(t, !1, o);
          } else
            this.navigateToMonth(t, !1, o);
          t.preventDefault();
          break;
        }
        case "Enter":
        case "NumpadEnter":
        case "Space": {
          this.onDateSelect(t, n), t.preventDefault();
          break;
        }
        case "Escape": {
          this.overlayVisible = !1, t.preventDefault();
          break;
        }
        case "Tab": {
          this.inline || this.trapFocus(t);
          break;
        }
        case "Home": {
          i.tabIndex = "-1";
          var P = r.parentElement, E = P.children[0].children[0];
          Ut(E, "data-p-disabled") ? this.navigateToMonth(t, !0, o) : (E.tabIndex = "0", E.focus()), t.preventDefault();
          break;
        }
        case "End": {
          i.tabIndex = "-1";
          var H = r.parentElement, ae = H.children[H.children.length - 1].children[0];
          Ut(ae, "data-p-disabled") ? this.navigateToMonth(t, !1, o) : (ae.tabIndex = "0", ae.focus()), t.preventDefault();
          break;
        }
        case "PageUp": {
          i.tabIndex = "-1", t.shiftKey ? (this.navigationState = {
            backward: !0
          }, this.navBackward(t)) : this.navigateToMonth(t, !0, o), t.preventDefault();
          break;
        }
        case "PageDown": {
          i.tabIndex = "-1", t.shiftKey ? (this.navigationState = {
            backward: !1
          }, this.navForward(t)) : this.navigateToMonth(t, !1, o), t.preventDefault();
          break;
        }
      }
    },
    navigateToMonth: function(t, n, o) {
      if (n)
        if (this.numberOfMonths === 1 || o === 0)
          this.navigationState = {
            backward: !0
          }, this.navBackward(t);
        else {
          var i = this.overlay.children[o - 1], r = Dt(i, 'table td span:not([data-p-disabled="true"]):not([data-p-ink="true"])'), a = r[r.length - 1];
          a.tabIndex = "0", a.focus();
        }
      else if (this.numberOfMonths === 1 || o === this.numberOfMonths - 1)
        this.navigationState = {
          backward: !1
        }, this.navForward(t);
      else {
        var d = this.overlay.children[o + 1], l = qe(d, 'table td span:not([data-p-disabled="true"]):not([data-p-ink="true"])');
        l.tabIndex = "0", l.focus();
      }
    },
    onMonthCellKeydown: function(t, n) {
      var o = t.currentTarget;
      switch (t.code) {
        case "ArrowUp":
        case "ArrowDown": {
          o.tabIndex = "-1";
          var i = o.parentElement.children, r = Dn(o), a = i[t.code === "ArrowDown" ? r + 3 : r - 3];
          a && (a.tabIndex = "0", a.focus()), t.preventDefault();
          break;
        }
        case "ArrowLeft": {
          o.tabIndex = "-1";
          var d = o.previousElementSibling;
          d ? (d.tabIndex = "0", d.focus()) : (this.navigationState = {
            backward: !0
          }, this.navBackward(t)), t.preventDefault();
          break;
        }
        case "ArrowRight": {
          o.tabIndex = "-1";
          var l = o.nextElementSibling;
          l ? (l.tabIndex = "0", l.focus()) : (this.navigationState = {
            backward: !1
          }, this.navForward(t)), t.preventDefault();
          break;
        }
        case "PageUp": {
          if (t.shiftKey) return;
          this.navigationState = {
            backward: !0
          }, this.navBackward(t);
          break;
        }
        case "PageDown": {
          if (t.shiftKey) return;
          this.navigationState = {
            backward: !1
          }, this.navForward(t);
          break;
        }
        case "Enter":
        case "NumpadEnter":
        case "Space": {
          this.onMonthSelect(t, n), t.preventDefault();
          break;
        }
        case "Escape": {
          this.overlayVisible = !1, t.preventDefault();
          break;
        }
        case "Tab": {
          this.trapFocus(t);
          break;
        }
      }
    },
    onYearCellKeydown: function(t, n) {
      var o = t.currentTarget;
      switch (t.code) {
        case "ArrowUp":
        case "ArrowDown": {
          o.tabIndex = "-1";
          var i = o.parentElement.children, r = Dn(o), a = i[t.code === "ArrowDown" ? r + 2 : r - 2];
          a && (a.tabIndex = "0", a.focus()), t.preventDefault();
          break;
        }
        case "ArrowLeft": {
          o.tabIndex = "-1";
          var d = o.previousElementSibling;
          d ? (d.tabIndex = "0", d.focus()) : (this.navigationState = {
            backward: !0
          }, this.navBackward(t)), t.preventDefault();
          break;
        }
        case "ArrowRight": {
          o.tabIndex = "-1";
          var l = o.nextElementSibling;
          l ? (l.tabIndex = "0", l.focus()) : (this.navigationState = {
            backward: !1
          }, this.navForward(t)), t.preventDefault();
          break;
        }
        case "PageUp": {
          if (t.shiftKey) return;
          this.navigationState = {
            backward: !0
          }, this.navBackward(t);
          break;
        }
        case "PageDown": {
          if (t.shiftKey) return;
          this.navigationState = {
            backward: !1
          }, this.navForward(t);
          break;
        }
        case "Enter":
        case "NumpadEnter":
        case "Space": {
          this.onYearSelect(t, n), t.preventDefault();
          break;
        }
        case "Escape": {
          this.overlayVisible = !1, t.preventDefault();
          break;
        }
        case "Tab": {
          this.trapFocus(t);
          break;
        }
      }
    },
    updateFocus: function() {
      var t;
      if (this.navigationState) {
        if (this.navigationState.button)
          this.initFocusableCell(), this.navigationState.backward ? this.previousButton && this.previousButton.focus() : this.nextButton && this.nextButton.focus();
        else {
          if (this.navigationState.backward) {
            var n;
            this.currentView === "month" ? n = Dt(this.overlay, '[data-pc-section="monthview"] [data-pc-section="month"]:not([data-p-disabled="true"])') : this.currentView === "year" ? n = Dt(this.overlay, '[data-pc-section="yearview"] [data-pc-section="year"]:not([data-p-disabled="true"])') : n = Dt(this.overlay, 'table td span:not([data-p-disabled="true"]):not([data-p-ink="true"])'), n && n.length > 0 && (t = n[n.length - 1]);
          } else
            this.currentView === "month" ? t = qe(this.overlay, '[data-pc-section="monthview"] [data-pc-section="month"]:not([data-p-disabled="true"])') : this.currentView === "year" ? t = qe(this.overlay, '[data-pc-section="yearview"] [data-pc-section="year"]:not([data-p-disabled="true"])') : t = qe(this.overlay, 'table td span:not([data-p-disabled="true"]):not([data-p-ink="true"])');
          t && (t.tabIndex = "0", t.focus());
        }
        this.navigationState = null;
      } else
        this.initFocusableCell();
    },
    initFocusableCell: function() {
      var t;
      if (this.currentView === "month") {
        var n = Dt(this.overlay, '[data-pc-section="monthview"] [data-pc-section="month"]'), o = qe(this.overlay, '[data-pc-section="monthview"] [data-pc-section="month"][data-p-selected="true"]');
        n.forEach(function(d) {
          return d.tabIndex = -1;
        }), t = o || n[0];
      } else if (this.currentView === "year") {
        var i = Dt(this.overlay, '[data-pc-section="yearview"] [data-pc-section="year"]'), r = qe(this.overlay, '[data-pc-section="yearview"] [data-pc-section="year"][data-p-selected="true"]');
        i.forEach(function(d) {
          return d.tabIndex = -1;
        }), t = r || i[0];
      } else if (t = qe(this.overlay, 'span[data-p-selected="true"]'), !t) {
        var a = qe(this.overlay, 'td[data-p-today="true"] span:not([data-p-disabled="true"]):not([data-p-ink="true"])');
        a ? t = a : t = qe(this.overlay, '.p-datepicker-calendar td span:not([data-p-disabled="true"]):not([data-p-ink="true"])');
      }
      t && (t.tabIndex = "0", this.preventFocus = !1);
    },
    trapFocus: function(t) {
      t.preventDefault();
      var n = En(this.overlay);
      if (n && n.length > 0)
        if (!document.activeElement)
          n[0].focus();
        else {
          var o = n.indexOf(document.activeElement);
          if (t.shiftKey)
            o === -1 || o === 0 ? n[n.length - 1].focus() : n[o - 1].focus();
          else if (o === -1)
            if (this.timeOnly)
              n[0].focus();
            else {
              var i = n.findIndex(function(r) {
                return r.tagName === "SPAN";
              });
              i === -1 && (i = n.findIndex(function(r) {
                return r.tagName === "BUTTON";
              })), i !== -1 ? n[i].focus() : n[0].focus();
            }
          else o === n.length - 1 ? n[0].focus() : n[o + 1].focus();
        }
    },
    onContainerButtonKeydown: function(t) {
      switch (t.code) {
        case "Tab":
          this.trapFocus(t);
          break;
        case "Escape":
          this.overlayVisible = !1, t.preventDefault();
          break;
      }
      this.$emit("keydown", t);
    },
    onInput: function(t) {
      try {
        this.selectionStart = this.input.selectionStart, this.selectionEnd = this.input.selectionEnd;
        var n = this.parseValue(t.target.value);
        this.isValidSelection(n) && (this.typeUpdate = !0, this.updateModel(n), this.updateCurrentMetaData());
      } catch {
      }
      this.$emit("input", t);
    },
    onInputClick: function() {
      this.showOnFocus && this.isEnabled() && !this.overlayVisible && (this.overlayVisible = !0);
    },
    onFocus: function(t) {
      this.showOnFocus && this.isEnabled() && (this.overlayVisible = !0), this.focused = !0, this.$emit("focus", t);
    },
    onBlur: function(t) {
      var n, o;
      this.$emit("blur", {
        originalEvent: t,
        value: t.target.value
      }), (n = (o = this.formField).onBlur) === null || n === void 0 || n.call(o), this.focused = !1, t.target.value = this.formatValue(this.d_value);
    },
    onKeyDown: function(t) {
      if (t.code === "ArrowDown" && this.overlay)
        this.trapFocus(t);
      else if (t.code === "ArrowDown" && !this.overlay)
        this.overlayVisible = !0;
      else if (t.code === "Escape")
        this.overlayVisible && (this.overlayVisible = !1, t.preventDefault(), t.stopPropagation());
      else if (t.code === "Tab")
        this.overlay && En(this.overlay).forEach(function(i) {
          return i.tabIndex = "-1";
        }), this.overlayVisible && (this.overlayVisible = !1);
      else if (t.code === "Enter") {
        var n;
        if (this.manualInput && t.target.value !== null && ((n = t.target.value) === null || n === void 0 ? void 0 : n.trim()) !== "")
          try {
            var o = this.parseValue(t.target.value);
            this.isValidSelection(o) && (this.overlayVisible = !1);
          } catch {
          }
        this.$emit("keydown", t);
      }
    },
    overlayRef: function(t) {
      this.overlay = t;
    },
    inputRef: function(t) {
      this.input = t ? t.$el : void 0;
    },
    previousButtonRef: function(t) {
      this.previousButton = t ? t.$el : void 0;
    },
    nextButtonRef: function(t) {
      this.nextButton = t ? t.$el : void 0;
    },
    getMonthName: function(t) {
      return this.$primevue.config.locale.monthNames[t];
    },
    getYear: function(t) {
      return this.currentView === "month" ? this.currentYear : t.year;
    },
    onOverlayClick: function(t) {
      t.stopPropagation(), this.inline || yl.emit("overlay-click", {
        originalEvent: t,
        target: this.$el
      });
    },
    onOverlayKeyDown: function(t) {
      switch (t.code) {
        case "Escape":
          this.inline || (this.input.focus(), this.overlayVisible = !1, t.stopPropagation());
          break;
      }
    },
    onOverlayMouseUp: function(t) {
      this.onOverlayClick(t);
    },
    createResponsiveStyle: function() {
      if (this.numberOfMonths > 1 && this.responsiveOptions && !this.isUnstyled) {
        if (!this.responsiveStyleElement) {
          var t;
          this.responsiveStyleElement = document.createElement("style"), this.responsiveStyleElement.type = "text/css", Wr(this.responsiveStyleElement, "nonce", (t = this.$primevue) === null || t === void 0 || (t = t.config) === null || t === void 0 || (t = t.csp) === null || t === void 0 ? void 0 : t.nonce), document.body.appendChild(this.responsiveStyleElement);
        }
        var n = "";
        if (this.responsiveOptions)
          for (var o = Is(), i = tr(this.responsiveOptions).filter(function(c) {
            return !!(c.breakpoint && c.numMonths);
          }).sort(function(c, p) {
            return -1 * o(c.breakpoint, p.breakpoint);
          }), r = 0; r < i.length; r++) {
            for (var a = i[r], d = a.breakpoint, l = a.numMonths, u = `
                            .p-datepicker-panel[`.concat(this.$attrSelector, "] .p-datepicker-calendar:nth-child(").concat(l, `) .p-datepicker-next-button {
                                display: inline-flex;
                            }
                        `), s = l; s < this.numberOfMonths; s++)
              u += `
                                .p-datepicker-panel[`.concat(this.$attrSelector, "] .p-datepicker-calendar:nth-child(").concat(s + 1, `) {
                                    display: none;
                                }
                            `);
            n += `
                            @media screen and (max-width: `.concat(d, `) {
                                `).concat(u, `
                            }
                        `);
          }
        this.responsiveStyleElement.innerHTML = n;
      }
    },
    destroyResponsiveStyleElement: function() {
      this.responsiveStyleElement && (this.responsiveStyleElement.remove(), this.responsiveStyleElement = null);
    },
    dayDataP: function(t) {
      return Pe({
        today: t.today,
        "other-month": t.otherMonth,
        selected: this.isSelected(t),
        disabled: !t.selectable
      });
    }
  },
  computed: {
    viewDate: function() {
      var t = this.d_value;
      if (t && Array.isArray(t))
        if (this.isRangeSelection())
          if (t.length === 1)
            t = t[0];
          else {
            var n = new Date(t[0].getFullYear(), t[0].getMonth() + this.numberOfMonths, 1);
            t[1] < n ? t = t[0] : t = new Date(t[1].getFullYear(), t[1].getMonth() - this.numberOfMonths + 1, 1);
          }
        else this.isMultipleSelection() && (t = t[t.length - 1]);
      if (t && typeof t != "string")
        return t;
      var o = /* @__PURE__ */ new Date();
      return this.maxDate && this.maxDate < o ? this.maxDate : this.minDate && this.minDate > o ? this.minDate : o;
    },
    inputFieldValue: function() {
      return this.formatValue(this.d_value);
    },
    months: function() {
      for (var t = [], n = 0; n < this.numberOfMonths; n++) {
        var o = this.currentMonth + n, i = this.currentYear;
        o > 11 && (o = o % 11 - 1, i = i + 1);
        for (var r = [], a = this.getFirstDayOfMonthIndex(o, i), d = this.getDaysCountInMonth(o, i), l = this.getDaysCountInPrevMonth(o, i), u = 1, s = /* @__PURE__ */ new Date(), c = [], p = Math.ceil((d + a) / 7), f = 0; f < p; f++) {
          var b = [];
          if (f == 0) {
            for (var k = l - a + 1; k <= l; k++) {
              var T = this.getPreviousMonthAndYear(o, i);
              b.push({
                day: k,
                month: T.month,
                year: T.year,
                otherMonth: !0,
                today: this.isToday(s, k, T.month, T.year),
                selectable: this.isSelectable(k, T.month, T.year, !0)
              });
            }
            for (var $ = 7 - b.length, S = 0; S < $; S++)
              b.push({
                day: u,
                month: o,
                year: i,
                today: this.isToday(s, u, o, i),
                selectable: this.isSelectable(u, o, i, !1)
              }), u++;
          } else
            for (var O = 0; O < 7; O++) {
              if (u > d) {
                var w = this.getNextMonthAndYear(o, i);
                b.push({
                  day: u - d,
                  month: w.month,
                  year: w.year,
                  otherMonth: !0,
                  today: this.isToday(s, u - d, w.month, w.year),
                  selectable: this.isSelectable(u - d, w.month, w.year, !0)
                });
              } else
                b.push({
                  day: u,
                  month: o,
                  year: i,
                  today: this.isToday(s, u, o, i),
                  selectable: this.isSelectable(u, o, i, !1)
                });
              u++;
            }
          this.showWeek && c.push(this.getWeekNumber(new Date(b[0].year, b[0].month, b[0].day))), r.push(b);
        }
        t.push({
          month: o,
          year: i,
          dates: r,
          weekNumbers: c
        });
      }
      return t;
    },
    weekDays: function() {
      for (var t = [], n = this.$primevue.config.locale.firstDayOfWeek, o = 0; o < 7; o++)
        t.push(this.$primevue.config.locale.dayNamesMin[n]), n = n == 6 ? 0 : ++n;
      return t;
    },
    ticksTo1970: function() {
      return (1969 * 365 + Math.floor(1970 / 4) - Math.floor(1970 / 100) + Math.floor(1970 / 400)) * 24 * 60 * 60 * 1e7;
    },
    sundayIndex: function() {
      return this.$primevue.config.locale.firstDayOfWeek > 0 ? 7 - this.$primevue.config.locale.firstDayOfWeek : 0;
    },
    datePattern: function() {
      return this.dateFormat || this.$primevue.config.locale.dateFormat;
    },
    monthPickerValues: function() {
      for (var t = this, n = [], o = function(a) {
        if (t.minDate) {
          var d = t.minDate.getMonth(), l = t.minDate.getFullYear();
          if (t.currentYear < l || t.currentYear === l && a < d)
            return !1;
        }
        if (t.maxDate) {
          var u = t.maxDate.getMonth(), s = t.maxDate.getFullYear();
          if (t.currentYear > s || t.currentYear === s && a > u)
            return !1;
        }
        return !0;
      }, i = 0; i <= 11; i++)
        n.push({
          value: this.$primevue.config.locale.monthNamesShort[i],
          selectable: o(i)
        });
      return n;
    },
    yearPickerValues: function() {
      for (var t = this, n = [], o = this.currentYear - this.currentYear % 10, i = function(d) {
        return !(t.minDate && t.minDate.getFullYear() > d || t.maxDate && t.maxDate.getFullYear() < d);
      }, r = 0; r < 10; r++)
        n.push({
          value: o + r,
          selectable: i(o + r)
        });
      return n;
    },
    formattedCurrentHour: function() {
      return this.currentHour == 0 && this.hourFormat == "12" ? this.currentHour + 12 : this.currentHour < 10 ? "0" + this.currentHour : this.currentHour;
    },
    formattedCurrentMinute: function() {
      return this.currentMinute < 10 ? "0" + this.currentMinute : this.currentMinute;
    },
    formattedCurrentSecond: function() {
      return this.currentSecond < 10 ? "0" + this.currentSecond : this.currentSecond;
    },
    todayLabel: function() {
      return this.$primevue.config.locale.today;
    },
    clearLabel: function() {
      return this.$primevue.config.locale.clear;
    },
    weekHeaderLabel: function() {
      return this.$primevue.config.locale.weekHeader;
    },
    monthNames: function() {
      return this.$primevue.config.locale.monthNames;
    },
    switchViewButtonDisabled: function() {
      return this.numberOfMonths > 1 || this.disabled;
    },
    panelId: function() {
      return this.$id + "_panel";
    },
    containerDataP: function() {
      return Pe({
        fluid: this.$fluid
      });
    },
    panelDataP: function() {
      return Pe(aa({
        inline: this.inline
      }, "portal-" + this.appendTo, "portal-" + this.appendTo));
    },
    inputIconDataP: function() {
      return Pe(aa({}, this.size, this.size));
    },
    timePickerDataP: function() {
      return Pe({
        "time-only": this.timeOnly
      });
    },
    hourIncrementCallbacks: function() {
      var t = this;
      return {
        mousedown: function(o) {
          return t.onTimePickerElementMouseDown(o, 0, 1);
        },
        mouseup: function(o) {
          return t.onTimePickerElementMouseUp(o);
        },
        mouseleave: function() {
          return t.onTimePickerElementMouseLeave();
        },
        keydown: function(o) {
          return t.onTimePickerElementKeyDown(o, 0, 1);
        },
        keyup: function(o) {
          return t.onTimePickerElementKeyUp(o);
        }
      };
    },
    hourDecrementCallbacks: function() {
      var t = this;
      return {
        mousedown: function(o) {
          return t.onTimePickerElementMouseDown(o, 0, -1);
        },
        mouseup: function(o) {
          return t.onTimePickerElementMouseUp(o);
        },
        mouseleave: function() {
          return t.onTimePickerElementMouseLeave();
        },
        keydown: function(o) {
          return t.onTimePickerElementKeyDown(o, 0, -1);
        },
        keyup: function(o) {
          return t.onTimePickerElementKeyUp(o);
        }
      };
    },
    minuteIncrementCallbacks: function() {
      var t = this;
      return {
        mousedown: function(o) {
          return t.onTimePickerElementMouseDown(o, 1, 1);
        },
        mouseup: function(o) {
          return t.onTimePickerElementMouseUp(o);
        },
        mouseleave: function() {
          return t.onTimePickerElementMouseLeave();
        },
        keydown: function(o) {
          return t.onTimePickerElementKeyDown(o, 1, 1);
        },
        keyup: function(o) {
          return t.onTimePickerElementKeyUp(o);
        }
      };
    },
    minuteDecrementCallbacks: function() {
      var t = this;
      return {
        mousedown: function(o) {
          return t.onTimePickerElementMouseDown(o, 1, -1);
        },
        mouseup: function(o) {
          return t.onTimePickerElementMouseUp(o);
        },
        mouseleave: function() {
          return t.onTimePickerElementMouseLeave();
        },
        keydown: function(o) {
          return t.onTimePickerElementKeyDown(o, 1, -1);
        },
        keyup: function(o) {
          return t.onTimePickerElementKeyUp(o);
        }
      };
    },
    secondIncrementCallbacks: function() {
      var t = this;
      return {
        mousedown: function(o) {
          return t.onTimePickerElementMouseDown(o, 2, 1);
        },
        mouseup: function(o) {
          return t.onTimePickerElementMouseUp(o);
        },
        mouseleave: function() {
          return t.onTimePickerElementMouseLeave();
        },
        keydown: function(o) {
          return t.onTimePickerElementKeyDown(o, 2, 1);
        },
        keyup: function(o) {
          return t.onTimePickerElementKeyUp(o);
        }
      };
    },
    secondDecrementCallbacks: function() {
      var t = this;
      return {
        mousedown: function(o) {
          return t.onTimePickerElementMouseDown(o, 2, -1);
        },
        mouseup: function(o) {
          return t.onTimePickerElementMouseUp(o);
        },
        mouseleave: function() {
          return t.onTimePickerElementMouseLeave();
        },
        keydown: function(o) {
          return t.onTimePickerElementKeyDown(o, 2, -1);
        },
        keyup: function(o) {
          return t.onTimePickerElementKeyUp(o);
        }
      };
    }
  },
  components: {
    InputText: Et,
    Button: bt,
    Portal: Yo,
    CalendarIcon: Cl,
    ChevronLeftIcon: Sl,
    ChevronRightIcon: $l,
    ChevronUpIcon: Bl,
    ChevronDownIcon: Xr
  },
  directives: {
    ripple: fo
  }
}, Nw = ["id", "data-p"], jw = ["disabled", "aria-label", "aria-expanded", "aria-controls"], Uw = ["data-p"], Hw = ["id", "role", "aria-modal", "aria-label", "data-p"], Kw = ["disabled", "aria-label"], Ww = ["disabled", "aria-label"], Yw = ["disabled", "aria-label"], Gw = ["disabled", "aria-label"], qw = ["data-p-disabled"], Zw = ["abbr"], Xw = ["data-p-disabled"], Jw = ["aria-label", "data-p-today", "data-p-other-month"], Qw = ["onClick", "onKeydown", "aria-selected", "aria-disabled", "data-p"], e2 = ["onClick", "onKeydown", "data-p-disabled", "data-p-selected"], t2 = ["onClick", "onKeydown", "data-p-disabled", "data-p-selected"], n2 = ["data-p"];
function o2(e, t, n, o, i, r) {
  var a = ze("InputText"), d = ze("Button"), l = ze("Portal"), u = uo("ripple");
  return m(), h("span", x({
    ref: "container",
    id: e.$id,
    class: e.cx("root"),
    style: e.sx("root"),
    "data-p": r.containerDataP
  }, e.ptmi("root")), [e.inline ? B("", !0) : (m(), j(a, {
    key: 0,
    ref: r.inputRef,
    id: e.inputId,
    role: "combobox",
    class: ee([e.inputClass, e.cx("pcInputText")]),
    style: Zt(e.inputStyle),
    defaultValue: r.inputFieldValue,
    placeholder: e.placeholder,
    name: e.name,
    size: e.size,
    invalid: e.invalid,
    variant: e.variant,
    fluid: e.fluid,
    required: e.required,
    unstyled: e.unstyled,
    autocomplete: "off",
    "aria-autocomplete": "none",
    "aria-haspopup": "dialog",
    "aria-expanded": i.overlayVisible,
    "aria-controls": r.panelId,
    "aria-labelledby": e.ariaLabelledby,
    "aria-label": e.ariaLabel,
    inputmode: "none",
    disabled: e.disabled,
    readonly: !e.manualInput || e.readonly,
    tabindex: 0,
    onInput: r.onInput,
    onClick: r.onInputClick,
    onFocus: r.onFocus,
    onBlur: r.onBlur,
    onKeydown: r.onKeyDown,
    "data-p-has-dropdown": e.showIcon && e.iconDisplay === "button" && !e.inline,
    "data-p-has-e-icon": e.showIcon && e.iconDisplay === "input" && !e.inline,
    pt: e.ptm("pcInputText")
  }, null, 8, ["id", "class", "style", "defaultValue", "placeholder", "name", "size", "invalid", "variant", "fluid", "required", "unstyled", "aria-expanded", "aria-controls", "aria-labelledby", "aria-label", "disabled", "readonly", "onInput", "onClick", "onFocus", "onBlur", "onKeydown", "data-p-has-dropdown", "data-p-has-e-icon", "pt"])), e.showIcon && e.iconDisplay === "button" && !e.inline ? R(e.$slots, "dropdownbutton", {
    key: 1,
    toggleCallback: r.onButtonClick
  }, function() {
    return [g("button", x({
      class: e.cx("dropdown"),
      disabled: e.disabled,
      onClick: t[0] || (t[0] = function() {
        return r.onButtonClick && r.onButtonClick.apply(r, arguments);
      }),
      type: "button",
      "aria-label": e.$primevue.config.locale.chooseDate,
      "aria-haspopup": "dialog",
      "aria-expanded": i.overlayVisible,
      "aria-controls": r.panelId
    }, e.ptm("dropdown")), [R(e.$slots, "dropdownicon", {
      class: ee(e.icon)
    }, function() {
      return [(m(), j($e(e.icon ? "span" : "CalendarIcon"), x({
        class: e.icon
      }, e.ptm("dropdownIcon")), null, 16, ["class"]))];
    })], 16, jw)];
  }) : e.showIcon && e.iconDisplay === "input" && !e.inline ? (m(), h(Y, {
    key: 2
  }, [e.$slots.inputicon || e.showIcon ? (m(), h("span", x({
    key: 0,
    class: e.cx("inputIconContainer"),
    "data-p": r.inputIconDataP
  }, e.ptm("inputIconContainer")), [R(e.$slots, "inputicon", {
    class: ee(e.cx("inputIcon")),
    clickCallback: r.onButtonClick
  }, function() {
    return [(m(), j($e(e.icon ? "i" : "CalendarIcon"), x({
      class: [e.icon, e.cx("inputIcon")],
      onClick: r.onButtonClick
    }, e.ptm("inputicon")), null, 16, ["class", "onClick"]))];
  })], 16, Uw)) : B("", !0)], 64)) : B("", !0), L(l, {
    appendTo: e.appendTo,
    disabled: e.inline
  }, {
    default: U(function() {
      return [L(Cn, x({
        name: "p-connected-overlay",
        onEnter: t[58] || (t[58] = function(s) {
          return r.onOverlayEnter(s);
        }),
        onAfterEnter: r.onOverlayEnterComplete,
        onAfterLeave: r.onOverlayAfterLeave,
        onLeave: r.onOverlayLeave
      }, e.ptm("transition")), {
        default: U(function() {
          return [e.inline || i.overlayVisible ? (m(), h("div", x({
            key: 0,
            ref: r.overlayRef,
            id: r.panelId,
            class: [e.cx("panel"), e.panelClass],
            style: e.panelStyle,
            role: e.inline ? null : "dialog",
            "aria-modal": e.inline ? null : "true",
            "aria-label": e.$primevue.config.locale.chooseDate,
            onClick: t[55] || (t[55] = function() {
              return r.onOverlayClick && r.onOverlayClick.apply(r, arguments);
            }),
            onKeydown: t[56] || (t[56] = function() {
              return r.onOverlayKeyDown && r.onOverlayKeyDown.apply(r, arguments);
            }),
            onMouseup: t[57] || (t[57] = function() {
              return r.onOverlayMouseUp && r.onOverlayMouseUp.apply(r, arguments);
            }),
            "data-p": r.panelDataP
          }, e.ptm("panel")), [e.timeOnly ? B("", !0) : (m(), h(Y, {
            key: 0
          }, [g("div", x({
            class: e.cx("calendarContainer")
          }, e.ptm("calendarContainer")), [(m(!0), h(Y, null, he(r.months, function(s, c) {
            return m(), h("div", x({
              key: s.month + s.year,
              class: e.cx("calendar")
            }, {
              ref_for: !0
            }, e.ptm("calendar")), [g("div", x({
              class: e.cx("header")
            }, {
              ref_for: !0
            }, e.ptm("header")), [R(e.$slots, "header"), R(e.$slots, "prevbutton", {
              actionCallback: function(f) {
                return r.onPrevButtonClick(f);
              },
              keydownCallback: function(f) {
                return r.onContainerButtonKeydown(f);
              }
            }, function() {
              return [Ze(L(d, x({
                ref_for: !0,
                ref: r.previousButtonRef,
                class: e.cx("pcPrevButton"),
                disabled: e.disabled,
                "aria-label": i.currentView === "year" ? e.$primevue.config.locale.prevDecade : i.currentView === "month" ? e.$primevue.config.locale.prevYear : e.$primevue.config.locale.prevMonth,
                unstyled: e.unstyled,
                onClick: r.onPrevButtonClick,
                onKeydown: r.onContainerButtonKeydown
              }, {
                ref_for: !0
              }, e.navigatorButtonProps, {
                pt: e.ptm("pcPrevButton"),
                "data-pc-group-section": "navigator"
              }), {
                icon: U(function(p) {
                  return [R(e.$slots, "previcon", {}, function() {
                    return [(m(), j($e(e.prevIcon ? "span" : "ChevronLeftIcon"), x({
                      class: [e.prevIcon, p.class]
                    }, {
                      ref_for: !0
                    }, e.ptm("pcPrevButton").icon), null, 16, ["class"]))];
                  })];
                }),
                _: 2
              }, 1040, ["class", "disabled", "aria-label", "unstyled", "onClick", "onKeydown", "pt"]), [[Fn, c === 0]])];
            }), g("div", x({
              class: e.cx("title")
            }, {
              ref_for: !0
            }, e.ptm("title")), [e.$primevue.config.locale.showMonthAfterYear ? (m(), h(Y, {
              key: 0
            }, [i.currentView !== "year" ? (m(), h("button", x({
              key: 0,
              type: "button",
              onClick: t[1] || (t[1] = function() {
                return r.switchToYearView && r.switchToYearView.apply(r, arguments);
              }),
              onKeydown: t[2] || (t[2] = function() {
                return r.onContainerButtonKeydown && r.onContainerButtonKeydown.apply(r, arguments);
              }),
              class: e.cx("selectYear"),
              disabled: r.switchViewButtonDisabled,
              "aria-label": e.$primevue.config.locale.chooseYear
            }, {
              ref_for: !0
            }, e.ptm("selectYear"), {
              "data-pc-group-section": "view"
            }), y(r.getYear(s)), 17, Kw)) : B("", !0), i.currentView === "date" ? (m(), h("button", x({
              key: 1,
              type: "button",
              onClick: t[3] || (t[3] = function() {
                return r.switchToMonthView && r.switchToMonthView.apply(r, arguments);
              }),
              onKeydown: t[4] || (t[4] = function() {
                return r.onContainerButtonKeydown && r.onContainerButtonKeydown.apply(r, arguments);
              }),
              class: e.cx("selectMonth"),
              disabled: r.switchViewButtonDisabled,
              "aria-label": e.$primevue.config.locale.chooseMonth
            }, {
              ref_for: !0
            }, e.ptm("selectMonth"), {
              "data-pc-group-section": "view"
            }), y(r.getMonthName(s.month)), 17, Ww)) : B("", !0)], 64)) : (m(), h(Y, {
              key: 1
            }, [i.currentView === "date" ? (m(), h("button", x({
              key: 0,
              type: "button",
              onClick: t[5] || (t[5] = function() {
                return r.switchToMonthView && r.switchToMonthView.apply(r, arguments);
              }),
              onKeydown: t[6] || (t[6] = function() {
                return r.onContainerButtonKeydown && r.onContainerButtonKeydown.apply(r, arguments);
              }),
              class: e.cx("selectMonth"),
              disabled: r.switchViewButtonDisabled,
              "aria-label": e.$primevue.config.locale.chooseMonth
            }, {
              ref_for: !0
            }, e.ptm("selectMonth"), {
              "data-pc-group-section": "view"
            }), y(r.getMonthName(s.month)), 17, Yw)) : B("", !0), i.currentView !== "year" ? (m(), h("button", x({
              key: 1,
              type: "button",
              onClick: t[7] || (t[7] = function() {
                return r.switchToYearView && r.switchToYearView.apply(r, arguments);
              }),
              onKeydown: t[8] || (t[8] = function() {
                return r.onContainerButtonKeydown && r.onContainerButtonKeydown.apply(r, arguments);
              }),
              class: e.cx("selectYear"),
              disabled: r.switchViewButtonDisabled,
              "aria-label": e.$primevue.config.locale.chooseYear
            }, {
              ref_for: !0
            }, e.ptm("selectYear"), {
              "data-pc-group-section": "view"
            }), y(r.getYear(s)), 17, Gw)) : B("", !0)], 64)), i.currentView === "year" ? (m(), h("span", x({
              key: 2,
              class: e.cx("decade")
            }, {
              ref_for: !0
            }, e.ptm("decade")), [R(e.$slots, "decade", {
              years: r.yearPickerValues
            }, function() {
              return [q(y(r.yearPickerValues[0].value) + " - " + y(r.yearPickerValues[r.yearPickerValues.length - 1].value), 1)];
            })], 16)) : B("", !0)], 16), R(e.$slots, "nextbutton", {
              actionCallback: function(f) {
                return r.onNextButtonClick(f);
              },
              keydownCallback: function(f) {
                return r.onContainerButtonKeydown(f);
              }
            }, function() {
              return [Ze(L(d, x({
                ref_for: !0,
                ref: r.nextButtonRef,
                class: e.cx("pcNextButton"),
                disabled: e.disabled,
                "aria-label": i.currentView === "year" ? e.$primevue.config.locale.nextDecade : i.currentView === "month" ? e.$primevue.config.locale.nextYear : e.$primevue.config.locale.nextMonth,
                unstyled: e.unstyled,
                onClick: r.onNextButtonClick,
                onKeydown: r.onContainerButtonKeydown
              }, {
                ref_for: !0
              }, e.navigatorButtonProps, {
                pt: e.ptm("pcNextButton"),
                "data-pc-group-section": "navigator"
              }), {
                icon: U(function(p) {
                  return [R(e.$slots, "nexticon", {}, function() {
                    return [(m(), j($e(e.nextIcon ? "span" : "ChevronRightIcon"), x({
                      class: [e.nextIcon, p.class]
                    }, {
                      ref_for: !0
                    }, e.ptm("pcNextButton").icon), null, 16, ["class"]))];
                  })];
                }),
                _: 2
              }, 1040, ["class", "disabled", "aria-label", "unstyled", "onClick", "onKeydown", "pt"]), [[Fn, e.numberOfMonths === 1 ? !0 : c === e.numberOfMonths - 1]])];
            })], 16), i.currentView === "date" ? (m(), h("table", x({
              key: 0,
              class: e.cx("dayView"),
              role: "grid"
            }, {
              ref_for: !0
            }, e.ptm("dayView")), [g("thead", x({
              ref_for: !0
            }, e.ptm("tableHeader")), [g("tr", x({
              ref_for: !0
            }, e.ptm("tableHeaderRow")), [e.showWeek ? (m(), h("th", x({
              key: 0,
              scope: "col",
              class: e.cx("weekHeader")
            }, {
              ref_for: !0
            }, e.ptm("weekHeader", {
              context: {
                disabled: e.showWeek
              }
            }), {
              "data-p-disabled": e.showWeek,
              "data-pc-group-section": "tableheadercell"
            }), [R(e.$slots, "weekheaderlabel", {}, function() {
              return [g("span", x({
                ref_for: !0
              }, e.ptm("weekHeaderLabel", {
                context: {
                  disabled: e.showWeek
                }
              }), {
                "data-pc-group-section": "tableheadercelllabel"
              }), y(r.weekHeaderLabel), 17)];
            })], 16, qw)) : B("", !0), (m(!0), h(Y, null, he(r.weekDays, function(p) {
              return m(), h("th", x({
                key: p,
                scope: "col",
                abbr: p
              }, {
                ref_for: !0
              }, e.ptm("tableHeaderCell"), {
                "data-pc-group-section": "tableheadercell",
                class: e.cx("weekDayCell")
              }), [g("span", x({
                class: e.cx("weekDay")
              }, {
                ref_for: !0
              }, e.ptm("weekDay"), {
                "data-pc-group-section": "tableheadercelllabel"
              }), y(p), 17)], 16, Zw);
            }), 128))], 16)], 16), g("tbody", x({
              ref_for: !0
            }, e.ptm("tableBody")), [(m(!0), h(Y, null, he(s.dates, function(p, f) {
              return m(), h("tr", x({
                key: p[0].day + "" + p[0].month
              }, {
                ref_for: !0
              }, e.ptm("tableBodyRow")), [e.showWeek ? (m(), h("td", x({
                key: 0,
                class: e.cx("weekNumber")
              }, {
                ref_for: !0
              }, e.ptm("weekNumber"), {
                "data-pc-group-section": "tablebodycell"
              }), [g("span", x({
                class: e.cx("weekLabelContainer")
              }, {
                ref_for: !0
              }, e.ptm("weekLabelContainer", {
                context: {
                  disabled: e.showWeek
                }
              }), {
                "data-p-disabled": e.showWeek,
                "data-pc-group-section": "tablebodycelllabel"
              }), [R(e.$slots, "weeklabel", {
                weekNumber: s.weekNumbers[f]
              }, function() {
                return [s.weekNumbers[f] < 10 ? (m(), h("span", x({
                  key: 0,
                  style: {
                    visibility: "hidden"
                  }
                }, {
                  ref_for: !0
                }, e.ptm("weekLabel")), "0", 16)) : B("", !0), q(" " + y(s.weekNumbers[f]), 1)];
              })], 16, Xw)], 16)) : B("", !0), (m(!0), h(Y, null, he(p, function(b) {
                return m(), h("td", x({
                  key: b.day + "" + b.month,
                  "aria-label": b.day,
                  class: e.cx("dayCell", {
                    date: b
                  })
                }, {
                  ref_for: !0
                }, e.ptm("dayCell", {
                  context: {
                    date: b,
                    today: b.today,
                    otherMonth: b.otherMonth,
                    selected: r.isSelected(b),
                    disabled: !b.selectable
                  }
                }), {
                  "data-p-today": b.today,
                  "data-p-other-month": b.otherMonth,
                  "data-pc-group-section": "tablebodycell"
                }), [e.showOtherMonths || !b.otherMonth ? Ze((m(), h("span", x({
                  key: 0,
                  class: e.cx("day", {
                    date: b
                  }),
                  onClick: function(T) {
                    return r.onDateSelect(T, b);
                  },
                  draggable: "false",
                  onKeydown: function(T) {
                    return r.onDateCellKeydown(T, b, c);
                  },
                  "aria-selected": r.isSelected(b),
                  "aria-disabled": !b.selectable
                }, {
                  ref_for: !0
                }, e.ptm("day", {
                  context: {
                    date: b,
                    today: b.today,
                    otherMonth: b.otherMonth,
                    selected: r.isSelected(b),
                    disabled: !b.selectable
                  }
                }), {
                  "data-p": r.dayDataP(b),
                  "data-pc-group-section": "tablebodycelllabel"
                }), [R(e.$slots, "date", {
                  date: b
                }, function() {
                  return [q(y(b.day), 1)];
                })], 16, Qw)), [[u]]) : B("", !0), r.isSelected(b) ? (m(), h("div", x({
                  key: 1,
                  class: "p-hidden-accessible",
                  "aria-live": "polite"
                }, {
                  ref_for: !0
                }, e.ptm("hiddenSelectedDay"), {
                  "data-p-hidden-accessible": !0
                }), y(b.day), 17)) : B("", !0)], 16, Jw);
              }), 128))], 16);
            }), 128))], 16)], 16)) : B("", !0)], 16);
          }), 128))], 16), i.currentView === "month" ? (m(), h("div", x({
            key: 0,
            class: e.cx("monthView")
          }, e.ptm("monthView")), [(m(!0), h(Y, null, he(r.monthPickerValues, function(s, c) {
            return Ze((m(), h("span", x({
              key: s,
              onClick: function(f) {
                return r.onMonthSelect(f, {
                  month: s,
                  index: c
                });
              },
              onKeydown: function(f) {
                return r.onMonthCellKeydown(f, {
                  month: s,
                  index: c
                });
              },
              class: e.cx("month", {
                month: s,
                index: c
              })
            }, {
              ref_for: !0
            }, e.ptm("month", {
              context: {
                month: s,
                monthIndex: c,
                selected: r.isMonthSelected(c),
                disabled: !s.selectable
              }
            }), {
              "data-p-disabled": !s.selectable,
              "data-p-selected": r.isMonthSelected(c)
            }), [q(y(s.value) + " ", 1), r.isMonthSelected(c) ? (m(), h("div", x({
              key: 0,
              class: "p-hidden-accessible",
              "aria-live": "polite"
            }, {
              ref_for: !0
            }, e.ptm("hiddenMonth"), {
              "data-p-hidden-accessible": !0
            }), y(s.value), 17)) : B("", !0)], 16, e2)), [[u]]);
          }), 128))], 16)) : B("", !0), i.currentView === "year" ? (m(), h("div", x({
            key: 1,
            class: e.cx("yearView")
          }, e.ptm("yearView")), [(m(!0), h(Y, null, he(r.yearPickerValues, function(s) {
            return Ze((m(), h("span", x({
              key: s.value,
              onClick: function(p) {
                return r.onYearSelect(p, s);
              },
              onKeydown: function(p) {
                return r.onYearCellKeydown(p, s);
              },
              class: e.cx("year", {
                year: s
              })
            }, {
              ref_for: !0
            }, e.ptm("year", {
              context: {
                year: s,
                selected: r.isYearSelected(s.value),
                disabled: !s.selectable
              }
            }), {
              "data-p-disabled": !s.selectable,
              "data-p-selected": r.isYearSelected(s.value)
            }), [q(y(s.value) + " ", 1), r.isYearSelected(s.value) ? (m(), h("div", x({
              key: 0,
              class: "p-hidden-accessible",
              "aria-live": "polite"
            }, {
              ref_for: !0
            }, e.ptm("hiddenYear"), {
              "data-p-hidden-accessible": !0
            }), y(s.value), 17)) : B("", !0)], 16, t2)), [[u]]);
          }), 128))], 16)) : B("", !0)], 64)), (e.showTime || e.timeOnly) && i.currentView === "date" ? (m(), h("div", x({
            key: 1,
            class: e.cx("timePicker"),
            "data-p": r.timePickerDataP
          }, e.ptm("timePicker")), [g("div", x({
            class: e.cx("hourPicker")
          }, e.ptm("hourPicker"), {
            "data-pc-group-section": "timepickerContainer"
          }), [R(e.$slots, "hourincrementbutton", {
            callbacks: r.hourIncrementCallbacks
          }, function() {
            return [L(d, x({
              class: e.cx("pcIncrementButton"),
              "aria-label": e.$primevue.config.locale.nextHour,
              unstyled: e.unstyled,
              onMousedown: t[9] || (t[9] = function(s) {
                return r.onTimePickerElementMouseDown(s, 0, 1);
              }),
              onMouseup: t[10] || (t[10] = function(s) {
                return r.onTimePickerElementMouseUp(s);
              }),
              onKeydown: [r.onContainerButtonKeydown, t[12] || (t[12] = Te(function(s) {
                return r.onTimePickerElementMouseDown(s, 0, 1);
              }, ["enter"])), t[13] || (t[13] = Te(function(s) {
                return r.onTimePickerElementMouseDown(s, 0, 1);
              }, ["space"]))],
              onMouseleave: t[11] || (t[11] = function(s) {
                return r.onTimePickerElementMouseLeave();
              }),
              onKeyup: [t[14] || (t[14] = Te(function(s) {
                return r.onTimePickerElementMouseUp(s);
              }, ["enter"])), t[15] || (t[15] = Te(function(s) {
                return r.onTimePickerElementMouseUp(s);
              }, ["space"]))]
            }, e.timepickerButtonProps, {
              pt: e.ptm("pcIncrementButton"),
              "data-pc-group-section": "timepickerbutton"
            }), {
              icon: U(function(s) {
                return [R(e.$slots, "incrementicon", {}, function() {
                  return [(m(), j($e(e.incrementIcon ? "span" : "ChevronUpIcon"), x({
                    class: [e.incrementIcon, s.class]
                  }, e.ptm("pcIncrementButton").icon, {
                    "data-pc-group-section": "timepickerlabel"
                  }), null, 16, ["class"]))];
                })];
              }),
              _: 3
            }, 16, ["class", "aria-label", "unstyled", "onKeydown", "pt"])];
          }), g("span", x(e.ptm("hour"), {
            "data-pc-group-section": "timepickerlabel"
          }), y(r.formattedCurrentHour), 17), R(e.$slots, "hourdecrementbutton", {
            callbacks: r.hourDecrementCallbacks
          }, function() {
            return [L(d, x({
              class: e.cx("pcDecrementButton"),
              "aria-label": e.$primevue.config.locale.prevHour,
              unstyled: e.unstyled,
              onMousedown: t[16] || (t[16] = function(s) {
                return r.onTimePickerElementMouseDown(s, 0, -1);
              }),
              onMouseup: t[17] || (t[17] = function(s) {
                return r.onTimePickerElementMouseUp(s);
              }),
              onKeydown: [r.onContainerButtonKeydown, t[19] || (t[19] = Te(function(s) {
                return r.onTimePickerElementMouseDown(s, 0, -1);
              }, ["enter"])), t[20] || (t[20] = Te(function(s) {
                return r.onTimePickerElementMouseDown(s, 0, -1);
              }, ["space"]))],
              onMouseleave: t[18] || (t[18] = function(s) {
                return r.onTimePickerElementMouseLeave();
              }),
              onKeyup: [t[21] || (t[21] = Te(function(s) {
                return r.onTimePickerElementMouseUp(s);
              }, ["enter"])), t[22] || (t[22] = Te(function(s) {
                return r.onTimePickerElementMouseUp(s);
              }, ["space"]))]
            }, e.timepickerButtonProps, {
              pt: e.ptm("pcDecrementButton"),
              "data-pc-group-section": "timepickerbutton"
            }), {
              icon: U(function(s) {
                return [R(e.$slots, "decrementicon", {}, function() {
                  return [(m(), j($e(e.decrementIcon ? "span" : "ChevronDownIcon"), x({
                    class: [e.decrementIcon, s.class]
                  }, e.ptm("pcDecrementButton").icon, {
                    "data-pc-group-section": "timepickerlabel"
                  }), null, 16, ["class"]))];
                })];
              }),
              _: 3
            }, 16, ["class", "aria-label", "unstyled", "onKeydown", "pt"])];
          })], 16), g("div", x(e.ptm("separatorContainer"), {
            "data-pc-group-section": "timepickerContainer"
          }), [g("span", x(e.ptm("separator"), {
            "data-pc-group-section": "timepickerlabel"
          }), y(e.timeSeparator), 17)], 16), g("div", x({
            class: e.cx("minutePicker")
          }, e.ptm("minutePicker"), {
            "data-pc-group-section": "timepickerContainer"
          }), [R(e.$slots, "minuteincrementbutton", {
            callbacks: r.minuteIncrementCallbacks
          }, function() {
            return [L(d, x({
              class: e.cx("pcIncrementButton"),
              "aria-label": e.$primevue.config.locale.nextMinute,
              disabled: e.disabled,
              unstyled: e.unstyled,
              onMousedown: t[23] || (t[23] = function(s) {
                return r.onTimePickerElementMouseDown(s, 1, 1);
              }),
              onMouseup: t[24] || (t[24] = function(s) {
                return r.onTimePickerElementMouseUp(s);
              }),
              onKeydown: [r.onContainerButtonKeydown, t[26] || (t[26] = Te(function(s) {
                return r.onTimePickerElementMouseDown(s, 1, 1);
              }, ["enter"])), t[27] || (t[27] = Te(function(s) {
                return r.onTimePickerElementMouseDown(s, 1, 1);
              }, ["space"]))],
              onMouseleave: t[25] || (t[25] = function(s) {
                return r.onTimePickerElementMouseLeave();
              }),
              onKeyup: [t[28] || (t[28] = Te(function(s) {
                return r.onTimePickerElementMouseUp(s);
              }, ["enter"])), t[29] || (t[29] = Te(function(s) {
                return r.onTimePickerElementMouseUp(s);
              }, ["space"]))]
            }, e.timepickerButtonProps, {
              pt: e.ptm("pcIncrementButton"),
              "data-pc-group-section": "timepickerbutton"
            }), {
              icon: U(function(s) {
                return [R(e.$slots, "incrementicon", {}, function() {
                  return [(m(), j($e(e.incrementIcon ? "span" : "ChevronUpIcon"), x({
                    class: [e.incrementIcon, s.class]
                  }, e.ptm("pcIncrementButton").icon, {
                    "data-pc-group-section": "timepickerlabel"
                  }), null, 16, ["class"]))];
                })];
              }),
              _: 3
            }, 16, ["class", "aria-label", "disabled", "unstyled", "onKeydown", "pt"])];
          }), g("span", x(e.ptm("minute"), {
            "data-pc-group-section": "timepickerlabel"
          }), y(r.formattedCurrentMinute), 17), R(e.$slots, "minutedecrementbutton", {
            callbacks: r.minuteDecrementCallbacks
          }, function() {
            return [L(d, x({
              class: e.cx("pcDecrementButton"),
              "aria-label": e.$primevue.config.locale.prevMinute,
              disabled: e.disabled,
              unstyled: e.unstyled,
              onMousedown: t[30] || (t[30] = function(s) {
                return r.onTimePickerElementMouseDown(s, 1, -1);
              }),
              onMouseup: t[31] || (t[31] = function(s) {
                return r.onTimePickerElementMouseUp(s);
              }),
              onKeydown: [r.onContainerButtonKeydown, t[33] || (t[33] = Te(function(s) {
                return r.onTimePickerElementMouseDown(s, 1, -1);
              }, ["enter"])), t[34] || (t[34] = Te(function(s) {
                return r.onTimePickerElementMouseDown(s, 1, -1);
              }, ["space"]))],
              onMouseleave: t[32] || (t[32] = function(s) {
                return r.onTimePickerElementMouseLeave();
              }),
              onKeyup: [t[35] || (t[35] = Te(function(s) {
                return r.onTimePickerElementMouseUp(s);
              }, ["enter"])), t[36] || (t[36] = Te(function(s) {
                return r.onTimePickerElementMouseUp(s);
              }, ["space"]))]
            }, e.timepickerButtonProps, {
              pt: e.ptm("pcDecrementButton"),
              "data-pc-group-section": "timepickerbutton"
            }), {
              icon: U(function(s) {
                return [R(e.$slots, "decrementicon", {}, function() {
                  return [(m(), j($e(e.decrementIcon ? "span" : "ChevronDownIcon"), x({
                    class: [e.decrementIcon, s.class]
                  }, e.ptm("pcDecrementButton").icon, {
                    "data-pc-group-section": "timepickerlabel"
                  }), null, 16, ["class"]))];
                })];
              }),
              _: 3
            }, 16, ["class", "aria-label", "disabled", "unstyled", "onKeydown", "pt"])];
          })], 16), e.showSeconds ? (m(), h("div", x({
            key: 0,
            class: e.cx("separatorContainer")
          }, e.ptm("separatorContainer"), {
            "data-pc-group-section": "timepickerContainer"
          }), [g("span", x(e.ptm("separator"), {
            "data-pc-group-section": "timepickerlabel"
          }), y(e.timeSeparator), 17)], 16)) : B("", !0), e.showSeconds ? (m(), h("div", x({
            key: 1,
            class: e.cx("secondPicker")
          }, e.ptm("secondPicker"), {
            "data-pc-group-section": "timepickerContainer"
          }), [R(e.$slots, "secondincrementbutton", {
            callbacks: r.secondIncrementCallbacks
          }, function() {
            return [L(d, x({
              class: e.cx("pcIncrementButton"),
              "aria-label": e.$primevue.config.locale.nextSecond,
              disabled: e.disabled,
              unstyled: e.unstyled,
              onMousedown: t[37] || (t[37] = function(s) {
                return r.onTimePickerElementMouseDown(s, 2, 1);
              }),
              onMouseup: t[38] || (t[38] = function(s) {
                return r.onTimePickerElementMouseUp(s);
              }),
              onKeydown: [r.onContainerButtonKeydown, t[40] || (t[40] = Te(function(s) {
                return r.onTimePickerElementMouseDown(s, 2, 1);
              }, ["enter"])), t[41] || (t[41] = Te(function(s) {
                return r.onTimePickerElementMouseDown(s, 2, 1);
              }, ["space"]))],
              onMouseleave: t[39] || (t[39] = function(s) {
                return r.onTimePickerElementMouseLeave();
              }),
              onKeyup: [t[42] || (t[42] = Te(function(s) {
                return r.onTimePickerElementMouseUp(s);
              }, ["enter"])), t[43] || (t[43] = Te(function(s) {
                return r.onTimePickerElementMouseUp(s);
              }, ["space"]))]
            }, e.timepickerButtonProps, {
              pt: e.ptm("pcIncrementButton"),
              "data-pc-group-section": "timepickerbutton"
            }), {
              icon: U(function(s) {
                return [R(e.$slots, "incrementicon", {}, function() {
                  return [(m(), j($e(e.incrementIcon ? "span" : "ChevronUpIcon"), x({
                    class: [e.incrementIcon, s.class]
                  }, e.ptm("pcIncrementButton").icon, {
                    "data-pc-group-section": "timepickerlabel"
                  }), null, 16, ["class"]))];
                })];
              }),
              _: 3
            }, 16, ["class", "aria-label", "disabled", "unstyled", "onKeydown", "pt"])];
          }), g("span", x(e.ptm("second"), {
            "data-pc-group-section": "timepickerlabel"
          }), y(r.formattedCurrentSecond), 17), R(e.$slots, "seconddecrementbutton", {
            callbacks: r.secondDecrementCallbacks
          }, function() {
            return [L(d, x({
              class: e.cx("pcDecrementButton"),
              "aria-label": e.$primevue.config.locale.prevSecond,
              disabled: e.disabled,
              unstyled: e.unstyled,
              onMousedown: t[44] || (t[44] = function(s) {
                return r.onTimePickerElementMouseDown(s, 2, -1);
              }),
              onMouseup: t[45] || (t[45] = function(s) {
                return r.onTimePickerElementMouseUp(s);
              }),
              onKeydown: [r.onContainerButtonKeydown, t[47] || (t[47] = Te(function(s) {
                return r.onTimePickerElementMouseDown(s, 2, -1);
              }, ["enter"])), t[48] || (t[48] = Te(function(s) {
                return r.onTimePickerElementMouseDown(s, 2, -1);
              }, ["space"]))],
              onMouseleave: t[46] || (t[46] = function(s) {
                return r.onTimePickerElementMouseLeave();
              }),
              onKeyup: [t[49] || (t[49] = Te(function(s) {
                return r.onTimePickerElementMouseUp(s);
              }, ["enter"])), t[50] || (t[50] = Te(function(s) {
                return r.onTimePickerElementMouseUp(s);
              }, ["space"]))]
            }, e.timepickerButtonProps, {
              pt: e.ptm("pcDecrementButton"),
              "data-pc-group-section": "timepickerbutton"
            }), {
              icon: U(function(s) {
                return [R(e.$slots, "decrementicon", {}, function() {
                  return [(m(), j($e(e.decrementIcon ? "span" : "ChevronDownIcon"), x({
                    class: [e.decrementIcon, s.class]
                  }, e.ptm("pcDecrementButton").icon, {
                    "data-pc-group-section": "timepickerlabel"
                  }), null, 16, ["class"]))];
                })];
              }),
              _: 3
            }, 16, ["class", "aria-label", "disabled", "unstyled", "onKeydown", "pt"])];
          })], 16)) : B("", !0), e.hourFormat == "12" ? (m(), h("div", x({
            key: 2,
            class: e.cx("separatorContainer")
          }, e.ptm("separatorContainer"), {
            "data-pc-group-section": "timepickerContainer"
          }), [g("span", x(e.ptm("separator"), {
            "data-pc-group-section": "timepickerlabel"
          }), y(e.timeSeparator), 17)], 16)) : B("", !0), e.hourFormat == "12" ? (m(), h("div", x({
            key: 3,
            class: e.cx("ampmPicker")
          }, e.ptm("ampmPicker")), [R(e.$slots, "ampmincrementbutton", {
            toggleCallback: function(c) {
              return r.toggleAMPM(c);
            },
            keydownCallback: function(c) {
              return r.onContainerButtonKeydown(c);
            }
          }, function() {
            return [L(d, x({
              class: e.cx("pcIncrementButton"),
              "aria-label": e.$primevue.config.locale.am,
              disabled: e.disabled,
              unstyled: e.unstyled,
              onClick: t[51] || (t[51] = function(s) {
                return r.toggleAMPM(s);
              }),
              onKeydown: r.onContainerButtonKeydown
            }, e.timepickerButtonProps, {
              pt: e.ptm("pcIncrementButton"),
              "data-pc-group-section": "timepickerbutton"
            }), {
              icon: U(function(s) {
                return [R(e.$slots, "incrementicon", {
                  class: ee(e.cx("incrementIcon"))
                }, function() {
                  return [(m(), j($e(e.incrementIcon ? "span" : "ChevronUpIcon"), x({
                    class: [e.cx("incrementIcon"), s.class]
                  }, e.ptm("pcIncrementButton").icon, {
                    "data-pc-group-section": "timepickerlabel"
                  }), null, 16, ["class"]))];
                })];
              }),
              _: 3
            }, 16, ["class", "aria-label", "disabled", "unstyled", "onKeydown", "pt"])];
          }), g("span", x(e.ptm("ampm"), {
            "data-pc-group-section": "timepickerlabel"
          }), y(i.pm ? e.$primevue.config.locale.pm : e.$primevue.config.locale.am), 17), R(e.$slots, "ampmdecrementbutton", {
            toggleCallback: function(c) {
              return r.toggleAMPM(c);
            },
            keydownCallback: function(c) {
              return r.onContainerButtonKeydown(c);
            }
          }, function() {
            return [L(d, x({
              class: e.cx("pcDecrementButton"),
              "aria-label": e.$primevue.config.locale.pm,
              disabled: e.disabled,
              onClick: t[52] || (t[52] = function(s) {
                return r.toggleAMPM(s);
              }),
              onKeydown: r.onContainerButtonKeydown
            }, e.timepickerButtonProps, {
              pt: e.ptm("pcDecrementButton"),
              "data-pc-group-section": "timepickerbutton"
            }), {
              icon: U(function(s) {
                return [R(e.$slots, "decrementicon", {
                  class: ee(e.cx("decrementIcon"))
                }, function() {
                  return [(m(), j($e(e.decrementIcon ? "span" : "ChevronDownIcon"), x({
                    class: [e.cx("decrementIcon"), s.class]
                  }, e.ptm("pcDecrementButton").icon, {
                    "data-pc-group-section": "timepickerlabel"
                  }), null, 16, ["class"]))];
                })];
              }),
              _: 3
            }, 16, ["class", "aria-label", "disabled", "onKeydown", "pt"])];
          })], 16)) : B("", !0)], 16, n2)) : B("", !0), e.showButtonBar ? (m(), h("div", x({
            key: 2,
            class: e.cx("buttonbar")
          }, e.ptm("buttonbar")), [R(e.$slots, "todaybutton", {
            actionCallback: function(c) {
              return r.onTodayButtonClick(c);
            },
            keydownCallback: function(c) {
              return r.onContainerButtonKeydown(c);
            }
          }, function() {
            return [L(d, x({
              label: r.todayLabel,
              onClick: t[53] || (t[53] = function(s) {
                return r.onTodayButtonClick(s);
              }),
              class: e.cx("pcTodayButton"),
              unstyled: e.unstyled,
              onKeydown: r.onContainerButtonKeydown
            }, e.todayButtonProps, {
              pt: e.ptm("pcTodayButton"),
              "data-pc-group-section": "button"
            }), null, 16, ["label", "class", "unstyled", "onKeydown", "pt"])];
          }), R(e.$slots, "clearbutton", {
            actionCallback: function(c) {
              return r.onClearButtonClick(c);
            },
            keydownCallback: function(c) {
              return r.onContainerButtonKeydown(c);
            }
          }, function() {
            return [L(d, x({
              label: r.clearLabel,
              onClick: t[54] || (t[54] = function(s) {
                return r.onClearButtonClick(s);
              }),
              class: e.cx("pcClearButton"),
              unstyled: e.unstyled,
              onKeydown: r.onContainerButtonKeydown
            }, e.clearButtonProps, {
              pt: e.ptm("pcClearButton"),
              "data-pc-group-section": "button"
            }), null, 16, ["label", "class", "unstyled", "onKeydown", "pt"])];
          })], 16)) : B("", !0), R(e.$slots, "footer")], 16, Hw)) : B("", !0)];
        }),
        _: 3
      }, 16, ["onAfterEnter", "onAfterLeave", "onLeave"])];
    }),
    _: 3
  }, 8, ["appendTo", "disabled"])], 16, Nw);
}
Jr.render = o2;
const r2 = {
  viewBox: "0 0 24 24",
  width: "1.2em",
  height: "1.2em"
};
function i2(e, t) {
  return m(), h("svg", r2, [...t[0] || (t[0] = [
    g("path", {
      fill: "currentColor",
      d: "M7.41 8.58L12 13.17l4.59-4.59L18 10l-6 6l-6-6z"
    }, null, -1)
  ])]);
}
const Il = Se({ name: "mdi-chevron-down", render: i2 }), a2 = {
  viewBox: "0 0 24 24",
  width: "1.2em",
  height: "1.2em"
};
function l2(e, t) {
  return m(), h("svg", a2, [...t[0] || (t[0] = [
    g("path", {
      fill: "currentColor",
      d: "M19 3h-1V1h-2v2H8V1H6v2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14c1.11 0 2-.89 2-2V5a2 2 0 0 0-2-2m0 16H5V9h14zm0-12H5V5h14z"
    }, null, -1)
  ])]);
}
const s2 = Se({ name: "mdi-calendar-blank-outline", render: l2 });
var d2 = `
    .p-progressspinner {
        position: relative;
        margin: 0 auto;
        width: 100px;
        height: 100px;
        display: inline-block;
    }

    .p-progressspinner::before {
        content: '';
        display: block;
        padding-top: 100%;
    }

    .p-progressspinner-spin {
        height: 100%;
        transform-origin: center center;
        width: 100%;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
        animation: p-progressspinner-rotate 2s linear infinite;
    }

    .p-progressspinner-circle {
        stroke-dasharray: 89, 200;
        stroke-dashoffset: 0;
        stroke: dt('progressspinner.colorOne');
        animation:
            p-progressspinner-dash 1.5s ease-in-out infinite,
            p-progressspinner-color 6s ease-in-out infinite;
        stroke-linecap: round;
    }

    @keyframes p-progressspinner-rotate {
        100% {
            transform: rotate(360deg);
        }
    }
    @keyframes p-progressspinner-dash {
        0% {
            stroke-dasharray: 1, 200;
            stroke-dashoffset: 0;
        }
        50% {
            stroke-dasharray: 89, 200;
            stroke-dashoffset: -35px;
        }
        100% {
            stroke-dasharray: 89, 200;
            stroke-dashoffset: -124px;
        }
    }
    @keyframes p-progressspinner-color {
        100%,
        0% {
            stroke: dt('progressspinner.color.one');
        }
        40% {
            stroke: dt('progressspinner.color.two');
        }
        66% {
            stroke: dt('progressspinner.color.three');
        }
        80%,
        90% {
            stroke: dt('progressspinner.color.four');
        }
    }
`, u2 = {
  root: "p-progressspinner",
  spin: "p-progressspinner-spin",
  circle: "p-progressspinner-circle"
}, c2 = oe.extend({
  name: "progressspinner",
  style: d2,
  classes: u2
}), p2 = {
  name: "BaseProgressSpinner",
  extends: nt,
  props: {
    strokeWidth: {
      type: String,
      default: "2"
    },
    fill: {
      type: String,
      default: "none"
    },
    animationDuration: {
      type: String,
      default: "2s"
    }
  },
  style: c2,
  provide: function() {
    return {
      $pcProgressSpinner: this,
      $parentInstance: this
    };
  }
}, go = {
  name: "ProgressSpinner",
  extends: p2,
  inheritAttrs: !1,
  computed: {
    svgStyle: function() {
      return {
        "animation-duration": this.animationDuration
      };
    }
  }
}, m2 = ["fill", "stroke-width"];
function f2(e, t, n, o, i, r) {
  return m(), h("div", x({
    class: e.cx("root"),
    role: "progressbar"
  }, e.ptmi("root")), [(m(), h("svg", x({
    class: e.cx("spin"),
    viewBox: "25 25 50 50",
    style: r.svgStyle
  }, e.ptm("spin")), [g("circle", x({
    class: e.cx("circle"),
    cx: "50",
    cy: "50",
    r: "20",
    fill: e.fill,
    "stroke-width": e.strokeWidth,
    strokeMiterlimit: "10"
  }, e.ptm("circle")), null, 16, m2)], 16))], 16);
}
go.render = f2;
const g2 = {
  viewBox: "0 0 24 24",
  width: "1.2em",
  height: "1.2em"
};
function h2(e, t) {
  return m(), h("svg", g2, [...t[0] || (t[0] = [
    g("path", {
      fill: "currentColor",
      d: "M15.41 16.58L10.83 12l4.58-4.59L14 6l-6 6l6 6z"
    }, null, -1)
  ])]);
}
const b2 = Se({ name: "mdi-chevron-left", render: h2 }), la = (e) => e.scope === "ticket" && e.config.attribute_type === "choice";
function v2(e, t, n) {
  if (t !== void 0) {
    if (t === null) return null;
    const i = e.find((r) => r.ident === t);
    return i && la(i) ? i : null;
  }
  return n !== "multiple_attribute_choices" && n !== "multiple_capacity" ? null : e.filter(la).sort((i, r) => i.sort_order - r.sort_order)[0] ?? null;
}
const sa = (e) => e ? e.slice(0, 5) : null;
function Fo(e) {
  return e.units ?? 1;
}
function y2(e, t, n) {
  if (!e.capacity_ident) return null;
  const o = sa(n);
  if (o && t?.length) {
    const i = t.filter((a) => a.ident === e.capacity_ident), r = i.find((a) => sa(a.time) === o) ?? i.find((a) => !a.time);
    if (r) return r.remaining_capacity ?? null;
  }
  return e.remaining_units ?? null;
}
function k2(e, t) {
  return !e.capacity_ident || t === null ? !1 : t < Fo(e);
}
function w2(e, t, n) {
  const o = /* @__PURE__ */ new Map();
  for (const r of e) {
    if (!r.capacity_ident) continue;
    const a = (t[r.value] ?? 0) * Fo(r);
    o.set(r.capacity_ident, (o.get(r.capacity_ident) ?? 0) + a);
  }
  const i = {};
  for (const r of e) {
    const a = Fo(r), d = n(r);
    if (!r.capacity_ident || d === null || a <= 0) continue;
    const l = (t[r.value] ?? 0) * a, u = d - ((o.get(r.capacity_ident) ?? 0) - l);
    i[r.value] = Math.max(0, Math.floor(u / a));
  }
  return i;
}
function x2(e, t, n) {
  const o = /* @__PURE__ */ new Map(), i = {};
  for (const r of e) {
    const a = Fo(r), d = n(r);
    if (!r.capacity_ident || d === null || a <= 0) continue;
    const l = r.capacity_ident, u = o.get(l) ?? d, s = t[r.value] ?? 0, c = Math.max(0, Math.min(s, Math.floor(u / a)));
    o.set(l, u - c * a), c !== s && (i[r.value] = c);
  }
  return Object.keys(i).length > 0 ? { ...t, ...i } : t;
}
var C2 = `
    .p-textarea {
        font-family: inherit;
        font-feature-settings: inherit;
        font-size: 1rem;
        color: dt('textarea.color');
        background: dt('textarea.background');
        padding-block: dt('textarea.padding.y');
        padding-inline: dt('textarea.padding.x');
        border: 1px solid dt('textarea.border.color');
        transition:
            background dt('textarea.transition.duration'),
            color dt('textarea.transition.duration'),
            border-color dt('textarea.transition.duration'),
            outline-color dt('textarea.transition.duration'),
            box-shadow dt('textarea.transition.duration');
        appearance: none;
        border-radius: dt('textarea.border.radius');
        outline-color: transparent;
        box-shadow: dt('textarea.shadow');
    }

    .p-textarea:enabled:hover {
        border-color: dt('textarea.hover.border.color');
    }

    .p-textarea:enabled:focus {
        border-color: dt('textarea.focus.border.color');
        box-shadow: dt('textarea.focus.ring.shadow');
        outline: dt('textarea.focus.ring.width') dt('textarea.focus.ring.style') dt('textarea.focus.ring.color');
        outline-offset: dt('textarea.focus.ring.offset');
    }

    .p-textarea.p-invalid {
        border-color: dt('textarea.invalid.border.color');
    }

    .p-textarea.p-variant-filled {
        background: dt('textarea.filled.background');
    }

    .p-textarea.p-variant-filled:enabled:hover {
        background: dt('textarea.filled.hover.background');
    }

    .p-textarea.p-variant-filled:enabled:focus {
        background: dt('textarea.filled.focus.background');
    }

    .p-textarea:disabled {
        opacity: 1;
        background: dt('textarea.disabled.background');
        color: dt('textarea.disabled.color');
    }

    .p-textarea::placeholder {
        color: dt('textarea.placeholder.color');
    }

    .p-textarea.p-invalid::placeholder {
        color: dt('textarea.invalid.placeholder.color');
    }

    .p-textarea-fluid {
        width: 100%;
    }

    .p-textarea-resizable {
        overflow: hidden;
        resize: none;
    }

    .p-textarea-sm {
        font-size: dt('textarea.sm.font.size');
        padding-block: dt('textarea.sm.padding.y');
        padding-inline: dt('textarea.sm.padding.x');
    }

    .p-textarea-lg {
        font-size: dt('textarea.lg.font.size');
        padding-block: dt('textarea.lg.padding.y');
        padding-inline: dt('textarea.lg.padding.x');
    }
`, S2 = {
  root: function(t) {
    var n = t.instance, o = t.props;
    return ["p-textarea p-component", {
      "p-filled": n.$filled,
      "p-textarea-resizable ": o.autoResize,
      "p-textarea-sm p-inputfield-sm": o.size === "small",
      "p-textarea-lg p-inputfield-lg": o.size === "large",
      "p-invalid": n.$invalid,
      "p-variant-filled": n.$variant === "filled",
      "p-textarea-fluid": n.$fluid
    }];
  }
}, $2 = oe.extend({
  name: "textarea",
  style: C2,
  classes: S2
}), B2 = {
  name: "BaseTextarea",
  extends: on,
  props: {
    autoResize: Boolean
  },
  style: $2,
  provide: function() {
    return {
      $pcTextarea: this,
      $parentInstance: this
    };
  }
};
function no(e) {
  "@babel/helpers - typeof";
  return no = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, no(e);
}
function T2(e, t, n) {
  return (t = I2(t)) in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function I2(e) {
  var t = D2(e, "string");
  return no(t) == "symbol" ? t : t + "";
}
function D2(e, t) {
  if (no(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var o = n.call(e, t);
    if (no(o) != "object") return o;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var Qr = {
  name: "Textarea",
  extends: B2,
  inheritAttrs: !1,
  observer: null,
  mounted: function() {
    var t = this;
    this.autoResize && (this.observer = new ResizeObserver(function() {
      requestAnimationFrame(function() {
        t.resize();
      });
    }), this.observer.observe(this.$el));
  },
  updated: function() {
    this.autoResize && this.resize();
  },
  beforeUnmount: function() {
    this.observer && this.observer.disconnect();
  },
  methods: {
    resize: function() {
      if (this.$el.offsetParent) {
        var t = this.$el.style.height, n = parseInt(t) || 0, o = this.$el.scrollHeight, i = !n || o > n, r = n && o < n;
        r ? (this.$el.style.height = "auto", this.$el.style.height = "".concat(this.$el.scrollHeight, "px")) : i && (this.$el.style.height = "".concat(o, "px"));
      }
    },
    onInput: function(t) {
      this.autoResize && this.resize(), this.writeValue(t.target.value, t);
    }
  },
  computed: {
    attrs: function() {
      return x(this.ptmi("root", {
        context: {
          filled: this.$filled,
          disabled: this.disabled
        }
      }), this.formField);
    },
    dataP: function() {
      return Pe(T2({
        invalid: this.$invalid,
        fluid: this.$fluid,
        filled: this.$variant === "filled"
      }, this.size, this.size));
    }
  }
}, P2 = ["value", "name", "disabled", "aria-invalid", "data-p"];
function z2(e, t, n, o, i, r) {
  return m(), h("textarea", x({
    class: e.cx("root"),
    value: e.d_value,
    name: e.name,
    disabled: e.disabled,
    "aria-invalid": e.invalid || void 0,
    "data-p": r.dataP,
    onInput: t[0] || (t[0] = function() {
      return r.onInput && r.onInput.apply(r, arguments);
    })
  }, r.attrs), null, 16, P2);
}
Qr.render = z2;
const Je = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [o, i] of t)
    n[o] = i;
  return n;
}, L2 = {}, O2 = { class: "field-container py-4 @md:py-5 border-b border-gray-200 last:border-b-0 flex flex-col @md:flex-row @md:items-start gap-2 @md:gap-6" }, M2 = { class: "field-title text-sm font-medium text-gray-800 @md:w-2/5 @md:flex-shrink-0" }, A2 = { class: "field-input-container flex-1 min-w-0 @md:max-w-sm flex flex-col items-stretch gap-1.5" }, _2 = {
  key: 0,
  class: "field-price flex justify-end"
}, F2 = {
  key: 1,
  class: "field-errors self-start @md:self-auto"
};
function E2(e, t) {
  return m(), h("div", O2, [
    g("div", M2, [
      R(e.$slots, "title")
    ]),
    g("div", A2, [
      R(e.$slots, "default"),
      e.$slots.price ? (m(), h("div", _2, [
        R(e.$slots, "price")
      ])) : B("", !0),
      e.$slots.errors ? (m(), h("div", F2, [
        R(e.$slots, "errors")
      ])) : B("", !0)
    ])
  ]);
}
const Rt = /* @__PURE__ */ Je(L2, [["render", E2]]), R2 = ["for"], V2 = {
  key: 0,
  class: "text-red-500"
}, N2 = {
  key: 0,
  class: "field-meta mt-1 flex flex-col gap-0.5"
}, j2 = {
  key: 0,
  class: "field-price-hint text-xs font-medium text-gray-700 inline-flex items-baseline gap-1.5"
}, U2 = {
  key: 0,
  class: "mancub-strike-diagonal font-normal text-gray-400"
}, H2 = {
  key: 1,
  class: "field-description text-[11px] leading-snug text-gray-400"
}, an = /* @__PURE__ */ se({
  __name: "FieldLabel",
  props: {
    forId: {},
    title: {},
    price: {},
    subtitle: {},
    required: { type: Boolean },
    hidePrice: { type: Boolean }
  },
  setup(e) {
    const t = e, n = Bn(), o = v(() => tn(t.price ?? null, Q(n))), i = v(() => {
      if (t.hidePrice || !o.value.display) return !1;
      const c = o.value.amount;
      return !(c !== null && c === 0);
    }), r = ce(qr, void 0), a = v(() => $n(t.price ?? null, Q(r), o.value.code)), d = ce(mo, null), l = (c) => _t(c, {
      code: o.value.code,
      unit: o.value.unit,
      decimals: o.value.decimals,
      lang: Q(d) ?? void 0
    }), u = v(() => {
      const c = o.value.amount;
      return c === null ? o.value.unit ? `${o.value.display} ${o.value.unit}` : o.value.display : l(c);
    }), s = v(() => {
      const c = o.value.amount;
      return c === null || !a.value || !(c > 0) ? null : l(c * (1 - a.value / 100));
    });
    return (c, p) => (m(), h(Y, null, [
      g("label", { for: c.forId }, [
        q(y(c.title), 1),
        c.required ? (m(), h("span", V2, "*")) : B("", !0)
      ], 8, R2),
      i.value || c.subtitle ? (m(), h("div", N2, [
        i.value ? (m(), h("div", j2, [
          s.value ? (m(), h("span", U2, y(u.value), 1)) : B("", !0),
          g("span", null, [
            q(y(s.value ?? u.value), 1),
            c.price?.unit_quantifier ? (m(), h(Y, { key: 0 }, [
              q(" " + y(c.price.unit_quantifier), 1)
            ], 64)) : B("", !0)
          ])
        ])) : B("", !0),
        c.subtitle ? (m(), h("div", H2, y(c.subtitle), 1)) : B("", !0)
      ])) : B("", !0)
    ], 64));
  }
});
var Dl = {
  name: "MinusIcon",
  extends: Ue
};
function K2(e) {
  return q2(e) || G2(e) || Y2(e) || W2();
}
function W2() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Y2(e, t) {
  if (e) {
    if (typeof e == "string") return Dr(e, t);
    var n = {}.toString.call(e).slice(8, -1);
    return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Dr(e, t) : void 0;
  }
}
function G2(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function q2(e) {
  if (Array.isArray(e)) return Dr(e);
}
function Dr(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, o = Array(t); n < t; n++) o[n] = e[n];
  return o;
}
function Z2(e, t, n, o, i, r) {
  return m(), h("svg", x({
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.pti()), K2(t[0] || (t[0] = [g("path", {
    d: "M13.2222 7.77778H0.777778C0.571498 7.77778 0.373667 7.69584 0.227806 7.54998C0.0819442 7.40412 0 7.20629 0 7.00001C0 6.79373 0.0819442 6.5959 0.227806 6.45003C0.373667 6.30417 0.571498 6.22223 0.777778 6.22223H13.2222C13.4285 6.22223 13.6263 6.30417 13.7722 6.45003C13.9181 6.5959 14 6.79373 14 7.00001C14 7.20629 13.9181 7.40412 13.7722 7.54998C13.6263 7.69584 13.4285 7.77778 13.2222 7.77778Z",
    fill: "currentColor"
  }, null, -1)])), 16);
}
Dl.render = Z2;
var X2 = `
    .p-checkbox {
        position: relative;
        display: inline-flex;
        user-select: none;
        vertical-align: bottom;
        width: dt('checkbox.width');
        height: dt('checkbox.height');
    }

    .p-checkbox-input {
        cursor: pointer;
        appearance: none;
        position: absolute;
        inset-block-start: 0;
        inset-inline-start: 0;
        width: 100%;
        height: 100%;
        padding: 0;
        margin: 0;
        opacity: 0;
        z-index: 1;
        outline: 0 none;
        border: 1px solid transparent;
        border-radius: dt('checkbox.border.radius');
    }

    .p-checkbox-box {
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: dt('checkbox.border.radius');
        border: 1px solid dt('checkbox.border.color');
        background: dt('checkbox.background');
        width: dt('checkbox.width');
        height: dt('checkbox.height');
        transition:
            background dt('checkbox.transition.duration'),
            color dt('checkbox.transition.duration'),
            border-color dt('checkbox.transition.duration'),
            box-shadow dt('checkbox.transition.duration'),
            outline-color dt('checkbox.transition.duration');
        outline-color: transparent;
        box-shadow: dt('checkbox.shadow');
    }

    .p-checkbox-icon {
        transition-duration: dt('checkbox.transition.duration');
        color: dt('checkbox.icon.color');
        font-size: dt('checkbox.icon.size');
        width: dt('checkbox.icon.size');
        height: dt('checkbox.icon.size');
    }

    .p-checkbox:not(.p-disabled):has(.p-checkbox-input:hover) .p-checkbox-box {
        border-color: dt('checkbox.hover.border.color');
    }

    .p-checkbox-checked .p-checkbox-box {
        border-color: dt('checkbox.checked.border.color');
        background: dt('checkbox.checked.background');
    }

    .p-checkbox-checked .p-checkbox-icon {
        color: dt('checkbox.icon.checked.color');
    }

    .p-checkbox-checked:not(.p-disabled):has(.p-checkbox-input:hover) .p-checkbox-box {
        background: dt('checkbox.checked.hover.background');
        border-color: dt('checkbox.checked.hover.border.color');
    }

    .p-checkbox-checked:not(.p-disabled):has(.p-checkbox-input:hover) .p-checkbox-icon {
        color: dt('checkbox.icon.checked.hover.color');
    }

    .p-checkbox:not(.p-disabled):has(.p-checkbox-input:focus-visible) .p-checkbox-box {
        border-color: dt('checkbox.focus.border.color');
        box-shadow: dt('checkbox.focus.ring.shadow');
        outline: dt('checkbox.focus.ring.width') dt('checkbox.focus.ring.style') dt('checkbox.focus.ring.color');
        outline-offset: dt('checkbox.focus.ring.offset');
    }

    .p-checkbox-checked:not(.p-disabled):has(.p-checkbox-input:focus-visible) .p-checkbox-box {
        border-color: dt('checkbox.checked.focus.border.color');
    }

    .p-checkbox.p-invalid > .p-checkbox-box {
        border-color: dt('checkbox.invalid.border.color');
    }

    .p-checkbox.p-variant-filled .p-checkbox-box {
        background: dt('checkbox.filled.background');
    }

    .p-checkbox-checked.p-variant-filled .p-checkbox-box {
        background: dt('checkbox.checked.background');
    }

    .p-checkbox-checked.p-variant-filled:not(.p-disabled):has(.p-checkbox-input:hover) .p-checkbox-box {
        background: dt('checkbox.checked.hover.background');
    }

    .p-checkbox.p-disabled {
        opacity: 1;
    }

    .p-checkbox.p-disabled .p-checkbox-box {
        background: dt('checkbox.disabled.background');
        border-color: dt('checkbox.checked.disabled.border.color');
    }

    .p-checkbox.p-disabled .p-checkbox-box .p-checkbox-icon {
        color: dt('checkbox.icon.disabled.color');
    }

    .p-checkbox-sm,
    .p-checkbox-sm .p-checkbox-box {
        width: dt('checkbox.sm.width');
        height: dt('checkbox.sm.height');
    }

    .p-checkbox-sm .p-checkbox-icon {
        font-size: dt('checkbox.icon.sm.size');
        width: dt('checkbox.icon.sm.size');
        height: dt('checkbox.icon.sm.size');
    }

    .p-checkbox-lg,
    .p-checkbox-lg .p-checkbox-box {
        width: dt('checkbox.lg.width');
        height: dt('checkbox.lg.height');
    }

    .p-checkbox-lg .p-checkbox-icon {
        font-size: dt('checkbox.icon.lg.size');
        width: dt('checkbox.icon.lg.size');
        height: dt('checkbox.icon.lg.size');
    }
`, J2 = {
  root: function(t) {
    var n = t.instance, o = t.props;
    return ["p-checkbox p-component", {
      "p-checkbox-checked": n.checked,
      "p-disabled": o.disabled,
      "p-invalid": n.$pcCheckboxGroup ? n.$pcCheckboxGroup.$invalid : n.$invalid,
      "p-variant-filled": n.$variant === "filled",
      "p-checkbox-sm p-inputfield-sm": o.size === "small",
      "p-checkbox-lg p-inputfield-lg": o.size === "large"
    }];
  },
  box: "p-checkbox-box",
  input: "p-checkbox-input",
  icon: "p-checkbox-icon"
}, Q2 = oe.extend({
  name: "checkbox",
  style: X2,
  classes: J2
}), ex = {
  name: "BaseCheckbox",
  extends: on,
  props: {
    value: null,
    binary: Boolean,
    indeterminate: {
      type: Boolean,
      default: !1
    },
    trueValue: {
      type: null,
      default: !0
    },
    falseValue: {
      type: null,
      default: !1
    },
    readonly: {
      type: Boolean,
      default: !1
    },
    required: {
      type: Boolean,
      default: !1
    },
    tabindex: {
      type: Number,
      default: null
    },
    inputId: {
      type: String,
      default: null
    },
    inputClass: {
      type: [String, Object],
      default: null
    },
    inputStyle: {
      type: Object,
      default: null
    },
    ariaLabelledby: {
      type: String,
      default: null
    },
    ariaLabel: {
      type: String,
      default: null
    }
  },
  style: Q2,
  provide: function() {
    return {
      $pcCheckbox: this,
      $parentInstance: this
    };
  }
};
function oo(e) {
  "@babel/helpers - typeof";
  return oo = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, oo(e);
}
function tx(e, t, n) {
  return (t = nx(t)) in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function nx(e) {
  var t = ox(e, "string");
  return oo(t) == "symbol" ? t : t + "";
}
function ox(e, t) {
  if (oo(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var o = n.call(e, t);
    if (oo(o) != "object") return o;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function rx(e) {
  return sx(e) || lx(e) || ax(e) || ix();
}
function ix() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function ax(e, t) {
  if (e) {
    if (typeof e == "string") return Pr(e, t);
    var n = {}.toString.call(e).slice(8, -1);
    return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Pr(e, t) : void 0;
  }
}
function lx(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function sx(e) {
  if (Array.isArray(e)) return Pr(e);
}
function Pr(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, o = Array(t); n < t; n++) o[n] = e[n];
  return o;
}
var Go = {
  name: "Checkbox",
  extends: ex,
  inheritAttrs: !1,
  emits: ["change", "focus", "blur", "update:indeterminate"],
  inject: {
    $pcCheckboxGroup: {
      default: void 0
    }
  },
  data: function() {
    return {
      d_indeterminate: this.indeterminate
    };
  },
  watch: {
    indeterminate: function(t) {
      this.d_indeterminate = t;
    }
  },
  methods: {
    getPTOptions: function(t) {
      var n = t === "root" ? this.ptmi : this.ptm;
      return n(t, {
        context: {
          checked: this.checked,
          indeterminate: this.d_indeterminate,
          disabled: this.disabled
        }
      });
    },
    onChange: function(t) {
      var n = this;
      if (!this.disabled && !this.readonly) {
        var o = this.$pcCheckboxGroup ? this.$pcCheckboxGroup.d_value : this.d_value, i;
        this.binary ? i = this.d_indeterminate ? this.trueValue : this.checked ? this.falseValue : this.trueValue : this.checked || this.d_indeterminate ? i = o.filter(function(r) {
          return !co(r, n.value);
        }) : i = o ? [].concat(rx(o), [this.value]) : [this.value], this.d_indeterminate && (this.d_indeterminate = !1, this.$emit("update:indeterminate", this.d_indeterminate)), this.$pcCheckboxGroup ? this.$pcCheckboxGroup.writeValue(i, t) : this.writeValue(i, t), this.$emit("change", t);
      }
    },
    onFocus: function(t) {
      this.$emit("focus", t);
    },
    onBlur: function(t) {
      var n, o;
      this.$emit("blur", t), (n = (o = this.formField).onBlur) === null || n === void 0 || n.call(o, t);
    }
  },
  computed: {
    groupName: function() {
      return this.$pcCheckboxGroup ? this.$pcCheckboxGroup.groupName : this.$formName;
    },
    checked: function() {
      var t = this.$pcCheckboxGroup ? this.$pcCheckboxGroup.d_value : this.d_value;
      return this.d_indeterminate ? !1 : this.binary ? t === this.trueValue : $s(this.value, t);
    },
    dataP: function() {
      return Pe(tx({
        invalid: this.$invalid,
        checked: this.checked,
        disabled: this.disabled,
        filled: this.$variant === "filled"
      }, this.size, this.size));
    }
  },
  components: {
    CheckIcon: Zr,
    MinusIcon: Dl
  }
}, dx = ["data-p-checked", "data-p-indeterminate", "data-p-disabled", "data-p"], ux = ["id", "value", "name", "checked", "tabindex", "disabled", "readonly", "required", "aria-labelledby", "aria-label", "aria-invalid", "aria-checked"], cx = ["data-p"];
function px(e, t, n, o, i, r) {
  var a = ze("CheckIcon"), d = ze("MinusIcon");
  return m(), h("div", x({
    class: e.cx("root")
  }, r.getPTOptions("root"), {
    "data-p-checked": r.checked,
    "data-p-indeterminate": i.d_indeterminate || void 0,
    "data-p-disabled": e.disabled,
    "data-p": r.dataP
  }), [g("input", x({
    id: e.inputId,
    type: "checkbox",
    class: [e.cx("input"), e.inputClass],
    style: e.inputStyle,
    value: e.value,
    name: r.groupName,
    checked: r.checked,
    tabindex: e.tabindex,
    disabled: e.disabled,
    readonly: e.readonly,
    required: e.required,
    "aria-labelledby": e.ariaLabelledby,
    "aria-label": e.ariaLabel,
    "aria-invalid": e.invalid || void 0,
    "aria-checked": i.d_indeterminate ? "mixed" : void 0,
    onFocus: t[0] || (t[0] = function() {
      return r.onFocus && r.onFocus.apply(r, arguments);
    }),
    onBlur: t[1] || (t[1] = function() {
      return r.onBlur && r.onBlur.apply(r, arguments);
    }),
    onChange: t[2] || (t[2] = function() {
      return r.onChange && r.onChange.apply(r, arguments);
    })
  }, r.getPTOptions("input")), null, 16, ux), g("div", x({
    class: e.cx("box")
  }, r.getPTOptions("box"), {
    "data-p": r.dataP
  }), [R(e.$slots, "icon", {
    checked: r.checked,
    indeterminate: i.d_indeterminate,
    class: ee(e.cx("icon")),
    dataP: r.dataP
  }, function() {
    return [r.checked ? (m(), j(a, x({
      key: 0,
      class: e.cx("icon")
    }, r.getPTOptions("icon"), {
      "data-p": r.dataP
    }), null, 16, ["class", "data-p"])) : i.d_indeterminate ? (m(), j(d, x({
      key: 1,
      class: e.cx("icon")
    }, r.getPTOptions("icon"), {
      "data-p": r.dataP
    }), null, 16, ["class", "data-p"])) : B("", !0)];
  })], 16, cx)], 16, dx);
}
Go.render = px;
const Re = {
  reservation: "Reservation",
  date: "Date",
  changeDate: "Change date",
  hideDate: "Hide",
  time: "Time",
  possibleAlternatives: "Possible alternatives",
  priceList: "Price list",
  expandPriceList: "Expand price list",
  collapsePriceList: "Collapse price list",
  showFullPriceList: "Show full price list",
  showShortPriceList: "Show fewer prices",
  pickDate: "Pick a date in the calendar to load that day's prices.",
  discountAvailable: "Discount available",
  saveUpTo: "Save up to {percent}%",
  saveExact: "You save {percent}%",
  priceListSave: "You save {amount}",
  addToCart: "Add to cart",
  buyNow: "Buy now",
  saveChanges: "Save changes",
  cancel: "Cancel",
  confirmTickets: "Confirm ticket counts",
  selectTicketCounts: "Please select ticket counts",
  ticketDetailsNextStep: "The next step is configuring each ticket",
  backToTicketSelection: "Back to ticket selection",
  ticketNumber: "Ticket {n}",
  completeForm: "Fill in fields marked with an asterisk",
  processing: "Processing…",
  resetForm: "Reset form",
  revalidate: "Revalidate",
  selectDate: "Please select a date with available slots.",
  loadingForm: "Loading form...",
  leadTimeWarning: "This start time is close to the minimum booking lead time and may soon become unavailable. Please place your order soon.",
  onlineBookingUnavailable: "This date can't be booked online. Please contact us directly for a custom offer — subject to availability.",
  notBuyableAlone: "The selected items can't be purchased on their own. Please add at least one other item.",
  soldOut: "Sold out",
  priceUnavailable: "Not available on this date",
  customLocation: "Enter custom location",
  customLocationName: "Location name",
  customLocationAddress: "Address",
  basket: "Basket",
  basketEmpty: "Your basket is empty.",
  basketItems: "Order items",
  removeItem: "Remove item",
  removeItemConfirm: "Remove?",
  editItem: "Edit item",
  proceedToCheckout: "Proceed to order",
  backToBasket: "Back to basket",
  tickets: "Tickets",
  addedToBasket: "Added to basket",
  addedToBasketMessage: "Your item has been added to the basket.",
  continueShopping: "Continue shopping",
  backToShopping: "Back to shopping",
  goToBasket: "Go to basket",
  customer: "Customer",
  customerName: "Customer name",
  customerEmail: "Customer email",
  customerPhone: "Customer phone",
  addCustomerNote: "I want to add a note",
  customerNote: "Note",
  sendReceipt: "Send me a payment receipt",
  issueForCompany: "Issue receipt for a company",
  invoiceName: "Name",
  invoiceCompany: "Company",
  invoiceVat: "VAT ID",
  invoiceAddress: "Address",
  invoiceCity: "City / region",
  invoiceZip: "ZIP",
  invoiceCountry: "Country",
  participant: "Participant",
  customerIsParticipant: "Customer is also the participant",
  participantName: "Participant name",
  participantPhone: "Participant phone",
  participantEmail: "Participant email",
  separateParticipants: "Fill in a different participant for each item",
  payment: "Payment",
  checkout: "Checkout",
  agreeTerms: "I agree with the terms and conditions",
  termsLinkText: "terms and conditions",
  payNow: "Continue to payment",
  total: "Total",
  price: "Price",
  inclTaxes: "Including VAT and fees",
  changeCurrency: "Change currency",
  chooseCurrency: "Choose payment currency",
  currencyExplanation: "We set our own exchange rates — we aim to keep them fairer for both you and us than the card-conversion rate your bank would apply. Compare the order total in each currency below and pick the one matching your bank account.",
  currencyColumnCurrency: "Currency",
  currencyColumnRate: "Our rate",
  book: "Book",
  book_button: "Book",
  bookNow: "Book now",
  validationRequired: "This field is required.",
  validationMinValue: "Minimum value is {min}.",
  validationMaxValue: "Maximum value is {max}.",
  validationMinLength: "Minimum length is {min} characters.",
  validationMaxLength: "Maximum length is {max} characters.",
  validationInvalidFormat: "Invalid format.",
  validationCustomLocationDetails: "Please fill in custom location details.",
  counterDecrement: "Decrement",
  counterIncrement: "Increment",
  commodityDetailTitle: "Commodity Detail",
  loading: "Loading...",
  noData: "No data available.",
  errorPrefix: "Error: ",
  retry: "Try again",
  errorNetwork: "Couldn't reach the server. Check your connection and try again.",
  errorNotFound: "The requested content could not be found.",
  errorCommodityNotFound: 'Commodity "{commodity}" was not found.',
  errorServer: "The service is temporarily unavailable. Please try again shortly.",
  errorGeneric: "Something went wrong while loading.",
  errorDetails: "Technical details",
  errorLeadTimeTooShort: `We're sorry, it's too late to book "{commodity}" for {datetime} online — this booking requires at least {duration} notice. Please contact us directly and we'll do our best to help.`,
  errorPriceBlocked: `We're sorry, one of the items selected for "{commodity}" is no longer available on {date}. Please remove it from your basket or choose another date.`,
  reviewsTitle: "Customer reviews",
  reviewsEmpty: "No reviews yet.",
  reviewsAverage: "Average rating",
  reviewsBasedOn: "Based on {count} reviews",
  reviewsRecommend: "{percent}% would recommend",
  reviewsRecommendOf: "{percent}% of {total} guests would recommend",
  reviewsWouldRecommend: "would recommend",
  reviewsRecommends: "Recommends",
  reviewsDoesNotRecommend: "Does not recommend",
  reviewsBreakdown: "Rating breakdown",
  reviewsOverall: "Overall",
  reviewsAnonymous: "Guest",
  reviewsShowMore: "Show more",
  reviewsResponse: "Response from the host",
  reviewsResponseBy: "Response from {author}",
  reviewsAverageHelp: "Average of {rated} star ratings left by customers after a completed booking ({from} – {to}). Only published reviews are counted; the figure updates with the filters below.",
  reviewsRecommendHelp: 'Share of the {total} guests who answered the "would you recommend" question and said yes. Counted only from published reviews of completed bookings.',
  reviewsFilterLanguage: "Language",
  reviewsFilterPeriod: "Period",
  reviewsFilterRating: "Rating",
  reviewsFilterCommodity: "Service",
  reviewsFilterAll: "All",
  reviewsPeriodAll: "All time",
  reviewsPeriodMonths: "Last {months} months",
  reviewsRatingMin: "{count}★ & up"
};
function Le(e, t) {
  return e.replace(/\{(\w+)\}/g, (n, o) => t[o] != null ? String(t[o]) : `{${o}}`);
}
const $t = Symbol("mancub:widget-labels"), mx = ["for"], fx = ["for"], gx = /* @__PURE__ */ se({
  __name: "StringField",
  props: {
    fieldName: {},
    fieldTitle: { default: () => {
    } },
    fieldSubtitle: { default: () => {
    } },
    formKey: { default: () => {
    } },
    initialValue: { type: [Boolean, String, Number, null, Object], default: () => {
    } },
    required: { type: Boolean },
    config: { default: () => ({}) }
  },
  setup(e) {
    const t = W(null), n = ce($t, v(() => Re)), o = v({
      get: () => u.value === ye ? "" : u.value,
      set: (p) => {
        u.value = p;
      }
    }), i = v(() => e.config?.widget === "opt_in_textarea"), r = W(""), a = v({
      get: () => u.value !== ye,
      set: (p) => {
        p ? u.value = r.value : (r.value = u.value === ye ? "" : u.value, u.value = ye);
      }
    }), d = () => {
      const p = [];
      if (e.required && p.push((f) => f === ye || !f || !f.trim() ? n.value.validationRequired : !0), e.config?.min_length != null) {
        const f = e.config.min_length;
        p.push((b) => b === ye || !b ? !0 : b.length >= f || Le(n.value.validationMinLength, { min: f }));
      }
      if (e.config?.max_length != null) {
        const f = e.config.max_length;
        p.push((b) => b === ye || !b ? !0 : b.length <= f || Le(n.value.validationMaxLength, { max: f }));
      }
      if (e.config?.regex) {
        let f = null;
        try {
          f = new RegExp(e.config.regex);
        } catch {
          f = null;
        }
        if (f) {
          const b = f;
          p.push((k) => k === ye || !k ? !0 : b.test(k) || n.value.validationInvalidFormat);
        }
      }
      return p;
    }, {
      id: l,
      model: u,
      isVisible: s,
      errors: c
    } = Sn(v(() => t.value?.$el), e.fieldName, e.initialValue, e.formKey, d(), e.config);
    return (p, f) => {
      const b = Qr, k = Et, T = Ft;
      return z(s) ? (m(), j(Rt, {
        key: 0,
        ref_key: "containerRef",
        ref: t
      }, ht({
        title: U(() => [
          L(an, {
            "for-id": z(l),
            title: p.fieldTitle || p.fieldName,
            subtitle: p.fieldSubtitle,
            required: p.required
          }, null, 8, ["for-id", "title", "subtitle", "required"])
        ]),
        default: U(() => [
          i.value ? (m(), h("div", {
            key: 0,
            class: ee(["flex items-center gap-2", { "mb-2": a.value }])
          }, [
            L(z(Go), {
              modelValue: a.value,
              "onUpdate:modelValue": f[0] || (f[0] = ($) => a.value = $),
              "input-id": `${z(l)}-opt-in`,
              size: "large",
              binary: ""
            }, null, 8, ["modelValue", "input-id"]),
            g("label", {
              for: `${z(l)}-opt-in`,
              class: "text-sm text-gray-700 cursor-pointer"
            }, y(p.config?.label || p.fieldTitle || p.fieldName), 9, mx)
          ], 2)) : p.config?.label ? (m(), h("label", {
            key: 1,
            for: z(l),
            class: "block text-sm text-gray-700 mb-1"
          }, y(p.config.label), 9, fx)) : B("", !0),
          p.config?.widget === "textarea" || i.value && a.value ? (m(), j(b, {
            key: 2,
            id: z(l),
            modelValue: o.value,
            "onUpdate:modelValue": f[1] || (f[1] = ($) => o.value = $),
            rows: "5",
            cols: "50",
            type: "text",
            name: p.fieldName,
            required: p.required,
            class: "relative w-full rounded-lg bg-white py-2 pl-3 pr-10 text-left shadow-md focus:outline-none focus-visible:border-indigo-500 focus-visible:ring-2 focus-visible:ring-white/75 focus-visible:ring-offset-2 focus-visible:ring-offset-orange-300 sm:text-sm"
          }, null, 8, ["id", "modelValue", "name", "required"])) : i.value ? B("", !0) : (m(), j(k, {
            key: 3,
            id: z(l),
            modelValue: o.value,
            "onUpdate:modelValue": f[2] || (f[2] = ($) => o.value = $),
            type: "text",
            name: p.fieldName,
            required: p.required,
            class: "relative w-full rounded-lg bg-white py-2 pl-3 pr-10 text-left shadow-md focus:outline-none focus-visible:border-indigo-500 focus-visible:ring-2 focus-visible:ring-white/75 focus-visible:ring-offset-2 focus-visible:ring-offset-orange-300 sm:text-sm"
          }, null, 8, ["id", "modelValue", "name", "required"]))
        ]),
        _: 2
      }, [
        z(c).length ? {
          name: "errors",
          fn: U(() => [
            (m(!0), h(Y, null, he(z(c), ($, S) => (m(), j(T, {
              key: S,
              severity: "error",
              size: "small",
              variant: "simple"
            }, {
              default: U(() => [
                q(y($.toString()), 1)
              ]),
              _: 2
            }, 1024))), 128))
          ]),
          key: "0"
        } : void 0
      ]), 1536)) : B("", !0);
    };
  }
});
var Pl = {
  name: "AngleDownIcon",
  extends: Ue
};
function hx(e) {
  return kx(e) || yx(e) || vx(e) || bx();
}
function bx() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function vx(e, t) {
  if (e) {
    if (typeof e == "string") return zr(e, t);
    var n = {}.toString.call(e).slice(8, -1);
    return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? zr(e, t) : void 0;
  }
}
function yx(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function kx(e) {
  if (Array.isArray(e)) return zr(e);
}
function zr(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, o = Array(t); n < t; n++) o[n] = e[n];
  return o;
}
function wx(e, t, n, o, i, r) {
  return m(), h("svg", x({
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.pti()), hx(t[0] || (t[0] = [g("path", {
    d: "M3.58659 4.5007C3.68513 4.50023 3.78277 4.51945 3.87379 4.55723C3.9648 4.59501 4.04735 4.65058 4.11659 4.7207L7.11659 7.7207L10.1166 4.7207C10.2619 4.65055 10.4259 4.62911 10.5843 4.65956C10.7427 4.69002 10.8871 4.77074 10.996 4.88976C11.1049 5.00877 11.1726 5.15973 11.1889 5.32022C11.2052 5.48072 11.1693 5.6422 11.0866 5.7807L7.58659 9.2807C7.44597 9.42115 7.25534 9.50004 7.05659 9.50004C6.85784 9.50004 6.66722 9.42115 6.52659 9.2807L3.02659 5.7807C2.88614 5.64007 2.80725 5.44945 2.80725 5.2507C2.80725 5.05195 2.88614 4.86132 3.02659 4.7207C3.09932 4.64685 3.18675 4.58911 3.28322 4.55121C3.37969 4.51331 3.48305 4.4961 3.58659 4.5007Z",
    fill: "currentColor"
  }, null, -1)])), 16);
}
Pl.render = wx;
var zl = {
  name: "AngleUpIcon",
  extends: Ue
};
function xx(e) {
  return Bx(e) || $x(e) || Sx(e) || Cx();
}
function Cx() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Sx(e, t) {
  if (e) {
    if (typeof e == "string") return Lr(e, t);
    var n = {}.toString.call(e).slice(8, -1);
    return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Lr(e, t) : void 0;
  }
}
function $x(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function Bx(e) {
  if (Array.isArray(e)) return Lr(e);
}
function Lr(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, o = Array(t); n < t; n++) o[n] = e[n];
  return o;
}
function Tx(e, t, n, o, i, r) {
  return m(), h("svg", x({
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.pti()), xx(t[0] || (t[0] = [g("path", {
    d: "M10.4134 9.49931C10.3148 9.49977 10.2172 9.48055 10.1262 9.44278C10.0352 9.405 9.95263 9.34942 9.88338 9.27931L6.88338 6.27931L3.88338 9.27931C3.73811 9.34946 3.57409 9.3709 3.41567 9.34044C3.25724 9.30999 3.11286 9.22926 3.00395 9.11025C2.89504 8.99124 2.82741 8.84028 2.8111 8.67978C2.79478 8.51928 2.83065 8.35781 2.91338 8.21931L6.41338 4.71931C6.55401 4.57886 6.74463 4.49997 6.94338 4.49997C7.14213 4.49997 7.33276 4.57886 7.47338 4.71931L10.9734 8.21931C11.1138 8.35994 11.1927 8.55056 11.1927 8.74931C11.1927 8.94806 11.1138 9.13868 10.9734 9.27931C10.9007 9.35315 10.8132 9.41089 10.7168 9.44879C10.6203 9.48669 10.5169 9.5039 10.4134 9.49931Z",
    fill: "currentColor"
  }, null, -1)])), 16);
}
zl.render = Tx;
var Ix = `
    .p-inputnumber {
        display: inline-flex;
        position: relative;
    }

    .p-inputnumber-button {
        display: flex;
        align-items: center;
        justify-content: center;
        flex: 0 0 auto;
        cursor: pointer;
        background: dt('inputnumber.button.background');
        color: dt('inputnumber.button.color');
        width: dt('inputnumber.button.width');
        transition:
            background dt('inputnumber.transition.duration'),
            color dt('inputnumber.transition.duration'),
            border-color dt('inputnumber.transition.duration'),
            outline-color dt('inputnumber.transition.duration');
    }

    .p-inputnumber-button:disabled {
        cursor: auto;
    }

    .p-inputnumber-button:not(:disabled):hover {
        background: dt('inputnumber.button.hover.background');
        color: dt('inputnumber.button.hover.color');
    }

    .p-inputnumber-button:not(:disabled):active {
        background: dt('inputnumber.button.active.background');
        color: dt('inputnumber.button.active.color');
    }

    .p-inputnumber-stacked .p-inputnumber-button {
        position: relative;
        flex: 1 1 auto;
        border: 0 none;
    }

    .p-inputnumber-stacked .p-inputnumber-button-group {
        display: flex;
        flex-direction: column;
        position: absolute;
        inset-block-start: 1px;
        inset-inline-end: 1px;
        height: calc(100% - 2px);
        z-index: 1;
    }

    .p-inputnumber-stacked .p-inputnumber-increment-button {
        padding: 0;
        border-start-end-radius: calc(dt('inputnumber.button.border.radius') - 1px);
    }

    .p-inputnumber-stacked .p-inputnumber-decrement-button {
        padding: 0;
        border-end-end-radius: calc(dt('inputnumber.button.border.radius') - 1px);
    }

    .p-inputnumber-horizontal .p-inputnumber-button {
        border: 1px solid dt('inputnumber.button.border.color');
    }

    .p-inputnumber-horizontal .p-inputnumber-button:hover {
        border-color: dt('inputnumber.button.hover.border.color');
    }

    .p-inputnumber-horizontal .p-inputnumber-button:active {
        border-color: dt('inputnumber.button.active.border.color');
    }

    .p-inputnumber-horizontal .p-inputnumber-increment-button {
        order: 3;
        border-start-end-radius: dt('inputnumber.button.border.radius');
        border-end-end-radius: dt('inputnumber.button.border.radius');
        border-inline-start: 0 none;
    }

    .p-inputnumber-horizontal .p-inputnumber-input {
        order: 2;
        border-radius: 0;
    }

    .p-inputnumber-horizontal .p-inputnumber-decrement-button {
        order: 1;
        border-start-start-radius: dt('inputnumber.button.border.radius');
        border-end-start-radius: dt('inputnumber.button.border.radius');
        border-inline-end: 0 none;
    }

    .p-floatlabel:has(.p-inputnumber-horizontal) label {
        margin-inline-start: dt('inputnumber.button.width');
    }

    .p-inputnumber-vertical {
        flex-direction: column;
    }

    .p-inputnumber-vertical .p-inputnumber-button {
        border: 1px solid dt('inputnumber.button.border.color');
        padding: dt('inputnumber.button.vertical.padding');
    }

    .p-inputnumber-vertical .p-inputnumber-button:hover {
        border-color: dt('inputnumber.button.hover.border.color');
    }

    .p-inputnumber-vertical .p-inputnumber-button:active {
        border-color: dt('inputnumber.button.active.border.color');
    }

    .p-inputnumber-vertical .p-inputnumber-increment-button {
        order: 1;
        border-start-start-radius: dt('inputnumber.button.border.radius');
        border-start-end-radius: dt('inputnumber.button.border.radius');
        width: 100%;
        border-block-end: 0 none;
    }

    .p-inputnumber-vertical .p-inputnumber-input {
        order: 2;
        border-radius: 0;
        text-align: center;
    }

    .p-inputnumber-vertical .p-inputnumber-decrement-button {
        order: 3;
        border-end-start-radius: dt('inputnumber.button.border.radius');
        border-end-end-radius: dt('inputnumber.button.border.radius');
        width: 100%;
        border-block-start: 0 none;
    }

    .p-inputnumber-input {
        flex: 1 1 auto;
    }

    .p-inputnumber-fluid {
        width: 100%;
    }

    .p-inputnumber-fluid .p-inputnumber-input {
        width: 1%;
    }

    .p-inputnumber-fluid.p-inputnumber-vertical .p-inputnumber-input {
        width: 100%;
    }

    .p-inputnumber:has(.p-inputtext-sm) .p-inputnumber-button .p-icon {
        font-size: dt('form.field.sm.font.size');
        width: dt('form.field.sm.font.size');
        height: dt('form.field.sm.font.size');
    }

    .p-inputnumber:has(.p-inputtext-lg) .p-inputnumber-button .p-icon {
        font-size: dt('form.field.lg.font.size');
        width: dt('form.field.lg.font.size');
        height: dt('form.field.lg.font.size');
    }

    .p-inputnumber-clear-icon {
        position: absolute;
        top: 50%;
        margin-top: -0.5rem;
        cursor: pointer;
        inset-inline-end: dt('form.field.padding.x');
        color: dt('form.field.icon.color');
    }

    .p-inputnumber-stacked .p-inputnumber-clear-icon, 
    .p-inputnumber-horizontal .p-inputnumber-clear-icon {
        inset-inline-end: calc(dt('inputnumber.button.width') + dt('form.field.padding.x'));
    }
`, Dx = {
  root: function(t) {
    var n = t.instance, o = t.props;
    return ["p-inputnumber p-component p-inputwrapper", {
      "p-invalid": n.$invalid,
      "p-inputwrapper-filled": n.$filled || o.allowEmpty === !1,
      "p-inputwrapper-focus": n.focused,
      "p-inputnumber-stacked": o.showButtons && o.buttonLayout === "stacked",
      "p-inputnumber-horizontal": o.showButtons && o.buttonLayout === "horizontal",
      "p-inputnumber-vertical": o.showButtons && o.buttonLayout === "vertical",
      "p-inputnumber-fluid": n.$fluid
    }];
  },
  pcInputText: "p-inputnumber-input",
  buttonGroup: "p-inputnumber-button-group",
  incrementButton: function(t) {
    var n = t.instance, o = t.props;
    return ["p-inputnumber-button p-inputnumber-increment-button", {
      "p-disabled": o.showButtons && o.max !== null && n.maxBoundry()
    }];
  },
  decrementButton: function(t) {
    var n = t.instance, o = t.props;
    return ["p-inputnumber-button p-inputnumber-decrement-button", {
      "p-disabled": o.showButtons && o.min !== null && n.minBoundry()
    }];
  }
}, Px = oe.extend({
  name: "inputnumber",
  style: Ix,
  classes: Dx
}), zx = {
  name: "BaseInputNumber",
  extends: on,
  props: {
    format: {
      type: Boolean,
      default: !0
    },
    showButtons: {
      type: Boolean,
      default: !1
    },
    buttonLayout: {
      type: String,
      default: "stacked"
    },
    incrementButtonClass: {
      type: String,
      default: null
    },
    decrementButtonClass: {
      type: String,
      default: null
    },
    incrementButtonIcon: {
      type: String,
      default: void 0
    },
    incrementIcon: {
      type: String,
      default: void 0
    },
    decrementButtonIcon: {
      type: String,
      default: void 0
    },
    decrementIcon: {
      type: String,
      default: void 0
    },
    locale: {
      type: String,
      default: void 0
    },
    localeMatcher: {
      type: String,
      default: void 0
    },
    mode: {
      type: String,
      default: "decimal"
    },
    prefix: {
      type: String,
      default: null
    },
    suffix: {
      type: String,
      default: null
    },
    currency: {
      type: String,
      default: void 0
    },
    currencyDisplay: {
      type: String,
      default: void 0
    },
    useGrouping: {
      type: Boolean,
      default: !0
    },
    minFractionDigits: {
      type: Number,
      default: void 0
    },
    maxFractionDigits: {
      type: Number,
      default: void 0
    },
    roundingMode: {
      type: String,
      default: "halfExpand",
      validator: function(t) {
        return ["ceil", "floor", "expand", "trunc", "halfCeil", "halfFloor", "halfExpand", "halfTrunc", "halfEven"].includes(t);
      }
    },
    min: {
      type: Number,
      default: null
    },
    max: {
      type: Number,
      default: null
    },
    step: {
      type: Number,
      default: 1
    },
    allowEmpty: {
      type: Boolean,
      default: !0
    },
    highlightOnFocus: {
      type: Boolean,
      default: !1
    },
    readonly: {
      type: Boolean,
      default: !1
    },
    placeholder: {
      type: String,
      default: null
    },
    inputId: {
      type: String,
      default: null
    },
    inputClass: {
      type: [String, Object],
      default: null
    },
    inputStyle: {
      type: Object,
      default: null
    },
    ariaLabelledby: {
      type: String,
      default: null
    },
    ariaLabel: {
      type: String,
      default: null
    },
    required: {
      type: Boolean,
      default: !1
    }
  },
  style: Px,
  provide: function() {
    return {
      $pcInputNumber: this,
      $parentInstance: this
    };
  }
};
function ro(e) {
  "@babel/helpers - typeof";
  return ro = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ro(e);
}
function da(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    t && (o = o.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, o);
  }
  return n;
}
function ua(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? da(Object(n), !0).forEach(function(o) {
      Or(e, o, n[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : da(Object(n)).forEach(function(o) {
      Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(n, o));
    });
  }
  return e;
}
function Or(e, t, n) {
  return (t = Lx(t)) in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Lx(e) {
  var t = Ox(e, "string");
  return ro(t) == "symbol" ? t : t + "";
}
function Ox(e, t) {
  if (ro(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var o = n.call(e, t);
    if (ro(o) != "object") return o;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Mx(e) {
  return Ex(e) || Fx(e) || _x(e) || Ax();
}
function Ax() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _x(e, t) {
  if (e) {
    if (typeof e == "string") return Mr(e, t);
    var n = {}.toString.call(e).slice(8, -1);
    return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Mr(e, t) : void 0;
  }
}
function Fx(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function Ex(e) {
  if (Array.isArray(e)) return Mr(e);
}
function Mr(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, o = Array(t); n < t; n++) o[n] = e[n];
  return o;
}
var Ll = {
  name: "InputNumber",
  extends: zx,
  inheritAttrs: !1,
  emits: ["input", "focus", "blur"],
  inject: {
    $pcFluid: {
      default: null
    }
  },
  numberFormat: null,
  _numeral: null,
  _decimal: null,
  _group: null,
  _minusSign: null,
  _currency: null,
  _suffix: null,
  _prefix: null,
  _index: null,
  groupChar: "",
  isSpecialChar: null,
  prefixChar: null,
  suffixChar: null,
  timer: null,
  data: function() {
    return {
      // @deprecated
      d_modelValue: this.d_value,
      focused: !1
    };
  },
  watch: {
    d_value: function(t) {
      this.d_modelValue = t;
    },
    locale: function(t, n) {
      this.updateConstructParser(t, n);
    },
    localeMatcher: function(t, n) {
      this.updateConstructParser(t, n);
    },
    mode: function(t, n) {
      this.updateConstructParser(t, n);
    },
    currency: function(t, n) {
      this.updateConstructParser(t, n);
    },
    currencyDisplay: function(t, n) {
      this.updateConstructParser(t, n);
    },
    useGrouping: function(t, n) {
      this.updateConstructParser(t, n);
    },
    minFractionDigits: function(t, n) {
      this.updateConstructParser(t, n);
    },
    maxFractionDigits: function(t, n) {
      this.updateConstructParser(t, n);
    },
    suffix: function(t, n) {
      this.updateConstructParser(t, n);
    },
    prefix: function(t, n) {
      this.updateConstructParser(t, n);
    }
  },
  created: function() {
    this.constructParser();
  },
  methods: {
    getOptions: function() {
      return {
        localeMatcher: this.localeMatcher,
        style: this.mode,
        currency: this.currency,
        currencyDisplay: this.currencyDisplay,
        useGrouping: this.useGrouping,
        minimumFractionDigits: this.minFractionDigits,
        maximumFractionDigits: this.maxFractionDigits,
        roundingMode: this.roundingMode
      };
    },
    constructParser: function() {
      this.numberFormat = new Intl.NumberFormat(this.locale, this.getOptions());
      var t = Mx(new Intl.NumberFormat(this.locale, {
        useGrouping: !1
      }).format(9876543210)).reverse(), n = new Map(t.map(function(o, i) {
        return [o, i];
      }));
      this._numeral = new RegExp("[".concat(t.join(""), "]"), "g"), this._group = this.getGroupingExpression(), this._minusSign = this.getMinusSignExpression(), this._currency = this.getCurrencyExpression(), this._decimal = this.getDecimalExpression(), this._suffix = this.getSuffixExpression(), this._prefix = this.getPrefixExpression(), this._index = function(o) {
        return n.get(o);
      };
    },
    updateConstructParser: function(t, n) {
      t !== n && this.constructParser();
    },
    escapeRegExp: function(t) {
      return t.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
    },
    getDecimalExpression: function() {
      var t = new Intl.NumberFormat(this.locale, ua(ua({}, this.getOptions()), {}, {
        useGrouping: !1
      }));
      return new RegExp("[".concat(t.format(1.1).replace(this._currency, "").trim().replace(this._numeral, ""), "]"), "g");
    },
    getGroupingExpression: function() {
      var t = new Intl.NumberFormat(this.locale, {
        useGrouping: !0
      });
      return this.groupChar = t.format(1e6).trim().replace(this._numeral, "").charAt(0), new RegExp("[".concat(this.groupChar, "]"), "g");
    },
    getMinusSignExpression: function() {
      var t = new Intl.NumberFormat(this.locale, {
        useGrouping: !1
      });
      return new RegExp("[".concat(t.format(-1).trim().replace(this._numeral, ""), "]"), "g");
    },
    getCurrencyExpression: function() {
      if (this.currency) {
        var t = new Intl.NumberFormat(this.locale, {
          style: "currency",
          currency: this.currency,
          currencyDisplay: this.currencyDisplay,
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
          roundingMode: this.roundingMode
        });
        return new RegExp("[".concat(t.format(1).replace(/\s/g, "").replace(this._numeral, "").replace(this._group, ""), "]"), "g");
      }
      return new RegExp("[]", "g");
    },
    getPrefixExpression: function() {
      if (this.prefix)
        this.prefixChar = this.prefix;
      else {
        var t = new Intl.NumberFormat(this.locale, {
          style: this.mode,
          currency: this.currency,
          currencyDisplay: this.currencyDisplay
        });
        this.prefixChar = t.format(1).split("1")[0];
      }
      return new RegExp("".concat(this.escapeRegExp(this.prefixChar || "")), "g");
    },
    getSuffixExpression: function() {
      if (this.suffix)
        this.suffixChar = this.suffix;
      else {
        var t = new Intl.NumberFormat(this.locale, {
          style: this.mode,
          currency: this.currency,
          currencyDisplay: this.currencyDisplay,
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
          roundingMode: this.roundingMode
        });
        this.suffixChar = t.format(1).split("1")[1];
      }
      return new RegExp("".concat(this.escapeRegExp(this.suffixChar || "")), "g");
    },
    formatValue: function(t) {
      if (t != null) {
        if (t === "-")
          return t;
        if (this.format) {
          var n = new Intl.NumberFormat(this.locale, this.getOptions()), o = n.format(t);
          return this.prefix && (o = this.prefix + o), this.suffix && (o = o + this.suffix), o;
        }
        return t.toString();
      }
      return "";
    },
    parseValue: function(t) {
      var n = t.replace(this._suffix, "").replace(this._prefix, "").trim().replace(/\s/g, "").replace(this._currency, "").replace(this._group, "").replace(this._minusSign, "-").replace(this._decimal, ".").replace(this._numeral, this._index);
      if (n) {
        if (n === "-")
          return n;
        var o = +n;
        return isNaN(o) ? null : o;
      }
      return null;
    },
    repeat: function(t, n, o) {
      var i = this;
      if (!this.readonly) {
        var r = n || 500;
        this.clearTimer(), this.timer = setTimeout(function() {
          i.repeat(t, 40, o);
        }, r), this.spin(t, o);
      }
    },
    addWithPrecision: function(t, n) {
      var o = t.toString(), i = n.toString(), r = o.includes(".") ? o.split(".")[1].length : 0, a = i.includes(".") ? i.split(".")[1].length : 0, d = Math.max(r, a), l = Math.pow(10, d);
      return Math.round((t + n) * l) / l;
    },
    spin: function(t, n) {
      if (this.$refs.input) {
        var o = this.step * n, i = this.parseValue(this.$refs.input.$el.value) || 0, r = this.validateValue(this.addWithPrecision(i, o));
        this.updateInput(r, null, "spin"), this.updateModel(t, r), this.handleOnInput(t, i, r);
      }
    },
    onUpButtonMouseDown: function(t) {
      this.disabled || (this.$refs.input.$el.focus(), this.repeat(t, null, 1), t.preventDefault());
    },
    onUpButtonMouseUp: function() {
      this.disabled || this.clearTimer();
    },
    onUpButtonMouseLeave: function() {
      this.disabled || this.clearTimer();
    },
    onUpButtonKeyUp: function() {
      this.disabled || this.clearTimer();
    },
    onUpButtonKeyDown: function(t) {
      (t.code === "Space" || t.code === "Enter" || t.code === "NumpadEnter") && this.repeat(t, null, 1);
    },
    onDownButtonMouseDown: function(t) {
      this.disabled || (this.$refs.input.$el.focus(), this.repeat(t, null, -1), t.preventDefault());
    },
    onDownButtonMouseUp: function() {
      this.disabled || this.clearTimer();
    },
    onDownButtonMouseLeave: function() {
      this.disabled || this.clearTimer();
    },
    onDownButtonKeyUp: function() {
      this.disabled || this.clearTimer();
    },
    onDownButtonKeyDown: function(t) {
      (t.code === "Space" || t.code === "Enter" || t.code === "NumpadEnter") && this.repeat(t, null, -1);
    },
    onUserInput: function() {
      this.isSpecialChar && (this.$refs.input.$el.value = this.lastValue), this.isSpecialChar = !1;
    },
    onInputKeyDown: function(t) {
      if (!this.readonly && !t.isComposing) {
        if (t.altKey || t.ctrlKey || t.metaKey) {
          this.isSpecialChar = !0, this.lastValue = this.$refs.input.$el.value;
          return;
        }
        this.lastValue = t.target.value;
        var n = t.target.selectionStart, o = t.target.selectionEnd, i = o - n, r = t.target.value, a = null, d = t.code || t.key;
        switch (d) {
          case "ArrowUp":
            this.spin(t, 1), t.preventDefault();
            break;
          case "ArrowDown":
            this.spin(t, -1), t.preventDefault();
            break;
          case "ArrowLeft":
            if (i > 1) {
              var l = this.isNumeralChar(r.charAt(n)) ? n + 1 : n + 2;
              this.$refs.input.$el.setSelectionRange(l, l);
            } else this.isNumeralChar(r.charAt(n - 1)) || t.preventDefault();
            break;
          case "ArrowRight":
            if (i > 1) {
              var u = o - 1;
              this.$refs.input.$el.setSelectionRange(u, u);
            } else this.isNumeralChar(r.charAt(n)) || t.preventDefault();
            break;
          case "Tab":
          case "Enter":
          case "NumpadEnter":
            a = this.validateValue(this.parseValue(r)), this.$refs.input.$el.value = this.formatValue(a), this.$refs.input.$el.setAttribute("aria-valuenow", a), this.updateModel(t, a);
            break;
          case "Backspace": {
            if (t.preventDefault(), n === o) {
              n >= r.length && this.suffixChar !== null && (n = r.length - this.suffixChar.length, this.$refs.input.$el.setSelectionRange(n, n));
              var s = r.charAt(n - 1), c = this.getDecimalCharIndexes(r), p = c.decimalCharIndex, f = c.decimalCharIndexWithoutPrefix;
              if (this.isNumeralChar(s)) {
                var b = this.getDecimalLength(r);
                if (this._group.test(s))
                  this._group.lastIndex = 0, a = r.slice(0, n - 2) + r.slice(n - 1);
                else if (this._decimal.test(s))
                  this._decimal.lastIndex = 0, b ? this.$refs.input.$el.setSelectionRange(n - 1, n - 1) : a = r.slice(0, n - 1) + r.slice(n);
                else if (p > 0 && n > p) {
                  var k = this.isDecimalMode() && (this.minFractionDigits || 0) < b ? "" : "0";
                  a = r.slice(0, n - 1) + k + r.slice(n);
                } else f === 1 ? (a = r.slice(0, n - 1) + "0" + r.slice(n), a = this.parseValue(a) > 0 ? a : "") : a = r.slice(0, n - 1) + r.slice(n);
              }
              this.updateValue(t, a, null, "delete-single");
            } else
              a = this.deleteRange(r, n, o), this.updateValue(t, a, null, "delete-range");
            break;
          }
          case "Delete":
            if (t.preventDefault(), n === o) {
              var T = r.charAt(n), $ = this.getDecimalCharIndexes(r), S = $.decimalCharIndex, O = $.decimalCharIndexWithoutPrefix;
              if (this.isNumeralChar(T)) {
                var w = this.getDecimalLength(r);
                if (this._group.test(T))
                  this._group.lastIndex = 0, a = r.slice(0, n) + r.slice(n + 2);
                else if (this._decimal.test(T))
                  this._decimal.lastIndex = 0, w ? this.$refs.input.$el.setSelectionRange(n + 1, n + 1) : a = r.slice(0, n) + r.slice(n + 1);
                else if (S > 0 && n > S) {
                  var F = this.isDecimalMode() && (this.minFractionDigits || 0) < w ? "" : "0";
                  a = r.slice(0, n) + F + r.slice(n + 1);
                } else O === 1 ? (a = r.slice(0, n) + "0" + r.slice(n + 1), a = this.parseValue(a) > 0 ? a : "") : a = r.slice(0, n) + r.slice(n + 1);
              }
              this.updateValue(t, a, null, "delete-back-single");
            } else
              a = this.deleteRange(r, n, o), this.updateValue(t, a, null, "delete-range");
            break;
          case "Home":
            t.preventDefault(), le(this.min) && this.updateModel(t, this.min);
            break;
          case "End":
            t.preventDefault(), le(this.max) && this.updateModel(t, this.max);
            break;
        }
      }
    },
    onInputKeyPress: function(t) {
      if (!this.readonly) {
        var n = t.key, o = this.isDecimalSign(n), i = this.isMinusSign(n);
        t.code !== "Enter" && t.preventDefault(), (Number(n) >= 0 && Number(n) <= 9 || i || o) && this.insert(t, n, {
          isDecimalSign: o,
          isMinusSign: i
        });
      }
    },
    onPaste: function(t) {
      if (!this.readonly) {
        t.preventDefault();
        var n = (t.clipboardData || window.clipboardData).getData("Text");
        if (n) {
          var o = this.parseValue(n);
          o != null && this.insert(t, o.toString());
        }
      }
    },
    allowMinusSign: function() {
      return this.min === null || this.min < 0;
    },
    isMinusSign: function(t) {
      return this._minusSign.test(t) || t === "-" ? (this._minusSign.lastIndex = 0, !0) : !1;
    },
    isDecimalSign: function(t) {
      var n;
      return (n = this.locale) !== null && n !== void 0 && n.includes("fr") && [".", ","].includes(t) || this._decimal.test(t) ? (this._decimal.lastIndex = 0, !0) : !1;
    },
    isDecimalMode: function() {
      return this.mode === "decimal";
    },
    getDecimalCharIndexes: function(t) {
      var n = t.search(this._decimal);
      this._decimal.lastIndex = 0;
      var o = t.replace(this._prefix, "").trim().replace(/\s/g, "").replace(this._currency, ""), i = o.search(this._decimal);
      return this._decimal.lastIndex = 0, {
        decimalCharIndex: n,
        decimalCharIndexWithoutPrefix: i
      };
    },
    getCharIndexes: function(t) {
      var n = t.search(this._decimal);
      this._decimal.lastIndex = 0;
      var o = t.search(this._minusSign);
      this._minusSign.lastIndex = 0;
      var i = t.search(this._suffix);
      this._suffix.lastIndex = 0;
      var r = t.search(this._currency);
      return this._currency.lastIndex = 0, {
        decimalCharIndex: n,
        minusCharIndex: o,
        suffixCharIndex: i,
        currencyCharIndex: r
      };
    },
    insert: function(t, n) {
      var o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
        isDecimalSign: !1,
        isMinusSign: !1
      }, i = n.search(this._minusSign);
      if (this._minusSign.lastIndex = 0, !(!this.allowMinusSign() && i !== -1)) {
        var r = this.$refs.input.$el.selectionStart, a = this.$refs.input.$el.selectionEnd, d = this.$refs.input.$el.value.trim(), l = this.getCharIndexes(d), u = l.decimalCharIndex, s = l.minusCharIndex, c = l.suffixCharIndex, p = l.currencyCharIndex, f;
        if (o.isMinusSign) {
          var b = s === -1;
          (r === 0 || r === p + 1) && (f = d, (b || a !== 0) && (f = this.insertText(d, n, 0, a)), this.updateValue(t, f, n, "insert"));
        } else if (o.isDecimalSign)
          u > 0 && r === u ? this.updateValue(t, d, n, "insert") : u > r && u < a ? (f = this.insertText(d, n, r, a), this.updateValue(t, f, n, "insert")) : u === -1 && this.maxFractionDigits && (f = this.insertText(d, n, r, a), this.updateValue(t, f, n, "insert"));
        else {
          var k = this.numberFormat.resolvedOptions().maximumFractionDigits, T = r !== a ? "range-insert" : "insert";
          if (u > 0 && r > u) {
            if (r + n.length - (u + 1) <= k) {
              var $ = p >= r ? p - 1 : c >= r ? c : d.length;
              f = d.slice(0, r) + n + d.slice(r + n.length, $) + d.slice($), this.updateValue(t, f, n, T);
            }
          } else
            f = this.insertText(d, n, r, a), this.updateValue(t, f, n, T);
        }
      }
    },
    insertText: function(t, n, o, i) {
      var r = n === "." ? n : n.split(".");
      if (r.length === 2) {
        var a = t.slice(o, i).search(this._decimal);
        return this._decimal.lastIndex = 0, a > 0 ? t.slice(0, o) + this.formatValue(n) + t.slice(i) : this.formatValue(n) || t;
      } else return i - o === t.length ? this.formatValue(n) : o === 0 ? n + t.slice(i) : i === t.length ? t.slice(0, o) + n : t.slice(0, o) + n + t.slice(i);
    },
    deleteRange: function(t, n, o) {
      var i;
      return o - n === t.length ? i = "" : n === 0 ? i = t.slice(o) : o === t.length ? i = t.slice(0, n) : i = t.slice(0, n) + t.slice(o), i;
    },
    initCursor: function() {
      var t = this.$refs.input.$el.selectionStart, n = this.$refs.input.$el.value, o = n.length, i = null, r = (this.prefixChar || "").length;
      n = n.replace(this._prefix, ""), t = t - r;
      var a = n.charAt(t);
      if (this.isNumeralChar(a))
        return t + r;
      for (var d = t - 1; d >= 0; )
        if (a = n.charAt(d), this.isNumeralChar(a)) {
          i = d + r;
          break;
        } else
          d--;
      if (i !== null)
        this.$refs.input.$el.setSelectionRange(i + 1, i + 1);
      else {
        for (d = t; d < o; )
          if (a = n.charAt(d), this.isNumeralChar(a)) {
            i = d + r;
            break;
          } else
            d++;
        i !== null && this.$refs.input.$el.setSelectionRange(i, i);
      }
      return i || 0;
    },
    onInputClick: function() {
      var t = this.$refs.input.$el.value;
      !this.readonly && t !== bi() && this.initCursor();
    },
    isNumeralChar: function(t) {
      return t.length === 1 && (this._numeral.test(t) || this._decimal.test(t) || this._group.test(t) || this._minusSign.test(t)) ? (this.resetRegex(), !0) : !1;
    },
    resetRegex: function() {
      this._numeral.lastIndex = 0, this._decimal.lastIndex = 0, this._group.lastIndex = 0, this._minusSign.lastIndex = 0;
    },
    updateValue: function(t, n, o, i) {
      var r = this.$refs.input.$el.value, a = null;
      n != null && (a = this.parseValue(n), a = !a && !this.allowEmpty ? 0 : a, this.updateInput(a, o, i, n), this.handleOnInput(t, r, a));
    },
    handleOnInput: function(t, n, o) {
      if (this.isValueChanged(n, o)) {
        var i, r;
        this.$emit("input", {
          originalEvent: t,
          value: o,
          formattedValue: n
        }), (i = (r = this.formField).onInput) === null || i === void 0 || i.call(r, {
          originalEvent: t,
          value: o
        });
      }
    },
    isValueChanged: function(t, n) {
      if (n === null && t !== null)
        return !0;
      if (n != null) {
        var o = typeof t == "string" ? this.parseValue(t) : t;
        return n !== o;
      }
      return !1;
    },
    validateValue: function(t) {
      return t === "-" || t == null ? null : this.min != null && t < this.min ? this.min : this.max != null && t > this.max ? this.max : t;
    },
    updateInput: function(t, n, o, i) {
      n = n || "";
      var r = this.$refs.input.$el.value, a = this.formatValue(t), d = r.length;
      if (a !== i && (a = this.concatValues(a, i)), d === 0) {
        this.$refs.input.$el.value = a, this.$refs.input.$el.setSelectionRange(0, 0);
        var l = this.initCursor(), u = l + n.length;
        this.$refs.input.$el.setSelectionRange(u, u);
      } else {
        var s = this.$refs.input.$el.selectionStart, c = this.$refs.input.$el.selectionEnd;
        this.$refs.input.$el.value = a;
        var p = a.length;
        if (o === "range-insert") {
          var f = this.parseValue((r || "").slice(0, s)), b = f !== null ? f.toString() : "", k = b.split("").join("(".concat(this.groupChar, ")?")), T = new RegExp(k, "g");
          T.test(a);
          var $ = n.split("").join("(".concat(this.groupChar, ")?")), S = new RegExp($, "g");
          S.test(a.slice(T.lastIndex)), c = T.lastIndex + S.lastIndex, this.$refs.input.$el.setSelectionRange(c, c);
        } else if (p === d)
          o === "insert" || o === "delete-back-single" ? this.$refs.input.$el.setSelectionRange(c + 1, c + 1) : o === "delete-single" ? this.$refs.input.$el.setSelectionRange(c - 1, c - 1) : (o === "delete-range" || o === "spin") && this.$refs.input.$el.setSelectionRange(c, c);
        else if (o === "delete-back-single") {
          var O = r.charAt(c - 1), w = r.charAt(c), F = d - p, D = this._group.test(w);
          D && F === 1 ? c += 1 : !D && this.isNumeralChar(O) && (c += -1 * F + 1), this._group.lastIndex = 0, this.$refs.input.$el.setSelectionRange(c, c);
        } else if (r === "-" && o === "insert") {
          this.$refs.input.$el.setSelectionRange(0, 0);
          var C = this.initCursor(), I = C + n.length + 1;
          this.$refs.input.$el.setSelectionRange(I, I);
        } else
          c = c + (p - d), this.$refs.input.$el.setSelectionRange(c, c);
      }
      this.$refs.input.$el.setAttribute("aria-valuenow", t);
    },
    concatValues: function(t, n) {
      if (t && n) {
        var o = n.search(this._decimal);
        return this._decimal.lastIndex = 0, this.suffixChar ? o !== -1 ? t.replace(this.suffixChar, "").split(this._decimal)[0] + n.replace(this.suffixChar, "").slice(o) + this.suffixChar : t : o !== -1 ? t.split(this._decimal)[0] + n.slice(o) : t;
      }
      return t;
    },
    getDecimalLength: function(t) {
      if (t) {
        var n = t.split(this._decimal);
        if (n.length === 2)
          return n[1].replace(this._suffix, "").trim().replace(/\s/g, "").replace(this._currency, "").length;
      }
      return 0;
    },
    updateModel: function(t, n) {
      this.writeValue(n, t);
    },
    onInputFocus: function(t) {
      this.focused = !0, !this.disabled && !this.readonly && this.$refs.input.$el.value !== bi() && this.highlightOnFocus && t.target.select(), this.$emit("focus", t);
    },
    onInputBlur: function(t) {
      var n, o;
      this.focused = !1;
      var i = t.target, r = this.validateValue(this.parseValue(i.value));
      this.$emit("blur", {
        originalEvent: t,
        value: i.value
      }), (n = (o = this.formField).onBlur) === null || n === void 0 || n.call(o, t), i.value = this.formatValue(r), i.setAttribute("aria-valuenow", r), this.updateModel(t, r), !this.disabled && !this.readonly && this.highlightOnFocus && Rs();
    },
    clearTimer: function() {
      this.timer && clearTimeout(this.timer);
    },
    maxBoundry: function() {
      return this.d_value >= this.max;
    },
    minBoundry: function() {
      return this.d_value <= this.min;
    }
  },
  computed: {
    upButtonListeners: function() {
      var t = this;
      return {
        mousedown: function(o) {
          return t.onUpButtonMouseDown(o);
        },
        mouseup: function(o) {
          return t.onUpButtonMouseUp(o);
        },
        mouseleave: function(o) {
          return t.onUpButtonMouseLeave(o);
        },
        keydown: function(o) {
          return t.onUpButtonKeyDown(o);
        },
        keyup: function(o) {
          return t.onUpButtonKeyUp(o);
        }
      };
    },
    downButtonListeners: function() {
      var t = this;
      return {
        mousedown: function(o) {
          return t.onDownButtonMouseDown(o);
        },
        mouseup: function(o) {
          return t.onDownButtonMouseUp(o);
        },
        mouseleave: function(o) {
          return t.onDownButtonMouseLeave(o);
        },
        keydown: function(o) {
          return t.onDownButtonKeyDown(o);
        },
        keyup: function(o) {
          return t.onDownButtonKeyUp(o);
        }
      };
    },
    formattedValue: function() {
      var t = !this.d_value && !this.allowEmpty ? 0 : this.d_value;
      return this.formatValue(t);
    },
    getFormatter: function() {
      return this.numberFormat;
    },
    dataP: function() {
      return Pe(Or(Or({
        invalid: this.$invalid,
        fluid: this.$fluid,
        filled: this.$variant === "filled"
      }, this.size, this.size), this.buttonLayout, this.showButtons && this.buttonLayout));
    }
  },
  components: {
    InputText: Et,
    AngleUpIcon: zl,
    AngleDownIcon: Pl
  }
}, Rx = ["data-p"], Vx = ["data-p"], Nx = ["disabled", "data-p"], jx = ["disabled", "data-p"], Ux = ["disabled", "data-p"], Hx = ["disabled", "data-p"];
function Kx(e, t, n, o, i, r) {
  var a = ze("InputText");
  return m(), h("span", x({
    class: e.cx("root")
  }, e.ptmi("root"), {
    "data-p": r.dataP
  }), [L(a, {
    ref: "input",
    id: e.inputId,
    name: e.$formName,
    role: "spinbutton",
    class: ee([e.cx("pcInputText"), e.inputClass]),
    style: Zt(e.inputStyle),
    defaultValue: r.formattedValue,
    "aria-valuemin": e.min,
    "aria-valuemax": e.max,
    "aria-valuenow": e.d_value,
    inputmode: e.mode === "decimal" && !e.minFractionDigits ? "numeric" : "decimal",
    disabled: e.disabled,
    readonly: e.readonly,
    placeholder: e.placeholder,
    "aria-labelledby": e.ariaLabelledby,
    "aria-label": e.ariaLabel,
    required: e.required,
    size: e.size,
    invalid: e.invalid,
    variant: e.variant,
    onInput: r.onUserInput,
    onKeydown: r.onInputKeyDown,
    onKeypress: r.onInputKeyPress,
    onPaste: r.onPaste,
    onClick: r.onInputClick,
    onFocus: r.onInputFocus,
    onBlur: r.onInputBlur,
    pt: e.ptm("pcInputText"),
    unstyled: e.unstyled,
    "data-p": r.dataP
  }, null, 8, ["id", "name", "class", "style", "defaultValue", "aria-valuemin", "aria-valuemax", "aria-valuenow", "inputmode", "disabled", "readonly", "placeholder", "aria-labelledby", "aria-label", "required", "size", "invalid", "variant", "onInput", "onKeydown", "onKeypress", "onPaste", "onClick", "onFocus", "onBlur", "pt", "unstyled", "data-p"]), e.showButtons && e.buttonLayout === "stacked" ? (m(), h("span", x({
    key: 0,
    class: e.cx("buttonGroup")
  }, e.ptm("buttonGroup"), {
    "data-p": r.dataP
  }), [R(e.$slots, "incrementbutton", {
    listeners: r.upButtonListeners
  }, function() {
    return [g("button", x({
      class: [e.cx("incrementButton"), e.incrementButtonClass]
    }, wo(r.upButtonListeners, !0), {
      disabled: e.disabled,
      tabindex: -1,
      "aria-hidden": "true",
      type: "button"
    }, e.ptm("incrementButton"), {
      "data-p": r.dataP
    }), [R(e.$slots, e.$slots.incrementicon ? "incrementicon" : "incrementbuttonicon", {}, function() {
      return [(m(), j($e(e.incrementIcon || e.incrementButtonIcon ? "span" : "AngleUpIcon"), x({
        class: [e.incrementIcon, e.incrementButtonIcon]
      }, e.ptm("incrementIcon"), {
        "data-pc-section": "incrementicon"
      }), null, 16, ["class"]))];
    })], 16, Nx)];
  }), R(e.$slots, "decrementbutton", {
    listeners: r.downButtonListeners
  }, function() {
    return [g("button", x({
      class: [e.cx("decrementButton"), e.decrementButtonClass]
    }, wo(r.downButtonListeners, !0), {
      disabled: e.disabled,
      tabindex: -1,
      "aria-hidden": "true",
      type: "button"
    }, e.ptm("decrementButton"), {
      "data-p": r.dataP
    }), [R(e.$slots, e.$slots.decrementicon ? "decrementicon" : "decrementbuttonicon", {}, function() {
      return [(m(), j($e(e.decrementIcon || e.decrementButtonIcon ? "span" : "AngleDownIcon"), x({
        class: [e.decrementIcon, e.decrementButtonIcon]
      }, e.ptm("decrementIcon"), {
        "data-pc-section": "decrementicon"
      }), null, 16, ["class"]))];
    })], 16, jx)];
  })], 16, Vx)) : B("", !0), R(e.$slots, "incrementbutton", {
    listeners: r.upButtonListeners
  }, function() {
    return [e.showButtons && e.buttonLayout !== "stacked" ? (m(), h("button", x({
      key: 0,
      class: [e.cx("incrementButton"), e.incrementButtonClass]
    }, wo(r.upButtonListeners, !0), {
      disabled: e.disabled,
      tabindex: -1,
      "aria-hidden": "true",
      type: "button"
    }, e.ptm("incrementButton"), {
      "data-p": r.dataP
    }), [R(e.$slots, e.$slots.incrementicon ? "incrementicon" : "incrementbuttonicon", {}, function() {
      return [(m(), j($e(e.incrementIcon || e.incrementButtonIcon ? "span" : "AngleUpIcon"), x({
        class: [e.incrementIcon, e.incrementButtonIcon]
      }, e.ptm("incrementIcon"), {
        "data-pc-section": "incrementicon"
      }), null, 16, ["class"]))];
    })], 16, Ux)) : B("", !0)];
  }), R(e.$slots, "decrementbutton", {
    listeners: r.downButtonListeners
  }, function() {
    return [e.showButtons && e.buttonLayout !== "stacked" ? (m(), h("button", x({
      key: 0,
      class: [e.cx("decrementButton"), e.decrementButtonClass]
    }, wo(r.downButtonListeners, !0), {
      disabled: e.disabled,
      tabindex: -1,
      "aria-hidden": "true",
      type: "button"
    }, e.ptm("decrementButton"), {
      "data-p": r.dataP
    }), [R(e.$slots, e.$slots.decrementicon ? "decrementicon" : "decrementbuttonicon", {}, function() {
      return [(m(), j($e(e.decrementIcon || e.decrementButtonIcon ? "span" : "AngleDownIcon"), x({
        class: [e.decrementIcon, e.decrementButtonIcon]
      }, e.ptm("decrementIcon"), {
        "data-pc-section": "decrementicon"
      }), null, 16, ["class"]))];
    })], 16, Hx)) : B("", !0)];
  })], 16, Rx);
}
Ll.render = Kx;
const Wx = {
  viewBox: "0 0 24 24",
  width: "1.2em",
  height: "1.2em"
};
function Yx(e, t) {
  return m(), h("svg", Wx, [...t[0] || (t[0] = [
    g("path", {
      fill: "currentColor",
      d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6z"
    }, null, -1)
  ])]);
}
const Gx = Se({ name: "mdi-plus", render: Yx }), qx = {
  viewBox: "0 0 24 24",
  width: "1.2em",
  height: "1.2em"
};
function Zx(e, t) {
  return m(), h("svg", qx, [...t[0] || (t[0] = [
    g("path", {
      fill: "currentColor",
      d: "M19 13H5v-2h14z"
    }, null, -1)
  ])]);
}
const Xx = Se({ name: "mdi-minus", render: Zx }), Jx = { class: "mancub-counter inline-flex self-end items-stretch border border-gray-300 rounded-md bg-white overflow-hidden" }, Qx = ["disabled", "aria-label"], eC = ["id", "min", "max", "step"], tC = ["disabled", "aria-label"], nC = /* @__PURE__ */ se({
  __name: "CounterNumber",
  props: /* @__PURE__ */ Mt({
    inputId: {},
    min: { default: () => {
    } },
    max: { default: () => {
    } },
    step: { default: () => {
    } },
    startValue: { default: () => {
    } },
    allowEmpty: { type: Boolean, default: !1 }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = ce($t, v(() => Re)), n = v(() => t.value), o = At(e, "modelValue"), i = v(() => e.min ?? 0), r = v(() => e.max ?? Number.POSITIVE_INFINITY), a = v(() => e.startValue ?? i.value), d = (c) => Math.min(Math.max(c, i.value), r.value), l = v({
      get: () => o.value ?? "",
      set: (c) => {
        if (c === "" || c == null || !Number.isFinite(c)) {
          o.value = e.allowEmpty ? void 0 : i.value;
          return;
        }
        o.value = d(c);
      }
    }), u = () => {
      if (o.value == null) {
        o.value = d(a.value);
        return;
      }
      o.value = d(o.value - (e.step ?? 1));
    }, s = () => {
      if (o.value == null) {
        o.value = d(a.value);
        return;
      }
      o.value = d(o.value + (e.step ?? 1));
    };
    return (c, p) => {
      const f = Xx, b = Gx;
      return m(), h("div", Jx, [
        g("button", {
          type: "button",
          class: "counter-btn",
          disabled: o.value == null || o.value <= i.value,
          "aria-label": n.value.counterDecrement,
          onClick: u
        }, [
          L(f, { class: "text-base" })
        ], 8, Qx),
        Ze(g("input", {
          id: c.inputId,
          "onUpdate:modelValue": p[0] || (p[0] = (k) => l.value = k),
          type: "number",
          class: "counter-input",
          min: c.min,
          max: c.max,
          step: c.step ?? 1,
          inputmode: "numeric"
        }, null, 8, eC), [
          [
            fs,
            l.value,
            void 0,
            { number: !0 }
          ]
        ]),
        g("button", {
          type: "button",
          class: "counter-btn",
          disabled: o.value != null && o.value >= r.value,
          "aria-label": n.value.counterIncrement,
          onClick: s
        }, [
          L(b, { class: "text-base" })
        ], 8, tC)
      ]);
    };
  }
}), Ol = /* @__PURE__ */ Je(nC, [["__scopeId", "data-v-4562d0c6"]]), oC = ["for"], rC = 1e3, iC = /* @__PURE__ */ se({
  __name: "NumberField",
  props: {
    fieldName: {},
    fieldTitle: { default: () => {
    } },
    fieldSubtitle: { default: () => {
    } },
    formKey: { default: () => {
    } },
    initialValue: { type: [Boolean, String, Number, null, Object], default: () => {
    } },
    required: { type: Boolean },
    config: { default: () => ({}) }
  },
  setup(e) {
    const t = v(() => e.config?.widget ?? "counter"), n = v(() => {
      const p = e.config?.min, f = e.config?.max;
      if (p == null || f == null) return [];
      const b = e.config?.step && e.config.step > 0 ? e.config.step : 1, k = Math.floor((f - p) / b) + 1;
      if (k <= 0) return [];
      if (k > rC)
        return console.warn(`NumberField "${e.fieldName}": select widget would render ${k} options; falling back to empty list. Tighten min/max/step.`), [];
      const T = [];
      for (let $ = 0; $ < k; $++)
        T.push(Number((p + $ * b).toPrecision(12)));
      return T;
    }), o = W(null), i = ce($t, v(() => Re)), r = () => {
      const p = [];
      if (e.required && p.push((f) => f === ye ? i.value.validationRequired : !0), e.config?.min != null) {
        const f = e.config.min;
        p.push((b) => b === ye ? !0 : b >= f || Le(i.value.validationMinValue, { min: f }));
      }
      if (e.config?.max != null) {
        const f = e.config.max;
        p.push((b) => b === ye ? !0 : b <= f || Le(i.value.validationMaxValue, { max: f }));
      }
      return p;
    }, {
      id: a,
      model: d,
      isVisible: l,
      errors: u
    } = Sn(v(() => o.value?.$el), e.fieldName, e.initialValue, e.formKey, r(), e.config), s = v({
      get: () => d.value === ye ? void 0 : d.value,
      set: (p) => {
        if (p == null) {
          d.value = ye;
          return;
        }
        d.value = p;
      }
    }), c = (p) => {
      const f = typeof p == "object" && p !== null ? p.value : p;
      s.value = typeof f == "number" ? f : void 0;
    };
    return (p, f) => {
      const b = rn, k = Ll, T = Ft;
      return z(l) ? (m(), j(Rt, {
        key: 0,
        ref_key: "containerRef",
        ref: o
      }, ht({
        title: U(() => [
          L(an, {
            "for-id": z(a),
            title: p.fieldTitle || p.fieldName,
            subtitle: p.fieldSubtitle,
            required: p.required
          }, null, 8, ["for-id", "title", "subtitle", "required"])
        ]),
        default: U(() => [
          p.config?.label ? (m(), h("label", {
            key: 0,
            for: z(a),
            class: "block text-sm text-gray-700 mb-1"
          }, y(p.config.label), 9, oC)) : B("", !0),
          t.value === "counter" ? (m(), j(Ol, {
            key: 1,
            modelValue: s.value,
            "onUpdate:modelValue": f[0] || (f[0] = ($) => s.value = $),
            "input-id": z(a),
            min: p.config?.min ?? void 0,
            max: p.config?.max ?? void 0,
            step: p.config?.step ?? void 0,
            "start-value": p.config?.initial_value ?? void 0,
            "allow-empty": ""
          }, null, 8, ["modelValue", "input-id", "min", "max", "step", "start-value"])) : t.value === "select" ? (m(), j(b, {
            key: 2,
            id: z(a),
            modelValue: s.value,
            "onUpdate:modelValue": f[1] || (f[1] = ($) => s.value = $),
            options: n.value,
            name: p.fieldName,
            invalid: z(u).length > 0,
            placeholder: p.fieldTitle || p.fieldName,
            "append-to": "body",
            "overlay-class": "mancub-widget-overlay",
            class: "w-full",
            "show-clear": ""
          }, null, 8, ["id", "modelValue", "options", "name", "invalid", "placeholder"])) : (m(), j(k, {
            key: 3,
            id: z(a),
            modelValue: s.value,
            "onUpdate:modelValue": f[2] || (f[2] = ($) => s.value = $),
            name: p.fieldName,
            min: p.config?.min ?? void 0,
            max: p.config?.max ?? void 0,
            step: p.config?.step ?? void 0,
            fluid: "",
            onInput: c,
            onValueChange: c
          }, null, 8, ["id", "modelValue", "name", "min", "max", "step"]))
        ]),
        _: 2
      }, [
        z(u).length ? {
          name: "errors",
          fn: U(() => [
            (m(!0), h(Y, null, he(z(u), ($, S) => (m(), j(T, {
              key: S,
              severity: "error",
              size: "small",
              variant: "simple"
            }, {
              default: U(() => [
                q(y($.toString()), 1)
              ]),
              _: 2
            }, 1024))), 128))
          ]),
          key: "0"
        } : void 0
      ]), 1536)) : B("", !0);
    };
  }
}), aC = {
  key: "unavailable",
  class: "price-line"
}, lC = ["data-testid"], sC = {
  key: "amount",
  class: "price-line"
}, dC = { class: "price-line-inner flex flex-col items-end gap-0.5" }, uC = {
  key: 0,
  class: "mancub-save-tag"
}, cC = { class: "flex items-baseline gap-2" }, pC = {
  key: 0,
  class: "mancub-strike-diagonal text-sm text-gray-400"
}, mC = { class: "text-sm font-semibold text-gray-900" }, fC = /* @__PURE__ */ se({
  __name: "PriceLine",
  props: {
    price: {},
    count: { default: 1 }
  },
  setup(e) {
    const t = ce($t, v(() => Re)), n = ce(qr, void 0), o = Bn(), i = ce(mo, null), r = v(() => tn(e.price, Q(o))), a = v(() => $n(e.price, Q(n), r.value.code)), d = (p) => _t(p, {
      code: r.value.code,
      unit: r.value.unit,
      decimals: r.value.decimals,
      lang: Q(i) ?? void 0
    }), l = v(() => {
      const p = r.value.amount;
      return p === null ? null : a.value ? en(p * (1 - a.value / 100), r.value.decimals) : p;
    }), u = v(() => {
      if (!e.price || e.count <= 0) return null;
      const p = l.value;
      return p === null ? r.value.display ? r.value.unit ? `${r.value.display} ${r.value.unit}` : r.value.display : null : p === 0 ? null : d(p * e.count);
    }), s = v(() => {
      if (!e.price || e.count <= 0 || a.value <= 0) return null;
      const p = r.value.amount;
      return p === null || p <= 0 ? null : d(p * e.count);
    }), c = v(() => {
      if (!e.price || e.count <= 0 || a.value <= 0) return null;
      const p = r.value.amount;
      return p === null || p <= 0 || l.value === null ? null : Le(t.value.priceListSave, { amount: d((p - l.value) * e.count) });
    });
    return (p, f) => (m(), j(Cn, { name: "price-line" }, {
      default: U(() => [
        p.price?.is_blocked ? (m(), h("div", aC, [
          g("span", {
            class: "mancub-price-unavailable text-sm font-medium text-gray-500",
            "data-testid": `mancub-price-unavailable-${p.price.ident}`
          }, y(z(t).priceUnavailable), 9, lC)
        ])) : u.value !== null ? (m(), h("div", sC, [
          g("div", dC, [
            c.value ? (m(), h("span", uC, y(c.value), 1)) : B("", !0),
            g("span", cC, [
              s.value ? (m(), h("span", pC, y(s.value), 1)) : B("", !0),
              g("span", mC, y(u.value), 1)
            ])
          ])
        ])) : B("", !0)
      ]),
      _: 1
    }));
  }
}), kn = /* @__PURE__ */ Je(fC, [["__scopeId", "data-v-7adf9538"]]), gC = { class: "flex flex-col items-start gap-0 text-sm text-gray-900 leading-snug" }, hC = { class: "font-medium" }, bC = {
  key: 0,
  class: "text-xs text-gray-500 mt-0.5 whitespace-pre-line"
}, ei = /* @__PURE__ */ se({
  __name: "PlainValue",
  props: {
    title: {},
    subtitle: {}
  },
  setup(e) {
    return (t, n) => (m(), h("div", gC, [
      g("div", hC, y(t.title), 1),
      t.subtitle ? (m(), h("div", bC, y(t.subtitle), 1)) : B("", !0)
    ]));
  }
});
var vC = `
    .p-radiobutton {
        position: relative;
        display: inline-flex;
        user-select: none;
        vertical-align: bottom;
        width: dt('radiobutton.width');
        height: dt('radiobutton.height');
    }

    .p-radiobutton-input {
        cursor: pointer;
        appearance: none;
        position: absolute;
        top: 0;
        inset-inline-start: 0;
        width: 100%;
        height: 100%;
        padding: 0;
        margin: 0;
        opacity: 0;
        z-index: 1;
        outline: 0 none;
        border: 1px solid transparent;
        border-radius: 50%;
    }

    .p-radiobutton-box {
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 50%;
        border: 1px solid dt('radiobutton.border.color');
        background: dt('radiobutton.background');
        width: dt('radiobutton.width');
        height: dt('radiobutton.height');
        transition:
            background dt('radiobutton.transition.duration'),
            color dt('radiobutton.transition.duration'),
            border-color dt('radiobutton.transition.duration'),
            box-shadow dt('radiobutton.transition.duration'),
            outline-color dt('radiobutton.transition.duration');
        outline-color: transparent;
        box-shadow: dt('radiobutton.shadow');
    }

    .p-radiobutton-icon {
        transition-duration: dt('radiobutton.transition.duration');
        background: transparent;
        font-size: dt('radiobutton.icon.size');
        width: dt('radiobutton.icon.size');
        height: dt('radiobutton.icon.size');
        border-radius: 50%;
        backface-visibility: hidden;
        transform: translateZ(0) scale(0.1);
    }

    .p-radiobutton:not(.p-disabled):has(.p-radiobutton-input:hover) .p-radiobutton-box {
        border-color: dt('radiobutton.hover.border.color');
    }

    .p-radiobutton-checked .p-radiobutton-box {
        border-color: dt('radiobutton.checked.border.color');
        background: dt('radiobutton.checked.background');
    }

    .p-radiobutton-checked .p-radiobutton-box .p-radiobutton-icon {
        background: dt('radiobutton.icon.checked.color');
        transform: translateZ(0) scale(1, 1);
        visibility: visible;
    }

    .p-radiobutton-checked:not(.p-disabled):has(.p-radiobutton-input:hover) .p-radiobutton-box {
        border-color: dt('radiobutton.checked.hover.border.color');
        background: dt('radiobutton.checked.hover.background');
    }

    .p-radiobutton:not(.p-disabled):has(.p-radiobutton-input:hover).p-radiobutton-checked .p-radiobutton-box .p-radiobutton-icon {
        background: dt('radiobutton.icon.checked.hover.color');
    }

    .p-radiobutton:not(.p-disabled):has(.p-radiobutton-input:focus-visible) .p-radiobutton-box {
        border-color: dt('radiobutton.focus.border.color');
        box-shadow: dt('radiobutton.focus.ring.shadow');
        outline: dt('radiobutton.focus.ring.width') dt('radiobutton.focus.ring.style') dt('radiobutton.focus.ring.color');
        outline-offset: dt('radiobutton.focus.ring.offset');
    }

    .p-radiobutton-checked:not(.p-disabled):has(.p-radiobutton-input:focus-visible) .p-radiobutton-box {
        border-color: dt('radiobutton.checked.focus.border.color');
    }

    .p-radiobutton.p-invalid > .p-radiobutton-box {
        border-color: dt('radiobutton.invalid.border.color');
    }

    .p-radiobutton.p-variant-filled .p-radiobutton-box {
        background: dt('radiobutton.filled.background');
    }

    .p-radiobutton.p-variant-filled.p-radiobutton-checked .p-radiobutton-box {
        background: dt('radiobutton.checked.background');
    }

    .p-radiobutton.p-variant-filled:not(.p-disabled):has(.p-radiobutton-input:hover).p-radiobutton-checked .p-radiobutton-box {
        background: dt('radiobutton.checked.hover.background');
    }

    .p-radiobutton.p-disabled {
        opacity: 1;
    }

    .p-radiobutton.p-disabled .p-radiobutton-box {
        background: dt('radiobutton.disabled.background');
        border-color: dt('radiobutton.checked.disabled.border.color');
    }

    .p-radiobutton-checked.p-disabled .p-radiobutton-box .p-radiobutton-icon {
        background: dt('radiobutton.icon.disabled.color');
    }

    .p-radiobutton-sm,
    .p-radiobutton-sm .p-radiobutton-box {
        width: dt('radiobutton.sm.width');
        height: dt('radiobutton.sm.height');
    }

    .p-radiobutton-sm .p-radiobutton-icon {
        font-size: dt('radiobutton.icon.sm.size');
        width: dt('radiobutton.icon.sm.size');
        height: dt('radiobutton.icon.sm.size');
    }

    .p-radiobutton-lg,
    .p-radiobutton-lg .p-radiobutton-box {
        width: dt('radiobutton.lg.width');
        height: dt('radiobutton.lg.height');
    }

    .p-radiobutton-lg .p-radiobutton-icon {
        font-size: dt('radiobutton.icon.lg.size');
        width: dt('radiobutton.icon.lg.size');
        height: dt('radiobutton.icon.lg.size');
    }
`, yC = {
  root: function(t) {
    var n = t.instance, o = t.props;
    return ["p-radiobutton p-component", {
      "p-radiobutton-checked": n.checked,
      "p-disabled": o.disabled,
      "p-invalid": n.$pcRadioButtonGroup ? n.$pcRadioButtonGroup.$invalid : n.$invalid,
      "p-variant-filled": n.$variant === "filled",
      "p-radiobutton-sm p-inputfield-sm": o.size === "small",
      "p-radiobutton-lg p-inputfield-lg": o.size === "large"
    }];
  },
  box: "p-radiobutton-box",
  input: "p-radiobutton-input",
  icon: "p-radiobutton-icon"
}, kC = oe.extend({
  name: "radiobutton",
  style: vC,
  classes: yC
}), wC = {
  name: "BaseRadioButton",
  extends: on,
  props: {
    value: null,
    binary: Boolean,
    readonly: {
      type: Boolean,
      default: !1
    },
    tabindex: {
      type: Number,
      default: null
    },
    inputId: {
      type: String,
      default: null
    },
    inputClass: {
      type: [String, Object],
      default: null
    },
    inputStyle: {
      type: Object,
      default: null
    },
    ariaLabelledby: {
      type: String,
      default: null
    },
    ariaLabel: {
      type: String,
      default: null
    }
  },
  style: kC,
  provide: function() {
    return {
      $pcRadioButton: this,
      $parentInstance: this
    };
  }
};
function io(e) {
  "@babel/helpers - typeof";
  return io = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, io(e);
}
function xC(e, t, n) {
  return (t = CC(t)) in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function CC(e) {
  var t = SC(e, "string");
  return io(t) == "symbol" ? t : t + "";
}
function SC(e, t) {
  if (io(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var o = n.call(e, t);
    if (io(o) != "object") return o;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var Ml = {
  name: "RadioButton",
  extends: wC,
  inheritAttrs: !1,
  emits: ["change", "focus", "blur"],
  inject: {
    $pcRadioButtonGroup: {
      default: void 0
    }
  },
  methods: {
    getPTOptions: function(t) {
      var n = t === "root" ? this.ptmi : this.ptm;
      return n(t, {
        context: {
          checked: this.checked,
          disabled: this.disabled
        }
      });
    },
    onChange: function(t) {
      if (!this.disabled && !this.readonly) {
        var n = this.binary ? !this.checked : this.value;
        this.$pcRadioButtonGroup ? this.$pcRadioButtonGroup.writeValue(n, t) : this.writeValue(n, t), this.$emit("change", t);
      }
    },
    onFocus: function(t) {
      this.$emit("focus", t);
    },
    onBlur: function(t) {
      var n, o;
      this.$emit("blur", t), (n = (o = this.formField).onBlur) === null || n === void 0 || n.call(o, t);
    }
  },
  computed: {
    groupName: function() {
      return this.$pcRadioButtonGroup ? this.$pcRadioButtonGroup.groupName : this.$formName;
    },
    checked: function() {
      var t = this.$pcRadioButtonGroup ? this.$pcRadioButtonGroup.d_value : this.d_value;
      return t != null && (this.binary ? !!t : co(t, this.value));
    },
    dataP: function() {
      return Pe(xC({
        invalid: this.$invalid,
        checked: this.checked,
        disabled: this.disabled,
        filled: this.$variant === "filled"
      }, this.size, this.size));
    }
  }
}, $C = ["data-p-checked", "data-p-disabled", "data-p"], BC = ["id", "value", "name", "checked", "tabindex", "disabled", "readonly", "aria-labelledby", "aria-label", "aria-invalid"], TC = ["data-p"], IC = ["data-p"];
function DC(e, t, n, o, i, r) {
  return m(), h("div", x({
    class: e.cx("root")
  }, r.getPTOptions("root"), {
    "data-p-checked": r.checked,
    "data-p-disabled": e.disabled,
    "data-p": r.dataP
  }), [g("input", x({
    id: e.inputId,
    type: "radio",
    class: [e.cx("input"), e.inputClass],
    style: e.inputStyle,
    value: e.value,
    name: r.groupName,
    checked: r.checked,
    tabindex: e.tabindex,
    disabled: e.disabled,
    readonly: e.readonly,
    "aria-labelledby": e.ariaLabelledby,
    "aria-label": e.ariaLabel,
    "aria-invalid": e.invalid || void 0,
    onFocus: t[0] || (t[0] = function() {
      return r.onFocus && r.onFocus.apply(r, arguments);
    }),
    onBlur: t[1] || (t[1] = function() {
      return r.onBlur && r.onBlur.apply(r, arguments);
    }),
    onChange: t[2] || (t[2] = function() {
      return r.onChange && r.onChange.apply(r, arguments);
    })
  }, r.getPTOptions("input")), null, 16, BC), g("div", x({
    class: e.cx("box")
  }, r.getPTOptions("box"), {
    "data-p": r.dataP
  }), [g("div", x({
    class: e.cx("icon")
  }, r.getPTOptions("icon"), {
    "data-p": r.dataP
  }), null, 16, IC)], 16, TC)], 16, $C);
}
Ml.render = DC;
const PC = ["aria-labelledby"], zC = { class: "flex-1 min-w-0" }, LC = { class: "font-medium text-gray-900 truncate" }, OC = {
  key: 0,
  class: "text-sm text-gray-500 truncate"
}, MC = /* @__PURE__ */ se({
  __name: "ChoiceField",
  props: {
    fieldName: {},
    fieldTitle: { default: () => {
    } },
    fieldSubtitle: { default: () => {
    } },
    formKey: { default: () => {
    } },
    initialValue: { type: [Boolean, String, Number, null, Object], default: () => {
    } },
    required: { type: Boolean },
    config: {}
  },
  setup(e) {
    const t = v(() => e.config.choices.length === 1), n = v(() => t.value ? e.config.choices[0] ?? null : null), o = W(null), i = ce($t, v(() => Re)), r = (D) => D.label || D.value, a = () => {
      if (e.required)
        return [(D) => D != ye || i.value.validationRequired];
    }, {
      id: d,
      model: l,
      errors: u,
      isValid: s,
      isVisible: c,
      validate: p
    } = Sn(v(() => o.value?.$el), e.fieldName, e.initialValue ?? (t.value ? e.config.choices[0]?.value : void 0), e.formKey, a(), e.config), f = v({
      get: () => l.value === ye ? null : l.value,
      set: (D) => {
        l.value = D;
      }
    }), b = v(() => {
      const D = f.value;
      return D == null ? n.value : e.config.choices.find((C) => C.value === D) ?? n.value;
    }), { price: k } = jo(() => b.value?.price_ident), T = Yr(), $ = (D) => D.price_ident ? T?.get(D.price_ident) ?? null : null, S = (D) => $(D)?.is_blocked === !0;
    te(() => f.value != null && e.config.choices.some((D) => D.value === f.value && S(D)), (D) => {
      D && (l.value = ye);
    }, { immediate: !0 });
    const O = Bn(), w = ce(mo, null), F = (D) => {
      const C = r(D);
      if (S(D)) return `${C} – ${i.value.priceUnavailable}`;
      const I = tn($(D), Q(O));
      if (I.amount === 0) return C;
      let N;
      if (I.amount === null) {
        if (!I.display) return C;
        N = I.unit ? `${I.display} ${I.unit}` : I.display;
      } else
        N = _t(I.amount, {
          code: I.code,
          unit: I.unit,
          decimals: I.decimals,
          lang: Q(w) ?? void 0
        });
      return `${C} – ${N}`;
    };
    return (D, C) => {
      const I = rn, N = Ft;
      return z(c) ? (m(), j(Rt, {
        key: 0,
        ref_key: "containerRef",
        ref: o
      }, ht({
        title: U(() => [
          L(an, {
            "for-id": z(d),
            title: D.fieldTitle || D.fieldName,
            subtitle: D.fieldSubtitle,
            required: D.required,
            price: z(k),
            "hide-price": ""
          }, null, 8, ["for-id", "title", "subtitle", "required", "price"])
        ]),
        default: U(() => [
          t.value ? (m(), j(ei, {
            key: 0,
            title: n.value?.label || n.value?.value || "",
            subtitle: n.value?.sublabel ?? null
          }, null, 8, ["title", "subtitle"])) : D.config.widget === "radio" ? (m(), h("div", {
            key: 1,
            class: "mancub-radio-group w-full flex flex-col gap-2",
            role: "radiogroup",
            "aria-labelledby": z(d) + "-label"
          }, [
            (m(!0), h(Y, null, he(D.config.choices, (K) => (m(), h("label", {
              key: K.value,
              class: ee(["mancub-radio-row flex items-center gap-3 px-3 py-2 border border-gray-200 rounded-md", S(K) ? "is-unavailable cursor-not-allowed opacity-60" : ["cursor-pointer hover:bg-gray-50", { "is-selected": f.value === K.value }]])
            }, [
              L(z(Ml), {
                modelValue: f.value,
                "onUpdate:modelValue": C[0] || (C[0] = (V) => f.value = V),
                name: D.fieldName,
                value: K.value,
                "input-id": `${z(d)}-${K.value}`,
                disabled: S(K),
                invalid: !z(s),
                onChange: z(p)
              }, null, 8, ["modelValue", "name", "value", "input-id", "disabled", "invalid", "onChange"]),
              g("div", zC, [
                g("div", LC, y(r(K)), 1),
                K.sublabel ? (m(), h("div", OC, y(K.sublabel), 1)) : B("", !0)
              ]),
              $(K) ? (m(), j(kn, {
                key: 0,
                price: $(K)
              }, null, 8, ["price"])) : B("", !0)
            ], 2))), 128))
          ], 8, PC)) : (m(), j(I, {
            key: 2,
            modelValue: f.value,
            "onUpdate:modelValue": C[1] || (C[1] = (K) => f.value = K),
            "data-normalized-price": z(k)?.amount,
            options: D.config.choices,
            "option-label": r,
            "option-disabled": S,
            "option-value": "value",
            "append-to": "body",
            "overlay-class": "mancub-widget-overlay",
            name: D.fieldName,
            invalid: !z(s),
            class: "w-full",
            onBlur: z(p)
          }, {
            option: U(({ option: K }) => [
              q(y(F(K)), 1)
            ]),
            _: 1
          }, 8, ["modelValue", "data-normalized-price", "options", "name", "invalid", "onBlur"]))
        ]),
        _: 2
      }, [
        z(k) ? {
          name: "price",
          fn: U(() => [
            L(kn, { price: z(k) }, null, 8, ["price"])
          ]),
          key: "0"
        } : void 0,
        z(u).length ? {
          name: "errors",
          fn: U(() => [
            (m(!0), h(Y, null, he(z(u), (K, V) => (m(), j(N, {
              key: V,
              severity: "error",
              size: "small",
              variant: "simple"
            }, {
              default: U(() => [
                q(y(K.toString()), 1)
              ]),
              _: 2
            }, 1024))), 128))
          ]),
          key: "1"
        } : void 0
      ]), 1536)) : B("", !0);
    };
  }
});
var AC = `
    .p-toggleswitch {
        display: inline-block;
        width: dt('toggleswitch.width');
        height: dt('toggleswitch.height');
    }

    .p-toggleswitch-input {
        cursor: pointer;
        appearance: none;
        position: absolute;
        top: 0;
        inset-inline-start: 0;
        width: 100%;
        height: 100%;
        padding: 0;
        margin: 0;
        opacity: 0;
        z-index: 1;
        outline: 0 none;
        border-radius: dt('toggleswitch.border.radius');
    }

    .p-toggleswitch-slider {
        cursor: pointer;
        width: 100%;
        height: 100%;
        border-width: dt('toggleswitch.border.width');
        border-style: solid;
        border-color: dt('toggleswitch.border.color');
        background: dt('toggleswitch.background');
        transition:
            background dt('toggleswitch.transition.duration'),
            color dt('toggleswitch.transition.duration'),
            border-color dt('toggleswitch.transition.duration'),
            outline-color dt('toggleswitch.transition.duration'),
            box-shadow dt('toggleswitch.transition.duration');
        border-radius: dt('toggleswitch.border.radius');
        outline-color: transparent;
        box-shadow: dt('toggleswitch.shadow');
    }

    .p-toggleswitch-handle {
        position: absolute;
        top: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        background: dt('toggleswitch.handle.background');
        color: dt('toggleswitch.handle.color');
        width: dt('toggleswitch.handle.size');
        height: dt('toggleswitch.handle.size');
        inset-inline-start: dt('toggleswitch.gap');
        margin-block-start: calc(-1 * calc(dt('toggleswitch.handle.size') / 2));
        border-radius: dt('toggleswitch.handle.border.radius');
        transition:
            background dt('toggleswitch.transition.duration'),
            color dt('toggleswitch.transition.duration'),
            inset-inline-start dt('toggleswitch.slide.duration'),
            box-shadow dt('toggleswitch.slide.duration');
    }

    .p-toggleswitch.p-toggleswitch-checked .p-toggleswitch-slider {
        background: dt('toggleswitch.checked.background');
        border-color: dt('toggleswitch.checked.border.color');
    }

    .p-toggleswitch.p-toggleswitch-checked .p-toggleswitch-handle {
        background: dt('toggleswitch.handle.checked.background');
        color: dt('toggleswitch.handle.checked.color');
        inset-inline-start: calc(dt('toggleswitch.width') - calc(dt('toggleswitch.handle.size') + dt('toggleswitch.gap')));
    }

    .p-toggleswitch:not(.p-disabled):has(.p-toggleswitch-input:hover) .p-toggleswitch-slider {
        background: dt('toggleswitch.hover.background');
        border-color: dt('toggleswitch.hover.border.color');
    }

    .p-toggleswitch:not(.p-disabled):has(.p-toggleswitch-input:hover) .p-toggleswitch-handle {
        background: dt('toggleswitch.handle.hover.background');
        color: dt('toggleswitch.handle.hover.color');
    }

    .p-toggleswitch:not(.p-disabled):has(.p-toggleswitch-input:hover).p-toggleswitch-checked .p-toggleswitch-slider {
        background: dt('toggleswitch.checked.hover.background');
        border-color: dt('toggleswitch.checked.hover.border.color');
    }

    .p-toggleswitch:not(.p-disabled):has(.p-toggleswitch-input:hover).p-toggleswitch-checked .p-toggleswitch-handle {
        background: dt('toggleswitch.handle.checked.hover.background');
        color: dt('toggleswitch.handle.checked.hover.color');
    }

    .p-toggleswitch:not(.p-disabled):has(.p-toggleswitch-input:focus-visible) .p-toggleswitch-slider {
        box-shadow: dt('toggleswitch.focus.ring.shadow');
        outline: dt('toggleswitch.focus.ring.width') dt('toggleswitch.focus.ring.style') dt('toggleswitch.focus.ring.color');
        outline-offset: dt('toggleswitch.focus.ring.offset');
    }

    .p-toggleswitch.p-invalid > .p-toggleswitch-slider {
        border-color: dt('toggleswitch.invalid.border.color');
    }

    .p-toggleswitch.p-disabled {
        opacity: 1;
    }

    .p-toggleswitch.p-disabled .p-toggleswitch-slider {
        background: dt('toggleswitch.disabled.background');
    }

    .p-toggleswitch.p-disabled .p-toggleswitch-handle {
        background: dt('toggleswitch.handle.disabled.background');
    }
`, _C = {
  root: {
    position: "relative"
  }
}, FC = {
  root: function(t) {
    var n = t.instance, o = t.props;
    return ["p-toggleswitch p-component", {
      "p-toggleswitch-checked": n.checked,
      "p-disabled": o.disabled,
      "p-invalid": n.$invalid
    }];
  },
  input: "p-toggleswitch-input",
  slider: "p-toggleswitch-slider",
  handle: "p-toggleswitch-handle"
}, EC = oe.extend({
  name: "toggleswitch",
  style: AC,
  classes: FC,
  inlineStyles: _C
}), RC = {
  name: "BaseToggleSwitch",
  extends: vl,
  props: {
    trueValue: {
      type: null,
      default: !0
    },
    falseValue: {
      type: null,
      default: !1
    },
    readonly: {
      type: Boolean,
      default: !1
    },
    tabindex: {
      type: Number,
      default: null
    },
    inputId: {
      type: String,
      default: null
    },
    inputClass: {
      type: [String, Object],
      default: null
    },
    inputStyle: {
      type: Object,
      default: null
    },
    ariaLabelledby: {
      type: String,
      default: null
    },
    ariaLabel: {
      type: String,
      default: null
    }
  },
  style: EC,
  provide: function() {
    return {
      $pcToggleSwitch: this,
      $parentInstance: this
    };
  }
}, Al = {
  name: "ToggleSwitch",
  extends: RC,
  inheritAttrs: !1,
  emits: ["change", "focus", "blur"],
  methods: {
    getPTOptions: function(t) {
      var n = t === "root" ? this.ptmi : this.ptm;
      return n(t, {
        context: {
          checked: this.checked,
          disabled: this.disabled
        }
      });
    },
    onChange: function(t) {
      if (!this.disabled && !this.readonly) {
        var n = this.checked ? this.falseValue : this.trueValue;
        this.writeValue(n, t), this.$emit("change", t);
      }
    },
    onFocus: function(t) {
      this.$emit("focus", t);
    },
    onBlur: function(t) {
      var n, o;
      this.$emit("blur", t), (n = (o = this.formField).onBlur) === null || n === void 0 || n.call(o, t);
    }
  },
  computed: {
    checked: function() {
      return this.d_value === this.trueValue;
    },
    dataP: function() {
      return Pe({
        checked: this.checked,
        disabled: this.disabled,
        invalid: this.$invalid
      });
    }
  }
}, VC = ["data-p-checked", "data-p-disabled", "data-p"], NC = ["id", "checked", "tabindex", "disabled", "readonly", "aria-checked", "aria-labelledby", "aria-label", "aria-invalid"], jC = ["data-p"], UC = ["data-p"];
function HC(e, t, n, o, i, r) {
  return m(), h("div", x({
    class: e.cx("root"),
    style: e.sx("root")
  }, r.getPTOptions("root"), {
    "data-p-checked": r.checked,
    "data-p-disabled": e.disabled,
    "data-p": r.dataP
  }), [g("input", x({
    id: e.inputId,
    type: "checkbox",
    role: "switch",
    class: [e.cx("input"), e.inputClass],
    style: e.inputStyle,
    checked: r.checked,
    tabindex: e.tabindex,
    disabled: e.disabled,
    readonly: e.readonly,
    "aria-checked": r.checked,
    "aria-labelledby": e.ariaLabelledby,
    "aria-label": e.ariaLabel,
    "aria-invalid": e.invalid || void 0,
    onFocus: t[0] || (t[0] = function() {
      return r.onFocus && r.onFocus.apply(r, arguments);
    }),
    onBlur: t[1] || (t[1] = function() {
      return r.onBlur && r.onBlur.apply(r, arguments);
    }),
    onChange: t[2] || (t[2] = function() {
      return r.onChange && r.onChange.apply(r, arguments);
    })
  }, r.getPTOptions("input")), null, 16, NC), g("div", x({
    class: e.cx("slider")
  }, r.getPTOptions("slider"), {
    "data-p": r.dataP
  }), [g("div", x({
    class: e.cx("handle")
  }, r.getPTOptions("handle"), {
    "data-p": r.dataP
  }), [R(e.$slots, "handle", {
    checked: r.checked
  })], 16, UC)], 16, jC)], 16, VC);
}
Al.render = HC;
const KC = { class: "flex items-center gap-2" }, WC = ["for"], YC = /* @__PURE__ */ se({
  __name: "BoolField",
  props: {
    fieldName: {},
    fieldTitle: { default: () => {
    } },
    fieldSubtitle: { default: () => {
    } },
    formKey: { default: () => {
    } },
    initialValue: { type: [Boolean, String, Number, null, Object], default: !1 },
    required: { type: Boolean },
    config: {}
  },
  setup(e) {
    const t = v({
      get: () => d.value == ye ? e.initialValue : d.value,
      set: (p) => {
        d.value = p;
      }
    }), n = W(null), o = v(() => (t.value === !0 ? e.config?.true_label : e.config?.false_label) ?? null), i = ce($t, v(() => Re)), r = () => {
      if (e.required)
        return [(p) => p == !0 || i.value.validationRequired];
    }, { id: a, model: d, isVisible: l, errors: u } = Sn(v(() => n.value?.$el), e.fieldName, e.initialValue === ye ? void 0 : e.initialValue, e.formKey, r(), e.config), { price: s } = jo(() => e.config.price_ident ?? e.fieldName), c = v(() => s.value?.is_blocked === !0);
    return te(() => c.value && t.value === !0, (p) => {
      p && (d.value = !1);
    }, { immediate: !0 }), (p, f) => {
      const b = Ft;
      return z(l) ? (m(), j(Rt, {
        key: 0,
        ref_key: "containerRef",
        ref: n
      }, ht({
        title: U(() => [
          L(an, {
            "for-id": z(a),
            title: p.fieldTitle || p.fieldName,
            subtitle: p.fieldSubtitle,
            required: p.required,
            price: z(s)
          }, null, 8, ["for-id", "title", "subtitle", "required", "price"])
        ]),
        default: U(() => [
          g("div", KC, [
            (m(), j($e(p.config?.widget === "switch" ? z(Al) : z(Go)), {
              id: z(a),
              modelValue: t.value,
              "onUpdate:modelValue": f[0] || (f[0] = (k) => t.value = k),
              name: p.fieldName,
              size: "large",
              disabled: c.value,
              "data-normalized-price": t.value === !0 ? z(s)?.amount : void 0,
              binary: ""
            }, null, 8, ["id", "modelValue", "name", "disabled", "data-normalized-price"])),
            p.config?.label || o.value ? (m(), h("label", {
              key: 0,
              for: z(a),
              class: "text-sm text-gray-700 cursor-pointer"
            }, y(p.config?.label ? `${p.config.label}${o.value ? ": " : ""}` : "") + y(o.value), 9, WC)) : B("", !0)
          ])
        ]),
        _: 2
      }, [
        z(s) ? {
          name: "price",
          fn: U(() => [
            L(kn, {
              price: z(s),
              count: t.value === !0 ? 1 : 0
            }, null, 8, ["price", "count"])
          ]),
          key: "0"
        } : void 0,
        z(u).length ? {
          name: "errors",
          fn: U(() => [
            (m(!0), h(Y, null, he(z(u), (k, T) => (m(), j(b, {
              key: T,
              severity: "error",
              size: "small",
              variant: "simple"
            }, {
              default: U(() => [
                q(y(k.toString()), 1)
              ]),
              _: 2
            }, 1024))), 128))
          ]),
          key: "1"
        } : void 0
      ]), 1536)) : B("", !0);
    };
  }
}), GC = {
  viewBox: "0 0 24 24",
  width: "1.2em",
  height: "1.2em"
};
function qC(e, t) {
  return m(), h("svg", GC, [...t[0] || (t[0] = [
    g("path", {
      fill: "currentColor",
      d: "M21 7L9 19l-5.5-5.5l1.41-1.41L9 16.17L19.59 5.59z"
    }, null, -1)
  ])]);
}
const ZC = Se({ name: "mdi-check", render: qC }), XC = {
  key: 1,
  class: "w-full flex flex-col gap-2"
}, JC = {
  key: 2,
  class: "w-full flex flex-col gap-2"
}, QC = ["disabled", "onClick"], e5 = { class: "geo-card-content" }, t5 = { class: "geo-card-title" }, n5 = {
  key: 0,
  class: "geo-card-subtitle"
}, o5 = ["data-testid"], r5 = { class: "geo-card-content" }, i5 = { class: "geo-card-title" }, a5 = { class: "geo-card-body mt-2 flex flex-col gap-2" }, l5 = /* @__PURE__ */ se({
  __name: "GeolocationField",
  props: {
    fieldName: {},
    fieldTitle: { default: () => {
    } },
    fieldSubtitle: { default: () => {
    } },
    formKey: { default: () => {
    } },
    initialValue: { type: [Boolean, String, Number, null, Object], default: () => {
    } },
    required: { type: Boolean },
    config: {}
  },
  setup(e) {
    const t = W(null), n = ce($t, v(() => Re)), o = v(() => n.value), i = (I) => !I || typeof I != "object" ? null : {
      name: typeof I.name == "string" ? I.name : "",
      address: typeof I.address == "string" ? I.address : ""
    }, r = () => ({ name: u.value, address: s.value }), a = i(e.initialValue), d = !!e.config.custom_location && e.initialValue === void 0, l = W(a !== null || d), u = W(a?.name ?? ""), s = W(a?.address ?? ""), c = () => {
      if (e.required)
        return [
          (I) => {
            if (I === ye) return o.value.validationRequired;
            const N = i(I);
            return N && (!N.name.trim() || !N.address.trim()) ? o.value.validationCustomLocationDetails : !0;
          }
        ];
    }, {
      id: p,
      model: f,
      errors: b,
      isVisible: k
    } = Sn(v(() => t.value?.$el), e.fieldName, e.initialValue, e.formKey, c(), e.config), T = v({
      get: () => f.value === ye ? null : f.value,
      set: (I) => {
        f.value = I ?? ye;
      }
    }), $ = (I) => {
      l.value = !1, f.value = I;
    }, S = () => {
      l.value || (l.value = !0), f.value = r();
    };
    te([u, s], () => {
      l.value && (f.value = r());
    });
    const O = v(() => !e.config.custom_location && e.config.choices.length === 1), w = v(() => {
      const I = T.value, N = O.value ? e.config.choices[0] ?? null : null;
      return I == null ? N : e.config.choices.find((K) => K.value === I) ?? N;
    }), { price: F } = jo(() => w.value?.price_ident), D = Yr(), C = (I) => !!I.price_ident && D?.get(I.price_ident)?.is_blocked === !0;
    return te(() => typeof T.value == "string" && e.config.choices.some((I) => I.value === T.value && C(I)), (I) => {
      I && (f.value = ye);
    }, { immediate: !0 }), (I, N) => {
      const K = Et, V = ZC, M = Ft;
      return z(k) ? (m(), j(Rt, {
        key: 0,
        ref_key: "containerRef",
        ref: t
      }, ht({
        title: U(() => [
          L(an, {
            "for-id": z(p),
            title: I.fieldTitle || I.fieldName,
            subtitle: I.fieldSubtitle,
            required: I.required,
            price: z(F)
          }, null, 8, ["for-id", "title", "subtitle", "required", "price"])
        ]),
        default: U(() => [
          !I.config.custom_location && I.config.choices.length === 1 && I.config.choices[0] ? (m(), j(ei, {
            key: 0,
            title: I.config.choices[0].label || I.config.choices[0].value,
            subtitle: I.config.choices[0].sublabel ?? null
          }, null, 8, ["title", "subtitle"])) : I.config.custom_location && I.config.choices.length === 0 ? (m(), h("div", XC, [
            L(K, {
              modelValue: u.value,
              "onUpdate:modelValue": N[0] || (N[0] = (P) => u.value = P),
              placeholder: o.value.customLocationName
            }, null, 8, ["modelValue", "placeholder"]),
            L(K, {
              modelValue: s.value,
              "onUpdate:modelValue": N[1] || (N[1] = (P) => s.value = P),
              placeholder: o.value.customLocationAddress
            }, null, 8, ["modelValue", "placeholder"])
          ])) : (m(), h("div", JC, [
            (m(!0), h(Y, null, he(I.config.choices, (P) => (m(), h("button", {
              key: P.value,
              type: "button",
              class: ee(["geo-card", { "geo-card--selected": T.value === P.value, "geo-card--unavailable": C(P) }]),
              disabled: C(P),
              onClick: (E) => $(P.value)
            }, [
              g("span", e5, [
                g("span", t5, y(P.label || P.value), 1),
                P.sublabel ? (m(), h("span", n5, y(P.sublabel), 1)) : B("", !0),
                C(P) ? (m(), h("span", {
                  key: 1,
                  class: "mancub-price-unavailable geo-card-subtitle",
                  "data-testid": `mancub-price-unavailable-${P.price_ident}`
                }, y(o.value.priceUnavailable), 9, o5)) : B("", !0)
              ]),
              T.value === P.value ? (m(), j(V, {
                key: 0,
                class: "geo-card-check"
              })) : B("", !0)
            ], 10, QC))), 128)),
            I.config.custom_location ? (m(), h("button", {
              key: 0,
              type: "button",
              class: ee(["geo-card", { "geo-card--selected": l.value }]),
              onClick: S
            }, [
              g("span", r5, [
                g("span", i5, y(o.value.customLocation), 1),
                g("span", a5, [
                  L(K, {
                    modelValue: u.value,
                    "onUpdate:modelValue": N[2] || (N[2] = (P) => u.value = P),
                    placeholder: o.value.customLocationName,
                    onClick: N[3] || (N[3] = Ot(() => {
                    }, ["stop"])),
                    onFocus: S
                  }, null, 8, ["modelValue", "placeholder"]),
                  L(K, {
                    modelValue: s.value,
                    "onUpdate:modelValue": N[4] || (N[4] = (P) => s.value = P),
                    placeholder: o.value.customLocationAddress,
                    onClick: N[5] || (N[5] = Ot(() => {
                    }, ["stop"])),
                    onFocus: S
                  }, null, 8, ["modelValue", "placeholder"])
                ])
              ]),
              l.value ? (m(), j(V, {
                key: 0,
                class: "geo-card-check"
              })) : B("", !0)
            ], 2)) : B("", !0)
          ]))
        ]),
        _: 2
      }, [
        z(F) ? {
          name: "price",
          fn: U(() => [
            L(kn, { price: z(F) }, null, 8, ["price"])
          ]),
          key: "0"
        } : void 0,
        z(b).length ? {
          name: "errors",
          fn: U(() => [
            (m(!0), h(Y, null, he(z(b), (P, E) => (m(), j(M, {
              key: E,
              severity: "error",
              size: "small",
              variant: "simple"
            }, {
              default: U(() => [
                q(y(P.toString()), 1)
              ]),
              _: 2
            }, 1024))), 128))
          ]),
          key: "1"
        } : void 0
      ]), 1536)) : B("", !0);
    };
  }
}), s5 = /* @__PURE__ */ Je(l5, [["__scopeId", "data-v-d172c918"]]), d5 = /* @__PURE__ */ se({
  __name: "FixedField",
  props: {
    fieldName: {},
    fieldTitle: { default: () => {
    } },
    fieldSubtitle: { default: () => {
    } },
    formKey: { default: () => {
    } },
    required: { type: Boolean },
    config: {}
  },
  setup(e) {
    const t = W(null), { id: n, isVisible: o } = Sn(v(() => t.value?.$el), e.fieldName, e.config.value ?? e.config.label, e.formKey, void 0, e.config), { price: i } = jo(() => e.config.price_ident);
    return (r, a) => z(o) ? (m(), j(Rt, {
      key: 0,
      ref_key: "containerRef",
      ref: t
    }, ht({
      title: U(() => [
        L(an, {
          "for-id": z(n),
          title: r.fieldTitle || r.fieldName,
          subtitle: r.fieldSubtitle,
          required: r.required,
          price: z(i),
          "hide-price": ""
        }, null, 8, ["for-id", "title", "subtitle", "required", "price"])
      ]),
      default: U(() => [
        L(ei, {
          title: r.config.label,
          subtitle: null
        }, null, 8, ["title"])
      ]),
      _: 2
    }, [
      z(i) ? {
        name: "price",
        fn: U(() => [
          L(kn, { price: z(i) }, null, 8, ["price"])
        ]),
        key: "0"
      } : void 0
    ]), 1536)) : B("", !0);
  }
}), u5 = {
  string: gx,
  number: iC,
  choice: MC,
  boolean: YC,
  geolocation: s5,
  fixed: d5
}, c5 = (e) => e.attribute_type === "fixed" || e.attribute_type === "choice" && e.choices.length === 1 || e.attribute_type === "geolocation" && !e.custom_location && e.choices.length === 1, p5 = (e) => {
  if (e) {
    if (e.attribute_type === "choice" && e.choices.length >= 1)
      return e.initial_value != null ? e.initial_value : e.widget === "radio" ? void 0 : e.choices[0].value;
    if (e.attribute_type === "geolocation" && e.choices.length >= 1)
      return e.choices[0].value;
    if (e.attribute_type === "number" && e.initial_value != null || e.attribute_type === "string" && e.initial_value != null || e.attribute_type === "boolean" && e.initial_value != null)
      return e.initial_value;
  }
}, m5 = /* @__PURE__ */ se({
  __name: "AttributeField",
  props: {
    ident: {},
    title: {},
    subtitle: { default: () => {
    } },
    formKey: { default: () => {
    } },
    config: {},
    required: { type: Boolean, default: !0 },
    initialValue: { type: [Boolean, String, Number, null, Object], default: () => {
    } }
  },
  setup(e) {
    const t = v(() => e.initialValue ?? p5(e.config));
    return (n, o) => (m(), j($e(z(u5)[n.config.attribute_type]), {
      "field-name": n.ident,
      "field-title": n.title,
      "field-subtitle": n.subtitle,
      config: n.config,
      "initial-value": t.value,
      "form-key": n.formKey,
      required: n.required
    }, null, 8, ["field-name", "field-title", "field-subtitle", "config", "initial-value", "form-key", "required"]));
  }
}), ca = /* @__PURE__ */ se({
  __name: "AbstractForm",
  props: {
    name: {},
    attributes: {},
    initialValues: {}
  },
  setup(e, { expose: t }) {
    const { formState: n, resetForm: o, validate: i, isValid: r } = Xa();
    return t({
      formState: n,
      resetForm: o,
      validate: i,
      isValid: r
    }), (a, d) => (m(), j($e("form"), {
      class: "flex flex-col",
      onSubmit: d[0] || (d[0] = Ot(() => {
        throw new Error("Use @submit on AbstractForm component");
      }, ["prevent"])),
      onReset: Ot(z(o), ["prevent"])
    }, {
      default: U(() => [
        R(a.$slots, "default", {}, () => [
          (m(!0), h(Y, null, he(a.attributes, (l) => (m(), j(m5, {
            key: l.ident,
            config: l.config,
            ident: l.ident,
            title: l.title || l.ident,
            subtitle: l.subtitle ?? void 0,
            required: (l.config.is_required ?? !0) && !z(c5)(l.config),
            "initial-value": a.initialValues?.[l.ident]
          }, null, 8, ["config", "ident", "title", "subtitle", "required", "initial-value"]))), 128))
        ]),
        R(a.$slots, "bottom", Vo(Rr({ formState: z(n) })))
      ]),
      _: 3
    }, 40, ["onReset"]));
  }
}), f5 = ["data-testid"], g5 = ["data-testid"], h5 = /* @__PURE__ */ se({
  __name: "CounterChoiceRow",
  props: /* @__PURE__ */ Mt({
    inputId: {},
    title: {},
    subtitle: {},
    price: {},
    required: { type: Boolean },
    max: {},
    soldOut: { type: Boolean },
    blocked: { type: Boolean }
  }, {
    modelValue: { default: 0 },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = e, n = ce($t, v(() => Re)), o = v(() => t.blocked || t.soldOut), i = At(e, "modelValue");
    return (r, a) => (m(), j(Rt, {
      class: ee({ "is-sold-out": o.value })
    }, ht({
      title: U(() => [
        L(an, {
          "for-id": o.value ? void 0 : r.inputId,
          title: r.title,
          subtitle: r.subtitle ?? void 0,
          price: r.price,
          required: r.required
        }, null, 8, ["for-id", "title", "subtitle", "price", "required"])
      ]),
      default: U(() => [
        r.blocked ? (m(), h("span", {
          key: 0,
          class: "mancub-sold-out mancub-price-unavailable self-end text-sm font-medium text-gray-500 py-1.5",
          "data-testid": `mancub-price-unavailable-${r.inputId}`
        }, y(z(n).priceUnavailable), 9, f5)) : r.soldOut ? (m(), h("span", {
          key: 1,
          class: "mancub-sold-out self-end text-sm font-medium text-gray-500 py-1.5",
          "data-testid": `mancub-sold-out-${r.inputId}`
        }, y(z(n).soldOut), 9, g5)) : (m(), j(Ol, {
          key: 2,
          modelValue: i.value,
          "onUpdate:modelValue": a[0] || (a[0] = (d) => i.value = d),
          "input-id": r.inputId,
          max: r.max
        }, null, 8, ["modelValue", "input-id", "max"]))
      ]),
      _: 2
    }, [
      r.price && !o.value ? {
        name: "price",
        fn: U(() => [
          L(kn, {
            price: r.price,
            count: i.value
          }, null, 8, ["price", "count"])
        ]),
        key: "0"
      } : void 0
    ]), 1032, ["class"]));
  }
}), pa = /* @__PURE__ */ Je(h5, [["__scopeId", "data-v-99ee9b38"]]), b5 = { class: "flex flex-col gap-4" }, v5 = { class: "mancub-ticket-counts-header pt-4 @md:pt-5 -mb-1 flex flex-col gap-1" }, y5 = { class: "text-sm text-gray-600" }, k5 = {
  key: 0,
  class: "text-base font-semibold text-gray-900",
  "data-testid": "mancub-ticket-control-title"
}, w5 = ["aria-hidden"], x5 = { class: "mancub-accordion-content" }, C5 = { class: "mancub-ticket-counts-header pt-4 @md:pt-5 -mb-1 flex flex-col gap-1" }, S5 = { class: "text-sm text-gray-600" }, $5 = {
  key: 0,
  class: "text-base font-semibold text-gray-900",
  "data-testid": "mancub-ticket-control-title"
}, B5 = { class: "py-4 mt-1 flex flex-col gap-2" }, T5 = { class: "text-sm text-gray-500 text-center" }, I5 = ["aria-hidden"], D5 = { class: "mancub-accordion-content" }, P5 = { class: "pb-4" }, z5 = { class: "py-3" }, L5 = {
  key: 0,
  class: "mancub-ticket-strip"
}, O5 = {
  key: 0,
  class: "mancub-ticket-perf"
}, M5 = {
  class: "mancub-ticket px-4",
  "data-testid": "mancub-ticket-card"
}, A5 = { class: "text-sm text-gray-500 text-center pt-2 -mb-2" }, _5 = /* @__PURE__ */ se({
  __name: "SetupForm",
  props: {
    ticketControlAttribute: {},
    form: {},
    capacities: {},
    selectedTime: {},
    prices: {},
    labels: {},
    initialItems: {},
    flat: { type: Boolean },
    name: {},
    attributes: {},
    initialValues: {}
  },
  emits: ["submit"],
  setup(e, { expose: t, emit: n }) {
    const o = e, i = v(() => o.flat ? "flex flex-col" : "bg-white border border-gray-200 rounded-md px-4 md:px-6 flex flex-col"), r = v(() => ({ ...Re, ...o.labels ?? {} }));
    mn($t, r);
    const a = R0(() => o.prices), d = v(() => new Map(o.attributes.map((_) => [_.ident, _]))), l = (_, J) => {
      const re = d.value.get(_);
      return re ? Io(re.config, J) : null;
    }, u = (_, J) => {
      const re = l(_, J);
      return re ? a.get(re) ?? null : null;
    }, s = v(() => o.attributes.filter((_) => _.scope === "setup").sort((_, J) => _.sort_order - J.sort_order)), c = v(() => o.attributes.filter((_) => _.scope === "ticket").sort((_, J) => _.sort_order - J.sort_order)), p = v(() => v2(o.attributes, o.ticketControlAttribute, o.form)), f = v(() => p.value?.config.choices ?? []), b = v(() => p.value?.title || null), k = v(() => p.value !== null), T = v(() => c.value.filter((_) => _.ident !== p.value?.ident)), $ = v(() => k.value && T.value.length > 0), S = (_) => _.price_ident ? a.get(_.price_ident) ?? null : null, O = W(null), w = W([]), F = (_) => _ ? Object.fromEntries(_.map((J) => [J.ident, J.value])) : {}, D = v(() => F(o.initialItems?.setup)), C = W({}), I = W("counts"), N = v(() => $.value && I.value === "counts"), K = v(() => $.value && I.value === "tickets"), V = v(
      () => Object.values(C.value).reduce((_, J) => _ + (J || 0), 0)
    ), M = (_) => y2(_, o.capacities, o.selectedTime), P = v(() => new Set(
      f.value.filter((_) => k2(_, M(_))).map((_) => _.value)
    )), E = v(() => w2(f.value, C.value, M)), H = v(() => new Set(
      f.value.filter((_) => S(_)?.is_blocked).map((_) => _.value)
    )), ae = (_) => {
      const J = x2(f.value, _, M), re = [...H.value].filter((ie) => (J[ie] ?? 0) > 0);
      return re.length === 0 ? J : { ...J, ...Object.fromEntries(re.map((ie) => [ie, 0])) };
    };
    te([f, () => o.capacities, () => o.selectedTime, H], () => {
      const _ = ae(C.value);
      _ !== C.value && (C.value = _);
    });
    const fe = (_) => {
      const J = p.value, re = f.value.find((ie) => ie.value === _);
      return [
        {
          ...J,
          config: {
            attribute_type: "fixed",
            label: re?.label || _,
            value: _,
            price_ident: re?.price_ident ?? null,
            is_required: !0,
            show_in_setup_form: !0,
            show_on_outgoing_order: J.config.show_on_outgoing_order,
            show_on_voucher: J.config.show_on_voucher,
            voucher_display_mode: J.config.voucher_display_mode,
            widget: "text",
            conditions: [],
            conditions_logic: "and"
          }
        },
        ...T.value
      ];
    }, Be = v(() => {
      if (!k.value) return [];
      const _ = [];
      for (const J of f.value) {
        const re = C.value[J.value] ?? 0;
        for (let ie = 1; ie <= re; ie++) _.push({ key: J.value, indexInChoice: ie });
      }
      return _;
    }), Ae = v(() => {
      const _ = {}, J = o.initialItems?.ticket;
      if (!J) return _;
      const re = p.value?.ident;
      if (!re) return _;
      for (const ie of J) {
        const we = {};
        for (const ke of ie)
          we[ke.ident] = ke.value;
        const Z = String(we[re] ?? "");
        Z && (_[Z] || (_[Z] = []), _[Z].push(we));
      }
      return _;
    }), Oe = (_, J) => Ae.value[_]?.[J] ?? {};
    gs(() => {
      if (k.value) {
        f.value.forEach((_) => {
          C.value[_.value] = 0;
        });
        for (const [_, J] of Object.entries(Ae.value))
          C.value[_] = J.length;
        C.value = ae(C.value);
      }
    });
    const _e = (_) => {
      if (!_?.formState) return [];
      const J = _.formState.fields, re = [];
      for (const ie in J) {
        const we = u(ie, J[ie]);
        we && re.push(we);
      }
      return re;
    }, be = v(() => {
      const _ = [];
      if (_.push(..._e(O.value)), k.value && !$.value)
        f.value.forEach((J) => {
          const re = C.value[J.value] ?? 0;
          if (re <= 0) return;
          const ie = S(J);
          if (ie)
            for (let we = 0; we < re; we++) _.push(ie);
        });
      else
        for (const J of w.value) _.push(..._e(J));
      return _;
    }), je = v(() => {
      const _ = be.value;
      return _.length === 0 ? !1 : !_.some((J) => J.is_buyable_alone);
    }), G = v(() => {
      if (O.value && !O.value.isValid) return !1;
      if ($.value) {
        for (const _ of w.value)
          if (_ && !_.isValid) return !1;
      }
      return !(k.value && V.value === 0 || N.value || je.value);
    }), Fe = (_, J) => _ ? { price: Number(_.amount) || 0, price_currency: _.currency || "", price_ident: J ?? "" } : {}, He = () => {
      const _ = {}, J = (re) => {
        if (!re) return null;
        const ie = re.formState.fields, we = [];
        for (const Z in ie) {
          const ke = ie[Z];
          if (ke === ye || ke === void 0 || ke === null || ke === "" || !(d.value.get(Z)?.config.is_required ?? !0) && (ke === 0 || ke === "0")) continue;
          const It = l(Z, ke), ot = It ? a.get(It) ?? null : null;
          we.push({
            ident: Z,
            value: ke,
            ...Fe(ot, It)
          });
        }
        return we;
      };
      if (O.value && (_.setup = J(O.value)), k.value && !$.value) {
        const re = p.value.ident;
        _.ticket = [], f.value.forEach((ie) => {
          const we = C.value[ie.value] ?? 0;
          for (let Z = 0; Z < we; Z++) {
            const ke = ie.price_ident ?? null, Tt = S(ie);
            _.ticket.push([{
              ident: re,
              value: ie.value,
              ...Fe(Tt, ke)
            }]);
          }
        });
      } else w.value.length > 0 && (_.ticket = [], w.value.forEach((re) => {
        if (re && re.formState) {
          _.ticket.push([]);
          const ie = re.formState;
          for (const we in ie.fields) {
            const Z = ie.fields[we] === ye || ie.fields[we] === void 0 ? null : ie.fields[we], ke = l(we, ie.fields[we]), Tt = ke ? a.get(ke) ?? null : null;
            _.ticket[_.ticket.length - 1].push({
              ident: we,
              value: Z,
              ...Fe(Tt, ke)
            });
          }
        }
      }));
      return _;
    }, Me = n, Vt = W(!1), Nt = async () => {
      Vt.value || (Vt.value = !0, _0(), await new Promise((_) => setTimeout(_, 100)), Vt.value = !1, G.value && Me("submit", He()));
    }, jt = () => {
      O.value?.resetForm(), w.value.forEach((_) => _?.resetForm());
      for (const _ in C.value) C.value[_] = 0;
      I.value = "counts";
    };
    return t({
      submitForm: Nt,
      resetForm: jt,
      getData: He,
      isValid: G,
      selectedPrices: be,
      totalTicketsSelected: V,
      onlyNonBuyableAloneSelected: je,
      awaitingTicketConfirm: N,
      onTicketDetailsStep: K
    }), (_, J) => {
      const re = bt, ie = b2, we = Ft;
      return m(), h("form", {
        class: "mancub-form flex flex-col",
        onSubmit: Ot(Nt, ["prevent", "stop"]),
        onReset: Ot(jt, ["prevent"])
      }, [
        g("div", b5, [
          k.value ? (m(), h("div", {
            key: 0,
            class: ee(i.value)
          }, [
            $.value ? (m(), h(Y, { key: 1 }, [
              g("div", {
                class: ee(["mancub-accordion", { "is-open": I.value === "counts" }]),
                "aria-hidden": I.value !== "counts"
              }, [
                g("div", x5, [
                  g("div", C5, [
                    g("p", S5, y(r.value.selectTicketCounts), 1),
                    b.value ? (m(), h("div", $5, y(b.value), 1)) : B("", !0)
                  ]),
                  (m(!0), h(Y, null, he(f.value, (Z) => (m(), j(pa, {
                    key: Z.value,
                    modelValue: C.value[Z.value],
                    "onUpdate:modelValue": (ke) => C.value[Z.value] = ke,
                    "input-id": Z.value,
                    title: Z.label || Z.value,
                    subtitle: Z.sublabel ?? null,
                    price: S(Z),
                    max: E.value[Z.value],
                    "sold-out": P.value.has(Z.value),
                    blocked: H.value.has(Z.value)
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "input-id", "title", "subtitle", "price", "max", "sold-out", "blocked"]))), 128)),
                  g("div", B5, [
                    L(re, {
                      type: "button",
                      disabled: V.value === 0,
                      size: "large",
                      class: "w-full",
                      onClick: J[0] || (J[0] = (Z) => I.value = "tickets")
                    }, {
                      default: U(() => [
                        q(y(r.value.confirmTickets), 1)
                      ]),
                      _: 1
                    }, 8, ["disabled"]),
                    g("p", T5, y(r.value.ticketDetailsNextStep), 1)
                  ])
                ])
              ], 10, w5),
              g("div", {
                class: ee(["mancub-accordion", { "is-open": I.value === "tickets" }]),
                "aria-hidden": I.value !== "tickets"
              }, [
                g("div", D5, [
                  g("div", P5, [
                    g("div", z5, [
                      g("button", {
                        type: "button",
                        class: "inline-flex items-center gap-1 text-sm font-medium text-gray-600 hover:text-gray-900 -ml-1",
                        onClick: J[1] || (J[1] = (Z) => I.value = "counts")
                      }, [
                        L(ie, { class: "text-lg" }),
                        q(" " + y(r.value.backToTicketSelection), 1)
                      ])
                    ]),
                    Be.value.length ? (m(), h("div", L5, [
                      J[2] || (J[2] = g("div", { class: "mancub-ticket-rip mancub-ticket-rip--top" }, null, -1)),
                      (m(!0), h(Y, null, he(Be.value, (Z, ke) => (m(), h(Y, {
                        key: `${Z.key}-${Z.indexInChoice}`
                      }, [
                        ke > 0 ? (m(), h("div", O5)) : B("", !0),
                        g("div", M5, [
                          g("div", A5, y(z(Le)(r.value.ticketNumber, { n: ke + 1 })), 1),
                          L(ca, {
                            is: "div",
                            ref_for: !0,
                            ref_key: "$ticketForms",
                            ref: w,
                            name: `ticket_${Z.key}_${Z.indexInChoice}`,
                            attributes: fe(Z.key),
                            "initial-values": Oe(Z.key, Z.indexInChoice - 1)
                          }, null, 8, ["name", "attributes", "initial-values"])
                        ])
                      ], 64))), 128)),
                      J[3] || (J[3] = g("div", { class: "mancub-ticket-rip mancub-ticket-rip--bottom" }, null, -1))
                    ])) : B("", !0)
                  ])
                ])
              ], 10, I5)
            ], 64)) : (m(), h(Y, { key: 0 }, [
              g("div", v5, [
                g("p", y5, y(r.value.selectTicketCounts), 1),
                b.value ? (m(), h("div", k5, y(b.value), 1)) : B("", !0)
              ]),
              (m(!0), h(Y, null, he(f.value, (Z) => (m(), j(pa, {
                key: Z.value,
                modelValue: C.value[Z.value],
                "onUpdate:modelValue": (ke) => C.value[Z.value] = ke,
                "input-id": Z.value,
                title: Z.label || Z.value,
                subtitle: Z.sublabel ?? null,
                price: S(Z),
                required: !!S(Z)?.is_buyable_alone,
                max: E.value[Z.value],
                "sold-out": P.value.has(Z.value),
                blocked: H.value.has(Z.value)
              }, null, 8, ["modelValue", "onUpdate:modelValue", "input-id", "title", "subtitle", "price", "required", "max", "sold-out", "blocked"]))), 128))
            ], 64))
          ], 2)) : B("", !0),
          s.value.length > 0 ? Ze((m(), h("div", {
            key: 1,
            class: ee(i.value)
          }, [
            L(ca, {
              is: "div",
              ref_key: "$setupForm",
              ref: O,
              name: "setup",
              attributes: s.value,
              "initial-values": D.value
            }, null, 8, ["attributes", "initial-values"])
          ], 2)), [
            [Fn, !N.value]
          ]) : B("", !0),
          je.value ? (m(), j(we, {
            key: 2,
            severity: "warn",
            size: "small",
            variant: "simple"
          }, {
            default: U(() => [
              q(y(r.value.notBuyableAlone), 1)
            ]),
            _: 1
          })) : B("", !0)
        ])
      ], 32);
    };
  }
}), F5 = /* @__PURE__ */ Je(_5, [["__scopeId", "data-v-12a13865"]]), ln = "en", Bt = "https://{host}/api/v1/public/", E5 = "mancub.displayFormats", at = Vr(E5, { date: "", time: "", firstDayOfWeek: null }, void 0, {
  mergeDefaults: !0
});
function R5(e) {
  e.date && (at.value = { ...at.value, date: e.date }), e.time && (at.value = { ...at.value, time: e.time }), e.firstDayOfWeek != null && (at.value = { ...at.value, firstDayOfWeek: e.firstDayOfWeek });
}
function V5() {
  return at.value.firstDayOfWeek;
}
function wn(e, t) {
  return at.value.date ? qa(e, at.value.date, t) : null;
}
function ti(e, t) {
  return at.value.time ? M0(e, at.value.time, t) : null;
}
const On = {
  en: Re,
  cs: {
    reservation: "Rezervace",
    date: "Datum",
    changeDate: "Změnit datum",
    hideDate: "Skrýt",
    time: "Čas",
    possibleAlternatives: "Možné alternativy",
    priceList: "Ceník",
    expandPriceList: "Zobrazit ceník",
    collapsePriceList: "Skrýt ceník",
    showFullPriceList: "Zobrazit celý ceník",
    showShortPriceList: "Zobrazit méně cen",
    pickDate: "Ceny se zobrazí po výběru data v kalendáři.",
    discountAvailable: "Sleva k dispozici",
    saveUpTo: "Ušetříte až {percent} %",
    saveExact: "Ušetříte {percent} %",
    priceListSave: "Ušetříte {amount}",
    addToCart: "Přidat do košíku",
    buyNow: "Koupit nyní",
    saveChanges: "Uložit změny",
    cancel: "Zrušit",
    confirmTickets: "Potvrdit počty vstupenek",
    selectTicketCounts: "Vyberte prosím počty vstupenek",
    ticketDetailsNextStep: "V dalším kroku nastavíte jednotlivé vstupenky",
    backToTicketSelection: "Zpět k výběru vstupenek",
    ticketNumber: "Vstupenka {n}",
    completeForm: "Vyplňte políčka označená hvězdičkou",
    processing: "Zpracovávám…",
    resetForm: "Obnovit formulář",
    revalidate: "Ověřit znovu",
    selectDate: "Vyberte prosím datum s dostupnými termíny.",
    loadingForm: "Načítání formuláře…",
    leadTimeWarning: "Tento čas začátku se blíží minimální době nutné pro rezervaci a může se brzy stát nedostupným. Objednejte prosím co nejdříve.",
    onlineBookingUnavailable: "Tento termín nelze rezervovat online. Kontaktujte nás prosím přímo pro individuální nabídku – v závislosti na dostupnosti.",
    notBuyableAlone: "Vybrané položky nelze zakoupit samostatně. Přidejte prosím alespoň jednu další položku.",
    soldOut: "Vyprodáno",
    priceUnavailable: "Pro tento termín nedostupné",
    customLocation: "Zadat vlastní místo",
    customLocationName: "Název místa",
    customLocationAddress: "Adresa",
    basket: "Košík",
    basketEmpty: "Košík je prázdný.",
    basketItems: "Položky objednávky",
    removeItem: "Odebrat položku",
    removeItemConfirm: "Odebrat?",
    editItem: "Upravit položku",
    proceedToCheckout: "Pokračovat k objednávce",
    backToBasket: "Zpět ke košíku",
    tickets: "Vstupenky",
    addedToBasket: "Přidáno do košíku",
    addedToBasketMessage: "Položka byla přidána do košíku.",
    continueShopping: "Pokračovat v nákupu",
    backToShopping: "Zpět k nákupu",
    goToBasket: "Přejít do košíku",
    customer: "Zákazník",
    customerName: "Jméno zákazníka",
    customerEmail: "E-mail zákazníka",
    customerPhone: "Mobilní telefon zákazníka",
    addCustomerNote: "Chci přidat poznámku",
    customerNote: "Poznámka",
    sendReceipt: "Pošlete mi potvrzení o platbě",
    issueForCompany: "Vystavit doklad na firmu",
    invoiceName: "Jméno",
    invoiceCompany: "Firma",
    invoiceVat: "DIČ",
    invoiceAddress: "Adresa",
    invoiceCity: "Město/provincie/region/stát",
    invoiceZip: "PSČ",
    invoiceCountry: "Země",
    participant: "Účastník",
    customerIsParticipant: "Zákazník je zároveň účastníkem.",
    participantName: "Jméno účastníka",
    participantPhone: "Mobilní telefon účastníka",
    participantEmail: "E-mail účastníka",
    separateParticipants: "Vyplnit jiného účastníka pro každou položku",
    payment: "Platba",
    checkout: "Pokladna",
    agreeTerms: "Souhlasím s",
    termsLinkText: "obchodními podmínkami",
    payNow: "Pokračovat k platbě",
    total: "Celkem",
    price: "Cena",
    inclTaxes: "Včetně DPH a poplatků",
    changeCurrency: "Změnit měnu",
    chooseCurrency: "Vyberte měnu platby",
    currencyExplanation: "Používáme vlastní směnné kurzy – snažíme se, aby byly výhodnější pro vás i pro nás než kurz, kterým by kartovou platbu přepočítala vaše banka. Porovnejte níže celkovou cenu objednávky v jednotlivých měnách a zvolte tu, která odpovídá vašemu bankovnímu účtu.",
    currencyColumnCurrency: "Měna",
    currencyColumnRate: "Náš kurz",
    book: "Rezervovat",
    book_button: "Objednat",
    bookNow: "Objednat",
    validationRequired: "Toto pole je povinné.",
    validationMinValue: "Minimální hodnota je {min}.",
    validationMaxValue: "Maximální hodnota je {max}.",
    validationMinLength: "Minimální délka je {min} znaků.",
    validationMaxLength: "Maximální délka je {max} znaků.",
    validationInvalidFormat: "Neplatný formát.",
    validationCustomLocationDetails: "Vyplňte prosím údaje o vlastním místě.",
    counterDecrement: "Snížit",
    counterIncrement: "Zvýšit",
    commodityDetailTitle: "Detail produktu",
    loading: "Načítání…",
    noData: "Žádná data k dispozici.",
    errorPrefix: "Chyba: ",
    retry: "Zkusit znovu",
    errorNetwork: "Nepodařilo se spojit se serverem. Zkontrolujte připojení a zkuste to znovu.",
    errorNotFound: "Požadovaný obsah nebyl nalezen.",
    errorCommodityNotFound: "Produkt „{commodity}“ nebyl nalezen.",
    errorServer: "Služba je dočasně nedostupná. Zkuste to prosím za chvíli.",
    errorGeneric: "Při načítání došlo k chybě.",
    errorDetails: "Technické podrobnosti",
    errorLeadTimeTooShort: "Je nám líto, ale objednávku „{commodity}“ na {datetime} už online nelze vytvořit — je potřeba objednat alespoň {duration} předem. Kontaktujte nás prosím přímo, rádi vám pomůžeme.",
    errorPriceBlocked: "Je nám líto, ale jedna z vybraných položek pro „{commodity}“ už není {date} k dispozici. Odeberte ji prosím z košíku nebo zvolte jiný termín.",
    reviewsTitle: "Recenze zákazníků",
    reviewsEmpty: "Zatím žádné recenze.",
    reviewsAverage: "Průměrné hodnocení",
    reviewsBasedOn: "Na základě {count} recenzí",
    reviewsRecommend: "{percent} % by doporučilo",
    reviewsRecommendOf: "{percent} % z {total} hostů by doporučilo",
    reviewsWouldRecommend: "doporučuje",
    reviewsRecommends: "Doporučuje",
    reviewsDoesNotRecommend: "Nedoporučuje",
    reviewsBreakdown: "Rozložení hodnocení",
    reviewsOverall: "Celkově",
    reviewsAnonymous: "Host",
    reviewsShowMore: "Zobrazit více",
    reviewsAverageHelp: "Průměr z {rated} hvězdičkových hodnocení od zákazníků po dokončené rezervaci ({from} – {to}). Počítají se pouze zveřejněné recenze; hodnota se mění podle filtrů níže.",
    reviewsRecommendHelp: "Podíl z {total} hostů, kteří odpověděli na otázku „doporučili byste“ a zvolili ano. Počítáno pouze ze zveřejněných recenzí dokončených rezervací.",
    reviewsFilterLanguage: "Jazyk",
    reviewsFilterPeriod: "Období",
    reviewsFilterRating: "Hodnocení",
    reviewsFilterCommodity: "Služba",
    reviewsFilterAll: "Vše",
    reviewsPeriodAll: "Celé období",
    reviewsPeriodMonths: "Posledních {months} měsíců",
    reviewsRatingMin: "{count}★ a více",
    reviewsResponse: "Odpověď poskytovatele",
    reviewsResponseBy: "Odpověď od {author}"
  },
  sk: {
    reservation: "Rezervácia",
    date: "Dátum",
    changeDate: "Zmeniť dátum",
    hideDate: "Skryť",
    time: "Čas",
    possibleAlternatives: "Možné alternatívy",
    priceList: "Cenník",
    expandPriceList: "Zobraziť cenník",
    collapsePriceList: "Skryť cenník",
    showFullPriceList: "Zobraziť celý cenník",
    showShortPriceList: "Zobraziť menej cien",
    priceListSave: "Ušetríte {amount}",
    pickDate: "Ceny sa zobrazia po výbere dátumu v kalendári.",
    discountAvailable: "Zľava k dispozícii",
    saveUpTo: "Ušetríte až {percent} %",
    saveExact: "Ušetríte {percent} %",
    addToCart: "Pridať do košíka",
    buyNow: "Kúpiť teraz",
    saveChanges: "Uložiť zmeny",
    cancel: "Zrušiť",
    confirmTickets: "Potvrdiť počty vstupeniek",
    selectTicketCounts: "Vyberte, prosím, počty vstupeniek",
    ticketDetailsNextStep: "V ďalšom kroku nastavíte jednotlivé vstupenky",
    backToTicketSelection: "Späť na výber vstupeniek",
    ticketNumber: "Vstupenka {n}",
    completeForm: "Vyplňte polia označené hviezdičkou",
    processing: "Spracovávam…",
    resetForm: "Obnoviť formulár",
    revalidate: "Overiť znova",
    selectDate: "Vyberte si prosím dátum s dostupnými termínmi.",
    loadingForm: "Načítava sa formulár…",
    leadTimeWarning: "Tento čas začiatku sa blíži minimálnej dobe potrebnej na rezerváciu a čoskoro sa môže stať nedostupným. Objednajte si, prosím, čo najskôr.",
    onlineBookingUnavailable: "Tento termín nie je možné rezervovať online. Kontaktujte nás, prosím, priamo pre individuálnu ponuku – v závislosti od dostupnosti.",
    notBuyableAlone: "Vybrané položky nie je možné kúpiť samostatne. Pridajte, prosím, aspoň jednu ďalšiu položku.",
    soldOut: "Vypredané",
    priceUnavailable: "V tento termín nedostupné",
    customLocation: "Zadať vlastné miesto",
    customLocationName: "Názov miesta",
    customLocationAddress: "Adresa",
    basket: "Košík",
    basketEmpty: "Košík je prázdny.",
    basketItems: "Položky objednávky",
    removeItem: "Odstrániť položku",
    removeItemConfirm: "Odstrániť?",
    editItem: "Upraviť položku",
    proceedToCheckout: "Pokračovať k objednávke",
    backToBasket: "Späť do košíka",
    tickets: "Vstupenky",
    addedToBasket: "Pridané do košíka",
    addedToBasketMessage: "Položka bola pridaná do košíka.",
    continueShopping: "Pokračovať v nákupe",
    backToShopping: "Späť k nákupu",
    goToBasket: "Prejsť do košíka",
    customer: "Zákazník",
    customerName: "Meno zákazníka",
    customerEmail: "E-mail zákazníka",
    customerPhone: "Mobilný telefón zákazníka",
    addCustomerNote: "Chcem pridať poznámku",
    customerNote: "Poznámka",
    sendReceipt: "Pošlite mi potvrdenie o platbe",
    issueForCompany: "Vystaviť doklad na firmu",
    invoiceName: "Meno",
    invoiceCompany: "Firma",
    invoiceVat: "IČ DPH",
    invoiceAddress: "Adresa",
    invoiceCity: "Mesto/región",
    invoiceZip: "PSČ",
    invoiceCountry: "Krajina",
    participant: "Účastník",
    customerIsParticipant: "Zákazník je zároveň účastníkom.",
    participantName: "Meno účastníka",
    participantPhone: "Mobilný telefón účastníka",
    participantEmail: "E-mail účastníka",
    separateParticipants: "Vyplniť iného účastníka pre každú položku",
    payment: "Platba",
    checkout: "Pokladňa",
    agreeTerms: "Súhlasím s",
    termsLinkText: "obchodnými podmienkami",
    payNow: "Pokračovať k platbe",
    total: "Celkom",
    price: "Cena",
    inclTaxes: "Vrátane DPH a poplatkov",
    changeCurrency: "Zmeniť menu",
    chooseCurrency: "Vyberte menu platby",
    currencyExplanation: "Používame vlastné výmenné kurzy – snažíme sa, aby boli výhodnejšie pre vás aj pre nás ako kurz, ktorým by kartovú platbu prepočítala vaša banka. Porovnajte nižšie celkovú cenu objednávky v jednotlivých menách a zvoľte tú, ktorá zodpovedá vášmu bankovému účtu.",
    currencyColumnCurrency: "Mena",
    currencyColumnRate: "Náš kurz",
    book: "Rezervovať",
    book_button: "Objednať",
    bookNow: "Objednať",
    validationRequired: "Toto pole je povinné.",
    validationMinValue: "Minimálna hodnota je {min}.",
    validationMaxValue: "Maximálna hodnota je {max}.",
    validationMinLength: "Minimálna dĺžka je {min} znakov.",
    validationMaxLength: "Maximálna dĺžka je {max} znakov.",
    validationInvalidFormat: "Neplatný formát.",
    validationCustomLocationDetails: "Vyplňte prosím údaje o vlastnom mieste.",
    counterDecrement: "Znížiť",
    counterIncrement: "Zvýšiť",
    commodityDetailTitle: "Detail produktu",
    loading: "Načítavanie…",
    noData: "Žiadne dostupné údaje.",
    errorPrefix: "Chyba: ",
    retry: "Skúsiť znova",
    errorNetwork: "Nepodarilo sa spojiť so serverom. Skontrolujte pripojenie a skúste to znova.",
    errorNotFound: "Požadovaný obsah sa nenašiel.",
    errorCommodityNotFound: "Produkt „{commodity}“ sa nenašiel.",
    errorServer: "Služba je dočasne nedostupná. Skúste to, prosím, o chvíľu.",
    errorGeneric: "Pri načítaní došlo k chybe.",
    errorDetails: "Technické podrobnosti",
    errorLeadTimeTooShort: "Je nám ľúto, ale objednávku „{commodity}“ na {datetime} už online nie je možné vytvoriť — je potrebné objednať aspoň {duration} vopred. Kontaktujte nás, prosím, priamo, radi vám pomôžeme.",
    errorPriceBlocked: "Je nám ľúto, ale jedna z vybraných položiek pre „{commodity}“ už nie je {date} k dispozícii. Odstráňte ju, prosím, z košíka alebo zvoľte iný termín.",
    reviewsTitle: "Recenzie zákazníkov",
    reviewsEmpty: "Zatiaľ žiadne recenzie.",
    reviewsAverage: "Priemerné hodnotenie",
    reviewsBasedOn: "Na základe {count} recenzií",
    reviewsRecommend: "{percent} % by odporučilo",
    reviewsRecommendOf: "{percent} % z {total} hostí by odporučilo",
    reviewsWouldRecommend: "odporúča",
    reviewsRecommends: "Odporúča",
    reviewsDoesNotRecommend: "Neodporúča",
    reviewsBreakdown: "Rozloženie hodnotenia",
    reviewsOverall: "Celkovo",
    reviewsAnonymous: "Hosť",
    reviewsShowMore: "Zobraziť viac",
    reviewsResponse: "Odpoveď poskytovateľa",
    reviewsResponseBy: "Odpoveď od {author}",
    reviewsAverageHelp: "Priemer z {rated} hviezdičkových hodnotení od zákazníkov po dokončenej rezervácii ({from} – {to}). Počítajú sa iba zverejnené recenzie; hodnota sa mení podľa filtrov nižšie.",
    reviewsRecommendHelp: "Podiel z {total} hostí, ktorí odpovedali na otázku „odporučili by ste“ a zvolili áno. Počítané iba zo zverejnených recenzií dokončených rezervácií.",
    reviewsFilterLanguage: "Jazyk",
    reviewsFilterPeriod: "Obdobie",
    reviewsFilterRating: "Hodnotenie",
    reviewsFilterCommodity: "Služba",
    reviewsFilterAll: "Všetko",
    reviewsPeriodAll: "Celé obdobie",
    reviewsPeriodMonths: "Posledných {months} mesiacov",
    reviewsRatingMin: "{count}★ a viac"
  },
  de: {
    reservation: "Reservierung",
    date: "Datum",
    changeDate: "Datum ändern",
    hideDate: "Ausblenden",
    time: "Uhrzeit",
    possibleAlternatives: "Mögliche Alternativen",
    priceList: "Preisliste",
    expandPriceList: "Preisliste anzeigen",
    collapsePriceList: "Preisliste ausblenden",
    showFullPriceList: "Vollständige Preisliste anzeigen",
    showShortPriceList: "Weniger Preise anzeigen",
    priceListSave: "Sie sparen {amount}",
    pickDate: "Bitte wählen Sie ein Datum mit verfügbaren Terminen.",
    discountAvailable: "Rabatt verfügbar",
    saveUpTo: "Sparen Sie bis zu {percent} %",
    saveExact: "Sie sparen {percent} %",
    addToCart: "In den Warenkorb",
    buyNow: "Jetzt kaufen",
    saveChanges: "Änderungen speichern",
    cancel: "Abbrechen",
    confirmTickets: "Ticketanzahl bestätigen",
    selectTicketCounts: "Bitte wählen Sie die Anzahl der Tickets",
    ticketDetailsNextStep: "Im nächsten Schritt konfigurieren Sie die einzelnen Tickets",
    backToTicketSelection: "Zurück zur Ticketauswahl",
    ticketNumber: "Ticket {n}",
    completeForm: "Füllen Sie die mit einem Sternchen markierten Felder aus",
    processing: "Wird verarbeitet…",
    resetForm: "Formular zurücksetzen",
    revalidate: "Erneut prüfen",
    selectDate: "Bitte wählen Sie ein Datum mit verfügbaren Terminen.",
    loadingForm: "Formular wird geladen…",
    leadTimeWarning: "Diese Startzeit liegt nahe an der minimalen Vorlaufzeit für Buchungen und könnte bald nicht mehr verfügbar sein. Bitte bestellen Sie zeitnah.",
    onlineBookingUnavailable: "Dieser Termin kann nicht online gebucht werden. Bitte kontaktieren Sie uns direkt für ein individuelles Angebot – je nach Verfügbarkeit.",
    notBuyableAlone: "Die ausgewählten Positionen können nicht einzeln erworben werden. Bitte fügen Sie mindestens eine weitere Position hinzu.",
    soldOut: "Ausverkauft",
    priceUnavailable: "An diesem Termin nicht verfügbar",
    customLocation: "Eigenen Ort eingeben",
    customLocationName: "Name des Ortes",
    customLocationAddress: "Adresse",
    basket: "Warenkorb",
    basketEmpty: "Ihr Warenkorb ist leer.",
    basketItems: "Bestellpositionen",
    removeItem: "Artikel entfernen",
    removeItemConfirm: "Entfernen?",
    editItem: "Artikel bearbeiten",
    proceedToCheckout: "Zur Bestellung",
    backToBasket: "Zurück zum Warenkorb",
    tickets: "Tickets",
    addedToBasket: "In den Warenkorb gelegt",
    addedToBasketMessage: "Ihr Artikel wurde in den Warenkorb gelegt.",
    continueShopping: "Weiter einkaufen",
    backToShopping: "Zurück zum Einkauf",
    goToBasket: "Zum Warenkorb",
    customer: "Kunde",
    customerName: "Name des Kunden",
    customerEmail: "E-Mail des Kunden",
    customerPhone: "Telefon des Kunden",
    addCustomerNote: "Ich möchte eine Notiz hinzufügen",
    customerNote: "Notiz",
    sendReceipt: "Senden Sie mir einen Zahlungsbeleg",
    issueForCompany: "Beleg auf Firma ausstellen",
    invoiceName: "Name",
    invoiceCompany: "Firma",
    invoiceVat: "USt-IdNr.",
    invoiceAddress: "Adresse",
    invoiceCity: "Stadt / Region",
    invoiceZip: "PLZ",
    invoiceCountry: "Land",
    participant: "Teilnehmer",
    customerIsParticipant: "Kunde ist auch Teilnehmer.",
    participantName: "Name des Teilnehmers",
    participantPhone: "Telefon des Teilnehmers",
    participantEmail: "E-Mail des Teilnehmers",
    separateParticipants: "Für jede Position einen eigenen Teilnehmer angeben",
    payment: "Zahlung",
    checkout: "Kasse",
    agreeTerms: "Ich akzeptiere die",
    termsLinkText: "Allgemeinen Geschäftsbedingungen",
    payNow: "Weiter zur Zahlung",
    total: "Gesamt",
    price: "Preis",
    inclTaxes: "Inkl. MwSt. und Gebühren",
    changeCurrency: "Währung ändern",
    chooseCurrency: "Zahlungswährung wählen",
    currencyExplanation: "Wir legen unsere eigenen Wechselkurse fest – wir bemühen uns, dass sie sowohl für Sie als auch für uns fairer sind als der Kartenumrechnungskurs Ihrer Bank. Vergleichen Sie unten den Gesamtbetrag der Bestellung in den einzelnen Währungen und wählen Sie die, die zu Ihrem Bankkonto passt.",
    currencyColumnCurrency: "Währung",
    currencyColumnRate: "Unser Kurs",
    book: "Buchen",
    book_button: "Buchen",
    bookNow: "Jetzt buchen",
    validationRequired: "Dieses Feld ist erforderlich.",
    validationMinValue: "Mindestwert ist {min}.",
    validationMaxValue: "Höchstwert ist {max}.",
    validationMinLength: "Mindestlänge ist {min} Zeichen.",
    validationMaxLength: "Höchstlänge ist {max} Zeichen.",
    validationInvalidFormat: "Ungültiges Format.",
    validationCustomLocationDetails: "Bitte geben Sie die Details des eigenen Ortes an.",
    counterDecrement: "Verringern",
    counterIncrement: "Erhöhen",
    commodityDetailTitle: "Produktdetails",
    loading: "Wird geladen…",
    noData: "Keine Daten verfügbar.",
    errorPrefix: "Fehler: ",
    retry: "Erneut versuchen",
    errorNetwork: "Der Server konnte nicht erreicht werden. Überprüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
    errorNotFound: "Der angeforderte Inhalt wurde nicht gefunden.",
    errorCommodityNotFound: "Produkt „{commodity}“ wurde nicht gefunden.",
    errorServer: "Der Dienst ist vorübergehend nicht verfügbar. Bitte versuchen Sie es in Kürze erneut.",
    errorGeneric: "Beim Laden ist ein Fehler aufgetreten.",
    errorDetails: "Technische Details",
    errorLeadTimeTooShort: "Es tut uns leid, aber die Buchung von „{commodity}“ für {datetime} kann online nicht mehr vorgenommen werden — dafür ist eine Vorlaufzeit von mindestens {duration} erforderlich. Bitte kontaktieren Sie uns direkt, wir helfen Ihnen gerne weiter.",
    errorPriceBlocked: "Es tut uns leid, aber eine der für „{commodity}“ gewählten Positionen ist am {date} nicht mehr verfügbar. Bitte entfernen Sie sie aus dem Warenkorb oder wählen Sie einen anderen Termin.",
    reviewsTitle: "Kundenbewertungen",
    reviewsEmpty: "Noch keine Bewertungen.",
    reviewsAverage: "Durchschnittliche Bewertung",
    reviewsBasedOn: "Basierend auf {count} Bewertungen",
    reviewsRecommend: "{percent} % würden weiterempfehlen",
    reviewsRecommendOf: "{percent} % von {total} Gästen würden weiterempfehlen",
    reviewsWouldRecommend: "Weiterempfehlung",
    reviewsRecommends: "Empfiehlt weiter",
    reviewsDoesNotRecommend: "Empfiehlt nicht weiter",
    reviewsBreakdown: "Bewertungsübersicht",
    reviewsOverall: "Insgesamt",
    reviewsAnonymous: "Gast",
    reviewsShowMore: "Mehr anzeigen",
    reviewsResponse: "Antwort des Anbieters",
    reviewsResponseBy: "Antwort von {author}",
    reviewsAverageHelp: "Durchschnitt aus {rated} Sternebewertungen von Kunden nach einer abgeschlossenen Buchung ({from} – {to}). Es werden nur veröffentlichte Bewertungen gezählt; der Wert ändert sich je nach den Filtern unten.",
    reviewsRecommendHelp: "Anteil der {total} Gäste, die die Frage „Würden Sie weiterempfehlen“ mit Ja beantwortet haben. Berücksichtigt werden nur veröffentlichte Bewertungen abgeschlossener Buchungen.",
    reviewsFilterLanguage: "Sprache",
    reviewsFilterPeriod: "Zeitraum",
    reviewsFilterRating: "Bewertung",
    reviewsFilterCommodity: "Leistung",
    reviewsFilterAll: "Alle",
    reviewsPeriodAll: "Gesamter Zeitraum",
    reviewsPeriodMonths: "Letzte {months} Monate",
    reviewsRatingMin: "{count}★ und mehr"
  },
  fr: {
    reservation: "Réservation",
    date: "Date",
    changeDate: "Modifier la date",
    hideDate: "Masquer",
    time: "Heure",
    possibleAlternatives: "Alternatives possibles",
    priceList: "Liste des prix",
    priceListSave: "Vous économisez {amount}",
    expandPriceList: "Afficher la liste des prix",
    collapsePriceList: "Masquer la liste des prix",
    showFullPriceList: "Afficher la liste complète des prix",
    showShortPriceList: "Afficher moins de prix",
    pickDate: "Veuillez sélectionner une date avec des créneaux disponibles.",
    discountAvailable: "Remise disponible",
    saveUpTo: "Économisez jusqu'à {percent} %",
    saveExact: "Vous économisez {percent} %",
    addToCart: "Ajouter au panier",
    buyNow: "Acheter maintenant",
    saveChanges: "Enregistrer les modifications",
    cancel: "Annuler",
    confirmTickets: "Confirmer le nombre de billets",
    selectTicketCounts: "Veuillez choisir le nombre de billets",
    ticketDetailsNextStep: "L’étape suivante consiste à configurer chaque billet",
    backToTicketSelection: "Retour à la sélection des billets",
    ticketNumber: "Billet {n}",
    completeForm: "Remplissez les champs marqués d'un astérisque",
    processing: "Traitement en cours…",
    resetForm: "Réinitialiser le formulaire",
    revalidate: "Revalider",
    selectDate: "Veuillez sélectionner une date avec des créneaux disponibles.",
    loadingForm: "Chargement du formulaire…",
    leadTimeWarning: "Cette heure de début approche du délai minimum de réservation et pourrait bientôt ne plus être disponible. Veuillez passer votre commande rapidement.",
    onlineBookingUnavailable: "Cette date ne peut pas être réservée en ligne. Veuillez nous contacter directement pour une offre personnalisée — sous réserve de disponibilité.",
    notBuyableAlone: "Les articles sélectionnés ne peuvent pas être achetés seuls. Veuillez ajouter au moins un autre article.",
    soldOut: "Complet",
    priceUnavailable: "Indisponible à cette date",
    customLocation: "Saisir un lieu personnalisé",
    customLocationName: "Nom du lieu",
    customLocationAddress: "Adresse",
    basket: "Panier",
    basketEmpty: "Votre panier est vide.",
    basketItems: "Articles de la commande",
    removeItem: "Retirer l'article",
    removeItemConfirm: "Retirer ?",
    editItem: "Modifier l'article",
    proceedToCheckout: "Passer à la commande",
    backToBasket: "Retour au panier",
    tickets: "Billets",
    addedToBasket: "Ajouté au panier",
    addedToBasketMessage: "Votre article a été ajouté au panier.",
    continueShopping: "Continuer mes achats",
    backToShopping: "Retour aux achats",
    goToBasket: "Aller au panier",
    customer: "Client",
    customerName: "Nom du client",
    customerEmail: "E-mail du client",
    customerPhone: "Téléphone du client",
    addCustomerNote: "Je souhaite ajouter une note",
    customerNote: "Note",
    sendReceipt: "M'envoyer un reçu de paiement",
    issueForCompany: "Émettre un reçu pour une entreprise",
    invoiceName: "Nom",
    invoiceCompany: "Société",
    invoiceVat: "N° TVA",
    invoiceAddress: "Adresse",
    invoiceCity: "Ville / région",
    invoiceZip: "Code postal",
    invoiceCountry: "Pays",
    participant: "Participant",
    customerIsParticipant: "Le client est aussi le participant.",
    participantName: "Nom du participant",
    participantPhone: "Téléphone du participant",
    participantEmail: "E-mail du participant",
    separateParticipants: "Renseigner un participant différent pour chaque article",
    payment: "Paiement",
    checkout: "Commande",
    agreeTerms: "J'accepte les",
    termsLinkText: "conditions générales",
    payNow: "Continuer vers le paiement",
    total: "Total",
    price: "Prix",
    inclTaxes: "TVA et frais inclus",
    changeCurrency: "Changer de devise",
    chooseCurrency: "Choisissez la devise de paiement",
    currencyExplanation: "Nous fixons nos propres taux de change – nous cherchons à les rendre plus avantageux, pour vous comme pour nous, que le taux de conversion appliqué par votre banque lors du paiement par carte. Comparez ci-dessous le total de la commande dans chaque devise et choisissez celle qui correspond à votre compte bancaire.",
    currencyColumnCurrency: "Devise",
    currencyColumnRate: "Notre taux",
    book: "Réserver",
    book_button: "Réserver",
    bookNow: "Réserver maintenant",
    validationRequired: "Ce champ est obligatoire.",
    validationMinValue: "La valeur minimale est {min}.",
    validationMaxValue: "La valeur maximale est {max}.",
    validationMinLength: "La longueur minimale est de {min} caractères.",
    validationMaxLength: "La longueur maximale est de {max} caractères.",
    validationInvalidFormat: "Format invalide.",
    validationCustomLocationDetails: "Veuillez compléter les détails du lieu personnalisé.",
    counterDecrement: "Diminuer",
    counterIncrement: "Augmenter",
    commodityDetailTitle: "Détails du produit",
    loading: "Chargement…",
    noData: "Aucune donnée disponible.",
    errorPrefix: "Erreur : ",
    retry: "Réessayer",
    errorNetwork: "Impossible de contacter le serveur. Vérifiez votre connexion et réessayez.",
    errorNotFound: "Le contenu demandé est introuvable.",
    errorCommodityNotFound: "Le produit « {commodity} » est introuvable.",
    errorServer: "Le service est temporairement indisponible. Veuillez réessayer dans quelques instants.",
    errorGeneric: "Une erreur est survenue lors du chargement.",
    errorDetails: "Détails techniques",
    errorLeadTimeTooShort: "Nous sommes désolés, il est trop tard pour réserver « {commodity} » pour {datetime} en ligne — cette réservation nécessite un délai d'au moins {duration}. Contactez-nous directement, nous ferons de notre mieux pour vous aider.",
    errorPriceBlocked: "Nous sommes désolés, l'un des articles choisis pour « {commodity} » n'est plus disponible le {date}. Veuillez le retirer de votre panier ou choisir une autre date.",
    reviewsTitle: "Avis clients",
    reviewsEmpty: "Aucun avis pour le moment.",
    reviewsAverage: "Note moyenne",
    reviewsBasedOn: "Basé sur {count} avis",
    reviewsRecommend: "{percent} % recommandent",
    reviewsRecommendOf: "{percent} % des {total} clients recommandent",
    reviewsWouldRecommend: "de recommandation",
    reviewsRecommends: "Recommande",
    reviewsDoesNotRecommend: "Ne recommande pas",
    reviewsBreakdown: "Répartition des notes",
    reviewsOverall: "Global",
    reviewsAnonymous: "Client",
    reviewsShowMore: "Afficher plus",
    reviewsResponse: "Réponse du prestataire",
    reviewsResponseBy: "Réponse de {author}",
    reviewsAverageHelp: "Moyenne de {rated} évaluations laissées par des clients après une réservation terminée ({from} – {to}). Seuls les avis publiés sont comptabilisés ; la valeur évolue selon les filtres ci-dessous.",
    reviewsRecommendHelp: "Part des {total} clients ayant répondu « oui » à la question « recommanderiez-vous ». Calculée uniquement à partir des avis publiés de réservations terminées.",
    reviewsFilterLanguage: "Langue",
    reviewsFilterPeriod: "Période",
    reviewsFilterRating: "Note",
    reviewsFilterCommodity: "Service",
    reviewsFilterAll: "Tous",
    reviewsPeriodAll: "Toute la période",
    reviewsPeriodMonths: "Les {months} derniers mois",
    reviewsRatingMin: "{count}★ et plus"
  },
  es: {
    reservation: "Reserva",
    date: "Fecha",
    changeDate: "Cambiar fecha",
    hideDate: "Ocultar",
    time: "Hora",
    possibleAlternatives: "Posibles alternativas",
    priceList: "Lista de precios",
    expandPriceList: "Mostrar lista de precios",
    collapsePriceList: "Ocultar lista de precios",
    showFullPriceList: "Mostrar la lista de precios completa",
    showShortPriceList: "Mostrar menos precios",
    priceListSave: "Ahorras {amount}",
    pickDate: "Seleccione una fecha con horarios disponibles.",
    discountAvailable: "Descuento disponible",
    saveUpTo: "Ahorra hasta el {percent} %",
    saveExact: "Ahorras el {percent} %",
    addToCart: "Añadir al carrito",
    buyNow: "Comprar ahora",
    saveChanges: "Guardar cambios",
    cancel: "Cancelar",
    confirmTickets: "Confirmar número de entradas",
    selectTicketCounts: "Seleccione el número de entradas",
    ticketDetailsNextStep: "En el siguiente paso configurará cada entrada",
    backToTicketSelection: "Volver a la selección de entradas",
    ticketNumber: "Entrada {n}",
    completeForm: "Complete los campos marcados con un asterisco",
    processing: "Procesando…",
    resetForm: "Restablecer formulario",
    revalidate: "Revalidar",
    selectDate: "Seleccione una fecha con horarios disponibles.",
    loadingForm: "Cargando formulario…",
    leadTimeWarning: "Esta hora de inicio se acerca al plazo mínimo de reserva y podría dejar de estar disponible pronto. Realice su pedido cuanto antes.",
    onlineBookingUnavailable: "Esta fecha no se puede reservar en línea. Póngase en contacto con nosotros directamente para una oferta personalizada, según disponibilidad.",
    notBuyableAlone: "Los artículos seleccionados no se pueden comprar por separado. Añada al menos otro artículo.",
    soldOut: "Agotado",
    priceUnavailable: "No disponible en esta fecha",
    customLocation: "Introducir ubicación personalizada",
    customLocationName: "Nombre de la ubicación",
    customLocationAddress: "Dirección",
    basket: "Cesta",
    basketEmpty: "Tu cesta está vacía.",
    basketItems: "Artículos del pedido",
    removeItem: "Eliminar artículo",
    removeItemConfirm: "¿Eliminar?",
    editItem: "Editar artículo",
    proceedToCheckout: "Ir al pedido",
    backToBasket: "Volver a la cesta",
    tickets: "Entradas",
    addedToBasket: "Añadido a la cesta",
    addedToBasketMessage: "Tu artículo se ha añadido a la cesta.",
    continueShopping: "Seguir comprando",
    backToShopping: "Volver a comprar",
    goToBasket: "Ir a la cesta",
    customer: "Cliente",
    customerName: "Nombre del cliente",
    customerEmail: "Correo del cliente",
    customerPhone: "Teléfono del cliente",
    addCustomerNote: "Quiero añadir una nota",
    customerNote: "Nota",
    sendReceipt: "Enviarme un recibo de pago",
    issueForCompany: "Emitir recibo para una empresa",
    invoiceName: "Nombre",
    invoiceCompany: "Empresa",
    invoiceVat: "NIF/CIF",
    invoiceAddress: "Dirección",
    invoiceCity: "Ciudad / región",
    invoiceZip: "Código postal",
    invoiceCountry: "País",
    participant: "Participante",
    customerIsParticipant: "El cliente también es el participante.",
    participantName: "Nombre del participante",
    participantPhone: "Teléfono del participante",
    participantEmail: "Correo del participante",
    separateParticipants: "Indicar un participante distinto para cada artículo",
    payment: "Pago",
    checkout: "Finalizar compra",
    agreeTerms: "Acepto los",
    termsLinkText: "términos y condiciones",
    payNow: "Continuar al pago",
    total: "Total",
    price: "Precio",
    inclTaxes: "IVA y gastos incluidos",
    changeCurrency: "Cambiar moneda",
    chooseCurrency: "Elija la moneda de pago",
    currencyExplanation: "Establecemos nuestros propios tipos de cambio: intentamos que sean más ventajosos, tanto para usted como para nosotros, que el tipo de conversión que aplicaría su banco al pagar con tarjeta. Compare a continuación el total del pedido en cada moneda y elija la que coincida con su cuenta bancaria.",
    currencyColumnCurrency: "Moneda",
    currencyColumnRate: "Nuestro tipo",
    book: "Reservar",
    book_button: "Reservar",
    bookNow: "Reservar ahora",
    validationRequired: "Este campo es obligatorio.",
    validationMinValue: "El valor mínimo es {min}.",
    validationMaxValue: "El valor máximo es {max}.",
    validationMinLength: "La longitud mínima es {min} caracteres.",
    validationMaxLength: "La longitud máxima es {max} caracteres.",
    validationInvalidFormat: "Formato no válido.",
    validationCustomLocationDetails: "Complete los detalles de la ubicación personalizada.",
    counterDecrement: "Disminuir",
    counterIncrement: "Aumentar",
    commodityDetailTitle: "Detalle del producto",
    loading: "Cargando…",
    noData: "No hay datos disponibles.",
    errorPrefix: "Error: ",
    retry: "Reintentar",
    errorNetwork: "No se pudo conectar con el servidor. Compruebe su conexión e inténtelo de nuevo.",
    errorNotFound: "No se ha encontrado el contenido solicitado.",
    errorCommodityNotFound: "No se encontró el producto «{commodity}».",
    errorServer: "El servicio no está disponible temporalmente. Inténtelo de nuevo en unos instantes.",
    errorGeneric: "Se produjo un error al cargar.",
    errorDetails: "Detalles técnicos",
    errorLeadTimeTooShort: "Lo sentimos, ya es demasiado tarde para reservar «{commodity}» para el {datetime} en línea — esta reserva requiere un aviso de al menos {duration}. Póngase en contacto con nosotros directamente y haremos todo lo posible por ayudarle.",
    errorPriceBlocked: "Lo sentimos, uno de los artículos elegidos para «{commodity}» ya no está disponible el {date}. Elimínelo de su cesta o elija otra fecha.",
    reviewsTitle: "Opiniones de los clientes",
    reviewsEmpty: "Todavía no hay opiniones.",
    reviewsAverage: "Valoración media",
    reviewsBasedOn: "Basado en {count} opiniones",
    reviewsRecommend: "{percent} % recomienda",
    reviewsRecommendOf: "{percent} % de {total} huéspedes recomienda",
    reviewsWouldRecommend: "de recomendación",
    reviewsRecommends: "Recomienda",
    reviewsDoesNotRecommend: "No recomienda",
    reviewsBreakdown: "Desglose de valoraciones",
    reviewsOverall: "General",
    reviewsAnonymous: "Huésped",
    reviewsShowMore: "Mostrar más",
    reviewsResponse: "Respuesta del proveedor",
    reviewsResponseBy: "Respuesta de {author}",
    reviewsAverageHelp: "Media de {rated} valoraciones con estrellas dejadas por clientes tras una reserva completada ({from} – {to}). Solo se cuentan las opiniones publicadas; el valor cambia según los filtros de abajo.",
    reviewsRecommendHelp: "Porcentaje de los {total} huéspedes que respondieron «sí» a la pregunta de si recomendarían. Se calcula solo a partir de opiniones publicadas de reservas completadas.",
    reviewsFilterLanguage: "Idioma",
    reviewsFilterPeriod: "Período",
    reviewsFilterRating: "Valoración",
    reviewsFilterCommodity: "Servicio",
    reviewsFilterAll: "Todos",
    reviewsPeriodAll: "Todo el período",
    reviewsPeriodMonths: "Últimos {months} meses",
    reviewsRatingMin: "{count}★ o más"
  },
  it: {
    reservation: "Prenotazione",
    date: "Data",
    changeDate: "Cambia data",
    hideDate: "Nascondi",
    time: "Ora",
    possibleAlternatives: "Possibili alternative",
    priceList: "Listino prezzi",
    expandPriceList: "Mostra listino prezzi",
    collapsePriceList: "Nascondi listino prezzi",
    showFullPriceList: "Mostra il listino prezzi completo",
    showShortPriceList: "Mostra meno prezzi",
    priceListSave: "Risparmi {amount}",
    pickDate: "Seleziona una data con slot disponibili.",
    discountAvailable: "Sconto disponibile",
    saveUpTo: "Risparmia fino al {percent} %",
    saveExact: "Risparmi il {percent} %",
    addToCart: "Aggiungi al carrello",
    buyNow: "Acquista ora",
    saveChanges: "Salva modifiche",
    cancel: "Annulla",
    confirmTickets: "Conferma il numero di biglietti",
    selectTicketCounts: "Seleziona il numero di biglietti",
    ticketDetailsNextStep: "Nel passaggio successivo configurerai ogni biglietto",
    backToTicketSelection: "Torna alla selezione dei biglietti",
    ticketNumber: "Biglietto {n}",
    completeForm: "Compila i campi contrassegnati con un asterisco",
    processing: "Elaborazione in corso…",
    resetForm: "Reimposta modulo",
    revalidate: "Riconvalida",
    selectDate: "Seleziona una data con slot disponibili.",
    loadingForm: "Caricamento modulo…",
    leadTimeWarning: "Questo orario di inizio si avvicina al termine minimo di prenotazione e potrebbe presto non essere più disponibile. Effettua l'ordine al più presto.",
    onlineBookingUnavailable: "Questa data non può essere prenotata online. Contattaci direttamente per un'offerta personalizzata, in base alla disponibilità.",
    notBuyableAlone: "Gli articoli selezionati non possono essere acquistati singolarmente. Aggiungi almeno un altro articolo.",
    soldOut: "Esaurito",
    priceUnavailable: "Non disponibile in questa data",
    customLocation: "Inserisci posizione personalizzata",
    customLocationName: "Nome della posizione",
    customLocationAddress: "Indirizzo",
    basket: "Carrello",
    basketEmpty: "Il tuo carrello è vuoto.",
    basketItems: "Articoli dell'ordine",
    removeItem: "Rimuovi articolo",
    removeItemConfirm: "Rimuovere?",
    editItem: "Modifica articolo",
    proceedToCheckout: "Procedi all'ordine",
    backToBasket: "Torna al carrello",
    tickets: "Biglietti",
    addedToBasket: "Aggiunto al carrello",
    addedToBasketMessage: "L'articolo è stato aggiunto al carrello.",
    continueShopping: "Continua lo shopping",
    backToShopping: "Torna agli acquisti",
    goToBasket: "Vai al carrello",
    customer: "Cliente",
    customerName: "Nome del cliente",
    customerEmail: "E-mail del cliente",
    customerPhone: "Telefono del cliente",
    addCustomerNote: "Voglio aggiungere una nota",
    customerNote: "Nota",
    sendReceipt: "Inviami una ricevuta di pagamento",
    issueForCompany: "Emetti ricevuta per un'azienda",
    invoiceName: "Nome",
    invoiceCompany: "Azienda",
    invoiceVat: "P. IVA",
    invoiceAddress: "Indirizzo",
    invoiceCity: "Città / regione",
    invoiceZip: "CAP",
    invoiceCountry: "Paese",
    participant: "Partecipante",
    customerIsParticipant: "Il cliente è anche il partecipante.",
    participantName: "Nome del partecipante",
    participantPhone: "Telefono del partecipante",
    participantEmail: "E-mail del partecipante",
    separateParticipants: "Inserisci un partecipante diverso per ogni articolo",
    payment: "Pagamento",
    checkout: "Cassa",
    agreeTerms: "Accetto i",
    termsLinkText: "termini e condizioni",
    payNow: "Continua al pagamento",
    total: "Totale",
    price: "Prezzo",
    inclTaxes: "IVA e spese incluse",
    changeCurrency: "Cambia valuta",
    chooseCurrency: "Scegli la valuta di pagamento",
    currencyExplanation: "Applichiamo i nostri tassi di cambio – cerchiamo di renderli più vantaggiosi, sia per te che per noi, rispetto al tasso di conversione applicato dalla tua banca per i pagamenti con carta. Confronta di seguito il totale dell'ordine nelle diverse valute e scegli quella corrispondente al tuo conto bancario.",
    currencyColumnCurrency: "Valuta",
    currencyColumnRate: "Il nostro tasso",
    book: "Prenota",
    book_button: "Prenota",
    bookNow: "Prenota ora",
    validationRequired: "Questo campo è obbligatorio.",
    validationMinValue: "Il valore minimo è {min}.",
    validationMaxValue: "Il valore massimo è {max}.",
    validationMinLength: "La lunghezza minima è {min} caratteri.",
    validationMaxLength: "La lunghezza massima è {max} caratteri.",
    validationInvalidFormat: "Formato non valido.",
    validationCustomLocationDetails: "Compila i dettagli della posizione personalizzata.",
    counterDecrement: "Diminuisci",
    counterIncrement: "Aumenta",
    commodityDetailTitle: "Dettagli prodotto",
    loading: "Caricamento…",
    noData: "Nessun dato disponibile.",
    errorPrefix: "Errore: ",
    retry: "Riprova",
    errorNetwork: "Impossibile contattare il server. Controlla la connessione e riprova.",
    errorNotFound: "Il contenuto richiesto non è stato trovato.",
    errorCommodityNotFound: "Il prodotto «{commodity}» non è stato trovato.",
    errorServer: "Il servizio non è temporaneamente disponibile. Riprova tra poco.",
    errorGeneric: "Si è verificato un errore durante il caricamento.",
    errorDetails: "Dettagli tecnici",
    errorLeadTimeTooShort: "Siamo spiacenti, è troppo tardi per prenotare «{commodity}» per il {datetime} online — questa prenotazione richiede un preavviso di almeno {duration}. Contattaci direttamente, faremo del nostro meglio per aiutarti.",
    errorPriceBlocked: "Siamo spiacenti, uno degli articoli scelti per «{commodity}» non è più disponibile il {date}. Rimuovilo dal carrello o scegli un'altra data.",
    reviewsTitle: "Recensioni dei clienti",
    reviewsEmpty: "Ancora nessuna recensione.",
    reviewsAverage: "Valutazione media",
    reviewsBasedOn: "Basato su {count} recensioni",
    reviewsRecommend: "{percent} % consiglia",
    reviewsRecommendOf: "{percent} % di {total} ospiti consiglia",
    reviewsWouldRecommend: "di raccomandazione",
    reviewsRecommends: "Consiglia",
    reviewsDoesNotRecommend: "Non consiglia",
    reviewsBreakdown: "Distribuzione delle valutazioni",
    reviewsOverall: "Complessivo",
    reviewsAnonymous: "Ospite",
    reviewsShowMore: "Mostra altro",
    reviewsResponse: "Risposta del fornitore",
    reviewsResponseBy: "Risposta di {author}",
    reviewsAverageHelp: "Media di {rated} valutazioni a stelle lasciate dai clienti dopo una prenotazione completata ({from} – {to}). Vengono conteggiate solo le recensioni pubblicate; il valore cambia in base ai filtri qui sotto.",
    reviewsRecommendHelp: "Percentuale dei {total} ospiti che hanno risposto «sì» alla domanda se consiglierebbero. Calcolata solo sulle recensioni pubblicate di prenotazioni completate.",
    reviewsFilterLanguage: "Lingua",
    reviewsFilterPeriod: "Periodo",
    reviewsFilterRating: "Valutazione",
    reviewsFilterCommodity: "Servizio",
    reviewsFilterAll: "Tutti",
    reviewsPeriodAll: "Tutto il periodo",
    reviewsPeriodMonths: "Ultimi {months} mesi",
    reviewsRatingMin: "{count}★ e oltre"
  },
  pl: {
    reservation: "Rezerwacja",
    date: "Data",
    changeDate: "Zmień datę",
    hideDate: "Ukryj",
    time: "Godzina",
    possibleAlternatives: "Możliwe alternatywy",
    priceList: "Cennik",
    expandPriceList: "Pokaż cennik",
    collapsePriceList: "Ukryj cennik",
    showFullPriceList: "Pokaż pełny cennik",
    showShortPriceList: "Pokaż mniej cen",
    priceListSave: "Oszczędzasz {amount}",
    pickDate: "Wybierz datę z dostępnymi terminami.",
    discountAvailable: "Dostępna zniżka",
    saveUpTo: "Oszczędzasz do {percent}%",
    saveExact: "Oszczędzasz {percent}%",
    addToCart: "Dodaj do koszyka",
    buyNow: "Kup teraz",
    saveChanges: "Zapisz zmiany",
    cancel: "Anuluj",
    confirmTickets: "Potwierdź liczbę biletów",
    selectTicketCounts: "Wybierz liczbę biletów",
    ticketDetailsNextStep: "W następnym kroku skonfigurujesz poszczególne bilety",
    backToTicketSelection: "Powrót do wyboru biletów",
    ticketNumber: "Bilet {n}",
    completeForm: "Wypełnij pola oznaczone gwiazdką",
    processing: "Przetwarzanie…",
    resetForm: "Resetuj formularz",
    revalidate: "Sprawdź ponownie",
    selectDate: "Wybierz datę z dostępnymi terminami.",
    loadingForm: "Ładowanie formularza…",
    leadTimeWarning: "Ta godzina rozpoczęcia zbliża się do minimalnego wyprzedzenia rezerwacji i może wkrótce stać się niedostępna. Prosimy o jak najszybsze złożenie zamówienia.",
    onlineBookingUnavailable: "Tego terminu nie można zarezerwować online. Skontaktuj się z nami bezpośrednio w sprawie indywidualnej oferty — w zależności od dostępności.",
    notBuyableAlone: "Wybranych pozycji nie można kupić osobno. Dodaj co najmniej jedną inną pozycję.",
    soldOut: "Wyprzedane",
    priceUnavailable: "Niedostępne w tym terminie",
    customLocation: "Wprowadź własną lokalizację",
    customLocationName: "Nazwa lokalizacji",
    customLocationAddress: "Adres",
    basket: "Koszyk",
    basketEmpty: "Twój koszyk jest pusty.",
    basketItems: "Pozycje zamówienia",
    removeItem: "Usuń pozycję",
    removeItemConfirm: "Usunąć?",
    editItem: "Edytuj pozycję",
    proceedToCheckout: "Przejdź do zamówienia",
    backToBasket: "Powrót do koszyka",
    tickets: "Bilety",
    addedToBasket: "Dodano do koszyka",
    addedToBasketMessage: "Pozycja została dodana do koszyka.",
    continueShopping: "Kontynuuj zakupy",
    backToShopping: "Powrót do zakupów",
    goToBasket: "Przejdź do koszyka",
    customer: "Klient",
    customerName: "Imię i nazwisko klienta",
    customerEmail: "E-mail klienta",
    customerPhone: "Telefon klienta",
    addCustomerNote: "Chcę dodać notatkę",
    customerNote: "Notatka",
    sendReceipt: "Wyślij mi potwierdzenie płatności",
    issueForCompany: "Wystaw fakturę na firmę",
    invoiceName: "Imię i nazwisko",
    invoiceCompany: "Firma",
    invoiceVat: "NIP",
    invoiceAddress: "Adres",
    invoiceCity: "Miasto / region",
    invoiceZip: "Kod pocztowy",
    invoiceCountry: "Kraj",
    participant: "Uczestnik",
    customerIsParticipant: "Klient jest również uczestnikiem.",
    participantName: "Imię i nazwisko uczestnika",
    participantPhone: "Telefon uczestnika",
    participantEmail: "E-mail uczestnika",
    separateParticipants: "Wypełnij dane innego uczestnika dla każdej pozycji",
    payment: "Płatność",
    checkout: "Kasa",
    agreeTerms: "Akceptuję",
    termsLinkText: "regulamin",
    payNow: "Przejdź do płatności",
    total: "Razem",
    price: "Cena",
    inclTaxes: "Z VAT i opłatami",
    changeCurrency: "Zmień walutę",
    chooseCurrency: "Wybierz walutę płatności",
    currencyExplanation: "Stosujemy własne kursy wymiany – staramy się, aby były korzystniejsze zarówno dla Ciebie, jak i dla nas, niż kurs przeliczeniowy zastosowany przez Twój bank przy płatności kartą. Porównaj poniżej łączną kwotę zamówienia w poszczególnych walutach i wybierz tę, która odpowiada Twojemu kontu bankowemu.",
    currencyColumnCurrency: "Waluta",
    currencyColumnRate: "Nasz kurs",
    book: "Zarezerwuj",
    book_button: "Zamów",
    bookNow: "Zamów teraz",
    validationRequired: "To pole jest wymagane.",
    validationMinValue: "Minimalna wartość to {min}.",
    validationMaxValue: "Maksymalna wartość to {max}.",
    validationMinLength: "Minimalna długość to {min} znaków.",
    validationMaxLength: "Maksymalna długość to {max} znaków.",
    validationInvalidFormat: "Nieprawidłowy format.",
    validationCustomLocationDetails: "Wypełnij szczegóły własnej lokalizacji.",
    counterDecrement: "Zmniejsz",
    counterIncrement: "Zwiększ",
    commodityDetailTitle: "Szczegóły produktu",
    loading: "Ładowanie…",
    noData: "Brak dostępnych danych.",
    errorPrefix: "Błąd: ",
    retry: "Spróbuj ponownie",
    errorNetwork: "Nie udało się połączyć z serwerem. Sprawdź połączenie i spróbuj ponownie.",
    errorNotFound: "Nie znaleziono żądanej zawartości.",
    errorCommodityNotFound: "Nie znaleziono produktu „{commodity}”.",
    errorServer: "Usługa jest chwilowo niedostępna. Spróbuj ponownie za chwilę.",
    errorGeneric: "Wystąpił błąd podczas ładowania.",
    errorDetails: "Szczegóły techniczne",
    errorLeadTimeTooShort: "Przykro nam, ale zamówienia „{commodity}” na {datetime} nie można już złożyć online — wymaga ono co najmniej {duration} wyprzedzenia. Skontaktuj się z nami bezpośrednio, chętnie pomożemy.",
    errorPriceBlocked: "Przykro nam, ale jedna z wybranych pozycji dla „{commodity}” nie jest już dostępna w dniu {date}. Usuń ją z koszyka lub wybierz inny termin.",
    reviewsTitle: "Opinie klientów",
    reviewsEmpty: "Brak opinii.",
    reviewsAverage: "Średnia ocena",
    reviewsBasedOn: "Na podstawie {count} opinii",
    reviewsRecommend: "{percent}% poleca",
    reviewsRecommendOf: "{percent}% z {total} gości poleca",
    reviewsWouldRecommend: "poleca",
    reviewsRecommends: "Poleca",
    reviewsDoesNotRecommend: "Nie poleca",
    reviewsBreakdown: "Rozkład ocen",
    reviewsOverall: "Ogółem",
    reviewsAnonymous: "Gość",
    reviewsShowMore: "Pokaż więcej",
    reviewsResponse: "Odpowiedź usługodawcy",
    reviewsResponseBy: "Odpowiedź od {author}",
    reviewsAverageHelp: "Średnia z {rated} ocen w gwiazdkach wystawionych przez klientów po zakończonej rezerwacji ({from} – {to}). Liczone są tylko opublikowane opinie; wartość zmienia się w zależności od filtrów poniżej.",
    reviewsRecommendHelp: "Odsetek {total} gości, którzy odpowiedzieli „tak” na pytanie, czy poleciliby. Liczony tylko na podstawie opublikowanych opinii z zakończonych rezerwacji.",
    reviewsFilterLanguage: "Język",
    reviewsFilterPeriod: "Okres",
    reviewsFilterRating: "Ocena",
    reviewsFilterCommodity: "Usługa",
    reviewsFilterAll: "Wszystkie",
    reviewsPeriodAll: "Cały okres",
    reviewsPeriodMonths: "Ostatnie {months} mies.",
    reviewsRatingMin: "{count}★ i więcej"
  },
  pt: {
    reservation: "Reserva",
    date: "Data",
    changeDate: "Alterar data",
    hideDate: "Ocultar",
    time: "Hora",
    possibleAlternatives: "Alternativas possíveis",
    priceList: "Lista de preços",
    expandPriceList: "Mostrar lista de preços",
    collapsePriceList: "Ocultar lista de preços",
    showFullPriceList: "Mostrar lista de preços completa",
    showShortPriceList: "Mostrar menos preços",
    priceListSave: "Poupa {amount}",
    pickDate: "Selecione uma data com horários disponíveis.",
    discountAvailable: "Desconto disponível",
    saveUpTo: "Poupe até {percent} %",
    saveExact: "Poupa {percent} %",
    addToCart: "Adicionar ao carrinho",
    buyNow: "Comprar agora",
    saveChanges: "Guardar alterações",
    cancel: "Cancelar",
    confirmTickets: "Confirmar número de bilhetes",
    selectTicketCounts: "Selecione o número de bilhetes",
    ticketDetailsNextStep: "No próximo passo, irá configurar cada bilhete",
    backToTicketSelection: "Voltar à seleção de bilhetes",
    ticketNumber: "Bilhete {n}",
    completeForm: "Preencha os campos marcados com um asterisco",
    processing: "A processar…",
    resetForm: "Repor formulário",
    revalidate: "Revalidar",
    selectDate: "Selecione uma data com horários disponíveis.",
    loadingForm: "A carregar formulário…",
    leadTimeWarning: "Esta hora de início está próxima do prazo mínimo de reserva e pode deixar de estar disponível em breve. Por favor, faça a sua encomenda o mais rapidamente possível.",
    onlineBookingUnavailable: "Esta data não pode ser reservada online. Contacte-nos diretamente para uma oferta personalizada — sujeita a disponibilidade.",
    notBuyableAlone: "Os itens selecionados não podem ser comprados isoladamente. Adicione pelo menos mais um item.",
    soldOut: "Esgotado",
    priceUnavailable: "Indisponível nesta data",
    customLocation: "Introduzir local personalizado",
    customLocationName: "Nome do local",
    customLocationAddress: "Endereço",
    basket: "Carrinho",
    basketEmpty: "O seu carrinho está vazio.",
    basketItems: "Itens do pedido",
    removeItem: "Remover item",
    removeItemConfirm: "Remover?",
    editItem: "Editar item",
    proceedToCheckout: "Ir para o pedido",
    backToBasket: "Voltar ao carrinho",
    tickets: "Bilhetes",
    addedToBasket: "Adicionado ao carrinho",
    addedToBasketMessage: "O seu item foi adicionado ao carrinho.",
    continueShopping: "Continuar a comprar",
    backToShopping: "Voltar às compras",
    goToBasket: "Ir para o carrinho",
    customer: "Cliente",
    customerName: "Nome do cliente",
    customerEmail: "E-mail do cliente",
    customerPhone: "Telefone do cliente",
    addCustomerNote: "Quero adicionar uma nota",
    customerNote: "Nota",
    sendReceipt: "Enviem-me um comprovativo de pagamento",
    issueForCompany: "Emitir recibo para empresa",
    invoiceName: "Nome",
    invoiceCompany: "Empresa",
    invoiceVat: "NIF",
    invoiceAddress: "Endereço",
    invoiceCity: "Cidade / região",
    invoiceZip: "Código postal",
    invoiceCountry: "País",
    participant: "Participante",
    customerIsParticipant: "O cliente é também o participante.",
    participantName: "Nome do participante",
    participantPhone: "Telefone do participante",
    participantEmail: "E-mail do participante",
    separateParticipants: "Preencher um participante diferente para cada item",
    payment: "Pagamento",
    checkout: "Finalizar compra",
    agreeTerms: "Concordo com os",
    termsLinkText: "termos e condições",
    payNow: "Continuar para o pagamento",
    total: "Total",
    price: "Preço",
    inclTaxes: "Inclui IVA e taxas",
    changeCurrency: "Alterar moeda",
    chooseCurrency: "Escolha a moeda de pagamento",
    currencyExplanation: "Definimos as nossas próprias taxas de câmbio – procuramos torná-las mais vantajosas, tanto para si como para nós, do que a taxa de conversão que o seu banco aplicaria ao pagamento com cartão. Compare abaixo o total da encomenda em cada moeda e escolha a que corresponde à sua conta bancária.",
    currencyColumnCurrency: "Moeda",
    currencyColumnRate: "A nossa taxa",
    book: "Reservar",
    book_button: "Reservar",
    bookNow: "Reservar agora",
    validationRequired: "Este campo é obrigatório.",
    validationMinValue: "O valor mínimo é {min}.",
    validationMaxValue: "O valor máximo é {max}.",
    validationMinLength: "O comprimento mínimo é {min} caracteres.",
    validationMaxLength: "O comprimento máximo é {max} caracteres.",
    validationInvalidFormat: "Formato inválido.",
    validationCustomLocationDetails: "Preencha os detalhes do local personalizado.",
    counterDecrement: "Diminuir",
    counterIncrement: "Aumentar",
    commodityDetailTitle: "Detalhes do produto",
    loading: "A carregar…",
    noData: "Sem dados disponíveis.",
    errorPrefix: "Erro: ",
    retry: "Tentar novamente",
    errorNetwork: "Não foi possível contactar o servidor. Verifique a sua ligação e tente novamente.",
    errorNotFound: "O conteúdo solicitado não foi encontrado.",
    errorCommodityNotFound: "O produto «{commodity}» não foi encontrado.",
    errorServer: "O serviço está temporariamente indisponível. Tente novamente dentro de instantes.",
    errorGeneric: "Ocorreu um erro ao carregar.",
    errorDetails: "Detalhes técnicos",
    errorLeadTimeTooShort: "Lamentamos, mas já não é possível reservar «{commodity}» para {datetime} online — esta reserva requer um aviso prévio de, pelo menos, {duration}. Contacte-nos diretamente e faremos os possíveis para ajudar.",
    errorPriceBlocked: "Lamentamos, mas um dos itens escolhidos para «{commodity}» já não está disponível em {date}. Remova-o do carrinho ou escolha outra data.",
    reviewsTitle: "Avaliações dos clientes",
    reviewsEmpty: "Ainda sem avaliações.",
    reviewsAverage: "Avaliação média",
    reviewsBasedOn: "Baseado em {count} avaliações",
    reviewsRecommend: "{percent} % recomendam",
    reviewsRecommendOf: "{percent} % de {total} hóspedes recomendam",
    reviewsWouldRecommend: "recomendam",
    reviewsRecommends: "Recomenda",
    reviewsDoesNotRecommend: "Não recomenda",
    reviewsBreakdown: "Distribuição das avaliações",
    reviewsOverall: "Geral",
    reviewsAnonymous: "Hóspede",
    reviewsShowMore: "Mostrar mais",
    reviewsResponse: "Resposta do prestador",
    reviewsResponseBy: "Resposta de {author}",
    reviewsAverageHelp: "Média de {rated} avaliações em estrelas deixadas por clientes após uma reserva concluída ({from} – {to}). São contabilizadas apenas as avaliações publicadas; o valor muda consoante os filtros abaixo.",
    reviewsRecommendHelp: "Percentagem dos {total} hóspedes que responderam «sim» à pergunta se recomendariam. Calculada apenas com base em avaliações publicadas de reservas concluídas.",
    reviewsFilterLanguage: "Idioma",
    reviewsFilterPeriod: "Período",
    reviewsFilterRating: "Avaliação",
    reviewsFilterCommodity: "Serviço",
    reviewsFilterAll: "Todos",
    reviewsPeriodAll: "Todo o período",
    reviewsPeriodMonths: "Últimos {months} meses",
    reviewsRatingMin: "{count}★ ou mais"
  },
  ru: {
    reservation: "Бронирование",
    date: "Дата",
    changeDate: "Изменить дату",
    hideDate: "Скрыть",
    time: "Время",
    possibleAlternatives: "Возможные альтернативы",
    priceList: "Прайс-лист",
    expandPriceList: "Показать прайс-лист",
    collapsePriceList: "Скрыть прайс-лист",
    showFullPriceList: "Показать весь прайс-лист",
    showShortPriceList: "Показать меньше цен",
    priceListSave: "Вы экономите {amount}",
    pickDate: "Пожалуйста, выберите дату с доступным временем.",
    discountAvailable: "Доступна скидка",
    saveUpTo: "Экономия до {percent}%",
    saveExact: "Вы экономите {percent}%",
    addToCart: "Добавить в корзину",
    buyNow: "Купить сейчас",
    saveChanges: "Сохранить изменения",
    cancel: "Отмена",
    confirmTickets: "Подтвердить количество билетов",
    selectTicketCounts: "Выберите количество билетов",
    ticketDetailsNextStep: "На следующем шаге вы настроите каждый билет",
    backToTicketSelection: "Назад к выбору билетов",
    ticketNumber: "Билет {n}",
    completeForm: "Заполните поля, отмеченные звёздочкой",
    processing: "Обработка…",
    resetForm: "Сбросить форму",
    revalidate: "Проверить заново",
    selectDate: "Пожалуйста, выберите дату с доступным временем.",
    loadingForm: "Загрузка формы…",
    leadTimeWarning: "Это время начала приближается к минимальному сроку бронирования и вскоре может стать недоступным. Пожалуйста, оформите заказ как можно скорее.",
    onlineBookingUnavailable: "Эту дату нельзя забронировать онлайн. Пожалуйста, свяжитесь с нами напрямую для индивидуального предложения — в зависимости от наличия.",
    notBuyableAlone: "Выбранные позиции нельзя приобрести отдельно. Добавьте, пожалуйста, хотя бы ещё одну позицию.",
    soldOut: "Распродано",
    priceUnavailable: "Недоступно в эту дату",
    customLocation: "Указать своё место",
    customLocationName: "Название места",
    customLocationAddress: "Адрес",
    basket: "Корзина",
    basketEmpty: "Ваша корзина пуста.",
    basketItems: "Позиции заказа",
    removeItem: "Удалить позицию",
    removeItemConfirm: "Удалить?",
    editItem: "Изменить позицию",
    proceedToCheckout: "Перейти к заказу",
    backToBasket: "Вернуться в корзину",
    tickets: "Билеты",
    addedToBasket: "Добавлено в корзину",
    addedToBasketMessage: "Товар добавлен в корзину.",
    continueShopping: "Продолжить покупки",
    backToShopping: "Назад к покупкам",
    goToBasket: "Перейти в корзину",
    customer: "Покупатель",
    customerName: "Имя покупателя",
    customerEmail: "E-mail покупателя",
    customerPhone: "Телефон покупателя",
    addCustomerNote: "Хочу добавить примечание",
    customerNote: "Примечание",
    sendReceipt: "Отправьте мне чек об оплате",
    issueForCompany: "Оформить документ на компанию",
    invoiceName: "Имя",
    invoiceCompany: "Компания",
    invoiceVat: "ИНН",
    invoiceAddress: "Адрес",
    invoiceCity: "Город / регион",
    invoiceZip: "Индекс",
    invoiceCountry: "Страна",
    participant: "Участник",
    customerIsParticipant: "Покупатель также является участником.",
    participantName: "Имя участника",
    participantPhone: "Телефон участника",
    participantEmail: "E-mail участника",
    separateParticipants: "Указать отдельного участника для каждой позиции",
    payment: "Оплата",
    checkout: "Оформление заказа",
    agreeTerms: "Я согласен с",
    termsLinkText: "условиями использования",
    payNow: "Перейти к оплате",
    total: "Итого",
    price: "Цена",
    inclTaxes: "Включая НДС и сборы",
    changeCurrency: "Изменить валюту",
    chooseCurrency: "Выберите валюту платежа",
    currencyExplanation: "Мы устанавливаем собственные курсы обмена — мы стремимся сделать их более выгодными как для вас, так и для нас, чем курс конвертации, который применил бы ваш банк при оплате картой. Сравните ниже итоговую сумму заказа в разных валютах и выберите ту, которая соответствует вашему банковскому счёту.",
    currencyColumnCurrency: "Валюта",
    currencyColumnRate: "Наш курс",
    book: "Забронировать",
    book_button: "Заказать",
    bookNow: "Заказать",
    validationRequired: "Это поле обязательно.",
    validationMinValue: "Минимальное значение — {min}.",
    validationMaxValue: "Максимальное значение — {max}.",
    validationMinLength: "Минимальная длина — {min} символов.",
    validationMaxLength: "Максимальная длина — {max} символов.",
    validationInvalidFormat: "Неверный формат.",
    validationCustomLocationDetails: "Пожалуйста, заполните данные о своём месте.",
    counterDecrement: "Уменьшить",
    counterIncrement: "Увеличить",
    commodityDetailTitle: "Детали товара",
    loading: "Загрузка…",
    noData: "Нет данных.",
    errorPrefix: "Ошибка: ",
    retry: "Повторить",
    errorNetwork: "Не удалось связаться с сервером. Проверьте подключение и попробуйте снова.",
    errorNotFound: "Запрошенное содержимое не найдено.",
    errorCommodityNotFound: "Товар «{commodity}» не найден.",
    errorServer: "Сервис временно недоступен. Пожалуйста, повторите попытку через некоторое время.",
    errorGeneric: "При загрузке произошла ошибка.",
    errorDetails: "Технические подробности",
    errorLeadTimeTooShort: "Приносим извинения, но заказ «{commodity}» на {datetime} уже нельзя оформить онлайн — для этого требуется не менее {duration} до начала. Свяжитесь с нами напрямую, мы постараемся помочь.",
    errorPriceBlocked: "Приносим извинения, но одна из выбранных позиций для «{commodity}» больше недоступна на {date}. Удалите её из корзины или выберите другую дату.",
    reviewsTitle: "Отзывы клиентов",
    reviewsEmpty: "Пока нет отзывов.",
    reviewsAverage: "Средний рейтинг",
    reviewsBasedOn: "На основе {count} отзывов",
    reviewsRecommend: "{percent}% рекомендуют",
    reviewsRecommendOf: "{percent}% из {total} гостей рекомендуют",
    reviewsWouldRecommend: "рекомендуют",
    reviewsRecommends: "Рекомендует",
    reviewsDoesNotRecommend: "Не рекомендует",
    reviewsBreakdown: "Распределение оценок",
    reviewsOverall: "Общая оценка",
    reviewsAnonymous: "Гость",
    reviewsShowMore: "Показать больше",
    reviewsResponse: "Ответ поставщика",
    reviewsResponseBy: "Ответ от {author}",
    reviewsAverageHelp: "Среднее значение {rated} оценок в звёздах, оставленных клиентами после завершённого бронирования ({from} – {to}). Учитываются только опубликованные отзывы; значение меняется в зависимости от фильтров ниже.",
    reviewsRecommendHelp: "Доля из {total} гостей, ответивших «да» на вопрос, рекомендовали бы они. Учитываются только опубликованные отзывы о завершённых бронированиях.",
    reviewsFilterLanguage: "Язык",
    reviewsFilterPeriod: "Период",
    reviewsFilterRating: "Рейтинг",
    reviewsFilterCommodity: "Услуга",
    reviewsFilterAll: "Все",
    reviewsPeriodAll: "За всё время",
    reviewsPeriodMonths: "Последние {months} мес.",
    reviewsRatingMin: "{count}★ и выше"
  },
  uk: {
    reservation: "Бронювання",
    date: "Дата",
    changeDate: "Змінити дату",
    hideDate: "Приховати",
    time: "Час",
    possibleAlternatives: "Можливі альтернативи",
    priceList: "Прайс-лист",
    expandPriceList: "Показати прайс-лист",
    collapsePriceList: "Приховати прайс-лист",
    showFullPriceList: "Показати весь прайс-лист",
    showShortPriceList: "Показати менше цін",
    priceListSave: "Ви заощаджуєте {amount}",
    pickDate: "Будь ласка, виберіть дату з доступним часом.",
    discountAvailable: "Доступна знижка",
    saveUpTo: "Заощаджуєте до {percent}%",
    saveExact: "Ви заощаджуєте {percent}%",
    addToCart: "Додати до кошика",
    buyNow: "Купити зараз",
    saveChanges: "Зберегти зміни",
    cancel: "Скасувати",
    confirmTickets: "Підтвердити кількість квитків",
    selectTicketCounts: "Оберіть кількість квитків",
    ticketDetailsNextStep: "На наступному кроці ви налаштуєте кожен квиток",
    backToTicketSelection: "Назад до вибору квитків",
    ticketNumber: "Квиток {n}",
    completeForm: "Заповніть поля, позначені зірочкою",
    processing: "Обробка…",
    resetForm: "Скинути форму",
    revalidate: "Перевірити знову",
    selectDate: "Будь ласка, виберіть дату з доступним часом.",
    loadingForm: "Завантаження форми…",
    leadTimeWarning: "Цей час початку наближається до мінімального терміну бронювання і незабаром може стати недоступним. Будь ласка, оформте замовлення якнайшвидше.",
    onlineBookingUnavailable: "Цю дату не можна забронювати онлайн. Будь ласка, зв'яжіться з нами напряму щодо індивідуальної пропозиції — залежно від наявності.",
    notBuyableAlone: "Обрані позиції не можна придбати окремо. Додайте, будь ласка, принаймні ще одну позицію.",
    soldOut: "Розпродано",
    priceUnavailable: "Недоступно на цю дату",
    customLocation: "Вказати власне місце",
    customLocationName: "Назва місця",
    customLocationAddress: "Адреса",
    basket: "Кошик",
    basketEmpty: "Ваш кошик порожній.",
    basketItems: "Позиції замовлення",
    removeItem: "Видалити позицію",
    removeItemConfirm: "Видалити?",
    editItem: "Редагувати позицію",
    proceedToCheckout: "Перейти до замовлення",
    backToBasket: "Назад до кошика",
    tickets: "Квитки",
    addedToBasket: "Додано до кошика",
    addedToBasketMessage: "Товар додано до кошика.",
    continueShopping: "Продовжити покупки",
    backToShopping: "Назад до покупок",
    goToBasket: "Перейти до кошика",
    customer: "Покупець",
    customerName: "Імʼя покупця",
    customerEmail: "E-mail покупця",
    customerPhone: "Телефон покупця",
    addCustomerNote: "Хочу додати примітку",
    customerNote: "Примітка",
    sendReceipt: "Надіслати мені квитанцію про оплату",
    issueForCompany: "Оформити документ на компанію",
    invoiceName: "Імʼя",
    invoiceCompany: "Компанія",
    invoiceVat: "ЄДРПОУ / ІПН",
    invoiceAddress: "Адреса",
    invoiceCity: "Місто / регіон",
    invoiceZip: "Поштовий індекс",
    invoiceCountry: "Країна",
    participant: "Учасник",
    customerIsParticipant: "Покупець також є учасником.",
    participantName: "Імʼя учасника",
    participantPhone: "Телефон учасника",
    participantEmail: "E-mail учасника",
    separateParticipants: "Вказати окремого учасника для кожної позиції",
    payment: "Оплата",
    checkout: "Оформлення замовлення",
    agreeTerms: "Я погоджуюсь з",
    termsLinkText: "умовами користування",
    payNow: "Перейти до оплати",
    total: "Разом",
    price: "Ціна",
    inclTaxes: "Включаючи ПДВ і збори",
    changeCurrency: "Змінити валюту",
    chooseCurrency: "Виберіть валюту оплати",
    currencyExplanation: "Ми встановлюємо власні курси обміну — прагнемо зробити їх вигіднішими як для вас, так і для нас, ніж курс конвертації, який застосував би ваш банк під час оплати карткою. Порівняйте нижче загальну суму замовлення в різних валютах і оберіть ту, що відповідає вашому банківському рахунку.",
    currencyColumnCurrency: "Валюта",
    currencyColumnRate: "Наш курс",
    book: "Забронювати",
    book_button: "Замовити",
    bookNow: "Замовити",
    validationRequired: "Це поле обовʼязкове.",
    validationMinValue: "Мінімальне значення — {min}.",
    validationMaxValue: "Максимальне значення — {max}.",
    validationMinLength: "Мінімальна довжина — {min} символів.",
    validationMaxLength: "Максимальна довжина — {max} символів.",
    validationInvalidFormat: "Неправильний формат.",
    validationCustomLocationDetails: "Будь ласка, заповніть дані про власне місце.",
    counterDecrement: "Зменшити",
    counterIncrement: "Збільшити",
    commodityDetailTitle: "Деталі товару",
    loading: "Завантаження…",
    noData: "Немає даних.",
    errorPrefix: "Помилка: ",
    retry: "Спробувати ще раз",
    errorNetwork: "Не вдалося з'єднатися із сервером. Перевірте підключення і спробуйте ще раз.",
    errorNotFound: "Запитаний вміст не знайдено.",
    errorCommodityNotFound: "Товар «{commodity}» не знайдено.",
    errorServer: "Сервіс тимчасово недоступний. Будь ласка, спробуйте ще раз трохи згодом.",
    errorGeneric: "Під час завантаження сталася помилка.",
    errorDetails: "Технічні подробиці",
    errorLeadTimeTooShort: "Перепрошуємо, але замовлення «{commodity}» на {datetime} вже не можна оформити онлайн — для цього потрібно щонайменше {duration} до початку. Зв'яжіться з нами напряму, ми постараємося допомогти.",
    errorPriceBlocked: "Перепрошуємо, але одна з вибраних позицій для «{commodity}» більше недоступна на {date}. Видаліть її з кошика або виберіть іншу дату.",
    reviewsTitle: "Відгуки клієнтів",
    reviewsEmpty: "Поки що немає відгуків.",
    reviewsAverage: "Середній рейтинг",
    reviewsBasedOn: "На основі {count} відгуків",
    reviewsRecommend: "{percent}% рекомендують",
    reviewsRecommendOf: "{percent}% із {total} гостей рекомендують",
    reviewsWouldRecommend: "рекомендують",
    reviewsRecommends: "Рекомендує",
    reviewsDoesNotRecommend: "Не рекомендує",
    reviewsBreakdown: "Розподіл оцінок",
    reviewsOverall: "Загальна оцінка",
    reviewsAnonymous: "Гість",
    reviewsShowMore: "Показати більше",
    reviewsResponse: "Відповідь постачальника",
    reviewsResponseBy: "Відповідь від {author}",
    reviewsAverageHelp: "Середнє значення {rated} зіркових оцінок, залишених клієнтами після завершеного бронювання ({from} – {to}). Враховуються лише опубліковані відгуки; значення змінюється залежно від фільтрів нижче.",
    reviewsRecommendHelp: "Частка з {total} гостей, які відповіли «так» на запитання, чи рекомендували б вони. Враховуються лише опубліковані відгуки про завершені бронювання.",
    reviewsFilterLanguage: "Мова",
    reviewsFilterPeriod: "Період",
    reviewsFilterRating: "Рейтинг",
    reviewsFilterCommodity: "Послуга",
    reviewsFilterAll: "Усі",
    reviewsPeriodAll: "За весь час",
    reviewsPeriodMonths: "Останні {months} міс.",
    reviewsRatingMin: "{count}★ і вище"
  },
  hu: {
    reservation: "Foglalás",
    date: "Dátum",
    changeDate: "Dátum módosítása",
    hideDate: "Elrejtés",
    time: "Idő",
    possibleAlternatives: "Lehetséges alternatívák",
    priceList: "Árlista",
    expandPriceList: "Árlista megjelenítése",
    collapsePriceList: "Árlista elrejtése",
    showFullPriceList: "Teljes árlista megjelenítése",
    showShortPriceList: "Kevesebb ár megjelenítése",
    priceListSave: "Megtakarít {amount}",
    pickDate: "Válasszon egy dátumot, amely elérhető időpontokat tartalmaz.",
    discountAvailable: "Kedvezmény elérhető",
    saveUpTo: "Akár {percent}%-ot is megtakaríthat",
    saveExact: "{percent}%-ot takarít meg",
    addToCart: "Kosárba",
    buyNow: "Megveszem most",
    saveChanges: "Módosítások mentése",
    cancel: "Mégse",
    confirmTickets: "Jegyek számának megerősítése",
    selectTicketCounts: "Kérjük, válassza ki a jegyek számát",
    ticketDetailsNextStep: "A következő lépésben az egyes jegyeket állíthatja be",
    backToTicketSelection: "Vissza a jegyválasztáshoz",
    ticketNumber: "{n}. jegy",
    completeForm: "Töltse ki a csillaggal jelölt mezőket",
    processing: "Feldolgozás…",
    resetForm: "Űrlap visszaállítása",
    revalidate: "Újraellenőrzés",
    selectDate: "Válasszon egy dátumot, amely elérhető időpontokat tartalmaz.",
    loadingForm: "Űrlap betöltése…",
    leadTimeWarning: "Ez a kezdési időpont közel van a foglalás minimális határidejéhez, és hamarosan elérhetetlenné válhat. Kérjük, mielőbb adja le a rendelését.",
    onlineBookingUnavailable: "Ez az időpont online nem foglalható. Kérjük, vegye fel velünk közvetlenül a kapcsolatot egyedi ajánlatért — a rendelkezésre állás függvényében.",
    notBuyableAlone: "A kiválasztott tételek önmagukban nem vásárolhatók meg. Kérjük, adjon hozzá legalább még egy tételt.",
    soldOut: "Elfogyott",
    priceUnavailable: "Ezen a napon nem elérhető",
    customLocation: "Egyedi helyszín megadása",
    customLocationName: "Helyszín neve",
    customLocationAddress: "Cím",
    basket: "Kosár",
    basketEmpty: "A kosara üres.",
    basketItems: "Rendelési tételek",
    removeItem: "Tétel eltávolítása",
    removeItemConfirm: "Eltávolítja?",
    editItem: "Tétel szerkesztése",
    proceedToCheckout: "Tovább a rendeléshez",
    backToBasket: "Vissza a kosárhoz",
    tickets: "Jegyek",
    addedToBasket: "Kosárba helyezve",
    addedToBasketMessage: "A tétel hozzáadásra került a kosárhoz.",
    continueShopping: "Vásárlás folytatása",
    backToShopping: "Vissza a vásárláshoz",
    goToBasket: "Kosárhoz",
    customer: "Vásárló",
    customerName: "Vásárló neve",
    customerEmail: "Vásárló e-mail címe",
    customerPhone: "Vásárló telefonszáma",
    addCustomerNote: "Megjegyzést szeretnék hozzáadni",
    customerNote: "Megjegyzés",
    sendReceipt: "Kérek fizetési igazolást",
    issueForCompany: "Számla cégre kiállítása",
    invoiceName: "Név",
    invoiceCompany: "Cég",
    invoiceVat: "Adószám",
    invoiceAddress: "Cím",
    invoiceCity: "Város / régió",
    invoiceZip: "Irányítószám",
    invoiceCountry: "Ország",
    participant: "Résztvevő",
    customerIsParticipant: "A vásárló egyben a résztvevő is.",
    participantName: "Résztvevő neve",
    participantPhone: "Résztvevő telefonszáma",
    participantEmail: "Résztvevő e-mail címe",
    separateParticipants: "Adjon meg külön résztvevőt minden egyes tételhez",
    payment: "Fizetés",
    checkout: "Pénztár",
    agreeTerms: "Elfogadom az",
    termsLinkText: "Általános Szerződési Feltételeket",
    payNow: "Tovább a fizetéshez",
    total: "Összesen",
    price: "Ár",
    inclTaxes: "ÁFÁ-val és díjakkal",
    changeCurrency: "Pénznem módosítása",
    chooseCurrency: "Válassza ki a fizetési pénznemet",
    currencyExplanation: "Saját árfolyamainkat alkalmazzuk – törekszünk arra, hogy ezek mind Ön, mind számunkra kedvezőbbek legyenek, mint a bankja által a kártyás fizetéskor alkalmazott átváltási árfolyam. Hasonlítsa össze alább a rendelés végösszegét az egyes pénznemekben, és válassza ki a bankszámlájának megfelelőt.",
    currencyColumnCurrency: "Pénznem",
    currencyColumnRate: "A mi árfolyamunk",
    book: "Lefoglalom",
    book_button: "Megrendelem",
    bookNow: "Megrendelem",
    validationRequired: "Ez a mező kötelező.",
    validationMinValue: "A minimális érték {min}.",
    validationMaxValue: "A maximális érték {max}.",
    validationMinLength: "A minimális hossz {min} karakter.",
    validationMaxLength: "A maximális hossz {max} karakter.",
    validationInvalidFormat: "Érvénytelen formátum.",
    validationCustomLocationDetails: "Kérjük, töltse ki az egyedi helyszín adatait.",
    counterDecrement: "Csökkentés",
    counterIncrement: "Növelés",
    commodityDetailTitle: "Termék részletei",
    loading: "Betöltés…",
    noData: "Nincs elérhető adat.",
    errorPrefix: "Hiba: ",
    retry: "Újra",
    errorNetwork: "Nem sikerült kapcsolódni a szerverhez. Ellenőrizze a kapcsolatot, és próbálja újra.",
    errorNotFound: "A kért tartalom nem található.",
    errorCommodityNotFound: "A(z) „{commodity}” termék nem található.",
    errorServer: "A szolgáltatás átmenetileg nem érhető el. Kérjük, próbálja meg később újra.",
    errorGeneric: "Hiba történt a betöltés során.",
    errorDetails: "Technikai részletek",
    errorLeadTimeTooShort: "Sajnáljuk, de a(z) „{commodity}” foglalása {datetime} időpontra már nem adható le online — ehhez legalább {duration} előzetes bejelentés szükséges. Kérjük, vegye fel velünk közvetlenül a kapcsolatot, szívesen segítünk.",
    errorPriceBlocked: "Sajnáljuk, de a(z) „{commodity}” egyik kiválasztott tétele {date} napon már nem elérhető. Kérjük, távolítsa el a kosárból, vagy válasszon másik időpontot.",
    reviewsTitle: "Vásárlói vélemények",
    reviewsEmpty: "Még nincsenek vélemények.",
    reviewsAverage: "Átlagos értékelés",
    reviewsBasedOn: "{count} értékelés alapján",
    reviewsRecommend: "{percent}% ajánlaná",
    reviewsRecommendOf: "{total} vendégből {percent}% ajánlaná",
    reviewsWouldRecommend: "ajánlaná",
    reviewsRecommends: "Ajánlja",
    reviewsDoesNotRecommend: "Nem ajánlja",
    reviewsBreakdown: "Értékelések megoszlása",
    reviewsOverall: "Összesített",
    reviewsAnonymous: "Vendég",
    reviewsShowMore: "Több megjelenítése",
    reviewsResponse: "A szolgáltató válasza",
    reviewsResponseBy: "{author} válasza",
    reviewsAverageHelp: "{rated} csillagos értékelés átlaga, amelyet vásárlók adtak egy lezárt foglalás után ({from} – {to}). Csak a közzétett értékelések számítanak bele; az érték az alábbi szűrők szerint változik.",
    reviewsRecommendHelp: "A(z) {total} vendégből azok aránya, akik igennel válaszoltak arra a kérdésre, hogy ajánlanák-e. Csak lezárt foglalások közzétett értékelései alapján számítva.",
    reviewsFilterLanguage: "Nyelv",
    reviewsFilterPeriod: "Időszak",
    reviewsFilterRating: "Értékelés",
    reviewsFilterCommodity: "Szolgáltatás",
    reviewsFilterAll: "Összes",
    reviewsPeriodAll: "Teljes időszak",
    reviewsPeriodMonths: "Elmúlt {months} hónap",
    reviewsRatingMin: "{count}★ és afelett"
  },
  sv: {
    reservation: "Bokning",
    date: "Datum",
    changeDate: "Ändra datum",
    hideDate: "Dölj",
    time: "Tid",
    possibleAlternatives: "Möjliga alternativ",
    priceList: "Prislista",
    expandPriceList: "Visa prislista",
    collapsePriceList: "Dölj prislista",
    showFullPriceList: "Visa hela prislistan",
    showShortPriceList: "Visa färre priser",
    priceListSave: "Du sparar {amount}",
    pickDate: "Välj ett datum med tillgängliga tider.",
    discountAvailable: "Rabatt tillgänglig",
    saveUpTo: "Spara upp till {percent} %",
    saveExact: "Du sparar {percent} %",
    addToCart: "Lägg i varukorgen",
    buyNow: "Köp nu",
    saveChanges: "Spara ändringar",
    cancel: "Avbryt",
    confirmTickets: "Bekräfta antal biljetter",
    selectTicketCounts: "Välj antal biljetter",
    ticketDetailsNextStep: "I nästa steg konfigurerar du varje biljett",
    backToTicketSelection: "Tillbaka till biljettvalet",
    ticketNumber: "Biljett {n}",
    completeForm: "Fyll i fälten markerade med asterisk",
    processing: "Bearbetar…",
    resetForm: "Återställ formulär",
    revalidate: "Validera igen",
    selectDate: "Välj ett datum med tillgängliga tider.",
    loadingForm: "Laddar formulär…",
    leadTimeWarning: "Denna starttid närmar sig den minsta bokningsfristen och kan snart bli otillgänglig. Lägg din beställning så snart som möjligt.",
    onlineBookingUnavailable: "Detta datum kan inte bokas online. Kontakta oss direkt för ett skräddarsytt erbjudande — i mån av tillgänglighet.",
    notBuyableAlone: "De valda artiklarna kan inte köpas separat. Lägg till minst en artikel till.",
    soldOut: "Slutsålt",
    priceUnavailable: "Inte tillgänglig detta datum",
    customLocation: "Ange egen plats",
    customLocationName: "Platsens namn",
    customLocationAddress: "Adress",
    basket: "Varukorg",
    basketEmpty: "Din varukorg är tom.",
    basketItems: "Artiklar i ordern",
    removeItem: "Ta bort artikel",
    removeItemConfirm: "Ta bort?",
    editItem: "Redigera artikel",
    proceedToCheckout: "Till beställningen",
    backToBasket: "Tillbaka till varukorgen",
    tickets: "Biljetter",
    addedToBasket: "Tillagd i varukorgen",
    addedToBasketMessage: "Din artikel har lagts till i varukorgen.",
    continueShopping: "Fortsätt handla",
    backToShopping: "Tillbaka till shoppingen",
    goToBasket: "Gå till varukorgen",
    customer: "Kund",
    customerName: "Kundens namn",
    customerEmail: "Kundens e-post",
    customerPhone: "Kundens telefon",
    addCustomerNote: "Jag vill lägga till en notering",
    customerNote: "Notering",
    sendReceipt: "Skicka mig ett kvitto",
    issueForCompany: "Utfärda kvitto till företag",
    invoiceName: "Namn",
    invoiceCompany: "Företag",
    invoiceVat: "Momsregnr",
    invoiceAddress: "Adress",
    invoiceCity: "Stad / region",
    invoiceZip: "Postnummer",
    invoiceCountry: "Land",
    participant: "Deltagare",
    customerIsParticipant: "Kunden är även deltagare.",
    participantName: "Deltagarens namn",
    participantPhone: "Deltagarens telefon",
    participantEmail: "Deltagarens e-post",
    separateParticipants: "Ange en egen deltagare för varje artikel",
    payment: "Betalning",
    checkout: "Kassa",
    agreeTerms: "Jag godkänner",
    termsLinkText: "villkoren",
    payNow: "Gå vidare till betalning",
    total: "Totalt",
    price: "Pris",
    inclTaxes: "Inkl. moms och avgifter",
    changeCurrency: "Byt valuta",
    chooseCurrency: "Välj betalningsvaluta",
    currencyExplanation: "Vi sätter våra egna växelkurser – vi strävar efter att göra dem mer fördelaktiga för både dig och oss än den omräkningskurs din bank skulle använda vid kortbetalning. Jämför ordersumman i respektive valuta nedan och välj den som matchar ditt bankkonto.",
    currencyColumnCurrency: "Valuta",
    currencyColumnRate: "Vår kurs",
    book: "Boka",
    book_button: "Boka",
    bookNow: "Boka nu",
    validationRequired: "Det här fältet är obligatoriskt.",
    validationMinValue: "Minsta värde är {min}.",
    validationMaxValue: "Högsta värde är {max}.",
    validationMinLength: "Minsta längd är {min} tecken.",
    validationMaxLength: "Högsta längd är {max} tecken.",
    validationInvalidFormat: "Ogiltigt format.",
    validationCustomLocationDetails: "Fyll i uppgifterna om den egna platsen.",
    counterDecrement: "Minska",
    counterIncrement: "Öka",
    commodityDetailTitle: "Produktinformation",
    loading: "Laddar…",
    noData: "Inga data tillgängliga.",
    errorPrefix: "Fel: ",
    retry: "Försök igen",
    errorNetwork: "Det gick inte att nå servern. Kontrollera din anslutning och försök igen.",
    errorNotFound: "Det begärda innehållet kunde inte hittas.",
    errorCommodityNotFound: 'Produkten "{commodity}" kunde inte hittas.',
    errorServer: "Tjänsten är tillfälligt otillgänglig. Försök igen om en stund.",
    errorGeneric: "Något gick fel vid inläsningen.",
    errorDetails: "Tekniska detaljer",
    errorLeadTimeTooShort: 'Vi beklagar, det är för sent att boka "{commodity}" för {datetime} online — denna bokning kräver minst {duration} varsel. Kontakta oss direkt så hjälper vi dig gärna.',
    errorPriceBlocked: 'Vi beklagar, en av de valda artiklarna för "{commodity}" är inte längre tillgänglig den {date}. Ta bort den från varukorgen eller välj ett annat datum.',
    reviewsTitle: "Kundrecensioner",
    reviewsEmpty: "Inga recensioner än.",
    reviewsAverage: "Genomsnittligt betyg",
    reviewsBasedOn: "Baserat på {count} recensioner",
    reviewsRecommend: "{percent} % skulle rekommendera",
    reviewsRecommendOf: "{percent} % av {total} gäster skulle rekommendera",
    reviewsWouldRecommend: "skulle rekommendera",
    reviewsRecommends: "Rekommenderar",
    reviewsDoesNotRecommend: "Rekommenderar inte",
    reviewsBreakdown: "Betygsfördelning",
    reviewsOverall: "Totalt",
    reviewsAnonymous: "Gäst",
    reviewsShowMore: "Visa mer",
    reviewsResponse: "Svar från leverantören",
    reviewsResponseBy: "Svar från {author}",
    reviewsAverageHelp: "Genomsnitt av {rated} stjärnbetyg lämnade av kunder efter en genomförd bokning ({from} – {to}). Endast publicerade recensioner räknas; värdet ändras beroende på filtren nedan.",
    reviewsRecommendHelp: "Andel av {total} gäster som svarade ja på frågan om de skulle rekommendera. Beräknas endast utifrån publicerade recensioner av genomförda bokningar.",
    reviewsFilterLanguage: "Språk",
    reviewsFilterPeriod: "Period",
    reviewsFilterRating: "Betyg",
    reviewsFilterCommodity: "Tjänst",
    reviewsFilterAll: "Alla",
    reviewsPeriodAll: "Hela perioden",
    reviewsPeriodMonths: "Senaste {months} månaderna",
    reviewsRatingMin: "{count}★ och uppåt"
  },
  fi: {
    reservation: "Varaus",
    date: "Päivämäärä",
    changeDate: "Muuta päivämäärää",
    hideDate: "Piilota",
    time: "Aika",
    possibleAlternatives: "Mahdolliset vaihtoehdot",
    priceList: "Hinnasto",
    expandPriceList: "Näytä hinnasto",
    collapsePriceList: "Piilota hinnasto",
    showFullPriceList: "Näytä koko hinnasto",
    showShortPriceList: "Näytä vähemmän hintoja",
    priceListSave: "Säästät {amount}",
    pickDate: "Valitse päivä, jolle on saatavilla aikoja.",
    discountAvailable: "Alennus saatavilla",
    saveUpTo: "Säästät jopa {percent} %",
    saveExact: "Säästät {percent} %",
    addToCart: "Lisää ostoskoriin",
    buyNow: "Osta nyt",
    saveChanges: "Tallenna muutokset",
    cancel: "Peruuta",
    confirmTickets: "Vahvista lippujen määrä",
    selectTicketCounts: "Valitse lippujen määrä",
    ticketDetailsNextStep: "Seuraavassa vaiheessa määrität jokaisen lipun",
    backToTicketSelection: "Takaisin lippujen valintaan",
    ticketNumber: "Lippu {n}",
    completeForm: "Täytä tähdellä merkityt kentät",
    processing: "Käsitellään…",
    resetForm: "Tyhjennä lomake",
    revalidate: "Tarkista uudelleen",
    selectDate: "Valitse päivä, jolle on saatavilla aikoja.",
    loadingForm: "Lomaketta ladataan…",
    leadTimeWarning: "Tämä aloitusaika lähestyy varauksen vähimmäisaikaa ja saattaa pian muuttua saatavuudettomaksi. Tee tilaus mahdollisimman pian.",
    onlineBookingUnavailable: "Tätä ajankohtaa ei voi varata verkossa. Ota meihin suoraan yhteyttä räätälöityä tarjousta varten – saatavuuden mukaan.",
    notBuyableAlone: "Valittuja tuotteita ei voi ostaa yksinään. Lisää vähintään yksi muu tuote.",
    soldOut: "Loppuunmyyty",
    priceUnavailable: "Ei saatavilla tänä päivänä",
    customLocation: "Anna oma sijainti",
    customLocationName: "Sijainnin nimi",
    customLocationAddress: "Osoite",
    basket: "Ostoskori",
    basketEmpty: "Ostoskorisi on tyhjä.",
    basketItems: "Tilauksen tuotteet",
    removeItem: "Poista tuote",
    removeItemConfirm: "Poistetaanko?",
    editItem: "Muokkaa tuotetta",
    proceedToCheckout: "Siirry tilaukseen",
    backToBasket: "Takaisin ostoskoriin",
    tickets: "Liput",
    addedToBasket: "Lisätty ostoskoriin",
    addedToBasketMessage: "Tuote lisättiin ostoskoriin.",
    continueShopping: "Jatka ostoksia",
    backToShopping: "Takaisin ostoksille",
    goToBasket: "Siirry ostoskoriin",
    customer: "Asiakas",
    customerName: "Asiakkaan nimi",
    customerEmail: "Asiakkaan sähköposti",
    customerPhone: "Asiakkaan puhelin",
    addCustomerNote: "Haluan lisätä huomautuksen",
    customerNote: "Huomautus",
    sendReceipt: "Lähetä minulle maksukuitti",
    issueForCompany: "Anna kuitti yritykselle",
    invoiceName: "Nimi",
    invoiceCompany: "Yritys",
    invoiceVat: "ALV-numero",
    invoiceAddress: "Osoite",
    invoiceCity: "Kaupunki / alue",
    invoiceZip: "Postinumero",
    invoiceCountry: "Maa",
    participant: "Osallistuja",
    customerIsParticipant: "Asiakas on myös osallistuja.",
    participantName: "Osallistujan nimi",
    participantPhone: "Osallistujan puhelin",
    participantEmail: "Osallistujan sähköposti",
    separateParticipants: "Täytä eri osallistuja jokaiselle tuotteelle",
    payment: "Maksu",
    checkout: "Kassa",
    agreeTerms: "Hyväksyn",
    termsLinkText: "käyttöehdot",
    payNow: "Siirry maksamaan",
    total: "Yhteensä",
    price: "Hinta",
    inclTaxes: "Sis. ALV ja maksut",
    changeCurrency: "Vaihda valuutta",
    chooseCurrency: "Valitse maksuvaluutta",
    currencyExplanation: "Käytämme omia vaihtokurssejamme – pyrimme siihen, että ne olisivat edullisempia sekä sinulle että meille kuin pankkisi korttimaksun muuntokurssi. Vertaile alla tilauksen kokonaissummaa eri valuutoissa ja valitse pankkitiliäsi vastaava.",
    currencyColumnCurrency: "Valuutta",
    currencyColumnRate: "Meidän kurssimme",
    book: "Varaa",
    book_button: "Tilaa",
    bookNow: "Tilaa nyt",
    validationRequired: "Tämä kenttä on pakollinen.",
    validationMinValue: "Vähimmäisarvo on {min}.",
    validationMaxValue: "Enimmäisarvo on {max}.",
    validationMinLength: "Vähimmäispituus on {min} merkkiä.",
    validationMaxLength: "Enimmäispituus on {max} merkkiä.",
    validationInvalidFormat: "Virheellinen muoto.",
    validationCustomLocationDetails: "Täytä mukautetun sijainnin tiedot.",
    counterDecrement: "Vähennä",
    counterIncrement: "Lisää",
    commodityDetailTitle: "Tuotteen tiedot",
    loading: "Ladataan…",
    noData: "Ei saatavilla olevia tietoja.",
    errorPrefix: "Virhe: ",
    retry: "Yritä uudelleen",
    errorNetwork: "Palvelimeen ei saatu yhteyttä. Tarkista yhteytesi ja yritä uudelleen.",
    errorNotFound: "Pyydettyä sisältöä ei löytynyt.",
    errorCommodityNotFound: 'Tuotetta "{commodity}" ei löytynyt.',
    errorServer: "Palvelu ei ole tilapäisesti käytettävissä. Yritä hetken kuluttua uudelleen.",
    errorGeneric: "Latauksessa tapahtui virhe.",
    errorDetails: "Tekniset tiedot",
    errorLeadTimeTooShort: 'Valitettavasti tuotteen "{commodity}" varaaminen ajankohtaan {datetime} ei ole enää mahdollista verkossa — tämä varaus vaatii vähintään {duration} ennakkoilmoituksen. Ota suoraan yhteyttä, autamme mielellämme.',
    errorPriceBlocked: 'Valitettavasti yksi tuotteeseen "{commodity}" valituista kohteista ei ole enää saatavilla {date}. Poista se ostoskorista tai valitse toinen päivä.',
    reviewsTitle: "Asiakasarvostelut",
    reviewsEmpty: "Ei vielä arvosteluja.",
    reviewsAverage: "Keskimääräinen arvosana",
    reviewsBasedOn: "Perustuu {count} arvosteluun",
    reviewsRecommend: "{percent} % suosittelisi",
    reviewsRecommendOf: "{percent} % / {total} vierasta suosittelisi",
    reviewsWouldRecommend: "suosittelisi",
    reviewsRecommends: "Suosittelee",
    reviewsDoesNotRecommend: "Ei suosittele",
    reviewsBreakdown: "Arvosanojen jakauma",
    reviewsOverall: "Kokonaisarvosana",
    reviewsAnonymous: "Vieras",
    reviewsShowMore: "Näytä lisää",
    reviewsResponse: "Palveluntarjoajan vastaus",
    reviewsResponseBy: "Vastaus: {author}",
    reviewsAverageHelp: "Keskiarvo {rated} tähtiarvostelusta, jotka asiakkaat ovat jättäneet päättyneen varauksen jälkeen ({from} – {to}). Mukaan lasketaan vain julkaistut arvostelut; luku muuttuu alla olevien suodattimien mukaan.",
    reviewsRecommendHelp: "Osuus {total} vieraasta, jotka vastasivat kyllä kysymykseen suosittelisivatko he. Laskettu vain päättyneiden varausten julkaistuista arvosteluista.",
    reviewsFilterLanguage: "Kieli",
    reviewsFilterPeriod: "Ajanjakso",
    reviewsFilterRating: "Arvosana",
    reviewsFilterCommodity: "Palvelu",
    reviewsFilterAll: "Kaikki",
    reviewsPeriodAll: "Koko ajanjakso",
    reviewsPeriodMonths: "Viimeiset {months} kuukautta",
    reviewsRatingMin: "{count}★ ja enemmän"
  },
  da: {
    reservation: "Reservation",
    date: "Dato",
    changeDate: "Ændr dato",
    hideDate: "Skjul",
    time: "Tidspunkt",
    possibleAlternatives: "Mulige alternativer",
    priceList: "Prisliste",
    expandPriceList: "Vis prisliste",
    collapsePriceList: "Skjul prisliste",
    showFullPriceList: "Vis hele prislisten",
    showShortPriceList: "Vis færre priser",
    priceListSave: "Du sparer {amount}",
    pickDate: "Vælg en dato med ledige tider.",
    discountAvailable: "Rabat tilgængelig",
    saveUpTo: "Spar op til {percent} %",
    saveExact: "Du sparer {percent} %",
    addToCart: "Læg i kurv",
    buyNow: "Køb nu",
    saveChanges: "Gem ændringer",
    cancel: "Annuller",
    confirmTickets: "Bekræft antal billetter",
    selectTicketCounts: "Vælg antal billetter",
    ticketDetailsNextStep: "I næste trin konfigurerer du hver billet",
    backToTicketSelection: "Tilbage til billetvalg",
    ticketNumber: "Billet {n}",
    completeForm: "Udfyld felterne markeret med stjerne",
    processing: "Behandler…",
    resetForm: "Nulstil formular",
    revalidate: "Valider igen",
    selectDate: "Vælg en dato med ledige tider.",
    loadingForm: "Indlæser formular…",
    leadTimeWarning: "Dette starttidspunkt nærmer sig den minimale bookingfrist og kan snart blive utilgængeligt. Bestil venligst snarest muligt.",
    onlineBookingUnavailable: "Denne dato kan ikke bookes online. Kontakt os venligst direkte for et skræddersyet tilbud — afhængigt af tilgængelighed.",
    notBuyableAlone: "De valgte varer kan ikke købes separat. Tilføj venligst mindst én vare mere.",
    soldOut: "Udsolgt",
    priceUnavailable: "Ikke tilgængelig på denne dato",
    customLocation: "Indtast brugerdefineret sted",
    customLocationName: "Stedets navn",
    customLocationAddress: "Adresse",
    basket: "Kurv",
    basketEmpty: "Din kurv er tom.",
    basketItems: "Varer i ordren",
    removeItem: "Fjern vare",
    removeItemConfirm: "Fjern?",
    editItem: "Rediger vare",
    proceedToCheckout: "Gå til bestillingen",
    backToBasket: "Tilbage til kurven",
    tickets: "Billetter",
    addedToBasket: "Lagt i kurven",
    addedToBasketMessage: "Din vare er lagt i kurven.",
    continueShopping: "Fortsæt med at handle",
    backToShopping: "Tilbage til indkøb",
    goToBasket: "Gå til kurven",
    customer: "Kunde",
    customerName: "Kundens navn",
    customerEmail: "Kundens e-mail",
    customerPhone: "Kundens telefon",
    addCustomerNote: "Jeg vil tilføje en note",
    customerNote: "Note",
    sendReceipt: "Send mig en kvittering",
    issueForCompany: "Udsted kvittering til virksomhed",
    invoiceName: "Navn",
    invoiceCompany: "Virksomhed",
    invoiceVat: "CVR/momsnummer",
    invoiceAddress: "Adresse",
    invoiceCity: "By / region",
    invoiceZip: "Postnummer",
    invoiceCountry: "Land",
    participant: "Deltager",
    customerIsParticipant: "Kunden er også deltageren.",
    participantName: "Deltagerens navn",
    participantPhone: "Deltagerens telefon",
    participantEmail: "Deltagerens e-mail",
    separateParticipants: "Angiv en anden deltager for hver vare",
    payment: "Betaling",
    checkout: "Kasse",
    agreeTerms: "Jeg accepterer",
    termsLinkText: "vilkår og betingelser",
    payNow: "Fortsæt til betaling",
    total: "I alt",
    price: "Pris",
    inclTaxes: "Inkl. moms og gebyrer",
    changeCurrency: "Skift valuta",
    chooseCurrency: "Vælg betalingsvaluta",
    currencyExplanation: "Vi fastsætter vores egne valutakurser – vi bestræber os på at gøre dem mere fordelagtige for både dig og os end den omregningskurs, din bank ville anvende ved kortbetaling. Sammenlign ordrens samlede beløb i de enkelte valutaer nedenfor, og vælg den, der matcher din bankkonto.",
    currencyColumnCurrency: "Valuta",
    currencyColumnRate: "Vores kurs",
    book: "Book",
    book_button: "Book",
    bookNow: "Book nu",
    validationRequired: "Dette felt er påkrævet.",
    validationMinValue: "Mindste værdi er {min}.",
    validationMaxValue: "Største værdi er {max}.",
    validationMinLength: "Mindste længde er {min} tegn.",
    validationMaxLength: "Største længde er {max} tegn.",
    validationInvalidFormat: "Ugyldigt format.",
    validationCustomLocationDetails: "Udfyld detaljerne for det brugerdefinerede sted.",
    counterDecrement: "Mindsk",
    counterIncrement: "Forøg",
    commodityDetailTitle: "Produktdetaljer",
    loading: "Indlæser…",
    noData: "Ingen data tilgængelige.",
    errorPrefix: "Fejl: ",
    retry: "Prøv igen",
    errorNetwork: "Kunne ikke oprette forbindelse til serveren. Kontrollér din forbindelse, og prøv igen.",
    errorNotFound: "Det anmodede indhold blev ikke fundet.",
    errorCommodityNotFound: 'Produktet "{commodity}" blev ikke fundet.',
    errorServer: "Tjenesten er midlertidigt utilgængelig. Prøv venligst igen om et øjeblik.",
    errorGeneric: "Der opstod en fejl under indlæsningen.",
    errorDetails: "Tekniske detaljer",
    errorLeadTimeTooShort: 'Vi beklager, det er for sent at booke "{commodity}" til {datetime} online — denne booking kræver mindst {duration} varsel. Kontakt os venligst direkte, så hjælper vi dig gerne.',
    errorPriceBlocked: 'Vi beklager, en af de valgte varer til "{commodity}" er ikke længere tilgængelig den {date}. Fjern den fra kurven, eller vælg en anden dato.',
    reviewsTitle: "Kundeanmeldelser",
    reviewsEmpty: "Ingen anmeldelser endnu.",
    reviewsAverage: "Gennemsnitlig bedømmelse",
    reviewsBasedOn: "Baseret på {count} anmeldelser",
    reviewsRecommend: "{percent} % ville anbefale",
    reviewsRecommendOf: "{percent} % af {total} gæster ville anbefale",
    reviewsWouldRecommend: "ville anbefale",
    reviewsRecommends: "Anbefaler",
    reviewsDoesNotRecommend: "Anbefaler ikke",
    reviewsBreakdown: "Fordeling af bedømmelser",
    reviewsOverall: "Samlet",
    reviewsAnonymous: "Gæst",
    reviewsShowMore: "Vis mere",
    reviewsResponse: "Svar fra udbyderen",
    reviewsResponseBy: "Svar fra {author}",
    reviewsAverageHelp: "Gennemsnit af {rated} stjernebedømmelser givet af kunder efter en gennemført booking ({from} – {to}). Kun offentliggjorte anmeldelser tælles med; værdien ændrer sig afhængigt af filtrene nedenfor.",
    reviewsRecommendHelp: "Andel af {total} gæster, der svarede ja på spørgsmålet om, hvorvidt de ville anbefale. Beregnet kun ud fra offentliggjorte anmeldelser af gennemførte bookinger.",
    reviewsFilterLanguage: "Sprog",
    reviewsFilterPeriod: "Periode",
    reviewsFilterRating: "Bedømmelse",
    reviewsFilterCommodity: "Ydelse",
    reviewsFilterAll: "Alle",
    reviewsPeriodAll: "Hele perioden",
    reviewsPeriodMonths: "Seneste {months} måneder",
    reviewsRatingMin: "{count}★ og derover"
  },
  ar: {
    reservation: "الحجز",
    date: "التاريخ",
    changeDate: "تغيير التاريخ",
    hideDate: "إخفاء",
    time: "الوقت",
    possibleAlternatives: "البدائل الممكنة",
    priceList: "قائمة الأسعار",
    expandPriceList: "إظهار قائمة الأسعار",
    collapsePriceList: "إخفاء قائمة الأسعار",
    showFullPriceList: "إظهار قائمة الأسعار كاملة",
    showShortPriceList: "إظهار أسعار أقل",
    priceListSave: "توفّر {amount}",
    discountAvailable: "خصم متاح",
    saveUpTo: "وفّر حتى {percent}%",
    saveExact: "توفّر {percent}%",
    addToCart: "أضف إلى السلة",
    buyNow: "اشترِ الآن",
    saveChanges: "حفظ التغييرات",
    cancel: "إلغاء",
    confirmTickets: "تأكيد عدد التذاكر",
    selectTicketCounts: "يرجى اختيار عدد التذاكر",
    ticketDetailsNextStep: "في الخطوة التالية ستقوم بإعداد كل تذكرة على حدة",
    backToTicketSelection: "العودة إلى اختيار التذاكر",
    ticketNumber: "التذكرة {n}",
    completeForm: "املأ الحقول المميزة بعلامة النجمة",
    processing: "جارٍ المعالجة…",
    resetForm: "إعادة تعيين النموذج",
    revalidate: "إعادة التحقق",
    selectDate: "يرجى اختيار تاريخ به مواعيد متاحة.",
    loadingForm: "جارٍ تحميل النموذج…",
    pickDate: "تظهر الأسعار بعد اختيار التاريخ في التقويم.",
    leadTimeWarning: "يقترب وقت البدء هذا من الحد الأدنى لمهلة الحجز وقد يصبح غير متاح قريبًا. يرجى إتمام طلبك في أقرب وقت ممكن.",
    onlineBookingUnavailable: "لا يمكن حجز هذا الموعد عبر الإنترنت. يرجى التواصل معنا مباشرة للحصول على عرض مخصص — حسب التوفر.",
    notBuyableAlone: "لا يمكن شراء العناصر المحددة بمفردها. يرجى إضافة عنصر آخر واحد على الأقل.",
    soldOut: "نفدت الكمية",
    priceUnavailable: "غير متاح في هذا التاريخ",
    customLocation: "إدخال موقع مخصص",
    customLocationName: "اسم الموقع",
    customLocationAddress: "العنوان",
    basket: "السلة",
    basketEmpty: "سلتك فارغة.",
    basketItems: "عناصر الطلب",
    removeItem: "إزالة العنصر",
    removeItemConfirm: "إزالة؟",
    editItem: "تعديل العنصر",
    proceedToCheckout: "المتابعة إلى الطلب",
    backToBasket: "العودة إلى السلة",
    tickets: "التذاكر",
    addedToBasket: "تمت الإضافة إلى السلة",
    addedToBasketMessage: "تمت إضافة العنصر إلى السلة.",
    continueShopping: "متابعة التسوق",
    backToShopping: "العودة للتسوق",
    goToBasket: "الانتقال إلى السلة",
    customer: "العميل",
    customerName: "اسم العميل",
    customerEmail: "البريد الإلكتروني للعميل",
    customerPhone: "هاتف العميل",
    addCustomerNote: "أرغب في إضافة ملاحظة",
    customerNote: "ملاحظة",
    sendReceipt: "أرسلوا لي إيصال الدفع",
    issueForCompany: "إصدار إيصال لشركة",
    invoiceName: "الاسم",
    invoiceCompany: "الشركة",
    invoiceVat: "الرقم الضريبي",
    invoiceAddress: "العنوان",
    invoiceCity: "المدينة / المنطقة",
    invoiceZip: "الرمز البريدي",
    invoiceCountry: "الدولة",
    participant: "المشارك",
    customerIsParticipant: "العميل هو نفسه المشارك.",
    participantName: "اسم المشارك",
    participantPhone: "هاتف المشارك",
    participantEmail: "البريد الإلكتروني للمشارك",
    separateParticipants: "إدخال مشارك مختلف لكل عنصر",
    payment: "الدفع",
    checkout: "إتمام الطلب",
    agreeTerms: "أوافق على",
    termsLinkText: "الشروط والأحكام",
    payNow: "المتابعة إلى الدفع",
    total: "الإجمالي",
    price: "السعر",
    inclTaxes: "شاملاً ضريبة القيمة المضافة والرسوم",
    changeCurrency: "تغيير العملة",
    chooseCurrency: "اختر عملة الدفع",
    currencyExplanation: "نحدد أسعار الصرف الخاصة بنا — ونسعى إلى أن تكون أكثر إنصافًا لك ولنا من سعر التحويل الذي يطبقه بنكك عند الدفع بالبطاقة. قارن أدناه إجمالي الطلب بكل عملة واختر العملة التي تطابق حسابك المصرفي.",
    currencyColumnCurrency: "العملة",
    currencyColumnRate: "سعرنا",
    book: "احجز",
    book_button: "اطلب",
    bookNow: "اطلب الآن",
    validationRequired: "هذا الحقل مطلوب.",
    validationMinValue: "الحد الأدنى هو {min}.",
    validationMaxValue: "الحد الأقصى هو {max}.",
    validationMinLength: "الحد الأدنى للطول هو {min} حرفًا.",
    validationMaxLength: "الحد الأقصى للطول هو {max} حرفًا.",
    validationInvalidFormat: "صيغة غير صالحة.",
    validationCustomLocationDetails: "يرجى ملء تفاصيل الموقع المخصص.",
    counterDecrement: "إنقاص",
    counterIncrement: "زيادة",
    commodityDetailTitle: "تفاصيل المنتج",
    loading: "جارٍ التحميل…",
    noData: "لا توجد بيانات متاحة.",
    errorPrefix: "خطأ: ",
    retry: "إعادة المحاولة",
    errorNetwork: "تعذّر الاتصال بالخادم. تحقق من اتصالك وحاول مرة أخرى.",
    errorNotFound: "لم يتم العثور على المحتوى المطلوب.",
    errorCommodityNotFound: "لم يتم العثور على المنتج «{commodity}».",
    errorServer: "الخدمة غير متاحة مؤقتًا. يرجى المحاولة مرة أخرى بعد قليل.",
    errorGeneric: "حدث خطأ أثناء التحميل.",
    errorDetails: "التفاصيل التقنية",
    errorLeadTimeTooShort: "نأسف، لم يعد من الممكن حجز «{commodity}» لتاريخ {datetime} عبر الإنترنت — يتطلب هذا الحجز مهلة {duration} على الأقل مسبقًا. يرجى التواصل معنا مباشرة، وسنبذل قصارى جهدنا لمساعدتك.",
    errorPriceBlocked: "نأسف، أحد العناصر المختارة لـ «{commodity}» لم يعد متاحًا بتاريخ {date}. يرجى إزالته من السلة أو اختيار تاريخ آخر.",
    reviewsTitle: "آراء العملاء",
    reviewsEmpty: "لا توجد تقييمات بعد.",
    reviewsAverage: "متوسط التقييم",
    reviewsBasedOn: "استنادًا إلى {count} تقييمًا",
    reviewsRecommend: "{percent}% يوصون",
    reviewsRecommendOf: "{percent}% من {total} ضيف يوصون",
    reviewsWouldRecommend: "يوصون",
    reviewsRecommends: "يوصي",
    reviewsDoesNotRecommend: "لا يوصي",
    reviewsBreakdown: "توزيع التقييمات",
    reviewsOverall: "الإجمالي",
    reviewsAnonymous: "ضيف",
    reviewsShowMore: "عرض المزيد",
    reviewsResponse: "رد مقدّم الخدمة",
    reviewsResponseBy: "رد من {author}",
    reviewsAverageHelp: "متوسط {rated} تقييمًا بالنجوم من العملاء بعد إتمام الحجز ({from} – {to}). يتم احتساب التقييمات المنشورة فقط؛ وتتغير القيمة وفقًا للفلاتر أدناه.",
    reviewsRecommendHelp: "نسبة {total} ضيف أجابوا بـ«نعم» على سؤال ما إذا كانوا سيوصون. تُحتسب فقط من التقييمات المنشورة للحجوزات المكتملة.",
    reviewsFilterLanguage: "اللغة",
    reviewsFilterPeriod: "الفترة",
    reviewsFilterRating: "التقييم",
    reviewsFilterCommodity: "الخدمة",
    reviewsFilterAll: "الكل",
    reviewsPeriodAll: "كل الفترة",
    reviewsPeriodMonths: "آخر {months} أشهر",
    reviewsRatingMin: "{count}★ فأكثر"
  }
}, sn = {
  ua: "uk",
  // Ukrainian
  sw: "sv",
  // Swedish (callers occasionally use country code "sw"; Swahili is not bundled)
  dk: "da"
  // Danish
};
function N5(e) {
  if (!e) return "en";
  const t = st(e).toLowerCase();
  if (On[t]) return t;
  if (sn[t] && On[sn[t]]) return sn[t];
  const n = t.split("-")[0];
  return On[n] ? n : sn[n] && On[sn[n]] ? sn[n] : "en";
}
function Qe(e, t) {
  const n = On[N5(e)] ?? {};
  return { ...Re, ...n, ...t ?? {} };
}
const j5 = {
  key: 0,
  class: "flex flex-col gap-1 rounded-t border-b border-gray-200 bg-white px-3 py-2"
}, U5 = { class: "flex flex-wrap items-start justify-between gap-x-2 gap-y-1" }, H5 = {
  key: 0,
  class: "mancub-discount-badge"
}, K5 = { class: "ml-auto flex flex-col items-end gap-y-0.5 text-right" }, W5 = {
  key: 0,
  class: "font-medium text-gray-900"
}, Y5 = {
  key: 1,
  class: "text-gray-600"
}, G5 = { class: "flex flex-col divide-y divide-gray-200" }, q5 = { class: "flex min-w-0 flex-1 flex-col" }, Z5 = {
  key: 0,
  class: "mt-0.5 whitespace-pre-line break-words text-xs text-gray-500"
}, X5 = { class: "flex flex-shrink-0 flex-col items-end text-right" }, J5 = ["data-testid"], Q5 = {
  key: 0,
  class: "mancub-save-tag"
}, eS = { class: "flex items-baseline gap-2" }, tS = { class: "mancub-strike-diagonal text-sm text-gray-400" }, nS = { class: "font-semibold text-gray-900" }, oS = {
  key: 2,
  class: "font-medium text-gray-900"
}, rS = {
  key: 3,
  class: "text-xs text-gray-500"
}, iS = ["aria-expanded"], aS = {
  key: 1,
  class: "text-sm text-gray-500"
}, _l = /* @__PURE__ */ se({
  __name: "PriceTable",
  props: {
    preferredLanguage: { default: () => ln },
    labels: { default: () => {
    } },
    prices: { default: () => [] },
    referenceDate: { default: null },
    discountPercent: { default: 0 },
    discountIdents: { default: null },
    discountTitle: { default: null },
    time: { default: null },
    timeChoices: { default: null },
    activeDiscounts: { default: null },
    discounts: { default: null },
    currency: { default: null },
    maxHeight: { default: null },
    showHeading: { type: Boolean, default: !0 },
    showQuantifiers: { type: Boolean, default: !1 },
    divideByUnits: { type: Boolean, default: !0 },
    shortlist: { type: Boolean, default: !1 }
  },
  setup(e) {
    const t = v(() => Qe(e.preferredLanguage, e.labels)), n = v(() => {
      if (e.maxHeight)
        return { maxHeight: typeof e.maxHeight == "number" ? `${e.maxHeight}px` : e.maxHeight };
    }), o = (O, w) => w || (O > 0 ? `−${O} %` : null), i = v(() => {
      if (e.timeChoices && e.timeChoices.length > 0)
        return K0(e.timeChoices, e.activeDiscounts, e.discounts, e.prices, e.referenceDate).map((w) => ({
          key: w.label,
          prices: Mo(e.prices, e.referenceDate, w.times[0]),
          percent: w.percent,
          idents: w.idents,
          badge: o(w.percent, w.titles[0]),
          timeLabel: w.label
        })).filter((w) => w.prices.length > 0);
      const O = Mo(e.prices, e.referenceDate, e.time);
      return O.length === 0 ? [] : [{ key: "day", prices: O, percent: e.discountPercent, idents: e.discountIdents ?? [], badge: e.discountTitle, timeLabel: e.time }];
    }), r = W(!1), a = v(() => {
      if (!e.shortlist) return !1;
      const O = i.value.flatMap((w) => w.prices);
      return O.some((w) => w.is_on_shortlist) && O.some((w) => !w.is_on_shortlist);
    }), d = v(() => !a.value || r.value ? i.value : i.value.map((O) => ({ ...O, prices: O.prices.filter((w) => w.is_on_shortlist) })).filter((O) => O.prices.length > 0)), l = v(() => {
      if (e.referenceDate == null) return null;
      const O = e.referenceDate instanceof Date ? e.referenceDate : Ne(e.referenceDate);
      return Number.isNaN(O.getTime()) ? null : O;
    }), u = v(() => l.value ? wn(l.value, e.preferredLanguage) ?? bn(l.value, e.preferredLanguage) : null), s = (O, w) => e.showHeading && !!(O.badge || O.timeLabel || w === 0 && u.value), c = (O) => O.title || O.ident, p = Bn(() => e.currency), f = (O) => {
      const w = tn(O, p.value);
      return e.divideByUnits ? Qa(w, O.units) : w;
    }, b = (O, w) => _t(O, {
      code: w.code,
      unit: w.unit,
      decimals: w.decimals,
      lang: e.preferredLanguage
    }), k = (O) => {
      const w = f(O);
      return w.amount !== null ? b(w.amount, w) : w.display;
    }, T = (O, w) => {
      const F = f(O), D = $n(O, { percent: w.percent, idents: w.idents }, F.code), C = F.amount;
      return C === null || !D || !(C > 0) ? null : en(C * (1 - D / 100), F.decimals);
    }, $ = (O, w) => {
      const F = T(O, w);
      return F === null ? null : b(F, f(O));
    }, S = (O, w) => {
      const F = T(O, w);
      if (F === null) return null;
      const D = f(O), C = b(D.amount - F, D);
      return Le(t.value.priceListSave, { amount: C });
    };
    return (O, w) => {
      const F = Il;
      return m(), h("div", {
        class: ee(["mancub-widget mancub-pricetable flex flex-col gap-3", { "overflow-y-auto": n.value }]),
        style: Zt(n.value)
      }, [
        i.value.length ? (m(), h(Y, { key: 0 }, [
          (m(!0), h(Y, null, he(d.value, (D, C) => (m(), h("section", {
            key: D.key,
            class: "rounded border border-gray-200 bg-gray-50"
          }, [
            s(D, C) ? (m(), h("header", j5, [
              g("div", U5, [
                D.badge ? (m(), h("span", H5, y(D.badge), 1)) : B("", !0),
                g("span", K5, [
                  C === 0 && u.value ? (m(), h("span", W5, y(u.value), 1)) : B("", !0),
                  D.timeLabel ? (m(), h("span", Y5, y(D.timeLabel), 1)) : B("", !0)
                ])
              ])
            ])) : B("", !0),
            g("ul", G5, [
              (m(!0), h(Y, null, he(D.prices, (I) => (m(), h("li", {
                key: I.ident,
                class: "flex items-start justify-between gap-3 px-3 py-2"
              }, [
                g("span", q5, [
                  g("span", {
                    class: ee(["break-words", I.is_blocked ? "text-gray-400" : "text-gray-900"])
                  }, y(c(I)), 3),
                  I.subtitle ? (m(), h("span", Z5, y(I.subtitle), 1)) : B("", !0)
                ]),
                g("span", X5, [
                  I.is_blocked ? (m(), h("span", {
                    key: 0,
                    class: "mancub-price-unavailable text-sm font-medium text-gray-500",
                    "data-testid": `mancub-price-unavailable-${I.ident}`
                  }, y(t.value.priceUnavailable), 9, J5)) : $(I, D) !== null ? (m(), h(Y, { key: 1 }, [
                    S(I, D) ? (m(), h("span", Q5, y(S(I, D)), 1)) : B("", !0),
                    g("span", eS, [
                      g("span", tS, y(k(I)), 1),
                      g("span", nS, y($(I, D)), 1)
                    ])
                  ], 64)) : (m(), h("span", oS, y(k(I)), 1)),
                  O.showQuantifiers && I.unit_quantifier && !I.is_blocked ? (m(), h("span", rS, y(I.unit_quantifier), 1)) : B("", !0)
                ])
              ]))), 128))
            ])
          ]))), 128)),
          a.value ? (m(), h("button", {
            key: 0,
            type: "button",
            class: "inline-flex cursor-pointer items-center gap-1 self-start text-sm text-gray-600 border-0 bg-transparent p-0 hover:text-gray-900 focus:text-gray-900",
            "aria-expanded": r.value,
            onClick: w[0] || (w[0] = (D) => r.value = !r.value)
          }, [
            L(F, {
              class: ee(["transition-transform", r.value ? "rotate-180" : ""])
            }, null, 8, ["class"]),
            q(" " + y(r.value ? t.value.showShortPriceList : t.value.showFullPriceList), 1)
          ], 8, iS)) : B("", !0)
        ], 64)) : (m(), h("div", aS, y(t.value.noData), 1))
      ], 6);
    };
  }
});
var Fl = {
  name: "WindowMaximizeIcon",
  extends: Ue
};
function lS(e) {
  return cS(e) || uS(e) || dS(e) || sS();
}
function sS() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function dS(e, t) {
  if (e) {
    if (typeof e == "string") return Ar(e, t);
    var n = {}.toString.call(e).slice(8, -1);
    return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Ar(e, t) : void 0;
  }
}
function uS(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function cS(e) {
  if (Array.isArray(e)) return Ar(e);
}
function Ar(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, o = Array(t); n < t; n++) o[n] = e[n];
  return o;
}
function pS(e, t, n, o, i, r) {
  return m(), h("svg", x({
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.pti()), lS(t[0] || (t[0] = [g("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M7 14H11.8C12.3835 14 12.9431 13.7682 13.3556 13.3556C13.7682 12.9431 14 12.3835 14 11.8V2.2C14 1.61652 13.7682 1.05694 13.3556 0.644365C12.9431 0.231785 12.3835 0 11.8 0H2.2C1.61652 0 1.05694 0.231785 0.644365 0.644365C0.231785 1.05694 0 1.61652 0 2.2V7C0 7.15913 0.063214 7.31174 0.175736 7.42426C0.288258 7.53679 0.44087 7.6 0.6 7.6C0.75913 7.6 0.911742 7.53679 1.02426 7.42426C1.13679 7.31174 1.2 7.15913 1.2 7V2.2C1.2 1.93478 1.30536 1.68043 1.49289 1.49289C1.68043 1.30536 1.93478 1.2 2.2 1.2H11.8C12.0652 1.2 12.3196 1.30536 12.5071 1.49289C12.6946 1.68043 12.8 1.93478 12.8 2.2V11.8C12.8 12.0652 12.6946 12.3196 12.5071 12.5071C12.3196 12.6946 12.0652 12.8 11.8 12.8H7C6.84087 12.8 6.68826 12.8632 6.57574 12.9757C6.46321 13.0883 6.4 13.2409 6.4 13.4C6.4 13.5591 6.46321 13.7117 6.57574 13.8243C6.68826 13.9368 6.84087 14 7 14ZM9.77805 7.42192C9.89013 7.534 10.0415 7.59788 10.2 7.59995C10.3585 7.59788 10.5099 7.534 10.622 7.42192C10.7341 7.30985 10.798 7.15844 10.8 6.99995V3.94242C10.8066 3.90505 10.8096 3.86689 10.8089 3.82843C10.8079 3.77159 10.7988 3.7157 10.7824 3.6623C10.756 3.55552 10.701 3.45698 10.622 3.37798C10.5099 3.2659 10.3585 3.20202 10.2 3.19995H7.00002C6.84089 3.19995 6.68828 3.26317 6.57576 3.37569C6.46324 3.48821 6.40002 3.64082 6.40002 3.79995C6.40002 3.95908 6.46324 4.11169 6.57576 4.22422C6.68828 4.33674 6.84089 4.39995 7.00002 4.39995H8.80006L6.19997 7.00005C6.10158 7.11005 6.04718 7.25246 6.04718 7.40005C6.04718 7.54763 6.10158 7.69004 6.19997 7.80005C6.30202 7.91645 6.44561 7.98824 6.59997 8.00005C6.75432 7.98824 6.89791 7.91645 6.99997 7.80005L9.60002 5.26841V6.99995C9.6021 7.15844 9.66598 7.30985 9.77805 7.42192ZM1.4 14H3.8C4.17066 13.9979 4.52553 13.8498 4.78763 13.5877C5.04973 13.3256 5.1979 12.9707 5.2 12.6V10.2C5.1979 9.82939 5.04973 9.47452 4.78763 9.21242C4.52553 8.95032 4.17066 8.80215 3.8 8.80005H1.4C1.02934 8.80215 0.674468 8.95032 0.412371 9.21242C0.150274 9.47452 0.00210008 9.82939 0 10.2V12.6C0.00210008 12.9707 0.150274 13.3256 0.412371 13.5877C0.674468 13.8498 1.02934 13.9979 1.4 14ZM1.25858 10.0586C1.29609 10.0211 1.34696 10 1.4 10H3.8C3.85304 10 3.90391 10.0211 3.94142 10.0586C3.97893 10.0961 4 10.147 4 10.2V12.6C4 12.6531 3.97893 12.704 3.94142 12.7415C3.90391 12.779 3.85304 12.8 3.8 12.8H1.4C1.34696 12.8 1.29609 12.779 1.25858 12.7415C1.22107 12.704 1.2 12.6531 1.2 12.6V10.2C1.2 10.147 1.22107 10.0961 1.25858 10.0586Z",
    fill: "currentColor"
  }, null, -1)])), 16);
}
Fl.render = pS;
var El = {
  name: "WindowMinimizeIcon",
  extends: Ue
};
function mS(e) {
  return bS(e) || hS(e) || gS(e) || fS();
}
function fS() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function gS(e, t) {
  if (e) {
    if (typeof e == "string") return _r(e, t);
    var n = {}.toString.call(e).slice(8, -1);
    return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? _r(e, t) : void 0;
  }
}
function hS(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function bS(e) {
  if (Array.isArray(e)) return _r(e);
}
function _r(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, o = Array(t); n < t; n++) o[n] = e[n];
  return o;
}
function vS(e, t, n, o, i, r) {
  return m(), h("svg", x({
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.pti()), mS(t[0] || (t[0] = [g("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M11.8 0H2.2C1.61652 0 1.05694 0.231785 0.644365 0.644365C0.231785 1.05694 0 1.61652 0 2.2V7C0 7.15913 0.063214 7.31174 0.175736 7.42426C0.288258 7.53679 0.44087 7.6 0.6 7.6C0.75913 7.6 0.911742 7.53679 1.02426 7.42426C1.13679 7.31174 1.2 7.15913 1.2 7V2.2C1.2 1.93478 1.30536 1.68043 1.49289 1.49289C1.68043 1.30536 1.93478 1.2 2.2 1.2H11.8C12.0652 1.2 12.3196 1.30536 12.5071 1.49289C12.6946 1.68043 12.8 1.93478 12.8 2.2V11.8C12.8 12.0652 12.6946 12.3196 12.5071 12.5071C12.3196 12.6946 12.0652 12.8 11.8 12.8H7C6.84087 12.8 6.68826 12.8632 6.57574 12.9757C6.46321 13.0883 6.4 13.2409 6.4 13.4C6.4 13.5591 6.46321 13.7117 6.57574 13.8243C6.68826 13.9368 6.84087 14 7 14H11.8C12.3835 14 12.9431 13.7682 13.3556 13.3556C13.7682 12.9431 14 12.3835 14 11.8V2.2C14 1.61652 13.7682 1.05694 13.3556 0.644365C12.9431 0.231785 12.3835 0 11.8 0ZM6.368 7.952C6.44137 7.98326 6.52025 7.99958 6.6 8H9.8C9.95913 8 10.1117 7.93678 10.2243 7.82426C10.3368 7.71174 10.4 7.55913 10.4 7.4C10.4 7.24087 10.3368 7.08826 10.2243 6.97574C10.1117 6.86321 9.95913 6.8 9.8 6.8H8.048L10.624 4.224C10.73 4.11026 10.7877 3.95982 10.7849 3.80438C10.7822 3.64894 10.7192 3.50063 10.6093 3.3907C10.4994 3.28077 10.3511 3.2178 10.1956 3.21506C10.0402 3.21232 9.88974 3.27002 9.776 3.376L7.2 5.952V4.2C7.2 4.04087 7.13679 3.88826 7.02426 3.77574C6.91174 3.66321 6.75913 3.6 6.6 3.6C6.44087 3.6 6.28826 3.66321 6.17574 3.77574C6.06321 3.88826 6 4.04087 6 4.2V7.4C6.00042 7.47975 6.01674 7.55862 6.048 7.632C6.07656 7.70442 6.11971 7.7702 6.17475 7.82524C6.2298 7.88029 6.29558 7.92344 6.368 7.952ZM1.4 8.80005H3.8C4.17066 8.80215 4.52553 8.95032 4.78763 9.21242C5.04973 9.47452 5.1979 9.82939 5.2 10.2V12.6C5.1979 12.9707 5.04973 13.3256 4.78763 13.5877C4.52553 13.8498 4.17066 13.9979 3.8 14H1.4C1.02934 13.9979 0.674468 13.8498 0.412371 13.5877C0.150274 13.3256 0.00210008 12.9707 0 12.6V10.2C0.00210008 9.82939 0.150274 9.47452 0.412371 9.21242C0.674468 8.95032 1.02934 8.80215 1.4 8.80005ZM3.94142 12.7415C3.97893 12.704 4 12.6531 4 12.6V10.2C4 10.147 3.97893 10.0961 3.94142 10.0586C3.90391 10.0211 3.85304 10 3.8 10H1.4C1.34696 10 1.29609 10.0211 1.25858 10.0586C1.22107 10.0961 1.2 10.147 1.2 10.2V12.6C1.2 12.6531 1.22107 12.704 1.25858 12.7415C1.29609 12.779 1.34696 12.8 1.4 12.8H3.8C3.85304 12.8 3.90391 12.779 3.94142 12.7415Z",
    fill: "currentColor"
  }, null, -1)])), 16);
}
El.render = vS;
var yS = oe.extend({
  name: "focustrap-directive"
}), kS = ne.extend({
  style: yS
});
function ao(e) {
  "@babel/helpers - typeof";
  return ao = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ao(e);
}
function ma(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    t && (o = o.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, o);
  }
  return n;
}
function fa(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ma(Object(n), !0).forEach(function(o) {
      wS(e, o, n[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : ma(Object(n)).forEach(function(o) {
      Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(n, o));
    });
  }
  return e;
}
function wS(e, t, n) {
  return (t = xS(t)) in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function xS(e) {
  var t = CS(e, "string");
  return ao(t) == "symbol" ? t : t + "";
}
function CS(e, t) {
  if (ao(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var o = n.call(e, t);
    if (ao(o) != "object") return o;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var SS = kS.extend("focustrap", {
  mounted: function(t, n) {
    var o = n.value || {}, i = o.disabled;
    i || (this.createHiddenFocusableElements(t, n), this.bind(t, n), this.autoElementFocus(t, n)), t.setAttribute("data-pd-focustrap", !0), this.$el = t;
  },
  updated: function(t, n) {
    var o = n.value || {}, i = o.disabled;
    i && this.unbind(t);
  },
  unmounted: function(t) {
    this.unbind(t);
  },
  methods: {
    getComputedSelector: function(t) {
      return ':not(.p-hidden-focusable):not([data-p-hidden-focusable="true"])'.concat(t ?? "");
    },
    bind: function(t, n) {
      var o = this, i = n.value || {}, r = i.onFocusIn, a = i.onFocusOut;
      t.$_pfocustrap_mutationobserver = new MutationObserver(function(d) {
        d.forEach(function(l) {
          if (l.type === "childList" && !t.contains(document.activeElement)) {
            var u = function(c) {
              var p = vi(c) ? vi(c, o.getComputedSelector(t.$_pfocustrap_focusableselector)) ? c : un(t, o.getComputedSelector(t.$_pfocustrap_focusableselector)) : un(c);
              return le(p) ? p : c.nextSibling && u(c.nextSibling);
            };
            We(u(l.nextSibling));
          }
        });
      }), t.$_pfocustrap_mutationobserver.disconnect(), t.$_pfocustrap_mutationobserver.observe(t, {
        childList: !0
      }), t.$_pfocustrap_focusinlistener = function(d) {
        return r && r(d);
      }, t.$_pfocustrap_focusoutlistener = function(d) {
        return a && a(d);
      }, t.addEventListener("focusin", t.$_pfocustrap_focusinlistener), t.addEventListener("focusout", t.$_pfocustrap_focusoutlistener);
    },
    unbind: function(t) {
      t.$_pfocustrap_mutationobserver && t.$_pfocustrap_mutationobserver.disconnect(), t.$_pfocustrap_focusinlistener && t.removeEventListener("focusin", t.$_pfocustrap_focusinlistener) && (t.$_pfocustrap_focusinlistener = null), t.$_pfocustrap_focusoutlistener && t.removeEventListener("focusout", t.$_pfocustrap_focusoutlistener) && (t.$_pfocustrap_focusoutlistener = null);
    },
    autoFocus: function(t) {
      this.autoElementFocus(this.$el, {
        value: fa(fa({}, t), {}, {
          autoFocus: !0
        })
      });
    },
    autoElementFocus: function(t, n) {
      var o = n.value || {}, i = o.autoFocusSelector, r = i === void 0 ? "" : i, a = o.firstFocusableSelector, d = a === void 0 ? "" : a, l = o.autoFocus, u = l === void 0 ? !1 : l, s = un(t, "[autofocus]".concat(this.getComputedSelector(r)));
      u && !s && (s = un(t, this.getComputedSelector(d))), We(s);
    },
    onFirstHiddenElementFocus: function(t) {
      var n, o = t.currentTarget, i = t.relatedTarget, r = i === o.$_pfocustrap_lasthiddenfocusableelement || !((n = this.$el) !== null && n !== void 0 && n.contains(i)) ? un(o.parentElement, this.getComputedSelector(o.$_pfocustrap_focusableselector)) : o.$_pfocustrap_lasthiddenfocusableelement;
      We(r);
    },
    onLastHiddenElementFocus: function(t) {
      var n, o = t.currentTarget, i = t.relatedTarget, r = i === o.$_pfocustrap_firsthiddenfocusableelement || !((n = this.$el) !== null && n !== void 0 && n.contains(i)) ? Oa(o.parentElement, this.getComputedSelector(o.$_pfocustrap_focusableselector)) : o.$_pfocustrap_firsthiddenfocusableelement;
      We(r);
    },
    createHiddenFocusableElements: function(t, n) {
      var o = this, i = n.value || {}, r = i.tabIndex, a = r === void 0 ? 0 : r, d = i.firstFocusableSelector, l = d === void 0 ? "" : d, u = i.lastFocusableSelector, s = u === void 0 ? "" : u, c = function(k) {
        return La("span", {
          class: "p-hidden-accessible p-hidden-focusable",
          tabIndex: a,
          role: "presentation",
          "aria-hidden": !0,
          "data-p-hidden-accessible": !0,
          "data-p-hidden-focusable": !0,
          onFocus: k?.bind(o)
        });
      }, p = c(this.onFirstHiddenElementFocus), f = c(this.onLastHiddenElementFocus);
      p.$_pfocustrap_lasthiddenfocusableelement = f, p.$_pfocustrap_focusableselector = l, p.setAttribute("data-pc-section", "firstfocusableelement"), f.$_pfocustrap_firsthiddenfocusableelement = p, f.$_pfocustrap_focusableselector = s, f.setAttribute("data-pc-section", "lastfocusableelement"), t.prepend(p), t.append(f);
    }
  }
});
function Fr() {
  Os({
    variableName: Wa("scrollbar.width").name
  });
}
function ga() {
  Ms({
    variableName: Wa("scrollbar.width").name
  });
}
var $S = `
    .p-dialog {
        max-height: 90%;
        transform: scale(1);
        border-radius: dt('dialog.border.radius');
        box-shadow: dt('dialog.shadow');
        background: dt('dialog.background');
        border: 1px solid dt('dialog.border.color');
        color: dt('dialog.color');
    }

    .p-dialog-content {
        overflow-y: auto;
        padding: dt('dialog.content.padding');
    }

    .p-dialog-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-shrink: 0;
        padding: dt('dialog.header.padding');
    }

    .p-dialog-title {
        font-weight: dt('dialog.title.font.weight');
        font-size: dt('dialog.title.font.size');
    }

    .p-dialog-footer {
        flex-shrink: 0;
        padding: dt('dialog.footer.padding');
        display: flex;
        justify-content: flex-end;
        gap: dt('dialog.footer.gap');
    }

    .p-dialog-header-actions {
        display: flex;
        align-items: center;
        gap: dt('dialog.header.gap');
    }

    .p-dialog-enter-active {
        transition: all 150ms cubic-bezier(0, 0, 0.2, 1);
    }

    .p-dialog-leave-active {
        transition: all 150ms cubic-bezier(0.4, 0, 0.2, 1);
    }

    .p-dialog-enter-from,
    .p-dialog-leave-to {
        opacity: 0;
        transform: scale(0.7);
    }

    .p-dialog-top .p-dialog,
    .p-dialog-bottom .p-dialog,
    .p-dialog-left .p-dialog,
    .p-dialog-right .p-dialog,
    .p-dialog-topleft .p-dialog,
    .p-dialog-topright .p-dialog,
    .p-dialog-bottomleft .p-dialog,
    .p-dialog-bottomright .p-dialog {
        margin: 0.75rem;
        transform: translate3d(0px, 0px, 0px);
    }

    .p-dialog-top .p-dialog-enter-active,
    .p-dialog-top .p-dialog-leave-active,
    .p-dialog-bottom .p-dialog-enter-active,
    .p-dialog-bottom .p-dialog-leave-active,
    .p-dialog-left .p-dialog-enter-active,
    .p-dialog-left .p-dialog-leave-active,
    .p-dialog-right .p-dialog-enter-active,
    .p-dialog-right .p-dialog-leave-active,
    .p-dialog-topleft .p-dialog-enter-active,
    .p-dialog-topleft .p-dialog-leave-active,
    .p-dialog-topright .p-dialog-enter-active,
    .p-dialog-topright .p-dialog-leave-active,
    .p-dialog-bottomleft .p-dialog-enter-active,
    .p-dialog-bottomleft .p-dialog-leave-active,
    .p-dialog-bottomright .p-dialog-enter-active,
    .p-dialog-bottomright .p-dialog-leave-active {
        transition: all 0.3s ease-out;
    }

    .p-dialog-top .p-dialog-enter-from,
    .p-dialog-top .p-dialog-leave-to {
        transform: translate3d(0px, -100%, 0px);
    }

    .p-dialog-bottom .p-dialog-enter-from,
    .p-dialog-bottom .p-dialog-leave-to {
        transform: translate3d(0px, 100%, 0px);
    }

    .p-dialog-left .p-dialog-enter-from,
    .p-dialog-left .p-dialog-leave-to,
    .p-dialog-topleft .p-dialog-enter-from,
    .p-dialog-topleft .p-dialog-leave-to,
    .p-dialog-bottomleft .p-dialog-enter-from,
    .p-dialog-bottomleft .p-dialog-leave-to {
        transform: translate3d(-100%, 0px, 0px);
    }

    .p-dialog-right .p-dialog-enter-from,
    .p-dialog-right .p-dialog-leave-to,
    .p-dialog-topright .p-dialog-enter-from,
    .p-dialog-topright .p-dialog-leave-to,
    .p-dialog-bottomright .p-dialog-enter-from,
    .p-dialog-bottomright .p-dialog-leave-to {
        transform: translate3d(100%, 0px, 0px);
    }

    .p-dialog-left:dir(rtl) .p-dialog-enter-from,
    .p-dialog-left:dir(rtl) .p-dialog-leave-to,
    .p-dialog-topleft:dir(rtl) .p-dialog-enter-from,
    .p-dialog-topleft:dir(rtl) .p-dialog-leave-to,
    .p-dialog-bottomleft:dir(rtl) .p-dialog-enter-from,
    .p-dialog-bottomleft:dir(rtl) .p-dialog-leave-to {
        transform: translate3d(100%, 0px, 0px);
    }

    .p-dialog-right:dir(rtl) .p-dialog-enter-from,
    .p-dialog-right:dir(rtl) .p-dialog-leave-to,
    .p-dialog-topright:dir(rtl) .p-dialog-enter-from,
    .p-dialog-topright:dir(rtl) .p-dialog-leave-to,
    .p-dialog-bottomright:dir(rtl) .p-dialog-enter-from,
    .p-dialog-bottomright:dir(rtl) .p-dialog-leave-to {
        transform: translate3d(-100%, 0px, 0px);
    }

    .p-dialog-maximized {
        width: 100vw !important;
        height: 100vh !important;
        top: 0px !important;
        left: 0px !important;
        max-height: 100%;
        height: 100%;
        border-radius: 0;
    }

    .p-dialog-maximized .p-dialog-content {
        flex-grow: 1;
    }

    .p-dialog .p-resizable-handle {
        position: absolute;
        font-size: 0.1px;
        display: block;
        cursor: se-resize;
        width: 12px;
        height: 12px;
        right: 1px;
        bottom: 1px;
    }
`, BS = {
  mask: function(t) {
    var n = t.position, o = t.modal;
    return {
      position: "fixed",
      height: "100%",
      width: "100%",
      left: 0,
      top: 0,
      display: "flex",
      justifyContent: n === "left" || n === "topleft" || n === "bottomleft" ? "flex-start" : n === "right" || n === "topright" || n === "bottomright" ? "flex-end" : "center",
      alignItems: n === "top" || n === "topleft" || n === "topright" ? "flex-start" : n === "bottom" || n === "bottomleft" || n === "bottomright" ? "flex-end" : "center",
      pointerEvents: o ? "auto" : "none"
    };
  },
  root: {
    display: "flex",
    flexDirection: "column",
    pointerEvents: "auto"
  }
}, TS = {
  mask: function(t) {
    var n = t.props, o = ["left", "right", "top", "topleft", "topright", "bottom", "bottomleft", "bottomright"], i = o.find(function(r) {
      return r === n.position;
    });
    return ["p-dialog-mask", {
      "p-overlay-mask p-overlay-mask-enter": n.modal
    }, i ? "p-dialog-".concat(i) : ""];
  },
  root: function(t) {
    var n = t.props, o = t.instance;
    return ["p-dialog p-component", {
      "p-dialog-maximized": n.maximizable && o.maximized
    }];
  },
  header: "p-dialog-header",
  title: "p-dialog-title",
  headerActions: "p-dialog-header-actions",
  pcMaximizeButton: "p-dialog-maximize-button",
  pcCloseButton: "p-dialog-close-button",
  content: "p-dialog-content",
  footer: "p-dialog-footer"
}, IS = oe.extend({
  name: "dialog",
  style: $S,
  classes: TS,
  inlineStyles: BS
}), DS = {
  name: "BaseDialog",
  extends: nt,
  props: {
    header: {
      type: null,
      default: null
    },
    footer: {
      type: null,
      default: null
    },
    visible: {
      type: Boolean,
      default: !1
    },
    modal: {
      type: Boolean,
      default: null
    },
    contentStyle: {
      type: null,
      default: null
    },
    contentClass: {
      type: String,
      default: null
    },
    contentProps: {
      type: null,
      default: null
    },
    maximizable: {
      type: Boolean,
      default: !1
    },
    dismissableMask: {
      type: Boolean,
      default: !1
    },
    closable: {
      type: Boolean,
      default: !0
    },
    closeOnEscape: {
      type: Boolean,
      default: !0
    },
    showHeader: {
      type: Boolean,
      default: !0
    },
    blockScroll: {
      type: Boolean,
      default: !1
    },
    baseZIndex: {
      type: Number,
      default: 0
    },
    autoZIndex: {
      type: Boolean,
      default: !0
    },
    position: {
      type: String,
      default: "center"
    },
    breakpoints: {
      type: Object,
      default: null
    },
    draggable: {
      type: Boolean,
      default: !0
    },
    keepInViewport: {
      type: Boolean,
      default: !0
    },
    minX: {
      type: Number,
      default: 0
    },
    minY: {
      type: Number,
      default: 0
    },
    appendTo: {
      type: [String, Object],
      default: "body"
    },
    closeIcon: {
      type: String,
      default: void 0
    },
    maximizeIcon: {
      type: String,
      default: void 0
    },
    minimizeIcon: {
      type: String,
      default: void 0
    },
    closeButtonProps: {
      type: Object,
      default: function() {
        return {
          severity: "secondary",
          text: !0,
          rounded: !0
        };
      }
    },
    maximizeButtonProps: {
      type: Object,
      default: function() {
        return {
          severity: "secondary",
          text: !0,
          rounded: !0
        };
      }
    },
    _instance: null
  },
  style: IS,
  provide: function() {
    return {
      $pcDialog: this,
      $parentInstance: this
    };
  }
}, ho = {
  name: "Dialog",
  extends: DS,
  inheritAttrs: !1,
  emits: ["update:visible", "show", "hide", "after-hide", "maximize", "unmaximize", "dragstart", "dragend"],
  provide: function() {
    var t = this;
    return {
      dialogRef: v(function() {
        return t._instance;
      })
    };
  },
  data: function() {
    return {
      containerVisible: this.visible,
      maximized: !1,
      focusableMax: null,
      focusableClose: null,
      target: null
    };
  },
  documentKeydownListener: null,
  container: null,
  mask: null,
  content: null,
  headerContainer: null,
  footerContainer: null,
  maximizableButton: null,
  closeButton: null,
  styleElement: null,
  dragging: null,
  documentDragListener: null,
  documentDragEndListener: null,
  lastPageX: null,
  lastPageY: null,
  maskMouseDownTarget: null,
  updated: function() {
    this.visible && (this.containerVisible = this.visible);
  },
  beforeUnmount: function() {
    this.unbindDocumentState(), this.unbindGlobalListeners(), this.destroyStyle(), this.mask && this.autoZIndex && wt.clear(this.mask), this.container = null, this.mask = null;
  },
  mounted: function() {
    this.breakpoints && this.createStyle();
  },
  methods: {
    close: function() {
      this.$emit("update:visible", !1);
    },
    onEnter: function() {
      this.$emit("show"), this.target = document.activeElement, this.enableDocumentSettings(), this.bindGlobalListeners(), this.autoZIndex && wt.set("modal", this.mask, this.baseZIndex + this.$primevue.config.zIndex.modal);
    },
    onAfterEnter: function() {
      this.focus();
    },
    onBeforeLeave: function() {
      this.modal && !this.isUnstyled && Po(this.mask, "p-overlay-mask-leave"), this.dragging && this.documentDragEndListener && this.documentDragEndListener();
    },
    onLeave: function() {
      this.$emit("hide"), We(this.target), this.target = null, this.focusableClose = null, this.focusableMax = null;
    },
    onAfterLeave: function() {
      this.autoZIndex && wt.clear(this.mask), this.containerVisible = !1, this.unbindDocumentState(), this.unbindGlobalListeners(), this.$emit("after-hide");
    },
    onMaskMouseDown: function(t) {
      this.maskMouseDownTarget = t.target;
    },
    onMaskMouseUp: function() {
      this.dismissableMask && this.modal && this.mask === this.maskMouseDownTarget && this.close();
    },
    focus: function() {
      var t = function(i) {
        return i && i.querySelector("[autofocus]");
      }, n = this.$slots.footer && t(this.footerContainer);
      n || (n = this.$slots.header && t(this.headerContainer), n || (n = this.$slots.default && t(this.content), n || (this.maximizable ? (this.focusableMax = !0, n = this.maximizableButton) : (this.focusableClose = !0, n = this.closeButton)))), n && We(n, {
        focusVisible: !0
      });
    },
    maximize: function(t) {
      this.maximized ? (this.maximized = !1, this.$emit("unmaximize", t)) : (this.maximized = !0, this.$emit("maximize", t)), this.modal || (this.maximized ? Fr() : ga());
    },
    enableDocumentSettings: function() {
      (this.modal || !this.modal && this.blockScroll || this.maximizable && this.maximized) && Fr();
    },
    unbindDocumentState: function() {
      (this.modal || !this.modal && this.blockScroll || this.maximizable && this.maximized) && ga();
    },
    onKeyDown: function(t) {
      t.code === "Escape" && this.closeOnEscape && this.close();
    },
    bindDocumentKeyDownListener: function() {
      this.documentKeydownListener || (this.documentKeydownListener = this.onKeyDown.bind(this), window.document.addEventListener("keydown", this.documentKeydownListener));
    },
    unbindDocumentKeyDownListener: function() {
      this.documentKeydownListener && (window.document.removeEventListener("keydown", this.documentKeydownListener), this.documentKeydownListener = null);
    },
    containerRef: function(t) {
      this.container = t;
    },
    maskRef: function(t) {
      this.mask = t;
    },
    contentRef: function(t) {
      this.content = t;
    },
    headerContainerRef: function(t) {
      this.headerContainer = t;
    },
    footerContainerRef: function(t) {
      this.footerContainer = t;
    },
    maximizableRef: function(t) {
      this.maximizableButton = t ? t.$el : void 0;
    },
    closeButtonRef: function(t) {
      this.closeButton = t ? t.$el : void 0;
    },
    createStyle: function() {
      if (!this.styleElement && !this.isUnstyled) {
        var t;
        this.styleElement = document.createElement("style"), this.styleElement.type = "text/css", Wr(this.styleElement, "nonce", (t = this.$primevue) === null || t === void 0 || (t = t.config) === null || t === void 0 || (t = t.csp) === null || t === void 0 ? void 0 : t.nonce), document.head.appendChild(this.styleElement);
        var n = "";
        for (var o in this.breakpoints)
          n += `
                        @media screen and (max-width: `.concat(o, `) {
                            .p-dialog[`).concat(this.$attrSelector, `] {
                                width: `).concat(this.breakpoints[o], ` !important;
                            }
                        }
                    `);
        this.styleElement.innerHTML = n;
      }
    },
    destroyStyle: function() {
      this.styleElement && (document.head.removeChild(this.styleElement), this.styleElement = null);
    },
    initDrag: function(t) {
      t.target.closest("div").getAttribute("data-pc-section") !== "headeractions" && this.draggable && (this.dragging = !0, this.lastPageX = t.pageX, this.lastPageY = t.pageY, this.container.style.margin = "0", document.body.setAttribute("data-p-unselectable-text", "true"), !this.isUnstyled && Hr(document.body, {
        "user-select": "none"
      }), this.$emit("dragstart", t));
    },
    bindGlobalListeners: function() {
      this.draggable && (this.bindDocumentDragListener(), this.bindDocumentDragEndListener()), this.closeOnEscape && this.bindDocumentKeyDownListener();
    },
    unbindGlobalListeners: function() {
      this.unbindDocumentDragListener(), this.unbindDocumentDragEndListener(), this.unbindDocumentKeyDownListener();
    },
    bindDocumentDragListener: function() {
      var t = this;
      this.documentDragListener = function(n) {
        if (t.dragging) {
          var o = fn(t.container), i = Ma(t.container), r = n.pageX - t.lastPageX, a = n.pageY - t.lastPageY, d = t.container.getBoundingClientRect(), l = d.left + r, u = d.top + a, s = Ur(), c = getComputedStyle(t.container), p = parseFloat(c.marginLeft), f = parseFloat(c.marginTop);
          t.container.style.position = "fixed", t.keepInViewport ? (l >= t.minX && l + o < s.width && (t.lastPageX = n.pageX, t.container.style.left = l - p + "px"), u >= t.minY && u + i < s.height && (t.lastPageY = n.pageY, t.container.style.top = u - f + "px")) : (t.lastPageX = n.pageX, t.container.style.left = l - p + "px", t.lastPageY = n.pageY, t.container.style.top = u - f + "px");
        }
      }, window.document.addEventListener("mousemove", this.documentDragListener);
    },
    unbindDocumentDragListener: function() {
      this.documentDragListener && (window.document.removeEventListener("mousemove", this.documentDragListener), this.documentDragListener = null);
    },
    bindDocumentDragEndListener: function() {
      var t = this;
      this.documentDragEndListener = function(n) {
        t.dragging && (t.dragging = !1, document.body.removeAttribute("data-p-unselectable-text"), !t.isUnstyled && (document.body.style["user-select"] = ""), t.$emit("dragend", n));
      }, window.document.addEventListener("mouseup", this.documentDragEndListener);
    },
    unbindDocumentDragEndListener: function() {
      this.documentDragEndListener && (window.document.removeEventListener("mouseup", this.documentDragEndListener), this.documentDragEndListener = null);
    }
  },
  computed: {
    maximizeIconComponent: function() {
      return this.maximized ? this.minimizeIcon ? "span" : "WindowMinimizeIcon" : this.maximizeIcon ? "span" : "WindowMaximizeIcon";
    },
    ariaLabelledById: function() {
      return this.header != null || this.$attrs["aria-labelledby"] !== null ? this.$id + "_header" : null;
    },
    closeAriaLabel: function() {
      return this.$primevue.config.locale.aria ? this.$primevue.config.locale.aria.close : void 0;
    },
    dataP: function() {
      return Pe({
        maximized: this.maximized,
        modal: this.modal
      });
    }
  },
  directives: {
    ripple: fo,
    focustrap: SS
  },
  components: {
    Button: bt,
    Portal: Yo,
    WindowMinimizeIcon: El,
    WindowMaximizeIcon: Fl,
    TimesIcon: Wo
  }
};
function lo(e) {
  "@babel/helpers - typeof";
  return lo = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, lo(e);
}
function ha(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    t && (o = o.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, o);
  }
  return n;
}
function ba(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ha(Object(n), !0).forEach(function(o) {
      PS(e, o, n[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : ha(Object(n)).forEach(function(o) {
      Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(n, o));
    });
  }
  return e;
}
function PS(e, t, n) {
  return (t = zS(t)) in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function zS(e) {
  var t = LS(e, "string");
  return lo(t) == "symbol" ? t : t + "";
}
function LS(e, t) {
  if (lo(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var o = n.call(e, t);
    if (lo(o) != "object") return o;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var OS = ["data-p"], MS = ["aria-labelledby", "aria-modal", "data-p"], AS = ["id"], _S = ["data-p"];
function FS(e, t, n, o, i, r) {
  var a = ze("Button"), d = ze("Portal"), l = uo("focustrap");
  return m(), j(d, {
    appendTo: e.appendTo
  }, {
    default: U(function() {
      return [i.containerVisible ? (m(), h("div", x({
        key: 0,
        ref: r.maskRef,
        class: e.cx("mask"),
        style: e.sx("mask", !0, {
          position: e.position,
          modal: e.modal
        }),
        onMousedown: t[1] || (t[1] = function() {
          return r.onMaskMouseDown && r.onMaskMouseDown.apply(r, arguments);
        }),
        onMouseup: t[2] || (t[2] = function() {
          return r.onMaskMouseUp && r.onMaskMouseUp.apply(r, arguments);
        }),
        "data-p": r.dataP
      }, e.ptm("mask")), [L(Cn, x({
        name: "p-dialog",
        onEnter: r.onEnter,
        onAfterEnter: r.onAfterEnter,
        onBeforeLeave: r.onBeforeLeave,
        onLeave: r.onLeave,
        onAfterLeave: r.onAfterLeave,
        appear: ""
      }, e.ptm("transition")), {
        default: U(function() {
          return [e.visible ? Ze((m(), h("div", x({
            key: 0,
            ref: r.containerRef,
            class: e.cx("root"),
            style: e.sx("root"),
            role: "dialog",
            "aria-labelledby": r.ariaLabelledById,
            "aria-modal": e.modal,
            "data-p": r.dataP
          }, e.ptmi("root")), [e.$slots.container ? R(e.$slots, "container", {
            key: 0,
            closeCallback: r.close,
            maximizeCallback: function(s) {
              return r.maximize(s);
            }
          }) : (m(), h(Y, {
            key: 1
          }, [e.showHeader ? (m(), h("div", x({
            key: 0,
            ref: r.headerContainerRef,
            class: e.cx("header"),
            onMousedown: t[0] || (t[0] = function() {
              return r.initDrag && r.initDrag.apply(r, arguments);
            })
          }, e.ptm("header")), [R(e.$slots, "header", {
            class: ee(e.cx("title"))
          }, function() {
            return [e.header ? (m(), h("span", x({
              key: 0,
              id: r.ariaLabelledById,
              class: e.cx("title")
            }, e.ptm("title")), y(e.header), 17, AS)) : B("", !0)];
          }), g("div", x({
            class: e.cx("headerActions")
          }, e.ptm("headerActions")), [e.maximizable ? R(e.$slots, "maximizebutton", {
            key: 0,
            maximized: i.maximized,
            maximizeCallback: function(s) {
              return r.maximize(s);
            }
          }, function() {
            return [L(a, x({
              ref: r.maximizableRef,
              autofocus: i.focusableMax,
              class: e.cx("pcMaximizeButton"),
              onClick: r.maximize,
              tabindex: e.maximizable ? "0" : "-1",
              unstyled: e.unstyled
            }, e.maximizeButtonProps, {
              pt: e.ptm("pcMaximizeButton"),
              "data-pc-group-section": "headericon"
            }), {
              icon: U(function(u) {
                return [R(e.$slots, "maximizeicon", {
                  maximized: i.maximized
                }, function() {
                  return [(m(), j($e(r.maximizeIconComponent), x({
                    class: [u.class, i.maximized ? e.minimizeIcon : e.maximizeIcon]
                  }, e.ptm("pcMaximizeButton").icon), null, 16, ["class"]))];
                })];
              }),
              _: 3
            }, 16, ["autofocus", "class", "onClick", "tabindex", "unstyled", "pt"])];
          }) : B("", !0), e.closable ? R(e.$slots, "closebutton", {
            key: 1,
            closeCallback: r.close
          }, function() {
            return [L(a, x({
              ref: r.closeButtonRef,
              autofocus: i.focusableClose,
              class: e.cx("pcCloseButton"),
              onClick: r.close,
              "aria-label": r.closeAriaLabel,
              unstyled: e.unstyled
            }, e.closeButtonProps, {
              pt: e.ptm("pcCloseButton"),
              "data-pc-group-section": "headericon"
            }), {
              icon: U(function(u) {
                return [R(e.$slots, "closeicon", {}, function() {
                  return [(m(), j($e(e.closeIcon ? "span" : "TimesIcon"), x({
                    class: [e.closeIcon, u.class]
                  }, e.ptm("pcCloseButton").icon), null, 16, ["class"]))];
                })];
              }),
              _: 3
            }, 16, ["autofocus", "class", "onClick", "aria-label", "unstyled", "pt"])];
          }) : B("", !0)], 16)], 16)) : B("", !0), g("div", x({
            ref: r.contentRef,
            class: [e.cx("content"), e.contentClass],
            style: e.contentStyle,
            "data-p": r.dataP
          }, ba(ba({}, e.contentProps), e.ptm("content"))), [R(e.$slots, "default")], 16, _S), e.footer || e.$slots.footer ? (m(), h("div", x({
            key: 1,
            ref: r.footerContainerRef,
            class: e.cx("footer")
          }, e.ptm("footer")), [R(e.$slots, "footer", {}, function() {
            return [q(y(e.footer), 1)];
          })], 16)) : B("", !0)], 64))], 16, MS)), [[l, {
            disabled: !e.modal
          }]]) : B("", !0)];
        }),
        _: 3
      }, 16, ["onEnter", "onAfterEnter", "onBeforeLeave", "onLeave", "onAfterLeave"])], 16, OS)) : B("", !0)];
    }),
    _: 3
  }, 8, ["appendTo"]);
}
ho.render = FS;
const ES = {
  viewBox: "0 0 24 24",
  width: "1.2em",
  height: "1.2em"
};
function RS(e, t) {
  return m(), h("svg", ES, [...t[0] || (t[0] = [
    g("path", {
      fill: "currentColor",
      d: "M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10s10-4.5 10-10S17.5 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8s8 3.59 8 8s-3.59 8-8 8m4.59-12.42L10 14.17l-2.59-2.58L6 13l4 4l8-8z"
    }, null, -1)
  ])]);
}
const VS = Se({ name: "mdi-check-circle-outline", render: RS }), NS = "p-overflow-hidden", gn = /* @__PURE__ */ new Set();
let dn = null;
const jS = () => {
  gn.size > 0 && !document.body.classList.contains(NS) && Fr();
}, va = () => {
  gn.size > 0 && !dn ? (dn = new MutationObserver(jS), dn.observe(document.body, { attributes: !0, attributeFilter: ["class"] })) : gn.size === 0 && dn && (dn.disconnect(), dn = null);
};
function so(e) {
  const t = Symbol("mancub-modal");
  te(() => Q(e), (n) => {
    n ? gn.add(t) : gn.delete(t), va();
  }, { immediate: !0 }), hs(() => {
    gn.delete(t), va();
  });
}
const Rl = W(0), Vl = W("items");
function Nl(e = "items") {
  Vl.value = e, Rl.value += 1;
}
function US() {
  return { openRequestSeq: Rl, requestedStep: Vl };
}
const HS = { class: "mancub-modal-shell flex flex-col items-center text-center px-8 py-10 gap-4" }, KS = { class: "text-xl font-semibold text-gray-900" }, WS = { class: "text-sm text-gray-600" }, YS = { class: "flex flex-col sm:flex-row gap-2 w-full mt-2" }, GS = {
  key: 0,
  class: "mancub-success-extra w-full border-t border-gray-200 pt-4 mt-2 text-start",
  "data-testid": "mancub-success-extra"
}, jl = /* @__PURE__ */ se({
  __name: "BookSuccessDialog",
  props: /* @__PURE__ */ Mt({
    labels: {},
    item: { default: null },
    successContent: { default: () => {
    } }
  }, {
    visible: { type: Boolean, default: !1 },
    visibleModifiers: {}
  }),
  emits: ["update:visible"],
  setup(e) {
    const t = bs(), n = At(e, "visible");
    so(n);
    const o = ce(rl, void 0), i = v(() => e.successContent ?? Q(o) ?? null);
    function r(c) {
      if (typeof c != "string") return c ?? null;
      try {
        return document.querySelector(c);
      } catch {
        return console.warn(`[mancub] invalid successContent selector "${c}"`), null;
      }
    }
    const a = W(null);
    te(n, (c) => {
      c && (a.value = r(i.value));
    }, { immediate: !0 });
    const d = v(() => !!t.extra || !!a.value), l = W(null);
    te(l, (c) => {
      const p = a.value;
      !c || !p || (p instanceof HTMLTemplateElement ? c.replaceChildren(document.importNode(p.content, !0)) : c.replaceChildren(...Array.from(p.childNodes, (f) => f.cloneNode(!0))));
    }, { flush: "post" });
    const u = () => {
      n.value = !1;
    }, s = () => {
      n.value = !1, Nl("items");
    };
    return (c, p) => {
      const f = VS, b = bt, k = ho;
      return m(), j(k, {
        visible: n.value,
        "onUpdate:visible": p[0] || (p[0] = (T) => n.value = T),
        modal: "",
        draggable: !1,
        "show-header": !1,
        class: "mancub-modal",
        pt: { root: { class: "mancub-modal-root" } },
        breakpoints: { "768px": "100vw" },
        style: Zt({ width: d.value ? "min(640px, 100vw)" : "min(420px, 100vw)", maxWidth: "100vw" }),
        "data-analytics-id": "mancub-dialog-book-success",
        "append-to": "self"
      }, {
        default: U(() => [
          g("div", HS, [
            L(f, { class: "text-5xl text-[var(--p-primary-color)]" }),
            g("h2", KS, y(c.labels.addedToBasket), 1),
            g("p", WS, y(c.labels.addedToBasketMessage), 1),
            g("div", YS, [
              L(b, {
                type: "button",
                severity: "secondary",
                outlined: "",
                size: "large",
                class: "flex-1",
                "data-testid": "mancub-continue-shopping-btn",
                onClick: u
              }, {
                default: U(() => [
                  q(y(c.labels.continueShopping), 1)
                ]),
                _: 1
              }),
              L(b, {
                type: "button",
                size: "large",
                class: "flex-1",
                onClick: s
              }, {
                default: U(() => [
                  q(y(c.labels.goToBasket), 1)
                ]),
                _: 1
              })
            ]),
            d.value ? (m(), h("div", GS, [
              c.$slots.extra ? R(c.$slots, "extra", {
                key: 0,
                item: c.item,
                close: u
              }) : (m(), h("div", {
                key: 1,
                ref_key: "$hostContent",
                ref: l
              }, null, 512))
            ])) : B("", !0)
          ])
        ]),
        _: 3
      }, 8, ["visible", "style"]);
    };
  }
}), qS = {
  viewBox: "0 0 24 24",
  width: "1.2em",
  height: "1.2em"
};
function ZS(e, t) {
  return m(), h("svg", qS, [...t[0] || (t[0] = [
    g("path", {
      fill: "currentColor",
      d: "M17.65 6.35A7.96 7.96 0 0 0 12 4a8 8 0 0 0-8 8a8 8 0 0 0 8 8c3.73 0 6.84-2.55 7.73-6h-2.08A5.99 5.99 0 0 1 12 18a6 6 0 0 1-6-6a6 6 0 0 1 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4z"
    }, null, -1)
  ])]);
}
const XS = Se({ name: "mdi-refresh", render: ZS }), JS = {
  viewBox: "0 0 24 24",
  width: "1.2em",
  height: "1.2em"
};
function QS(e, t) {
  return m(), h("svg", JS, [...t[0] || (t[0] = [
    g("path", {
      fill: "currentColor",
      d: "M8.59 16.58L13.17 12L8.59 7.41L10 6l6 6l-6 6z"
    }, null, -1)
  ])]);
}
const e$ = Se({ name: "mdi-chevron-right", render: QS }), t$ = {
  viewBox: "0 0 24 24",
  width: "1.2em",
  height: "1.2em"
};
function n$(e, t) {
  return m(), h("svg", t$, [...t[0] || (t[0] = [
    g("path", {
      fill: "currentColor",
      d: "M11 15h2v2h-2zm0-8h2v6h-2zm1-5C6.47 2 2 6.5 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2m0 18a8 8 0 0 1-8-8a8 8 0 0 1 8-8a8 8 0 0 1 8 8a8 8 0 0 1-8 8"
    }, null, -1)
  ])]);
}
const Ul = Se({ name: "mdi-alert-circle-outline", render: n$ }), o$ = "mancub:widget-error", r$ = "mancub:widget-empty";
function i$(e, t, n = {}) {
  if (!e) return "";
  const o = t ?? Re, i = (r) => o[r] ?? Re[r] ?? "";
  return e.code === "NETWORK_ERROR" ? i("errorNetwork") : e.status === 404 ? n.commodity ? Le(i("errorCommodityNotFound"), { commodity: n.commodity }) : i("errorNotFound") : e.status != null && e.status >= 500 ? i("errorServer") : i("errorGeneric");
}
function a$(e, t) {
  const n = Math.floor(Math.max(e, 0) / 60), o = Math.max(e, 0) % 60;
  try {
    const i = st(t), r = (a, d) => new Intl.NumberFormat(i, { style: "unit", unit: d, unitDisplay: "short" }).format(a);
    return n > 0 && o > 0 ? `${r(n, "hour")}, ${r(o, "minute")}` : n > 0 ? r(n, "hour") : r(o, "minute");
  } catch {
    return n > 0 ? `${n}h${o > 0 ? ` ${o}min` : ""}` : `${o}min`;
  }
}
function l$(e, t, n, o) {
  const i = n ?? Re, r = (l) => i[l] ?? Re[l] ?? "", a = e.setup_index != null ? t[e.setup_index] : void 0, d = a?.title_customer || e.commodity_ident || "";
  if (e.kind === "lead_time_too_short") {
    const l = a?.day ? wn(Ne(a.day), o) ?? bn(Ne(a.day), o) : "", u = a?.time ? ti(a.time, o) ?? a.time.slice(0, 5) : "", s = u ? `${l} ${u}` : l, c = e.min_lead_time_minutes, p = typeof c == "number" ? a$(c, o) : "";
    return Le(r("errorLeadTimeTooShort"), { commodity: d, datetime: s, duration: p });
  }
  if (e.kind === "price_blocked") {
    if (!a?.day) return e.message;
    const l = wn(Ne(a.day), o) ?? bn(Ne(a.day), o);
    return Le(r("errorPriceBlocked"), { commodity: d, date: l });
  }
  return e.message;
}
const s$ = { class: "flex min-w-0 items-center gap-1.5 text-gray-700" }, d$ = {
  key: 0,
  class: "mancub-widget-error__details"
}, u$ = ["aria-expanded"], c$ = {
  key: 0,
  class: "mancub-widget-error__details-body mt-1 overflow-x-auto whitespace-pre-wrap break-all rounded bg-gray-50 p-2 text-xs text-gray-600 font-mono"
}, p$ = { class: "mb-1" }, m$ = { class: "mb-1" }, f$ = { class: "flex justify-center pt-1" }, xn = /* @__PURE__ */ se({
  __name: "WidgetError",
  props: {
    error: { default: null },
    labels: { default: () => {
    } },
    commodity: { default: null }
  },
  emits: ["retry"],
  setup(e, { emit: t }) {
    const n = t, o = W(!1), i = W(null), r = ce(nl, !1), a = v(() => Q(r)), d = v(() => i$(e.error, e.labels, { commodity: e.commodity })), l = v(() => e.labels?.retry ?? Re.retry), u = v(() => e.labels?.errorDetails ?? Re.errorDetails), s = v(() => a.value && !!(e.error && (e.error.url || e.error.body || e.error.status != null)));
    te([() => e.error, i], ([p, f]) => {
      if (!p || !f) return;
      const b = {
        error: p,
        commodity: e.commodity ?? null,
        retry: () => n("retry")
      };
      f.dispatchEvent(new CustomEvent(o$, { detail: b, bubbles: !0, composed: !0 }));
    }, { flush: "post" });
    const c = v(() => {
      const p = e.error?.body;
      if (!p) return p;
      try {
        return JSON.stringify(JSON.parse(p), null, 2);
      } catch {
        return p;
      }
    });
    return (p, f) => {
      const b = Ul, k = e$, T = XS, $ = bt;
      return m(), h("div", {
        ref_key: "root",
        ref: i,
        class: "mancub-widget-error flex flex-col gap-1 py-1 text-sm",
        role: "alert"
      }, [
        g("span", s$, [
          L(b, { class: "flex-shrink-0 text-base text-red-500" }),
          g("span", null, y(d.value), 1)
        ]),
        s.value ? (m(), h("div", d$, [
          g("button", {
            type: "button",
            class: "mancub-widget-error__details-toggle inline-flex items-center gap-1 text-xs text-gray-500 transition-colors hover:text-gray-700",
            "aria-expanded": o.value,
            onClick: f[0] || (f[0] = (S) => o.value = !o.value)
          }, [
            L(k, {
              class: ee(["text-sm transition-transform", { "rotate-90": o.value }])
            }, null, 8, ["class"]),
            q(" " + y(u.value), 1)
          ], 8, u$),
          o.value ? (m(), h("dl", c$, [
            p.error?.status != null ? (m(), h(Y, { key: 0 }, [
              f[2] || (f[2] = g("dt", { class: "text-gray-400 select-none" }, " Status ", -1)),
              g("dd", p$, y(p.error.status), 1)
            ], 64)) : B("", !0),
            p.error?.url ? (m(), h(Y, { key: 1 }, [
              f[3] || (f[3] = g("dt", { class: "text-gray-400 select-none" }, " URL ", -1)),
              g("dd", m$, y(p.error.url), 1)
            ], 64)) : B("", !0),
            p.error?.body ? (m(), h(Y, { key: 2 }, [
              f[4] || (f[4] = g("dt", { class: "text-gray-400 select-none" }, " Body ", -1)),
              g("dd", null, y(c.value), 1)
            ], 64)) : B("", !0)
          ])) : B("", !0)
        ])) : B("", !0),
        g("div", f$, [
          L($, {
            size: "small",
            class: "mancub-widget-error__retry",
            label: l.value,
            onClick: f[1] || (f[1] = (S) => n("retry"))
          }, {
            icon: U(() => [
              L(T, { class: "text-sm" })
            ]),
            _: 1
          }, 8, ["label"])
        ])
      ], 512);
    };
  }
}), ya = 2e3;
async function g$(e) {
  try {
    const t = await e.text();
    return t ? t.length > ya ? t.slice(0, ya) + "…" : t : void 0;
  } catch {
    return;
  }
}
function qo(e, t = {}) {
  t = { initialFetch: !0, ...t };
  const n = mi(t.refetch ?? !1), o = W(!1), i = W(null), r = W(null), a = t.expectedStatus ?? [200];
  async function d() {
    o.value = !0, r.value = null;
    const l = Q(e).toString();
    try {
      let u;
      try {
        u = await fetch(Q(e));
      } catch (s) {
        console.error("Fetch error:", s), s instanceof Error && (r.value = {
          message: `Network error: ${s.message}`,
          code: "NETWORK_ERROR",
          url: l
        });
        return;
      }
      if (!a.includes(u.status)) {
        r.value = {
          message: `Unexpected response status: ${u.status} ${u.statusText}`,
          code: "HTTP-" + u.status.toString(),
          status: u.status,
          url: l,
          body: await g$(u)
        };
        return;
      }
      try {
        const s = await u.json();
        i.value = s;
      } catch (s) {
        console.error("JSON parse error:", s), s instanceof Error && (r.value = {
          message: `Error parsing JSON: ${s.message}`,
          code: "JSON_PARSE_ERROR",
          url: l
        });
      }
    } finally {
      o.value = !1;
    }
  }
  return te(
    [
      n,
      mi(e)
    ],
    ([l]) => l && d(),
    { deep: !0 }
  ), t.initialFetch && d(), { loading: o, data: i, error: r, execute: d };
}
function Hl(e) {
  return te(e.data, (t) => {
    t && R5({ date: t.date_format, time: t.time_format, firstDayOfWeek: t.first_day_of_week });
  }, { immediate: !0 }), e;
}
const Xt = (e, t = Bt) => new URL(e ? t.replace("{host}", e) : t, window.location.href);
function ni(e, t, n = null, o = void 0, i = {}) {
  const r = v(() => {
    const a = new URL(`commodity/${Q(t)}`, Xt(Q(e), Q(o))), d = Q(n);
    return d && a.searchParams.set("language", d), a;
  });
  return Hl(qo(r, i));
}
function h$(e, t, n = null, o = null, i = void 0, r = {}) {
  const a = v(() => {
    const d = new URL(`commodity/${Q(t)}`, Xt(Q(e), Q(i))), l = Q(n);
    l && d.searchParams.set("at", l);
    const u = Q(o);
    return u && d.searchParams.set("language", u), d;
  });
  return Hl(qo(a, r));
}
function Kl(e, t, n, o = null, i = void 0, r = {}) {
  const a = v(() => {
    const d = new URL(`commodity/${Q(t)}/${Q(n)}`, Xt(Q(e), Q(i))), l = Q(o);
    return l && d.searchParams.set("language", l), d;
  });
  return qo(a, r);
}
function Wl(e) {
  const t = Id();
  te([() => Q(e), V5], ([n, o]) => {
    t?.config?.locale && Object.assign(t.config.locale, O0(n, o ?? 1));
  }, { immediate: !0 });
}
function Yl() {
  const e = W(/* @__PURE__ */ new Date());
  let t;
  const n = () => {
    e.value = /* @__PURE__ */ new Date();
  }, o = () => {
    document.visibilityState === "visible" && n();
  };
  return Er(() => {
    t = setInterval(n, 6e4), document.addEventListener("visibilitychange", o);
  }), Sa(() => {
    t && clearInterval(t), document.removeEventListener("visibilitychange", o);
  }), e;
}
const b$ = {
  key: 1,
  class: "flex justify-center p-8"
}, v$ = { class: "flex items-center gap-3" }, y$ = ["src", "alt"], k$ = { class: "min-w-0" }, w$ = { class: "text-xs text-gray-500 uppercase tracking-wide" }, x$ = {
  key: 0,
  class: "text-lg @md:text-xl font-semibold text-gray-900 leading-snug mt-0.5"
}, C$ = { class: "text-sm font-medium text-gray-800 @md:w-2/5 @md:flex-shrink-0 @md:pt-1" }, S$ = { class: "flex-1 flex flex-col items-start gap-1 @md:ms-2" }, $$ = { class: "flex items-center gap-2 text-base text-gray-900" }, B$ = { key: 0 }, T$ = {
  key: 1,
  class: "text-gray-400"
}, I$ = ["aria-expanded"], D$ = { class: "mancub-accordion-content" }, P$ = { class: "datepicker-container border-t border-gray-200 pt-3" }, z$ = ["data-testid"], L$ = ["title"], O$ = {
  key: 1,
  class: "border-t border-gray-200"
}, M$ = {
  for: "setup-time-select",
  class: "text-sm font-medium text-gray-800"
}, A$ = { class: "flex flex-col items-start gap-1" }, _$ = {
  key: 0,
  class: "mancub-discount-badge"
}, F$ = ["data-testid"], E$ = {
  key: 0,
  class: "mancub-discount-badge"
}, R$ = {
  key: 2,
  class: "mancub-discount-cta flex items-center gap-2 rounded-md border border-green-200 bg-green-50 px-3 py-2 mt-1"
}, V$ = { class: "text-sm font-semibold text-green-800 leading-tight" }, N$ = {
  key: 3,
  class: "flex flex-col text-sm text-gray-600 py-2 border-t border-gray-200"
}, j$ = ["aria-expanded"], U$ = { class: "mancub-accordion-content" }, H$ = { class: "text-sm text-gray-600" }, K$ = {
  key: 6,
  class: "mancub-order-summary flex flex-col gap-4 border-t border-gray-200 pt-4 @md:pt-5",
  "data-testid": "mancub-order-summary"
}, W$ = {
  key: 0,
  class: "grid grid-cols-[auto_1fr] mx-auto w-full max-w-60 gap-x-6 gap-y-1.5 text-sm"
}, Y$ = { class: "flex items-center gap-2 text-gray-500" }, G$ = { class: "text-right font-medium text-gray-900 tabular-nums" }, q$ = { class: "text-gray-500 font-normal" }, Z$ = { class: "flex items-center gap-2 text-gray-500" }, X$ = { class: "text-right font-medium text-gray-900 tabular-nums" }, J$ = { class: "flex items-center gap-2 text-gray-500" }, Q$ = { class: "text-right font-medium text-gray-900 tabular-nums" }, e4 = { class: "flex items-center gap-2 text-gray-500" }, t4 = { class: "text-right font-medium text-gray-900 tabular-nums" }, n4 = { class: "w-full py-1.5" }, o4 = 30, Gl = /* @__PURE__ */ se({
  __name: "BookForm",
  props: {
    host: { default: () => {
    } },
    commodity: {},
    preferredLanguage: { default: () => {
    } },
    apiUrl: { default: () => {
    } },
    currency: { default: () => {
    } },
    labels: { default: () => {
    } },
    mode: { default: "add-to-basket" },
    initialItem: { default: null },
    initialDate: { default: null },
    hideHeader: { type: Boolean, default: !1 },
    thumbnail: { type: Boolean, default: !1 },
    showPrices: { type: Boolean, default: !1 },
    flat: { type: Boolean, default: !0 },
    suppressSuccessDialog: { type: Boolean, default: !1 },
    successContent: { default: () => {
    } }
  },
  emits: ["submitted", "cancel"],
  setup(e, { expose: t, emit: n }) {
    const o = n, i = ce(Ct, void 0), r = v(() => e.apiUrl ?? Q(i) ?? Bt), a = ce(St, void 0), d = v(() => e.host ?? Q(a) ?? ""), l = W(e.commodity);
    te(() => e.commodity, (A) => {
      l.value = A;
    });
    const u = W(e.preferredLanguage || "en");
    te(() => e.preferredLanguage, (A) => {
      A && (u.value = A);
    });
    const { data: s, error: c, execute: p } = ni(
      d,
      l,
      u,
      r,
      { refetch: !0 }
    ), f = Yl(), b = v(() => s.value?.min_lead_time ?? 0), k = v(
      () => (s.value?.availabilities ?? []).filter((A) => !fr(A, f.value))
    ), T = v(
      () => (s.value?.availabilities ?? []).filter((A) => !tl(A, b.value, f.value))
    ), $ = v(() => {
      const A = k.value;
      if (A.length > 0) return Ne(A[0].day);
      const X = s.value?.availabilities;
      return !X || X.length === 0 ? /* @__PURE__ */ new Date() : Ne(X[0].day);
    }), S = v(() => {
      const A = s.value?.availabilities;
      return !A || A.length === 0 ? /* @__PURE__ */ new Date() : Ne(A[A.length - 1].day);
    }), O = v(() => {
      const A = /* @__PURE__ */ new Map(), X = s.value?.discounts;
      if (!X?.length) return A;
      for (const ue of s.value?.availabilities ?? []) {
        const { hasDiscount: ge, maxPercent: xe } = Ao(ue.active_discounts, X);
        ge && A.set(ue.day.slice(0, 10), xe);
      }
      return A;
    }), w = (A) => {
      const X = O.value.get(qt(A));
      return X ? Le(C.value.saveUpTo, { percent: X }) : C.value.discountAvailable;
    }, F = v(() => {
      const A = s.value?.availabilities;
      if (!A || A.length === 0) return [];
      const X = new Set(k.value.map((xe) => xe.day.slice(0, 10))), ue = A[A.length - 1].day.slice(0, 10), ge = [];
      for (const xe = Ne(A[0].day); lt(xe) <= ue; xe.setDate(xe.getDate() + 1))
        X.has(lt(xe)) || ge.push(new Date(xe));
      return ge;
    });
    Wl(u);
    const D = (A, X) => new Intl.DateTimeFormat(st(X), {
      day: "numeric",
      month: "numeric",
      year: "numeric"
    }).format(A), C = v(() => Qe(u.value, {
      ...s.value?.widget_labels_overrides ?? {},
      ...e.labels ?? {}
    })), I = v(() => s.value?.title ?? null), N = v(() => s.value?.thumbnail ?? null), K = v(() => Mo(H.value?.prices ?? [], E.value, Me.value)), V = W(!1), M = W(!1), P = v(() => (s.value?.availabilities?.length ?? 0) > 1);
    te(s, (A, X) => {
      A && !X && P.value && e.mode !== "edit" && !Q(e.initialDate) && (M.value = !0);
    }, { immediate: !0 });
    const E = W(
      (() => {
        if (e.initialItem)
          return Ne(e.initialItem.day);
        const A = Q(e.initialDate);
        return A ? A instanceof Date ? A : Ne(A) : null;
      })()
    );
    te(() => Q(e.initialDate), (A) => {
      e.mode === "edit" || !A || (E.value = A instanceof Date ? A : Ne(A));
    });
    const { data: H, loading: ae, error: fe, execute: Be } = Kl(
      d,
      l,
      v(() => E.value ? lt(E.value) : null),
      u,
      r,
      { refetch: !1, initialFetch: !1 }
    );
    te([E, s], () => {
      const A = s.value?.availabilities;
      if (!A || A.length === 0) return;
      if (!E.value) {
        const ue = k.value[0]?.day ?? A[0].day, ge = T.value[0]?.day ?? ue;
        E.value = Ne(ge);
        return;
      }
      const X = lt(E.value);
      A.some((ue) => ue.day === X) && Be();
    });
    const Ae = v(() => H.value?.min_lead_time ?? s.value?.min_lead_time ?? 0), Oe = v(() => new Date(f.value.getTime() + Math.max(Ae.value, 0) * 6e4)), _e = (A) => H.value ? /* @__PURE__ */ new Date(H.value.day + "T" + A) : null, be = v(() => (H.value?.time_choices || []).map((A) => {
      const X = /* @__PURE__ */ new Date(H.value.day + "T" + A), ue = X.getTime() < Oe.value.getTime();
      return {
        label: ti(A, u.value) ?? X.toLocaleTimeString([u.value], { hour: "2-digit", minute: "2-digit", timeZone: "Europe/Prague" }),
        value: A,
        disabled: ue
      };
    })), je = v(() => be.value.filter((A) => !A.disabled)), G = v(
      () => !!H.value && je.value.length === 0
    ), Fe = v(() => {
      if (!E.value) return !1;
      const A = s.value?.availabilities;
      if (!A || A.length === 0) return !1;
      const X = lt(E.value);
      return !A.some((ue) => ue.day === X);
    }), He = v(() => Fe.value || G.value), Me = W(e.initialItem?.time ?? void 0), Vt = v(() => Me.value ? be.value.find((A) => A.value === Me.value)?.label ?? null : null), Nt = v(() => Me.value ? be.value.find((A) => A.value === Me.value)?.disabled ?? !1 : !1), jt = v(() => {
      if (!Me.value || Nt.value) return !1;
      const A = _e(Me.value);
      if (!A) return !1;
      const X = A.getTime() - Oe.value.getTime();
      return X >= 0 && X < o4 * 6e4;
    });
    te([be, je], () => {
      if (!H.value) return;
      const A = be.value.find((X) => X.value === Me.value);
      A && !A.disabled || (Me.value = je.value[0]?.value);
    });
    const _ = v(() => E.value ? wn(E.value, u.value) ?? D(E.value, u.value) : null), J = v(() => E.value ? new Intl.DateTimeFormat(st(u.value), { weekday: "short" }).format(E.value) : null), re = v(() => Vt.value), ie = v(() => Z.value?.totalTicketsSelected ?? 0), we = v(() => !!(_.value || re.value || ie.value > 0 || Xo.value)), Z = W(null), ke = v(() => Z.value?.awaitingTicketConfirm ?? !1), Tt = v(() => Z.value?.onTicketDetailsStep ?? !1), It = v(() => !H.value || !Z.value || Nt.value || je.value.length === 0 ? !1 : Z.value.isValid), ot = v(() => po(
      H.value?.active_discounts,
      H.value?.discounts,
      Me.value
    ));
    mn(qr, ot);
    const vt = Bn(() => e.currency);
    mn(ol, vt), mn(mo, v(() => u.value));
    const bo = v(() => Ao(
      H.value?.active_discounts,
      H.value?.discounts,
      Me.value
    )), Zo = v(() => bo.value.titles[0] || C.value.discountAvailable), vo = v(() => {
      const A = /* @__PURE__ */ new Set(), X = H.value?.active_discounts, ue = H.value?.discounts;
      for (const ge of be.value)
        Ni(X, ue, ge.value) > 0 && A.add(ge.value);
      return A;
    }), is = v(() => be.value.length > 0 && vo.value.size === be.value.length), yo = (A) => is.value || !vo.value.has(A) ? 0 : Ni(H.value?.active_discounts, H.value?.discounts, A), Xo = v(() => {
      const A = Z.value?.selectedPrices ?? [];
      if (A.length === 0) return null;
      const { amount: X, unit: ue, decimals: ge } = Gt(A, ot.value, vt.value);
      return X ? _t(X, { code: vt.value, unit: ue, decimals: ge, lang: u.value }) : null;
    }), as = v(() => e.mode === "edit" ? C.value.saveChanges : e.mode === "buy-now" ? C.value.buyNow : C.value.addToCart), li = nn(), Tn = W(!1), Jo = W(!1), si = W(null), di = W(null), ui = (A, X) => {
      if (A.config.attribute_type === "geolocation") {
        if (X && typeof X == "object") {
          const pe = X;
          return { value: pe.name || "", subvalue: pe.address || null };
        }
        const ge = String(X ?? ""), xe = A.config.choices.find((pe) => pe.value === ge);
        return { value: xe?.label || ge, subvalue: xe?.sublabel || null };
      }
      const ue = String(X ?? "");
      return A.config.attribute_type === "choice" ? { value: A.config.choices.find((xe) => xe.value === ue)?.label || ue, subvalue: null } : A.config.attribute_type === "fixed" ? { value: A.config.label || ue, subvalue: null } : { value: ue, subvalue: null };
    }, ls = (A) => {
      if (!H.value) return [];
      const X = new Map(H.value.attributes.map((pe) => [pe.ident, pe])), ue = new Map(K.value.map((pe) => [pe.ident, pe])), ge = [];
      return ((pe) => {
        if (pe)
          for (const De of pe) {
            const et = X.get(De.ident);
            if (!et) continue;
            const Ie = ui(et, De.value);
            if (Ie.value === "") continue;
            const ut = Io(et.config, De.value), ct = ut ? ue.get(ut) : null;
            ge.push({
              label: et.title || et.ident,
              value: Ie.value,
              subvalue: Ie.subvalue,
              price: ct ?? null
            });
          }
      })(A.setup), ge;
    }, ss = (A) => {
      if (!H.value || !A.ticket || A.ticket.length === 0) return [];
      const X = new Map(H.value.attributes.map((pe) => [pe.ident, pe])), ue = new Map(K.value.map((pe) => [pe.ident, pe])), ge = H.value.attributes.filter((pe) => pe.scope === "ticket").sort((pe, De) => pe.sort_order - De.sort_order)[0]?.ident, xe = /* @__PURE__ */ new Map();
      for (const pe of A.ticket) {
        let De = C.value.tickets;
        const et = [], Ie = [];
        for (const Ge of pe) {
          const pt = X.get(Ge.ident);
          if (!pt) continue;
          const ko = Io(pt.config, Ge.value), In = ko ? ue.get(ko) : null;
          In && et.push(In);
          const Ce = ui(pt, Ge.value);
          Ge.ident === ge ? De = Ce.value || De : Ce.value !== "" && Ie.push({
            label: pt.title || pt.ident,
            value: Ce.value,
            subvalue: Ce.subvalue,
            price: In ?? null
          });
        }
        const ut = JSON.stringify([De, Ie.map((Ge) => [Ge.label, Ge.value, Ge.subvalue])]), ct = xe.get(ut);
        ct ? ct.count += 1 : xe.set(ut, {
          label: De,
          count: 1,
          prices: et,
          details: Ie.length > 0 ? Ie : void 0
        });
      }
      return [...xe.values()];
    }, ds = (A) => {
      if (!H.value) return { amount: 0, unit: "", code: vt.value ?? "CZK", prices: [] };
      const X = new Map(K.value.map((Ie) => [Ie.ident, Ie])), ue = new Map(H.value.attributes.map((Ie) => [Ie.ident, Ie])), ge = [], xe = (Ie) => {
        if (Ie)
          for (const ut of Ie) {
            const ct = ue.get(ut.ident);
            if (!ct) continue;
            const Ge = Io(ct.config, ut.value);
            if (!Ge) continue;
            const pt = X.get(Ge);
            pt && ge.push(pt);
          }
      };
      if (xe(A.setup), A.ticket)
        for (const Ie of A.ticket) xe(Ie);
      const { amount: pe, unit: De } = Gt(ge, ot.value, vt.value), et = vt.value ?? ge.find((Ie) => Ie.currency)?.currency ?? "CZK";
      return { amount: pe, unit: De, code: et, prices: ge };
    }, us = (A) => {
      ci(A);
    }, ci = async (A) => {
      Tn.value = !0;
      try {
        const X = E.value ? `${E.value.getFullYear()}-${String(E.value.getMonth() + 1).padStart(2, "0")}-${String(E.value.getDate()).padStart(2, "0")}` : "", ue = ds(A), ge = ls(A), xe = ss(A), pe = {
          host: d.value,
          commodity_ident: l.value,
          title_customer: I.value,
          thumbnail: N.value,
          day: X,
          time: Me.value ?? null,
          setup_items: A,
          detail_lines: ge,
          ticket_groups: xe,
          prices_snapshot: ue.prices,
          discount_percent: ot.value.percent,
          discount_idents: ot.value.idents,
          total_amount: ue.amount,
          currency: ue.code,
          currency_unit: ue.unit || null,
          language: u.value
        };
        let De;
        e.mode === "edit" && e.initialItem ? (li.update(e.initialItem.id, pe), De = { ...e.initialItem, ...pe }) : (De = li.add(pe), e.mode === "add-to-basket" && Z.value?.resetForm()), o("submitted", De, e.mode), e.mode === "add-to-basket" && !e.suppressSuccessDialog && (si.value = De, Jo.value = !0), e.mode === "add-to-basket" && di.value?.dispatchEvent(new CustomEvent("mancub:added-to-basket", {
          bubbles: !0,
          detail: { item: De }
        }));
      } finally {
        Tn.value = !1;
      }
    };
    return t({ cancel: () => o("cancel"), submitItem: ci }), (A, X) => {
      const ue = go, ge = s2, xe = Il, pe = Jr, De = aw, et = xl, Ie = rn, ut = pl, ct = Ft, Ge = l1, pt = cl, ko = n1, In = bt;
      return m(), h(Y, null, [
        g("div", {
          ref_key: "$rootEl",
          ref: di,
          class: ee(["mancub-widget mancub-booking flex flex-col w-full gap-3 @md:gap-4", A.flat ? "" : "bg-gray-50 p-3 @sm:p-4 @md:p-6 @xl:p-8"])
        }, [
          z(c) ? (m(), j(xn, {
            key: 0,
            error: z(c),
            commodity: l.value,
            labels: C.value,
            onRetry: z(p)
          }, null, 8, ["error", "commodity", "labels", "onRetry"])) : z(s) ? (m(), h(Y, { key: 2 }, [
            A.hideHeader ? B("", !0) : (m(), h("header", {
              key: 0,
              class: ee(A.flat ? "" : "px-2")
            }, [
              g("div", v$, [
                A.thumbnail && N.value ? (m(), h("img", {
                  key: 0,
                  src: N.value,
                  alt: I.value ?? "",
                  class: "aspect-[4/3] h-14 flex-shrink-0 rounded-[1px] object-cover shadow-sm"
                }, null, 8, y$)) : B("", !0),
                g("div", k$, [
                  g("div", w$, y(C.value.reservation), 1),
                  I.value ? (m(), h("h2", x$, y(I.value), 1)) : B("", !0)
                ])
              ])
            ], 2)),
            Ze(g("div", {
              class: ee(A.flat ? "" : "bg-white border border-gray-200 rounded-md p-3 @md:p-4")
            }, [
              g("div", {
                class: ee(["group flex flex-col @md:flex-row gap-1 @md:gap-4 py-2 @md:py-3", { "cursor-pointer": P.value }]),
                "data-testid": "mancub-date-row",
                onClick: X[0] || (X[0] = (Ce) => P.value && (M.value = !M.value))
              }, [
                g("div", C$, y(C.value.date), 1),
                g("div", S$, [
                  g("div", $$, [
                    L(ge, { class: "text-xl text-gray-700" }),
                    E.value ? (m(), h("span", B$, y(z(wn)(E.value, u.value) ?? z(bn)(E.value, u.value)), 1)) : (m(), h("span", T$, "—"))
                  ]),
                  P.value ? (m(), h("button", {
                    key: 0,
                    type: "button",
                    "aria-expanded": M.value,
                    class: "text-sm text-gray-600 group-hover:text-gray-900 inline-flex items-center gap-1 cursor-pointer"
                  }, [
                    q(y(M.value ? C.value.hideDate : C.value.changeDate) + " ", 1),
                    L(xe, {
                      class: ee(["transition-transform", M.value ? "rotate-180" : ""])
                    }, null, 8, ["class"])
                  ], 8, I$)) : B("", !0)
                ])
              ], 2),
              P.value ? (m(), h("div", {
                key: 0,
                class: ee(["mancub-accordion", { "is-open": M.value || !E.value }])
              }, [
                g("div", D$, [
                  g("div", P$, [
                    L(pe, {
                      modelValue: E.value,
                      "onUpdate:modelValue": X[1] || (X[1] = (Ce) => E.value = Ce),
                      "min-date": $.value,
                      "max-date": S.value,
                      "disabled-dates": F.value,
                      inline: "",
                      class: "w-full",
                      "select-other-months": "",
                      view: "date",
                      onDateSelect: X[2] || (X[2] = (Ce) => M.value = !1)
                    }, {
                      date: U(({ date: Ce }) => [
                        g("span", {
                          class: "mancub-day",
                          "data-testid": `mancub-calendar-day-${z(qt)(Ce)}`
                        }, [
                          q(y(Ce.day) + " ", 1),
                          O.value.has(z(qt)(Ce)) ? (m(), h("span", {
                            key: 0,
                            class: "mancub-day-discount-dot",
                            title: w(Ce),
                            "aria-hidden": "true"
                          }, null, 8, L$)) : B("", !0)
                        ], 8, z$)
                      ]),
                      _: 1
                    }, 8, ["modelValue", "min-date", "max-date", "disabled-dates"])
                  ])
                ])
              ], 2)) : B("", !0),
              z(H) && !Fe.value ? (m(), h("div", O$, [
                L(Rt, {
                  class: ee({ "!border-b-0": jt.value })
                }, {
                  title: U(() => [
                    g("label", M$, y(C.value.time), 1)
                  ]),
                  default: U(() => [
                    g("div", A$, [
                      be.value.length === 1 ? (m(), h("div", {
                        key: 0,
                        class: ee(["flex items-center gap-2 text-base text-gray-900 @md:pt-1", { "opacity-50 line-through": be.value[0]?.disabled }])
                      }, [
                        L(De, { class: "text-xl text-gray-500" }),
                        g("span", null, y(be.value[0]?.label), 1),
                        be.value[0] && yo(be.value[0].value) > 0 ? (m(), h("span", _$, "−" + y(yo(be.value[0].value)) + "%", 1)) : B("", !0)
                      ], 2)) : (m(), j(ut, { key: 1 }, {
                        default: U(() => [
                          L(et, null, {
                            default: U(() => [
                              L(De, { class: "text-xl text-gray-500" })
                            ]),
                            _: 1
                          }),
                          L(Ie, {
                            id: "setup-time-select",
                            modelValue: Me.value,
                            "onUpdate:modelValue": X[3] || (X[3] = (Ce) => Me.value = Ce),
                            options: be.value,
                            "append-to": "body",
                            "overlay-class": "mancub-widget-overlay",
                            "option-label": "label",
                            "option-value": "value",
                            "option-disabled": "disabled",
                            "pt:root:data-testid": "mancub-time-select"
                          }, {
                            option: U(({ option: Ce }) => [
                              g("span", {
                                class: ee(["flex items-center gap-2", { "opacity-50": Ce.disabled }]),
                                "data-testid": `mancub-time-select-option-${Ce.value}`
                              }, [
                                g("span", null, y(Ce.label), 1),
                                yo(Ce.value) > 0 ? (m(), h("span", E$, "−" + y(yo(Ce.value)) + "%", 1)) : B("", !0)
                              ], 10, F$)
                            ]),
                            _: 1
                          }, 8, ["modelValue", "options"])
                        ]),
                        _: 1
                      }))
                    ])
                  ]),
                  _: 1
                }, 8, ["class"]),
                jt.value ? (m(), j(ct, {
                  key: 0,
                  severity: "warn",
                  size: "small",
                  variant: "simple",
                  class: "pb-2",
                  "pt:root:data-testid": "mancub-lead-time-warning"
                }, {
                  default: U(() => [
                    q(y(C.value.leadTimeWarning), 1)
                  ]),
                  _: 1
                })) : B("", !0)
              ])) : B("", !0),
              bo.value.hasDiscount ? (m(), h("div", R$, [
                L(Ge, { class: "text-lg text-green-600 flex-shrink-0" }),
                g("span", V$, y(Zo.value), 1)
              ])) : B("", !0),
              K.value.length > 0 && A.showPrices ? (m(), h("div", N$, [
                g("button", {
                  type: "button",
                  class: "ms-auto inline-flex items-center gap-1.5 rounded-md border border-gray-300 px-3 py-1.5 text-sm font-medium text-gray-700 cursor-pointer hover:bg-gray-100",
                  "aria-expanded": V.value,
                  onClick: X[4] || (X[4] = (Ce) => V.value = !V.value)
                }, [
                  L(xe, {
                    class: ee(["transition-transform", V.value ? "rotate-180" : ""])
                  }, null, 8, ["class"]),
                  q(" " + y(V.value ? C.value.collapsePriceList : C.value.expandPriceList), 1)
                ], 8, j$),
                g("div", {
                  class: ee(["mancub-accordion", { "is-open": V.value }])
                }, [
                  g("div", U$, [
                    L(_l, {
                      class: "mt-2 mb-1",
                      "preferred-language": u.value,
                      prices: K.value,
                      "reference-date": E.value,
                      "discount-percent": ot.value.percent,
                      "discount-idents": ot.value.idents,
                      currency: z(vt),
                      "show-heading": !1
                    }, null, 8, ["preferred-language", "prices", "reference-date", "discount-percent", "discount-idents", "currency"])
                  ])
                ], 2)
              ])) : B("", !0)
            ], 2), [
              [Fn, !Tt.value]
            ]),
            z(ae) ? (m(), h("div", {
              key: 1,
              class: ee(["flex flex-col items-center gap-2", A.flat ? "py-6" : "bg-white border border-gray-200 rounded-md p-6"])
            }, [
              L(ue),
              g("span", H$, y(C.value.loadingForm), 1)
            ], 2)) : z(fe) ? (m(), h("div", {
              key: 2,
              class: ee(A.flat ? "py-2" : "bg-white border border-gray-200 rounded-md p-4")
            }, [
              L(xn, {
                error: z(fe),
                labels: C.value,
                onRetry: z(Be)
              }, null, 8, ["error", "labels", "onRetry"])
            ], 2)) : He.value ? (m(), h("div", {
              key: 3,
              class: ee(A.flat ? "py-2" : "bg-white border border-gray-200 rounded-md p-4")
            }, [
              L(ct, {
                severity: "warn",
                size: "small",
                variant: "simple",
                "pt:root:data-testid": "mancub-online-booking-unavailable"
              }, {
                default: U(() => [
                  q(y(C.value.onlineBookingUnavailable), 1)
                ]),
                _: 1
              })
            ], 2)) : z(H) ? (m(), j(F5, {
              key: 5,
              ref_key: "$setupForm",
              ref: Z,
              attributes: z(H).attributes,
              prices: K.value,
              "ticket-control-attribute": z(H).ticket_control_attribute,
              form: z(H).form,
              capacities: z(H).capacities,
              "selected-time": Me.value ?? null,
              labels: C.value,
              "initial-items": A.initialItem?.setup_items,
              flat: A.flat,
              onSubmit: us
            }, null, 8, ["attributes", "prices", "ticket-control-attribute", "form", "capacities", "selected-time", "labels", "initial-items", "flat"])) : (m(), h("div", {
              key: 4,
              class: ee(["text-sm text-gray-600 text-center", A.flat ? "py-4" : "bg-white border border-gray-200 rounded-md p-4"])
            }, y(C.value.selectDate), 3)),
            z(H) && !He.value && !ke.value ? (m(), h("section", K$, [
              we.value ? (m(), h("dl", W$, [
                _.value ? (m(), h(Y, { key: 0 }, [
                  g("dt", Y$, [
                    L(ge, { class: "text-base" }),
                    q(" " + y(C.value.date), 1)
                  ]),
                  g("dd", G$, [
                    g("span", q$, y(J.value), 1),
                    q(" " + y(_.value), 1)
                  ])
                ], 64)) : B("", !0),
                re.value ? (m(), h(Y, { key: 1 }, [
                  g("dt", Z$, [
                    L(De, { class: "text-base" }),
                    q(" " + y(C.value.time), 1)
                  ]),
                  g("dd", X$, y(re.value), 1)
                ], 64)) : B("", !0),
                ie.value > 0 ? (m(), h(Y, { key: 2 }, [
                  g("dt", J$, [
                    L(pt, { class: "text-base" }),
                    q(" " + y(C.value.tickets), 1)
                  ]),
                  g("dd", Q$, y(ie.value), 1)
                ], 64)) : B("", !0),
                Xo.value ? (m(), h(Y, { key: 3 }, [
                  g("dt", e4, [
                    L(ko, { class: "text-base" }),
                    q(" " + y(C.value.price), 1)
                  ]),
                  g("dd", t4, y(Xo.value), 1)
                ], 64)) : B("", !0)
              ])) : B("", !0),
              L(In, {
                type: "button",
                disabled: !It.value || Tn.value,
                loading: Tn.value,
                size: "large",
                class: "mancub-submit-button w-full",
                "data-testid": "mancub-add-to-basket-btn",
                onClick: X[5] || (X[5] = (Ce) => Z.value?.submitForm())
              }, {
                default: U(() => [
                  g("span", n4, y(Tn.value ? C.value.processing : It.value ? as.value : C.value.completeForm), 1)
                ]),
                _: 1
              }, 8, ["disabled", "loading"])
            ])) : B("", !0)
          ], 64)) : (m(), h("div", b$, [
            L(ue)
          ]))
        ], 2),
        A.suppressSuccessDialog ? B("", !0) : (m(), j(jl, {
          key: 0,
          visible: Jo.value,
          "onUpdate:visible": X[6] || (X[6] = (Ce) => Jo.value = Ce),
          labels: C.value,
          item: si.value,
          "success-content": A.successContent
        }, ht({ _: 2 }, [
          A.$slots["success-extra"] ? {
            name: "extra",
            fn: U((Ce) => [
              R(A.$slots, "success-extra", Vo(Rr(Ce)))
            ]),
            key: "0"
          } : void 0
        ]), 1032, ["visible", "labels", "item", "success-content"]))
      ], 64);
    };
  }
}), r4 = {
  viewBox: "0 0 24 24",
  width: "1.2em",
  height: "1.2em"
};
function i4(e, t) {
  return m(), h("svg", r4, [...t[0] || (t[0] = [
    g("path", {
      fill: "currentColor",
      d: "M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12z"
    }, null, -1)
  ])]);
}
const oi = Se({ name: "mdi-close", render: i4 }), a4 = { class: "mancub-modal-shell flex flex-col" }, l4 = { class: "flex items-center justify-between border-b border-gray-200 px-4 sm:px-6 lg:px-12 py-3 lg:py-5 sticky top-0 bg-white z-10" }, s4 = { class: "text-xl font-semibold text-gray-900" }, d4 = ["aria-label"], u4 = { class: "overflow-y-auto pb-[50vh] sm:pb-0" }, u9 = /* @__PURE__ */ se({
  __name: "BookButton",
  props: {
    host: { default: () => {
    } },
    commodity: {},
    preferredLanguage: { default: () => ln },
    apiUrl: { default: () => {
    } },
    currency: { default: () => {
    } },
    labels: { default: () => {
    } },
    mode: { default: "add-to-basket" },
    label: { default: () => {
    } },
    initialItem: { default: null },
    initialDate: { default: null },
    showPrices: { type: Boolean, default: !1 },
    flat: { type: Boolean, default: !1 },
    hideHeader: { type: Boolean, default: !0 },
    thumbnail: { type: Boolean, default: !1 },
    successContent: { default: () => {
    } }
  },
  setup(e, { expose: t }) {
    const n = W(!1), o = W(!1), i = W(null);
    so(n);
    const r = v(() => Qe(e.preferredLanguage, e.labels)), a = v(() => e.label ?? r.value.book_button), d = ce(Ct, void 0), l = v(() => e.apiUrl ?? Q(d) ?? Bt), u = ce(St, void 0), s = v(() => e.host ?? Q(u) ?? ""), { data: c, execute: p } = ni(s, e.commodity, e.preferredLanguage, l, { initialFetch: !1 }), f = v(() => c.value?.title ?? null), b = () => {
      n.value = !0;
    }, k = () => {
      n.value = !1;
    }, T = (S, O) => {
      n.value = !1, O === "buy-now" ? Nl("checkout") : O === "add-to-basket" && (i.value = S, o.value = !0);
    };
    te(n, (S) => {
      S && !c.value && p();
    });
    const $ = v(() => n.value || o.value);
    return t({ visible: $ }), (S, O) => {
      const w = bt, F = oi, D = ho;
      return m(), h(Y, null, [
        L(w, {
          label: a.value,
          size: "large",
          class: "mancub-book-button",
          "data-analytics-id": "mancub-button-book",
          onClick: b
        }, null, 8, ["label"]),
        L(D, {
          visible: n.value,
          "onUpdate:visible": O[0] || (O[0] = (C) => n.value = C),
          modal: "",
          "dismissable-mask": "",
          draggable: !1,
          "show-header": !1,
          class: "mancub-modal",
          pt: { root: { class: "mancub-modal-root" } },
          breakpoints: { "768px": "100vw" },
          style: { width: "min(640px, 100vw)", "max-width": "100vw" },
          "data-analytics-id": "mancub-dialog-book",
          "append-to": "self"
        }, {
          default: U(() => [
            g("div", a4, [
              g("header", l4, [
                g("h2", s4, y(f.value ?? r.value.book), 1),
                g("button", {
                  type: "button",
                  class: "text-gray-500 hover:text-gray-900 cursor-pointer",
                  "aria-label": r.value.cancel,
                  onClick: k
                }, [
                  L(F, { class: "text-2xl" })
                ], 8, d4)
              ]),
              g("div", u4, [
                L(Gl, {
                  host: s.value,
                  commodity: S.commodity,
                  "preferred-language": S.preferredLanguage,
                  "api-url": S.apiUrl,
                  currency: S.currency,
                  labels: e.labels,
                  mode: S.mode,
                  "initial-item": S.initialItem,
                  "initial-date": S.initialDate,
                  "show-prices": S.showPrices,
                  "hide-header": S.hideHeader,
                  thumbnail: S.thumbnail,
                  flat: S.flat,
                  "suppress-success-dialog": !0,
                  onSubmitted: T
                }, null, 8, ["host", "commodity", "preferred-language", "api-url", "currency", "labels", "mode", "initial-item", "initial-date", "show-prices", "hide-header", "thumbnail", "flat"])
              ])
            ])
          ]),
          _: 1
        }, 8, ["visible"]),
        L(jl, {
          visible: o.value,
          "onUpdate:visible": O[1] || (O[1] = (C) => o.value = C),
          labels: r.value,
          item: i.value,
          "success-content": S.successContent
        }, ht({ _: 2 }, [
          S.$slots["success-extra"] ? {
            name: "extra",
            fn: U((C) => [
              R(S.$slots, "success-extra", Vo(Rr(C)))
            ]),
            key: "0"
          } : void 0
        ]), 1032, ["visible", "labels", "item", "success-content"])
      ], 64);
    };
  }
}), c4 = {
  key: 0,
  class: "flex justify-center p-4",
  "data-testid": "mancub-calendar-loading"
}, p4 = ["data-testid"], m4 = ["title"], c9 = /* @__PURE__ */ se({
  __name: "Calendar",
  props: {
    host: { default: () => {
    } },
    commodity: {},
    preferredLanguage: { default: () => ln },
    apiUrl: { default: () => {
    } },
    modelValue: { default: null },
    labels: { default: () => {
    } },
    flat: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue", "select"],
  setup(e, { emit: t }) {
    const n = t, o = v(() => Qe(e.preferredLanguage, e.labels));
    Wl(() => e.preferredLanguage);
    const i = ce(Ct, void 0), r = v(() => e.apiUrl ?? Q(i) ?? Bt), a = ce(St, void 0), d = v(() => e.host ?? Q(a) ?? ""), { loading: l, data: u, error: s, execute: c } = ni(d, e.commodity, e.preferredLanguage, r, { refetch: !0 }), p = W(null), f = Yl(), b = v(() => u.value?.min_lead_time ?? 0), k = v(() => (u.value?.availabilities ?? []).filter((V) => !fr(V, f.value)).map((V) => Ne(V.day))), T = v(() => {
      const V = (u.value?.availabilities ?? []).find((M) => !fr(M, f.value) && !tl(M, b.value, f.value));
      return V ? Ne(V.day) : null;
    }), $ = v(() => {
      const V = /* @__PURE__ */ new Map(), M = u.value?.discounts;
      if (!M?.length) return V;
      for (const P of u.value?.availabilities ?? []) {
        const { hasDiscount: E, maxPercent: H } = Ao(P.active_discounts, M);
        E && V.set(P.day.slice(0, 10), H);
      }
      return V;
    }), S = (V) => {
      const M = $.value.get(qt(V));
      return M ? Le(o.value.saveUpTo, { percent: M }) : o.value.discountAvailable;
    }, O = v(() => k.value[0] ?? /* @__PURE__ */ new Date()), w = v(() => k.value[k.value.length - 1] ?? /* @__PURE__ */ new Date()), F = v(() => {
      const V = k.value;
      if (V.length === 0) return [];
      const M = new Set(V.map(lt)), P = [], E = new Date(V[0]), H = lt(V[V.length - 1]);
      for (E.setDate(E.getDate() + 1); lt(E) < H; E.setDate(E.getDate() + 1))
        M.has(lt(E)) || P.push(new Date(E));
      return P;
    }), D = W(e.modelValue);
    te(() => e.modelValue, (V) => {
      D.value = V;
    });
    const C = (V) => {
      D.value = V, n("update:modelValue", V), n("select", lt(V));
    }, I = (V) => C(V);
    let N = !1;
    te([l, s, k, p], ([V, M, P, E]) => {
      if (V || M || P.length > 0) {
        N = !1;
        return;
      }
      if (!E || !u.value || N) return;
      N = !0;
      const H = {
        commodity: e.commodity,
        retry: () => {
          c();
        }
      };
      E.dispatchEvent(new CustomEvent(r$, { detail: H, bubbles: !0, composed: !0 }));
    }, { flush: "post" });
    let K = !1;
    return te(k, (V) => {
      if (K) return;
      if (D.value) {
        K = !0;
        return;
      }
      const M = T.value ?? V[0];
      M && (K = !0, C(M));
    }, { immediate: !0 }), (V, M) => {
      const P = go, E = Jr;
      return m(), h("div", {
        ref_key: "root",
        ref: p,
        class: ee(["mancub-widget mancub-calendar", V.flat ? "mancub-calendar--flat" : "bg-white border border-gray-200 rounded-md p-3 md:p-4"]),
        "data-testid": "mancub-calendar",
        "data-analytics-id": "mancub-calendar"
      }, [
        z(l) ? (m(), h("div", c4, [
          L(P)
        ])) : z(s) ? (m(), j(xn, {
          key: 1,
          error: z(s),
          commodity: V.commodity,
          labels: o.value,
          "data-testid": "mancub-calendar-error2",
          onRetry: z(c)
        }, null, 8, ["error", "commodity", "labels", "onRetry"])) : (m(), j(E, {
          key: 2,
          "model-value": D.value,
          "min-date": O.value,
          "max-date": w.value,
          "disabled-dates": F.value,
          inline: "",
          class: "w-full",
          "select-other-months": "",
          view: "date",
          "data-testid": "mancub-calendar-datepicker",
          onDateSelect: I
        }, {
          date: U(({ date: H }) => [
            g("span", {
              class: "mancub-day",
              "data-testid": `mancub-calendar-day-${z(qt)(H)}`
            }, [
              q(y(H.day) + " ", 1),
              $.value.has(z(qt)(H)) ? (m(), h("span", {
                key: 0,
                class: "mancub-day-discount-dot",
                title: S(H),
                "aria-hidden": "true",
                "data-testid": "mancub-calendar-day-discount-dot"
              }, null, 8, m4)) : B("", !0)
            ], 8, p4)
          ]),
          _: 1
        }, 8, ["model-value", "min-date", "max-date", "disabled-dates"]))
      ], 2);
    };
  }
}), f4 = { class: "mancub-widget mancub-pricelist" }, g4 = {
  key: 0,
  class: "flex justify-center p-4"
}, p9 = /* @__PURE__ */ se({
  __name: "PriceList",
  props: {
    host: { default: () => {
    } },
    commodity: {},
    day: {},
    time: { default: null },
    preferredLanguage: { default: () => ln },
    apiUrl: { default: () => {
    } },
    labels: { default: () => {
    } },
    currency: { default: null },
    maxHeight: { default: null },
    showHeading: { type: Boolean, default: !0 },
    showQuantifiers: { type: Boolean, default: !1 },
    divideByUnits: { type: Boolean, default: !0 },
    shortlist: { type: Boolean, default: !0 }
  },
  setup(e) {
    const t = v(() => Qe(e.preferredLanguage, e.labels)), n = ce(Ct, void 0), o = v(() => e.apiUrl ?? Q(n) ?? Bt), i = ce(St, void 0), r = v(() => e.host ?? Q(i) ?? ""), a = v(() => e.day instanceof Date ? lt(e.day) : e.day.slice(0, 10)), { loading: d, data: l, error: u, execute: s } = Kl(r, e.commodity, a, e.preferredLanguage, o, { refetch: !0 }), c = v(() => l.value?.prices ?? []), p = v(() => po(l.value?.active_discounts, l.value?.discounts, e.time));
    return (f, b) => {
      const k = go;
      return m(), h("div", f4, [
        z(d) ? (m(), h("div", g4, [
          L(k)
        ])) : z(u) ? (m(), j(xn, {
          key: 1,
          error: z(u),
          commodity: f.commodity,
          labels: t.value,
          onRetry: z(s)
        }, null, 8, ["error", "commodity", "labels", "onRetry"])) : (m(), j(_l, {
          key: 2,
          "preferred-language": f.preferredLanguage,
          labels: e.labels,
          prices: c.value,
          "reference-date": f.day,
          "discount-percent": f.time ? p.value.percent : 0,
          "discount-idents": f.time ? p.value.idents : null,
          time: f.time,
          "time-choices": f.time ? null : z(l)?.time_choices,
          "active-discounts": f.time ? null : z(l)?.active_discounts,
          discounts: f.time ? null : z(l)?.discounts,
          currency: f.currency,
          "max-height": f.maxHeight,
          "show-heading": f.showHeading,
          "show-quantifiers": f.showQuantifiers,
          "divide-by-units": f.divideByUnits,
          shortlist: f.shortlist
        }, null, 8, ["preferred-language", "labels", "prices", "reference-date", "discount-percent", "discount-idents", "time", "time-choices", "active-discounts", "discounts", "currency", "max-height", "show-heading", "show-quantifiers", "divide-by-units", "shortlist"]))
      ]);
    };
  }
}), h4 = { class: "mancub-widget mancub-main-price" }, b4 = {
  key: 0,
  class: "text-sm text-gray-500"
}, v4 = {
  key: 2,
  class: "inline-flex items-baseline gap-1"
}, y4 = {
  key: 0,
  class: "text-gray-500"
}, k4 = {
  key: 1,
  class: "mancub-discount-badge self-center"
}, w4 = {
  key: 2,
  class: "text-gray-400 line-through text-sm"
}, x4 = { class: "text-gray-900 font-medium" }, C4 = {
  key: 3,
  class: "text-xs text-gray-500"
}, S4 = {
  key: 3,
  class: "text-sm text-gray-500"
}, m9 = /* @__PURE__ */ se({
  __name: "MainPrice",
  props: {
    host: { default: () => {
    } },
    commodity: {},
    date: { default: null },
    time: { default: null },
    currency: { default: null },
    preferredLanguage: { default: () => ln },
    apiUrl: { default: () => {
    } },
    labels: { default: () => {
    } },
    prefix: { default: "" },
    showQuantifier: { type: Boolean, default: !0 }
  },
  setup(e) {
    const t = v(() => Qe(e.preferredLanguage, e.labels)), n = ce(Ct, void 0), o = v(() => e.apiUrl ?? Q(n) ?? Bt), i = ce(St, void 0), r = v(() => e.host ?? Q(i) ?? ""), a = Bn(() => e.currency), { loading: d, data: l, error: u, execute: s } = h$(r, e.commodity, () => e.date, () => e.preferredLanguage, o, { refetch: !0 }), c = v(() => l.value?.main_price ?? null), p = v(() => Qa(tn(c.value, a.value), c.value?.units)), f = v(() => {
      const S = c.value;
      return S ? [S.unit_quantifier, S.main_price_extra_quantifier].filter(Boolean).join(" ") : "";
    }), b = () => {
      const S = /* @__PURE__ */ new Date();
      return `${S.getFullYear()}-${String(S.getMonth() + 1).padStart(2, "0")}-${String(S.getDate()).padStart(2, "0")}`;
    }, k = v(() => {
      if (!e.time) return 0;
      const S = (e.date ?? b()).slice(0, 10), O = l.value?.availabilities?.find((F) => F.day.slice(0, 10) === S), w = po(O?.active_discounts, l.value?.discounts, e.time);
      return $n(c.value, w, p.value.code);
    }), T = v(() => Math.round(k.value * 100) / 100), $ = v(() => {
      const S = p.value, O = S.amount;
      if (O === null || !k.value || !(O > 0)) return null;
      const w = en(O * (1 - k.value / 100), S.decimals);
      return Za(w, S.decimals);
    });
    return (S, O) => (m(), h("div", h4, [
      z(d) ? (m(), h("span", b4, y(t.value.loading), 1)) : z(u) ? (m(), j(xn, {
        key: 1,
        error: z(u),
        commodity: S.commodity,
        labels: t.value,
        onRetry: z(s)
      }, null, 8, ["error", "commodity", "labels", "onRetry"])) : c.value ? (m(), h("span", v4, [
        S.prefix ? (m(), h("span", y4, y(S.prefix), 1)) : B("", !0),
        T.value > 0 ? (m(), h("span", k4, "−" + y(T.value) + "%", 1)) : B("", !0),
        $.value !== null ? (m(), h("span", w4, y(p.value.display), 1)) : B("", !0),
        g("span", x4, [
          $.value !== null ? (m(), h(Y, { key: 0 }, [
            q(y($.value), 1)
          ], 64)) : (m(), h(Y, { key: 1 }, [
            q(y(p.value.display), 1)
          ], 64)),
          p.value.unit ? (m(), h(Y, { key: 2 }, [
            q(" " + y(p.value.unit), 1)
          ], 64)) : B("", !0)
        ]),
        S.showQuantifier && f.value ? (m(), h("span", C4, " " + y(f.value), 1)) : B("", !0)
      ])) : (m(), h("span", S4, y(t.value.noData), 1))
    ]));
  }
}), $4 = {
  viewBox: "0 0 24 24",
  width: "1.2em",
  height: "1.2em"
};
function B4(e, t) {
  return m(), h("svg", $4, [...t[0] || (t[0] = [
    g("path", {
      fill: "currentColor",
      d: "M17 18a2 2 0 0 1 2 2a2 2 0 0 1-2 2a2 2 0 0 1-2-2c0-1.11.89-2 2-2M1 2h3.27l.94 2H20a1 1 0 0 1 1 1c0 .17-.05.34-.12.5l-3.58 6.47c-.34.61-1 1.03-1.75 1.03H8.1l-.9 1.63l-.03.12a.25.25 0 0 0 .25.25H19v2H7a2 2 0 0 1-2-2c0-.35.09-.68.24-.96l1.36-2.45L3 4H1zm6 16a2 2 0 0 1 2 2a2 2 0 0 1-2 2a2 2 0 0 1-2-2c0-1.11.89-2 2-2m9-7l2.78-5H6.14l2.36 5z"
    }, null, -1)
  ])]);
}
const T4 = Se({ name: "mdi-cart-outline", render: B4 }), I4 = {
  viewBox: "0 0 24 24",
  width: "1.2em",
  height: "1.2em"
};
function D4(e, t) {
  return m(), h("svg", I4, [...t[0] || (t[0] = [
    g("path", {
      fill: "currentColor",
      d: "M4 11v2h12l-5.5 5.5l1.42 1.42L19.84 12l-7.92-7.92L10.5 5.5L16 11z"
    }, null, -1)
  ])]);
}
const ql = Se({ name: "mdi-arrow-right", render: D4 }), P4 = {
  viewBox: "0 0 24 24",
  width: "1.2em",
  height: "1.2em"
};
function z4(e, t) {
  return m(), h("svg", P4, [...t[0] || (t[0] = [
    g("path", {
      fill: "currentColor",
      d: "M22 9h-4.79l-4.38-6.56a.997.997 0 0 0-1.66.01L6.79 9H2c-.55 0-1 .45-1 1c0 .09 0 .18.04.27l2.54 9.27c.23.84 1 1.46 1.92 1.46h13c.92 0 1.69-.62 1.93-1.46l2.54-9.27L23 10c0-.55-.45-1-1-1M12 4.8L14.8 9H9.2zM18.5 19h-13l-2.19-8H20.7zM12 13c-1.1 0-2 .9-2 2s.9 2 2 2s2-.9 2-2s-.9-2-2-2"
    }, null, -1)
  ])]);
}
const L4 = Se({ name: "mdi-basket-outline", render: z4 }), O4 = {
  viewBox: "0 0 24 24",
  width: "1.2em",
  height: "1.2em"
};
function M4(e, t) {
  return m(), h("svg", O4, [...t[0] || (t[0] = [
    g("path", {
      fill: "currentColor",
      d: "M9 3v1H4v2h1v13a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V6h1V4h-5V3zM7 6h10v13H7zm2 2v9h2V8zm4 0v9h2V8z"
    }, null, -1)
  ])]);
}
const A4 = Se({ name: "mdi-trash-can-outline", render: M4 }), _4 = {
  viewBox: "0 0 24 24",
  width: "1.2em",
  height: "1.2em"
};
function F4(e, t) {
  return m(), h("svg", _4, [...t[0] || (t[0] = [
    g("path", {
      fill: "currentColor",
      d: "m14.06 9l.94.94L5.92 19H5v-.92zm3.6-6c-.25 0-.51.1-.7.29l-1.83 1.83l3.75 3.75l1.83-1.83c.39-.39.39-1.04 0-1.41l-2.34-2.34c-.2-.2-.45-.29-.71-.29m-3.6 3.19L3 17.25V21h3.75L17.81 9.94z"
    }, null, -1)
  ])]);
}
const E4 = Se({ name: "mdi-pencil-outline", render: F4 }), R4 = {
  viewBox: "0 0 24 24",
  width: "1.2em",
  height: "1.2em"
};
function V4(e, t) {
  return m(), h("svg", R4, [...t[0] || (t[0] = [
    g("path", {
      fill: "currentColor",
      d: "M12 20a8 8 0 0 0 8-8a8 8 0 0 0-8-8a8 8 0 0 0-8 8a8 8 0 0 0 8 8m0-18a10 10 0 0 1 10 10a10 10 0 0 1-10 10C6.47 22 2 17.5 2 12A10 10 0 0 1 12 2m.5 5v5.25l4.5 2.67l-.75 1.23L11 13V7z"
    }, null, -1)
  ])]);
}
const N4 = Se({ name: "mdi-clock-outline", render: V4 }), j4 = {
  viewBox: "0 0 24 24",
  width: "1.2em",
  height: "1.2em"
};
function U4(e, t) {
  return m(), h("svg", j4, [...t[0] || (t[0] = [
    g("path", {
      fill: "currentColor",
      d: "M12 12h5v5h-5zm7-9h-1V1h-2v2H8V1H6v2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m0 2v2H5V5zM5 19V9h14v10z"
    }, null, -1)
  ])]);
}
const H4 = Se({ name: "mdi-calendar-outline", render: U4 }), K4 = { class: "mancub-basket-item border border-gray-200 rounded-xl bg-white p-4 sm:p-5 flex flex-col gap-3 hover:border-gray-300 transition-colors" }, W4 = { class: "flex items-start gap-3" }, Y4 = ["src", "alt"], G4 = { class: "min-w-0 flex flex-col gap-1.5" }, q4 = { class: "font-semibold text-gray-900 leading-snug text-base sm:text-lg" }, Z4 = { class: "flex flex-wrap items-center gap-x-4 gap-y-1 text-sm text-gray-600" }, X4 = { class: "inline-flex items-center gap-1.5" }, J4 = {
  key: 0,
  class: "inline-flex items-center gap-1.5"
}, Q4 = {
  key: 0,
  class: "border-t border-gray-200 text-sm"
}, e3 = { class: "min-w-0 font-normal text-gray-400" }, t3 = { class: "min-w-0 text-right text-base font-medium text-gray-900" }, n3 = {
  key: 0,
  class: "font-normal text-gray-500"
}, o3 = { class: "mancub-strike-diagonal text-xs text-gray-400" }, r3 = {
  key: 1,
  class: "block text-xs font-normal text-gray-500 mt-0.5"
}, i3 = {
  key: 1,
  class: "border-t border-gray-200 text-sm flex flex-col"
}, a3 = { class: "flex items-baseline justify-between gap-3" }, l3 = { class: "min-w-0 flex items-baseline gap-1.5" }, s3 = { class: "font-semibold text-gray-500 tabular-nums" }, d3 = { class: "font-medium text-gray-900" }, u3 = {
  key: 0,
  class: "flex flex-col items-end whitespace-nowrap"
}, c3 = { class: "font-medium text-gray-900" }, p3 = { class: "text-xs text-gray-400 tabular-nums" }, m3 = { class: "mancub-strike-diagonal" }, f3 = {
  key: 1,
  class: "text-gray-500 whitespace-nowrap"
}, g3 = { class: "mancub-strike-diagonal text-xs text-gray-400" }, h3 = { class: "font-medium text-gray-900" }, b3 = {
  key: 0,
  class: "mt-1 ml-5 flex flex-col gap-0.5"
}, v3 = { class: "min-w-0 text-gray-400" }, y3 = { class: "min-w-0 text-right font-medium text-gray-700" }, k3 = { class: "flex items-center justify-between gap-3 border-t border-gray-200 pt-3" }, w3 = { class: "flex items-center gap-1 -ml-2" }, x3 = ["aria-label", "title"], C3 = ["aria-label", "title"], S3 = ["aria-label"], $3 = { class: "flex flex-col items-end gap-0.5" }, B3 = {
  key: 0,
  class: "mancub-save-tag"
}, T3 = { class: "flex items-baseline gap-2 whitespace-nowrap" }, I3 = {
  key: 0,
  class: "mancub-strike-diagonal text-sm text-gray-400"
}, D3 = { class: "text-base sm:text-lg font-semibold text-[var(--p-primary-color)]" }, P3 = /* @__PURE__ */ se({
  __name: "BasketItemCard",
  props: {
    item: {},
    currency: { default: () => {
    } },
    preferredLanguage: { default: "en" },
    labels: { default: () => {
    } }
  },
  emits: ["edit", "remove"],
  setup(e, { emit: t }) {
    const n = t, o = v(() => Qe(e.preferredLanguage, e.labels)), i = W(!1);
    let r;
    const a = () => {
      clearTimeout(r), i.value = !1;
    }, d = () => {
      clearTimeout(r), i.value = !0, r = setTimeout(a, 4e3);
    }, l = () => {
      a(), n("remove", e.item);
    };
    vs(() => clearTimeout(r));
    const u = v(() => e.currency ?? e.item.currency), s = v(() => {
      if (!e.item.day) return "—";
      const D = Ne(e.item.day);
      return wn(D, e.preferredLanguage) ?? bn(D, e.preferredLanguage);
    }), c = v(() => {
      if (!e.item.time) return "";
      const D = e.item.time;
      return ti(D, e.preferredLanguage) ?? (D.length >= 5 ? D.substring(0, 5) : D);
    }), p = v(() => e.item.ticket_groups ?? []), f = (D, C, I, N) => _t(D, { code: N || u.value, unit: C, decimals: I, lang: e.preferredLanguage }), b = v(() => ({
      percent: e.item.discount_percent > 0 ? e.item.discount_percent : 0,
      idents: e.item.discount_idents ?? []
    })), k = (D, C, I, N, K) => K ? {
      discounted: f(D * (1 - K / 100), C, I, N),
      original: f(D, C, I, N)
    } : { discounted: f(D, C, I, N), original: null }, T = (D) => {
      if (!D) return null;
      const C = tn(D, u.value);
      return C.amount ? k(C.amount, C.unit, C.decimals, C.code, $n(D, b.value, C.code)) : null;
    }, $ = (D) => {
      if (!D.prices?.length) return null;
      const { amount: C, unit: I, decimals: N } = Gt(D.prices, 0, u.value);
      if (!C) return null;
      const K = Gt(D.prices, b.value, u.value).amount;
      return {
        discounted: f(K, I, N),
        original: K < C ? f(C, I, N) : null,
        total: D.count > 1 ? f(K * D.count, I, N) : null
      };
    }, S = v(() => {
      const D = Uo(e.item, u.value);
      if (!e.item.prices_snapshot?.length) return { discounted: D, original: null };
      const C = Gt(e.item.prices_snapshot, 0, u.value);
      return C.amount <= D.amount ? { discounted: D, original: null } : { discounted: D, original: C };
    }), O = v(() => {
      const { amount: D, unit: C, decimals: I } = S.value.discounted;
      return f(D, C, I);
    }), w = v(() => {
      const D = S.value.original;
      return D ? f(D.amount, D.unit, D.decimals) : null;
    }), F = v(() => {
      const { discounted: D, original: C } = S.value;
      if (!C) return null;
      const I = en(C.amount - D.amount, C.decimals);
      return Le(o.value.priceListSave, { amount: f(I, C.unit, C.decimals) });
    });
    return (D, C) => {
      const I = H4, N = N4, K = E4, V = A4;
      return m(), h("div", K4, [
        g("div", W4, [
          D.item.thumbnail ? (m(), h("img", {
            key: 0,
            src: D.item.thumbnail,
            alt: D.item.title_customer ?? D.item.commodity_ident,
            class: "aspect-[4/3] h-14 flex-shrink-0 rounded-[1px] object-cover shadow-sm"
          }, null, 8, Y4)) : B("", !0),
          g("div", G4, [
            g("h3", q4, y(D.item.title_customer ?? D.item.commodity_ident), 1),
            g("div", Z4, [
              g("span", X4, [
                L(I, { class: "text-base text-gray-400" }),
                g("span", null, y(s.value), 1)
              ]),
              D.item.time ? (m(), h("span", J4, [
                L(N, { class: "text-base text-gray-400" }),
                g("span", null, y(c.value), 1)
              ])) : B("", !0)
            ])
          ])
        ]),
        D.item.detail_lines.length > 0 ? (m(), h("dl", Q4, [
          (m(!0), h(Y, null, he(D.item.detail_lines, (M, P) => (m(), h("div", {
            key: P,
            class: "grid grid-cols-2 items-start gap-4 py-2 border-b border-gray-100 last:border-b-0"
          }, [
            g("dt", e3, y(M.label), 1),
            g("dd", t3, [
              g("span", null, y(M.value), 1),
              T(M.price) ? (m(), h("span", n3, [
                C[2] || (C[2] = q(" — ", -1)),
                T(M.price)?.original ? (m(), h(Y, { key: 0 }, [
                  g("span", o3, y(T(M.price)?.original), 1),
                  C[1] || (C[1] = q(" ", -1))
                ], 64)) : B("", !0),
                q(y(T(M.price)?.discounted), 1)
              ])) : B("", !0),
              M.subvalue ? (m(), h("span", r3, y(M.subvalue), 1)) : B("", !0)
            ])
          ]))), 128))
        ])) : B("", !0),
        p.value.length > 0 ? (m(), h("ul", i3, [
          (m(!0), h(Y, null, he(p.value, (M, P) => (m(), h("li", {
            key: P,
            class: "py-2 border-b border-gray-100 last:border-b-0"
          }, [
            g("div", a3, [
              g("span", l3, [
                g("span", s3, y(M.count) + "×", 1),
                g("span", d3, y(M.label), 1)
              ]),
              $(M)?.total ? (m(), h("span", u3, [
                g("span", c3, y($(M)?.total), 1),
                g("span", p3, [
                  q(y(M.count) + " × ", 1),
                  $(M)?.original ? (m(), h(Y, { key: 0 }, [
                    g("span", m3, y($(M)?.original), 1),
                    C[3] || (C[3] = q(" ", -1))
                  ], 64)) : B("", !0),
                  q(y($(M)?.discounted), 1)
                ])
              ])) : $(M) ? (m(), h("span", f3, [
                $(M)?.original ? (m(), h(Y, { key: 0 }, [
                  g("span", g3, y($(M)?.original), 1),
                  C[4] || (C[4] = q(" ", -1))
                ], 64)) : B("", !0),
                g("span", h3, y($(M)?.discounted), 1)
              ])) : B("", !0)
            ]),
            M.details && M.details.length > 0 ? (m(), h("dl", b3, [
              (m(!0), h(Y, null, he(M.details, (E, H) => (m(), h("div", {
                key: H,
                class: "grid grid-cols-2 items-start gap-3 text-xs"
              }, [
                g("dt", v3, y(E.label), 1),
                g("dd", y3, y(E.value), 1)
              ]))), 128))
            ])) : B("", !0)
          ]))), 128))
        ])) : B("", !0),
        g("div", k3, [
          g("div", w3, [
            g("button", {
              type: "button",
              class: "p-2 rounded-lg text-gray-500 hover:text-gray-900 hover:bg-gray-100 cursor-pointer transition-colors",
              "aria-label": o.value.editItem,
              title: o.value.editItem,
              onClick: C[0] || (C[0] = (M) => D.$emit("edit", D.item))
            }, [
              L(K, { class: "text-lg" })
            ], 8, x3),
            i.value ? (m(), h("button", {
              key: 1,
              type: "button",
              class: "px-3 py-2 rounded-lg bg-red-600 text-sm text-white font-medium inline-flex items-center gap-1.5 cursor-pointer transition-colors hover:bg-red-700",
              "aria-label": o.value.removeItem,
              onClick: l,
              onBlur: a
            }, [
              L(V, { class: "text-base" }),
              q(" " + y(o.value.removeItemConfirm), 1)
            ], 40, S3)) : (m(), h("button", {
              key: 0,
              type: "button",
              class: "p-2 rounded-lg text-gray-500 hover:text-red-700 hover:bg-red-50 cursor-pointer transition-colors",
              "aria-label": o.value.removeItem,
              title: o.value.removeItem,
              onClick: d
            }, [
              L(V, { class: "text-lg" })
            ], 8, C3))
          ]),
          g("div", $3, [
            F.value ? (m(), h("span", B3, y(F.value), 1)) : B("", !0),
            g("div", T3, [
              w.value ? (m(), h("span", I3, y(w.value), 1)) : B("", !0),
              g("span", D3, y(O.value), 1)
            ])
          ])
        ])
      ]);
    };
  }
}), z3 = {
  viewBox: "0 0 24 24",
  width: "1.2em",
  height: "1.2em"
};
function L3(e, t) {
  return m(), h("svg", z3, [...t[0] || (t[0] = [
    g("path", {
      fill: "currentColor",
      d: "M12 20a8 8 0 0 1-8-8a8 8 0 0 1 8-8a8 8 0 0 1 8 8a8 8 0 0 1-8 8m0-18A10 10 0 0 0 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2"
    }, null, -1)
  ])]);
}
const O3 = Se({ name: "mdi-radiobox-blank", render: L3 }), M3 = {
  viewBox: "0 0 24 24",
  width: "1.2em",
  height: "1.2em"
};
function A3(e, t) {
  return m(), h("svg", M3, [...t[0] || (t[0] = [
    g("path", {
      fill: "currentColor",
      d: "M12 20a8 8 0 0 1-8-8a8 8 0 0 1 8-8a8 8 0 0 1 8 8a8 8 0 0 1-8 8m0-18A10 10 0 0 0 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2m0 5a5 5 0 0 0-5 5a5 5 0 0 0 5 5a5 5 0 0 0 5-5a5 5 0 0 0-5-5"
    }, null, -1)
  ])]);
}
const _3 = Se({ name: "mdi-radiobox-marked", render: A3 }), F3 = { class: "mancub-modal-shell flex flex-col" }, E3 = { class: "flex items-center gap-2 border-b border-gray-200 bg-white px-5 py-4 sticky top-0 z-10" }, R3 = { class: "flex-1 text-lg font-semibold text-gray-900" }, V3 = ["aria-label"], N3 = { class: "flex flex-col gap-4 p-5" }, j3 = { class: "text-sm text-gray-600 leading-relaxed" }, U3 = { class: "w-full text-sm border-collapse" }, H3 = { class: "text-xs text-gray-500 uppercase tracking-wide" }, K3 = { class: "pb-2 pr-2 text-left font-medium" }, W3 = { class: "pb-2 px-2 text-left font-medium" }, Y3 = { class: "pb-2 pl-2 text-right font-medium" }, G3 = ["onClick"], q3 = { class: "py-3 pr-2" }, Z3 = { class: "flex items-center gap-2" }, X3 = { class: "flex flex-col leading-tight" }, J3 = { class: "font-medium text-gray-900" }, Q3 = {
  key: 0,
  class: "text-xs text-gray-400"
}, e6 = { class: "py-3 px-2 text-xs text-gray-500 whitespace-nowrap" }, t6 = /* @__PURE__ */ se({
  __name: "CurrencyDialog",
  props: /* @__PURE__ */ Mt({
    preferredLanguage: { default: "en" },
    labels: { default: () => {
    } },
    currencies: { default: () => [] }
  }, {
    visible: { type: Boolean, default: !1 },
    visibleModifiers: {}
  }),
  emits: ["update:visible"],
  setup(e) {
    const t = At(e, "visible");
    so(t);
    const n = Ho(), o = nn(), i = v(() => Qe(e.preferredLanguage, e.labels)), r = (p, f) => f && f.toUpperCase() !== p.toUpperCase() ? f : To(p, e.preferredLanguage), a = v(() => {
      const p = /* @__PURE__ */ new Set(), f = [];
      for (const b of o.items.value)
        p.has(b.currency) || (p.add(b.currency), f.push({ label: r(b.currency, b.currency_unit), value: b.currency }));
      for (const b of e.currencies) {
        const k = (b || "").toUpperCase();
        !k || p.has(k) || (p.add(k), f.push({ label: r(k), value: k }));
      }
      return n.value && !p.has(n.value) && f.unshift({ label: r(n.value), value: n.value }), f;
    });
    function d(p) {
      let f = 0, b = null, k = null;
      for (const T of o.items.value) {
        const $ = Uo(T, p);
        f += $.amount, b = b ?? $.unit, $.decimals != null && (k = Math.max(k ?? 0, $.decimals));
      }
      return { amount: f, unit: b, decimals: k };
    }
    const l = v(() => (o.items.value.find((p) => p.currency)?.currency || n.value || "").toUpperCase()), u = v(() => new Intl.NumberFormat(e.preferredLanguage || "en", { maximumSignificantDigits: 4 })), s = v(() => {
      const p = l.value, f = d(p).amount, b = To(p, e.preferredLanguage);
      return a.value.map((k) => {
        const T = d(k.value), $ = p && k.value !== p && T.amount > 0 ? f / T.amount : null;
        return {
          code: k.value,
          label: k.label,
          selected: k.value === n.value,
          formattedTotal: _t(T.amount, { code: k.value, unit: T.unit, decimals: T.decimals, lang: e.preferredLanguage }),
          rateLabel: $ != null ? `1 ${To(k.value, e.preferredLanguage)} = ${u.value.format($)} ${b}` : null
        };
      });
    });
    function c(p) {
      il(p), t.value = !1;
    }
    return (p, f) => {
      const b = oi, k = _3, T = O3, $ = ho;
      return m(), j($, {
        visible: t.value,
        "onUpdate:visible": f[1] || (f[1] = (S) => t.value = S),
        modal: "",
        "dismissable-mask": "",
        draggable: !1,
        "show-header": !1,
        pt: { root: { class: "mancub-modal-root" } },
        style: { width: "min(520px, 100vw)", "max-width": "100vw" },
        "data-analytics-id": "mancub-dialog-currency",
        "append-to": "self"
      }, {
        default: U(() => [
          g("div", F3, [
            g("header", E3, [
              g("h2", R3, y(i.value.chooseCurrency), 1),
              g("button", {
                type: "button",
                class: "-mr-2 p-2 text-gray-500 rounded-full cursor-pointer hover:bg-gray-100 hover:text-gray-900",
                "aria-label": i.value.cancel,
                onClick: f[0] || (f[0] = (S) => t.value = !1)
              }, [
                L(b, { class: "text-2xl" })
              ], 8, V3)
            ]),
            g("div", N3, [
              g("p", j3, y(i.value.currencyExplanation), 1),
              g("table", U3, [
                g("thead", null, [
                  g("tr", H3, [
                    g("th", K3, y(i.value.currencyColumnCurrency), 1),
                    g("th", W3, y(i.value.currencyColumnRate), 1),
                    g("th", Y3, y(i.value.total), 1)
                  ])
                ]),
                g("tbody", null, [
                  (m(!0), h(Y, null, he(s.value, (S) => (m(), h("tr", {
                    key: S.code,
                    class: ee(["cursor-pointer border-t border-gray-100 transition-colors", S.selected ? "bg-[var(--p-primary-50)]" : "hover:bg-gray-50"]),
                    onClick: (O) => c(S.code)
                  }, [
                    g("td", q3, [
                      g("span", Z3, [
                        S.selected ? (m(), j(k, {
                          key: 0,
                          class: "text-lg shrink-0 text-[var(--p-primary-color)]"
                        })) : (m(), j(T, {
                          key: 1,
                          class: "text-lg shrink-0 text-gray-400"
                        })),
                        g("span", X3, [
                          g("span", J3, y(S.label), 1),
                          S.code !== S.label ? (m(), h("span", Q3, y(S.code), 1)) : B("", !0)
                        ])
                      ])
                    ]),
                    g("td", e6, y(S.rateLabel ?? "—"), 1),
                    g("td", {
                      class: ee(["py-3 pl-2 text-right font-semibold whitespace-nowrap", S.selected ? "text-[var(--p-primary-color)]" : "text-gray-900"])
                    }, y(S.formattedTotal), 3)
                  ], 10, G3))), 128))
                ])
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["visible"]);
    };
  }
}), n6 = { class: "static sm:sticky sm:bottom-0 bg-white border-t border-gray-200 px-4 sm:px-6 lg:px-12 pt-3 pb-[50vh] sm:py-4 lg:py-5 flex flex-col gap-3" }, o6 = { class: "flex flex-col sm:flex-row sm:items-center gap-3" }, r6 = { class: "flex items-center justify-between sm:justify-start sm:flex-1 gap-3" }, i6 = { class: "flex flex-col" }, a6 = { class: "text-xs text-gray-500 uppercase tracking-wide" }, l6 = {
  key: 0,
  class: "mancub-save-tag self-start"
}, s6 = { class: "flex items-baseline gap-2" }, d6 = {
  key: 0,
  class: "mancub-strike-diagonal text-sm text-gray-400 whitespace-nowrap"
}, u6 = { class: "text-xl sm:text-2xl font-semibold text-[var(--p-primary-color)] whitespace-nowrap leading-tight" }, Zl = /* @__PURE__ */ se({
  __name: "BasketFooter",
  props: {
    preferredLanguage: { default: "en" },
    labels: { default: () => {
    } },
    currencies: { default: () => [] }
  },
  setup(e) {
    const t = Ho(), n = nn(), o = v(() => Qe(e.preferredLanguage, e.labels)), i = W(!1), r = v(() => {
      let s = 0, c = 0, p = null, f = null;
      for (const b of n.items.value) {
        const k = Uo(b, t.value);
        s += k.amount, p = p ?? k.unit, k.decimals != null && (f = Math.max(f ?? 0, k.decimals)), c += b.prices_snapshot?.length ? Gt(b.prices_snapshot, 0, t.value).amount : k.amount;
      }
      return { amount: s, original: c, unit: p, decimals: f };
    }), a = (s) => _t(s, { code: t.value, unit: r.value.unit, decimals: r.value.decimals, lang: e.preferredLanguage }), d = v(() => a(r.value.amount)), l = v(() => {
      const { amount: s, original: c } = r.value;
      return c > s ? a(c) : null;
    }), u = v(() => {
      const { amount: s, original: c } = r.value;
      return c <= s ? null : Le(o.value.priceListSave, { amount: a(c - s) });
    });
    return (s, c) => (m(), h(Y, null, [
      g("div", n6, [
        R(s.$slots, "top"),
        g("div", o6, [
          g("div", r6, [
            g("div", i6, [
              g("span", a6, y(o.value.total), 1),
              u.value ? (m(), h("span", l6, y(u.value), 1)) : B("", !0),
              g("span", s6, [
                l.value ? (m(), h("span", d6, y(l.value), 1)) : B("", !0),
                g("span", u6, y(d.value), 1)
              ])
            ]),
            g("button", {
              type: "button",
              class: "self-end text-xs text-gray-500 underline underline-offset-2 cursor-pointer transition-colors hover:text-gray-700",
              onClick: c[0] || (c[0] = (p) => i.value = !0)
            }, y(o.value.changeCurrency), 1)
          ]),
          R(s.$slots, "default")
        ])
      ]),
      L(t6, {
        visible: i.value,
        "onUpdate:visible": c[1] || (c[1] = (p) => i.value = p),
        "preferred-language": s.preferredLanguage,
        currencies: s.currencies,
        labels: e.labels
      }, null, 8, ["visible", "preferred-language", "currencies", "labels"])
    ], 64));
  }
}), c6 = {
  viewBox: "0 0 24 24",
  width: "1.2em",
  height: "1.2em"
};
function p6(e, t) {
  return m(), h("svg", c6, [...t[0] || (t[0] = [
    g("path", {
      fill: "currentColor",
      d: "M20 11v2H8l5.5 5.5l-1.42 1.42L4.16 12l7.92-7.92L13.5 5.5L8 11z"
    }, null, -1)
  ])]);
}
const m6 = Se({ name: "mdi-arrow-left", render: p6 }), f6 = {
  viewBox: "0 0 24 24",
  width: "1.2em",
  height: "1.2em"
};
function g6(e, t) {
  return m(), h("svg", f6, [...t[0] || (t[0] = [
    g("path", {
      fill: "currentColor",
      d: "M12 5a3.5 3.5 0 0 0-3.5 3.5A3.5 3.5 0 0 0 12 12a3.5 3.5 0 0 0 3.5-3.5A3.5 3.5 0 0 0 12 5m0 2a1.5 1.5 0 0 1 1.5 1.5A1.5 1.5 0 0 1 12 10a1.5 1.5 0 0 1-1.5-1.5A1.5 1.5 0 0 1 12 7M5.5 8A2.5 2.5 0 0 0 3 10.5c0 .94.53 1.75 1.29 2.18c.36.2.77.32 1.21.32s.85-.12 1.21-.32c.37-.21.68-.51.91-.87A5.42 5.42 0 0 1 6.5 8.5v-.28c-.3-.14-.64-.22-1-.22m13 0c-.36 0-.7.08-1 .22v.28c0 1.2-.39 2.36-1.12 3.31c.12.19.25.34.4.49a2.48 2.48 0 0 0 1.72.7c.44 0 .85-.12 1.21-.32c.76-.43 1.29-1.24 1.29-2.18A2.5 2.5 0 0 0 18.5 8M12 14c-2.34 0-7 1.17-7 3.5V19h14v-1.5c0-2.33-4.66-3.5-7-3.5m-7.29.55C2.78 14.78 0 15.76 0 17.5V19h3v-1.93c0-1.01.69-1.85 1.71-2.52m14.58 0c1.02.67 1.71 1.51 1.71 2.52V19h3v-1.5c0-1.74-2.78-2.72-4.71-2.95M12 16c1.53 0 3.24.5 4.23 1H7.77c.99-.5 2.7-1 4.23-1"
    }, null, -1)
  ])]);
}
const h6 = Se({ name: "mdi-account-group-outline", render: g6 }), b6 = {
  viewBox: "0 0 24 24",
  width: "1.2em",
  height: "1.2em"
};
function v6(e, t) {
  return m(), h("svg", b6, [...t[0] || (t[0] = [
    g("path", {
      fill: "currentColor",
      d: "M12 4a4 4 0 0 1 4 4a4 4 0 0 1-4 4a4 4 0 0 1-4-4a4 4 0 0 1 4-4m0 2a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2m0 7c2.67 0 8 1.33 8 4v3H4v-3c0-2.67 5.33-4 8-4m0 1.9c-2.97 0-6.1 1.46-6.1 2.1v1.1h12.2V17c0-.64-3.13-2.1-6.1-2.1"
    }, null, -1)
  ])]);
}
const y6 = Se({ name: "mdi-account-outline", render: v6 }), xt = {
  AC: 247,
  AD: 376,
  AE: 971,
  AF: 93,
  AG: 1,
  AI: 1,
  AL: 355,
  AM: 374,
  AO: 244,
  AR: 54,
  AS: 1,
  AT: 43,
  AU: 61,
  AW: 297,
  AX: 358,
  AZ: 994,
  BA: 387,
  BB: 1,
  BD: 880,
  BE: 32,
  BF: 226,
  BG: 359,
  BH: 973,
  BI: 257,
  BJ: 229,
  BL: 590,
  BM: 1,
  BN: 673,
  BO: 591,
  BQ: 599,
  BR: 55,
  BS: 1,
  BT: 975,
  BW: 267,
  BY: 375,
  BZ: 501,
  CA: 1,
  CC: 61,
  CD: 243,
  CF: 236,
  CG: 242,
  CH: 41,
  CI: 225,
  CK: 682,
  CL: 56,
  CM: 237,
  CN: 86,
  CO: 57,
  CR: 506,
  CU: 53,
  CV: 238,
  CW: 599,
  CX: 61,
  CY: 357,
  CZ: 420,
  DE: 49,
  DJ: 253,
  DK: 45,
  DM: 1,
  DO: 1,
  DZ: 213,
  EC: 593,
  EE: 372,
  EG: 20,
  EH: 212,
  ER: 291,
  ES: 34,
  ET: 251,
  FI: 358,
  FJ: 679,
  FK: 500,
  FM: 691,
  FO: 298,
  FR: 33,
  GA: 241,
  GB: 44,
  GD: 1,
  GE: 995,
  GF: 594,
  GG: 44,
  GH: 233,
  GI: 350,
  GL: 299,
  GM: 220,
  GN: 224,
  GP: 590,
  GQ: 240,
  GR: 30,
  GT: 502,
  GU: 1,
  GW: 245,
  GY: 592,
  HK: 852,
  HN: 504,
  HR: 385,
  HT: 509,
  HU: 36,
  ID: 62,
  IE: 353,
  IL: 972,
  IM: 44,
  IN: 91,
  IO: 246,
  IQ: 964,
  IR: 98,
  IS: 354,
  IT: 39,
  JE: 44,
  JM: 1,
  JO: 962,
  JP: 81,
  KE: 254,
  KG: 996,
  KH: 855,
  KI: 686,
  KM: 269,
  KN: 1,
  KP: 850,
  KR: 82,
  KW: 965,
  KY: 1,
  KZ: 7,
  LA: 856,
  LB: 961,
  LC: 1,
  LI: 423,
  LK: 94,
  LR: 231,
  LS: 266,
  LT: 370,
  LU: 352,
  LV: 371,
  LY: 218,
  MA: 212,
  MC: 377,
  MD: 373,
  ME: 382,
  MF: 590,
  MG: 261,
  MH: 692,
  MK: 389,
  ML: 223,
  MM: 95,
  MN: 976,
  MO: 853,
  MP: 1,
  MQ: 596,
  MR: 222,
  MS: 1,
  MT: 356,
  MU: 230,
  MV: 960,
  MW: 265,
  MX: 52,
  MY: 60,
  MZ: 258,
  NA: 264,
  NC: 687,
  NE: 227,
  NF: 672,
  NG: 234,
  NI: 505,
  NL: 31,
  NO: 47,
  NP: 977,
  NR: 674,
  NU: 683,
  NZ: 64,
  OM: 968,
  PA: 507,
  PE: 51,
  PF: 689,
  PG: 675,
  PH: 63,
  PK: 92,
  PL: 48,
  PM: 508,
  PR: 1,
  PS: 970,
  PT: 351,
  PW: 680,
  PY: 595,
  QA: 974,
  RE: 262,
  RO: 40,
  RS: 381,
  RU: 7,
  RW: 250,
  SA: 966,
  SB: 677,
  SC: 248,
  SD: 249,
  SE: 46,
  SG: 65,
  SH: 290,
  SI: 386,
  SJ: 47,
  SK: 421,
  SL: 232,
  SM: 378,
  SN: 221,
  SO: 252,
  SR: 597,
  SS: 211,
  ST: 239,
  SV: 503,
  SX: 1,
  SY: 963,
  SZ: 268,
  TA: 290,
  TC: 1,
  TD: 235,
  TG: 228,
  TH: 66,
  TJ: 992,
  TK: 690,
  TL: 670,
  TM: 993,
  TN: 216,
  TO: 676,
  TR: 90,
  TT: 1,
  TV: 688,
  TW: 886,
  TZ: 255,
  UA: 380,
  UG: 256,
  US: 1,
  UY: 598,
  UZ: 998,
  VA: 39,
  VC: 1,
  VE: 58,
  VG: 1,
  VI: 1,
  VN: 84,
  VU: 678,
  WF: 681,
  WS: 685,
  XK: 383,
  YE: 967,
  YT: 262,
  ZA: 27,
  ZM: 260,
  ZW: 263
}, k6 = { 1: "US", 7: "RU", 39: "IT", 44: "GB", 47: "NO", 61: "AU", 212: "MA", 262: "RE", 290: "SH", 358: "FI", 590: "GP", 599: "CW" }, ri = Object.keys(xt), w6 = new Set(Object.values(xt)), Eo = ["CZ", "SK", "PL", "DE", "AT", "HU", "GB", "US", "FR", "ES", "IT", "NL"], x6 = "/static/assets/flags/4x3/", C6 = { AC: "sh-ac", TA: "sh-ta" };
function Xl(e) {
  return !!e && e in xt;
}
const ka = /* @__PURE__ */ new Set();
function ii(e) {
  const t = [];
  for (const n of e) {
    const o = n.trim().toUpperCase();
    if (!Xl(o)) {
      ka.has(n) || console.warn(`[mancub] unknown country code "${n}" in preferredCountries — ignored`), ka.add(n);
      continue;
    }
    t.includes(o) || t.push(o);
  }
  return t;
}
function Jl(e, t) {
  return new URL(x6, Xt(e, t).origin).href;
}
function Ql(e) {
  const t = ce(St, void 0), n = ce(Ct, void 0);
  return v(() => e() ?? Jl(Q(t) ?? "", Q(n) ?? Bt));
}
function S6(e, t) {
  return `${e}${C6[t] ?? t.toLowerCase()}.svg`;
}
const or = /* @__PURE__ */ new Map();
function $6(e) {
  if (!or.has(e)) {
    let t = null;
    try {
      t = new Intl.DisplayNames([e, "en"], { type: "region" });
    } catch {
    }
    or.set(e, t);
  }
  return or.get(e) ?? null;
}
function ai(e, t) {
  return $6(t)?.of(e) ?? e;
}
const es = ({ context: e }) => ({
  class: { "mancub-country-option--pinned-last": e.option.pinnedLast }
});
function ts(e, t) {
  const n = (a, d = !1) => ({ code: a, name: ai(a, e), dial: xt[a] ?? 0, pinnedLast: d }), o = t.map((a, d) => n(a, d === t.length - 1)), i = new Set(t), r = ri.filter((a) => !i.has(a)).map((a) => n(a)).sort((a, d) => a.name.localeCompare(d.name, e));
  return [...o, ...r];
}
function rr(e, t, n = [], o) {
  const i = (e ?? "").replace(/\s+/g, "");
  if (!i.startsWith("+")) return { country: t, number: i };
  const r = i.slice(1);
  for (const a of [1, 2, 3]) {
    const d = Number(r.slice(0, a));
    if (r.length < a || !w6.has(d)) continue;
    return { country: o && xt[o] === d && o || n.find((u) => xt[u] === d) || k6[d] || ri.find((u) => xt[u] === d) || t, number: r.slice(a) };
  }
  return { country: t, number: r };
}
const wa = (e) => e.normalize("NFD").replace(/\p{Diacritic}/gu, "").toLowerCase().trim();
function B6(e, t) {
  if (!e?.trim()) return null;
  const n = e.trim().toUpperCase();
  if (Xl(n)) return n;
  const o = wa(e);
  for (const i of [t, "en"]) {
    const r = ri.find((a) => wa(ai(a, i)) === o);
    if (r) return r;
  }
  return null;
}
const T6 = ["src"], I6 = {
  key: 1,
  class: "mancub-country-flag mancub-country-flag--missing",
  "aria-hidden": "true"
}, Ro = /* @__PURE__ */ se({
  __name: "CountryFlag",
  props: {
    code: {},
    baseUrl: {}
  },
  setup(e) {
    const t = W(!1);
    return te(() => [e.code, e.baseUrl], () => {
      t.value = !1;
    }), (n, o) => t.value ? (m(), h("span", I6)) : (m(), h("img", {
      key: 0,
      src: z(S6)(n.baseUrl, n.code),
      alt: "",
      width: "20",
      height: "15",
      loading: "lazy",
      class: "mancub-country-flag",
      onError: o[0] || (o[0] = (i) => t.value = !0)
    }, null, 40, T6));
  }
}), D6 = { class: "mancub-phone-input flex items-stretch" }, P6 = {
  key: 0,
  class: "mancub-country-item"
}, z6 = { class: "mancub-country-item__dial" }, L6 = { class: "mancub-country-item mancub-country-item--option" }, O6 = { class: "mancub-country-item__label" }, M6 = { class: "mancub-country-item__dial mancub-country-item__dial--option" }, ir = /* @__PURE__ */ se({
  __name: "PhoneInput",
  props: /* @__PURE__ */ Mt({
    required: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    placeholder: { default: "" },
    name: { default: () => {
    } },
    autocomplete: { default: "tel" },
    preferredLanguage: { default: "en" },
    preferredCountries: { default: () => {
    } },
    flagBaseUrl: { default: () => {
    } }
  }, {
    modelValue: { default: "" },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = At(e, "modelValue"), n = Ql(() => e.flagBaseUrl), o = v(() => ii(e.preferredCountries ?? Eo)), i = v(() => o.value[0] ?? Eo[0] ?? "CZ"), r = v(() => ts(e.preferredLanguage, o.value).map((c) => ({ ...c, search: `${c.name} ${c.code} +${c.dial}` }))), a = rr(t.value, i.value, o.value), d = W(a.country), l = W(a.number), u = () => l.value ? `+${xt[d.value]}${l.value}` : "";
    te(() => t.value, (c) => {
      if (c === u()) return;
      const p = rr(c, i.value, o.value, d.value);
      d.value = p.country, l.value = p.number;
    });
    const s = /^(?:\+|00)\d{8,}$/;
    return te([d, l], () => {
      const c = l.value.replace(/[\s\-().]/g, "");
      if (s.test(c)) {
        const f = rr(c.replace(/^00/, "+"), i.value, o.value, d.value);
        d.value = f.country, l.value = f.number;
        return;
      }
      const p = u();
      p !== t.value && (t.value = p);
    }), (c, p) => {
      const f = rn, b = Et;
      return m(), h("div", D6, [
        L(f, {
          modelValue: d.value,
          "onUpdate:modelValue": p[0] || (p[0] = (k) => d.value = k),
          options: r.value,
          "option-label": "search",
          "option-value": "code",
          filter: "",
          "filter-fields": ["search"],
          "auto-filter-focus": "",
          "overlay-class": "mancub-widget-overlay",
          disabled: c.disabled,
          pt: {
            root: {
              class: "mancub-phone-input__prefix min-w-28",
              "data-testid": "mancub-phone-prefix"
            },
            option: z(es)
          }
        }, {
          value: U(({ value: k }) => [
            k ? (m(), h("span", P6, [
              L(Ro, {
                code: k,
                "base-url": z(n)
              }, null, 8, ["code", "base-url"]),
              g("span", z6, "+" + y(z(xt)[k]), 1)
            ])) : B("", !0)
          ]),
          option: U(({ option: k }) => [
            g("span", L6, [
              L(Ro, {
                code: k.code,
                "base-url": z(n)
              }, null, 8, ["code", "base-url"]),
              g("span", O6, y(k.name), 1),
              g("span", M6, "+" + y(k.dial), 1)
            ])
          ]),
          _: 1
        }, 8, ["modelValue", "options", "disabled", "pt"]),
        L(b, {
          modelValue: l.value,
          "onUpdate:modelValue": p[1] || (p[1] = (k) => l.value = k),
          class: "mancub-phone-input__number flex-1 min-w-0",
          type: "tel",
          inputmode: "tel",
          name: c.name,
          autocomplete: c.autocomplete,
          disabled: c.disabled,
          required: c.required,
          placeholder: c.placeholder,
          "pt:root:data-testid": "mancub-phone-number-input"
        }, null, 8, ["modelValue", "name", "autocomplete", "disabled", "required", "placeholder"])
      ]);
    };
  }
}), A6 = {
  key: 0,
  class: "mancub-country-item"
}, _6 = { class: "mancub-country-item__label" }, F6 = { key: 1 }, E6 = { class: "mancub-country-item" }, R6 = { class: "mancub-country-item__label" }, V6 = /* @__PURE__ */ se({
  __name: "CountrySelect",
  props: /* @__PURE__ */ Mt({
    preferredLanguage: { default: "en" },
    preferredCountries: { default: () => {
    } },
    flagBaseUrl: { default: () => {
    } },
    disabled: { type: Boolean, default: !1 },
    placeholder: { default: () => {
    } },
    inputId: { default: () => {
    } }
  }, {
    modelValue: { default: "" },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = At(e, "modelValue"), n = Ql(() => e.flagBaseUrl), o = v(
      () => ts(e.preferredLanguage, ii(e.preferredCountries ?? Eo)).map((i) => ({ ...i, search: `${i.name} ${i.code}` }))
    );
    return (i, r) => {
      const a = rn;
      return m(), j(a, {
        modelValue: t.value,
        "onUpdate:modelValue": r[0] || (r[0] = (d) => t.value = d),
        options: o.value,
        "option-label": "search",
        "option-value": "code",
        filter: "",
        "filter-fields": ["search"],
        "auto-filter-focus": "",
        "overlay-class": "mancub-widget-overlay",
        disabled: i.disabled,
        placeholder: i.placeholder,
        "input-id": i.inputId,
        pt: { option: z(es) }
      }, {
        value: U(({ value: d, placeholder: l }) => [
          d ? (m(), h("span", A6, [
            L(Ro, {
              code: d,
              "base-url": z(n)
            }, null, 8, ["code", "base-url"]),
            g("span", _6, y(z(ai)(d, i.preferredLanguage)), 1)
          ])) : (m(), h("span", F6, y(l || " "), 1))
        ]),
        option: U(({ option: d }) => [
          g("span", E6, [
            L(Ro, {
              code: d.code,
              "base-url": z(n)
            }, null, 8, ["code", "base-url"]),
            g("span", R6, y(d.name), 1)
          ])
        ]),
        _: 1
      }, 8, ["modelValue", "options", "disabled", "placeholder", "input-id", "pt"]);
    };
  }
}), N6 = "mancub.customer", ns = {
  name: "",
  email: "",
  phone: "",
  invoice_name: "",
  invoice_company: "",
  invoice_vat: "",
  invoice_address: "",
  invoice_city: "",
  invoice_zip: "",
  invoice_country: "",
  invoice_is_company: !1,
  wants_receipt: !1
}, Bo = Vr(N6, ns, void 0, {
  mergeDefaults: !0
});
function j6() {
  function e() {
    Bo.value = { ...ns };
  }
  function t(n) {
    Bo.value = { ...Bo.value, ...n };
  }
  return { customer: Bo, reset: e, patch: t };
}
class os extends Error {
  constructor(t, n) {
    super(t), this.name = "OrderValidationError", this.issues = n;
  }
}
async function U6(e) {
  if (e.items.length === 0)
    throw new Error("Cannot place an empty order.");
  let t = 0, n = null;
  for (const l of e.items) {
    const u = Uo(l, e.currency);
    t += u.amount, u.decimals != null && (n = Math.max(n ?? 0, u.decimals));
  }
  t = en(t, n);
  const o = {
    agree_terms: !0,
    content: {
      case: {
        ident: "",
        language: e.language,
        price: t,
        currency: e.currency,
        // exchange_rate is omitted: the engine snapshots the tenant's
        // per-currency rates onto the case at creation time.
        customer_note: e.customer_note ?? ""
      },
      customer: {
        name: e.customer.name,
        email: e.customer.email,
        phone: e.customer.phone,
        invoice_name: e.customer.wants_receipt ? e.customer.invoice_name : null,
        invoice_company: e.customer.wants_receipt && e.customer.invoice_is_company ? e.customer.invoice_company : null,
        invoice_vat: e.customer.wants_receipt && e.customer.invoice_is_company ? e.customer.invoice_vat : null,
        invoice_address: e.customer.wants_receipt ? e.customer.invoice_address : null,
        invoice_city: e.customer.wants_receipt ? e.customer.invoice_city : null,
        invoice_zip: e.customer.wants_receipt ? e.customer.invoice_zip : null,
        invoice_country: e.customer.wants_receipt ? e.customer.invoice_country : null
      },
      setups: e.items.map((l) => {
        const u = e.beneficiaries[l.id] ?? { name: "", phone: "", email: "" };
        return {
          start_day: l.day,
          start_time: l.time ?? "00:00:00",
          commodity_ident: l.commodity_ident,
          title_customer: l.title_customer,
          beneficiary_name: u.name,
          beneficiary_phone: u.phone,
          beneficiary_email: u.email || null,
          setup_items: l.setup_items
        };
      })
    }
  }, i = new URL("order", Xt(e.host, e.apiUrl)), r = await fetch(i, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(o)
  });
  let a = null;
  try {
    a = await r.json();
  } catch {
  }
  if (!r.ok) {
    const l = a?.message ?? `Order failed (HTTP ${r.status})`, u = a?.details?.issues;
    throw u?.length ? new os(l, u) : new Error(l);
  }
  if (!a?.redirect)
    throw new Error("Order accepted but no redirect URL returned.");
  return { redirect: new URL(a.redirect, Xt(e.host, e.apiUrl)).toString() };
}
const H6 = { class: "flex flex-col gap-3 p-4 sm:p-6 lg:p-8 pb-2 sm:pb-2 lg:pb-2" }, K6 = { class: "rounded-xl border border-gray-200 bg-white p-4 sm:p-5 flex flex-col gap-4" }, W6 = { class: "flex items-center gap-2 pb-2 border-b border-gray-100" }, Y6 = { class: "text-base sm:text-lg font-semibold text-gray-900" }, G6 = { class: "grid grid-cols-1 sm:grid-cols-2 gap-3" }, q6 = { class: "sm:col-span-2" }, Z6 = { class: "text-sm font-medium text-gray-800 mb-1 block" }, X6 = { class: "text-sm font-medium text-gray-800 mb-1 block" }, J6 = { class: "text-sm font-medium text-gray-800 mb-1 block" }, Q6 = { class: "flex flex-col gap-2" }, e8 = { class: "flex items-center gap-3 cursor-pointer text-gray-700 py-1.5" }, t8 = { class: "flex items-center gap-3 cursor-pointer text-gray-700 py-1.5" }, n8 = {
  key: 0,
  class: "rounded-lg bg-gray-50 border border-gray-200 p-3 sm:p-4 flex flex-col gap-3"
}, o8 = { class: "text-sm font-medium text-gray-800 mb-1 block" }, r8 = { class: "flex items-center gap-3 cursor-pointer text-gray-700 py-1.5" }, i8 = {
  key: 0,
  class: "grid grid-cols-1 sm:grid-cols-2 gap-3"
}, a8 = { class: "sm:col-span-2" }, l8 = { class: "text-sm font-medium text-gray-800 mb-1 block" }, s8 = { class: "sm:col-span-2" }, d8 = { class: "text-sm font-medium text-gray-800 mb-1 block" }, u8 = { class: "grid grid-cols-1 sm:grid-cols-2 gap-3" }, c8 = { class: "sm:col-span-2" }, p8 = { class: "text-sm font-medium text-gray-800 mb-1 block" }, m8 = { class: "text-sm font-medium text-gray-800 mb-1 block" }, f8 = { class: "text-sm font-medium text-gray-800 mb-1 block" }, g8 = { class: "sm:col-span-2" }, h8 = {
  for: "mancub-invoice-country",
  class: "text-sm font-medium text-gray-800 mb-1 block"
}, b8 = { class: "rounded-xl border border-gray-200 bg-white p-4 sm:p-5 flex flex-col gap-4" }, v8 = { class: "flex items-center gap-2 pb-2 border-b border-gray-100" }, y8 = { class: "text-base sm:text-lg font-semibold text-gray-900" }, k8 = { class: "flex items-center gap-3 cursor-pointer text-gray-700 py-1.5" }, w8 = {
  key: 0,
  class: "flex items-center gap-3 cursor-pointer text-gray-700 py-1.5"
}, x8 = {
  key: 1,
  class: "grid grid-cols-1 sm:grid-cols-2 gap-3"
}, C8 = { class: "sm:col-span-2" }, S8 = { class: "text-sm font-medium text-gray-800 mb-1 block" }, $8 = { class: "text-sm font-medium text-gray-800 mb-1 block" }, B8 = { class: "text-sm font-medium text-gray-800 mb-1 block" }, T8 = {
  key: 2,
  class: "flex flex-col gap-3"
}, I8 = { class: "flex items-center gap-3 pb-2 border-b border-gray-200" }, D8 = ["src", "alt"], P8 = { class: "min-w-0 truncate text-base font-semibold text-gray-900 sm:text-lg" }, z8 = { class: "grid grid-cols-1 sm:grid-cols-2 gap-3" }, L8 = { class: "sm:col-span-2" }, O8 = { class: "text-sm font-medium text-gray-800 mb-1 block" }, M8 = { class: "text-sm font-medium text-gray-800 mb-1 block" }, A8 = { class: "text-sm font-medium text-gray-800 mb-1 block" }, _8 = { class: "flex flex-col gap-3 px-1" }, F8 = { class: "flex items-start gap-3 cursor-pointer text-gray-700 py-1.5" }, E8 = ["href"], R8 = {
  key: 0,
  class: "flex items-start gap-2 rounded-lg bg-red-50 border border-red-200 text-red-700 text-sm p-3",
  "data-testid": "mancub-checkout-error-message"
}, V8 = { class: "flex flex-col sm:flex-row gap-2 w-full sm:w-auto" }, N8 = /* @__PURE__ */ se({
  __name: "CheckoutForm",
  props: {
    host: { default: () => {
    } },
    preferredLanguage: { default: () => ln },
    apiUrl: { default: () => {
    } },
    currency: { default: () => {
    } },
    currencies: { default: () => [] },
    preferredCountries: { default: () => {
    } },
    labels: { default: () => {
    } },
    termsUrl: { default: () => {
    } }
  },
  emits: ["placed", "back"],
  setup(e, { emit: t }) {
    al(() => e.currency);
    const n = Ho(), o = t, i = v(() => Qe(e.preferredLanguage, e.labels)), r = ce(Ct, void 0), a = v(() => e.apiUrl ?? Q(r) ?? Bt), d = ce(St, void 0), l = v(() => e.host ?? Q(d) ?? ""), u = v(() => Jl(l.value, a.value)), { customer: s } = j6(), c = nn(), p = c.items, f = W(!1), b = W("");
    te(() => s.value.wants_receipt, (M) => {
      M && !s.value.invoice_name && (s.value.invoice_name = s.value.name);
    }), te(() => e.preferredCountries, () => {
      const M = s.value.invoice_country, P = B6(M, e.preferredLanguage) ?? ii(e.preferredCountries ?? Eo)[0] ?? "";
      P !== M && (s.value.invoice_country = P);
    }, { immediate: !0 });
    const k = W(!0), T = W(!1);
    function $() {
      return { name: s.value.name, phone: s.value.phone, email: s.value.email };
    }
    const S = Do($()), O = Do({});
    te(p, (M) => {
      const P = new Set(M.map((E) => E.id));
      for (const E of Object.keys(O)) P.has(E) || delete O[E];
      for (const E of M) O[E.id] || (O[E.id] = $());
    }, { immediate: !0 }), te(
      [k, () => s.value.name, () => s.value.phone, () => s.value.email],
      () => {
        if (k.value) {
          Object.assign(S, $());
          for (const M of Object.values(O)) Object.assign(M, $());
        }
      },
      { immediate: !0 }
    ), te(T, (M) => {
      if (M)
        for (const P of Object.values(O)) Object.assign(P, { ...S });
    });
    const w = v(() => !k.value && T.value && p.value.length > 1), F = v(
      () => p.value.map((M) => ({ item: M, beneficiary: O[M.id] })).filter((M) => !!M.beneficiary)
    ), D = v(() => {
      const M = {};
      for (const P of p.value)
        M[P.id] = w.value ? O[P.id] ?? $() : S;
      return M;
    }), C = W(!1), I = v(() => !C.value || !s.value.name || !s.value.email || !s.value.phone || p.value.length === 0 || !n.value ? !1 : p.value.every((M) => {
      const P = D.value[M.id];
      return !!P?.name && !!P?.phone;
    })), N = W(!1), K = W(null), V = async () => {
      const M = n.value;
      if (!(!I.value || !M || N.value)) {
        N.value = !0, K.value = null;
        try {
          const P = await U6({
            host: l.value,
            apiUrl: a.value,
            items: c.items.value,
            customer: s.value,
            beneficiaries: D.value,
            currency: M,
            language: e.preferredLanguage,
            customer_note: f.value ? b.value : ""
          });
          c.clear(), o("placed", P.redirect), window.location.href = P.redirect;
        } catch (P) {
          const E = P instanceof os ? P.issues[0] : void 0;
          E ? K.value = l$(E, c.items.value, i.value, e.preferredLanguage) : K.value = P instanceof Error ? P.message : String(P);
        } finally {
          N.value = !1;
        }
      }
    };
    return (M, P) => {
      const E = y6, H = Et, ae = Go, fe = Qr, Be = h6, Ae = cl, Oe = Ul, _e = m6, be = bt, je = ql;
      return m(), h("form", {
        class: "mancub-checkout flex flex-col",
        onSubmit: Ot(V, ["prevent"])
      }, [
        g("div", H6, [
          g("section", K6, [
            g("header", W6, [
              L(E, { class: "text-xl text-[var(--p-primary-color)]" }),
              g("h3", Y6, y(i.value.customer), 1)
            ]),
            g("div", G6, [
              g("div", q6, [
                g("label", Z6, [
                  q(y(i.value.customerName) + " ", 1),
                  P[21] || (P[21] = g("span", { class: "text-red-500" }, "*", -1))
                ]),
                L(H, {
                  modelValue: z(s).name,
                  "onUpdate:modelValue": P[0] || (P[0] = (G) => z(s).name = G),
                  class: "w-full",
                  name: "name",
                  autocomplete: "name",
                  required: "",
                  "pt:root:data-testid": "mancub-customer-name-input"
                }, null, 8, ["modelValue"])
              ]),
              g("div", null, [
                g("label", X6, [
                  q(y(i.value.customerPhone) + " ", 1),
                  P[22] || (P[22] = g("span", { class: "text-red-500" }, "*", -1))
                ]),
                L(ir, {
                  modelValue: z(s).phone,
                  "onUpdate:modelValue": P[1] || (P[1] = (G) => z(s).phone = G),
                  name: "tel",
                  autocomplete: "tel",
                  "preferred-language": M.preferredLanguage,
                  "preferred-countries": M.preferredCountries,
                  "flag-base-url": u.value,
                  required: ""
                }, null, 8, ["modelValue", "preferred-language", "preferred-countries", "flag-base-url"])
              ]),
              g("div", null, [
                g("label", J6, [
                  q(y(i.value.customerEmail) + " ", 1),
                  P[23] || (P[23] = g("span", { class: "text-red-500" }, "*", -1))
                ]),
                L(H, {
                  modelValue: z(s).email,
                  "onUpdate:modelValue": P[2] || (P[2] = (G) => z(s).email = G),
                  type: "email",
                  class: "w-full",
                  name: "email",
                  autocomplete: "email",
                  required: ""
                }, null, 8, ["modelValue"])
              ])
            ]),
            g("div", Q6, [
              g("label", e8, [
                L(ae, {
                  modelValue: f.value,
                  "onUpdate:modelValue": P[3] || (P[3] = (G) => f.value = G),
                  binary: "",
                  size: "large"
                }, null, 8, ["modelValue"]),
                g("span", null, y(i.value.addCustomerNote), 1)
              ]),
              f.value ? (m(), j(fe, {
                key: 0,
                modelValue: b.value,
                "onUpdate:modelValue": P[4] || (P[4] = (G) => b.value = G),
                rows: "3",
                class: "w-full"
              }, null, 8, ["modelValue"])) : B("", !0),
              g("label", t8, [
                L(ae, {
                  modelValue: z(s).wants_receipt,
                  "onUpdate:modelValue": P[5] || (P[5] = (G) => z(s).wants_receipt = G),
                  binary: "",
                  size: "large"
                }, null, 8, ["modelValue"]),
                g("span", null, y(i.value.sendReceipt), 1)
              ])
            ]),
            z(s).wants_receipt ? (m(), h("div", n8, [
              g("div", null, [
                g("label", o8, y(i.value.invoiceName), 1),
                L(H, {
                  modelValue: z(s).invoice_name,
                  "onUpdate:modelValue": P[6] || (P[6] = (G) => z(s).invoice_name = G),
                  class: "w-full",
                  name: "invoice_name",
                  autocomplete: "billing name"
                }, null, 8, ["modelValue"])
              ]),
              g("label", r8, [
                L(ae, {
                  modelValue: z(s).invoice_is_company,
                  "onUpdate:modelValue": P[7] || (P[7] = (G) => z(s).invoice_is_company = G),
                  binary: "",
                  size: "large"
                }, null, 8, ["modelValue"]),
                g("span", null, y(i.value.issueForCompany), 1)
              ]),
              z(s).invoice_is_company ? (m(), h("div", i8, [
                g("div", a8, [
                  g("label", l8, y(i.value.invoiceCompany), 1),
                  L(H, {
                    modelValue: z(s).invoice_company,
                    "onUpdate:modelValue": P[8] || (P[8] = (G) => z(s).invoice_company = G),
                    class: "w-full",
                    name: "invoice_company",
                    autocomplete: "billing organization"
                  }, null, 8, ["modelValue"])
                ]),
                g("div", s8, [
                  g("label", d8, y(i.value.invoiceVat), 1),
                  L(H, {
                    modelValue: z(s).invoice_vat,
                    "onUpdate:modelValue": P[9] || (P[9] = (G) => z(s).invoice_vat = G),
                    class: "w-full",
                    name: "invoice_vat"
                  }, null, 8, ["modelValue"])
                ])
              ])) : B("", !0),
              g("div", u8, [
                g("div", c8, [
                  g("label", p8, y(i.value.invoiceAddress), 1),
                  L(H, {
                    modelValue: z(s).invoice_address,
                    "onUpdate:modelValue": P[10] || (P[10] = (G) => z(s).invoice_address = G),
                    class: "w-full",
                    name: "invoice_address",
                    autocomplete: "billing street-address"
                  }, null, 8, ["modelValue"])
                ]),
                g("div", null, [
                  g("label", m8, y(i.value.invoiceCity), 1),
                  L(H, {
                    modelValue: z(s).invoice_city,
                    "onUpdate:modelValue": P[11] || (P[11] = (G) => z(s).invoice_city = G),
                    class: "w-full",
                    name: "invoice_city",
                    autocomplete: "billing address-level2"
                  }, null, 8, ["modelValue"])
                ]),
                g("div", null, [
                  g("label", f8, y(i.value.invoiceZip), 1),
                  L(H, {
                    modelValue: z(s).invoice_zip,
                    "onUpdate:modelValue": P[12] || (P[12] = (G) => z(s).invoice_zip = G),
                    class: "w-full",
                    name: "invoice_zip",
                    autocomplete: "billing postal-code"
                  }, null, 8, ["modelValue"])
                ]),
                g("div", g8, [
                  g("label", h8, y(i.value.invoiceCountry), 1),
                  L(V6, {
                    modelValue: z(s).invoice_country,
                    "onUpdate:modelValue": P[13] || (P[13] = (G) => z(s).invoice_country = G),
                    "input-id": "mancub-invoice-country",
                    class: "w-full",
                    "preferred-language": M.preferredLanguage,
                    "preferred-countries": M.preferredCountries,
                    "flag-base-url": u.value
                  }, null, 8, ["modelValue", "preferred-language", "preferred-countries", "flag-base-url"])
                ])
              ])
            ])) : B("", !0)
          ]),
          g("section", b8, [
            g("header", v8, [
              L(Be, { class: "text-xl text-[var(--p-primary-color)]" }),
              g("h3", y8, y(i.value.participant), 1)
            ]),
            g("label", k8, [
              L(ae, {
                modelValue: k.value,
                "onUpdate:modelValue": P[14] || (P[14] = (G) => k.value = G),
                binary: "",
                size: "large"
              }, null, 8, ["modelValue"]),
              g("span", null, y(i.value.customerIsParticipant), 1)
            ]),
            !k.value && z(p).length > 1 ? (m(), h("label", w8, [
              L(ae, {
                modelValue: T.value,
                "onUpdate:modelValue": P[15] || (P[15] = (G) => T.value = G),
                binary: "",
                size: "large"
              }, null, 8, ["modelValue"]),
              g("span", null, y(i.value.separateParticipants), 1)
            ])) : B("", !0),
            w.value ? (m(), h("div", T8, [
              (m(!0), h(Y, null, he(F.value, (G, Fe) => (m(), h("div", {
                key: G.item.id,
                class: "rounded-lg bg-gray-50 border border-gray-200 p-3 sm:p-4 flex flex-col gap-3"
              }, [
                g("div", I8, [
                  G.item.thumbnail ? (m(), h("img", {
                    key: 0,
                    src: G.item.thumbnail,
                    alt: G.item.title_customer ?? G.item.commodity_ident,
                    class: "aspect-[4/3] h-10 flex-shrink-0 rounded-[1px] object-cover shadow-sm"
                  }, null, 8, D8)) : (m(), j(Ae, {
                    key: 1,
                    class: "text-lg text-[var(--p-primary-color)] flex-shrink-0"
                  })),
                  g("span", P8, y(G.item.title_customer || `${i.value.reservation} ${Fe + 1}`), 1)
                ]),
                g("div", z8, [
                  g("div", L8, [
                    g("label", O8, [
                      q(y(i.value.participantName) + " ", 1),
                      P[26] || (P[26] = g("span", { class: "text-red-500" }, "*", -1))
                    ]),
                    L(H, {
                      modelValue: G.beneficiary.name,
                      "onUpdate:modelValue": (He) => G.beneficiary.name = He,
                      class: "w-full",
                      name: `participant_${Fe}_name`,
                      autocomplete: `section-participant-${Fe} name`,
                      required: ""
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "name", "autocomplete"])
                  ]),
                  g("div", null, [
                    g("label", M8, [
                      q(y(i.value.participantPhone) + " ", 1),
                      P[27] || (P[27] = g("span", { class: "text-red-500" }, "*", -1))
                    ]),
                    L(ir, {
                      modelValue: G.beneficiary.phone,
                      "onUpdate:modelValue": (He) => G.beneficiary.phone = He,
                      name: `participant_${Fe}_tel`,
                      autocomplete: `section-participant-${Fe} tel`,
                      "preferred-language": M.preferredLanguage,
                      "preferred-countries": M.preferredCountries,
                      "flag-base-url": u.value,
                      required: ""
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "name", "autocomplete", "preferred-language", "preferred-countries", "flag-base-url"])
                  ]),
                  g("div", null, [
                    g("label", A8, y(i.value.participantEmail), 1),
                    L(H, {
                      modelValue: G.beneficiary.email,
                      "onUpdate:modelValue": (He) => G.beneficiary.email = He,
                      type: "email",
                      class: "w-full",
                      name: `participant_${Fe}_email`,
                      autocomplete: `section-participant-${Fe} email`
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "name", "autocomplete"])
                  ])
                ])
              ]))), 128))
            ])) : (m(), h("div", x8, [
              g("div", C8, [
                g("label", S8, [
                  q(y(i.value.participantName) + " ", 1),
                  P[24] || (P[24] = g("span", { class: "text-red-500" }, "*", -1))
                ]),
                L(H, {
                  modelValue: S.name,
                  "onUpdate:modelValue": P[16] || (P[16] = (G) => S.name = G),
                  class: "w-full",
                  name: "participant_name",
                  autocomplete: "section-participant name",
                  disabled: k.value,
                  required: ""
                }, null, 8, ["modelValue", "disabled"])
              ]),
              g("div", null, [
                g("label", $8, [
                  q(y(i.value.participantPhone) + " ", 1),
                  P[25] || (P[25] = g("span", { class: "text-red-500" }, "*", -1))
                ]),
                L(ir, {
                  modelValue: S.phone,
                  "onUpdate:modelValue": P[17] || (P[17] = (G) => S.phone = G),
                  name: "participant_tel",
                  autocomplete: "section-participant tel",
                  "preferred-language": M.preferredLanguage,
                  "preferred-countries": M.preferredCountries,
                  "flag-base-url": u.value,
                  disabled: k.value,
                  required: ""
                }, null, 8, ["modelValue", "preferred-language", "preferred-countries", "flag-base-url", "disabled"])
              ]),
              g("div", null, [
                g("label", B8, y(i.value.participantEmail), 1),
                L(H, {
                  modelValue: S.email,
                  "onUpdate:modelValue": P[18] || (P[18] = (G) => S.email = G),
                  type: "email",
                  class: "w-full",
                  name: "participant_email",
                  autocomplete: "section-participant email",
                  disabled: k.value
                }, null, 8, ["modelValue", "disabled"])
              ])
            ]))
          ]),
          g("div", _8, [
            g("label", F8, [
              L(ae, {
                modelValue: C.value,
                "onUpdate:modelValue": P[19] || (P[19] = (G) => C.value = G),
                binary: "",
                required: "",
                size: "large",
                class: "mt-0.5"
              }, null, 8, ["modelValue"]),
              g("span", null, [
                q(y(i.value.agreeTerms) + " ", 1),
                M.termsUrl ? (m(), h("a", {
                  key: 0,
                  href: M.termsUrl,
                  target: "_blank",
                  rel: "noopener",
                  class: "underline text-[var(--p-primary-color)]"
                }, y(i.value.termsLinkText), 9, E8)) : (m(), h(Y, { key: 1 }, [
                  q(y(i.value.termsLinkText), 1)
                ], 64)),
                P[28] || (P[28] = g("span", { class: "text-red-500" }, " *", -1))
              ])
            ])
          ])
        ]),
        L(Zl, {
          "preferred-language": M.preferredLanguage,
          currencies: M.currencies,
          labels: e.labels
        }, {
          top: U(() => [
            K.value ? (m(), h("div", R8, [
              L(Oe, { class: "text-lg flex-shrink-0 mt-0.5" }),
              g("span", null, y(K.value), 1)
            ])) : B("", !0)
          ]),
          default: U(() => [
            g("div", V8, [
              L(be, {
                type: "button",
                severity: "secondary",
                outlined: "",
                size: "large",
                class: "w-full sm:w-auto",
                onClick: P[20] || (P[20] = (G) => o("back"))
              }, {
                default: U(() => [
                  L(_e, { class: "text-lg mr-1" }),
                  q(" " + y(i.value.backToBasket), 1)
                ]),
                _: 1
              }),
              L(be, {
                type: "submit",
                size: "large",
                class: "w-full sm:w-auto",
                disabled: !I.value,
                loading: N.value
              }, {
                default: U(() => [
                  q(y(i.value.payNow) + " ", 1),
                  L(je, { class: "text-lg ml-1" })
                ]),
                _: 1
              }, 8, ["disabled", "loading"])
            ])
          ]),
          _: 1
        }, 8, ["preferred-language", "currencies", "labels"])
      ], 32);
    };
  }
}), j8 = { class: "flex items-center gap-2 border-b border-gray-200 px-4 sm:px-6 lg:px-12 py-3 lg:py-5 sticky top-0 bg-white z-10" }, U8 = { class: "text-xl sm:text-2xl font-semibold text-gray-900 flex-1 truncate" }, H8 = ["aria-label"], K8 = {
  key: "items",
  class: "flex flex-col"
}, W8 = { class: "flex flex-col gap-3 p-4 sm:p-6 lg:p-12" }, Y8 = {
  key: 0,
  class: "text-center text-gray-500 py-16"
}, G8 = { class: "flex flex-col sm:flex-row gap-2 w-full sm:w-auto" }, q8 = {
  key: 0,
  class: "mancub-modal-shell flex flex-col"
}, Z8 = { class: "flex items-center justify-between border-b border-gray-200 px-4 sm:px-6 lg:px-12 py-3 lg:py-5 sticky top-0 bg-white z-10" }, X8 = { class: "text-xl font-semibold text-gray-900" }, J8 = ["aria-label"], Q8 = { class: "pb-[50vh] sm:pb-0" }, e7 = /* @__PURE__ */ se({
  __name: "BasketModal",
  props: /* @__PURE__ */ Mt({
    host: { default: () => {
    } },
    preferredLanguage: { default: "en" },
    apiUrl: { default: () => {
    } },
    currency: { default: () => {
    } },
    currencies: { default: () => [] },
    preferredCountries: { default: () => {
    } },
    labels: { default: () => {
    } },
    termsUrl: { default: () => {
    } }
  }, {
    visible: { type: Boolean, default: !1 },
    visibleModifiers: {}
  }),
  emits: ["update:visible"],
  setup(e) {
    const t = At(e, "visible");
    so(t);
    const n = v(() => Qe(e.preferredLanguage, e.labels)), o = nn(), i = W("items"), r = W(null), a = W("forward"), d = () => {
      a.value = "forward", i.value = "checkout";
    }, l = () => {
      a.value = "backward", i.value = "items";
    };
    te(i, () => {
      r.value?.scrollTo({ top: 0 });
    }), al(() => e.currency);
    const u = Ho(), { openRequestSeq: s, requestedStep: c } = US();
    te(s, () => {
      i.value = c.value, t.value = !0;
    });
    const p = W(!1), f = W(null);
    so(p);
    const b = ($) => {
      f.value = $, p.value = !0;
    }, k = ($) => {
      o.remove($.id);
    }, T = () => {
      p.value = !1, f.value = null;
    };
    return te(() => o.items.value.length, ($) => {
      $ === 0 && i.value === "checkout" && l();
    }), ($, S) => {
      const O = oi, w = L4, F = bt, D = ql, C = ho;
      return m(), h(Y, null, [
        L(C, {
          visible: t.value,
          "onUpdate:visible": S[2] || (S[2] = (I) => t.value = I),
          modal: "",
          "dismissable-mask": "",
          draggable: !1,
          "show-header": !1,
          class: "mancub-modal",
          pt: { root: { class: "mancub-modal-root" } },
          breakpoints: { "768px": "100vw" },
          style: { width: "min(820px, 100vw)", "max-width": "100vw" },
          "data-analytics-id": "mancub-dialog-basket",
          "append-to": "self"
        }, {
          default: U(() => [
            g("div", {
              ref_key: "shellRef",
              ref: r,
              class: "mancub-modal-shell flex flex-col"
            }, [
              g("header", j8, [
                g("h2", U8, y(i.value === "checkout" ? n.value.checkout : n.value.basket), 1),
                g("button", {
                  type: "button",
                  class: "p-2 -mr-2 text-gray-500 hover:text-gray-900 cursor-pointer rounded-full hover:bg-gray-100",
                  "aria-label": n.value.cancel,
                  onClick: S[0] || (S[0] = (I) => t.value = !1)
                }, [
                  L(O, { class: "text-2xl" })
                ], 8, H8)
              ]),
              L(Cn, {
                name: a.value === "forward" ? "slide-left" : "slide-right",
                mode: "out-in"
              }, {
                default: U(() => [
                  i.value === "items" ? (m(), h("div", K8, [
                    g("div", W8, [
                      z(o).items.value.length === 0 ? (m(), h("div", Y8, [
                        L(w, { class: "text-5xl text-gray-300 mx-auto block mb-3" }),
                        q(" " + y(n.value.basketEmpty), 1)
                      ])) : B("", !0),
                      (m(!0), h(Y, null, he(z(o).items.value, (I) => (m(), j(P3, {
                        key: I.id,
                        item: I,
                        currency: z(u) ?? void 0,
                        "preferred-language": $.preferredLanguage,
                        labels: e.labels,
                        onEdit: b,
                        onRemove: k
                      }, null, 8, ["item", "currency", "preferred-language", "labels"]))), 128))
                    ]),
                    z(o).items.value.length > 0 ? (m(), j(Zl, {
                      key: 0,
                      "preferred-language": $.preferredLanguage,
                      currencies: $.currencies,
                      labels: e.labels
                    }, {
                      default: U(() => [
                        g("div", G8, [
                          L(F, {
                            type: "button",
                            severity: "secondary",
                            outlined: "",
                            size: "large",
                            class: "w-full sm:w-auto",
                            onClick: S[1] || (S[1] = (I) => t.value = !1)
                          }, {
                            default: U(() => [
                              q(y(n.value.backToShopping), 1)
                            ]),
                            _: 1
                          }),
                          L(F, {
                            size: "large",
                            class: "w-full sm:w-auto",
                            onClick: d
                          }, {
                            default: U(() => [
                              q(y(n.value.proceedToCheckout) + " ", 1),
                              L(D, { class: "text-lg ml-1" })
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _: 1
                    }, 8, ["preferred-language", "currencies", "labels"])) : B("", !0)
                  ])) : i.value === "checkout" ? (m(), j(N8, {
                    key: "checkout",
                    host: $.host,
                    "preferred-language": $.preferredLanguage,
                    "api-url": $.apiUrl,
                    currencies: $.currencies,
                    "preferred-countries": $.preferredCountries,
                    labels: e.labels,
                    "terms-url": $.termsUrl,
                    onBack: l
                  }, null, 8, ["host", "preferred-language", "api-url", "currencies", "preferred-countries", "labels", "terms-url"])) : B("", !0)
                ]),
                _: 1
              }, 8, ["name"])
            ], 512)
          ]),
          _: 1
        }, 8, ["visible"]),
        L(C, {
          visible: p.value,
          "onUpdate:visible": S[5] || (S[5] = (I) => p.value = I),
          modal: "",
          "dismissable-mask": "",
          draggable: !1,
          "show-header": !1,
          class: "mancub-modal",
          pt: { root: { class: "mancub-modal-root" } },
          breakpoints: { "768px": "100vw" },
          style: { width: "min(640px, 100vw)", "max-width": "100vw" },
          "data-analytics-id": "mancub-dialog-basket-edit",
          "append-to": "self"
        }, {
          default: U(() => [
            f.value ? (m(), h("div", q8, [
              g("header", Z8, [
                g("h2", X8, y(f.value.title_customer ?? f.value.commodity_ident), 1),
                g("button", {
                  type: "button",
                  class: "text-gray-500 hover:text-gray-900 cursor-pointer",
                  "aria-label": n.value.cancel,
                  onClick: S[3] || (S[3] = (I) => p.value = !1)
                }, [
                  L(O, { class: "text-2xl" })
                ], 8, J8)
              ]),
              g("div", Q8, [
                L(Gl, {
                  host: f.value.host,
                  commodity: f.value.commodity_ident,
                  "preferred-language": $.preferredLanguage,
                  "api-url": $.apiUrl,
                  labels: e.labels,
                  mode: "edit",
                  "initial-item": f.value,
                  "hide-header": !0,
                  flat: !1,
                  onSubmitted: T,
                  onCancel: S[4] || (S[4] = (I) => p.value = !1)
                }, null, 8, ["host", "commodity", "preferred-language", "api-url", "labels", "initial-item"])
              ])
            ])) : B("", !0)
          ]),
          _: 1
        }, 8, ["visible"])
      ], 64);
    };
  }
}), t7 = /* @__PURE__ */ Je(e7, [["__scopeId", "data-v-9705a55f"]]), n7 = { class: "relative inline-flex" }, o7 = {
  key: 0,
  class: "absolute -top-1 -right-2 min-w-5 h-5 px-1 rounded-full bg-red-600 text-white text-xs font-semibold flex items-center justify-center"
}, r7 = {
  key: 0,
  class: "font-medium"
}, f9 = /* @__PURE__ */ se({
  __name: "BasketIcon",
  props: {
    host: { default: () => {
    } },
    preferredLanguage: { default: "en" },
    apiUrl: { default: () => {
    } },
    currency: { default: () => {
    } },
    currencies: { default: () => [] },
    preferredCountries: { default: () => {
    } },
    labels: { default: () => {
    } },
    termsUrl: { default: () => {
    } },
    showLabel: { type: Boolean, default: !0 },
    custom: { type: Boolean, default: !1 }
  },
  setup(e) {
    const t = v(() => Qe(e.preferredLanguage, e.labels)), n = nn(), o = W(!1), i = () => {
      o.value = !0;
    };
    return (r, a) => {
      const d = T4;
      return m(), h(Y, null, [
        r.custom ? B("", !0) : (m(), h("button", {
          key: 0,
          type: "button",
          class: "mancub-widget mancub-basket-icon inline-flex items-center gap-1 cursor-pointer text-gray-700 hover:text-gray-900 relative",
          onClick: i
        }, [
          g("span", n7, [
            L(d, { class: "text-2xl" }),
            z(n).count.value > 0 ? (m(), h("span", o7, y(z(n).count.value), 1)) : B("", !0)
          ]),
          r.showLabel ? (m(), h("span", r7, y(t.value.basket), 1)) : B("", !0)
        ])),
        L(t7, {
          visible: o.value,
          "onUpdate:visible": a[0] || (a[0] = (l) => o.value = l),
          host: r.host,
          "preferred-language": r.preferredLanguage,
          "api-url": r.apiUrl,
          currency: r.currency,
          currencies: r.currencies,
          "preferred-countries": r.preferredCountries,
          labels: e.labels,
          "terms-url": r.termsUrl
        }, null, 8, ["visible", "host", "preferred-language", "api-url", "currency", "currencies", "preferred-countries", "labels", "terms-url"])
      ], 64);
    };
  }
});
function i7(e, t = {}, n = void 0, o = {}) {
  const i = v(() => {
    const r = Q(t), a = new URL("reviews", Xt(Q(e), Q(n)));
    return r.commodity && a.searchParams.set("commodity_ident", r.commodity), r.general && a.searchParams.set("general", "true"), r.language && a.searchParams.set("language", r.language), r.minStars != null && a.searchParams.set("min_stars", String(r.minStars)), r.recommended && a.searchParams.set("recommended", "true"), r.months != null && a.searchParams.set("months", String(r.months)), r.sort && a.searchParams.set("sort", r.sort), r.limit != null && a.searchParams.set("limit", String(r.limit)), r.offset != null && a.searchParams.set("offset", String(r.offset)), a;
  });
  return qo(i, { refetch: !0, ...o });
}
const a7 = ["aria-label"], l7 = /* @__PURE__ */ se({
  __name: "ReviewStars",
  props: {
    value: { default: 0 },
    max: { default: 5 },
    size: { default: "1rem" }
  },
  setup(e) {
    const t = v(() => Math.max(0, Math.min(100, (e.value ?? 0) / e.max * 100))), n = v(() => `${(e.value ?? 0).toFixed(1)} / ${e.max}`);
    return (o, i) => (m(), h("span", {
      class: "mancub-review-stars",
      style: Zt({ fontSize: o.size }),
      role: "img",
      "aria-label": n.value
    }, [
      i[0] || (i[0] = g("span", { class: "mancub-review-stars__bg" }, "★★★★★", -1)),
      g("span", {
        class: "mancub-review-stars__fg",
        style: Zt({ width: `${t.value}%` })
      }, "★★★★★", 4)
    ], 12, a7));
  }
}), rs = /* @__PURE__ */ Je(l7, [["__scopeId", "data-v-ed7024f3"]]), s7 = { class: "mancub-review-card" }, d7 = { class: "mancub-review-card__head" }, u7 = { class: "mancub-review-card__who" }, c7 = { class: "mancub-review-card__author" }, p7 = {
  key: 0,
  class: "mancub-review-card__date"
}, m7 = {
  key: 0,
  class: "mancub-review-card__badges"
}, f7 = {
  key: 1,
  class: "mancub-review-card__text"
}, g7 = {
  key: 2,
  class: "mancub-review-card__response"
}, h7 = { class: "mancub-review-card__response-label" }, b7 = { class: "mancub-review-card__response-text" }, v7 = /* @__PURE__ */ se({
  __name: "ReviewCard",
  props: {
    review: {},
    labels: {},
    lang: {},
    showStars: { type: Boolean, default: !0 },
    showText: { type: Boolean, default: !0 }
  },
  setup(e) {
    const t = v(() => e.review.author?.trim() || e.labels.reviewsAnonymous), n = v(() => {
      if (!e.review.created_at) return "";
      try {
        return bn(new Date(e.review.created_at), e.lang);
      } catch {
        return "";
      }
    }), o = v(() => e.review.would_recommend ? `♥ ${e.labels.reviewsRecommends}` : e.labels.reviewsDoesNotRecommend), i = v(() => {
      const r = e.review.response_author?.trim();
      return r ? Le(e.labels.reviewsResponseBy, { author: r }) : e.labels.reviewsResponse;
    });
    return (r, a) => (m(), h("article", s7, [
      g("header", d7, [
        g("div", u7, [
          g("span", c7, y(t.value), 1),
          n.value ? (m(), h("span", p7, y(n.value), 1)) : B("", !0)
        ]),
        r.showStars && r.review.stars != null ? (m(), j(rs, {
          key: 0,
          value: r.review.stars,
          size: "0.95rem"
        }, null, 8, ["value"])) : B("", !0)
      ]),
      r.review.would_recommend != null ? (m(), h("div", m7, [
        g("span", {
          class: ee(["mancub-review-card__badge", r.review.would_recommend ? "mancub-review-card__badge--recommend" : "mancub-review-card__badge--not-recommend"])
        }, y(o.value), 3)
      ])) : B("", !0),
      r.showText && r.review.text ? (m(), h("p", f7, y(r.review.text), 1)) : B("", !0),
      r.showText && r.review.response ? (m(), h("div", g7, [
        g("span", h7, y(i.value), 1),
        g("p", b7, y(r.review.response), 1)
      ])) : B("", !0)
    ]));
  }
}), y7 = /* @__PURE__ */ Je(v7, [["__scopeId", "data-v-fb71b753"]]), k7 = {
  key: 0,
  class: "mancub-review-filters"
}, w7 = {
  key: 0,
  class: "mancub-review-filters__field"
}, x7 = { class: "mancub-review-filters__label" }, C7 = {
  key: 1,
  class: "mancub-review-filters__field"
}, S7 = { class: "mancub-review-filters__label" }, $7 = {
  key: 2,
  class: "mancub-review-filters__field"
}, B7 = { class: "mancub-review-filters__label" }, T7 = {
  key: 3,
  class: "mancub-review-filters__field"
}, I7 = { class: "mancub-review-filters__label" }, D7 = /* @__PURE__ */ se({
  __name: "ReviewFilters",
  props: /* @__PURE__ */ Mt({
    facets: {},
    labels: {},
    lang: {},
    showLanguage: { type: Boolean, default: !1 },
    showPeriod: { type: Boolean, default: !1 },
    showRating: { type: Boolean, default: !1 },
    showCommodity: { type: Boolean, default: !1 }
  }, {
    modelValue: { required: !0 },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = At(e, "modelValue"), n = v(() => e.showLanguage || e.showPeriod || e.showRating || e.showCommodity), o = (l) => {
      try {
        return new Intl.DisplayNames([st(e.lang)], { type: "language" }).of(l) ?? l.toUpperCase();
      } catch {
        return l.toUpperCase();
      }
    }, i = v(() => [
      { label: e.labels.reviewsFilterAll, value: null },
      ...(e.facets.languages ?? []).map((l) => ({ label: o(l), value: l }))
    ]), r = v(() => [
      { label: e.labels.reviewsFilterAll, value: null },
      ...(e.facets.commodities ?? []).map((l) => ({ label: `${l.title || l.ident} (${l.count})`, value: l.ident }))
    ]), a = v(() => [
      { label: e.labels.reviewsFilterAll, value: null },
      ...[5, 4, 3, 2].map((l) => ({ label: Le(e.labels.reviewsRatingMin, { count: l }), value: l }))
    ]), d = v(() => [
      { label: e.labels.reviewsPeriodAll, value: null },
      ...[6, 12, 24].map((l) => ({ label: Le(e.labels.reviewsPeriodMonths, { months: l }), value: l }))
    ]);
    return (l, u) => {
      const s = rn;
      return n.value ? (m(), h("div", k7, [
        l.showCommodity && r.value.length > 1 ? (m(), h("label", w7, [
          g("span", x7, y(l.labels.reviewsFilterCommodity), 1),
          L(s, {
            modelValue: t.value.commodity,
            "onUpdate:modelValue": u[0] || (u[0] = (c) => t.value.commodity = c),
            options: r.value,
            "option-label": "label",
            "option-value": "value",
            class: "mancub-review-filters__select"
          }, null, 8, ["modelValue", "options"])
        ])) : B("", !0),
        l.showLanguage && i.value.length > 1 ? (m(), h("label", C7, [
          g("span", S7, y(l.labels.reviewsFilterLanguage), 1),
          L(s, {
            modelValue: t.value.language,
            "onUpdate:modelValue": u[1] || (u[1] = (c) => t.value.language = c),
            options: i.value,
            "option-label": "label",
            "option-value": "value",
            class: "mancub-review-filters__select"
          }, null, 8, ["modelValue", "options"])
        ])) : B("", !0),
        l.showRating ? (m(), h("label", $7, [
          g("span", B7, y(l.labels.reviewsFilterRating), 1),
          L(s, {
            modelValue: t.value.minStars,
            "onUpdate:modelValue": u[2] || (u[2] = (c) => t.value.minStars = c),
            options: a.value,
            "option-label": "label",
            "option-value": "value",
            class: "mancub-review-filters__select"
          }, null, 8, ["modelValue", "options"])
        ])) : B("", !0),
        l.showPeriod ? (m(), h("label", T7, [
          g("span", I7, y(l.labels.reviewsFilterPeriod), 1),
          L(s, {
            modelValue: t.value.months,
            "onUpdate:modelValue": u[3] || (u[3] = (c) => t.value.months = c),
            options: d.value,
            "option-label": "label",
            "option-value": "value",
            class: "mancub-review-filters__select"
          }, null, 8, ["modelValue", "options"])
        ])) : B("", !0)
      ])) : B("", !0);
    };
  }
}), P7 = /* @__PURE__ */ Je(D7, [["__scopeId", "data-v-974a2a7e"]]), z7 = ["title", "aria-label"], L7 = /* @__PURE__ */ se({
  __name: "InfoHint",
  props: {
    text: {}
  },
  setup(e) {
    return (t, n) => (m(), h("span", {
      class: "mancub-info-hint",
      title: t.text,
      "aria-label": t.text,
      tabindex: "0",
      role: "note"
    }, [...n[0] || (n[0] = [
      g("svg", {
        viewBox: "0 0 16 16",
        width: "1em",
        height: "1em",
        fill: "currentColor",
        "aria-hidden": "true"
      }, [
        g("path", { d: "M8 1a7 7 0 1 0 0 14A7 7 0 0 0 8 1Zm0 3a1 1 0 1 1 0 2 1 1 0 0 1 0-2Zm1.25 8h-2.5v-1h.75V7.5h-.75v-1h1.75V11h.75v1Z" })
      ], -1)
    ])], 8, z7));
  }
}), xa = /* @__PURE__ */ Je(L7, [["__scopeId", "data-v-4f67766b"]]), O7 = { class: "mancub-review-stats" }, M7 = { class: "mancub-review-stats__top" }, A7 = { class: "mancub-review-stats__average" }, _7 = { class: "mancub-review-stats__average-value" }, F7 = {
  key: 0,
  class: "mancub-review-stats__recommend-inline"
}, E7 = { class: "mancub-review-stats__based-on" }, R7 = {
  key: 0,
  class: "mancub-review-stats__recommend"
}, V7 = { class: "mancub-review-stats__recommend-value" }, N7 = { class: "mancub-review-stats__recommend-label" }, j7 = {
  key: 0,
  class: "mancub-review-stats__breakdown"
}, U7 = { class: "mancub-review-stats__breakdown-title" }, H7 = { class: "mancub-review-stats__row-star" }, K7 = { class: "mancub-review-stats__bar" }, W7 = { class: "mancub-review-stats__row-count" }, Y7 = /* @__PURE__ */ se({
  __name: "ReviewStats",
  props: {
    stats: {},
    labels: {},
    lang: {},
    showRecommend: { type: Boolean, default: !0 },
    showBreakdown: { type: Boolean, default: !0 }
  },
  setup(e) {
    const t = v(
      () => e.stats.average_stars != null ? e.stats.average_stars.toFixed(1) : "—"
    ), n = v(() => Le(e.labels.reviewsBasedOn, { count: e.stats.total_count })), o = v(() => e.labels.reviewsWouldRecommend), i = v(() => `${e.stats.recommend_percent}% ${e.labels.reviewsWouldRecommend}`), r = (u) => {
      if (!u) return "—";
      try {
        return new Date(u).toLocaleDateString(st(e.lang), { year: "numeric", month: "short" });
      } catch {
        return "—";
      }
    }, a = v(() => Le(e.labels.reviewsAverageHelp, {
      rated: e.stats.rated_count,
      from: r(e.stats.first_review_at),
      to: r(e.stats.last_review_at)
    })), d = v(() => Le(e.labels.reviewsRecommendHelp, { total: e.stats.recommend_total })), l = v(() => {
      const u = Math.max(1, ...Object.values(e.stats.star_breakdown ?? {}));
      return [5, 4, 3, 2, 1].map((s) => {
        const c = e.stats.star_breakdown?.[String(s)] ?? 0;
        return { star: s, count: c, pct: Math.round(c / u * 100) };
      });
    });
    return (u, s) => (m(), h("div", O7, [
      g("div", M7, [
        g("div", A7, [
          g("div", _7, [
            q(y(t.value) + " ", 1),
            s[0] || (s[0] = g("span", { class: "mancub-review-stats__average-max" }, "/ 5", -1))
          ]),
          L(rs, {
            value: u.stats.average_stars,
            size: "1.25rem"
          }, null, 8, ["value"]),
          u.showRecommend && u.stats.recommend_percent != null ? (m(), h("div", F7, y(i.value), 1)) : B("", !0),
          g("div", E7, [
            q(y(n.value) + " ", 1),
            L(xa, { text: a.value }, null, 8, ["text"])
          ])
        ]),
        u.showRecommend && u.stats.recommend_percent != null ? (m(), h("div", R7, [
          g("div", V7, y(u.stats.recommend_percent) + "% ", 1),
          g("div", N7, [
            q(y(o.value) + " ", 1),
            L(xa, { text: d.value }, null, 8, ["text"])
          ])
        ])) : B("", !0)
      ]),
      u.showBreakdown && u.stats.rated_count > 0 ? (m(), h("div", j7, [
        g("div", U7, y(u.labels.reviewsBreakdown), 1),
        (m(!0), h(Y, null, he(l.value, (c) => (m(), h("div", {
          key: c.star,
          class: "mancub-review-stats__row"
        }, [
          g("span", H7, y(c.star) + "★", 1),
          g("span", K7, [
            g("span", {
              class: "mancub-review-stats__bar-fill",
              style: Zt({ width: `${c.pct}%` })
            }, null, 4)
          ]),
          g("span", W7, y(c.count), 1)
        ]))), 128))
      ])) : B("", !0)
    ]));
  }
}), G7 = /* @__PURE__ */ Je(Y7, [["__scopeId", "data-v-ee322d34"]]), q7 = {
  language: null,
  months: null,
  minStars: null,
  commodity: null
}, Z7 = { class: "mancub-widget mancub-review" }, X7 = {
  key: 0,
  class: "mancub-review__header"
}, J7 = { class: "mancub-review__title" }, Q7 = {
  key: 1,
  class: "mancub-review__state"
}, e9 = {
  key: 2,
  class: "mancub-review__state"
}, t9 = {
  key: 1,
  class: "mancub-review__state mancub-review__empty"
}, n9 = { class: "mancub-review__list" }, o9 = ["disabled"], r9 = /* @__PURE__ */ se({
  __name: "Review",
  props: {
    host: { default: void 0 },
    apiUrl: { default: void 0 },
    preferredLanguage: { default: void 0 },
    labels: { default: void 0 },
    commodity: { default: void 0 },
    general: { type: [Boolean, String], default: void 0 },
    variant: { default: void 0 },
    title: { default: void 0 },
    hideTitle: { type: [Boolean, String], default: void 0 },
    showText: { type: [Boolean, String], default: void 0 },
    showStars: { type: [Boolean, String], default: void 0 },
    showRecommend: { type: [Boolean, String], default: void 0 },
    showLanguageFilter: { type: [Boolean, String], default: void 0 },
    showDateFilter: { type: [Boolean, String], default: void 0 },
    showStarFilter: { type: [Boolean, String], default: void 0 },
    showCommodityFilter: { type: [Boolean, String], default: void 0 },
    minStars: { default: void 0 },
    limit: { default: void 0 }
  },
  setup(e) {
    const t = e, n = (P) => P === !0 || P === "" || P === "true" || P === "1", o = (P) => P !== void 0, i = (P) => {
      if (P == null || P === "") return null;
      const E = Number(P);
      return Number.isFinite(E) ? E : null;
    }, r = v(() => t.preferredLanguage ?? ln), a = v(() => Qe(r.value, t.labels)), d = ce(Ct, void 0), l = v(() => t.apiUrl ?? Q(d) ?? Bt), u = ce(St, void 0), s = v(() => t.host ?? Q(u) ?? ""), c = v(() => t.variant ?? "cards"), p = v(() => {
      const P = c.value, E = {
        summary: { showStats: !0, showBreakdown: !1, showRecommend: !0, showList: !1, showStars: !0, showText: !1 },
        stats: { showStats: !0, showBreakdown: !0, showRecommend: !0, showList: !1, showStars: !0, showText: !1 },
        cards: { showStats: !0, showBreakdown: !0, showRecommend: !0, showList: !0, showStars: !0, showText: !0 }
      }[P];
      return {
        ...E,
        showText: o(t.showText) ? n(t.showText) : E.showText,
        showStars: o(t.showStars) ? n(t.showStars) : E.showStars,
        showRecommend: o(t.showRecommend) ? n(t.showRecommend) : E.showRecommend
      };
    }), f = v(() => n(t.hideTitle)), b = v(() => t.title || a.value.reviewsTitle), k = v(() => n(t.showLanguageFilter)), T = v(() => n(t.showDateFilter)), $ = v(() => n(t.showStarFilter)), S = v(() => n(t.showCommodityFilter)), O = v(() => i(t.minStars)), w = v(() => i(t.limit) ?? 6), F = W({ ...q7 }), D = W(w.value), C = v(() => {
      const P = F.value, E = P.commodity ?? t.commodity ?? null, H = E ? !1 : n(t.general), ae = O.value, fe = ae != null || P.minStars != null ? Math.max(ae ?? 0, P.minStars ?? 0) : null;
      return {
        commodity: E,
        general: H,
        language: P.language,
        minStars: fe,
        months: P.months,
        sort: "recent",
        // Stats are computed server-side over the whole filtered set regardless
        // of limit, so non-list variants only need a single row.
        limit: p.value.showList ? D.value : 1,
        offset: 0
      };
    }), { loading: I, data: N, error: K, execute: V } = i7(s, C, l), M = () => {
      D.value += w.value;
    };
    return (P, E) => {
      const H = go;
      return m(), h("div", Z7, [
        f.value ? B("", !0) : (m(), h("header", X7, [
          g("h3", J7, y(b.value), 1)
        ])),
        z(I) && !z(N) ? (m(), h("div", Q7, [
          L(H, { style: { width: "2rem", height: "2rem" } })
        ])) : z(K) ? (m(), h("div", e9, [
          L(xn, {
            error: z(K),
            labels: a.value,
            onRetry: z(V)
          }, null, 8, ["error", "labels", "onRetry"])
        ])) : z(N) ? (m(), h(Y, { key: 3 }, [
          p.value.showStats && z(N).stats.total_count > 0 ? (m(), j(G7, {
            key: 0,
            stats: z(N).stats,
            labels: a.value,
            lang: r.value,
            "show-recommend": p.value.showRecommend,
            "show-breakdown": p.value.showBreakdown,
            class: "mancub-review__stats"
          }, null, 8, ["stats", "labels", "lang", "show-recommend", "show-breakdown"])) : B("", !0),
          L(P7, {
            modelValue: F.value,
            "onUpdate:modelValue": E[0] || (E[0] = (ae) => F.value = ae),
            facets: z(N).facets,
            labels: a.value,
            lang: r.value,
            "show-language": k.value,
            "show-period": T.value,
            "show-rating": $.value,
            "show-commodity": S.value,
            class: "mancub-review__filters"
          }, null, 8, ["modelValue", "facets", "labels", "lang", "show-language", "show-period", "show-rating", "show-commodity"]),
          z(N).stats.total_count === 0 ? (m(), h("div", t9, y(a.value.reviewsEmpty), 1)) : p.value.showList ? (m(), h(Y, { key: 2 }, [
            g("div", n9, [
              (m(!0), h(Y, null, he(z(N).reviews, (ae, fe) => (m(), j(y7, {
                key: fe,
                review: ae,
                labels: a.value,
                lang: r.value,
                "show-stars": p.value.showStars,
                "show-text": p.value.showText
              }, null, 8, ["review", "labels", "lang", "show-stars", "show-text"]))), 128))
            ]),
            z(N).reviews.length < z(N).total ? (m(), h("button", {
              key: 0,
              type: "button",
              class: "mancub-review__more",
              disabled: z(I),
              onClick: M
            }, y(a.value.reviewsShowMore), 9, o9)) : B("", !0)
          ], 64)) : B("", !0)
        ], 64)) : B("", !0)
      ]);
    };
  }
}), g9 = /* @__PURE__ */ Je(r9, [["__scopeId", "data-v-7b534ccd"]]);
function i9(e, t) {
  if (!e) return;
  const n = e.trim();
  if (!n) return;
  const o = n.match(/^var\((--[^),\s]+)(?:\s*,[^)]*)?\)$/), i = o ? o[1] : n.startsWith("--") ? n : null;
  if (i) {
    if (typeof window > "u" || typeof document > "u")
      return;
    const r = [
      t,
      document.documentElement
    ].filter((a, d, l) => a instanceof Element && l.indexOf(a) === d);
    for (const a of r) {
      const d = getComputedStyle(a).getPropertyValue(i).trim();
      if (d)
        return d;
    }
    return;
  }
  return n;
}
function h9(e, t = {}) {
  const n = i9(t.primaryColor, t.primaryColorScope), o = n ? Ga(z0(n)) : L0;
  if (e.use(Ld, {
    theme: {
      preset: o,
      options: {
        darkModeSelector: t.darkModeSelector ?? ".mancub-dark"
      }
    }
  }), t.apiUrl !== void 0 && e.provide(Ct, t.apiUrl), t.host !== void 0 && e.provide(St, t.host), t.currency !== void 0) {
    const i = t.currency;
    ys(i) || typeof i == "function" ? te(() => Q(i), _o, { immediate: !0 }) : _o(i);
  }
  t.language !== void 0 && (console.warn("currently language must be provided to each component"), e.provide(mo, t.language)), t.errorDetails !== void 0 && e.provide(nl, t.errorDetails), t.successContent !== void 0 && e.provide(rl, t.successContent);
}
export {
  ca as AbstractForm,
  f9 as BasketIcon,
  P3 as BasketItemCard,
  t7 as BasketModal,
  u9 as BookButton,
  Gl as BookForm,
  ey as CURRENCY_CHANGE_EVENT,
  c9 as Calendar,
  N8 as CheckoutForm,
  Bt as DEFAULT_API_URL,
  ln as DEFAULT_LANGUAGE,
  Ct as MANCUB_API_URL,
  ol as MANCUB_CURRENCY,
  nl as MANCUB_ERROR_DETAILS,
  St as MANCUB_HOST,
  mo as MANCUB_LANGUAGE,
  rl as MANCUB_SUCCESS_CONTENT,
  m9 as MainPrice,
  L0 as MancubMaterial,
  ir as PhoneInput,
  p9 as PriceList,
  g9 as Review,
  F5 as SetupForm,
  r$ as WIDGET_EMPTY_EVENT,
  o$ as WIDGET_ERROR_EVENT,
  Uo as basketItemAmountIn,
  Ga as buildMancubPreset,
  z0 as buildPrimaryPalette,
  h9 as installMancub,
  U6 as placeOrder,
  Nl as requestOpenBasket,
  _o as setCurrency,
  nn as useBasket,
  US as useBasketUiSignal,
  d9 as useCurrency,
  j6 as useCustomer
};
